const unformattedData = {
    "type": "FeatureCollection",
    "name": "Baltimore_City_Qualified_Census_Tracts",
    "crs": {
      "type": "name",
      "properties": {
        "name": "urn:ogc:def:crs:OGC:1.3:CRS84"
      }
    },
    "features": [
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 1,
          "Census_Tract": "24510260605",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "c1fd0b3e-60ca-4c08-ad3a-363b0f4110b7",
          "Shape__Area": 107084632.2958374,
          "Shape__Length": 98670.91325670245
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.5297880000858,
                39.2815269981731,
                0
              ],
              [
                -76.5297850000777,
                39.2805599988748,
                0
              ],
              [
                -76.5297849994273,
                39.2800289986831,
                0
              ],
              [
                -76.5297849998512,
                39.2795509986385,
                0
              ],
              [
                -76.5297849998988,
                39.2790469987843,
                0
              ],
              [
                -76.5297860011592,
                39.2786099992249,
                0
              ],
              [
                -76.5297849995953,
                39.2777359987203,
                0
              ],
              [
                -76.5297850004012,
                39.2768579989919,
                0
              ],
              [
                -76.5297850002659,
                39.2761440000355,
                0
              ],
              [
                -76.5297850002011,
                39.2749579993517,
                0
              ],
              [
                -76.5297850002622,
                39.2738859986095,
                0
              ],
              [
                -76.5297849995734,
                39.2738199993029,
                0
              ],
              [
                -76.5297850005423,
                39.2732940000324,
                0
              ],
              [
                -76.5297809996191,
                39.273100998842,
                0
              ],
              [
                -76.5296970000057,
                39.272678999167,
                0
              ],
              [
                -76.5296230002179,
                39.2723069987696,
                0
              ],
              [
                -76.5296850005177,
                39.2702069993423,
                0
              ],
              [
                -76.5297060002691,
                39.2701079988,
                0
              ],
              [
                -76.529737999842,
                39.2699559986856,
                0
              ],
              [
                -76.5297879994611,
                39.2697219988121,
                0
              ],
              [
                -76.5297869998016,
                39.2688109996203,
                0
              ],
              [
                -76.5297869996766,
                39.2687679986722,
                0
              ],
              [
                -76.5297870005313,
                39.2681919986869,
                0
              ],
              [
                -76.529786001054,
                39.2672139989021,
                0
              ],
              [
                -76.5297849995365,
                39.2666060001805,
                0
              ],
              [
                -76.5297840001296,
                39.2649889986205,
                0
              ],
              [
                -76.5297849995233,
                39.2647669986498,
                0
              ],
              [
                -76.5297850003394,
                39.2643789988011,
                0
              ],
              [
                -76.5297850001475,
                39.2639949983281,
                0
              ],
              [
                -76.5297849994563,
                39.263005999328,
                0
              ],
              [
                -76.5297849995537,
                39.2624169993417,
                0
              ],
              [
                -76.5297850002511,
                39.2620179999067,
                0
              ],
              [
                -76.5297850002099,
                39.2616379985974,
                0
              ],
              [
                -76.5297789996361,
                39.2612449976012,
                0
              ],
              [
                -76.5297719987538,
                39.2608329988787,
                0
              ],
              [
                -76.5297680005655,
                39.2607029987839,
                0
              ],
              [
                -76.5297739997833,
                39.2604279991216,
                0
              ],
              [
                -76.5297849999733,
                39.2599829987366,
                0
              ],
              [
                -76.5297850001327,
                39.2595219988682,
                0
              ],
              [
                -76.5297849998859,
                39.259112998721,
                0
              ],
              [
                -76.5297690003196,
                39.2589119993663,
                0
              ],
              [
                -76.5297550004404,
                39.2587280001763,
                0
              ],
              [
                -76.5297530004151,
                39.2586989990051,
                0
              ],
              [
                -76.5297440004622,
                39.2583449990183,
                0
              ],
              [
                -76.5297479997419,
                39.2581019992136,
                0
              ],
              [
                -76.5297580003567,
                39.2575839986129,
                0
              ],
              [
                -76.5297850004136,
                39.2570059997746,
                0
              ],
              [
                -76.5297850001966,
                39.2563059992084,
                0
              ],
              [
                -76.529785000322,
                39.2557809989175,
                0
              ],
              [
                -76.5297849999695,
                39.2552509992535,
                0
              ],
              [
                -76.5297849997658,
                39.2550800000462,
                0
              ],
              [
                -76.5297849998616,
                39.2550590003173,
                0
              ],
              [
                -76.5297779994712,
                39.253655998574,
                0
              ],
              [
                -76.5297750005727,
                39.2530329987897,
                0
              ],
              [
                -76.5297719990381,
                39.2523839989409,
                0
              ],
              [
                -76.5297170002207,
                39.2513629988338,
                0
              ],
              [
                -76.5296680015419,
                39.2504659987385,
                0
              ],
              [
                -76.5295849996296,
                39.248745997981,
                0
              ],
              [
                -76.5295850004642,
                39.2482329993776,
                0
              ],
              [
                -76.5294869998528,
                39.2470449993094,
                0
              ],
              [
                -76.5295950005204,
                39.2456559992118,
                0
              ],
              [
                -76.5295160004125,
                39.2441879987905,
                0
              ],
              [
                -76.5295079997013,
                39.2441069986579,
                0
              ],
              [
                -76.5295030003668,
                39.2440579989164,
                0
              ],
              [
                -76.5294620003183,
                39.2436439990627,
                0
              ],
              [
                -76.5296579997268,
                39.2427199987551,
                0
              ],
              [
                -76.529485000051,
                39.2415059989264,
                0
              ],
              [
                -76.5295650003321,
                39.2408579997481,
                0
              ],
              [
                -76.5295720004726,
                39.2408009987053,
                0
              ],
              [
                -76.5295750004802,
                39.2407789993393,
                0
              ],
              [
                -76.5295839998986,
                39.2403279991934,
                0
              ],
              [
                -76.529583967839,
                39.2403207757329,
                0
              ],
              [
                -76.53289794876,
                39.2392101289343,
                0
              ],
              [
                -76.5354003895043,
                39.2418956747336,
                0
              ],
              [
                -76.5357074734279,
                39.24187278666,
                0
              ],
              [
                -76.5358486169455,
                39.2424106597015,
                0
              ],
              [
                -76.5386867527499,
                39.2454204561887,
                0
              ],
              [
                -76.5380039225613,
                39.2476215364275,
                0
              ],
              [
                -76.5382938395473,
                39.2478275302208,
                0
              ],
              [
                -76.5378570550998,
                39.2491855616719,
                0
              ],
              [
                -76.5374870294757,
                39.2492618558347,
                0
              ],
              [
                -76.5355358122604,
                39.2555751797351,
                0
              ],
              [
                -76.5349082954759,
                39.2556400304127,
                0
              ],
              [
                -76.5345039370965,
                39.2562732702768,
                0
              ],
              [
                -76.534751892302,
                39.2581386558195,
                0
              ],
              [
                -76.5352401733593,
                39.2596035000847,
                0
              ],
              [
                -76.5364017495802,
                39.2608203890369,
                0
              ],
              [
                -76.5369052875081,
                39.260969162023,
                0
              ],
              [
                -76.539850234601,
                39.263513564662,
                0
              ],
              [
                -76.5399951943201,
                39.2641391745817,
                0
              ],
              [
                -76.5395240789409,
                39.2662715906571,
                0
              ],
              [
                -76.5392398824575,
                39.266607284643,
                0
              ],
              [
                -76.5384235384302,
                39.2666149142708,
                0
              ],
              [
                -76.5337409975676,
                39.2659969332792,
                0
              ],
              [
                -76.533456802143,
                39.2662754063873,
                0
              ],
              [
                -76.5336151127271,
                39.2666606902004,
                0
              ],
              [
                -76.5345096595328,
                39.2664127353305,
                0
              ],
              [
                -76.5363445293981,
                39.2668666840154,
                0
              ],
              [
                -76.5394325259929,
                39.2670192723599,
                0
              ],
              [
                -76.5398559575192,
                39.2666416171528,
                0
              ],
              [
                -76.5407123569413,
                39.2646503449163,
                0
              ],
              [
                -76.5408382409829,
                39.2634449009992,
                0
              ],
              [
                -76.5403633117553,
                39.2622356417566,
                0
              ],
              [
                -76.5368633268247,
                39.259378432829,
                0
              ],
              [
                -76.5362682350218,
                39.2583980556577,
                0
              ],
              [
                -76.5367984774718,
                39.2563991546879,
                0
              ],
              [
                -76.5403270719864,
                39.2506542214152,
                0
              ],
              [
                -76.544017790514,
                39.252511977552,
                0
              ],
              [
                -76.5525970459657,
                39.2575855252275,
                0
              ],
              [
                -76.5529136662008,
                39.2606372828088,
                0
              ],
              [
                -76.5543861385876,
                39.2608280178964,
                0
              ],
              [
                -76.5543727865519,
                39.2596225737559,
                0
              ],
              [
                -76.5555820466114,
                39.2594127650622,
                0
              ],
              [
                -76.5554618824678,
                39.2576389313449,
                0
              ],
              [
                -76.5556507110706,
                39.2575206748754,
                0
              ],
              [
                -76.5561714169064,
                39.2614154806115,
                0
              ],
              [
                -76.5565948481491,
                39.2613201141033,
                0
              ],
              [
                -76.5567302702902,
                39.2603321080831,
                0
              ],
              [
                -76.5576572424656,
                39.260229110914,
                0
              ],
              [
                -76.5577735899592,
                39.2612476350894,
                0
              ],
              [
                -76.5591087343161,
                39.2612743380043,
                0
              ],
              [
                -76.5588722229924,
                39.2568416596945,
                0
              ],
              [
                -76.5601825716086,
                39.2571773527749,
                0
              ],
              [
                -76.5604553214975,
                39.2612056733951,
                0
              ],
              [
                -76.5611324314116,
                39.2611713410087,
                0
              ],
              [
                -76.5609283448232,
                39.2583599089685,
                0
              ],
              [
                -76.562213898345,
                39.2584400169512,
                0
              ],
              [
                -76.5624408722163,
                39.2609653471888,
                0
              ],
              [
                -76.5628280645301,
                39.2608013151138,
                0
              ],
              [
                -76.5627155300379,
                39.2587718961001,
                0
              ],
              [
                -76.5630588533229,
                39.2585239407558,
                0
              ],
              [
                -76.5629310608782,
                39.256376267329,
                0
              ],
              [
                -76.563533783479,
                39.2564105992593,
                0
              ],
              [
                -76.5636882785807,
                39.2586307516985,
                0
              ],
              [
                -76.5645217894606,
                39.2587604518451,
                0
              ],
              [
                -76.5644397736713,
                39.2565937042575,
                0
              ],
              [
                -76.5647258762092,
                39.2565364843797,
                0
              ],
              [
                -76.5650081631516,
                39.2600231171342,
                0
              ],
              [
                -76.5658264159363,
                39.2599811564355,
                0
              ],
              [
                -76.5661506659827,
                39.2593975071877,
                0
              ],
              [
                -76.5672340391363,
                39.2593402858597,
                0
              ],
              [
                -76.5679492952414,
                39.2598514559251,
                0
              ],
              [
                -76.5682926176988,
                39.2597942352176,
                0
              ],
              [
                -76.5682601933034,
                39.2595272060601,
                0
              ],
              [
                -76.5688114157216,
                39.2592334752263,
                0
              ],
              [
                -76.5688514704651,
                39.2602481841461,
                0
              ],
              [
                -76.5693359369996,
                39.2596874237652,
                0
              ],
              [
                -76.5713062276703,
                39.2608737953315,
                0
              ],
              [
                -76.5716209409301,
                39.261602401861,
                0
              ],
              [
                -76.5718097694802,
                39.2622203834147,
                0
              ],
              [
                -76.5714054114948,
                39.2622623442928,
                0
              ],
              [
                -76.5716247554729,
                39.2633419041769,
                0
              ],
              [
                -76.5712509146844,
                39.2636356354383,
                0
              ],
              [
                -76.5713024137368,
                39.2644176486159,
                0
              ],
              [
                -76.5696773530101,
                39.2646083833973,
                0
              ],
              [
                -76.5696544641436,
                39.2643985752858,
                0
              ],
              [
                -76.5687332146776,
                39.2644176491413,
                0
              ],
              [
                -76.5687026978983,
                39.264837264782,
                0
              ],
              [
                -76.5719547273615,
                39.2647380832806,
                0
              ],
              [
                -76.5719280242287,
                39.2649097436338,
                0
              ],
              [
                -76.5687122339964,
                39.2650432588098,
                0
              ],
              [
                -76.5687694545571,
                39.2659740441198,
                0
              ],
              [
                -76.5714893345502,
                39.2659358981964,
                0
              ],
              [
                -76.5717239379813,
                39.2660465243513,
                0
              ],
              [
                -76.5717010493595,
                39.2666187287587,
                0
              ],
              [
                -76.5708141325533,
                39.2668666844433,
                0
              ],
              [
                -76.5726509085053,
                39.2667407986559,
                0
              ],
              [
                -76.5726432796739,
                39.2669277190318,
                0
              ],
              [
                -76.5696125029877,
                39.2670497889719,
                0
              ],
              [
                -76.569522858109,
                39.2672519684276,
                0
              ],
              [
                -76.5688056950606,
                39.267332076603,
                0
              ],
              [
                -76.5688476560325,
                39.2680377960603,
                0
              ],
              [
                -76.5727310182023,
                39.2679195397986,
                0
              ],
              [
                -76.5727577206148,
                39.2684917452301,
                0
              ],
              [
                -76.5688819893096,
                39.2686481473771,
                0
              ],
              [
                -76.5689296717845,
                39.2693119054499,
                0
              ],
              [
                -76.5698223114187,
                39.2694416039379,
                0
              ],
              [
                -76.5697326664631,
                39.2697429660405,
                0
              ],
              [
                -76.5689792645048,
                39.2696704867174,
                0
              ],
              [
                -76.5690879814942,
                39.2706699368081,
                0
              ],
              [
                -76.5705566412828,
                39.2706127156318,
                0
              ],
              [
                -76.5705680836766,
                39.270753859966,
                0
              ],
              [
                -76.5696258549818,
                39.2708339688293,
                0
              ],
              [
                -76.5705394753627,
                39.2709674840057,
                0
              ],
              [
                -76.5705089567647,
                39.2715206136803,
                0
              ],
              [
                -76.5725517267221,
                39.2714481348357,
                0
              ],
              [
                -76.572557448604,
                39.2715930935721,
                0
              ],
              [
                -76.5702571869284,
                39.2718219757139,
                0
              ],
              [
                -76.5705337530353,
                39.2718677518781,
                0
              ],
              [
                -76.570451735504,
                39.2721042635688,
                0
              ],
              [
                -76.571792601939,
                39.2720737463416,
                0
              ],
              [
                -76.5704383854314,
                39.2722187040177,
                0
              ],
              [
                -76.5706100461582,
                39.2727642055898,
                0
              ],
              [
                -76.5716323855615,
                39.2729282383615,
                0
              ],
              [
                -76.5715484619667,
                39.2738170617761,
                0
              ],
              [
                -76.5710659026552,
                39.273881912103,
                0
              ],
              [
                -76.5707588194337,
                39.274377823191,
                0
              ],
              [
                -76.5710851258508,
                39.2762453061514,
                0
              ],
              [
                -76.570978000912,
                39.2763449989929,
                0
              ],
              [
                -76.5709310002981,
                39.2763889990571,
                0
              ],
              [
                -76.5708770014617,
                39.2764209987539,
                0
              ],
              [
                -76.5708869997409,
                39.2769059994297,
                0
              ],
              [
                -76.570913999865,
                39.2772179989662,
                0
              ],
              [
                -76.5709309998942,
                39.2773219986033,
                0
              ],
              [
                -76.5710079999013,
                39.2783369992768,
                0
              ],
              [
                -76.5702250004635,
                39.2783719987617,
                0
              ],
              [
                -76.5694550005139,
                39.2783899991015,
                0
              ],
              [
                -76.5688929994909,
                39.2784059989602,
                0
              ],
              [
                -76.5685119999975,
                39.2784169989821,
                0
              ],
              [
                -76.5675729997405,
                39.2784509986633,
                0
              ],
              [
                -76.5666519995326,
                39.2784859985515,
                0
              ],
              [
                -76.5657420004869,
                39.2785319987138,
                0
              ],
              [
                -76.5645000011861,
                39.2785949991319,
                0
              ],
              [
                -76.564250999293,
                39.2787419993447,
                0
              ],
              [
                -76.563982998619,
                39.2789539988965,
                0
              ],
              [
                -76.5635929989905,
                39.2793009990087,
                0
              ],
              [
                -76.5633059997983,
                39.2796019985831,
                0
              ],
              [
                -76.5630450004445,
                39.2799029995815,
                0
              ],
              [
                -76.5627670002908,
                39.2802369992834,
                0
              ],
              [
                -76.5624770003807,
                39.2806929991639,
                0
              ],
              [
                -76.5620570004425,
                39.2807069992021,
                0
              ],
              [
                -76.5609940001066,
                39.2807379987905,
                0
              ],
              [
                -76.5592640001378,
                39.2807859994232,
                0
              ],
              [
                -76.5582469995272,
                39.2808259985701,
                0
              ],
              [
                -76.5575900000945,
                39.2808610003973,
                0
              ],
              [
                -76.5573199998411,
                39.2808749989054,
                0
              ],
              [
                -76.5563859996187,
                39.2809059988265,
                0
              ],
              [
                -76.5554199984843,
                39.2809529993112,
                0
              ],
              [
                -76.555353999505,
                39.2809569993036,
                0
              ],
              [
                -76.5545810002245,
                39.2809769986795,
                0
              ],
              [
                -76.5545180000367,
                39.280991998911,
                0
              ],
              [
                -76.5544249986727,
                39.2810089994031,
                0
              ],
              [
                -76.5542020014099,
                39.2810229987936,
                0
              ],
              [
                -76.5538639996705,
                39.2810349990866,
                0
              ],
              [
                -76.5534060010663,
                39.2810829989117,
                0
              ],
              [
                -76.5533780000143,
                39.2810809990384,
                0
              ],
              [
                -76.5532600003107,
                39.2810819987419,
                0
              ],
              [
                -76.5531959997429,
                39.2810849989681,
                0
              ],
              [
                -76.552726999448,
                39.2810999988968,
                0
              ],
              [
                -76.5523950005466,
                39.28109899906,
                0
              ],
              [
                -76.5517440004933,
                39.2811249987265,
                0
              ],
              [
                -76.5506079997436,
                39.281171998969,
                0
              ],
              [
                -76.5503440012718,
                39.2811889985566,
                0
              ],
              [
                -76.5500979994986,
                39.2812069987758,
                0
              ],
              [
                -76.5499310001076,
                39.2812149982582,
                0
              ],
              [
                -76.5498420001338,
                39.281215999351,
                0
              ],
              [
                -76.5497680002531,
                39.2812149978221,
                0
              ],
              [
                -76.549748000072,
                39.2812149977247,
                0
              ],
              [
                -76.5497150003915,
                39.2811999986872,
                0
              ],
              [
                -76.5495440005581,
                39.281206998648,
                0
              ],
              [
                -76.5489750001203,
                39.2812299997053,
                0
              ],
              [
                -76.5487979998509,
                39.28123699896,
                0
              ],
              [
                -76.5484059998979,
                39.2812539987589,
                0
              ],
              [
                -76.5475859999604,
                39.2812859993047,
                0
              ],
              [
                -76.5457230000255,
                39.2813619992502,
                0
              ],
              [
                -76.544785999511,
                39.2813989989581,
                0
              ],
              [
                -76.5438050001567,
                39.2814429994251,
                0
              ],
              [
                -76.5437780000057,
                39.2810679994457,
                0
              ],
              [
                -76.5436679998419,
                39.2794509988496,
                0
              ],
              [
                -76.5436589997604,
                39.2792169988459,
                0
              ],
              [
                -76.5436559998634,
                39.2789119994086,
                0
              ],
              [
                -76.5436669999172,
                39.278627998958,
                0
              ],
              [
                -76.5437130000149,
                39.278301999296,
                0
              ],
              [
                -76.5437379987066,
                39.2779309985759,
                0
              ],
              [
                -76.5436469999231,
                39.2764969980312,
                0
              ],
              [
                -76.5436399989428,
                39.2762819991632,
                0
              ],
              [
                -76.5429810000982,
                39.2762969999622,
                0
              ],
              [
                -76.5422280013881,
                39.2763219985705,
                0
              ],
              [
                -76.5416909995234,
                39.2763389997557,
                0
              ],
              [
                -76.5411350008772,
                39.2763579996397,
                0
              ],
              [
                -76.5405859996489,
                39.2763769999424,
                0
              ],
              [
                -76.5401710004581,
                39.2763909988674,
                0
              ],
              [
                -76.5400480002449,
                39.2763939987246,
                0
              ],
              [
                -76.539900000312,
                39.2763969996089,
                0
              ],
              [
                -76.5396229993248,
                39.2764109993384,
                0
              ],
              [
                -76.5394780007874,
                39.2764159994489,
                0
              ],
              [
                -76.5394020000989,
                39.2764179983911,
                0
              ],
              [
                -76.5393020003162,
                39.2764209993868,
                0
              ],
              [
                -76.5390830002065,
                39.2764279993754,
                0
              ],
              [
                -76.5389409988874,
                39.2764309991717,
                0
              ],
              [
                -76.5388609997801,
                39.2764329991828,
                0
              ],
              [
                -76.5387709998389,
                39.2764369983041,
                0
              ],
              [
                -76.5385310003324,
                39.276445999175,
                0
              ],
              [
                -76.5384720002178,
                39.2764479994534,
                0
              ],
              [
                -76.5383069999022,
                39.2764519989371,
                0
              ],
              [
                -76.5380520001562,
                39.2764639988709,
                0
              ],
              [
                -76.5380049997878,
                39.2764659992696,
                0
              ],
              [
                -76.5379859987341,
                39.2758129978561,
                0
              ],
              [
                -76.5379729995968,
                39.2756099992912,
                0
              ],
              [
                -76.5379499988929,
                39.2752519987069,
                0
              ],
              [
                -76.537923999634,
                39.2748399987666,
                0
              ],
              [
                -76.5373950010855,
                39.2748519989914,
                0
              ],
              [
                -76.5371879997913,
                39.2748869989202,
                0
              ],
              [
                -76.5370990004416,
                39.2749119993964,
                0
              ],
              [
                -76.5370079999486,
                39.2749459986939,
                0
              ],
              [
                -76.5368950003594,
                39.2749930002382,
                0
              ],
              [
                -76.536819999581,
                39.2750209994071,
                0
              ],
              [
                -76.5367500005306,
                39.2750349978055,
                0
              ],
              [
                -76.5363680002404,
                39.2750589993467,
                0
              ],
              [
                -76.536097999914,
                39.275063998997,
                0
              ],
              [
                -76.5358979995332,
                39.2750819988942,
                0
              ],
              [
                -76.5357460001811,
                39.2751099993593,
                0
              ],
              [
                -76.5355790003339,
                39.2751569987599,
                0
              ],
              [
                -76.535412999662,
                39.2752049990255,
                0
              ],
              [
                -76.5352680004615,
                39.2752489989767,
                0
              ],
              [
                -76.535169999665,
                39.2752709988498,
                0
              ],
              [
                -76.5350819995389,
                39.2752879993329,
                0
              ],
              [
                -76.5349930013702,
                39.2752929993733,
                0
              ],
              [
                -76.5350679996465,
                39.2760829993122,
                0
              ],
              [
                -76.5341810002655,
                39.2769159987932,
                0
              ],
              [
                -76.5335039996671,
                39.2775409990144,
                0
              ],
              [
                -76.5337269994733,
                39.2780029989298,
                0
              ],
              [
                -76.5338759994796,
                39.2783099988678,
                0
              ],
              [
                -76.5342520000805,
                39.2790789987885,
                0
              ],
              [
                -76.5346350003945,
                39.2798549987665,
                0
              ],
              [
                -76.534700000157,
                39.2799759986289,
                0
              ],
              [
                -76.5347250000388,
                39.2800229987732,
                0
              ],
              [
                -76.5352129998618,
                39.2809869988602,
                0
              ],
              [
                -76.5355350001379,
                39.2815159990364,
                0
              ],
              [
                -76.5357039999249,
                39.2817929987794,
                0
              ],
              [
                -76.5355079991651,
                39.2818999978354,
                0
              ],
              [
                -76.5349020000296,
                39.2822319993974,
                0
              ],
              [
                -76.5337850000657,
                39.2828429989196,
                0
              ],
              [
                -76.5330830003091,
                39.2832269994453,
                0
              ],
              [
                -76.5317000012447,
                39.2840409989322,
                0
              ],
              [
                -76.5303929999304,
                39.2848179987233,
                0
              ],
              [
                -76.5295920001223,
                39.2848519990143,
                0
              ],
              [
                -76.529663000279,
                39.2842029988531,
                0
              ],
              [
                -76.529933999888,
                39.2830819987208,
                0
              ],
              [
                -76.5297870000348,
                39.281872000297,
                0
              ],
              [
                -76.5297880000858,
                39.2815269981731,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 2,
          "Census_Tract": "24510250205",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "4af2f4c7-2bad-4d10-a588-dc3d8b6ff9eb",
          "Shape__Area": 24919633.131774902,
          "Shape__Length": 31475.704157190274
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6341089985249,
                39.2498449990476,
                0
              ],
              [
                -76.6314819994866,
                39.2466419985622,
                0
              ],
              [
                -76.6301310001159,
                39.2449959991782,
                0
              ],
              [
                -76.6297619997623,
                39.2445470004215,
                0
              ],
              [
                -76.629487999699,
                39.2442409987323,
                0
              ],
              [
                -76.6293300003654,
                39.2440679986094,
                0
              ],
              [
                -76.6292430012619,
                39.2439809993955,
                0
              ],
              [
                -76.6291320003039,
                39.2438719986097,
                0
              ],
              [
                -76.6289600002102,
                39.243709998999,
                0
              ],
              [
                -76.6288489997578,
                39.2436229992874,
                0
              ],
              [
                -76.6286699992865,
                39.2434729988058,
                0
              ],
              [
                -76.6284740005028,
                39.2433259978665,
                0
              ],
              [
                -76.6279849996396,
                39.2429959990458,
                0
              ],
              [
                -76.6276640004362,
                39.2428120003814,
                0
              ],
              [
                -76.627234999803,
                39.242605998877,
                0
              ],
              [
                -76.626870999982,
                39.2424410001728,
                0
              ],
              [
                -76.6266510003146,
                39.2423529987877,
                0
              ],
              [
                -76.6264790004347,
                39.24229399875,
                0
              ],
              [
                -76.6262289994913,
                39.2422169986226,
                0
              ],
              [
                -76.6259859998052,
                39.2421499990204,
                0
              ],
              [
                -76.6257559999411,
                39.2421029987673,
                0
              ],
              [
                -76.6255839997977,
                39.2420699991031,
                0
              ],
              [
                -76.6253199995807,
                39.2420229994435,
                0
              ],
              [
                -76.6249419999987,
                39.2419649987171,
                0
              ],
              [
                -76.6243169997951,
                39.2419009983281,
                0
              ],
              [
                -76.6235299995918,
                39.2418289987981,
                0
              ],
              [
                -76.6226439999332,
                39.2417639990844,
                0
              ],
              [
                -76.6219069996993,
                39.2417119987946,
                0
              ],
              [
                -76.6217210011725,
                39.2417019991435,
                0
              ],
              [
                -76.6212209999201,
                39.2416639993334,
                0
              ],
              [
                -76.6202639994267,
                39.2415939991562,
                0
              ],
              [
                -76.6193069995342,
                39.2415129990425,
                0
              ],
              [
                -76.6183399997882,
                39.2414249992379,
                0
              ],
              [
                -76.6173740004186,
                39.2413299993166,
                0
              ],
              [
                -76.6163849994973,
                39.2412350000466,
                0
              ],
              [
                -76.6157559993788,
                39.2411799991229,
                0
              ],
              [
                -76.6153189165405,
                39.2411448760821,
                0
              ],
              [
                -76.6153659818138,
                39.2410068508179,
                0
              ],
              [
                -76.6179904940695,
                39.2379856109799,
                0
              ],
              [
                -76.6186769850085,
                39.2374275382848,
                0
              ],
              [
                -76.6186889997725,
                39.2374329990703,
                0
              ],
              [
                -76.6190390001115,
                39.2377269986123,
                0
              ],
              [
                -76.6212620002202,
                39.23861099937,
                0
              ],
              [
                -76.6225499998301,
                39.2391680000891,
                0
              ],
              [
                -76.6236539995953,
                39.2396459989065,
                0
              ],
              [
                -76.6267039999252,
                39.2409689990397,
                0
              ],
              [
                -76.6293010004579,
                39.2420959984069,
                0
              ],
              [
                -76.6297649994577,
                39.2422969989874,
                0
              ],
              [
                -76.6298530015287,
                39.2423379985926,
                0
              ],
              [
                -76.6300170004102,
                39.2424099990304,
                0
              ],
              [
                -76.6307349997077,
                39.2427249986826,
                0
              ],
              [
                -76.6309609998319,
                39.2428239988639,
                0
              ],
              [
                -76.6311319994628,
                39.2428989985865,
                0
              ],
              [
                -76.6325890000697,
                39.2434059990792,
                0
              ],
              [
                -76.6333760001584,
                39.2437829993846,
                0
              ],
              [
                -76.6353759991668,
                39.2447410002705,
                0
              ],
              [
                -76.637266999627,
                39.2456479994056,
                0
              ],
              [
                -76.6384940001833,
                39.2461659998479,
                0
              ],
              [
                -76.6389149997695,
                39.2463419990109,
                0
              ],
              [
                -76.639427999936,
                39.2465679990754,
                0
              ],
              [
                -76.6403279995561,
                39.247029997755,
                0
              ],
              [
                -76.6410640008755,
                39.2473889994231,
                0
              ],
              [
                -76.6412550004914,
                39.2474819986328,
                0
              ],
              [
                -76.6418270013928,
                39.2477609994361,
                0
              ],
              [
                -76.6423420000126,
                39.2480119989934,
                0
              ],
              [
                -76.6440139995449,
                39.2488269988614,
                0
              ],
              [
                -76.6440339994437,
                39.2488369985952,
                0
              ],
              [
                -76.6442120003431,
                39.2489239994324,
                0
              ],
              [
                -76.6472560003506,
                39.2500599993846,
                0
              ],
              [
                -76.651491000407,
                39.2519829993075,
                0
              ],
              [
                -76.6525090002411,
                39.2523439991443,
                0
              ],
              [
                -76.6533929995052,
                39.2527030002329,
                0
              ],
              [
                -76.6542399998492,
                39.2531249997933,
                0
              ],
              [
                -76.6550799995079,
                39.2535119993702,
                0
              ],
              [
                -76.6555689996403,
                39.2537009990982,
                0
              ],
              [
                -76.6566900001857,
                39.2541439992619,
                0
              ],
              [
                -76.6598600000413,
                39.2555090003329,
                0
              ],
              [
                -76.6596670000289,
                39.2556250004103,
                0
              ],
              [
                -76.6596240000541,
                39.2556509989283,
                0
              ],
              [
                -76.6595090015035,
                39.2557299988103,
                0
              ],
              [
                -76.6593119999749,
                39.2558230000113,
                0
              ],
              [
                -76.6591699996035,
                39.2559009988255,
                0
              ],
              [
                -76.6591090005562,
                39.2559459988413,
                0
              ],
              [
                -76.6585800003476,
                39.2563219987175,
                0
              ],
              [
                -76.6581840004913,
                39.2565209998241,
                0
              ],
              [
                -76.6578119996434,
                39.2566869987593,
                0
              ],
              [
                -76.6577940004999,
                39.2566929985605,
                0
              ],
              [
                -76.6575590008632,
                39.2567839989555,
                0
              ],
              [
                -76.6565070014176,
                39.2571059987512,
                0
              ],
              [
                -76.656396998868,
                39.2571399988445,
                0
              ],
              [
                -76.6555580004397,
                39.2573919993859,
                0
              ],
              [
                -76.6543180004691,
                39.2577739991322,
                0
              ],
              [
                -76.6532300002329,
                39.2581189997784,
                0
              ],
              [
                -76.6529659998905,
                39.258212998562,
                0
              ],
              [
                -76.6527870011157,
                39.2582829985748,
                0
              ],
              [
                -76.6525100013502,
                39.2584009993665,
                0
              ],
              [
                -76.6521130002277,
                39.2586059986283,
                0
              ],
              [
                -76.6518419999122,
                39.2587709987205,
                0
              ],
              [
                -76.6515279999356,
                39.2589759988517,
                0
              ],
              [
                -76.6508140000707,
                39.2595179986668,
                0
              ],
              [
                -76.6499369995301,
                39.2602189989315,
                0
              ],
              [
                -76.649834000424,
                39.2603139992548,
                0
              ],
              [
                -76.648858999508,
                39.2603139990443,
                0
              ],
              [
                -76.6478939991251,
                39.260313999107,
                0
              ],
              [
                -76.6472729994464,
                39.2602829991898,
                0
              ],
              [
                -76.6469540005407,
                39.2602599987846,
                0
              ],
              [
                -76.6468000006625,
                39.2602489994112,
                0
              ],
              [
                -76.6465119998503,
                39.2602169986966,
                0
              ],
              [
                -76.6461890005106,
                39.260170999301,
                0
              ],
              [
                -76.6458750004993,
                39.2601199989749,
                0
              ],
              [
                -76.645670000332,
                39.2600809988976,
                0
              ],
              [
                -76.6453599985216,
                39.2600139990238,
                0
              ],
              [
                -76.6448929988937,
                39.2599099993606,
                0
              ],
              [
                -76.6445619999523,
                39.2598149992872,
                0
              ],
              [
                -76.6440600001479,
                39.259647998794,
                0
              ],
              [
                -76.6436539994432,
                39.2595049992965,
                0
              ],
              [
                -76.6434869992833,
                39.2594339992551,
                0
              ],
              [
                -76.6433509995024,
                39.259374998573,
                0
              ],
              [
                -76.6429029995786,
                39.2591489992047,
                0
              ],
              [
                -76.6427029995925,
                39.259052998668,
                0
              ],
              [
                -76.6425650004589,
                39.2589759990553,
                0
              ],
              [
                -76.6424419998437,
                39.2589119988841,
                0
              ],
              [
                -76.6422829997422,
                39.2588199993619,
                0
              ],
              [
                -76.6420569999991,
                39.2586789990346,
                0
              ],
              [
                -76.6418919996222,
                39.2585659991071,
                0
              ],
              [
                -76.6417790005456,
                39.2584909997344,
                0
              ],
              [
                -76.6414439997371,
                39.2582549985678,
                0
              ],
              [
                -76.6413489995226,
                39.2581839990922,
                0
              ],
              [
                -76.6412160004424,
                39.2580719994003,
                0
              ],
              [
                -76.6409969994901,
                39.2578909990686,
                0
              ],
              [
                -76.6409010004639,
                39.2578059991378,
                0
              ],
              [
                -76.6407619999619,
                39.2576639994092,
                0
              ],
              [
                -76.6406599991392,
                39.2575669988997,
                0
              ],
              [
                -76.6405560013668,
                39.2574639993772,
                0
              ],
              [
                -76.6403990004836,
                39.2572899992679,
                0
              ],
              [
                -76.640214999689,
                39.2570919990232,
                0
              ],
              [
                -76.6401040002815,
                39.2569629985811,
                0
              ],
              [
                -76.6399109996336,
                39.2567390002097,
                0
              ],
              [
                -76.6395980000024,
                39.25635499913,
                0
              ],
              [
                -76.6392869999199,
                39.2559790003259,
                0
              ],
              [
                -76.6386539993745,
                39.2552449987248,
                0
              ],
              [
                -76.638463000314,
                39.2550269986082,
                0
              ],
              [
                -76.6375550009631,
                39.2539189994021,
                0
              ],
              [
                -76.6374619994305,
                39.2538069989348,
                0
              ],
              [
                -76.6363570001404,
                39.2524549991071,
                0
              ],
              [
                -76.6355230012499,
                39.2514870000549,
                0
              ],
              [
                -76.6341089985249,
                39.2498449990476,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 3,
          "Census_Tract": "24510150100",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "5f9d6bf9-1fb3-482d-b806-acf78f1c30f5",
          "Shape__Area": 3975429.1446533203,
          "Shape__Length": 8364.423431078258
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6368289998164,
                39.3034209993124,
                0
              ],
              [
                -76.6373900004275,
                39.3034319988999,
                0
              ],
              [
                -76.638245999498,
                39.3034039991322,
                0
              ],
              [
                -76.6389669993524,
                39.3033779987359,
                0
              ],
              [
                -76.6396760003938,
                39.3033619987453,
                0
              ],
              [
                -76.6404069994913,
                39.3033239986949,
                0
              ],
              [
                -76.6411160004657,
                39.3033059993476,
                0
              ],
              [
                -76.6418030004648,
                39.3033079992902,
                0
              ],
              [
                -76.6423989999832,
                39.3032939992141,
                0
              ],
              [
                -76.6425559994742,
                39.30329000017,
                0
              ],
              [
                -76.6431310011232,
                39.3032729978411,
                0
              ],
              [
                -76.6432170002894,
                39.3032709990101,
                0
              ],
              [
                -76.6432180000639,
                39.3032109991197,
                0
              ],
              [
                -76.6439049998562,
                39.3031959994268,
                0
              ],
              [
                -76.6446430000691,
                39.3031759994514,
                0
              ],
              [
                -76.64467100153,
                39.3037049986845,
                0
              ],
              [
                -76.6446800003781,
                39.3039269990199,
                0
              ],
              [
                -76.6446900004014,
                39.3041069992517,
                0
              ],
              [
                -76.6446940002428,
                39.3042629987234,
                0
              ],
              [
                -76.6447310001812,
                39.3048369987717,
                0
              ],
              [
                -76.6447690000003,
                39.3053519986841,
                0
              ],
              [
                -76.6447970000171,
                39.3057739986769,
                0
              ],
              [
                -76.6448059999387,
                39.3062889990353,
                0
              ],
              [
                -76.6448389999231,
                39.306726998799,
                0
              ],
              [
                -76.6448450011869,
                39.3069149989869,
                0
              ],
              [
                -76.6448720003777,
                39.3073749985575,
                0
              ],
              [
                -76.644886001393,
                39.3076180004172,
                0
              ],
              [
                -76.6449129998661,
                39.3080059989972,
                0
              ],
              [
                -76.6449460004572,
                39.3088929991181,
                0
              ],
              [
                -76.6450060005635,
                39.3099439987967,
                0
              ],
              [
                -76.644379000322,
                39.3099849986792,
                0
              ],
              [
                -76.6442389998035,
                39.3099969990098,
                0
              ],
              [
                -76.6437200004107,
                39.3100239994145,
                0
              ],
              [
                -76.6425140003439,
                39.310088999422,
                0
              ],
              [
                -76.6416189997489,
                39.3093569987113,
                0
              ],
              [
                -76.6407960000858,
                39.3086569986938,
                0
              ],
              [
                -76.6403920000874,
                39.3082999993728,
                0
              ],
              [
                -76.6397370000319,
                39.3077429986932,
                0
              ],
              [
                -76.6394489995392,
                39.3075109988906,
                0
              ],
              [
                -76.6388230003318,
                39.306991999186,
                0
              ],
              [
                -76.6386959995798,
                39.3067759987136,
                0
              ],
              [
                -76.6386079998655,
                39.3066099991393,
                0
              ],
              [
                -76.6384680004206,
                39.3063369991814,
                0
              ],
              [
                -76.6381469996478,
                39.3057729987482,
                0
              ],
              [
                -76.6380329989852,
                39.3055969985967,
                0
              ],
              [
                -76.6377849997352,
                39.305152998907,
                0
              ],
              [
                -76.6374709997901,
                39.3045889990563,
                0
              ],
              [
                -76.6373000005712,
                39.3042769991393,
                0
              ],
              [
                -76.6368289998164,
                39.3034209993124,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 4,
          "Census_Tract": "24510120400",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "f4e46b61-4082-4235-80d9-c3690db5b795",
          "Shape__Area": 3024807.183959961,
          "Shape__Length": 7015.784245275022
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.609490000811,
                39.3162339993763,
                0
              ],
              [
                -76.6095240004939,
                39.3154909989082,
                0
              ],
              [
                -76.6095280000939,
                39.3150659988402,
                0
              ],
              [
                -76.6095320002956,
                39.3145079988255,
                0
              ],
              [
                -76.6095489994456,
                39.3139829986895,
                0
              ],
              [
                -76.6095339994755,
                39.3135219988155,
                0
              ],
              [
                -76.6095369997128,
                39.3127879986511,
                0
              ],
              [
                -76.6095370002449,
                39.3127660004329,
                0
              ],
              [
                -76.6095369999138,
                39.3127369988473,
                0
              ],
              [
                -76.6095269996343,
                39.3124769989248,
                0
              ],
              [
                -76.6095110006911,
                39.3120800004233,
                0
              ],
              [
                -76.6095080000464,
                39.3120169988928,
                0
              ],
              [
                -76.6095050001184,
                39.3118329981129,
                0
              ],
              [
                -76.6095029995367,
                39.3117520001231,
                0
              ],
              [
                -76.6094969988985,
                39.3114049987133,
                0
              ],
              [
                -76.6095319997312,
                39.311359998921,
                0
              ],
              [
                -76.6095860003884,
                39.3113309992943,
                0
              ],
              [
                -76.6097370000662,
                39.3113129993637,
                0
              ],
              [
                -76.6099140001983,
                39.3113129988583,
                0
              ],
              [
                -76.6102340015391,
                39.3112989991529,
                0
              ],
              [
                -76.6109710005059,
                39.3112589986565,
                0
              ],
              [
                -76.6118059998011,
                39.311215998937,
                0
              ],
              [
                -76.6124639994879,
                39.311193998993,
                0
              ],
              [
                -76.6137879994436,
                39.3111369993482,
                0
              ],
              [
                -76.6138099996939,
                39.3111359988525,
                0
              ],
              [
                -76.6149549995483,
                39.3110649989458,
                0
              ],
              [
                -76.6149639995726,
                39.3111969988725,
                0
              ],
              [
                -76.6150639996697,
                39.3123049993475,
                0
              ],
              [
                -76.615131999521,
                39.3132789992979,
                0
              ],
              [
                -76.6151759988294,
                39.3142919986172,
                0
              ],
              [
                -76.6152729999342,
                39.315362998588,
                0
              ],
              [
                -76.6152889991845,
                39.3159429991145,
                0
              ],
              [
                -76.615301999533,
                39.3164129996725,
                0
              ],
              [
                -76.6147169997789,
                39.3164369979307,
                0
              ],
              [
                -76.6141490006744,
                39.3164549987382,
                0
              ],
              [
                -76.6134489998983,
                39.3164879989026,
                0
              ],
              [
                -76.612769001108,
                39.3164989986619,
                0
              ],
              [
                -76.6120530000708,
                39.3165209990472,
                0
              ],
              [
                -76.6120139998609,
                39.3165229987783,
                0
              ],
              [
                -76.6112920003397,
                39.3165579987146,
                0
              ],
              [
                -76.6112760004975,
                39.316272999736,
                0
              ],
              [
                -76.6104290015416,
                39.3162569990429,
                0
              ],
              [
                -76.609490000811,
                39.3162339993763,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 5,
          "Census_Tract": "24510270701",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "901896a2-579d-47e1-a0a0-a4ddec033c98",
          "Shape__Area": 4303639.616027832,
          "Shape__Length": 9272.372669923865
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.5625449997021,
                39.3668279988656,
                0
              ],
              [
                -76.5626149998671,
                39.3667159989573,
                0
              ],
              [
                -76.5653360015692,
                39.3677349987074,
                0
              ],
              [
                -76.5660800005547,
                39.367957998765,
                0
              ],
              [
                -76.5665600001324,
                39.3681279991614,
                0
              ],
              [
                -76.5666610000701,
                39.3681639992357,
                0
              ],
              [
                -76.5670710002126,
                39.3683009985732,
                0
              ],
              [
                -76.5672039994268,
                39.3683619989186,
                0
              ],
              [
                -76.5676429996641,
                39.3685089993944,
                0
              ],
              [
                -76.5679380001396,
                39.3685829993347,
                0
              ],
              [
                -76.5681209998437,
                39.3686169988669,
                0
              ],
              [
                -76.568323000453,
                39.3686249986309,
                0
              ],
              [
                -76.5685379999465,
                39.368630999254,
                0
              ],
              [
                -76.5686570000661,
                39.3686229994221,
                0
              ],
              [
                -76.5689519995012,
                39.3686069993452,
                0
              ],
              [
                -76.5693860005646,
                39.368594998817,
                0
              ],
              [
                -76.5694400001118,
                39.3685989994424,
                0
              ],
              [
                -76.5698430002685,
                39.3685839986616,
                0
              ],
              [
                -76.5700810010733,
                39.3685639987551,
                0
              ],
              [
                -76.5703040005753,
                39.3685349992097,
                0
              ],
              [
                -76.5707849996629,
                39.3684989992635,
                0
              ],
              [
                -76.5714190005306,
                39.3684489981418,
                0
              ],
              [
                -76.5727559985908,
                39.3685029989642,
                0
              ],
              [
                -76.5730060006004,
                39.368509998592,
                0
              ],
              [
                -76.5733900002197,
                39.3685279990581,
                0
              ],
              [
                -76.573562999545,
                39.3685389993794,
                0
              ],
              [
                -76.5735130015626,
                39.368596998685,
                0
              ],
              [
                -76.5734449999521,
                39.3686719989947,
                0
              ],
              [
                -76.5731919994459,
                39.368965998715,
                0
              ],
              [
                -76.5729869995262,
                39.369203000395,
                0
              ],
              [
                -76.5728539992764,
                39.3693539993625,
                0
              ],
              [
                -76.5727320003314,
                39.3694869990248,
                0
              ],
              [
                -76.5724239985637,
                39.369788000428,
                0
              ],
              [
                -76.5721379996475,
                39.3700379992027,
                0
              ],
              [
                -76.5717209984294,
                39.370432999663,
                0
              ],
              [
                -76.5713499999782,
                39.3708009999767,
                0
              ],
              [
                -76.5709479996475,
                39.3712009991626,
                0
              ],
              [
                -76.5704210004772,
                39.3717249992105,
                0
              ],
              [
                -76.5702179992857,
                39.3719259988674,
                0
              ],
              [
                -76.5701000000112,
                39.3720389986155,
                0
              ],
              [
                -76.5699970001291,
                39.3721209991969,
                0
              ],
              [
                -76.5697490002988,
                39.3721139978485,
                0
              ],
              [
                -76.5693879995529,
                39.3721049988161,
                0
              ],
              [
                -76.5672429999257,
                39.3721039986861,
                0
              ],
              [
                -76.5664419995686,
                39.3721189986846,
                0
              ],
              [
                -76.5617880000751,
                39.3722049991166,
                0
              ],
              [
                -76.5616680011971,
                39.3719309991521,
                0
              ],
              [
                -76.5616669997302,
                39.3710389991361,
                0
              ],
              [
                -76.5616789988113,
                39.3705259985819,
                0
              ],
              [
                -76.5617079995118,
                39.3701229993418,
                0
              ],
              [
                -76.5617060003252,
                39.3701039988846,
                0
              ],
              [
                -76.5617130004658,
                39.3700309992629,
                0
              ],
              [
                -76.5617190002192,
                39.3699459989523,
                0
              ],
              [
                -76.5617429998006,
                39.3697829985562,
                0
              ],
              [
                -76.561792000295,
                39.3694959990087,
                0
              ],
              [
                -76.5618060000929,
                39.3693929992675,
                0
              ],
              [
                -76.561818999483,
                39.3692809991991,
                0
              ],
              [
                -76.5618299996989,
                39.3691619992293,
                0
              ],
              [
                -76.5618400000763,
                39.3689959993949,
                0
              ],
              [
                -76.5618560004625,
                39.3685029990303,
                0
              ],
              [
                -76.5618680011186,
                39.3683709987619,
                0
              ],
              [
                -76.5618860004363,
                39.3680399985665,
                0
              ],
              [
                -76.5618989995398,
                39.3679429993778,
                0
              ],
              [
                -76.5619189994687,
                39.3678889988046,
                0
              ],
              [
                -76.5619860011614,
                39.3677790003873,
                0
              ],
              [
                -76.5621080001011,
                39.3675719987588,
                0
              ],
              [
                -76.5622099997145,
                39.3673979986554,
                0
              ],
              [
                -76.5625449997021,
                39.3668279988656,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 6,
          "Census_Tract": "24510080301",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "310a07e6-2da6-426b-ba1e-db191281b5b3",
          "Shape__Area": 2891135.0327148438,
          "Shape__Length": 7208.5038038684415
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.5797039998385,
                39.3024819985599,
                0
              ],
              [
                -76.5811220001744,
                39.3024309990636,
                0
              ],
              [
                -76.5816509999267,
                39.3024069986572,
                0
              ],
              [
                -76.5820979999485,
                39.3023879989092,
                0
              ],
              [
                -76.582554999653,
                39.3023649993931,
                0
              ],
              [
                -76.5830849998412,
                39.3023439992158,
                0
              ],
              [
                -76.5839009997292,
                39.3023129989498,
                0
              ],
              [
                -76.5840230004095,
                39.3036549992261,
                0
              ],
              [
                -76.5840930000331,
                39.304722998892,
                0
              ],
              [
                -76.5841119999012,
                39.3049909991676,
                0
              ],
              [
                -76.5841300000677,
                39.3052479994333,
                0
              ],
              [
                -76.5841600015192,
                39.3055929992999,
                0
              ],
              [
                -76.5841750002382,
                39.3057799991494,
                0
              ],
              [
                -76.5842449995411,
                39.3068489987614,
                0
              ],
              [
                -76.5842770013468,
                39.3073699989796,
                0
              ],
              [
                -76.5842979999483,
                39.3078969988526,
                0
              ],
              [
                -76.584365000159,
                39.3089289993229,
                0
              ],
              [
                -76.5836419995293,
                39.3089559990308,
                0
              ],
              [
                -76.5829080010762,
                39.3089779992944,
                0
              ],
              [
                -76.5823150003006,
                39.3089789996816,
                0
              ],
              [
                -76.5815230011374,
                39.3090059986974,
                0
              ],
              [
                -76.5810410010128,
                39.309023998754,
                0
              ],
              [
                -76.5801030001919,
                39.3090599993729,
                0
              ],
              [
                -76.5800439996764,
                39.3080549989476,
                0
              ],
              [
                -76.580010000512,
                39.3075359991247,
                0
              ],
              [
                -76.5799859994462,
                39.3070009987671,
                0
              ],
              [
                -76.5799569999041,
                39.306469997826,
                0
              ],
              [
                -76.5799459996064,
                39.3062909987469,
                0
              ],
              [
                -76.5799209998859,
                39.3059410002696,
                0
              ],
              [
                -76.5799009999021,
                39.3056549986279,
                0
              ],
              [
                -76.5798809995138,
                39.3054099994401,
                0
              ],
              [
                -76.5798519989674,
                39.3048890002217,
                0
              ],
              [
                -76.5797849999031,
                39.3038109993644,
                0
              ],
              [
                -76.5797689999192,
                39.3035149989899,
                0
              ],
              [
                -76.579748001147,
                39.3031349994201,
                0
              ],
              [
                -76.5797039998385,
                39.3024819985599,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 7,
          "Census_Tract": "24510271801",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "04c60d5b-c02e-4694-bf79-9ef1ae20496c",
          "Shape__Area": 6005606.204345703,
          "Shape__Length": 10393.342788059459
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6759600004651,
                39.3490279988832,
                0
              ],
              [
                -76.6762320003541,
                39.3488909986909,
                0
              ],
              [
                -76.6766450002127,
                39.3486279999674,
                0
              ],
              [
                -76.6769379994234,
                39.3484409989664,
                0
              ],
              [
                -76.6782270005414,
                39.3476209990095,
                0
              ],
              [
                -76.6784490004779,
                39.3474719994401,
                0
              ],
              [
                -76.6789189994609,
                39.3471689997571,
                0
              ],
              [
                -76.6793599995083,
                39.346889998633,
                0
              ],
              [
                -76.6796009998325,
                39.3467349992984,
                0
              ],
              [
                -76.6802810004879,
                39.3463049986125,
                0
              ],
              [
                -76.6806920005285,
                39.3460259991341,
                0
              ],
              [
                -76.6807999995413,
                39.3459509993507,
                0
              ],
              [
                -76.6809269999613,
                39.3458309986101,
                0
              ],
              [
                -76.6814120003717,
                39.3453129989527,
                0
              ],
              [
                -76.6816149994795,
                39.3451009988647,
                0
              ],
              [
                -76.6819109999453,
                39.3447929994269,
                0
              ],
              [
                -76.6819609998476,
                39.3447409988139,
                0
              ],
              [
                -76.682317000152,
                39.3443829991626,
                0
              ],
              [
                -76.6824399994862,
                39.3442599990689,
                0
              ],
              [
                -76.6825269994236,
                39.3441709992531,
                0
              ],
              [
                -76.6829329996025,
                39.3437479990821,
                0
              ],
              [
                -76.683040999812,
                39.3436459992412,
                0
              ],
              [
                -76.6830870005724,
                39.3435939990631,
                0
              ],
              [
                -76.6831209996905,
                39.3435499993437,
                0
              ],
              [
                -76.6832600000723,
                39.3433729987231,
                0
              ],
              [
                -76.6834489998003,
                39.3431109988456,
                0
              ],
              [
                -76.6835189998209,
                39.3429399992977,
                0
              ],
              [
                -76.6853130001201,
                39.3442019995885,
                0
              ],
              [
                -76.6857170002838,
                39.3444879986158,
                0
              ],
              [
                -76.6860180006478,
                39.3446959988356,
                0
              ],
              [
                -76.6860799997825,
                39.3447389991988,
                0
              ],
              [
                -76.6863989994346,
                39.344978999412,
                0
              ],
              [
                -76.6866600008973,
                39.3451639988835,
                0
              ],
              [
                -76.6869439998629,
                39.3453649994332,
                0
              ],
              [
                -76.6870300002437,
                39.3454259987669,
                0
              ],
              [
                -76.6873010006236,
                39.3456179987436,
                0
              ],
              [
                -76.6873320005069,
                39.3456399989458,
                0
              ],
              [
                -76.6875270005466,
                39.3457789992514,
                0
              ],
              [
                -76.6880080005556,
                39.3461239988714,
                0
              ],
              [
                -76.6881979996059,
                39.3462670002724,
                0
              ],
              [
                -76.6886929994348,
                39.3466129988403,
                0
              ],
              [
                -76.6887560002853,
                39.34665899988,
                0
              ],
              [
                -76.6889110001375,
                39.3467749986827,
                0
              ],
              [
                -76.6889900005756,
                39.346831999449,
                0
              ],
              [
                -76.6890450000363,
                39.3468709993164,
                0
              ],
              [
                -76.690058999483,
                39.3475849986453,
                0
              ],
              [
                -76.6898959998687,
                39.3477199989251,
                0
              ],
              [
                -76.6896000008711,
                39.3479649986572,
                0
              ],
              [
                -76.6895719997099,
                39.347988998845,
                0
              ],
              [
                -76.6893659997578,
                39.3481599991612,
                0
              ],
              [
                -76.689166999801,
                39.3483069993497,
                0
              ],
              [
                -76.6888139999894,
                39.3485649989891,
                0
              ],
              [
                -76.6885019995897,
                39.3487979989229,
                0
              ],
              [
                -76.6882460000412,
                39.3489829983002,
                0
              ],
              [
                -76.6880170001516,
                39.3491489991681,
                0
              ],
              [
                -76.6879850001683,
                39.3491730000706,
                0
              ],
              [
                -76.6878409996754,
                39.3492599987398,
                0
              ],
              [
                -76.6876080003232,
                39.3494069996618,
                0
              ],
              [
                -76.6869749986775,
                39.3497519987377,
                0
              ],
              [
                -76.686659001405,
                39.3499299991564,
                0
              ],
              [
                -76.6863359994652,
                39.3501059993048,
                0
              ],
              [
                -76.6860340006453,
                39.3502719987752,
                0
              ],
              [
                -76.6857320004027,
                39.3504379992626,
                0
              ],
              [
                -76.6851249999142,
                39.3507629992131,
                0
              ],
              [
                -76.6849639996103,
                39.3508489994262,
                0
              ],
              [
                -76.6847480001313,
                39.3509639990366,
                0
              ],
              [
                -76.6846579997649,
                39.35101399921,
                0
              ],
              [
                -76.6842480002208,
                39.3512479994223,
                0
              ],
              [
                -76.6838630000371,
                39.351464999081,
                0
              ],
              [
                -76.6833579998676,
                39.3517569988023,
                0
              ],
              [
                -76.683179999471,
                39.3516509993727,
                0
              ],
              [
                -76.6825800000708,
                39.3512859980869,
                0
              ],
              [
                -76.6817030001619,
                39.3507829991756,
                0
              ],
              [
                -76.6815290004424,
                39.3506939987054,
                0
              ],
              [
                -76.6814420000944,
                39.3506529991004,
                0
              ],
              [
                -76.681322000393,
                39.3506039987893,
                0
              ],
              [
                -76.681210999423,
                39.3505659991813,
                0
              ],
              [
                -76.6808480005328,
                39.3504619994011,
                0
              ],
              [
                -76.6804590002335,
                39.3503579989924,
                0
              ],
              [
                -76.6798370000648,
                39.350187998998,
                0
              ],
              [
                -76.6796719994428,
                39.3501429989398,
                0
              ],
              [
                -76.6794419996624,
                39.3500799993952,
                0
              ],
              [
                -76.678857000122,
                39.3499199987074,
                0
              ],
              [
                -76.6768280000619,
                39.3493549988676,
                0
              ],
              [
                -76.6764930001921,
                39.3492429990847,
                0
              ],
              [
                -76.6763719994308,
                39.3491959986822,
                0
              ],
              [
                -76.6762049996095,
                39.3491329986205,
                0
              ],
              [
                -76.6759600004651,
                39.3490279988832,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 8,
          "Census_Tract": "24510060400",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "7a51ffcf-d715-4a85-967d-ee0a301a1a82",
          "Shape__Area": 4629646.413452148,
          "Shape__Length": 8689.289153080013
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.5877300013541,
                39.2965189987939,
                0
              ],
              [
                -76.5877079994547,
                39.2962329988521,
                0
              ],
              [
                -76.5877060001659,
                39.2962049989268,
                0
              ],
              [
                -76.5876459995235,
                39.2954059990521,
                0
              ],
              [
                -76.5875839995712,
                39.2942079993024,
                0
              ],
              [
                -76.5875279997245,
                39.2934319994292,
                0
              ],
              [
                -76.5875179994329,
                39.2932909989062,
                0
              ],
              [
                -76.5875040002387,
                39.2928869991789,
                0
              ],
              [
                -76.5874629999144,
                39.2924149989396,
                0
              ],
              [
                -76.5874449988376,
                39.2921679993671,
                0
              ],
              [
                -76.5874139996538,
                39.2918129988332,
                0
              ],
              [
                -76.5882300003008,
                39.291788999278,
                0
              ],
              [
                -76.589201000079,
                39.2917469993964,
                0
              ],
              [
                -76.5898430002153,
                39.2917129986505,
                0
              ],
              [
                -76.5904680000965,
                39.2916789990908,
                0
              ],
              [
                -76.5911119998396,
                39.2916479979176,
                0
              ],
              [
                -76.5917770000848,
                39.2916159987896,
                0
              ],
              [
                -76.5927709997133,
                39.2915789990135,
                0
              ],
              [
                -76.5932799996481,
                39.2915599988635,
                0
              ],
              [
                -76.5939439998038,
                39.2915419989477,
                0
              ],
              [
                -76.5939919986651,
                39.2920719994405,
                0
              ],
              [
                -76.5940289995255,
                39.2926319985788,
                0
              ],
              [
                -76.5940719999609,
                39.2932869990017,
                0
              ],
              [
                -76.5941170004714,
                39.2939680003205,
                0
              ],
              [
                -76.5941529995373,
                39.2946849989773,
                0
              ],
              [
                -76.5941789998418,
                39.2951429990273,
                0
              ],
              [
                -76.5941840002632,
                39.2952739993691,
                0
              ],
              [
                -76.5941850008896,
                39.2952920000036,
                0
              ],
              [
                -76.5941919995574,
                39.2953259990308,
                0
              ],
              [
                -76.5943120000968,
                39.296292998688,
                0
              ],
              [
                -76.5943630002832,
                39.2972979987501,
                0
              ],
              [
                -76.5944079998758,
                39.2983729991555,
                0
              ],
              [
                -76.594106000402,
                39.2983829986348,
                0
              ],
              [
                -76.5939460003536,
                39.2983879998561,
                0
              ],
              [
                -76.5923780003157,
                39.2984649987679,
                0
              ],
              [
                -76.5915390002252,
                39.298517998669,
                0
              ],
              [
                -76.5908740004891,
                39.2985239989064,
                0
              ],
              [
                -76.5902349997703,
                39.2985559990918,
                0
              ],
              [
                -76.5896009996309,
                39.298579999218,
                0
              ],
              [
                -76.5890929997389,
                39.298598998775,
                0
              ],
              [
                -76.5887130001134,
                39.2986129991918,
                0
              ],
              [
                -76.5878690001787,
                39.2986469989226,
                0
              ],
              [
                -76.5877799995578,
                39.297524999197,
                0
              ],
              [
                -76.5877300013541,
                39.2965189987939,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 9,
          "Census_Tract": "24510070100",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "cf39f086-2baf-467a-9fb1-0afac955dc7f",
          "Shape__Area": 3128199.7935791016,
          "Shape__Length": 7206.8481980413835
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.5726610000556,
                39.2992369992396,
                0
              ],
              [
                -76.5726310000903,
                39.2981229989417,
                0
              ],
              [
                -76.5725969992631,
                39.2971149986721,
                0
              ],
              [
                -76.572986999017,
                39.2971060003828,
                0
              ],
              [
                -76.573682000268,
                39.2970839993132,
                0
              ],
              [
                -76.5743720004431,
                39.2970479989222,
                0
              ],
              [
                -76.5750840003831,
                39.2970259997992,
                0
              ],
              [
                -76.5754899998707,
                39.2970039990554,
                0
              ],
              [
                -76.5758039996074,
                39.2969939988848,
                0
              ],
              [
                -76.5765319996404,
                39.2969679989406,
                0
              ],
              [
                -76.5772359994727,
                39.2969429989491,
                0
              ],
              [
                -76.5779549998092,
                39.2969110001802,
                0
              ],
              [
                -76.5780150000298,
                39.2979399996028,
                0
              ],
              [
                -76.5780850000943,
                39.2990289990329,
                0
              ],
              [
                -76.5781489996122,
                39.3000849988217,
                0
              ],
              [
                -76.5782110003324,
                39.30113099894,
                0
              ],
              [
                -76.5782500012974,
                39.301988998988,
                0
              ],
              [
                -76.5782779999231,
                39.3025489992493,
                0
              ],
              [
                -76.576880001185,
                39.3025929988405,
                0
              ],
              [
                -76.5765379994731,
                39.3025989989575,
                0
              ],
              [
                -76.5762049995343,
                39.3026089992892,
                0
              ],
              [
                -76.5727929984757,
                39.3027209992984,
                0
              ],
              [
                -76.5727870001615,
                39.3022539989692,
                0
              ],
              [
                -76.5727939997959,
                39.3018779990581,
                0
              ],
              [
                -76.5727900011118,
                39.3013509991187,
                0
              ],
              [
                -76.5727799995501,
                39.3007209988799,
                0
              ],
              [
                -76.5727870004944,
                39.3003079992129,
                0
              ],
              [
                -76.5727910008012,
                39.2996399989059,
                0
              ],
              [
                -76.5727890001753,
                39.2992340004057,
                0
              ],
              [
                -76.5726610000556,
                39.2992369992396,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 10,
          "Census_Tract": "24510070200",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "842dbc64-1896-47b5-8bcf-0ec062d47896",
          "Shape__Area": 3348960.7005615234,
          "Shape__Length": 8121.022321067165
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.5779549998092,
                39.2969110001802,
                0
              ],
              [
                -76.578653000252,
                39.2968789991689,
                0
              ],
              [
                -76.5793289985169,
                39.296852000025,
                0
              ],
              [
                -76.5800409998828,
                39.2968169981344,
                0
              ],
              [
                -76.5807540000454,
                39.2967899996473,
                0
              ],
              [
                -76.5814400005584,
                39.2967689987941,
                0
              ],
              [
                -76.5821690014118,
                39.2967519994192,
                0
              ],
              [
                -76.582882000469,
                39.2967199987102,
                0
              ],
              [
                -76.5835850001494,
                39.2966869989267,
                0
              ],
              [
                -76.5836310015069,
                39.2972059986402,
                0
              ],
              [
                -76.5836660000378,
                39.2976859987138,
                0
              ],
              [
                -76.5836819994374,
                39.2981789996025,
                0
              ],
              [
                -76.5837210004539,
                39.2988069994276,
                0
              ],
              [
                -76.5837600001448,
                39.2993339988063,
                0
              ],
              [
                -76.5837879997375,
                39.2998579992262,
                0
              ],
              [
                -76.5838610003801,
                39.3009289987279,
                0
              ],
              [
                -76.5839030002014,
                39.3018069987606,
                0
              ],
              [
                -76.5845840005653,
                39.3017820001707,
                0
              ],
              [
                -76.5845829998477,
                39.3018429986887,
                0
              ],
              [
                -76.5845880002111,
                39.3018809986434,
                0
              ],
              [
                -76.5846120002727,
                39.3018989986753,
                0
              ],
              [
                -76.5846499984427,
                39.3019179993869,
                0
              ],
              [
                -76.5848460002238,
                39.3019229986117,
                0
              ],
              [
                -76.5853540000103,
                39.3018969986397,
                0
              ],
              [
                -76.5853559998812,
                39.3021089991485,
                0
              ],
              [
                -76.5853579997924,
                39.3022969989429,
                0
              ],
              [
                -76.5852239999977,
                39.302293000422,
                0
              ],
              [
                -76.5851030003532,
                39.3022869993299,
                0
              ],
              [
                -76.5847839996658,
                39.3022879991608,
                0
              ],
              [
                -76.5839009997292,
                39.3023129989498,
                0
              ],
              [
                -76.5830849998412,
                39.3023439992158,
                0
              ],
              [
                -76.582554999653,
                39.3023649993931,
                0
              ],
              [
                -76.5820979999485,
                39.3023879989092,
                0
              ],
              [
                -76.5816509999267,
                39.3024069986572,
                0
              ],
              [
                -76.5811220001744,
                39.3024309990636,
                0
              ],
              [
                -76.5797039998385,
                39.3024819985599,
                0
              ],
              [
                -76.5782779999231,
                39.3025489992493,
                0
              ],
              [
                -76.5782500012974,
                39.301988998988,
                0
              ],
              [
                -76.5782110003324,
                39.30113099894,
                0
              ],
              [
                -76.5781489996122,
                39.3000849988217,
                0
              ],
              [
                -76.5780850000943,
                39.2990289990329,
                0
              ],
              [
                -76.5780150000298,
                39.2979399996028,
                0
              ],
              [
                -76.5779549998092,
                39.2969110001802,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 11,
          "Census_Tract": "24510070300",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "a4fb4b16-5823-452d-9750-09e945f44781",
          "Shape__Area": 2461452.398071289,
          "Shape__Length": 6949.353338767403
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.5853579997924,
                39.3022969989429,
                0
              ],
              [
                -76.5853559998812,
                39.3021089991485,
                0
              ],
              [
                -76.5853540000103,
                39.3018969986397,
                0
              ],
              [
                -76.5848460002238,
                39.3019229986117,
                0
              ],
              [
                -76.5846499984427,
                39.3019179993869,
                0
              ],
              [
                -76.5846120002727,
                39.3018989986753,
                0
              ],
              [
                -76.5845880002111,
                39.3018809986434,
                0
              ],
              [
                -76.5845829998477,
                39.3018429986887,
                0
              ],
              [
                -76.5845840005653,
                39.3017820001707,
                0
              ],
              [
                -76.5839030002014,
                39.3018069987606,
                0
              ],
              [
                -76.5838610003801,
                39.3009289987279,
                0
              ],
              [
                -76.5837879997375,
                39.2998579992262,
                0
              ],
              [
                -76.5837600001448,
                39.2993339988063,
                0
              ],
              [
                -76.5837210004539,
                39.2988069994276,
                0
              ],
              [
                -76.5836819994374,
                39.2981789996025,
                0
              ],
              [
                -76.5836660000378,
                39.2976859987138,
                0
              ],
              [
                -76.5836310015069,
                39.2972059986402,
                0
              ],
              [
                -76.5835850001494,
                39.2966869989267,
                0
              ],
              [
                -76.5842970003646,
                39.296662999253,
                0
              ],
              [
                -76.5850259998846,
                39.2966359990319,
                0
              ],
              [
                -76.5857520001147,
                39.296601000281,
                0
              ],
              [
                -76.5865289998558,
                39.296559999128,
                0
              ],
              [
                -76.5871050005468,
                39.296543997911,
                0
              ],
              [
                -76.5877300013541,
                39.2965189987939,
                0
              ],
              [
                -76.5877799995578,
                39.297524999197,
                0
              ],
              [
                -76.5878690001787,
                39.2986469989226,
                0
              ],
              [
                -76.5879360004638,
                39.2996989987384,
                0
              ],
              [
                -76.5879980012538,
                39.3007569977111,
                0
              ],
              [
                -76.5880790011215,
                39.3021379991153,
                0
              ],
              [
                -76.5880950005023,
                39.3024510001647,
                0
              ],
              [
                -76.5881350003318,
                39.303217998809,
                0
              ],
              [
                -76.5878880000916,
                39.303064999259,
                0
              ],
              [
                -76.5876850010067,
                39.3029540001005,
                0
              ],
              [
                -76.5874829994946,
                39.3028499993736,
                0
              ],
              [
                -76.5873130003615,
                39.3027689989591,
                0
              ],
              [
                -76.5871110005627,
                39.3026859978606,
                0
              ],
              [
                -76.5869169994783,
                39.3026129986255,
                0
              ],
              [
                -76.5865190003134,
                39.3024949991995,
                0
              ],
              [
                -76.5863479988845,
                39.302452999373,
                0
              ],
              [
                -76.5861919997435,
                39.3024159990965,
                0
              ],
              [
                -76.5859980001272,
                39.3023769992537,
                0
              ],
              [
                -76.5857990001453,
                39.3023429986852,
                0
              ],
              [
                -76.5856510004117,
                39.302322998872,
                0
              ],
              [
                -76.5855209996985,
                39.3023089992627,
                0
              ],
              [
                -76.5853579997924,
                39.3022969989429,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 12,
          "Census_Tract": "24510070400",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "e152c44c-eaff-40f4-8b58-5ca3c74294ae",
          "Shape__Area": 3519489.6533813477,
          "Shape__Length": 8069.43642612596
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.5878690001787,
                39.2986469989226,
                0
              ],
              [
                -76.5887130001134,
                39.2986129991918,
                0
              ],
              [
                -76.5890929997389,
                39.298598998775,
                0
              ],
              [
                -76.5896009996309,
                39.298579999218,
                0
              ],
              [
                -76.5902349997703,
                39.2985559990918,
                0
              ],
              [
                -76.5908740004891,
                39.2985239989064,
                0
              ],
              [
                -76.5915390002252,
                39.298517998669,
                0
              ],
              [
                -76.5923780003157,
                39.2984649987679,
                0
              ],
              [
                -76.5939460003536,
                39.2983879998561,
                0
              ],
              [
                -76.594106000402,
                39.2983829986348,
                0
              ],
              [
                -76.5944079998758,
                39.2983729991555,
                0
              ],
              [
                -76.5944739994744,
                39.2983919996892,
                0
              ],
              [
                -76.5945100000344,
                39.2983999992756,
                0
              ],
              [
                -76.5945870001316,
                39.2984019989568,
                0
              ],
              [
                -76.5948339997508,
                39.2983909988058,
                0
              ],
              [
                -76.5949309994992,
                39.2983849991318,
                0
              ],
              [
                -76.5951819994968,
                39.2983709990033,
                0
              ],
              [
                -76.5956769999751,
                39.2983499989696,
                0
              ],
              [
                -76.5962790003807,
                39.2983169998562,
                0
              ],
              [
                -76.5964530004649,
                39.2983069992967,
                0
              ],
              [
                -76.5975970007148,
                39.2982509991579,
                0
              ],
              [
                -76.5976599988743,
                39.2990580000692,
                0
              ],
              [
                -76.5976809986715,
                39.299336999041,
                0
              ],
              [
                -76.5977389995547,
                39.3004019992988,
                0
              ],
              [
                -76.5977939984429,
                39.301228998767,
                0
              ],
              [
                -76.5977960004206,
                39.3012639982627,
                0
              ],
              [
                -76.597828999503,
                39.3017439989562,
                0
              ],
              [
                -76.5973250012087,
                39.3017729994265,
                0
              ],
              [
                -76.5964420002493,
                39.3018229993777,
                0
              ],
              [
                -76.5946580000484,
                39.3018809987257,
                0
              ],
              [
                -76.5943669996982,
                39.3018919988705,
                0
              ],
              [
                -76.5943510005648,
                39.3018929993241,
                0
              ],
              [
                -76.5934989997056,
                39.3019269993563,
                0
              ],
              [
                -76.5924639996272,
                39.3019669990146,
                0
              ],
              [
                -76.5917880000748,
                39.3020009988664,
                0
              ],
              [
                -76.5911380006804,
                39.3020269992035,
                0
              ],
              [
                -76.5904789995009,
                39.3020539986423,
                0
              ],
              [
                -76.5898169984298,
                39.3020749992777,
                0
              ],
              [
                -76.588920999692,
                39.3021089989793,
                0
              ],
              [
                -76.5883499998112,
                39.302128999093,
                0
              ],
              [
                -76.5880790011215,
                39.3021379991153,
                0
              ],
              [
                -76.5879980012538,
                39.3007569977111,
                0
              ],
              [
                -76.5879360004638,
                39.2996989987384,
                0
              ],
              [
                -76.5878690001787,
                39.2986469989226,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 13,
          "Census_Tract": "24510080700",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "a5d56f2a-6091-4313-8c6e-aa2a593f05e3",
          "Shape__Area": 3215645.8822021484,
          "Shape__Length": 7872.463297157653
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.5885070003156,
                39.3086789985591,
                0
              ],
              [
                -76.5884120012602,
                39.3077319987887,
                0
              ],
              [
                -76.5883800002526,
                39.307206998703,
                0
              ],
              [
                -76.588339000109,
                39.306684998944,
                0
              ],
              [
                -76.5883179984785,
                39.3061619990541,
                0
              ],
              [
                -76.5882860000078,
                39.3056399991187,
                0
              ],
              [
                -76.5894679993497,
                39.3056050004293,
                0
              ],
              [
                -76.590027000458,
                39.3056019988699,
                0
              ],
              [
                -76.5906859997273,
                39.3055639991259,
                0
              ],
              [
                -76.5913310003077,
                39.3055519995972,
                0
              ],
              [
                -76.5925210001188,
                39.3054520003088,
                0
              ],
              [
                -76.5945640001954,
                39.3053689988127,
                0
              ],
              [
                -76.5948529996132,
                39.3053570004107,
                0
              ],
              [
                -76.5952359998446,
                39.3053429993876,
                0
              ],
              [
                -76.5966399997655,
                39.3053009988334,
                0
              ],
              [
                -76.5973659998791,
                39.3052629988615,
                0
              ],
              [
                -76.5980689994396,
                39.305221999082,
                0
              ],
              [
                -76.5980969995929,
                39.3056419988251,
                0
              ],
              [
                -76.5981170001703,
                39.3062319988536,
                0
              ],
              [
                -76.5981190004156,
                39.3062869995822,
                0
              ],
              [
                -76.5981260002587,
                39.3063959988443,
                0
              ],
              [
                -76.5981830001938,
                39.3073549993603,
                0
              ],
              [
                -76.5982780005799,
                39.3084249990255,
                0
              ],
              [
                -76.5975400004445,
                39.3084619988964,
                0
              ],
              [
                -76.5968599993747,
                39.3084959999486,
                0
              ],
              [
                -76.5959560009327,
                39.3085339992871,
                0
              ],
              [
                -76.5950270003318,
                39.3085649994144,
                0
              ],
              [
                -76.5947820000984,
                39.3085749999088,
                0
              ],
              [
                -76.5939559993569,
                39.3086109991186,
                0
              ],
              [
                -76.5928459994614,
                39.3086409988365,
                0
              ],
              [
                -76.5921929999422,
                39.3086579989208,
                0
              ],
              [
                -76.5915330006104,
                39.3086819987453,
                0
              ],
              [
                -76.5908879998814,
                39.3087099996015,
                0
              ],
              [
                -76.5902279999518,
                39.3087529989532,
                0
              ],
              [
                -76.5893460000967,
                39.3087939993697,
                0
              ],
              [
                -76.5891760000754,
                39.3088019992679,
                0
              ],
              [
                -76.5884829996931,
                39.308804998769,
                0
              ],
              [
                -76.5885070003156,
                39.3086789985591,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 14,
          "Census_Tract": "24510261000",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "f966c64f-8a2a-4bc4-9311-3206314e5e9d",
          "Shape__Area": 3336900.3588867188,
          "Shape__Length": 10206.153307543207
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.5694130003195,
                39.2924869991264,
                0
              ],
              [
                -76.5693849995504,
                39.2919549985633,
                0
              ],
              [
                -76.5693690001482,
                39.2917569993323,
                0
              ],
              [
                -76.5693340004036,
                39.2913359981889,
                0
              ],
              [
                -76.5693200003073,
                39.2910979989024,
                0
              ],
              [
                -76.5693059995362,
                39.2908669994158,
                0
              ],
              [
                -76.569258000262,
                39.2901990002318,
                0
              ],
              [
                -76.569213999845,
                39.2894179987036,
                0
              ],
              [
                -76.5691579995527,
                39.2885749994134,
                0
              ],
              [
                -76.5690909994278,
                39.2875649986319,
                0
              ],
              [
                -76.5695599994586,
                39.2875489991585,
                0
              ],
              [
                -76.5700460004854,
                39.2875319998409,
                0
              ],
              [
                -76.5708229991078,
                39.2875029991487,
                0
              ],
              [
                -76.5716069986352,
                39.2874769976726,
                0
              ],
              [
                -76.5716689995578,
                39.28847099916,
                0
              ],
              [
                -76.5717729996111,
                39.2901059988551,
                0
              ],
              [
                -76.5718389990352,
                39.2912429991561,
                0
              ],
              [
                -76.571953999992,
                39.2923959994504,
                0
              ],
              [
                -76.5723800011925,
                39.2923809993384,
                0
              ],
              [
                -76.5724370015608,
                39.2929379989216,
                0
              ],
              [
                -76.5724680004419,
                39.2935039987468,
                0
              ],
              [
                -76.5725219999436,
                39.2941869991294,
                0
              ],
              [
                -76.5725649997023,
                39.2947769990122,
                0
              ],
              [
                -76.572579000382,
                39.2956439996576,
                0
              ],
              [
                -76.5725870001013,
                39.2963379989317,
                0
              ],
              [
                -76.5725969992631,
                39.2971149986721,
                0
              ],
              [
                -76.5726310000903,
                39.2981229989417,
                0
              ],
              [
                -76.5726610000556,
                39.2992369992396,
                0
              ],
              [
                -76.5722599997805,
                39.2992489992019,
                0
              ],
              [
                -76.571536999783,
                39.2992769987756,
                0
              ],
              [
                -76.5707880000905,
                39.2993009986362,
                0
              ],
              [
                -76.5703979996179,
                39.2993229993342,
                0
              ],
              [
                -76.5699110005099,
                39.2993499996259,
                0
              ],
              [
                -76.5698919999181,
                39.2992909987706,
                0
              ],
              [
                -76.5698689984518,
                39.2992019987754,
                0
              ],
              [
                -76.5698589995249,
                39.2990799993031,
                0
              ],
              [
                -76.5698399996141,
                39.2988069986291,
                0
              ],
              [
                -76.5698029996495,
                39.2982389998019,
                0
              ],
              [
                -76.5697400004041,
                39.297224998736,
                0
              ],
              [
                -76.5696790004352,
                39.2963779993353,
                0
              ],
              [
                -76.5696560004569,
                39.2960609987145,
                0
              ],
              [
                -76.5696250005223,
                39.2954919989661,
                0
              ],
              [
                -76.5695930012501,
                39.2949079986816,
                0
              ],
              [
                -76.5695469999351,
                39.2942689987572,
                0
              ],
              [
                -76.5695020005466,
                39.2936189986615,
                0
              ],
              [
                -76.5694619995132,
                39.2930659990142,
                0
              ],
              [
                -76.5694130003195,
                39.2924869991264,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 15,
          "Census_Tract": "24510260303",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "906077a8-d543-444b-8891-bb17fff22a5e",
          "Shape__Area": 13119129.344543457,
          "Shape__Length": 18294.689961114796
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.5489380008862,
                39.3158879992101,
                0
              ],
              [
                -76.5491010002447,
                39.315180998728,
                0
              ],
              [
                -76.5491929996047,
                39.3149439987736,
                0
              ],
              [
                -76.5492369995978,
                39.3147679994142,
                0
              ],
              [
                -76.549267999493,
                39.3147039988691,
                0
              ],
              [
                -76.5492980001598,
                39.3146309986279,
                0
              ],
              [
                -76.5493099994237,
                39.3145519987616,
                0
              ],
              [
                -76.5493149987974,
                39.3144679989711,
                0
              ],
              [
                -76.5493220002435,
                39.3144139993464,
                0
              ],
              [
                -76.5493420001378,
                39.3143459995671,
                0
              ],
              [
                -76.5493769996188,
                39.314253998993,
                0
              ],
              [
                -76.5493990001341,
                39.3141809986658,
                0
              ],
              [
                -76.5494150002643,
                39.3141009989666,
                0
              ],
              [
                -76.5494119988673,
                39.3140329992499,
                0
              ],
              [
                -76.5494100004533,
                39.3139629991938,
                0
              ],
              [
                -76.5493909996181,
                39.3138779993976,
                0
              ],
              [
                -76.5493490006487,
                39.3137400000559,
                0
              ],
              [
                -76.5493559984349,
                39.3136819992421,
                0
              ],
              [
                -76.5493619995829,
                39.3136499985515,
                0
              ],
              [
                -76.5493759993824,
                39.3136200002882,
                0
              ],
              [
                -76.5494960000594,
                39.3134249988608,
                0
              ],
              [
                -76.5496439987796,
                39.3132589990795,
                0
              ],
              [
                -76.5498299998585,
                39.3130339991908,
                0
              ],
              [
                -76.5499759993807,
                39.3128589990629,
                0
              ],
              [
                -76.5501199994373,
                39.312728000276,
                0
              ],
              [
                -76.5502109997945,
                39.3126119996395,
                0
              ],
              [
                -76.550261,
                39.3125039992812,
                0
              ],
              [
                -76.5503209996972,
                39.3122149994064,
                0
              ],
              [
                -76.55038699884,
                39.3113179986823,
                0
              ],
              [
                -76.550577000374,
                39.311341000317,
                0
              ],
              [
                -76.5506940002626,
                39.3113609986575,
                0
              ],
              [
                -76.5508620004563,
                39.3114049988319,
                0
              ],
              [
                -76.5510099999697,
                39.3114299992399,
                0
              ],
              [
                -76.5511659994733,
                39.3114259986104,
                0
              ],
              [
                -76.551507999527,
                39.3113679994059,
                0
              ],
              [
                -76.5517940004627,
                39.3112869982768,
                0
              ],
              [
                -76.5519380005131,
                39.3112079988434,
                0
              ],
              [
                -76.5520460003522,
                39.3110939990959,
                0
              ],
              [
                -76.5521019997103,
                39.3109989988991,
                0
              ],
              [
                -76.5521689998921,
                39.3109519987201,
                0
              ],
              [
                -76.5526060015658,
                39.3108189982686,
                0
              ],
              [
                -76.5527900002279,
                39.3107519986263,
                0
              ],
              [
                -76.5529589991595,
                39.3106459991906,
                0
              ],
              [
                -76.5531390000403,
                39.3105079978039,
                0
              ],
              [
                -76.5533669994652,
                39.3102949977596,
                0
              ],
              [
                -76.5536099996068,
                39.3101019988214,
                0
              ],
              [
                -76.5540229998235,
                39.3108069990359,
                0
              ],
              [
                -76.5548540003178,
                39.3104639987601,
                0
              ],
              [
                -76.5560650004994,
                39.3101579987969,
                0
              ],
              [
                -76.5568080002133,
                39.309985998793,
                0
              ],
              [
                -76.5577880002165,
                39.3097139986786,
                0
              ],
              [
                -76.5587349988782,
                39.3094759988785,
                0
              ],
              [
                -76.5605360005511,
                39.3090579986357,
                0
              ],
              [
                -76.5608570000224,
                39.3090159992553,
                0
              ],
              [
                -76.5609150000185,
                39.3090119986466,
                0
              ],
              [
                -76.5611979997244,
                39.3089869986542,
                0
              ],
              [
                -76.5612150004187,
                39.3089859992432,
                0
              ],
              [
                -76.5616309996998,
                39.3089779993401,
                0
              ],
              [
                -76.5621170005771,
                39.3089689986786,
                0
              ],
              [
                -76.5622930004078,
                39.3089659982154,
                0
              ],
              [
                -76.5634520004245,
                39.3089669993591,
                0
              ],
              [
                -76.565477999992,
                39.3089699993363,
                0
              ],
              [
                -76.5661619998138,
                39.3089289993356,
                0
              ],
              [
                -76.5666569997774,
                39.3089599986375,
                0
              ],
              [
                -76.567022999794,
                39.3090249988879,
                0
              ],
              [
                -76.567312998462,
                39.309109998717,
                0
              ],
              [
                -76.5674179999886,
                39.3091369990719,
                0
              ],
              [
                -76.5680140014056,
                39.3092929985686,
                0
              ],
              [
                -76.5683500003182,
                39.3093459988864,
                0
              ],
              [
                -76.5684460000136,
                39.3093579982729,
                0
              ],
              [
                -76.5686149996021,
                39.3093789993304,
                0
              ],
              [
                -76.5688450003871,
                39.3093859992258,
                0
              ],
              [
                -76.5694749998178,
                39.3093719999657,
                0
              ],
              [
                -76.5698660010101,
                39.3093709997999,
                0
              ],
              [
                -76.5700480000917,
                39.3093699994512,
                0
              ],
              [
                -76.5701809995287,
                39.3093679990135,
                0
              ],
              [
                -76.5717360000984,
                39.3093659993562,
                0
              ],
              [
                -76.5721299991788,
                39.3093569993588,
                0
              ],
              [
                -76.572334000113,
                39.309353000396,
                0
              ],
              [
                -76.5728680004704,
                39.3093419987563,
                0
              ],
              [
                -76.5730459998483,
                39.3093379986219,
                0
              ],
              [
                -76.5730660002061,
                39.3097319992341,
                0
              ],
              [
                -76.5730760002909,
                39.30992199884,
                0
              ],
              [
                -76.573093999892,
                39.3103619991472,
                0
              ],
              [
                -76.5730909997658,
                39.3116419990333,
                0
              ],
              [
                -76.5731169996984,
                39.3124519992783,
                0
              ],
              [
                -76.5731419998902,
                39.3132289992002,
                0
              ],
              [
                -76.5731449999828,
                39.3143159986869,
                0
              ],
              [
                -76.5731369998857,
                39.3144739990568,
                0
              ],
              [
                -76.5729620001386,
                39.3144419989698,
                0
              ],
              [
                -76.5727569988449,
                39.3145639988926,
                0
              ],
              [
                -76.5724899999087,
                39.3145819987125,
                0
              ],
              [
                -76.5721949999976,
                39.3145089989678,
                0
              ],
              [
                -76.5715759998566,
                39.314101999399,
                0
              ],
              [
                -76.5713940004729,
                39.3139750002841,
                0
              ],
              [
                -76.5710949996814,
                39.3137699990369,
                0
              ],
              [
                -76.5708239998872,
                39.3136079986664,
                0
              ],
              [
                -76.5706800002271,
                39.3135409987132,
                0
              ],
              [
                -76.5705399994835,
                39.3134899989078,
                0
              ],
              [
                -76.570446999472,
                39.3134509985677,
                0
              ],
              [
                -76.5703150004003,
                39.3134249993927,
                0
              ],
              [
                -76.5701829999505,
                39.3134090002549,
                0
              ],
              [
                -76.5699859986536,
                39.3134099999999,
                0
              ],
              [
                -76.5699530001049,
                39.3134099999488,
                0
              ],
              [
                -76.5696729987201,
                39.3134169988932,
                0
              ],
              [
                -76.5689939994639,
                39.3134539987769,
                0
              ],
              [
                -76.5683549997431,
                39.3134939988646,
                0
              ],
              [
                -76.5681110008118,
                39.3135089998297,
                0
              ],
              [
                -76.5677130004043,
                39.3135309993407,
                0
              ],
              [
                -76.5675400000308,
                39.3135329993408,
                0
              ],
              [
                -76.5671640001031,
                39.31353799872,
                0
              ],
              [
                -76.5670190006214,
                39.3135399992971,
                0
              ],
              [
                -76.566871999973,
                39.3135449990429,
                0
              ],
              [
                -76.5664070005758,
                39.3135609994536,
                0
              ],
              [
                -76.5659270005697,
                39.3135709994301,
                0
              ],
              [
                -76.5658299984639,
                39.3135729992711,
                0
              ],
              [
                -76.56543700008,
                39.3135819990381,
                0
              ],
              [
                -76.5649799997506,
                39.31358799887,
                0
              ],
              [
                -76.5645109990845,
                39.3135939992945,
                0
              ],
              [
                -76.564215999813,
                39.3136009990198,
                0
              ],
              [
                -76.5640809998744,
                39.3136069990819,
                0
              ],
              [
                -76.5639819998466,
                39.3136119994126,
                0
              ],
              [
                -76.5638110001289,
                39.3136249986777,
                0
              ],
              [
                -76.5636679998889,
                39.3136420001299,
                0
              ],
              [
                -76.5635689997001,
                39.3136569994053,
                0
              ],
              [
                -76.5632789997123,
                39.3137099989425,
                0
              ],
              [
                -76.5630039985067,
                39.3137779988841,
                0
              ],
              [
                -76.5628310003576,
                39.3138349993329,
                0
              ],
              [
                -76.5625649998637,
                39.3139249993689,
                0
              ],
              [
                -76.56208800054,
                39.314120999161,
                0
              ],
              [
                -76.5617449995553,
                39.31426199943,
                0
              ],
              [
                -76.5614890000622,
                39.3143689991633,
                0
              ],
              [
                -76.5613590003465,
                39.3144239987707,
                0
              ],
              [
                -76.5610799999236,
                39.3145389987449,
                0
              ],
              [
                -76.5606940005421,
                39.3146849993743,
                0
              ],
              [
                -76.5603320004752,
                39.3148310002512,
                0
              ],
              [
                -76.5599419994393,
                39.3150089990034,
                0
              ],
              [
                -76.5594609997589,
                39.3152419987102,
                0
              ],
              [
                -76.5593140002863,
                39.3153149987845,
                0
              ],
              [
                -76.5592779984341,
                39.3153350001716,
                0
              ],
              [
                -76.5588589999809,
                39.3155649988967,
                0
              ],
              [
                -76.55841700008,
                39.3158069996393,
                0
              ],
              [
                -76.5580849999155,
                39.3159929989716,
                0
              ],
              [
                -76.5580200000874,
                39.316029998979,
                0
              ],
              [
                -76.5578829995859,
                39.3161069990873,
                0
              ],
              [
                -76.5575069996332,
                39.3163309989613,
                0
              ],
              [
                -76.5571230002956,
                39.3165609989399,
                0
              ],
              [
                -76.556752999433,
                39.3167989987213,
                0
              ],
              [
                -76.5564969991951,
                39.3169699988447,
                0
              ],
              [
                -76.5564070000566,
                39.3170369996526,
                0
              ],
              [
                -76.5560659990791,
                39.3172639985962,
                0
              ],
              [
                -76.5556819996272,
                39.3175179989674,
                0
              ],
              [
                -76.5555789991921,
                39.3175859993611,
                0
              ],
              [
                -76.5550240004388,
                39.3179559977145,
                0
              ],
              [
                -76.5549189998471,
                39.3178609991848,
                0
              ],
              [
                -76.5548730001269,
                39.3178239993883,
                0
              ],
              [
                -76.5548259998201,
                39.3177939991557,
                0
              ],
              [
                -76.5547410001816,
                39.317755998555,
                0
              ],
              [
                -76.5534729996097,
                39.3172789990445,
                0
              ],
              [
                -76.5530089996642,
                39.3170979992163,
                0
              ],
              [
                -76.5526260007786,
                39.316973998574,
                0
              ],
              [
                -76.5524499995619,
                39.3168699991685,
                0
              ],
              [
                -76.5523110000442,
                39.316807998573,
                0
              ],
              [
                -76.552049999743,
                39.316758999151,
                0
              ],
              [
                -76.5516179987334,
                39.3166869991007,
                0
              ],
              [
                -76.5512569997847,
                39.3166199993616,
                0
              ],
              [
                -76.5509529996956,
                39.316580999228,
                0
              ],
              [
                -76.5507890002094,
                39.3165419993757,
                0
              ],
              [
                -76.5505699995522,
                39.3164989985878,
                0
              ],
              [
                -76.5504309998151,
                39.3164609990954,
                0
              ],
              [
                -76.5502790002345,
                39.3164479988129,
                0
              ],
              [
                -76.5501359996237,
                39.3164639992905,
                0
              ],
              [
                -76.5500379993555,
                39.3164869987276,
                0
              ],
              [
                -76.54989200012,
                39.316491999106,
                0
              ],
              [
                -76.5497099996774,
                39.3164719987026,
                0
              ],
              [
                -76.549588000148,
                39.3164529990385,
                0
              ],
              [
                -76.5494929999289,
                39.3164419987765,
                0
              ],
              [
                -76.5493900006992,
                39.3164269990365,
                0
              ],
              [
                -76.5492549999949,
                39.3163869993923,
                0
              ],
              [
                -76.5491519999,
                39.3163509992144,
                0
              ],
              [
                -76.5490690001932,
                39.3163179986422,
                0
              ],
              [
                -76.5490299995065,
                39.3162970000905,
                0
              ],
              [
                -76.5490009997774,
                39.3162729998542,
                0
              ],
              [
                -76.5489640003705,
                39.3162380004025,
                0
              ],
              [
                -76.5489429998384,
                39.3161929990982,
                0
              ],
              [
                -76.5489240001604,
                39.3161099989675,
                0
              ],
              [
                -76.5489249992237,
                39.3159399985993,
                0
              ],
              [
                -76.5489380008862,
                39.3158879992101,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 16,
          "Census_Tract": "24510151200",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "22962967-baec-468d-8d95-1171a3f59e69",
          "Shape__Area": 8392221.768859863,
          "Shape__Length": 11884.693965165327
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6540320005283,
                39.3302909986759,
                0
              ],
              [
                -76.6540440000201,
                39.3302139993542,
                0
              ],
              [
                -76.6542669997788,
                39.3300990003731,
                0
              ],
              [
                -76.6545849992314,
                39.3298809986378,
                0
              ],
              [
                -76.6550609997726,
                39.329542998298,
                0
              ],
              [
                -76.6552960004822,
                39.3293259985579,
                0
              ],
              [
                -76.6554850003044,
                39.3289949990768,
                0
              ],
              [
                -76.6556629996546,
                39.328510999306,
                0
              ],
              [
                -76.6557919999976,
                39.3281569994191,
                0
              ],
              [
                -76.6562989990546,
                39.3269359991423,
                0
              ],
              [
                -76.6566140001941,
                39.3263749986619,
                0
              ],
              [
                -76.6567189994242,
                39.3262129985712,
                0
              ],
              [
                -76.6573010003591,
                39.3256229986877,
                0
              ],
              [
                -76.6575280001275,
                39.3254529990482,
                0
              ],
              [
                -76.6575939996963,
                39.3253999994136,
                0
              ],
              [
                -76.6577089990969,
                39.3255579987411,
                0
              ],
              [
                -76.6578420000255,
                39.3257130004162,
                0
              ],
              [
                -76.65805799854,
                39.326003998854,
                0
              ],
              [
                -76.6581620003036,
                39.3261329994342,
                0
              ],
              [
                -76.6582090007733,
                39.3261829988574,
                0
              ],
              [
                -76.6582810005287,
                39.326222998773,
                0
              ],
              [
                -76.6583880001776,
                39.3263759992955,
                0
              ],
              [
                -76.65853100034,
                39.3265559979522,
                0
              ],
              [
                -76.6586839987074,
                39.3267739992085,
                0
              ],
              [
                -76.6588670009304,
                39.3270679987987,
                0
              ],
              [
                -76.6597950002812,
                39.3266219986613,
                0
              ],
              [
                -76.6607479996623,
                39.3266819993166,
                0
              ],
              [
                -76.6615939996374,
                39.3269139991785,
                0
              ],
              [
                -76.663331001549,
                39.3272609986802,
                0
              ],
              [
                -76.6638390005572,
                39.3273919991251,
                0
              ],
              [
                -76.6639680003203,
                39.3274249993877,
                0
              ],
              [
                -76.6643019996071,
                39.3275119986251,
                0
              ],
              [
                -76.665142999993,
                39.3304309992404,
                0
              ],
              [
                -76.6654199997473,
                39.3314359993307,
                0
              ],
              [
                -76.6654499995233,
                39.3315469990811,
                0
              ],
              [
                -76.6655500005348,
                39.3319129994542,
                0
              ],
              [
                -76.665721999454,
                39.3325399994236,
                0
              ],
              [
                -76.6657900005163,
                39.332715999586,
                0
              ],
              [
                -76.6658900005336,
                39.3329679992571,
                0
              ],
              [
                -76.6650609997022,
                39.3333849978798,
                0
              ],
              [
                -76.6647459999308,
                39.3335269988257,
                0
              ],
              [
                -76.6640310001253,
                39.3338729986394,
                0
              ],
              [
                -76.6626639995881,
                39.3345099997756,
                0
              ],
              [
                -76.6625699998703,
                39.3345459994337,
                0
              ],
              [
                -76.6619949999883,
                39.3347729992077,
                0
              ],
              [
                -76.6612370005797,
                39.3350709989845,
                0
              ],
              [
                -76.6611540004622,
                39.3351029992684,
                0
              ],
              [
                -76.6602110002724,
                39.3354919991219,
                0
              ],
              [
                -76.6598440005638,
                39.3356519992176,
                0
              ],
              [
                -76.6587229999882,
                39.3359340001548,
                0
              ],
              [
                -76.6584690001212,
                39.3359939988791,
                0
              ],
              [
                -76.6571989996576,
                39.336301999103,
                0
              ],
              [
                -76.6568559997399,
                39.336384999241,
                0
              ],
              [
                -76.6567959998568,
                39.336399000024,
                0
              ],
              [
                -76.6563589998796,
                39.3365039978836,
                0
              ],
              [
                -76.6563480002995,
                39.3363979992914,
                0
              ],
              [
                -76.6563369998082,
                39.3362909990626,
                0
              ],
              [
                -76.6562780005798,
                39.3357069990902,
                0
              ],
              [
                -76.6562700002092,
                39.3356370003423,
                0
              ],
              [
                -76.6562560010212,
                39.3355659986349,
                0
              ],
              [
                -76.6562480002062,
                39.3355260001294,
                0
              ],
              [
                -76.6562159998598,
                39.3354079988882,
                0
              ],
              [
                -76.6561570001582,
                39.3352529988817,
                0
              ],
              [
                -76.6560719997342,
                39.3350570000685,
                0
              ],
              [
                -76.6560259988328,
                39.334943999271,
                0
              ],
              [
                -76.6560059986616,
                39.3348949986997,
                0
              ],
              [
                -76.6559729995631,
                39.3347859992051,
                0
              ],
              [
                -76.6559370001119,
                39.3346109977365,
                0
              ],
              [
                -76.6559249997435,
                39.3344649993686,
                0
              ],
              [
                -76.6559390000515,
                39.3342079988487,
                0
              ],
              [
                -76.6559489995495,
                39.3340499993547,
                0
              ],
              [
                -76.6559549994382,
                39.3339639992276,
                0
              ],
              [
                -76.6559559995855,
                39.3339189990573,
                0
              ],
              [
                -76.6559640005231,
                39.3335489993845,
                0
              ],
              [
                -76.6559489994536,
                39.3334529989405,
                0
              ],
              [
                -76.6559220014102,
                39.3333589999645,
                0
              ],
              [
                -76.6558850003237,
                39.3332829992417,
                0
              ],
              [
                -76.6558159989484,
                39.3331669990312,
                0
              ],
              [
                -76.6557730004094,
                39.333106998687,
                0
              ],
              [
                -76.6557349985154,
                39.3330529993224,
                0
              ],
              [
                -76.6556640002411,
                39.3329639993554,
                0
              ],
              [
                -76.6555359995992,
                39.3328209991837,
                0
              ],
              [
                -76.6554399995506,
                39.3326909985705,
                0
              ],
              [
                -76.6553050004115,
                39.3324840002654,
                0
              ],
              [
                -76.655187000518,
                39.3322840000181,
                0
              ],
              [
                -76.6549669996581,
                39.3318929986126,
                0
              ],
              [
                -76.6546309994433,
                39.3313369993763,
                0
              ],
              [
                -76.6540919994988,
                39.330396998684,
                0
              ],
              [
                -76.6540320005283,
                39.3302909986759,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 17,
          "Census_Tract": "24510151300",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "a8ced016-633a-4934-b3ac-43b65bbd6982",
          "Shape__Area": 9981887.201843262,
          "Shape__Length": 15529.293413620251
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6738480009793,
                39.3410260003007,
                0
              ],
              [
                -76.6725620000966,
                39.3406649986542,
                0
              ],
              [
                -76.671486000328,
                39.3403479992522,
                0
              ],
              [
                -76.6713500008815,
                39.3403089988336,
                0
              ],
              [
                -76.6707300001433,
                39.3401349993378,
                0
              ],
              [
                -76.669411999655,
                39.3397669989325,
                0
              ],
              [
                -76.6692499994838,
                39.339717999452,
                0
              ],
              [
                -76.6688579988807,
                39.3396089993629,
                0
              ],
              [
                -76.6686819998492,
                39.3395559990894,
                0
              ],
              [
                -76.6685270000518,
                39.3395039999405,
                0
              ],
              [
                -76.6684059995766,
                39.3394449986228,
                0
              ],
              [
                -76.66832399965,
                39.3393919989879,
                0
              ],
              [
                -76.6682700002017,
                39.3393439990764,
                0
              ],
              [
                -76.6681919997728,
                39.3392699989644,
                0
              ],
              [
                -76.6680720005475,
                39.3391130000105,
                0
              ],
              [
                -76.6679260004847,
                39.338920998406,
                0
              ],
              [
                -76.6671340004127,
                39.3393039998441,
                0
              ],
              [
                -76.6670310002434,
                39.3393539994333,
                0
              ],
              [
                -76.6668219996522,
                39.3394559993981,
                0
              ],
              [
                -76.6664729997112,
                39.3396319988832,
                0
              ],
              [
                -76.6663700002193,
                39.3396749991078,
                0
              ],
              [
                -76.6658839997575,
                39.3398829987346,
                0
              ],
              [
                -76.6654979998,
                39.3400469994255,
                0
              ],
              [
                -76.6653420007629,
                39.340130998444,
                0
              ],
              [
                -76.6652370000512,
                39.340215999093,
                0
              ],
              [
                -76.6651400000658,
                39.3403359992409,
                0
              ],
              [
                -76.6650020005516,
                39.3404349987253,
                0
              ],
              [
                -76.6649010001195,
                39.3405029981091,
                0
              ],
              [
                -76.6647210004435,
                39.3406109993742,
                0
              ],
              [
                -76.664549999594,
                39.340704998748,
                0
              ],
              [
                -76.6644470002864,
                39.3407539989408,
                0
              ],
              [
                -76.6642320000572,
                39.3408479992622,
                0
              ],
              [
                -76.6641009999382,
                39.3408889989314,
                0
              ],
              [
                -76.6639519998782,
                39.3409309990735,
                0
              ],
              [
                -76.6638259985601,
                39.3409539987406,
                0
              ],
              [
                -76.6636270005531,
                39.340967999074,
                0
              ],
              [
                -76.663440999546,
                39.3409670001552,
                0
              ],
              [
                -76.6633179997736,
                39.3409609994019,
                0
              ],
              [
                -76.6631829996372,
                39.340935998969,
                0
              ],
              [
                -76.6630020008814,
                39.3408819985798,
                0
              ],
              [
                -76.6628000005688,
                39.3408089986243,
                0
              ],
              [
                -76.6625819996608,
                39.3407459992992,
                0
              ],
              [
                -76.6624349996238,
                39.3407149979322,
                0
              ],
              [
                -76.6622630012068,
                39.3406890002624,
                0
              ],
              [
                -76.6621670000877,
                39.3406799989189,
                0
              ],
              [
                -76.6621280000638,
                39.3406789987068,
                0
              ],
              [
                -76.6620699994723,
                39.3406769980853,
                0
              ],
              [
                -76.6620059996433,
                39.3406729994506,
                0
              ],
              [
                -76.6612790002939,
                39.3406979987686,
                0
              ],
              [
                -76.6586999987038,
                39.3407999992731,
                0
              ],
              [
                -76.6584099997995,
                39.3408319990593,
                0
              ],
              [
                -76.658195000316,
                39.340684998677,
                0
              ],
              [
                -76.6581330000441,
                39.3405439986985,
                0
              ],
              [
                -76.6580579993331,
                39.3403309985784,
                0
              ],
              [
                -76.6579829997238,
                39.3400579988922,
                0
              ],
              [
                -76.6578919997302,
                39.3394060002061,
                0
              ],
              [
                -76.6578289996749,
                39.3390689985928,
                0
              ],
              [
                -76.6573159999866,
                39.338599998721,
                0
              ],
              [
                -76.6569029995174,
                39.3382009988932,
                0
              ],
              [
                -76.6568459997656,
                39.338152999347,
                0
              ],
              [
                -76.6567709998683,
                39.3380709990294,
                0
              ],
              [
                -76.6566860007972,
                39.3379689990353,
                0
              ],
              [
                -76.6566039998763,
                39.337847000377,
                0
              ],
              [
                -76.6565529994791,
                39.3377329989717,
                0
              ],
              [
                -76.6565230004075,
                39.3376509993366,
                0
              ],
              [
                -76.6564890003756,
                39.337553998695,
                0
              ],
              [
                -76.6564690001258,
                39.3374439988592,
                0
              ],
              [
                -76.6564450002137,
                39.337250998937,
                0
              ],
              [
                -76.6564090002766,
                39.3369209992454,
                0
              ],
              [
                -76.6563589998796,
                39.3365039978836,
                0
              ],
              [
                -76.6567959998568,
                39.336399000024,
                0
              ],
              [
                -76.6568559997399,
                39.336384999241,
                0
              ],
              [
                -76.6571989996576,
                39.336301999103,
                0
              ],
              [
                -76.6584690001212,
                39.3359939988791,
                0
              ],
              [
                -76.6587229999882,
                39.3359340001548,
                0
              ],
              [
                -76.6598440005638,
                39.3356519992176,
                0
              ],
              [
                -76.6602110002724,
                39.3354919991219,
                0
              ],
              [
                -76.6611540004622,
                39.3351029992684,
                0
              ],
              [
                -76.6612370005797,
                39.3350709989845,
                0
              ],
              [
                -76.6619949999883,
                39.3347729992077,
                0
              ],
              [
                -76.6625699998703,
                39.3345459994337,
                0
              ],
              [
                -76.6626639995881,
                39.3345099997756,
                0
              ],
              [
                -76.6640310001253,
                39.3338729986394,
                0
              ],
              [
                -76.6647459999308,
                39.3335269988257,
                0
              ],
              [
                -76.6650609997022,
                39.3333849978798,
                0
              ],
              [
                -76.6658900005336,
                39.3329679992571,
                0
              ],
              [
                -76.6660499998532,
                39.3332419988769,
                0
              ],
              [
                -76.6662240014913,
                39.3334789993248,
                0
              ],
              [
                -76.666331000523,
                39.3336099986691,
                0
              ],
              [
                -76.6664710007097,
                39.3337609989399,
                0
              ],
              [
                -76.666692998693,
                39.3339609988569,
                0
              ],
              [
                -76.6668719999626,
                39.3340989997484,
                0
              ],
              [
                -76.6670890002994,
                39.3342499985563,
                0
              ],
              [
                -76.6672849999657,
                39.3343689988656,
                0
              ],
              [
                -76.6674550005231,
                39.3344579989124,
                0
              ],
              [
                -76.6676580002673,
                39.3345510003453,
                0
              ],
              [
                -76.6679119994289,
                39.3346559993241,
                0
              ],
              [
                -76.6681570003543,
                39.3347450003222,
                0
              ],
              [
                -76.6684749994862,
                39.3348499985741,
                0
              ],
              [
                -76.6689039984685,
                39.3349929985541,
                0
              ],
              [
                -76.6695840000671,
                39.335232998752,
                0
              ],
              [
                -76.6708309999032,
                39.3356919987754,
                0
              ],
              [
                -76.6711059999312,
                39.3358119992661,
                0
              ],
              [
                -76.6713749995596,
                39.3359499990419,
                0
              ],
              [
                -76.6716699987711,
                39.3361039986922,
                0
              ],
              [
                -76.6718999994221,
                39.3362419991099,
                0
              ],
              [
                -76.6723639997106,
                39.3365379990525,
                0
              ],
              [
                -76.673018999571,
                39.3369769993882,
                0
              ],
              [
                -76.6742950008007,
                39.3378209987459,
                0
              ],
              [
                -76.6762429997679,
                39.3390979985548,
                0
              ],
              [
                -76.6765999989536,
                39.3393159992974,
                0
              ],
              [
                -76.6768989995918,
                39.3394809991915,
                0
              ],
              [
                -76.6772340001447,
                39.3396439993234,
                0
              ],
              [
                -76.6775689995231,
                39.3397899987417,
                0
              ],
              [
                -76.6779640003796,
                39.3399249986507,
                0
              ],
              [
                -76.6776649999266,
                39.3403589998704,
                0
              ],
              [
                -76.6772660000056,
                39.340903999191,
                0
              ],
              [
                -76.6771979994625,
                39.3409669996732,
                0
              ],
              [
                -76.6771399996675,
                39.3410359986105,
                0
              ],
              [
                -76.6770669999176,
                39.3411339989961,
                0
              ],
              [
                -76.6768939998415,
                39.341474999194,
                0
              ],
              [
                -76.6767099996939,
                39.3418409987185,
                0
              ],
              [
                -76.6758289999521,
                39.3415879994138,
                0
              ],
              [
                -76.6757150002665,
                39.3415539990066,
                0
              ],
              [
                -76.6748889999107,
                39.3413229990565,
                0
              ],
              [
                -76.6738480009793,
                39.3410260003007,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 18,
          "Census_Tract": "24510160400",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "ab306928-fcbc-42da-826c-c58c965fa087",
          "Shape__Area": 4193201.410522461,
          "Shape__Length": 9315.58516043635
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6455199994331,
                39.2938949989143,
                0
              ],
              [
                -76.6462770004696,
                39.2938589992397,
                0
              ],
              [
                -76.6472489999351,
                39.2938280000986,
                0
              ],
              [
                -76.6474410011167,
                39.2938229989427,
                0
              ],
              [
                -76.6490069998983,
                39.293767999224,
                0
              ],
              [
                -76.6497230003096,
                39.2937479991352,
                0
              ],
              [
                -76.6503829998594,
                39.2936979994509,
                0
              ],
              [
                -76.6503839999317,
                39.2937229993566,
                0
              ],
              [
                -76.6504769999504,
                39.2950719993607,
                0
              ],
              [
                -76.6505179997967,
                39.2963529990432,
                0
              ],
              [
                -76.6505380004187,
                39.296585998812,
                0
              ],
              [
                -76.6505669989625,
                39.2969329989985,
                0
              ],
              [
                -76.6505699999506,
                39.2972549987825,
                0
              ],
              [
                -76.6505610011268,
                39.2975089989473,
                0
              ],
              [
                -76.6505989994592,
                39.2981339992915,
                0
              ],
              [
                -76.6506070000847,
                39.298662998657,
                0
              ],
              [
                -76.6510520014609,
                39.2986459997571,
                0
              ],
              [
                -76.6513539996553,
                39.2986379986245,
                0
              ],
              [
                -76.6513449997492,
                39.2989469989156,
                0
              ],
              [
                -76.6510460001439,
                39.2997729991908,
                0
              ],
              [
                -76.6509050004478,
                39.3001649992324,
                0
              ],
              [
                -76.6507699995859,
                39.3003719989179,
                0
              ],
              [
                -76.6506300002953,
                39.3005659991784,
                0
              ],
              [
                -76.650461000459,
                39.300775998691,
                0
              ],
              [
                -76.650177000277,
                39.3010699987856,
                0
              ],
              [
                -76.6494789995066,
                39.301594999382,
                0
              ],
              [
                -76.6492260003716,
                39.3017379986554,
                0
              ],
              [
                -76.6489479995502,
                39.3018779988322,
                0
              ],
              [
                -76.6486179992818,
                39.3020210000016,
                0
              ],
              [
                -76.6483510002162,
                39.3021339990854,
                0
              ],
              [
                -76.6481650013061,
                39.3021980003319,
                0
              ],
              [
                -76.6479349989847,
                39.3022599985729,
                0
              ],
              [
                -76.6477170012986,
                39.3023049990689,
                0
              ],
              [
                -76.6477590002897,
                39.3027639977618,
                0
              ],
              [
                -76.6477869998294,
                39.3030619993398,
                0
              ],
              [
                -76.6473139996532,
                39.3030900001054,
                0
              ],
              [
                -76.6467800007437,
                39.3030939987395,
                0
              ],
              [
                -76.6466870002697,
                39.303093000327,
                0
              ],
              [
                -76.6461180012849,
                39.303111999075,
                0
              ],
              [
                -76.6460700005799,
                39.3024349979858,
                0
              ],
              [
                -76.6460569998741,
                39.3020919988143,
                0
              ],
              [
                -76.6460529997285,
                39.302023997724,
                0
              ],
              [
                -76.6459990007194,
                39.3009929992383,
                0
              ],
              [
                -76.6459970005737,
                39.3009609992598,
                0
              ],
              [
                -76.6459390000042,
                39.2999169994488,
                0
              ],
              [
                -76.6459260004644,
                39.2996979999251,
                0
              ],
              [
                -76.6458990003011,
                39.2993439987563,
                0
              ],
              [
                -76.6458679988528,
                39.2988029992283,
                0
              ],
              [
                -76.6458499997733,
                39.298524999403,
                0
              ],
              [
                -76.6458340004202,
                39.2980749988683,
                0
              ],
              [
                -76.6458100000354,
                39.2976569987604,
                0
              ],
              [
                -76.6458079998016,
                39.2976289990072,
                0
              ],
              [
                -76.6457350003471,
                39.2964549987686,
                0
              ],
              [
                -76.6456940002739,
                39.2960569989283,
                0
              ],
              [
                -76.6456710005759,
                39.2957589986566,
                0
              ],
              [
                -76.645665000511,
                39.2954379992401,
                0
              ],
              [
                -76.6456450000182,
                39.2953729988041,
                0
              ],
              [
                -76.6456100012253,
                39.2952399990718,
                0
              ],
              [
                -76.6455859995782,
                39.2946189992907,
                0
              ],
              [
                -76.6455199994331,
                39.2938949989143,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 19,
          "Census_Tract": "24510190200",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "0c3c20ac-c20e-4a48-99a6-37a0913ba328",
          "Shape__Area": 2864166.0858154297,
          "Shape__Length": 7324.154991009126
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6379840004908,
                39.2855869985552,
                0
              ],
              [
                -76.6379370001367,
                39.284557998642,
                0
              ],
              [
                -76.6379099988014,
                39.2839569989587,
                0
              ],
              [
                -76.6378880007253,
                39.2834469986559,
                0
              ],
              [
                -76.6378429995429,
                39.2827880000009,
                0
              ],
              [
                -76.6381360005529,
                39.2827119986991,
                0
              ],
              [
                -76.6386870005359,
                39.2825279992971,
                0
              ],
              [
                -76.6389789999034,
                39.2824019987602,
                0
              ],
              [
                -76.6390750002174,
                39.2823549993029,
                0
              ],
              [
                -76.6394819998801,
                39.282125999261,
                0
              ],
              [
                -76.6398680003688,
                39.2819089991203,
                0
              ],
              [
                -76.6401949994756,
                39.2817179994222,
                0
              ],
              [
                -76.6404919998409,
                39.281556998735,
                0
              ],
              [
                -76.640769000282,
                39.2814329988613,
                0
              ],
              [
                -76.64085499901,
                39.2813999994177,
                0
              ],
              [
                -76.6411330000035,
                39.2812969993937,
                0
              ],
              [
                -76.6418609999835,
                39.2809909987294,
                0
              ],
              [
                -76.6419879995861,
                39.2816040000448,
                0
              ],
              [
                -76.6420240000571,
                39.2822409993312,
                0
              ],
              [
                -76.6420839996292,
                39.2832769988283,
                0
              ],
              [
                -76.6421309996095,
                39.2836739992466,
                0
              ],
              [
                -76.6421679995816,
                39.284420999321,
                0
              ],
              [
                -76.6421970007379,
                39.2853889989296,
                0
              ],
              [
                -76.6422389998655,
                39.2858349995864,
                0
              ],
              [
                -76.6422720002488,
                39.2863779990384,
                0
              ],
              [
                -76.6423080004,
                39.2869079996519,
                0
              ],
              [
                -76.6423429999988,
                39.28739699814,
                0
              ],
              [
                -76.6423619997281,
                39.287910998863,
                0
              ],
              [
                -76.6424130002736,
                39.288372998787,
                0
              ],
              [
                -76.6409969995452,
                39.2884399994502,
                0
              ],
              [
                -76.640295000108,
                39.2884709990897,
                0
              ],
              [
                -76.6395729997612,
                39.288502998771,
                0
              ],
              [
                -76.6389089998956,
                39.2885349993654,
                0
              ],
              [
                -76.6381659996622,
                39.28856599897,
                0
              ],
              [
                -76.6381299996404,
                39.2881029993728,
                0
              ],
              [
                -76.6381009997067,
                39.2875559992806,
                0
              ],
              [
                -76.6380760000006,
                39.2870719988644,
                0
              ],
              [
                -76.63805200055,
                39.2865539986576,
                0
              ],
              [
                -76.638021000988,
                39.2860149989874,
                0
              ],
              [
                -76.6380189999985,
                39.2859809990267,
                0
              ],
              [
                -76.6379840004908,
                39.2855869985552,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 20,
          "Census_Tract": "24510190300",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "9c13360a-742e-4278-b220-e328acd01675",
          "Shape__Area": 3798641.9747314453,
          "Shape__Length": 8545.534088587563
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6418609999835,
                39.2809909987294,
                0
              ],
              [
                -76.6431299999601,
                39.2805449990963,
                0
              ],
              [
                -76.6442709997014,
                39.2801879987594,
                0
              ],
              [
                -76.644526999853,
                39.2801039976921,
                0
              ],
              [
                -76.6455289998219,
                39.2797749987342,
                0
              ],
              [
                -76.6464260008483,
                39.2794889991443,
                0
              ],
              [
                -76.6464579999977,
                39.2798949994034,
                0
              ],
              [
                -76.6465379996094,
                39.281051998973,
                0
              ],
              [
                -76.6465739999399,
                39.2815249988593,
                0
              ],
              [
                -76.6466099996178,
                39.2820079989146,
                0
              ],
              [
                -76.6466180004736,
                39.2821019993869,
                0
              ],
              [
                -76.646642999768,
                39.2827579988197,
                0
              ],
              [
                -76.6466660004712,
                39.2831469994178,
                0
              ],
              [
                -76.6466930000066,
                39.2836949980491,
                0
              ],
              [
                -76.6467190000109,
                39.2842419991384,
                0
              ],
              [
                -76.6467299995185,
                39.2845359989911,
                0
              ],
              [
                -76.6467339998143,
                39.2846329985946,
                0
              ],
              [
                -76.6467749996282,
                39.2851749976658,
                0
              ],
              [
                -76.6468019993478,
                39.285656000105,
                0
              ],
              [
                -76.6468369994867,
                39.2861609993467,
                0
              ],
              [
                -76.646870000184,
                39.2868099996624,
                0
              ],
              [
                -76.6468789989458,
                39.2870019993356,
                0
              ],
              [
                -76.6468910003575,
                39.2871789986639,
                0
              ],
              [
                -76.6469249998309,
                39.2876549991886,
                0
              ],
              [
                -76.6469399985476,
                39.2879149989618,
                0
              ],
              [
                -76.6469589997793,
                39.2881479987679,
                0
              ],
              [
                -76.6459069999078,
                39.2881929988268,
                0
              ],
              [
                -76.6452219990104,
                39.2882279992386,
                0
              ],
              [
                -76.6445310000082,
                39.2882599986966,
                0
              ],
              [
                -76.644152999581,
                39.2882749985975,
                0
              ],
              [
                -76.6438039994591,
                39.2882930000763,
                0
              ],
              [
                -76.6430629999937,
                39.2883359987943,
                0
              ],
              [
                -76.6424130002736,
                39.288372998787,
                0
              ],
              [
                -76.6423619997281,
                39.287910998863,
                0
              ],
              [
                -76.6423429999988,
                39.28739699814,
                0
              ],
              [
                -76.6423080004,
                39.2869079996519,
                0
              ],
              [
                -76.6422720002488,
                39.2863779990384,
                0
              ],
              [
                -76.6422389998655,
                39.2858349995864,
                0
              ],
              [
                -76.6421970007379,
                39.2853889989296,
                0
              ],
              [
                -76.6421679995816,
                39.284420999321,
                0
              ],
              [
                -76.6421309996095,
                39.2836739992466,
                0
              ],
              [
                -76.6420839996292,
                39.2832769988283,
                0
              ],
              [
                -76.6420240000571,
                39.2822409993312,
                0
              ],
              [
                -76.6419879995861,
                39.2816040000448,
                0
              ],
              [
                -76.6418609999835,
                39.2809909987294,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 21,
          "Census_Tract": "24510200100",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "f56f3bc9-4344-4f81-812c-efeb95c8994f",
          "Shape__Area": 2851197.5407714844,
          "Shape__Length": 6892.4891905758095
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6452219990104,
                39.2882279992386,
                0
              ],
              [
                -76.6459069999078,
                39.2881929988268,
                0
              ],
              [
                -76.6469589997793,
                39.2881479987679,
                0
              ],
              [
                -76.6478299994477,
                39.2881239992889,
                0
              ],
              [
                -76.6486929996245,
                39.2880989993134,
                0
              ],
              [
                -76.6500949994369,
                39.2880289989031,
                0
              ],
              [
                -76.6501229998464,
                39.2887769989083,
                0
              ],
              [
                -76.6501640000402,
                39.2893899992726,
                0
              ],
              [
                -76.6502179998814,
                39.2899239993313,
                0
              ],
              [
                -76.6502300004273,
                39.290476999148,
                0
              ],
              [
                -76.6502560001186,
                39.2908539990005,
                0
              ],
              [
                -76.6502790002331,
                39.2911950000698,
                0
              ],
              [
                -76.6502959987078,
                39.291585998744,
                0
              ],
              [
                -76.6503119985735,
                39.2919279985515,
                0
              ],
              [
                -76.6503369997387,
                39.2924009989538,
                0
              ],
              [
                -76.6503559995851,
                39.2928039988282,
                0
              ],
              [
                -76.6503599998829,
                39.2929869988244,
                0
              ],
              [
                -76.6503829998594,
                39.2936979994509,
                0
              ],
              [
                -76.6497230003096,
                39.2937479991352,
                0
              ],
              [
                -76.6490069998983,
                39.293767999224,
                0
              ],
              [
                -76.6474410011167,
                39.2938229989427,
                0
              ],
              [
                -76.6472489999351,
                39.2938280000986,
                0
              ],
              [
                -76.6462770004696,
                39.2938589992397,
                0
              ],
              [
                -76.6455199994331,
                39.2938949989143,
                0
              ],
              [
                -76.6455080003826,
                39.2936759992574,
                0
              ],
              [
                -76.6455060000205,
                39.2936489993059,
                0
              ],
              [
                -76.6455019999205,
                39.2935739991316,
                0
              ],
              [
                -76.6454929997474,
                39.293213999324,
                0
              ],
              [
                -76.6454880005178,
                39.2929909997574,
                0
              ],
              [
                -76.6454479998679,
                39.2920629989076,
                0
              ],
              [
                -76.6454419986839,
                39.2917679986108,
                0
              ],
              [
                -76.6454209989318,
                39.2913219993878,
                0
              ],
              [
                -76.6454009992694,
                39.2910119987724,
                0
              ],
              [
                -76.6453740007474,
                39.2906409992291,
                0
              ],
              [
                -76.6453449998894,
                39.2902879988628,
                0
              ],
              [
                -76.6453359996051,
                39.2901519994286,
                0
              ],
              [
                -76.6453339999236,
                39.2901139993788,
                0
              ],
              [
                -76.6453010000833,
                39.2895799991515,
                0
              ],
              [
                -76.6452639998573,
                39.2889649985829,
                0
              ],
              [
                -76.6452219990104,
                39.2882279992386,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 22,
          "Census_Tract": "24510260201",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "b774b62b-e22a-4405-a140-68e4fa3736ea",
          "Shape__Area": 17744054.003051758,
          "Shape__Length": 17770.541062424494
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.5417209994592,
                39.3292129987835,
                0
              ],
              [
                -76.5416470008177,
                39.3290339990914,
                0
              ],
              [
                -76.5416070013682,
                39.3289259986702,
                0
              ],
              [
                -76.5415789997988,
                39.3288029988476,
                0
              ],
              [
                -76.5414590002368,
                39.3281579987663,
                0
              ],
              [
                -76.5413779993354,
                39.3277210003124,
                0
              ],
              [
                -76.541273001471,
                39.3271799989811,
                0
              ],
              [
                -76.5410859999451,
                39.3261469991546,
                0
              ],
              [
                -76.5409309993613,
                39.3250069988013,
                0
              ],
              [
                -76.5408339989474,
                39.3242989991808,
                0
              ],
              [
                -76.5407849995232,
                39.3238810000861,
                0
              ],
              [
                -76.5407539999846,
                39.3236229992952,
                0
              ],
              [
                -76.5428180000391,
                39.3229749986226,
                0
              ],
              [
                -76.5428919998522,
                39.322951999241,
                0
              ],
              [
                -76.5441269993004,
                39.3225739986914,
                0
              ],
              [
                -76.5445769996387,
                39.3224359992986,
                0
              ],
              [
                -76.5450860005523,
                39.3222899990728,
                0
              ],
              [
                -76.5452660000606,
                39.3222499977448,
                0
              ],
              [
                -76.5454299999568,
                39.322215999042,
                0
              ],
              [
                -76.5456830003773,
                39.3221729988476,
                0
              ],
              [
                -76.5458750006746,
                39.3221429990166,
                0
              ],
              [
                -76.5460219997045,
                39.3221229990807,
                0
              ],
              [
                -76.5469230005335,
                39.3220149993737,
                0
              ],
              [
                -76.5477469996026,
                39.3219169993227,
                0
              ],
              [
                -76.5482000014999,
                39.3218659988016,
                0
              ],
              [
                -76.5484419987673,
                39.3218299987812,
                0
              ],
              [
                -76.5484970001757,
                39.322060998698,
                0
              ],
              [
                -76.5485959987473,
                39.322399998667,
                0
              ],
              [
                -76.548620999853,
                39.3224689987904,
                0
              ],
              [
                -76.5486470000546,
                39.322534998728,
                0
              ],
              [
                -76.5487329995887,
                39.3227019991261,
                0
              ],
              [
                -76.5488439987126,
                39.3228639989492,
                0
              ],
              [
                -76.5489519994805,
                39.3230009993294,
                0
              ],
              [
                -76.5495330000587,
                39.3236439987776,
                0
              ],
              [
                -76.549678999799,
                39.3237969991485,
                0
              ],
              [
                -76.5504299997688,
                39.3245929986402,
                0
              ],
              [
                -76.5506550005726,
                39.324839998079,
                0
              ],
              [
                -76.5508900004636,
                39.3250989990775,
                0
              ],
              [
                -76.5510270005899,
                39.3252499987511,
                0
              ],
              [
                -76.5512899994314,
                39.3254939993206,
                0
              ],
              [
                -76.5516690000434,
                39.325843999281,
                0
              ],
              [
                -76.5517879997114,
                39.3257809986661,
                0
              ],
              [
                -76.5523939992886,
                39.3262199994398,
                0
              ],
              [
                -76.5530949997192,
                39.3266519990993,
                0
              ],
              [
                -76.5532300002267,
                39.326723998775,
                0
              ],
              [
                -76.5534080000292,
                39.326808999208,
                0
              ],
              [
                -76.5537410000802,
                39.3269769987349,
                0
              ],
              [
                -76.5539910010039,
                39.3271119985746,
                0
              ],
              [
                -76.5545290001209,
                39.3274179987085,
                0
              ],
              [
                -76.5547799994567,
                39.3275500002171,
                0
              ],
              [
                -76.5550309998049,
                39.3276769993055,
                0
              ],
              [
                -76.5552169997782,
                39.3277569992415,
                0
              ],
              [
                -76.5553659998788,
                39.3278089986468,
                0
              ],
              [
                -76.5555529985773,
                39.3278679989773,
                0
              ],
              [
                -76.5558079998243,
                39.3279339990451,
                0
              ],
              [
                -76.5558740004964,
                39.3279479993328,
                0
              ],
              [
                -76.5559249999911,
                39.327957999415,
                0
              ],
              [
                -76.5561839994094,
                39.3280019993787,
                0
              ],
              [
                -76.5564149991238,
                39.3280339986704,
                0
              ],
              [
                -76.556745000358,
                39.3280859991847,
                0
              ],
              [
                -76.5570579995688,
                39.3281429987305,
                0
              ],
              [
                -76.5573180000266,
                39.3282079991988,
                0
              ],
              [
                -76.5576059995837,
                39.3283019988047,
                0
              ],
              [
                -76.5576760014497,
                39.3283309989512,
                0
              ],
              [
                -76.5578180002162,
                39.3283889976153,
                0
              ],
              [
                -76.5580869997479,
                39.3285239997551,
                0
              ],
              [
                -76.5582539999046,
                39.3286249992084,
                0
              ],
              [
                -76.5587559997044,
                39.3289629985868,
                0
              ],
              [
                -76.5594050003567,
                39.3294009997901,
                0
              ],
              [
                -76.5602440000258,
                39.3299639994223,
                0
              ],
              [
                -76.5609080005327,
                39.3304019986969,
                0
              ],
              [
                -76.5610769999836,
                39.3305339990783,
                0
              ],
              [
                -76.5613329995798,
                39.3307429985795,
                0
              ],
              [
                -76.5614260002713,
                39.3308379992696,
                0
              ],
              [
                -76.5615059997978,
                39.3309319992893,
                0
              ],
              [
                -76.5616119998502,
                39.3310950000952,
                0
              ],
              [
                -76.5615209994685,
                39.3311679989447,
                0
              ],
              [
                -76.5611509992276,
                39.3314609989902,
                0
              ],
              [
                -76.5608599995094,
                39.3316859980635,
                0
              ],
              [
                -76.5607570003652,
                39.3317669987984,
                0
              ],
              [
                -76.5603209994217,
                39.3320849994105,
                0
              ],
              [
                -76.5600629988481,
                39.3322659993246,
                0
              ],
              [
                -76.5595419996813,
                39.3326299990951,
                0
              ],
              [
                -76.5594240001364,
                39.3327119990222,
                0
              ],
              [
                -76.5589020006934,
                39.3330779990541,
                0
              ],
              [
                -76.5586769997885,
                39.3332419991505,
                0
              ],
              [
                -76.5577509995583,
                39.3339059996359,
                0
              ],
              [
                -76.5576779999767,
                39.3339579991411,
                0
              ],
              [
                -76.557396999969,
                39.334149999349,
                0
              ],
              [
                -76.5569849996787,
                39.3344299985963,
                0
              ],
              [
                -76.5561370013187,
                39.3350099987563,
                0
              ],
              [
                -76.555200999981,
                39.3356659992867,
                0
              ],
              [
                -76.5544559998082,
                39.3361849997631,
                0
              ],
              [
                -76.5540460001327,
                39.3364719986348,
                0
              ],
              [
                -76.5538919996766,
                39.3365799988527,
                0
              ],
              [
                -76.5533170000874,
                39.3369919992107,
                0
              ],
              [
                -76.5529380004508,
                39.3372549988912,
                0
              ],
              [
                -76.5527879994337,
                39.3373609978811,
                0
              ],
              [
                -76.552585000104,
                39.3375029988238,
                0
              ],
              [
                -76.5524410005219,
                39.3376139977516,
                0
              ],
              [
                -76.5522700000215,
                39.3377299991186,
                0
              ],
              [
                -76.5520599994393,
                39.3378719986028,
                0
              ],
              [
                -76.5518029996362,
                39.3380369993276,
                0
              ],
              [
                -76.5516599996618,
                39.3381219991555,
                0
              ],
              [
                -76.5515869998058,
                39.337967998762,
                0
              ],
              [
                -76.5515209991172,
                39.3378409988727,
                0
              ],
              [
                -76.5514639988249,
                39.337748998592,
                0
              ],
              [
                -76.5513869991175,
                39.3376629993219,
                0
              ],
              [
                -76.551155000521,
                39.3374499988459,
                0
              ],
              [
                -76.5507469997199,
                39.3370829988302,
                0
              ],
              [
                -76.5497200000183,
                39.3362270003039,
                0
              ],
              [
                -76.5490849999298,
                39.3356879991089,
                0
              ],
              [
                -76.5488570000172,
                39.335503999914,
                0
              ],
              [
                -76.5486469998362,
                39.3353339985836,
                0
              ],
              [
                -76.5485330003453,
                39.3352480003082,
                0
              ],
              [
                -76.5484340005271,
                39.3350429991975,
                0
              ],
              [
                -76.5483820001978,
                39.3349219988357,
                0
              ],
              [
                -76.5483480002709,
                39.3348319993927,
                0
              ],
              [
                -76.5482940003395,
                39.3346809989962,
                0
              ],
              [
                -76.5482650005029,
                39.334605999124,
                0
              ],
              [
                -76.548124999084,
                39.3342350001575,
                0
              ],
              [
                -76.5480040007994,
                39.3339660003462,
                0
              ],
              [
                -76.5479289991882,
                39.3338809989883,
                0
              ],
              [
                -76.5478059998273,
                39.3337529993458,
                0
              ],
              [
                -76.54770499985,
                39.3336579985677,
                0
              ],
              [
                -76.5476100007618,
                39.3335779993866,
                0
              ],
              [
                -76.547481000036,
                39.3334719987604,
                0
              ],
              [
                -76.5471790010804,
                39.3333089987085,
                0
              ],
              [
                -76.5471130001881,
                39.3332739988602,
                0
              ],
              [
                -76.5463499991312,
                39.3329009992217,
                0
              ],
              [
                -76.5462569997293,
                39.3328559990321,
                0
              ],
              [
                -76.5454250003263,
                39.332444999865,
                0
              ],
              [
                -76.545297998701,
                39.3323899987738,
                0
              ],
              [
                -76.5450390014862,
                39.3322539991651,
                0
              ],
              [
                -76.5448700002691,
                39.3321679987047,
                0
              ],
              [
                -76.5446110005722,
                39.3320329997637,
                0
              ],
              [
                -76.5443890001379,
                39.3318979986353,
                0
              ],
              [
                -76.5442410002178,
                39.3318019992392,
                0
              ],
              [
                -76.5441170003906,
                39.331705999056,
                0
              ],
              [
                -76.5439880003597,
                39.3315959987682,
                0
              ],
              [
                -76.5438989996974,
                39.3315109980872,
                0
              ],
              [
                -76.5437949990568,
                39.3314129989168,
                0
              ],
              [
                -76.5437739987957,
                39.3313929990811,
                0
              ],
              [
                -76.5435209995604,
                39.3311359996852,
                0
              ],
              [
                -76.5430870002045,
                39.3307059985916,
                0
              ],
              [
                -76.5418189997121,
                39.3293849976492,
                0
              ],
              [
                -76.5417810010642,
                39.3293319987584,
                0
              ],
              [
                -76.541758999929,
                39.3292979987469,
                0
              ],
              [
                -76.5417440004411,
                39.3292659986765,
                0
              ],
              [
                -76.5417209994592,
                39.3292129987835,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 23,
          "Census_Tract": "24510280401",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "fa422cdc-1d56-4199-ae7c-7152ff653c58",
          "Shape__Area": 17712522.96081543,
          "Shape__Length": 21322.00754503111
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6948660000233,
                39.3020159987692,
                0
              ],
              [
                -76.6947100006836,
                39.3018369992477,
                0
              ],
              [
                -76.6945839999205,
                39.3016179993356,
                0
              ],
              [
                -76.6944870001224,
                39.3013679986648,
                0
              ],
              [
                -76.6945920004684,
                39.3008059992257,
                0
              ],
              [
                -76.69240600033,
                39.2989459987925,
                0
              ],
              [
                -76.6929079998917,
                39.2984819990626,
                0
              ],
              [
                -76.6935120001649,
                39.2979219986642,
                0
              ],
              [
                -76.6925729993227,
                39.2973209989683,
                0
              ],
              [
                -76.6915719995858,
                39.2967339995622,
                0
              ],
              [
                -76.692248000176,
                39.2961169990898,
                0
              ],
              [
                -76.6913780001037,
                39.2954709990465,
                0
              ],
              [
                -76.6904779996471,
                39.2948209986743,
                0
              ],
              [
                -76.6894660011647,
                39.2941969991434,
                0
              ],
              [
                -76.6894500004865,
                39.2941620002998,
                0
              ],
              [
                -76.6894420001858,
                39.2941109990484,
                0
              ],
              [
                -76.6894390005407,
                39.2940499991082,
                0
              ],
              [
                -76.6894269996308,
                39.2936129996585,
                0
              ],
              [
                -76.6894249998167,
                39.2935809986026,
                0
              ],
              [
                -76.6909329995804,
                39.2935309993911,
                0
              ],
              [
                -76.6925129996586,
                39.2934689991759,
                0
              ],
              [
                -76.6931419998679,
                39.293454999427,
                0
              ],
              [
                -76.6939219998616,
                39.2934159992868,
                0
              ],
              [
                -76.6953229991456,
                39.2933659991051,
                0
              ],
              [
                -76.695693999526,
                39.2933509992581,
                0
              ],
              [
                -76.6959269990129,
                39.2933379993233,
                0
              ],
              [
                -76.6961239994509,
                39.2933200002999,
                0
              ],
              [
                -76.6963589998401,
                39.2932979989227,
                0
              ],
              [
                -76.6967230005171,
                39.2932579988637,
                0
              ],
              [
                -76.697993000347,
                39.2930599991601,
                0
              ],
              [
                -76.6984890003562,
                39.2929919986924,
                0
              ],
              [
                -76.698835999044,
                39.2929269993063,
                0
              ],
              [
                -76.6992640002221,
                39.2928469988083,
                0
              ],
              [
                -76.7000369996864,
                39.2927419975995,
                0
              ],
              [
                -76.7006449995926,
                39.2926609985993,
                0
              ],
              [
                -76.7018050003086,
                39.2924839991703,
                0
              ],
              [
                -76.7018399998698,
                39.292477998889,
                0
              ],
              [
                -76.702060999825,
                39.292440998925,
                0
              ],
              [
                -76.7023329994988,
                39.29239799903,
                0
              ],
              [
                -76.7025810000355,
                39.2923709991374,
                0
              ],
              [
                -76.7028460004437,
                39.2923499984234,
                0
              ],
              [
                -76.7029860000592,
                39.2923459999961,
                0
              ],
              [
                -76.7031180000942,
                39.2923549989173,
                0
              ],
              [
                -76.7032639991342,
                39.2923649986605,
                0
              ],
              [
                -76.7036919999353,
                39.2924109978446,
                0
              ],
              [
                -76.703901999897,
                39.29243099896,
                0
              ],
              [
                -76.7041120001614,
                39.2924239986305,
                0
              ],
              [
                -76.7045909995825,
                39.2923589993726,
                0
              ],
              [
                -76.7054039985656,
                39.2922459989701,
                0
              ],
              [
                -76.7059420000326,
                39.2921669993707,
                0
              ],
              [
                -76.706386000495,
                39.2920869985732,
                0
              ],
              [
                -76.7069970000344,
                39.291975998845,
                0
              ],
              [
                -76.7072429994779,
                39.2919479986975,
                0
              ],
              [
                -76.7076169998082,
                39.2919119990865,
                0
              ],
              [
                -76.7077990000009,
                39.2919069987242,
                0
              ],
              [
                -76.7081239995039,
                39.2918819981522,
                0
              ],
              [
                -76.709137000531,
                39.2918519986476,
                0
              ],
              [
                -76.7107199994781,
                39.2917669989872,
                0
              ],
              [
                -76.7107430013614,
                39.2917649991975,
                0
              ],
              [
                -76.7111950005998,
                39.29174899866,
                0
              ],
              [
                -76.7112009995625,
                39.2949119993922,
                0
              ],
              [
                -76.7113930003183,
                39.296804999133,
                0
              ],
              [
                -76.7112550004567,
                39.2973619975818,
                0
              ],
              [
                -76.7112229997384,
                39.2978149994224,
                0
              ],
              [
                -76.7111930001086,
                39.2982299987775,
                0
              ],
              [
                -76.7112240000796,
                39.2987099987273,
                0
              ],
              [
                -76.7112279999089,
                39.298777999297,
                0
              ],
              [
                -76.7112490002606,
                39.2991169993415,
                0
              ],
              [
                -76.7112550001773,
                39.2992119986196,
                0
              ],
              [
                -76.7112120000552,
                39.2997549999422,
                0
              ],
              [
                -76.7112100004854,
                39.2997779993854,
                0
              ],
              [
                -76.7112070001362,
                39.2998209994138,
                0
              ],
              [
                -76.7112029997681,
                39.2998709994453,
                0
              ],
              [
                -76.7112020002348,
                39.2998849992099,
                0
              ],
              [
                -76.7111929998571,
                39.3000049989561,
                0
              ],
              [
                -76.7111929997996,
                39.300539999948,
                0
              ],
              [
                -76.7111929994601,
                39.3006049992452,
                0
              ],
              [
                -76.7112000004071,
                39.3011189991618,
                0
              ],
              [
                -76.7112009986349,
                39.3011579988457,
                0
              ],
              [
                -76.7112009994236,
                39.3011840000033,
                0
              ],
              [
                -76.7112020004002,
                39.3012339987961,
                0
              ],
              [
                -76.7112030000741,
                39.3012939986527,
                0
              ],
              [
                -76.711206000322,
                39.3015109993749,
                0
              ],
              [
                -76.7112029998776,
                39.3016379991542,
                0
              ],
              [
                -76.7112009994605,
                39.3017169993306,
                0
              ],
              [
                -76.7112009990131,
                39.3017489985986,
                0
              ],
              [
                -76.7111999997055,
                39.3017859990969,
                0
              ],
              [
                -76.7111930002083,
                39.3021049990466,
                0
              ],
              [
                -76.7111909998206,
                39.302954998999,
                0
              ],
              [
                -76.7105979996292,
                39.3028159994168,
                0
              ],
              [
                -76.7103660001753,
                39.3027619986896,
                0
              ],
              [
                -76.7101669997181,
                39.302725999392,
                0
              ],
              [
                -76.7100079998096,
                39.3027169985828,
                0
              ],
              [
                -76.7098680001364,
                39.3027299994367,
                0
              ],
              [
                -76.7097329998797,
                39.3027689992069,
                0
              ],
              [
                -76.7094239999224,
                39.3030249987763,
                0
              ],
              [
                -76.7092189998635,
                39.3032269998706,
                0
              ],
              [
                -76.7090919995829,
                39.3033229994439,
                0
              ],
              [
                -76.7090290010604,
                39.3033509991968,
                0
              ],
              [
                -76.7089129998472,
                39.3033739990517,
                0
              ],
              [
                -76.7086740005519,
                39.3033919991737,
                0
              ],
              [
                -76.7084030012482,
                39.3033949993254,
                0
              ],
              [
                -76.7081919997995,
                39.3033799985944,
                0
              ],
              [
                -76.7077650005334,
                39.3033079985612,
                0
              ],
              [
                -76.7073149999081,
                39.3031789985631,
                0
              ],
              [
                -76.7071160010334,
                39.3031339991836,
                0
              ],
              [
                -76.7069720004136,
                39.3031039990661,
                0
              ],
              [
                -76.7067209994456,
                39.303056999354,
                0
              ],
              [
                -76.706531999705,
                39.3029979992101,
                0
              ],
              [
                -76.7063290004978,
                39.302921998983,
                0
              ],
              [
                -76.7061050012048,
                39.3028349990219,
                0
              ],
              [
                -76.7058439997063,
                39.302711999268,
                0
              ],
              [
                -76.7056979995385,
                39.3026109978911,
                0
              ],
              [
                -76.7055210005148,
                39.3024739992951,
                0
              ],
              [
                -76.7054740013997,
                39.3024079985814,
                0
              ],
              [
                -76.705444999292,
                39.302346998911,
                0
              ],
              [
                -76.7054130002359,
                39.3022379986678,
                0
              ],
              [
                -76.7054180000972,
                39.3021579999646,
                0
              ],
              [
                -76.7054369998638,
                39.30204099917,
                0
              ],
              [
                -76.7054709995925,
                39.3019579988858,
                0
              ],
              [
                -76.7055269995616,
                39.3019019988742,
                0
              ],
              [
                -76.7056560004221,
                39.3018359987127,
                0
              ],
              [
                -76.7057369994568,
                39.301784999154,
                0
              ],
              [
                -76.7058549990713,
                39.3016769987999,
                0
              ],
              [
                -76.7063160003339,
                39.3012459991478,
                0
              ],
              [
                -76.7064820004205,
                39.3010929993591,
                0
              ],
              [
                -76.7065460002893,
                39.3010129993326,
                0
              ],
              [
                -76.7066030002508,
                39.3009359993161,
                0
              ],
              [
                -76.7066219999691,
                39.3008789993119,
                0
              ],
              [
                -76.7066349993876,
                39.3007789994443,
                0
              ],
              [
                -76.7066349986796,
                39.3006549998526,
                0
              ],
              [
                -76.7066069994644,
                39.3004719994156,
                0
              ],
              [
                -76.7065330000239,
                39.3001999985639,
                0
              ],
              [
                -76.7064280003767,
                39.2999899992647,
                0
              ],
              [
                -76.70629500105,
                39.2997909992366,
                0
              ],
              [
                -76.7061779994256,
                39.2996729988439,
                0
              ],
              [
                -76.7060640013601,
                39.2995889994093,
                0
              ],
              [
                -76.7059579995598,
                39.2995359986149,
                0
              ],
              [
                -76.705854999334,
                39.2995159989674,
                0
              ],
              [
                -76.7057110001174,
                39.2995059994056,
                0
              ],
              [
                -76.7055730001952,
                39.2995169986734,
                0
              ],
              [
                -76.7054390003897,
                39.2995529992359,
                0
              ],
              [
                -76.7052020005784,
                39.2996369991693,
                0
              ],
              [
                -76.7049710013952,
                39.2997099992686,
                0
              ],
              [
                -76.7048859999665,
                39.2997319992992,
                0
              ],
              [
                -76.704778998857,
                39.2997459993402,
                0
              ],
              [
                -76.7046090004022,
                39.2997409998423,
                0
              ],
              [
                -76.7042590005687,
                39.2996980001175,
                0
              ],
              [
                -76.7038000004842,
                39.2996269975915,
                0
              ],
              [
                -76.7035549998318,
                39.2996339991742,
                0
              ],
              [
                -76.703303999821,
                39.2996719989694,
                0
              ],
              [
                -76.7031219984788,
                39.2997449993568,
                0
              ],
              [
                -76.7029149998731,
                39.2999119993273,
                0
              ],
              [
                -76.7028559994445,
                39.300017998616,
                0
              ],
              [
                -76.7028470010502,
                39.3001299990608,
                0
              ],
              [
                -76.7028780000604,
                39.3003129990159,
                0
              ],
              [
                -76.7028709995294,
                39.3004929988316,
                0
              ],
              [
                -76.7028519995838,
                39.3005559990665,
                0
              ],
              [
                -76.7028080003969,
                39.3006309989659,
                0
              ],
              [
                -76.7027330002299,
                39.300689998689,
                0
              ],
              [
                -76.7020539997842,
                39.301026000357,
                0
              ],
              [
                -76.7018939990619,
                39.3010879987568,
                0
              ],
              [
                -76.7017679995451,
                39.3011209988003,
                0
              ],
              [
                -76.7015580005525,
                39.301150999347,
                0
              ],
              [
                -76.7014240002987,
                39.3011789993314,
                0
              ],
              [
                -76.7013560000121,
                39.3011979990614,
                0
              ],
              [
                -76.7012740003144,
                39.301229998872,
                0
              ],
              [
                -76.7011929996804,
                39.3012969999615,
                0
              ],
              [
                -76.7010210004202,
                39.3015479988757,
                0
              ],
              [
                -76.700857000073,
                39.3017699992016,
                0
              ],
              [
                -76.7006980000152,
                39.3018499991779,
                0
              ],
              [
                -76.7005400004026,
                39.3018859987631,
                0
              ],
              [
                -76.700271999859,
                39.3019339993613,
                0
              ],
              [
                -76.699720000077,
                39.3020309991103,
                0
              ],
              [
                -76.6995239995183,
                39.3020359989471,
                0
              ],
              [
                -76.6991299996474,
                39.3020109991364,
                0
              ],
              [
                -76.6988980002753,
                39.3019609993917,
                0
              ],
              [
                -76.6987720005974,
                39.3019179987166,
                0
              ],
              [
                -76.6986859995275,
                39.3018199986677,
                0
              ],
              [
                -76.6986240003227,
                39.3016609989098,
                0
              ],
              [
                -76.6985370015502,
                39.3015389991971,
                0
              ],
              [
                -76.6984510000885,
                39.3014709985743,
                0
              ],
              [
                -76.6983569995944,
                39.3014340002208,
                0
              ],
              [
                -76.6981360004747,
                39.3014149987231,
                0
              ],
              [
                -76.6979790002224,
                39.3014029989573,
                0
              ],
              [
                -76.6976479995318,
                39.3014139988873,
                0
              ],
              [
                -76.6974549996002,
                39.3014559987613,
                0
              ],
              [
                -76.6973129993805,
                39.3015169978059,
                0
              ],
              [
                -76.6971240003897,
                39.3016329989808,
                0
              ],
              [
                -76.6969500000054,
                39.3017729985904,
                0
              ],
              [
                -76.6968310005233,
                39.3018759990779,
                0
              ],
              [
                -76.6966500003722,
                39.3019979993252,
                0
              ],
              [
                -76.6964759993693,
                39.3020409987351,
                0
              ],
              [
                -76.696180999766,
                39.3020759989457,
                0
              ],
              [
                -76.6958889999278,
                39.3020999989672,
                0
              ],
              [
                -76.6956850007948,
                39.3021059985583,
                0
              ],
              [
                -76.6948660000233,
                39.3020159987692,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 24,
          "Census_Tract": "24510280404",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "257f4609-75e8-400a-a001-259071a78973",
          "Shape__Area": 9137630.772399902,
          "Shape__Length": 13620.541895216431
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6867760002117,
                39.2872289993913,
                0
              ],
              [
                -76.6867559995621,
                39.28640499898,
                0
              ],
              [
                -76.68674499944,
                39.2859629989688,
                0
              ],
              [
                -76.6867250003797,
                39.2855319992854,
                0
              ],
              [
                -76.6867090003892,
                39.2850219992477,
                0
              ],
              [
                -76.6866810001826,
                39.2848099994276,
                0
              ],
              [
                -76.6866689999341,
                39.2846819993039,
                0
              ],
              [
                -76.686664999871,
                39.2845179991631,
                0
              ],
              [
                -76.6866879996884,
                39.2844139994288,
                0
              ],
              [
                -76.6867240000149,
                39.28433299921,
                0
              ],
              [
                -76.6867849994766,
                39.2842589978802,
                0
              ],
              [
                -76.6868469997729,
                39.2842089990095,
                0
              ],
              [
                -76.6868319995528,
                39.2838089985614,
                0
              ],
              [
                -76.6868170000203,
                39.2833799990216,
                0
              ],
              [
                -76.6867730007208,
                39.282523999057,
                0
              ],
              [
                -76.6867389995549,
                39.2820849988808,
                0
              ],
              [
                -76.6867060000926,
                39.2816559988407,
                0
              ],
              [
                -76.6872860012069,
                39.2816379996831,
                0
              ],
              [
                -76.6885220005658,
                39.2816000000745,
                0
              ],
              [
                -76.6894930002564,
                39.2815539992045,
                0
              ],
              [
                -76.6902769997407,
                39.2815269979286,
                0
              ],
              [
                -76.6906650004672,
                39.2815129992882,
                0
              ],
              [
                -76.6917590004648,
                39.2815039986897,
                0
              ],
              [
                -76.6919289995595,
                39.2815009992648,
                0
              ],
              [
                -76.6929310002901,
                39.2814689986466,
                0
              ],
              [
                -76.6929619988535,
                39.2818199975726,
                0
              ],
              [
                -76.6929660005662,
                39.2818599990508,
                0
              ],
              [
                -76.6929990001975,
                39.2822229985685,
                0
              ],
              [
                -76.6930480005766,
                39.282562999329,
                0
              ],
              [
                -76.6930980003026,
                39.2829059985696,
                0
              ],
              [
                -76.6931400004133,
                39.2831249999754,
                0
              ],
              [
                -76.6931640002717,
                39.2832309991456,
                0
              ],
              [
                -76.693191000494,
                39.2833539989637,
                0
              ],
              [
                -76.6932530007981,
                39.2835509992524,
                0
              ],
              [
                -76.6932629998785,
                39.2835839994478,
                0
              ],
              [
                -76.6934020006034,
                39.2838879991682,
                0
              ],
              [
                -76.6935729999382,
                39.2842619990688,
                0
              ],
              [
                -76.6937099995558,
                39.2845159992259,
                0
              ],
              [
                -76.6937489994546,
                39.2846119992849,
                0
              ],
              [
                -76.6937930000845,
                39.2847199987592,
                0
              ],
              [
                -76.6938170013021,
                39.2848399991378,
                0
              ],
              [
                -76.6938360005153,
                39.2850699988194,
                0
              ],
              [
                -76.6938329995172,
                39.2852719987136,
                0
              ],
              [
                -76.6938289999084,
                39.2855009989302,
                0
              ],
              [
                -76.6938439985369,
                39.2856129986934,
                0
              ],
              [
                -76.6938609995812,
                39.2856799999778,
                0
              ],
              [
                -76.6938920004617,
                39.285754998643,
                0
              ],
              [
                -76.6940600001329,
                39.2860429989013,
                0
              ],
              [
                -76.6942609996588,
                39.2863379990037,
                0
              ],
              [
                -76.6945129997883,
                39.2866520004523,
                0
              ],
              [
                -76.694578999621,
                39.2867189993123,
                0
              ],
              [
                -76.6946689999681,
                39.2867889987906,
                0
              ],
              [
                -76.6950730004962,
                39.2870679986777,
                0
              ],
              [
                -76.6951469995687,
                39.2871259986818,
                0
              ],
              [
                -76.6952180010061,
                39.2871899989162,
                0
              ],
              [
                -76.695306000445,
                39.2872759991707,
                0
              ],
              [
                -76.6953680000546,
                39.2873489988543,
                0
              ],
              [
                -76.6954389998051,
                39.2874439994292,
                0
              ],
              [
                -76.6954929999214,
                39.2875419986539,
                0
              ],
              [
                -76.6955670013659,
                39.2877219988309,
                0
              ],
              [
                -76.6956729998989,
                39.2882199988782,
                0
              ],
              [
                -76.6957350002317,
                39.2883449990852,
                0
              ],
              [
                -76.6957860005374,
                39.2884299996501,
                0
              ],
              [
                -76.6959440001695,
                39.2886810003596,
                0
              ],
              [
                -76.6960240004917,
                39.2887529986696,
                0
              ],
              [
                -76.6962140002894,
                39.2888609991648,
                0
              ],
              [
                -76.6965309998878,
                39.2890100002898,
                0
              ],
              [
                -76.6967620015008,
                39.2890509993703,
                0
              ],
              [
                -76.6970509995505,
                39.2890869988426,
                0
              ],
              [
                -76.6972040000716,
                39.2891369989134,
                0
              ],
              [
                -76.6972610003028,
                39.2891909993993,
                0
              ],
              [
                -76.6972839999427,
                39.2892719989217,
                0
              ],
              [
                -76.6972990002692,
                39.2897919988067,
                0
              ],
              [
                -76.6973240003033,
                39.2907269986203,
                0
              ],
              [
                -76.6972940000214,
                39.2911639991912,
                0
              ],
              [
                -76.6979419995054,
                39.2929219991824,
                0
              ],
              [
                -76.697993000347,
                39.2930599991601,
                0
              ],
              [
                -76.6967230005171,
                39.2932579988637,
                0
              ],
              [
                -76.6963589998401,
                39.2932979989227,
                0
              ],
              [
                -76.6961239994509,
                39.2933200002999,
                0
              ],
              [
                -76.6959269990129,
                39.2933379993233,
                0
              ],
              [
                -76.695693999526,
                39.2933509992581,
                0
              ],
              [
                -76.6953229991456,
                39.2933659991051,
                0
              ],
              [
                -76.6939219998616,
                39.2934159992868,
                0
              ],
              [
                -76.6931419998679,
                39.293454999427,
                0
              ],
              [
                -76.6925129996586,
                39.2934689991759,
                0
              ],
              [
                -76.6909329995804,
                39.2935309993911,
                0
              ],
              [
                -76.6894249998167,
                39.2935809986026,
                0
              ],
              [
                -76.6894170005422,
                39.2934349990622,
                0
              ],
              [
                -76.6893999999081,
                39.2931719989701,
                0
              ],
              [
                -76.6893659996777,
                39.2927699986837,
                0
              ],
              [
                -76.6893349995735,
                39.2924119992321,
                0
              ],
              [
                -76.6893000003107,
                39.2917189985658,
                0
              ],
              [
                -76.6892730001869,
                39.291473998722,
                0
              ],
              [
                -76.689221998525,
                39.2909810001658,
                0
              ],
              [
                -76.6891099995274,
                39.2904099993645,
                0
              ],
              [
                -76.6890760010061,
                39.2902590001077,
                0
              ],
              [
                -76.6890490000028,
                39.2901379992638,
                0
              ],
              [
                -76.6890319999989,
                39.2900109988155,
                0
              ],
              [
                -76.6890150007451,
                39.2898730001132,
                0
              ],
              [
                -76.6889919999679,
                39.2894569991309,
                0
              ],
              [
                -76.6889779994791,
                39.2892079989701,
                0
              ],
              [
                -76.6889249986487,
                39.2882039992331,
                0
              ],
              [
                -76.6883670001897,
                39.2879169998576,
                0
              ],
              [
                -76.6878739994793,
                39.2876639993824,
                0
              ],
              [
                -76.687473999471,
                39.2874849992448,
                0
              ],
              [
                -76.687244000641,
                39.287398998859,
                0
              ],
              [
                -76.6869850000995,
                39.287302998894,
                0
              ],
              [
                -76.6867760002117,
                39.2872289993913,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 25,
          "Census_Tract": "24510260401",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "5e2a6da5-f5cc-4a6f-b7db-d31773ca6f89",
          "Shape__Area": 14435298.488647461,
          "Shape__Length": 16386.807158663818
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.55038699884,
                39.3113179986823,
                0
              ],
              [
                -76.5500920011533,
                39.3113109993921,
                0
              ],
              [
                -76.5499280000533,
                39.3112979985819,
                0
              ],
              [
                -76.5498659996998,
                39.3112889994382,
                0
              ],
              [
                -76.5498019988795,
                39.3112889992708,
                0
              ],
              [
                -76.5497480000281,
                39.3113079992349,
                0
              ],
              [
                -76.5496649996851,
                39.3113219987266,
                0
              ],
              [
                -76.5495109997848,
                39.3113209986192,
                0
              ],
              [
                -76.5490949995866,
                39.3112969985938,
                0
              ],
              [
                -76.548972000511,
                39.3112879991025,
                0
              ],
              [
                -76.5488410007253,
                39.3112749991281,
                0
              ],
              [
                -76.5487199994375,
                39.3112559987269,
                0
              ],
              [
                -76.5486020005302,
                39.3112159986658,
                0
              ],
              [
                -76.5485289999117,
                39.3111929993234,
                0
              ],
              [
                -76.5484480005638,
                39.3111849992387,
                0
              ],
              [
                -76.5483769993073,
                39.3111919991045,
                0
              ],
              [
                -76.5482620003532,
                39.3112289988707,
                0
              ],
              [
                -76.54816200005,
                39.3112349989792,
                0
              ],
              [
                -76.5480610013478,
                39.3112329991389,
                0
              ],
              [
                -76.5479970005286,
                39.3112209989979,
                0
              ],
              [
                -76.5479179995931,
                39.3111959990327,
                0
              ],
              [
                -76.5478840001828,
                39.3111799986834,
                0
              ],
              [
                -76.5478540005195,
                39.3111529992512,
                0
              ],
              [
                -76.5477640004977,
                39.3110119996423,
                0
              ],
              [
                -76.5475799984424,
                39.3106789992034,
                0
              ],
              [
                -76.5473530001156,
                39.3101540002442,
                0
              ],
              [
                -76.547240000947,
                39.3099939992765,
                0
              ],
              [
                -76.5471950004349,
                39.3098939993942,
                0
              ],
              [
                -76.5471239999896,
                39.3098089986969,
                0
              ],
              [
                -76.546990000259,
                39.3096779993028,
                0
              ],
              [
                -76.546902999737,
                39.3096039989904,
                0
              ],
              [
                -76.5467980005141,
                39.3095379990875,
                0
              ],
              [
                -76.5461900001869,
                39.3092149998717,
                0
              ],
              [
                -76.5457449996269,
                39.3090459988782,
                0
              ],
              [
                -76.5455600002583,
                39.3089649999018,
                0
              ],
              [
                -76.5454749997288,
                39.308913998996,
                0
              ],
              [
                -76.5454230002933,
                39.3088669998567,
                0
              ],
              [
                -76.5451859995328,
                39.308662998729,
                0
              ],
              [
                -76.5447320000183,
                39.3082689991091,
                0
              ],
              [
                -76.5445129999868,
                39.3080119990249,
                0
              ],
              [
                -76.5443999987699,
                39.3078449989842,
                0
              ],
              [
                -76.5442959996895,
                39.3077229987053,
                0
              ],
              [
                -76.5441639990863,
                39.307607999395,
                0
              ],
              [
                -76.5440589999879,
                39.3075559992774,
                0
              ],
              [
                -76.5438789998727,
                39.3074809998323,
                0
              ],
              [
                -76.5435890000969,
                39.3074279990949,
                0
              ],
              [
                -76.5433309997304,
                39.3074069989556,
                0
              ],
              [
                -76.5431180002065,
                39.3073519993414,
                0
              ],
              [
                -76.544198001086,
                39.305444999229,
                0
              ],
              [
                -76.5446980001334,
                39.3045589988736,
                0
              ],
              [
                -76.5449040003853,
                39.3042149987946,
                0
              ],
              [
                -76.5453470012172,
                39.303574999109,
                0
              ],
              [
                -76.5457070003599,
                39.3030709986673,
                0
              ],
              [
                -76.5460460000251,
                39.3026059990082,
                0
              ],
              [
                -76.5460890003714,
                39.3025479985602,
                0
              ],
              [
                -76.5465429996761,
                39.3023979987197,
                0
              ],
              [
                -76.5476129998509,
                39.3020849990372,
                0
              ],
              [
                -76.5478410000881,
                39.3020249987985,
                0
              ],
              [
                -76.5487070008094,
                39.3017619986969,
                0
              ],
              [
                -76.5488339997248,
                39.301718998626,
                0
              ],
              [
                -76.5494759996977,
                39.3015029989099,
                0
              ],
              [
                -76.5500279998205,
                39.3013119993395,
                0
              ],
              [
                -76.550520999736,
                39.3011339991478,
                0
              ],
              [
                -76.5505529997256,
                39.3011219991299,
                0
              ],
              [
                -76.5506579995179,
                39.3010819989382,
                0
              ],
              [
                -76.5506740001128,
                39.3010769987577,
                0
              ],
              [
                -76.551027000555,
                39.3009709982845,
                0
              ],
              [
                -76.5519970003603,
                39.3006379994149,
                0
              ],
              [
                -76.5525129998131,
                39.3004649994128,
                0
              ],
              [
                -76.55276300019,
                39.3003809987991,
                0
              ],
              [
                -76.5534790008122,
                39.3001509989381,
                0
              ],
              [
                -76.55366499845,
                39.3002759988497,
                0
              ],
              [
                -76.5542390002826,
                39.300621998992,
                0
              ],
              [
                -76.5544720000818,
                39.3007619988162,
                0
              ],
              [
                -76.5548850014218,
                39.3010179991094,
                0
              ],
              [
                -76.5549799994424,
                39.3010769993288,
                0
              ],
              [
                -76.5551299997936,
                39.301181999666,
                0
              ],
              [
                -76.5554819995284,
                39.3014499991444,
                0
              ],
              [
                -76.5558429997152,
                39.3017229992498,
                0
              ],
              [
                -76.5562079999495,
                39.3019989993395,
                0
              ],
              [
                -76.5569790003598,
                39.3025729994319,
                0
              ],
              [
                -76.5576050002188,
                39.3030639992728,
                0
              ],
              [
                -76.5579519995798,
                39.3033480004099,
                0
              ],
              [
                -76.5582990002719,
                39.3036299990058,
                0
              ],
              [
                -76.5587869999903,
                39.3040059987333,
                0
              ],
              [
                -76.5592369998359,
                39.3043479988155,
                0
              ],
              [
                -76.5595880003415,
                39.3046179986697,
                0
              ],
              [
                -76.5607630003238,
                39.3055079992355,
                0
              ],
              [
                -76.5608779997867,
                39.3055969988298,
                0
              ],
              [
                -76.5609309995271,
                39.3056379994368,
                0
              ],
              [
                -76.5621099988261,
                39.306483999944,
                0
              ],
              [
                -76.5625560005765,
                39.3068309991711,
                0
              ],
              [
                -76.5636089986922,
                39.3076349991291,
                0
              ],
              [
                -76.5644980002439,
                39.3082509989107,
                0
              ],
              [
                -76.565477999992,
                39.3089699993363,
                0
              ],
              [
                -76.5634520004245,
                39.3089669993591,
                0
              ],
              [
                -76.5622930004078,
                39.3089659982154,
                0
              ],
              [
                -76.5621170005771,
                39.3089689986786,
                0
              ],
              [
                -76.5616309996998,
                39.3089779993401,
                0
              ],
              [
                -76.5612150004187,
                39.3089859992432,
                0
              ],
              [
                -76.5611979997244,
                39.3089869986542,
                0
              ],
              [
                -76.5609150000185,
                39.3090119986466,
                0
              ],
              [
                -76.5608570000224,
                39.3090159992553,
                0
              ],
              [
                -76.5605360005511,
                39.3090579986357,
                0
              ],
              [
                -76.5587349988782,
                39.3094759988785,
                0
              ],
              [
                -76.5577880002165,
                39.3097139986786,
                0
              ],
              [
                -76.5568080002133,
                39.309985998793,
                0
              ],
              [
                -76.5560650004994,
                39.3101579987969,
                0
              ],
              [
                -76.5548540003178,
                39.3104639987601,
                0
              ],
              [
                -76.5540229998235,
                39.3108069990359,
                0
              ],
              [
                -76.5536099996068,
                39.3101019988214,
                0
              ],
              [
                -76.5533669994652,
                39.3102949977596,
                0
              ],
              [
                -76.5531390000403,
                39.3105079978039,
                0
              ],
              [
                -76.5529589991595,
                39.3106459991906,
                0
              ],
              [
                -76.5527900002279,
                39.3107519986263,
                0
              ],
              [
                -76.5526060015658,
                39.3108189982686,
                0
              ],
              [
                -76.5521689998921,
                39.3109519987201,
                0
              ],
              [
                -76.5521019997103,
                39.3109989988991,
                0
              ],
              [
                -76.5520460003522,
                39.3110939990959,
                0
              ],
              [
                -76.5519380005131,
                39.3112079988434,
                0
              ],
              [
                -76.5517940004627,
                39.3112869982768,
                0
              ],
              [
                -76.551507999527,
                39.3113679994059,
                0
              ],
              [
                -76.5511659994733,
                39.3114259986104,
                0
              ],
              [
                -76.5510099999697,
                39.3114299992399,
                0
              ],
              [
                -76.5508620004563,
                39.3114049988319,
                0
              ],
              [
                -76.5506940002626,
                39.3113609986575,
                0
              ],
              [
                -76.550577000374,
                39.311341000317,
                0
              ],
              [
                -76.55038699884,
                39.3113179986823,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 26,
          "Census_Tract": "24510090300",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "53520466-fcc0-46a8-ba73-b11825b56d55",
          "Shape__Area": 8537794.641845703,
          "Shape__Length": 12579.082348320168
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.5954430003879,
                39.3340299988996,
                0
              ],
              [
                -76.5952720000606,
                39.3336419990279,
                0
              ],
              [
                -76.5951590009603,
                39.3331469995626,
                0
              ],
              [
                -76.5951090001679,
                39.3324519992489,
                0
              ],
              [
                -76.5951119996551,
                39.3317689991642,
                0
              ],
              [
                -76.5951120003129,
                39.3317369991364,
                0
              ],
              [
                -76.5951119997381,
                39.331690998753,
                0
              ],
              [
                -76.5951139994308,
                39.3309559992802,
                0
              ],
              [
                -76.5951149999366,
                39.3301359987225,
                0
              ],
              [
                -76.595114999821,
                39.3293459994017,
                0
              ],
              [
                -76.5951400013418,
                39.3285149991721,
                0
              ],
              [
                -76.5951450002494,
                39.3283470002964,
                0
              ],
              [
                -76.5953880004199,
                39.3283449987575,
                0
              ],
              [
                -76.596699000926,
                39.3283369991592,
                0
              ],
              [
                -76.5978969999013,
                39.3283290001578,
                0
              ],
              [
                -76.5992800001967,
                39.3283319991401,
                0
              ],
              [
                -76.6006899995527,
                39.3283429992753,
                0
              ],
              [
                -76.603629000176,
                39.3283319989777,
                0
              ],
              [
                -76.6045130000247,
                39.3283409990658,
                0
              ],
              [
                -76.6050399998632,
                39.3283489997402,
                0
              ],
              [
                -76.6053419988712,
                39.3283439989092,
                0
              ],
              [
                -76.6061510002675,
                39.3283409989662,
                0
              ],
              [
                -76.6063209985898,
                39.3283419990172,
                0
              ],
              [
                -76.6070279999463,
                39.3283319993297,
                0
              ],
              [
                -76.607577000299,
                39.3283319986659,
                0
              ],
              [
                -76.6084719998044,
                39.3283319991016,
                0
              ],
              [
                -76.6094280003982,
                39.3283139993852,
                0
              ],
              [
                -76.6094300002087,
                39.3284949991148,
                0
              ],
              [
                -76.6094429994875,
                39.3292229985601,
                0
              ],
              [
                -76.6094540010545,
                39.3296049988954,
                0
              ],
              [
                -76.6094480002361,
                39.3297690000466,
                0
              ],
              [
                -76.6094630004594,
                39.3302169989008,
                0
              ],
              [
                -76.6094759992483,
                39.3309649981847,
                0
              ],
              [
                -76.6094690001777,
                39.3325230004374,
                0
              ],
              [
                -76.6094759994649,
                39.3326209981318,
                0
              ],
              [
                -76.6094900013386,
                39.3331789989889,
                0
              ],
              [
                -76.6094940013449,
                39.3333449986171,
                0
              ],
              [
                -76.6095020002752,
                39.3337009991861,
                0
              ],
              [
                -76.6095079998607,
                39.3344559993362,
                0
              ],
              [
                -76.6075370002768,
                39.3344829991127,
                0
              ],
              [
                -76.6075480003574,
                39.3340459990424,
                0
              ],
              [
                -76.6071469996122,
                39.3340610000738,
                0
              ],
              [
                -76.6071119996078,
                39.3340639978879,
                0
              ],
              [
                -76.606762999749,
                39.3340919989573,
                0
              ],
              [
                -76.6063150005279,
                39.3341380004134,
                0
              ],
              [
                -76.605879000039,
                39.334184998789,
                0
              ],
              [
                -76.6051240007089,
                39.334270998711,
                0
              ],
              [
                -76.6046300001497,
                39.3343269987572,
                0
              ],
              [
                -76.6044849990067,
                39.3340399999914,
                0
              ],
              [
                -76.6032549996835,
                39.3340369990393,
                0
              ],
              [
                -76.6028469997567,
                39.3340369994469,
                0
              ],
              [
                -76.6019690002492,
                39.3340299989575,
                0
              ],
              [
                -76.6015389989586,
                39.3340329990851,
                0
              ],
              [
                -76.6010860008628,
                39.3340379994307,
                0
              ],
              [
                -76.600661000408,
                39.3340379994121,
                0
              ],
              [
                -76.6001969998603,
                39.3340379994322,
                0
              ],
              [
                -76.599778999704,
                39.3340329992597,
                0
              ],
              [
                -76.5992799999681,
                39.3340279989405,
                0
              ],
              [
                -76.5988259998327,
                39.3340349994343,
                0
              ],
              [
                -76.5983540003199,
                39.3340409989972,
                0
              ],
              [
                -76.5978799999186,
                39.3340379994464,
                0
              ],
              [
                -76.597416999813,
                39.334033998896,
                0
              ],
              [
                -76.5969499999954,
                39.3340259987957,
                0
              ],
              [
                -76.5964510000098,
                39.3340169988505,
                0
              ],
              [
                -76.5963830003004,
                39.3340159988534,
                0
              ],
              [
                -76.5957879987329,
                39.3340059989743,
                0
              ],
              [
                -76.5957069990117,
                39.3340049998219,
                0
              ],
              [
                -76.5954430003879,
                39.3340299988996,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 27,
          "Census_Tract": "24510090400",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "51d8f78a-2e82-49b9-87ff-4c79e115b831",
          "Shape__Area": 3791291.930786133,
          "Shape__Length": 8008.825496745315
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.60581199967,
                39.319456998941,
                0
              ],
              [
                -76.606757999497,
                39.3195150004492,
                0
              ],
              [
                -76.6073109984409,
                39.3195459987186,
                0
              ],
              [
                -76.6078730004708,
                39.3195519988181,
                0
              ],
              [
                -76.6086359987013,
                39.3195399994253,
                0
              ],
              [
                -76.6090669985567,
                39.319533999051,
                0
              ],
              [
                -76.60950899963,
                39.3195189991029,
                0
              ],
              [
                -76.6095320000752,
                39.3200119987122,
                0
              ],
              [
                -76.6095369998087,
                39.3202759996728,
                0
              ],
              [
                -76.6095319998273,
                39.3209219988504,
                0
              ],
              [
                -76.6095279999484,
                39.3211839989924,
                0
              ],
              [
                -76.6095190001985,
                39.3215279977578,
                0
              ],
              [
                -76.6094839995248,
                39.3221489984314,
                0
              ],
              [
                -76.6094679997298,
                39.322824998947,
                0
              ],
              [
                -76.6094559988782,
                39.323442998821,
                0
              ],
              [
                -76.609443000343,
                39.3237729989927,
                0
              ],
              [
                -76.6094359987026,
                39.3243749990428,
                0
              ],
              [
                -76.6094250004583,
                39.3247849987535,
                0
              ],
              [
                -76.6094259999457,
                39.3253999987161,
                0
              ],
              [
                -76.6092970004601,
                39.3255779996938,
                0
              ],
              [
                -76.6090380004161,
                39.3259359993396,
                0
              ],
              [
                -76.6088640010752,
                39.3264699987807,
                0
              ],
              [
                -76.6085680002277,
                39.3264279986269,
                0
              ],
              [
                -76.6081640001852,
                39.3263599987776,
                0
              ],
              [
                -76.6078270005776,
                39.326305998986,
                0
              ],
              [
                -76.6076330004058,
                39.3262799990087,
                0
              ],
              [
                -76.6074550005431,
                39.3262499987704,
                0
              ],
              [
                -76.607348000059,
                39.3262239988019,
                0
              ],
              [
                -76.6072379995993,
                39.326189999053,
                0
              ],
              [
                -76.6073630003876,
                39.3259839988653,
                0
              ],
              [
                -76.6069960011021,
                39.3258469985684,
                0
              ],
              [
                -76.6066660005012,
                39.3257239988027,
                0
              ],
              [
                -76.6063490002587,
                39.3256039988078,
                0
              ],
              [
                -76.6056320007369,
                39.3253329985645,
                0
              ],
              [
                -76.605106999538,
                39.3251329985937,
                0
              ],
              [
                -76.6033240003728,
                39.3244299987772,
                0
              ],
              [
                -76.6014679995088,
                39.323707000374,
                0
              ],
              [
                -76.6020050010382,
                39.3231529986067,
                0
              ],
              [
                -76.6027309994395,
                39.3224009986007,
                0
              ],
              [
                -76.6035840006844,
                39.3215719991795,
                0
              ],
              [
                -76.60581199967,
                39.319456998941,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 28,
          "Census_Tract": "24510090500",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "2969f51b-f538-4fc0-bd18-9839e6b5a8c1",
          "Shape__Area": 7982107.448059082,
          "Shape__Length": 15486.468657097648
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.5951450002494,
                39.3283470002964,
                0
              ],
              [
                -76.595161000156,
                39.3281309986699,
                0
              ],
              [
                -76.5951489996794,
                39.3279989982716,
                0
              ],
              [
                -76.5951299995966,
                39.3279419990813,
                0
              ],
              [
                -76.5950929998179,
                39.3278869988,
                0
              ],
              [
                -76.5950710003887,
                39.3278539987752,
                0
              ],
              [
                -76.5949420005115,
                39.3277299992258,
                0
              ],
              [
                -76.5947570001793,
                39.327540999253,
                0
              ],
              [
                -76.5945750010219,
                39.3273499988505,
                0
              ],
              [
                -76.5944409995414,
                39.3271509993661,
                0
              ],
              [
                -76.5943060001839,
                39.3269359989326,
                0
              ],
              [
                -76.5941569998686,
                39.3266759989045,
                0
              ],
              [
                -76.5939290012637,
                39.3262249989144,
                0
              ],
              [
                -76.5941150003083,
                39.3260539987109,
                0
              ],
              [
                -76.5944379997764,
                39.325757999054,
                0
              ],
              [
                -76.5948960005118,
                39.3253119987526,
                0
              ],
              [
                -76.5953319998062,
                39.3248779990544,
                0
              ],
              [
                -76.5953500005095,
                39.3248569987557,
                0
              ],
              [
                -76.5962160004908,
                39.3239980000754,
                0
              ],
              [
                -76.596386000558,
                39.3238299992867,
                0
              ],
              [
                -76.5964889995289,
                39.3237279987178,
                0
              ],
              [
                -76.5967640002377,
                39.3234559994053,
                0
              ],
              [
                -76.5970370000764,
                39.323178999706,
                0
              ],
              [
                -76.5973120000012,
                39.3228969989287,
                0
              ],
              [
                -76.5976150005474,
                39.3226109994397,
                0
              ],
              [
                -76.5978809994965,
                39.322359999192,
                0
              ],
              [
                -76.5981780003646,
                39.3220779986502,
                0
              ],
              [
                -76.5984259999911,
                39.3218409990471,
                0
              ],
              [
                -76.5989969997025,
                39.3212829995841,
                0
              ],
              [
                -76.5995070001991,
                39.3207889986748,
                0
              ],
              [
                -76.6005740000845,
                39.3197009987136,
                0
              ],
              [
                -76.6007210002076,
                39.3195559987253,
                0
              ],
              [
                -76.6014890005787,
                39.3187899992995,
                0
              ],
              [
                -76.6020949994383,
                39.3189299992838,
                0
              ],
              [
                -76.6025699994357,
                39.3190349994341,
                0
              ],
              [
                -76.6028940000541,
                39.3190989987092,
                0
              ],
              [
                -76.6033509999494,
                39.3191809990016,
                0
              ],
              [
                -76.6037279998716,
                39.3192329993552,
                0
              ],
              [
                -76.6042279999345,
                39.3192979989824,
                0
              ],
              [
                -76.6047910004226,
                39.3193599989662,
                0
              ],
              [
                -76.6054100003835,
                39.3194129993029,
                0
              ],
              [
                -76.60581199967,
                39.319456998941,
                0
              ],
              [
                -76.6035840006844,
                39.3215719991795,
                0
              ],
              [
                -76.6027309994395,
                39.3224009986007,
                0
              ],
              [
                -76.6020050010382,
                39.3231529986067,
                0
              ],
              [
                -76.6014679995088,
                39.323707000374,
                0
              ],
              [
                -76.6033240003728,
                39.3244299987772,
                0
              ],
              [
                -76.605106999538,
                39.3251329985937,
                0
              ],
              [
                -76.6056320007369,
                39.3253329985645,
                0
              ],
              [
                -76.6063490002587,
                39.3256039988078,
                0
              ],
              [
                -76.6066660005012,
                39.3257239988027,
                0
              ],
              [
                -76.6069960011021,
                39.3258469985684,
                0
              ],
              [
                -76.6073630003876,
                39.3259839988653,
                0
              ],
              [
                -76.6072379995993,
                39.326189999053,
                0
              ],
              [
                -76.607348000059,
                39.3262239988019,
                0
              ],
              [
                -76.6074550005431,
                39.3262499987704,
                0
              ],
              [
                -76.6076330004058,
                39.3262799990087,
                0
              ],
              [
                -76.6078270005776,
                39.326305998986,
                0
              ],
              [
                -76.6081640001852,
                39.3263599987776,
                0
              ],
              [
                -76.6085680002277,
                39.3264279986269,
                0
              ],
              [
                -76.6088640010752,
                39.3264699987807,
                0
              ],
              [
                -76.6090380004161,
                39.3259359993396,
                0
              ],
              [
                -76.6092970004601,
                39.3255779996938,
                0
              ],
              [
                -76.6094259999457,
                39.3253999987161,
                0
              ],
              [
                -76.6094290012023,
                39.3260909988368,
                0
              ],
              [
                -76.6094490006937,
                39.3268319991964,
                0
              ],
              [
                -76.6094419998784,
                39.327205998985,
                0
              ],
              [
                -76.6094359988247,
                39.327967999252,
                0
              ],
              [
                -76.6094359988375,
                39.3280159993203,
                0
              ],
              [
                -76.6094280003982,
                39.3283139993852,
                0
              ],
              [
                -76.6084719998044,
                39.3283319991016,
                0
              ],
              [
                -76.607577000299,
                39.3283319986659,
                0
              ],
              [
                -76.6070279999463,
                39.3283319993297,
                0
              ],
              [
                -76.6063209985898,
                39.3283419990172,
                0
              ],
              [
                -76.6061510002675,
                39.3283409989662,
                0
              ],
              [
                -76.6053419988712,
                39.3283439989092,
                0
              ],
              [
                -76.6050399998632,
                39.3283489997402,
                0
              ],
              [
                -76.6045130000247,
                39.3283409990658,
                0
              ],
              [
                -76.603629000176,
                39.3283319989777,
                0
              ],
              [
                -76.6006899995527,
                39.3283429992753,
                0
              ],
              [
                -76.5992800001967,
                39.3283319991401,
                0
              ],
              [
                -76.5978969999013,
                39.3283290001578,
                0
              ],
              [
                -76.596699000926,
                39.3283369991592,
                0
              ],
              [
                -76.5953880004199,
                39.3283449987575,
                0
              ],
              [
                -76.5951450002494,
                39.3283470002964,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 29,
          "Census_Tract": "24510090600",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "58e9eef3-f40c-4b8f-992f-c09a26c0e40b",
          "Shape__Area": 4276020.170349121,
          "Shape__Length": 9124.365663605438
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.5845760002598,
                39.327046999291,
                0
              ],
              [
                -76.5854560001983,
                39.3259609985801,
                0
              ],
              [
                -76.5861079999927,
                39.3251369989233,
                0
              ],
              [
                -76.5866490001509,
                39.3245189989912,
                0
              ],
              [
                -76.5869910000149,
                39.32411100041,
                0
              ],
              [
                -76.5870440009666,
                39.3240549986254,
                0
              ],
              [
                -76.5872049985424,
                39.3238639994238,
                0
              ],
              [
                -76.5872340005082,
                39.3238299988025,
                0
              ],
              [
                -76.5873360007894,
                39.323702998722,
                0
              ],
              [
                -76.5874699998711,
                39.3235639993513,
                0
              ],
              [
                -76.5876209995629,
                39.3234419990203,
                0
              ],
              [
                -76.5878970005231,
                39.3232539991606,
                0
              ],
              [
                -76.5882089997326,
                39.3230639999022,
                0
              ],
              [
                -76.5885340000958,
                39.3228300003371,
                0
              ],
              [
                -76.5886490002076,
                39.3227569987688,
                0
              ],
              [
                -76.5892820004489,
                39.3223609988651,
                0
              ],
              [
                -76.5893439999316,
                39.3223199997771,
                0
              ],
              [
                -76.5894130004403,
                39.3222789989919,
                0
              ],
              [
                -76.589613999838,
                39.3221359994459,
                0
              ],
              [
                -76.5898409995032,
                39.3219659992574,
                0
              ],
              [
                -76.5899780003088,
                39.3218609991572,
                0
              ],
              [
                -76.5906579987057,
                39.3212389992572,
                0
              ],
              [
                -76.5906910006386,
                39.3213199990851,
                0
              ],
              [
                -76.590732000602,
                39.3213869993313,
                0
              ],
              [
                -76.5907720005693,
                39.3214379987126,
                0
              ],
              [
                -76.5908720002207,
                39.321526998033,
                0
              ],
              [
                -76.5912530001505,
                39.3218249991628,
                0
              ],
              [
                -76.5915549993646,
                39.3220679992875,
                0
              ],
              [
                -76.591930999729,
                39.3223639982192,
                0
              ],
              [
                -76.5920939998828,
                39.3224909990423,
                0
              ],
              [
                -76.5922809998791,
                39.322649999245,
                0
              ],
              [
                -76.5924660015416,
                39.3228119980206,
                0
              ],
              [
                -76.5925770002034,
                39.3229189985774,
                0
              ],
              [
                -76.5926980012567,
                39.3230609999847,
                0
              ],
              [
                -76.5928140001463,
                39.3232089991522,
                0
              ],
              [
                -76.5931820002578,
                39.3239009989193,
                0
              ],
              [
                -76.5933970000609,
                39.3246249997179,
                0
              ],
              [
                -76.5935840004676,
                39.3252709980407,
                0
              ],
              [
                -76.5938099999053,
                39.3259669989984,
                0
              ],
              [
                -76.5939290012637,
                39.3262249989144,
                0
              ],
              [
                -76.5941569998686,
                39.3266759989045,
                0
              ],
              [
                -76.5943060001839,
                39.3269359989326,
                0
              ],
              [
                -76.5944409995414,
                39.3271509993661,
                0
              ],
              [
                -76.5945750010219,
                39.3273499988505,
                0
              ],
              [
                -76.5947570001793,
                39.327540999253,
                0
              ],
              [
                -76.5949420005115,
                39.3277299992258,
                0
              ],
              [
                -76.5950710003887,
                39.3278539987752,
                0
              ],
              [
                -76.5950929998179,
                39.3278869988,
                0
              ],
              [
                -76.5951299995966,
                39.3279419990813,
                0
              ],
              [
                -76.5951489996794,
                39.3279989982716,
                0
              ],
              [
                -76.595161000156,
                39.3281309986699,
                0
              ],
              [
                -76.5951450002494,
                39.3283470002964,
                0
              ],
              [
                -76.5921170011442,
                39.3283419993661,
                0
              ],
              [
                -76.5907040005695,
                39.3283589992679,
                0
              ],
              [
                -76.5893109998297,
                39.3283639991202,
                0
              ],
              [
                -76.5893120000407,
                39.3278919992552,
                0
              ],
              [
                -76.5893150004658,
                39.3275389991257,
                0
              ],
              [
                -76.589325000531,
                39.3274259988173,
                0
              ],
              [
                -76.5893339995676,
                39.3272969985681,
                0
              ],
              [
                -76.5880559997773,
                39.3273189986691,
                0
              ],
              [
                -76.5879709995287,
                39.3273219992877,
                0
              ],
              [
                -76.5878390003146,
                39.3273299990559,
                0
              ],
              [
                -76.5876320002129,
                39.3273519989676,
                0
              ],
              [
                -76.5871660001665,
                39.3273279993175,
                0
              ],
              [
                -76.5868589996116,
                39.3273289986767,
                0
              ],
              [
                -76.5861589994706,
                39.327335997656,
                0
              ],
              [
                -76.5855879993506,
                39.3273379987099,
                0
              ],
              [
                -76.5853070004517,
                39.3273259986719,
                0
              ],
              [
                -76.585238999518,
                39.327317998766,
                0
              ],
              [
                -76.5851530000935,
                39.3273079986827,
                0
              ],
              [
                -76.5850279997247,
                39.3272749997834,
                0
              ],
              [
                -76.5849040004264,
                39.3272409990472,
                0
              ],
              [
                -76.5848230002764,
                39.3272019986731,
                0
              ],
              [
                -76.5845760002598,
                39.327046999291,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 30,
          "Census_Tract": "24510090700",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "79c22996-f395-44e6-bde1-291a937660cf",
          "Shape__Area": 4682998.172729492,
          "Shape__Length": 9384.539663434622
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.5906579987057,
                39.3212389992572,
                0
              ],
              [
                -76.5911049994144,
                39.3207979992121,
                0
              ],
              [
                -76.591683000366,
                39.3202599983596,
                0
              ],
              [
                -76.591819000089,
                39.3201259991646,
                0
              ],
              [
                -76.5922519998318,
                39.3197309988306,
                0
              ],
              [
                -76.5924050004488,
                39.3195769990539,
                0
              ],
              [
                -76.5928209998909,
                39.3191779986259,
                0
              ],
              [
                -76.593034000351,
                39.3189849987858,
                0
              ],
              [
                -76.5933610005677,
                39.3186499992636,
                0
              ],
              [
                -76.5938739995641,
                39.3181739991313,
                0
              ],
              [
                -76.5942060001921,
                39.3178659992543,
                0
              ],
              [
                -76.5944389990182,
                39.3176179991994,
                0
              ],
              [
                -76.5948670011206,
                39.3172379990568,
                0
              ],
              [
                -76.5948870014066,
                39.3172429987269,
                0
              ],
              [
                -76.5977169984538,
                39.3179219986268,
                0
              ],
              [
                -76.5994119996495,
                39.318293998581,
                0
              ],
              [
                -76.6014890005787,
                39.3187899992995,
                0
              ],
              [
                -76.6007210002076,
                39.3195559987253,
                0
              ],
              [
                -76.6005740000845,
                39.3197009987136,
                0
              ],
              [
                -76.5995070001991,
                39.3207889986748,
                0
              ],
              [
                -76.5989969997025,
                39.3212829995841,
                0
              ],
              [
                -76.5984259999911,
                39.3218409990471,
                0
              ],
              [
                -76.5981780003646,
                39.3220779986502,
                0
              ],
              [
                -76.5978809994965,
                39.322359999192,
                0
              ],
              [
                -76.5976150005474,
                39.3226109994397,
                0
              ],
              [
                -76.5973120000012,
                39.3228969989287,
                0
              ],
              [
                -76.5970370000764,
                39.323178999706,
                0
              ],
              [
                -76.5967640002377,
                39.3234559994053,
                0
              ],
              [
                -76.5964889995289,
                39.3237279987178,
                0
              ],
              [
                -76.596386000558,
                39.3238299992867,
                0
              ],
              [
                -76.5962160004908,
                39.3239980000754,
                0
              ],
              [
                -76.5953500005095,
                39.3248569987557,
                0
              ],
              [
                -76.5953319998062,
                39.3248779990544,
                0
              ],
              [
                -76.5948960005118,
                39.3253119987526,
                0
              ],
              [
                -76.5944379997764,
                39.325757999054,
                0
              ],
              [
                -76.5941150003083,
                39.3260539987109,
                0
              ],
              [
                -76.5939290012637,
                39.3262249989144,
                0
              ],
              [
                -76.5938099999053,
                39.3259669989984,
                0
              ],
              [
                -76.5935840004676,
                39.3252709980407,
                0
              ],
              [
                -76.5933970000609,
                39.3246249997179,
                0
              ],
              [
                -76.5931820002578,
                39.3239009989193,
                0
              ],
              [
                -76.5928140001463,
                39.3232089991522,
                0
              ],
              [
                -76.5926980012567,
                39.3230609999847,
                0
              ],
              [
                -76.5925770002034,
                39.3229189985774,
                0
              ],
              [
                -76.5924660015416,
                39.3228119980206,
                0
              ],
              [
                -76.5922809998791,
                39.322649999245,
                0
              ],
              [
                -76.5920939998828,
                39.3224909990423,
                0
              ],
              [
                -76.591930999729,
                39.3223639982192,
                0
              ],
              [
                -76.5915549993646,
                39.3220679992875,
                0
              ],
              [
                -76.5912530001505,
                39.3218249991628,
                0
              ],
              [
                -76.5908720002207,
                39.321526998033,
                0
              ],
              [
                -76.5907720005693,
                39.3214379987126,
                0
              ],
              [
                -76.590732000602,
                39.3213869993313,
                0
              ],
              [
                -76.5906910006386,
                39.3213199990851,
                0
              ],
              [
                -76.5906579987057,
                39.3212389992572,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 31,
          "Census_Tract": "24510210200",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "c38471ef-1d88-4c79-94fd-5cdb217cab03",
          "Shape__Area": 25823594.746948242,
          "Shape__Length": 26307.146641438787
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6334719994538,
                39.2695449989991,
                0
              ],
              [
                -76.6334860000351,
                39.2695479990033,
                0
              ],
              [
                -76.6339320001995,
                39.2696269990305,
                0
              ],
              [
                -76.6344400005263,
                39.2697299993766,
                0
              ],
              [
                -76.6348410009556,
                39.2697969990966,
                0
              ],
              [
                -76.6353649996819,
                39.2698829999995,
                0
              ],
              [
                -76.6365230015744,
                39.2700239985774,
                0
              ],
              [
                -76.637329998474,
                39.2701399978358,
                0
              ],
              [
                -76.6380489984249,
                39.2702419990253,
                0
              ],
              [
                -76.639053999929,
                39.2704209987376,
                0
              ],
              [
                -76.6395050001302,
                39.270466998812,
                0
              ],
              [
                -76.6398290003914,
                39.2704999988449,
                0
              ],
              [
                -76.6423670002831,
                39.2707409987073,
                0
              ],
              [
                -76.6435990013485,
                39.27082599907,
                0
              ],
              [
                -76.6443709995681,
                39.2708949994067,
                0
              ],
              [
                -76.6473699999759,
                39.2711639991137,
                0
              ],
              [
                -76.6480779997232,
                39.2712209990884,
                0
              ],
              [
                -76.6484079995614,
                39.2712509983617,
                0
              ],
              [
                -76.6510780001236,
                39.2714969987104,
                0
              ],
              [
                -76.6514740000877,
                39.2715299994068,
                0
              ],
              [
                -76.6518849999494,
                39.2715659986333,
                0
              ],
              [
                -76.6521110002544,
                39.2715799995919,
                0
              ],
              [
                -76.6524750008993,
                39.2715839993174,
                0
              ],
              [
                -76.6531329994513,
                39.2715479989356,
                0
              ],
              [
                -76.6532639996989,
                39.271538999804,
                0
              ],
              [
                -76.6535590002042,
                39.2715009997123,
                0
              ],
              [
                -76.6541909998933,
                39.2713999986796,
                0
              ],
              [
                -76.6549960003978,
                39.2711919991414,
                0
              ],
              [
                -76.6549990003844,
                39.2712239985742,
                0
              ],
              [
                -76.6550569996753,
                39.2717389994416,
                0
              ],
              [
                -76.655154999899,
                39.2726809992865,
                0
              ],
              [
                -76.655238999657,
                39.2734469990381,
                0
              ],
              [
                -76.6553039985578,
                39.2740829987428,
                0
              ],
              [
                -76.6553350001304,
                39.2745229988521,
                0
              ],
              [
                -76.6552429995781,
                39.2749239987972,
                0
              ],
              [
                -76.6550240003973,
                39.2753309985749,
                0
              ],
              [
                -76.6549189994767,
                39.275523999164,
                0
              ],
              [
                -76.6545520000133,
                39.2761519992928,
                0
              ],
              [
                -76.6544940005512,
                39.276212998563,
                0
              ],
              [
                -76.6541079994393,
                39.2766289991631,
                0
              ],
              [
                -76.6539110001845,
                39.2767929989201,
                0
              ],
              [
                -76.6537339998874,
                39.2769339986911,
                0
              ],
              [
                -76.653547999928,
                39.2770689986923,
                0
              ],
              [
                -76.6532719999394,
                39.2772569993175,
                0
              ],
              [
                -76.6531510002523,
                39.2773300001296,
                0
              ],
              [
                -76.6529020005214,
                39.2774649985995,
                0
              ],
              [
                -76.6526820004924,
                39.2775689978979,
                0
              ],
              [
                -76.6523310000965,
                39.2777199999879,
                0
              ],
              [
                -76.6518449997302,
                39.2779209985815,
                0
              ],
              [
                -76.6509999997756,
                39.2782270000377,
                0
              ],
              [
                -76.6500209999352,
                39.2785199999634,
                0
              ],
              [
                -76.6499080001248,
                39.2785569988922,
                0
              ],
              [
                -76.6493619999678,
                39.2787029987943,
                0
              ],
              [
                -76.6486099997845,
                39.2788930002053,
                0
              ],
              [
                -76.6479769995152,
                39.2790749989397,
                0
              ],
              [
                -76.6478459994876,
                39.2791129994309,
                0
              ],
              [
                -76.6464260008483,
                39.2794889991443,
                0
              ],
              [
                -76.6455289998219,
                39.2797749987342,
                0
              ],
              [
                -76.644526999853,
                39.2801039976921,
                0
              ],
              [
                -76.6442709997014,
                39.2801879987594,
                0
              ],
              [
                -76.6431299999601,
                39.2805449990963,
                0
              ],
              [
                -76.6418609999835,
                39.2809909987294,
                0
              ],
              [
                -76.6411330000035,
                39.2812969993937,
                0
              ],
              [
                -76.64085499901,
                39.2813999994177,
                0
              ],
              [
                -76.640769000282,
                39.2814329988613,
                0
              ],
              [
                -76.6404919998409,
                39.281556998735,
                0
              ],
              [
                -76.6401949994756,
                39.2817179994222,
                0
              ],
              [
                -76.6398680003688,
                39.2819089991203,
                0
              ],
              [
                -76.6394819998801,
                39.282125999261,
                0
              ],
              [
                -76.6390750002174,
                39.2823549993029,
                0
              ],
              [
                -76.6389789999034,
                39.2824019987602,
                0
              ],
              [
                -76.6386870005359,
                39.2825279992971,
                0
              ],
              [
                -76.6381360005529,
                39.2827119986991,
                0
              ],
              [
                -76.6378429995429,
                39.2827880000009,
                0
              ],
              [
                -76.6378880007253,
                39.2834469986559,
                0
              ],
              [
                -76.6379099988014,
                39.2839569989587,
                0
              ],
              [
                -76.6379370001367,
                39.284557998642,
                0
              ],
              [
                -76.6379840004908,
                39.2855869985552,
                0
              ],
              [
                -76.6372680002312,
                39.2856210003874,
                0
              ],
              [
                -76.6371919988035,
                39.2856249992541,
                0
              ],
              [
                -76.6365970001828,
                39.2856569989499,
                0
              ],
              [
                -76.6359859996732,
                39.285681999383,
                0
              ],
              [
                -76.6358839995808,
                39.2856859988057,
                0
              ],
              [
                -76.6351349998806,
                39.2857089987589,
                0
              ],
              [
                -76.634407999543,
                39.2857539986283,
                0
              ],
              [
                -76.633600998462,
                39.285810000403,
                0
              ],
              [
                -76.6330130010382,
                39.2858289986093,
                0
              ],
              [
                -76.632814000853,
                39.2858340001948,
                0
              ],
              [
                -76.6319589997412,
                39.2858659993153,
                0
              ],
              [
                -76.6312960003815,
                39.2858999992939,
                0
              ],
              [
                -76.6308869995741,
                39.2859179992347,
                0
              ],
              [
                -76.6305320004598,
                39.2859369990128,
                0
              ],
              [
                -76.630024999608,
                39.2859649986897,
                0
              ],
              [
                -76.6296380007545,
                39.2859739992223,
                0
              ],
              [
                -76.6290189992645,
                39.2860089988019,
                0
              ],
              [
                -76.6289790002029,
                39.2854009985646,
                0
              ],
              [
                -76.6289479995994,
                39.2849259987677,
                0
              ],
              [
                -76.6289459995661,
                39.2848879992519,
                0
              ],
              [
                -76.6289459997388,
                39.2848759993144,
                0
              ],
              [
                -76.6289450002186,
                39.2848629990766,
                0
              ],
              [
                -76.6289419994561,
                39.2848159986972,
                0
              ],
              [
                -76.6289170004766,
                39.284339999005,
                0
              ],
              [
                -76.6288830004372,
                39.2837939987646,
                0
              ],
              [
                -76.629594000148,
                39.2837759991941,
                0
              ],
              [
                -76.6296159997847,
                39.2837749993597,
                0
              ],
              [
                -76.630411000476,
                39.2837419989817,
                0
              ],
              [
                -76.6305179988867,
                39.2837369985753,
                0
              ],
              [
                -76.630781000292,
                39.2837259994375,
                0
              ],
              [
                -76.6311299994914,
                39.2837129989751,
                0
              ],
              [
                -76.6311679999643,
                39.2837119986524,
                0
              ],
              [
                -76.6318500000403,
                39.2836889987343,
                0
              ],
              [
                -76.6326690002253,
                39.2836329988076,
                0
              ],
              [
                -76.6334929995777,
                39.2836179988093,
                0
              ],
              [
                -76.633018999503,
                39.283270998628,
                0
              ],
              [
                -76.6328209986336,
                39.2831169991426,
                0
              ],
              [
                -76.6325309998596,
                39.282892998925,
                0
              ],
              [
                -76.6319610004171,
                39.2824839990543,
                0
              ],
              [
                -76.6314520003914,
                39.282087999285,
                0
              ],
              [
                -76.6313880014676,
                39.282040999396,
                0
              ],
              [
                -76.6309300005262,
                39.2816899990456,
                0
              ],
              [
                -76.6303429995414,
                39.2812569990495,
                0
              ],
              [
                -76.6318600009177,
                39.280099000246,
                0
              ],
              [
                -76.6322139995102,
                39.279814999054,
                0
              ],
              [
                -76.632941999788,
                39.2792309989461,
                0
              ],
              [
                -76.6332109992001,
                39.2790159985801,
                0
              ],
              [
                -76.6345969999301,
                39.2779689989564,
                0
              ],
              [
                -76.6337110001816,
                39.2772819992079,
                0
              ],
              [
                -76.6328479994919,
                39.2766379993495,
                0
              ],
              [
                -76.6316980003818,
                39.2757469994452,
                0
              ],
              [
                -76.6309650004623,
                39.2751809991065,
                0
              ],
              [
                -76.6309150004238,
                39.2751389988281,
                0
              ],
              [
                -76.6296609991197,
                39.2741849989372,
                0
              ],
              [
                -76.6291449998357,
                39.27378499894,
                0
              ],
              [
                -76.6287619993763,
                39.2734909992318,
                0
              ],
              [
                -76.6287310004622,
                39.2734669985706,
                0
              ],
              [
                -76.6292660003996,
                39.2730600001707,
                0
              ],
              [
                -76.630107998691,
                39.272407999385,
                0
              ],
              [
                -76.6302299998978,
                39.2723029986388,
                0
              ],
              [
                -76.6302639995013,
                39.2722739992814,
                0
              ],
              [
                -76.6303999995069,
                39.2721769988761,
                0
              ],
              [
                -76.6304620001958,
                39.2721329988722,
                0
              ],
              [
                -76.6315000001902,
                39.271247000435,
                0
              ],
              [
                -76.6316120000981,
                39.2711519986641,
                0
              ],
              [
                -76.631927999539,
                39.2708839986099,
                0
              ],
              [
                -76.632937000179,
                39.2700019993582,
                0
              ],
              [
                -76.6332669994241,
                39.2697259991707,
                0
              ],
              [
                -76.6334719994538,
                39.2695449989991,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 32,
          "Census_Tract": "24510271600",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "4849c16f-c363-4e6d-86ef-fc81a91e246c",
          "Shape__Area": 9152197.237304688,
          "Shape__Length": 12513.490262180776
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6594470002422,
                39.3465059976618,
                0
              ],
              [
                -76.6595569985891,
                39.3460719987171,
                0
              ],
              [
                -76.6595890000224,
                39.3458539989811,
                0
              ],
              [
                -76.6595820003079,
                39.3457169991179,
                0
              ],
              [
                -76.659551999507,
                39.3455819989516,
                0
              ],
              [
                -76.6594619998263,
                39.3453059992155,
                0
              ],
              [
                -76.6594360009403,
                39.345252998941,
                0
              ],
              [
                -76.6592949995767,
                39.3449719989952,
                0
              ],
              [
                -76.6590959994443,
                39.3446589993242,
                0
              ],
              [
                -76.6588529984761,
                39.3443829993577,
                0
              ],
              [
                -76.6586830003517,
                39.344231998926,
                0
              ],
              [
                -76.658613999692,
                39.3441769991544,
                0
              ],
              [
                -76.6583910002215,
                39.3440049993671,
                0
              ],
              [
                -76.6580770002621,
                39.3437479988658,
                0
              ],
              [
                -76.657761998763,
                39.3434929987378,
                0
              ],
              [
                -76.6575490004685,
                39.3433039996567,
                0
              ],
              [
                -76.6573759991526,
                39.3431319993869,
                0
              ],
              [
                -76.6573040000278,
                39.3430149990865,
                0
              ],
              [
                -76.6572400005271,
                39.3428929986107,
                0
              ],
              [
                -76.6571950008428,
                39.3427439978497,
                0
              ],
              [
                -76.6571710005092,
                39.3425929992,
                0
              ],
              [
                -76.6571749996498,
                39.3424129989636,
                0
              ],
              [
                -76.6571930003987,
                39.3423029994398,
                0
              ],
              [
                -76.6572300006647,
                39.3421889992547,
                0
              ],
              [
                -76.6572679995258,
                39.3421109993052,
                0
              ],
              [
                -76.6574209998971,
                39.3418589990684,
                0
              ],
              [
                -76.6576829998069,
                39.3415559988398,
                0
              ],
              [
                -76.6578389993445,
                39.3413859988123,
                0
              ],
              [
                -76.6579590005154,
                39.3412369991845,
                0
              ],
              [
                -76.6580559994619,
                39.3411009987256,
                0
              ],
              [
                -76.6581089997752,
                39.3410129988135,
                0
              ],
              [
                -76.6581809998602,
                39.340866000411,
                0
              ],
              [
                -76.6584099997995,
                39.3408319990593,
                0
              ],
              [
                -76.6586999987038,
                39.3407999992731,
                0
              ],
              [
                -76.6612790002939,
                39.3406979987686,
                0
              ],
              [
                -76.6620059996433,
                39.3406729994506,
                0
              ],
              [
                -76.6620699994723,
                39.3406769980853,
                0
              ],
              [
                -76.6621280000638,
                39.3406789987068,
                0
              ],
              [
                -76.6621670000877,
                39.3406799989189,
                0
              ],
              [
                -76.6622630012068,
                39.3406890002624,
                0
              ],
              [
                -76.6624349996238,
                39.3407149979322,
                0
              ],
              [
                -76.6625819996608,
                39.3407459992992,
                0
              ],
              [
                -76.6628000005688,
                39.3408089986243,
                0
              ],
              [
                -76.6630020008814,
                39.3408819985798,
                0
              ],
              [
                -76.6631829996372,
                39.340935998969,
                0
              ],
              [
                -76.6633179997736,
                39.3409609994019,
                0
              ],
              [
                -76.663440999546,
                39.3409670001552,
                0
              ],
              [
                -76.6636270005531,
                39.340967999074,
                0
              ],
              [
                -76.6638259985601,
                39.3409539987406,
                0
              ],
              [
                -76.6639519998782,
                39.3409309990735,
                0
              ],
              [
                -76.6641009999382,
                39.3408889989314,
                0
              ],
              [
                -76.6642320000572,
                39.3408479992622,
                0
              ],
              [
                -76.6644470002864,
                39.3407539989408,
                0
              ],
              [
                -76.664549999594,
                39.340704998748,
                0
              ],
              [
                -76.6647210004435,
                39.3406109993742,
                0
              ],
              [
                -76.6649010001195,
                39.3405029981091,
                0
              ],
              [
                -76.6650020005516,
                39.3404349987253,
                0
              ],
              [
                -76.6651400000658,
                39.3403359992409,
                0
              ],
              [
                -76.6652370000512,
                39.340215999093,
                0
              ],
              [
                -76.6653420007629,
                39.340130998444,
                0
              ],
              [
                -76.6654979998,
                39.3400469994255,
                0
              ],
              [
                -76.6658839997575,
                39.3398829987346,
                0
              ],
              [
                -76.6663700002193,
                39.3396749991078,
                0
              ],
              [
                -76.6664729997112,
                39.3396319988832,
                0
              ],
              [
                -76.6668219996522,
                39.3394559993981,
                0
              ],
              [
                -76.6670310002434,
                39.3393539994333,
                0
              ],
              [
                -76.6671340004127,
                39.3393039998441,
                0
              ],
              [
                -76.6679260004847,
                39.338920998406,
                0
              ],
              [
                -76.6680720005475,
                39.3391130000105,
                0
              ],
              [
                -76.6681919997728,
                39.3392699989644,
                0
              ],
              [
                -76.6682700002017,
                39.3393439990764,
                0
              ],
              [
                -76.66832399965,
                39.3393919989879,
                0
              ],
              [
                -76.6684059995766,
                39.3394449986228,
                0
              ],
              [
                -76.6685270000518,
                39.3395039999405,
                0
              ],
              [
                -76.6686819998492,
                39.3395559990894,
                0
              ],
              [
                -76.6688579988807,
                39.3396089993629,
                0
              ],
              [
                -76.6692499994838,
                39.339717999452,
                0
              ],
              [
                -76.669411999655,
                39.3397669989325,
                0
              ],
              [
                -76.6707300001433,
                39.3401349993378,
                0
              ],
              [
                -76.6713500008815,
                39.3403089988336,
                0
              ],
              [
                -76.671486000328,
                39.3403479992522,
                0
              ],
              [
                -76.6725620000966,
                39.3406649986542,
                0
              ],
              [
                -76.6738480009793,
                39.3410260003007,
                0
              ],
              [
                -76.6735530002005,
                39.3417849994295,
                0
              ],
              [
                -76.6735029996447,
                39.3419039992411,
                0
              ],
              [
                -76.6729950004879,
                39.3431429993918,
                0
              ],
              [
                -76.6725489998718,
                39.3442609989585,
                0
              ],
              [
                -76.6723860010024,
                39.3446429994217,
                0
              ],
              [
                -76.6723250011157,
                39.3446779989331,
                0
              ],
              [
                -76.6721139997045,
                39.3447939992247,
                0
              ],
              [
                -76.6718900003434,
                39.3449169985643,
                0
              ],
              [
                -76.6713970004263,
                39.3451949987826,
                0
              ],
              [
                -76.6713140012382,
                39.3452409992001,
                0
              ],
              [
                -76.6707230005634,
                39.3455699991414,
                0
              ],
              [
                -76.6705480004201,
                39.3456679988037,
                0
              ],
              [
                -76.6699229996683,
                39.3460129992951,
                0
              ],
              [
                -76.6692820006705,
                39.3463719994238,
                0
              ],
              [
                -76.6690870008394,
                39.3464849992525,
                0
              ],
              [
                -76.6689190005442,
                39.3465909985554,
                0
              ],
              [
                -76.6687840003221,
                39.3466069992255,
                0
              ],
              [
                -76.6684990005206,
                39.3466170004118,
                0
              ],
              [
                -76.6682819995696,
                39.346621999096,
                0
              ],
              [
                -76.6655509998878,
                39.3466779987495,
                0
              ],
              [
                -76.6643670009354,
                39.3467019992523,
                0
              ],
              [
                -76.663450000531,
                39.3466989987302,
                0
              ],
              [
                -76.6633399994232,
                39.3466989990638,
                0
              ],
              [
                -76.6618940009746,
                39.3467189986038,
                0
              ],
              [
                -76.6614289991906,
                39.3466899986686,
                0
              ],
              [
                -76.6610070004598,
                39.3466499994188,
                0
              ],
              [
                -76.660580000041,
                39.3466089988008,
                0
              ],
              [
                -76.6604179990827,
                39.346593999328,
                0
              ],
              [
                -76.6594470002422,
                39.3465059976618,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 33,
          "Census_Tract": "24510271700",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "7681b8df-c333-41da-be55-bc6b129d8230",
          "Shape__Area": 18665047.066223145,
          "Shape__Length": 18590.365198197687
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6604080001719,
                39.3551929987354,
                0
              ],
              [
                -76.6603519996101,
                39.3550529988562,
                0
              ],
              [
                -76.6603140005647,
                39.3548799991792,
                0
              ],
              [
                -76.6602189994046,
                39.354422998835,
                0
              ],
              [
                -76.6599349996169,
                39.3530609991281,
                0
              ],
              [
                -76.6598860000622,
                39.3528249983795,
                0
              ],
              [
                -76.6597119998802,
                39.3518149991937,
                0
              ],
              [
                -76.6596040003202,
                39.3509339983519,
                0
              ],
              [
                -76.6595120005265,
                39.3503949992965,
                0
              ],
              [
                -76.6594860005308,
                39.3502450000423,
                0
              ],
              [
                -76.6594279996303,
                39.3499579989316,
                0
              ],
              [
                -76.659334999919,
                39.3494899976555,
                0
              ],
              [
                -76.6592839992708,
                39.3490570000849,
                0
              ],
              [
                -76.6591809997549,
                39.348232998913,
                0
              ],
              [
                -76.6591619997673,
                39.3481339990881,
                0
              ],
              [
                -76.6591330002485,
                39.3478869999034,
                0
              ],
              [
                -76.6591559994601,
                39.3476389993953,
                0
              ],
              [
                -76.6592650001898,
                39.3472049988774,
                0
              ],
              [
                -76.6594470002422,
                39.3465059976618,
                0
              ],
              [
                -76.6604179990827,
                39.346593999328,
                0
              ],
              [
                -76.660580000041,
                39.3466089988008,
                0
              ],
              [
                -76.6610070004598,
                39.3466499994188,
                0
              ],
              [
                -76.6614289991906,
                39.3466899986686,
                0
              ],
              [
                -76.6618940009746,
                39.3467189986038,
                0
              ],
              [
                -76.6633399994232,
                39.3466989990638,
                0
              ],
              [
                -76.663450000531,
                39.3466989987302,
                0
              ],
              [
                -76.6643670009354,
                39.3467019992523,
                0
              ],
              [
                -76.6655509998878,
                39.3466779987495,
                0
              ],
              [
                -76.6682819995696,
                39.346621999096,
                0
              ],
              [
                -76.6684990005206,
                39.3466170004118,
                0
              ],
              [
                -76.6687840003221,
                39.3466069992255,
                0
              ],
              [
                -76.6689190005442,
                39.3465909985554,
                0
              ],
              [
                -76.6690870008394,
                39.3464849992525,
                0
              ],
              [
                -76.6692820006705,
                39.3463719994238,
                0
              ],
              [
                -76.6699229996683,
                39.3460129992951,
                0
              ],
              [
                -76.6705480004201,
                39.3456679988037,
                0
              ],
              [
                -76.6707230005634,
                39.3455699991414,
                0
              ],
              [
                -76.6713140012382,
                39.3452409992001,
                0
              ],
              [
                -76.6713970004263,
                39.3451949987826,
                0
              ],
              [
                -76.6717969994925,
                39.3456359991761,
                0
              ],
              [
                -76.6726689996464,
                39.346574998749,
                0
              ],
              [
                -76.6729570000993,
                39.3468849989125,
                0
              ],
              [
                -76.6731070002176,
                39.3470429991059,
                0
              ],
              [
                -76.6734030002226,
                39.3473269988229,
                0
              ],
              [
                -76.6734530000689,
                39.3473799986516,
                0
              ],
              [
                -76.6734750002096,
                39.3474129989889,
                0
              ],
              [
                -76.6734830000331,
                39.3474399993312,
                0
              ],
              [
                -76.6734840005529,
                39.3474549985644,
                0
              ],
              [
                -76.6734889999821,
                39.3474709988181,
                0
              ],
              [
                -76.673565999643,
                39.3475389997689,
                0
              ],
              [
                -76.6736590000487,
                39.3476179990038,
                0
              ],
              [
                -76.6738040004789,
                39.3477349988247,
                0
              ],
              [
                -76.6739050006383,
                39.3478209990011,
                0
              ],
              [
                -76.6740440011632,
                39.3479229989345,
                0
              ],
              [
                -76.6742519995664,
                39.3480709989099,
                0
              ],
              [
                -76.6745220005475,
                39.3482519985978,
                0
              ],
              [
                -76.6747329995371,
                39.3483719992444,
                0
              ],
              [
                -76.6752399996448,
                39.3486729991315,
                0
              ],
              [
                -76.6755089998649,
                39.3488209986755,
                0
              ],
              [
                -76.6756899994758,
                39.3489129989948,
                0
              ],
              [
                -76.6758259996795,
                39.3489759989993,
                0
              ],
              [
                -76.6759600004651,
                39.3490279988832,
                0
              ],
              [
                -76.6762049996095,
                39.3491329986205,
                0
              ],
              [
                -76.6763719994308,
                39.3491959986822,
                0
              ],
              [
                -76.6764930001921,
                39.3492429990847,
                0
              ],
              [
                -76.6768280000619,
                39.3493549988676,
                0
              ],
              [
                -76.678857000122,
                39.3499199987074,
                0
              ],
              [
                -76.6794419996624,
                39.3500799993952,
                0
              ],
              [
                -76.6796719994428,
                39.3501429989398,
                0
              ],
              [
                -76.6798370000648,
                39.350187998998,
                0
              ],
              [
                -76.6804590002335,
                39.3503579989924,
                0
              ],
              [
                -76.6808480005328,
                39.3504619994011,
                0
              ],
              [
                -76.681210999423,
                39.3505659991813,
                0
              ],
              [
                -76.681322000393,
                39.3506039987893,
                0
              ],
              [
                -76.6814420000944,
                39.3506529991004,
                0
              ],
              [
                -76.6815290004424,
                39.3506939987054,
                0
              ],
              [
                -76.6817030001619,
                39.3507829991756,
                0
              ],
              [
                -76.6825800000708,
                39.3512859980869,
                0
              ],
              [
                -76.683179999471,
                39.3516509993727,
                0
              ],
              [
                -76.6833579998676,
                39.3517569988023,
                0
              ],
              [
                -76.6831840003336,
                39.3518719987265,
                0
              ],
              [
                -76.6831110003824,
                39.3519099988111,
                0
              ],
              [
                -76.6829419990696,
                39.3519959989947,
                0
              ],
              [
                -76.6828999994822,
                39.3520169990921,
                0
              ],
              [
                -76.682264999859,
                39.3523459989366,
                0
              ],
              [
                -76.6814049997793,
                39.3528249977858,
                0
              ],
              [
                -76.6812719997954,
                39.3528959993919,
                0
              ],
              [
                -76.6807950002599,
                39.3531489988239,
                0
              ],
              [
                -76.68066599956,
                39.3532209987093,
                0
              ],
              [
                -76.6805019999519,
                39.353310000308,
                0
              ],
              [
                -76.6797560000399,
                39.3537019996919,
                0
              ],
              [
                -76.6794149998312,
                39.3538849988966,
                0
              ],
              [
                -76.6791740003818,
                39.3539999993088,
                0
              ],
              [
                -76.6788709995178,
                39.3541359991053,
                0
              ],
              [
                -76.6779669994505,
                39.354504999152,
                0
              ],
              [
                -76.6773480004946,
                39.3547559994459,
                0
              ],
              [
                -76.676896000277,
                39.354949999077,
                0
              ],
              [
                -76.6762769997212,
                39.3552209991438,
                0
              ],
              [
                -76.6759070002606,
                39.3553659988601,
                0
              ],
              [
                -76.6754670002588,
                39.3555539992069,
                0
              ],
              [
                -76.6751850002475,
                39.3556769993196,
                0
              ],
              [
                -76.6748730001246,
                39.3558009993987,
                0
              ],
              [
                -76.6740980003272,
                39.3561109990167,
                0
              ],
              [
                -76.6730089997501,
                39.3565529987597,
                0
              ],
              [
                -76.6725810004246,
                39.3567489985971,
                0
              ],
              [
                -76.6721139997597,
                39.3566819992171,
                0
              ],
              [
                -76.6717539999418,
                39.3566329989472,
                0
              ],
              [
                -76.6707739997843,
                39.3564819993224,
                0
              ],
              [
                -76.6708170004639,
                39.3566329989866,
                0
              ],
              [
                -76.6708479996111,
                39.3567879994461,
                0
              ],
              [
                -76.668138000497,
                39.3572459991313,
                0
              ],
              [
                -76.6678410006145,
                39.3572959992087,
                0
              ],
              [
                -76.6675489999426,
                39.3573450002389,
                0
              ],
              [
                -76.6659639998714,
                39.3576129992914,
                0
              ],
              [
                -76.6658280002181,
                39.3574679991681,
                0
              ],
              [
                -76.6656340003288,
                39.3572659991097,
                0
              ],
              [
                -76.6653319995749,
                39.3569659989727,
                0
              ],
              [
                -76.6649099996149,
                39.3565199993063,
                0
              ],
              [
                -76.6647170004266,
                39.3563179987093,
                0
              ],
              [
                -76.6645180001918,
                39.3561179992167,
                0
              ],
              [
                -76.6642829999786,
                39.3558929992431,
                0
              ],
              [
                -76.6641300005123,
                39.3557689988158,
                0
              ],
              [
                -76.663971000576,
                39.3556589992532,
                0
              ],
              [
                -76.6637300000638,
                39.355516998599,
                0
              ],
              [
                -76.6634889997219,
                39.3554039985727,
                0
              ],
              [
                -76.6631959997099,
                39.3553009995577,
                0
              ],
              [
                -76.6630109996135,
                39.3552379986842,
                0
              ],
              [
                -76.6627849997125,
                39.3551739990226,
                0
              ],
              [
                -76.6622079996961,
                39.35503299928,
                0
              ],
              [
                -76.6619750002443,
                39.3550239987673,
                0
              ],
              [
                -76.6616750000665,
                39.3550229999714,
                0
              ],
              [
                -76.6613740004623,
                39.3550339989961,
                0
              ],
              [
                -76.6611769999137,
                39.3550470002652,
                0
              ],
              [
                -76.6610009997562,
                39.3550659994296,
                0
              ],
              [
                -76.6607760002318,
                39.3551040004188,
                0
              ],
              [
                -76.6605070002358,
                39.3551629990129,
                0
              ],
              [
                -76.6604080001719,
                39.3551929987354,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 34,
          "Census_Tract": "24510160700",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "4f95ed0d-1d69-42e6-bceb-df8100e3f104",
          "Shape__Area": 10420197.524169922,
          "Shape__Length": 16033.809095814435
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6608980010421,
                39.3061439994399,
                0
              ],
              [
                -76.6608179996539,
                39.3048199994266,
                0
              ],
              [
                -76.660797999909,
                39.3045320002252,
                0
              ],
              [
                -76.6607779996219,
                39.3042169990738,
                0
              ],
              [
                -76.6607589994315,
                39.3037629990178,
                0
              ],
              [
                -76.6608010015341,
                39.3036689986165,
                0
              ],
              [
                -76.6608270002117,
                39.3035769994194,
                0
              ],
              [
                -76.6608370008099,
                39.3032659985627,
                0
              ],
              [
                -76.6608290004346,
                39.3030779987421,
                0
              ],
              [
                -76.6607990003581,
                39.3029579991462,
                0
              ],
              [
                -76.6607660004872,
                39.3028659989513,
                0
              ],
              [
                -76.6607440005357,
                39.3027919987648,
                0
              ],
              [
                -76.6607209999116,
                39.3026239991979,
                0
              ],
              [
                -76.6607410001857,
                39.3025129992587,
                0
              ],
              [
                -76.6608480003591,
                39.3021299990403,
                0
              ],
              [
                -76.6608739997882,
                39.3019559986469,
                0
              ],
              [
                -76.6608849985794,
                39.30177099906,
                0
              ],
              [
                -76.6608679994478,
                39.3015419987278,
                0
              ],
              [
                -76.6608239986558,
                39.3004509992368,
                0
              ],
              [
                -76.6613299999111,
                39.3004269989792,
                0
              ],
              [
                -76.6617459999436,
                39.3004069989493,
                0
              ],
              [
                -76.6635059996092,
                39.3003609995795,
                0
              ],
              [
                -76.6652709997025,
                39.300282998668,
                0
              ],
              [
                -76.6651870001847,
                39.2992099990253,
                0
              ],
              [
                -76.6669600002306,
                39.2991519986803,
                0
              ],
              [
                -76.6670430000137,
                39.2992159993156,
                0
              ],
              [
                -76.6671309997028,
                39.2992659991984,
                0
              ],
              [
                -76.6672289997832,
                39.2993159994148,
                0
              ],
              [
                -76.6673810001834,
                39.2993599993721,
                0
              ],
              [
                -76.6674850003559,
                39.2993809994168,
                0
              ],
              [
                -76.6676410014313,
                39.2994099992657,
                0
              ],
              [
                -76.667783001403,
                39.2994169988972,
                0
              ],
              [
                -76.6678930005544,
                39.299401998829,
                0
              ],
              [
                -76.6680130003703,
                39.2993769988037,
                0
              ],
              [
                -76.6681510005358,
                39.2993589988274,
                0
              ],
              [
                -76.6682630005392,
                39.2993429988209,
                0
              ],
              [
                -76.6683730001712,
                39.299339999072,
                0
              ],
              [
                -76.6684739997575,
                39.2993439988183,
                0
              ],
              [
                -76.6686019996826,
                39.2993529990683,
                0
              ],
              [
                -76.6687170005763,
                39.299350999431,
                0
              ],
              [
                -76.6687839998585,
                39.2993509991641,
                0
              ],
              [
                -76.6688769995272,
                39.2993389993097,
                0
              ],
              [
                -76.6689419997635,
                39.2993129984131,
                0
              ],
              [
                -76.6689829996871,
                39.2992899987404,
                0
              ],
              [
                -76.6689490013437,
                39.2991819987327,
                0
              ],
              [
                -76.6689440002452,
                39.2990989989244,
                0
              ],
              [
                -76.6689600004569,
                39.2990039989706,
                0
              ],
              [
                -76.668981999545,
                39.2988089987,
                0
              ],
              [
                -76.6689840004196,
                39.2982639993324,
                0
              ],
              [
                -76.6689540010492,
                39.2971889994026,
                0
              ],
              [
                -76.669025000111,
                39.2971499976231,
                0
              ],
              [
                -76.6691130000821,
                39.2970639989869,
                0
              ],
              [
                -76.6692770002465,
                39.2968709999302,
                0
              ],
              [
                -76.6693009999297,
                39.2968119985921,
                0
              ],
              [
                -76.6692450002024,
                39.2966229991996,
                0
              ],
              [
                -76.669175999353,
                39.2965279994225,
                0
              ],
              [
                -76.6691029999102,
                39.2964079986557,
                0
              ],
              [
                -76.6690799994651,
                39.2962629985663,
                0
              ],
              [
                -76.6690720002777,
                39.2961489988195,
                0
              ],
              [
                -76.6691210005764,
                39.296047998992,
                0
              ],
              [
                -76.6693509995893,
                39.2956699990951,
                0
              ],
              [
                -76.6695049984663,
                39.2950089986814,
                0
              ],
              [
                -76.6696120001891,
                39.2946839994292,
                0
              ],
              [
                -76.6696789985565,
                39.2944489993041,
                0
              ],
              [
                -76.669717000533,
                39.2942759995819,
                0
              ],
              [
                -76.6698710014896,
                39.294268999376,
                0
              ],
              [
                -76.6699460005316,
                39.2942659988992,
                0
              ],
              [
                -76.6701700005527,
                39.2942659992496,
                0
              ],
              [
                -76.6704650002819,
                39.2942569989126,
                0
              ],
              [
                -76.6704869997323,
                39.2943159989431,
                0
              ],
              [
                -76.6705349995919,
                39.2945419992448,
                0
              ],
              [
                -76.6705650002309,
                39.2947630002835,
                0
              ],
              [
                -76.6705910009715,
                39.2950839992995,
                0
              ],
              [
                -76.6705900011257,
                39.295498999396,
                0
              ],
              [
                -76.6705400000102,
                39.2959719986641,
                0
              ],
              [
                -76.6704550003677,
                39.2963879989054,
                0
              ],
              [
                -76.6706680011323,
                39.2963620004312,
                0
              ],
              [
                -76.670726000546,
                39.2963539994409,
                0
              ],
              [
                -76.6708210002884,
                39.2963519993474,
                0
              ],
              [
                -76.6709489997707,
                39.296345998568,
                0
              ],
              [
                -76.6710770003754,
                39.296362000427,
                0
              ],
              [
                -76.6711839997715,
                39.2964019989699,
                0
              ],
              [
                -76.6712850000709,
                39.2964459989039,
                0
              ],
              [
                -76.6714449995923,
                39.2965559991305,
                0
              ],
              [
                -76.6715119999523,
                39.2965969988421,
                0
              ],
              [
                -76.6716759999948,
                39.2967469990039,
                0
              ],
              [
                -76.6717409999591,
                39.2968099993657,
                0
              ],
              [
                -76.6718279999634,
                39.2969039994147,
                0
              ],
              [
                -76.6719030002858,
                39.2969789986648,
                0
              ],
              [
                -76.6719570002906,
                39.297045000128,
                0
              ],
              [
                -76.6720130000742,
                39.2971039992651,
                0
              ],
              [
                -76.6721259999622,
                39.297193999344,
                0
              ],
              [
                -76.672404000088,
                39.2973609994375,
                0
              ],
              [
                -76.6725949997209,
                39.2974929989823,
                0
              ],
              [
                -76.6727500002799,
                39.2976089987024,
                0
              ],
              [
                -76.6728350005755,
                39.2977059991299,
                0
              ],
              [
                -76.6728829996749,
                39.2977909992961,
                0
              ],
              [
                -76.6729190003865,
                39.2978829991402,
                0
              ],
              [
                -76.6729549998465,
                39.2979679991936,
                0
              ],
              [
                -76.6730009994329,
                39.2981369991235,
                0
              ],
              [
                -76.6730480007924,
                39.2983029986943,
                0
              ],
              [
                -76.6731239998497,
                39.298543999269,
                0
              ],
              [
                -76.6731600001385,
                39.2986769987093,
                0
              ],
              [
                -76.6732330003796,
                39.2990560001015,
                0
              ],
              [
                -76.6732830009569,
                39.2991869991082,
                0
              ],
              [
                -76.6733169998231,
                39.2993229987284,
                0
              ],
              [
                -76.6733930001675,
                39.2995419999045,
                0
              ],
              [
                -76.6734180005308,
                39.2996359992664,
                0
              ],
              [
                -76.6734540011563,
                39.2997459986844,
                0
              ],
              [
                -76.6734900012433,
                39.2998369993553,
                0
              ],
              [
                -76.6735210005057,
                39.299939998589,
                0
              ],
              [
                -76.6735460001886,
                39.3000389989027,
                0
              ],
              [
                -76.6735560007828,
                39.3001119986713,
                0
              ],
              [
                -76.6735649996304,
                39.3001489996747,
                0
              ],
              [
                -76.673564000034,
                39.3002079990654,
                0
              ],
              [
                -76.6736040002765,
                39.3004969985826,
                0
              ],
              [
                -76.6736229996166,
                39.3006629992721,
                0
              ],
              [
                -76.6736169994523,
                39.3007439992168,
                0
              ],
              [
                -76.6735999999986,
                39.3008079992802,
                0
              ],
              [
                -76.6735680005251,
                39.3008599992435,
                0
              ],
              [
                -76.6735119996153,
                39.3009599985948,
                0
              ],
              [
                -76.6734860005278,
                39.3010389991237,
                0
              ],
              [
                -76.6734870001062,
                39.3011139987595,
                0
              ],
              [
                -76.6734859996668,
                39.3012189987837,
                0
              ],
              [
                -76.6734980001726,
                39.3012899990081,
                0
              ],
              [
                -76.6735259994369,
                39.3013859990985,
                0
              ],
              [
                -76.673519000074,
                39.3014429992346,
                0
              ],
              [
                -76.6736150001784,
                39.3016379992309,
                0
              ],
              [
                -76.6736809998511,
                39.3017309990228,
                0
              ],
              [
                -76.6738459999057,
                39.3019220001094,
                0
              ],
              [
                -76.6739689995576,
                39.3020579987322,
                0
              ],
              [
                -76.6740459992005,
                39.3021289990704,
                0
              ],
              [
                -76.6741450000426,
                39.3022760002936,
                0
              ],
              [
                -76.6742099994908,
                39.3023729990456,
                0
              ],
              [
                -76.674066999617,
                39.3025359993379,
                0
              ],
              [
                -76.673976000278,
                39.3026389985671,
                0
              ],
              [
                -76.6738529999053,
                39.3027779994312,
                0
              ],
              [
                -76.6737619999793,
                39.3028819992255,
                0
              ],
              [
                -76.6736949995984,
                39.3029739999922,
                0
              ],
              [
                -76.6736549988332,
                39.3030389981324,
                0
              ],
              [
                -76.6736059999114,
                39.303132999875,
                0
              ],
              [
                -76.6735629984824,
                39.3032639987278,
                0
              ],
              [
                -76.6735319997025,
                39.3034539987909,
                0
              ],
              [
                -76.6735279994357,
                39.3036109990574,
                0
              ],
              [
                -76.6735339999291,
                39.3037309988982,
                0
              ],
              [
                -76.673549999852,
                39.3038079992888,
                0
              ],
              [
                -76.6735950002527,
                39.3039669993282,
                0
              ],
              [
                -76.6736369995496,
                39.3041039990945,
                0
              ],
              [
                -76.6736819995983,
                39.3042429996413,
                0
              ],
              [
                -76.6737879994519,
                39.3045679986882,
                0
              ],
              [
                -76.6738659999084,
                39.3048169989497,
                0
              ],
              [
                -76.6740089992259,
                39.3052489991848,
                0
              ],
              [
                -76.6740830003734,
                39.3054779986243,
                0
              ],
              [
                -76.674142000324,
                39.305681999218,
                0
              ],
              [
                -76.6741730000871,
                39.3058759994284,
                0
              ],
              [
                -76.6741729995706,
                39.3059439991191,
                0
              ],
              [
                -76.6741629990258,
                39.3060659991798,
                0
              ],
              [
                -76.6741489997862,
                39.306165998951,
                0
              ],
              [
                -76.6741229993262,
                39.3062679993366,
                0
              ],
              [
                -76.6739540003218,
                39.3063719990209,
                0
              ],
              [
                -76.6737199998469,
                39.3065169986342,
                0
              ],
              [
                -76.6736120005525,
                39.3065739992311,
                0
              ],
              [
                -76.6733030000276,
                39.3067420002763,
                0
              ],
              [
                -76.6722909992221,
                39.3072049996993,
                0
              ],
              [
                -76.6721920005059,
                39.3070179991938,
                0
              ],
              [
                -76.6708299994622,
                39.3070569991184,
                0
              ],
              [
                -76.6692050012912,
                39.3070959989159,
                0
              ],
              [
                -76.6684050014106,
                39.3071169988443,
                0
              ],
              [
                -76.6677900001711,
                39.3065299979929,
                0
              ],
              [
                -76.6676039995123,
                39.3063299991761,
                0
              ],
              [
                -76.6675189995916,
                39.3062310000573,
                0
              ],
              [
                -76.6674089998483,
                39.3060739990349,
                0
              ],
              [
                -76.6673239996393,
                39.3059039987431,
                0
              ],
              [
                -76.666483999668,
                39.3059249984152,
                0
              ],
              [
                -76.6655949996012,
                39.3059599989849,
                0
              ],
              [
                -76.6645389998322,
                39.3060289988473,
                0
              ],
              [
                -76.6638250000986,
                39.3060429989207,
                0
              ],
              [
                -76.6630830001739,
                39.3060749997139,
                0
              ],
              [
                -76.6620909991222,
                39.3061059988253,
                0
              ],
              [
                -76.6608980010421,
                39.3061439994399,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 35,
          "Census_Tract": "24510160801",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "5b9d3449-180d-49ed-8e81-0ae47226d134",
          "Shape__Area": 4194517.617431641,
          "Shape__Length": 9186.994240517255
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6812109997702,
                39.2938839992397,
                0
              ],
              [
                -76.6816310005191,
                39.2938749992312,
                0
              ],
              [
                -76.6826160000297,
                39.2938349991091,
                0
              ],
              [
                -76.6838919994595,
                39.2937979989396,
                0
              ],
              [
                -76.6840570004672,
                39.2937930004127,
                0
              ],
              [
                -76.6849749995663,
                39.2937509988052,
                0
              ],
              [
                -76.6859950004472,
                39.2937109993555,
                0
              ],
              [
                -76.6859919996291,
                39.2937239991599,
                0
              ],
              [
                -76.6859990005263,
                39.294105998063,
                0
              ],
              [
                -76.6860089996217,
                39.2946989989872,
                0
              ],
              [
                -76.6860259998856,
                39.2955080000026,
                0
              ],
              [
                -76.6861009995656,
                39.2962499999421,
                0
              ],
              [
                -76.6861400002801,
                39.2969959992382,
                0
              ],
              [
                -76.6861930014049,
                39.2977419988157,
                0
              ],
              [
                -76.6862350005479,
                39.2984709985901,
                0
              ],
              [
                -76.6862749997365,
                39.2992169991019,
                0
              ],
              [
                -76.6862919985776,
                39.30018399856,
                0
              ],
              [
                -76.6863409995287,
                39.3004189993744,
                0
              ],
              [
                -76.6863789995032,
                39.3005180000719,
                0
              ],
              [
                -76.6865210008944,
                39.3007529985778,
                0
              ],
              [
                -76.6866399995252,
                39.3009139989124,
                0
              ],
              [
                -76.6875009997437,
                39.3018939987689,
                0
              ],
              [
                -76.6875500005115,
                39.3019909988954,
                0
              ],
              [
                -76.6875719996571,
                39.3020919986126,
                0
              ],
              [
                -76.6875670005429,
                39.3021969988455,
                0
              ],
              [
                -76.6875370013326,
                39.3023289993559,
                0
              ],
              [
                -76.6874829984978,
                39.3024159991916,
                0
              ],
              [
                -76.6873660002556,
                39.3025339992955,
                0
              ],
              [
                -76.6869910004235,
                39.3027059988443,
                0
              ],
              [
                -76.6864429997625,
                39.302933999417,
                0
              ],
              [
                -76.6862580000346,
                39.303001998918,
                0
              ],
              [
                -76.6861469995853,
                39.3030319993374,
                0
              ],
              [
                -76.686045000447,
                39.3030399993677,
                0
              ],
              [
                -76.6859539999898,
                39.3030409992225,
                0
              ],
              [
                -76.6858679995319,
                39.3030289991814,
                0
              ],
              [
                -76.6857910003351,
                39.3030049989828,
                0
              ],
              [
                -76.6848979996192,
                39.3024919989061,
                0
              ],
              [
                -76.6839289996328,
                39.3019539987536,
                0
              ],
              [
                -76.683747999614,
                39.3018519994041,
                0
              ],
              [
                -76.6824740001642,
                39.3011389985646,
                0
              ],
              [
                -76.6812439986199,
                39.300449999186,
                0
              ],
              [
                -76.6815050004337,
                39.3001629986583,
                0
              ],
              [
                -76.6815309999386,
                39.3001339990689,
                0
              ],
              [
                -76.6815459996471,
                39.3000809987698,
                0
              ],
              [
                -76.6815469994547,
                39.3000369986994,
                0
              ],
              [
                -76.6815339997912,
                39.2998079987516,
                0
              ],
              [
                -76.6815269998783,
                39.2996589993977,
                0
              ],
              [
                -76.681514999085,
                39.2994889988869,
                0
              ],
              [
                -76.6815070002993,
                39.29939000043,
                0
              ],
              [
                -76.6815030003861,
                39.2993249992026,
                0
              ],
              [
                -76.6814920005474,
                39.2991099987544,
                0
              ],
              [
                -76.6814649997619,
                39.2986399988241,
                0
              ],
              [
                -76.6814289994605,
                39.2979059990097,
                0
              ],
              [
                -76.6813810003256,
                39.2971569986231,
                0
              ],
              [
                -76.6813409986955,
                39.2964069982798,
                0
              ],
              [
                -76.6813030005135,
                39.2956689985562,
                0
              ],
              [
                -76.6812789998936,
                39.2951329988075,
                0
              ],
              [
                -76.6812109997702,
                39.2938839992397,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 36,
          "Census_Tract": "24510160802",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "c4f6689b-6f7a-4e8e-9cad-b7b0ed8c0cca",
          "Shape__Area": 13202263.0647583,
          "Shape__Length": 20355.76105640163
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6742099994908,
                39.3023729990456,
                0
              ],
              [
                -76.6741450000426,
                39.3022760002936,
                0
              ],
              [
                -76.6740459992005,
                39.3021289990704,
                0
              ],
              [
                -76.6739689995576,
                39.3020579987322,
                0
              ],
              [
                -76.6738459999057,
                39.3019220001094,
                0
              ],
              [
                -76.6736809998511,
                39.3017309990228,
                0
              ],
              [
                -76.6736150001784,
                39.3016379992309,
                0
              ],
              [
                -76.673519000074,
                39.3014429992346,
                0
              ],
              [
                -76.6735259994369,
                39.3013859990985,
                0
              ],
              [
                -76.6734980001726,
                39.3012899990081,
                0
              ],
              [
                -76.6734859996668,
                39.3012189987837,
                0
              ],
              [
                -76.6734870001062,
                39.3011139987595,
                0
              ],
              [
                -76.6734860005278,
                39.3010389991237,
                0
              ],
              [
                -76.6735119996153,
                39.3009599985948,
                0
              ],
              [
                -76.6735680005251,
                39.3008599992435,
                0
              ],
              [
                -76.6735999999986,
                39.3008079992802,
                0
              ],
              [
                -76.6736169994523,
                39.3007439992168,
                0
              ],
              [
                -76.6736229996166,
                39.3006629992721,
                0
              ],
              [
                -76.6736040002765,
                39.3004969985826,
                0
              ],
              [
                -76.673564000034,
                39.3002079990654,
                0
              ],
              [
                -76.6735649996304,
                39.3001489996747,
                0
              ],
              [
                -76.6735560007828,
                39.3001119986713,
                0
              ],
              [
                -76.6735460001886,
                39.3000389989027,
                0
              ],
              [
                -76.6735210005057,
                39.299939998589,
                0
              ],
              [
                -76.6734900012433,
                39.2998369993553,
                0
              ],
              [
                -76.6734540011563,
                39.2997459986844,
                0
              ],
              [
                -76.6734180005308,
                39.2996359992664,
                0
              ],
              [
                -76.6733930001675,
                39.2995419999045,
                0
              ],
              [
                -76.6733169998231,
                39.2993229987284,
                0
              ],
              [
                -76.6732830009569,
                39.2991869991082,
                0
              ],
              [
                -76.6732330003796,
                39.2990560001015,
                0
              ],
              [
                -76.6731600001385,
                39.2986769987093,
                0
              ],
              [
                -76.6731239998497,
                39.298543999269,
                0
              ],
              [
                -76.6730480007924,
                39.2983029986943,
                0
              ],
              [
                -76.6730009994329,
                39.2981369991235,
                0
              ],
              [
                -76.6729549998465,
                39.2979679991936,
                0
              ],
              [
                -76.6729190003865,
                39.2978829991402,
                0
              ],
              [
                -76.6728829996749,
                39.2977909992961,
                0
              ],
              [
                -76.6728350005755,
                39.2977059991299,
                0
              ],
              [
                -76.6727500002799,
                39.2976089987024,
                0
              ],
              [
                -76.6725949997209,
                39.2974929989823,
                0
              ],
              [
                -76.672404000088,
                39.2973609994375,
                0
              ],
              [
                -76.6721259999622,
                39.297193999344,
                0
              ],
              [
                -76.6720130000742,
                39.2971039992651,
                0
              ],
              [
                -76.6719570002906,
                39.297045000128,
                0
              ],
              [
                -76.6719030002858,
                39.2969789986648,
                0
              ],
              [
                -76.6718279999634,
                39.2969039994147,
                0
              ],
              [
                -76.6717409999591,
                39.2968099993657,
                0
              ],
              [
                -76.6716759999948,
                39.2967469990039,
                0
              ],
              [
                -76.6715119999523,
                39.2965969988421,
                0
              ],
              [
                -76.6714449995923,
                39.2965559991305,
                0
              ],
              [
                -76.6712850000709,
                39.2964459989039,
                0
              ],
              [
                -76.6711839997715,
                39.2964019989699,
                0
              ],
              [
                -76.6710770003754,
                39.296362000427,
                0
              ],
              [
                -76.6709489997707,
                39.296345998568,
                0
              ],
              [
                -76.6708210002884,
                39.2963519993474,
                0
              ],
              [
                -76.670726000546,
                39.2963539994409,
                0
              ],
              [
                -76.6706680011323,
                39.2963620004312,
                0
              ],
              [
                -76.6704550003677,
                39.2963879989054,
                0
              ],
              [
                -76.6705400000102,
                39.2959719986641,
                0
              ],
              [
                -76.6705900011257,
                39.295498999396,
                0
              ],
              [
                -76.6705910009715,
                39.2950839992995,
                0
              ],
              [
                -76.6705650002309,
                39.2947630002835,
                0
              ],
              [
                -76.6705349995919,
                39.2945419992448,
                0
              ],
              [
                -76.6704869997323,
                39.2943159989431,
                0
              ],
              [
                -76.6704650002819,
                39.2942569989126,
                0
              ],
              [
                -76.6706179994981,
                39.2942559993635,
                0
              ],
              [
                -76.6712629996643,
                39.2942319992436,
                0
              ],
              [
                -76.6716339996558,
                39.2942279988313,
                0
              ],
              [
                -76.6718859995475,
                39.2942169993599,
                0
              ],
              [
                -76.6721669999179,
                39.2942069990479,
                0
              ],
              [
                -76.6722870002455,
                39.2942049981775,
                0
              ],
              [
                -76.6723829997514,
                39.2942009999364,
                0
              ],
              [
                -76.6725939996541,
                39.2941889991632,
                0
              ],
              [
                -76.6727800005528,
                39.2941739991249,
                0
              ],
              [
                -76.674167999139,
                39.2941329991192,
                0
              ],
              [
                -76.6755740003829,
                39.2940969992066,
                0
              ],
              [
                -76.6764439997226,
                39.2940619990175,
                0
              ],
              [
                -76.6772469987553,
                39.2940339990844,
                0
              ],
              [
                -76.6784020000596,
                39.2939769985855,
                0
              ],
              [
                -76.6796659994739,
                39.2939399988438,
                0
              ],
              [
                -76.6797659995991,
                39.2939339985938,
                0
              ],
              [
                -76.6797940005184,
                39.2939319986703,
                0
              ],
              [
                -76.6806570004792,
                39.2939029985976,
                0
              ],
              [
                -76.6807769984367,
                39.2938979994395,
                0
              ],
              [
                -76.6812109997702,
                39.2938839992397,
                0
              ],
              [
                -76.6812789998936,
                39.2951329988075,
                0
              ],
              [
                -76.6813030005135,
                39.2956689985562,
                0
              ],
              [
                -76.6813409986955,
                39.2964069982798,
                0
              ],
              [
                -76.6813810003256,
                39.2971569986231,
                0
              ],
              [
                -76.6814289994605,
                39.2979059990097,
                0
              ],
              [
                -76.6814649997619,
                39.2986399988241,
                0
              ],
              [
                -76.6814920005474,
                39.2991099987544,
                0
              ],
              [
                -76.6815030003861,
                39.2993249992026,
                0
              ],
              [
                -76.6815070002993,
                39.29939000043,
                0
              ],
              [
                -76.681514999085,
                39.2994889988869,
                0
              ],
              [
                -76.6815269998783,
                39.2996589993977,
                0
              ],
              [
                -76.6815339997912,
                39.2998079987516,
                0
              ],
              [
                -76.6815469994547,
                39.3000369986994,
                0
              ],
              [
                -76.6815459996471,
                39.3000809987698,
                0
              ],
              [
                -76.6815309999386,
                39.3001339990689,
                0
              ],
              [
                -76.6815050004337,
                39.3001629986583,
                0
              ],
              [
                -76.6812439986199,
                39.300449999186,
                0
              ],
              [
                -76.6824740001642,
                39.3011389985646,
                0
              ],
              [
                -76.683747999614,
                39.3018519994041,
                0
              ],
              [
                -76.6839289996328,
                39.3019539987536,
                0
              ],
              [
                -76.6848979996192,
                39.3024919989061,
                0
              ],
              [
                -76.6857910003351,
                39.3030049989828,
                0
              ],
              [
                -76.6858679995319,
                39.3030289991814,
                0
              ],
              [
                -76.6859539999898,
                39.3030409992225,
                0
              ],
              [
                -76.686045000447,
                39.3030399993677,
                0
              ],
              [
                -76.6861469995853,
                39.3030319993374,
                0
              ],
              [
                -76.6862580000346,
                39.303001998918,
                0
              ],
              [
                -76.6864429997625,
                39.302933999417,
                0
              ],
              [
                -76.6869910004235,
                39.3027059988443,
                0
              ],
              [
                -76.6873660002556,
                39.3025339992955,
                0
              ],
              [
                -76.6874829984978,
                39.3024159991916,
                0
              ],
              [
                -76.6875370013326,
                39.3023289993559,
                0
              ],
              [
                -76.6875670005429,
                39.3021969988455,
                0
              ],
              [
                -76.6875719996571,
                39.3020919986126,
                0
              ],
              [
                -76.6875500005115,
                39.3019909988954,
                0
              ],
              [
                -76.6875009997437,
                39.3018939987689,
                0
              ],
              [
                -76.6866399995252,
                39.3009139989124,
                0
              ],
              [
                -76.6865210008944,
                39.3007529985778,
                0
              ],
              [
                -76.6863789995032,
                39.3005180000719,
                0
              ],
              [
                -76.6863409995287,
                39.3004189993744,
                0
              ],
              [
                -76.6862919985776,
                39.30018399856,
                0
              ],
              [
                -76.6862749997365,
                39.2992169991019,
                0
              ],
              [
                -76.6867559996265,
                39.2992130004361,
                0
              ],
              [
                -76.6871509994318,
                39.2992099985692,
                0
              ],
              [
                -76.6875910005122,
                39.2991929993082,
                0
              ],
              [
                -76.688138999775,
                39.2991719993165,
                0
              ],
              [
                -76.6900920010517,
                39.3023059988643,
                0
              ],
              [
                -76.6894999999551,
                39.3043719991725,
                0
              ],
              [
                -76.6894820013003,
                39.3044339991138,
                0
              ],
              [
                -76.6895820002095,
                39.3050989986276,
                0
              ],
              [
                -76.6890210002188,
                39.3051469990296,
                0
              ],
              [
                -76.6887490000769,
                39.3051659990423,
                0
              ],
              [
                -76.6885970003067,
                39.3051529992803,
                0
              ],
              [
                -76.6885070000145,
                39.3051159991846,
                0
              ],
              [
                -76.6884269996757,
                39.3050929989226,
                0
              ],
              [
                -76.6883809984772,
                39.3050769993566,
                0
              ],
              [
                -76.6883429999678,
                39.3050769985616,
                0
              ],
              [
                -76.688224000416,
                39.3051249992848,
                0
              ],
              [
                -76.6881229995751,
                39.3051639986927,
                0
              ],
              [
                -76.6879329995423,
                39.3051969986618,
                0
              ],
              [
                -76.6878110002258,
                39.3052159993526,
                0
              ],
              [
                -76.6876889998763,
                39.3052159994231,
                0
              ],
              [
                -76.6875500002161,
                39.3051959988759,
                0
              ],
              [
                -76.6874190008925,
                39.3051170002844,
                0
              ],
              [
                -76.6872770001675,
                39.3049919987121,
                0
              ],
              [
                -76.6871990002781,
                39.3049329989203,
                0
              ],
              [
                -76.6871359994299,
                39.3048929989723,
                0
              ],
              [
                -76.6870809998177,
                39.3048739988462,
                0
              ],
              [
                -76.6870100001239,
                39.3048639987401,
                0
              ],
              [
                -76.6869380005508,
                39.304856999039,
                0
              ],
              [
                -76.6868619987089,
                39.3048759987852,
                0
              ],
              [
                -76.6866379995277,
                39.3050689987623,
                0
              ],
              [
                -76.686430998501,
                39.305347998957,
                0
              ],
              [
                -76.686301999967,
                39.3055059989703,
                0
              ],
              [
                -76.6861190003832,
                39.3056069990514,
                0
              ],
              [
                -76.68593600092,
                39.3056999992564,
                0
              ],
              [
                -76.6857649992568,
                39.3057789993266,
                0
              ],
              [
                -76.6855529995317,
                39.3058669978582,
                0
              ],
              [
                -76.6853539996116,
                39.3059189988866,
                0
              ],
              [
                -76.6850570004628,
                39.3059489990773,
                0
              ],
              [
                -76.6849549999634,
                39.3059839991411,
                0
              ],
              [
                -76.6848749998719,
                39.3060329990767,
                0
              ],
              [
                -76.684761000061,
                39.3060550004488,
                0
              ],
              [
                -76.6844259995279,
                39.3060769992858,
                0
              ],
              [
                -76.6840659998795,
                39.3061279990638,
                0
              ],
              [
                -76.6836250004213,
                39.306182998808,
                0
              ],
              [
                -76.6833240000823,
                39.3062169976043,
                0
              ],
              [
                -76.6830759992909,
                39.3062509989709,
                0
              ],
              [
                -76.6828969997681,
                39.3062799986062,
                0
              ],
              [
                -76.6826570002022,
                39.3063449993854,
                0
              ],
              [
                -76.682439000316,
                39.3064309980399,
                0
              ],
              [
                -76.6822120006394,
                39.3065039993028,
                0
              ],
              [
                -76.6819949997893,
                39.3065639986932,
                0
              ],
              [
                -76.6817910003912,
                39.3065849987535,
                0
              ],
              [
                -76.6815649996428,
                39.3065840000948,
                0
              ],
              [
                -76.6814030003066,
                39.3065709990676,
                0
              ],
              [
                -76.6812919996544,
                39.3065399985844,
                0
              ],
              [
                -76.6811469997606,
                39.3064919986052,
                0
              ],
              [
                -76.6807180001038,
                39.3063049993181,
                0
              ],
              [
                -76.6801890005528,
                39.3060609986769,
                0
              ],
              [
                -76.6798269998591,
                39.3058929987724,
                0
              ],
              [
                -76.6797830003754,
                39.3058699988374,
                0
              ],
              [
                -76.6797359994742,
                39.3058399999578,
                0
              ],
              [
                -76.6797019997146,
                39.3058139989133,
                0
              ],
              [
                -76.6796439994714,
                39.3057650001451,
                0
              ],
              [
                -76.6795809999759,
                39.3057069990962,
                0
              ],
              [
                -76.6795239996277,
                39.3056409985687,
                0
              ],
              [
                -76.6794919996316,
                39.3055919976706,
                0
              ],
              [
                -76.6794639996853,
                39.3055529988328,
                0
              ],
              [
                -76.6794269993368,
                39.3055149977886,
                0
              ],
              [
                -76.6794029999262,
                39.3054899994528,
                0
              ],
              [
                -76.6793110003831,
                39.3054219991266,
                0
              ],
              [
                -76.6791429999878,
                39.3052909987868,
                0
              ],
              [
                -76.679026999688,
                39.305168999168,
                0
              ],
              [
                -76.6789730002677,
                39.3050769990964,
                0
              ],
              [
                -76.6789119997566,
                39.304988999029,
                0
              ],
              [
                -76.678830000027,
                39.3049099986107,
                0
              ],
              [
                -76.6787409996814,
                39.3048389993043,
                0
              ],
              [
                -76.6786720004263,
                39.3047679987794,
                0
              ],
              [
                -76.6786070003218,
                39.3047319998325,
                0
              ],
              [
                -76.6785089999434,
                39.3047049991693,
                0
              ],
              [
                -76.6784469994306,
                39.3046919991798,
                0
              ],
              [
                -76.6783290000576,
                39.3046709994034,
                0
              ],
              [
                -76.6782560013476,
                39.3046449992497,
                0
              ],
              [
                -76.6778819996875,
                39.3044749994458,
                0
              ],
              [
                -76.677838999942,
                39.3044639986506,
                0
              ],
              [
                -76.677790999025,
                39.3044579986226,
                0
              ],
              [
                -76.677734999972,
                39.3044579990797,
                0
              ],
              [
                -76.6776729990776,
                39.3044619986071,
                0
              ],
              [
                -76.6776340001247,
                39.3044600000368,
                0
              ],
              [
                -76.677557999709,
                39.3044539987569,
                0
              ],
              [
                -76.6775050004468,
                39.304432999053,
                0
              ],
              [
                -76.6774529994497,
                39.3043989996824,
                0
              ],
              [
                -76.6773470005647,
                39.3043639990116,
                0
              ],
              [
                -76.6772020000749,
                39.3042939986009,
                0
              ],
              [
                -76.677096999674,
                39.3042450000267,
                0
              ],
              [
                -76.6768660006762,
                39.3041509991432,
                0
              ],
              [
                -76.676635001281,
                39.3040589992755,
                0
              ],
              [
                -76.6764259988311,
                39.3039869986188,
                0
              ],
              [
                -76.6763469995613,
                39.3039639991723,
                0
              ],
              [
                -76.6762870005407,
                39.3039419987119,
                0
              ],
              [
                -76.6762099995084,
                39.3039099989384,
                0
              ],
              [
                -76.6761279995574,
                39.3038659990004,
                0
              ],
              [
                -76.6758649997094,
                39.3037439989551,
                0
              ],
              [
                -76.6757780012477,
                39.3036879986449,
                0
              ],
              [
                -76.6756989999964,
                39.3036439985708,
                0
              ],
              [
                -76.6756249985624,
                39.3036069993957,
                0
              ],
              [
                -76.6755340002313,
                39.3035639992539,
                0
              ],
              [
                -76.6754409995081,
                39.3035169986648,
                0
              ],
              [
                -76.6753809995036,
                39.3034679994274,
                0
              ],
              [
                -76.6752959999129,
                39.303420999208,
                0
              ],
              [
                -76.6752199989813,
                39.3033639993053,
                0
              ],
              [
                -76.6751190004762,
                39.3032819991602,
                0
              ],
              [
                -76.674880000788,
                39.3030409988212,
                0
              ],
              [
                -76.6748380000554,
                39.3029759985572,
                0
              ],
              [
                -76.6748099984818,
                39.302947998578,
                0
              ],
              [
                -76.6747879999678,
                39.3029159987431,
                0
              ],
              [
                -76.6744700008617,
                39.3026050001076,
                0
              ],
              [
                -76.6743940000712,
                39.3025179991223,
                0
              ],
              [
                -76.6742099994908,
                39.3023729990456,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 37,
          "Census_Tract": "24510080102",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "bf66c11e-e1d0-42d1-b983-5ee735829e5e",
          "Shape__Area": 3935490.5639648438,
          "Shape__Length": 9122.048157357642
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.5717290001641,
                39.3202589983616,
                0
              ],
              [
                -76.5718349998033,
                39.3201409975952,
                0
              ],
              [
                -76.572212999695,
                39.3192379990633,
                0
              ],
              [
                -76.5724450001854,
                39.3186409992388,
                0
              ],
              [
                -76.5725960013004,
                39.3182869998775,
                0
              ],
              [
                -76.5726780005255,
                39.3181019993707,
                0
              ],
              [
                -76.5727350000633,
                39.3179579976281,
                0
              ],
              [
                -76.5728389996245,
                39.3176979990874,
                0
              ],
              [
                -76.572874999486,
                39.3176029994439,
                0
              ],
              [
                -76.5729019999675,
                39.3175159991105,
                0
              ],
              [
                -76.572913000127,
                39.3174849999851,
                0
              ],
              [
                -76.5729280013198,
                39.3174059988738,
                0
              ],
              [
                -76.5729410000399,
                39.3173259987513,
                0
              ],
              [
                -76.5729689995606,
                39.3170749989251,
                0
              ],
              [
                -76.573010000176,
                39.3165759991639,
                0
              ],
              [
                -76.5730150001442,
                39.3165199993882,
                0
              ],
              [
                -76.5730709999965,
                39.3158519994231,
                0
              ],
              [
                -76.573087999749,
                39.3156219993353,
                0
              ],
              [
                -76.573104000623,
                39.3153779987668,
                0
              ],
              [
                -76.573124999847,
                39.3150629998928,
                0
              ],
              [
                -76.5731369998857,
                39.3144739990568,
                0
              ],
              [
                -76.5731449999828,
                39.3143159986869,
                0
              ],
              [
                -76.5735920004103,
                39.3142889999527,
                0
              ],
              [
                -76.5740140003794,
                39.3142779990923,
                0
              ],
              [
                -76.5749310003198,
                39.3142739990729,
                0
              ],
              [
                -76.5758299999788,
                39.3142899975592,
                0
              ],
              [
                -76.5777510004659,
                39.3142689993245,
                0
              ],
              [
                -76.5809850003304,
                39.3142369989553,
                0
              ],
              [
                -76.5816769994802,
                39.3142309980739,
                0
              ],
              [
                -76.5820379985515,
                39.3142339993906,
                0
              ],
              [
                -76.5821639995578,
                39.3142429992244,
                0
              ],
              [
                -76.5818129995756,
                39.3145529994022,
                0
              ],
              [
                -76.5817470002766,
                39.3146109992351,
                0
              ],
              [
                -76.5809400004736,
                39.3153119994118,
                0
              ],
              [
                -76.580371999863,
                39.3157939985929,
                0
              ],
              [
                -76.5802860002828,
                39.3158679992418,
                0
              ],
              [
                -76.5802510002696,
                39.3158969992387,
                0
              ],
              [
                -76.5796300013125,
                39.3164579989146,
                0
              ],
              [
                -76.5795870004928,
                39.3164969990926,
                0
              ],
              [
                -76.578871001324,
                39.3171079988745,
                0
              ],
              [
                -76.5784489996097,
                39.3174959991291,
                0
              ],
              [
                -76.5776739994832,
                39.3181729987978,
                0
              ],
              [
                -76.577626000538,
                39.3182139988744,
                0
              ],
              [
                -76.5774399998275,
                39.318375999245,
                0
              ],
              [
                -76.5769360005303,
                39.3188139981272,
                0
              ],
              [
                -76.5758860003963,
                39.3197269992358,
                0
              ],
              [
                -76.5753010002175,
                39.3202320002783,
                0
              ],
              [
                -76.575279000078,
                39.3202509996404,
                0
              ],
              [
                -76.5747560010909,
                39.3207159988101,
                0
              ],
              [
                -76.5745909996728,
                39.320864998837,
                0
              ],
              [
                -76.5743369990431,
                39.3210889991374,
                0
              ],
              [
                -76.5737450006833,
                39.3216119991401,
                0
              ],
              [
                -76.5737339999794,
                39.3215789988748,
                0
              ],
              [
                -76.5737090005063,
                39.3215469990135,
                0
              ],
              [
                -76.573653000483,
                39.32150899937,
                0
              ],
              [
                -76.5732129996331,
                39.3212469990952,
                0
              ],
              [
                -76.5727700010612,
                39.3209479985979,
                0
              ],
              [
                -76.5721280011415,
                39.3205299977085,
                0
              ],
              [
                -76.5717700002178,
                39.3202969992362,
                0
              ],
              [
                -76.5717290001641,
                39.3202589983616,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 38,
          "Census_Tract": "24510080200",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "b769f980-1a19-44e0-a027-bae02aa579c6",
          "Shape__Area": 9216364.348327637,
          "Shape__Length": 14554.339481015786
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.5818129995756,
                39.3145529994022,
                0
              ],
              [
                -76.5821639995578,
                39.3142429992244,
                0
              ],
              [
                -76.5820379985515,
                39.3142339993906,
                0
              ],
              [
                -76.5816769994802,
                39.3142309980739,
                0
              ],
              [
                -76.5809850003304,
                39.3142369989553,
                0
              ],
              [
                -76.5777510004659,
                39.3142689993245,
                0
              ],
              [
                -76.5758299999788,
                39.3142899975592,
                0
              ],
              [
                -76.5749310003198,
                39.3142739990729,
                0
              ],
              [
                -76.5740140003794,
                39.3142779990923,
                0
              ],
              [
                -76.5735920004103,
                39.3142889999527,
                0
              ],
              [
                -76.5731449999828,
                39.3143159986869,
                0
              ],
              [
                -76.5731419998902,
                39.3132289992002,
                0
              ],
              [
                -76.5731169996984,
                39.3124519992783,
                0
              ],
              [
                -76.5730909997658,
                39.3116419990333,
                0
              ],
              [
                -76.573093999892,
                39.3103619991472,
                0
              ],
              [
                -76.5730760002909,
                39.30992199884,
                0
              ],
              [
                -76.5730660002061,
                39.3097319992341,
                0
              ],
              [
                -76.5730459998483,
                39.3093379986219,
                0
              ],
              [
                -76.5735739997456,
                39.3093209990546,
                0
              ],
              [
                -76.5739960007185,
                39.309307998673,
                0
              ],
              [
                -76.5748880000464,
                39.3092709994322,
                0
              ],
              [
                -76.5758749994499,
                39.3092409992414,
                0
              ],
              [
                -76.5768210003557,
                39.3091939989755,
                0
              ],
              [
                -76.5777329995442,
                39.3091749986471,
                0
              ],
              [
                -76.5786779997982,
                39.3091369991182,
                0
              ],
              [
                -76.5795219999265,
                39.3090909994223,
                0
              ],
              [
                -76.5801030001919,
                39.3090599993729,
                0
              ],
              [
                -76.5810410010128,
                39.309023998754,
                0
              ],
              [
                -76.5815230011374,
                39.3090059986974,
                0
              ],
              [
                -76.5823150003006,
                39.3089789996816,
                0
              ],
              [
                -76.5829080010762,
                39.3089779992944,
                0
              ],
              [
                -76.5836419995293,
                39.3089559990308,
                0
              ],
              [
                -76.584365000159,
                39.3089289993229,
                0
              ],
              [
                -76.585074999777,
                39.3089089985816,
                0
              ],
              [
                -76.585379999782,
                39.3088999992834,
                0
              ],
              [
                -76.5854470014274,
                39.3088989989354,
                0
              ],
              [
                -76.5857639997469,
                39.3088869991142,
                0
              ],
              [
                -76.5861899995443,
                39.3088679988404,
                0
              ],
              [
                -76.5865469996145,
                39.3088539993725,
                0
              ],
              [
                -76.5872959999358,
                39.3088489993239,
                0
              ],
              [
                -76.5873940000806,
                39.3088499983204,
                0
              ],
              [
                -76.5885070003156,
                39.3086789985591,
                0
              ],
              [
                -76.5884829996931,
                39.308804998769,
                0
              ],
              [
                -76.5885240003997,
                39.309445998823,
                0
              ],
              [
                -76.5885509995419,
                39.3098679993671,
                0
              ],
              [
                -76.5885830008453,
                39.3103549987886,
                0
              ],
              [
                -76.588617000212,
                39.3109029988918,
                0
              ],
              [
                -76.5886919984559,
                39.3124189986441,
                0
              ],
              [
                -76.588744999402,
                39.3133089986831,
                0
              ],
              [
                -76.5887729998156,
                39.3136409987449,
                0
              ],
              [
                -76.588811999845,
                39.3143429988501,
                0
              ],
              [
                -76.5892519986184,
                39.314342999064,
                0
              ],
              [
                -76.5905699994885,
                39.3143039991095,
                0
              ],
              [
                -76.590612999582,
                39.3150029993236,
                0
              ],
              [
                -76.5906189998169,
                39.3150729989371,
                0
              ],
              [
                -76.5905999994866,
                39.3152359990194,
                0
              ],
              [
                -76.5905669994619,
                39.3153529992355,
                0
              ],
              [
                -76.5905239995467,
                39.3154409990393,
                0
              ],
              [
                -76.5904430004216,
                39.3155529994138,
                0
              ],
              [
                -76.5903109997492,
                39.3157079995994,
                0
              ],
              [
                -76.590156000196,
                39.3158559989322,
                0
              ],
              [
                -76.5898809999757,
                39.316122998632,
                0
              ],
              [
                -76.5892439995184,
                39.3159719990628,
                0
              ],
              [
                -76.5890659995028,
                39.3159349989254,
                0
              ],
              [
                -76.5887600004464,
                39.315864999222,
                0
              ],
              [
                -76.5883360000318,
                39.3157549990777,
                0
              ],
              [
                -76.5880239994727,
                39.3156679990074,
                0
              ],
              [
                -76.5876050004822,
                39.3155499988308,
                0
              ],
              [
                -76.5871920002458,
                39.3154319993072,
                0
              ],
              [
                -76.5869719996617,
                39.3153709991652,
                0
              ],
              [
                -76.5866679998976,
                39.3152899991973,
                0
              ],
              [
                -76.586507000167,
                39.3152499986964,
                0
              ],
              [
                -76.5861799998936,
                39.3151719989121,
                0
              ],
              [
                -76.5858590001655,
                39.3150899992917,
                0
              ],
              [
                -76.5855720002779,
                39.3150269994128,
                0
              ],
              [
                -76.5850620000133,
                39.3149259987897,
                0
              ],
              [
                -76.5848160005615,
                39.3148839987904,
                0
              ],
              [
                -76.5845729985962,
                39.3148469990521,
                0
              ],
              [
                -76.5843889999859,
                39.314820999436,
                0
              ],
              [
                -76.5837559995443,
                39.3147419985717,
                0
              ],
              [
                -76.583329999829,
                39.3146849988334,
                0
              ],
              [
                -76.5830569994393,
                39.3146549992459,
                0
              ],
              [
                -76.5827869997401,
                39.3146309987955,
                0
              ],
              [
                -76.5823850013418,
                39.3145839981431,
                0
              ],
              [
                -76.5821859994707,
                39.3145689994213,
                0
              ],
              [
                -76.5820490004207,
                39.3145609990709,
                0
              ],
              [
                -76.5819489994297,
                39.314556998923,
                0
              ],
              [
                -76.5818730003981,
                39.3145529994198,
                0
              ],
              [
                -76.5818129995756,
                39.3145529994022,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 39,
          "Census_Tract": "24510080302",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "447df68e-7a0a-47c0-8804-8fbb7b15451a",
          "Shape__Area": 4730875.875244141,
          "Shape__Length": 8767.94818675076
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.5727929984757,
                39.3027209992984,
                0
              ],
              [
                -76.5762049995343,
                39.3026089992892,
                0
              ],
              [
                -76.5765379994731,
                39.3025989989575,
                0
              ],
              [
                -76.576880001185,
                39.3025929988405,
                0
              ],
              [
                -76.5782779999231,
                39.3025489992493,
                0
              ],
              [
                -76.5797039998385,
                39.3024819985599,
                0
              ],
              [
                -76.579748001147,
                39.3031349994201,
                0
              ],
              [
                -76.5797689999192,
                39.3035149989899,
                0
              ],
              [
                -76.5797849999031,
                39.3038109993644,
                0
              ],
              [
                -76.5798519989674,
                39.3048890002217,
                0
              ],
              [
                -76.5798809995138,
                39.3054099994401,
                0
              ],
              [
                -76.5799009999021,
                39.3056549986279,
                0
              ],
              [
                -76.5799209998859,
                39.3059410002696,
                0
              ],
              [
                -76.5799459996064,
                39.3062909987469,
                0
              ],
              [
                -76.5799569999041,
                39.306469997826,
                0
              ],
              [
                -76.5799859994462,
                39.3070009987671,
                0
              ],
              [
                -76.580010000512,
                39.3075359991247,
                0
              ],
              [
                -76.5800439996764,
                39.3080549989476,
                0
              ],
              [
                -76.5801030001919,
                39.3090599993729,
                0
              ],
              [
                -76.5795219999265,
                39.3090909994223,
                0
              ],
              [
                -76.5786779997982,
                39.3091369991182,
                0
              ],
              [
                -76.5777329995442,
                39.3091749986471,
                0
              ],
              [
                -76.5768210003557,
                39.3091939989755,
                0
              ],
              [
                -76.5758749994499,
                39.3092409992414,
                0
              ],
              [
                -76.5748880000464,
                39.3092709994322,
                0
              ],
              [
                -76.5739960007185,
                39.309307998673,
                0
              ],
              [
                -76.5735739997456,
                39.3093209990546,
                0
              ],
              [
                -76.5730459998483,
                39.3093379986219,
                0
              ],
              [
                -76.5730420007017,
                39.3088599992646,
                0
              ],
              [
                -76.5730349999308,
                39.308323999092,
                0
              ],
              [
                -76.5730160000705,
                39.3072789994379,
                0
              ],
              [
                -76.5729860012922,
                39.3061869993778,
                0
              ],
              [
                -76.5729789997448,
                39.3051499990327,
                0
              ],
              [
                -76.5729679988907,
                39.3048459991719,
                0
              ],
              [
                -76.5728989997405,
                39.3041099992414,
                0
              ],
              [
                -76.5728440004941,
                39.3035279986176,
                0
              ],
              [
                -76.5727929984757,
                39.3027209992984,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 40,
          "Census_Tract": "24510080400",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "74f5d3de-33e9-4e09-b294-f3a76de699a5",
          "Shape__Area": 2701375.9591674805,
          "Shape__Length": 6865.023394193897
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.5839009997292,
                39.3023129989498,
                0
              ],
              [
                -76.5847839996658,
                39.3022879991608,
                0
              ],
              [
                -76.5851030003532,
                39.3022869993299,
                0
              ],
              [
                -76.5852239999977,
                39.302293000422,
                0
              ],
              [
                -76.5853579997924,
                39.3022969989429,
                0
              ],
              [
                -76.5855209996985,
                39.3023089992627,
                0
              ],
              [
                -76.5856510004117,
                39.302322998872,
                0
              ],
              [
                -76.5857990001453,
                39.3023429986852,
                0
              ],
              [
                -76.5859980001272,
                39.3023769992537,
                0
              ],
              [
                -76.5861919997435,
                39.3024159990965,
                0
              ],
              [
                -76.5863479988845,
                39.302452999373,
                0
              ],
              [
                -76.5865190003134,
                39.3024949991995,
                0
              ],
              [
                -76.5869169994783,
                39.3026129986255,
                0
              ],
              [
                -76.5871110005627,
                39.3026859978606,
                0
              ],
              [
                -76.5873130003615,
                39.3027689989591,
                0
              ],
              [
                -76.5874829994946,
                39.3028499993736,
                0
              ],
              [
                -76.5876850010067,
                39.3029540001005,
                0
              ],
              [
                -76.5878880000916,
                39.303064999259,
                0
              ],
              [
                -76.5881350003318,
                39.303217998809,
                0
              ],
              [
                -76.5881469995744,
                39.3034889987072,
                0
              ],
              [
                -76.5882220002451,
                39.3045509989204,
                0
              ],
              [
                -76.58823700033,
                39.3048529988698,
                0
              ],
              [
                -76.5882499998093,
                39.3051059986907,
                0
              ],
              [
                -76.5882860000078,
                39.3056399991187,
                0
              ],
              [
                -76.5883179984785,
                39.3061619990541,
                0
              ],
              [
                -76.588339000109,
                39.306684998944,
                0
              ],
              [
                -76.5883800002526,
                39.307206998703,
                0
              ],
              [
                -76.5884120012602,
                39.3077319987887,
                0
              ],
              [
                -76.5885070003156,
                39.3086789985591,
                0
              ],
              [
                -76.5873940000806,
                39.3088499983204,
                0
              ],
              [
                -76.5872959999358,
                39.3088489993239,
                0
              ],
              [
                -76.5865469996145,
                39.3088539993725,
                0
              ],
              [
                -76.5861899995443,
                39.3088679988404,
                0
              ],
              [
                -76.5857639997469,
                39.3088869991142,
                0
              ],
              [
                -76.5854470014274,
                39.3088989989354,
                0
              ],
              [
                -76.585379999782,
                39.3088999992834,
                0
              ],
              [
                -76.585074999777,
                39.3089089985816,
                0
              ],
              [
                -76.584365000159,
                39.3089289993229,
                0
              ],
              [
                -76.5842979999483,
                39.3078969988526,
                0
              ],
              [
                -76.5842770013468,
                39.3073699989796,
                0
              ],
              [
                -76.5842449995411,
                39.3068489987614,
                0
              ],
              [
                -76.5841750002382,
                39.3057799991494,
                0
              ],
              [
                -76.5841600015192,
                39.3055929992999,
                0
              ],
              [
                -76.5841300000677,
                39.3052479994333,
                0
              ],
              [
                -76.5841119999012,
                39.3049909991676,
                0
              ],
              [
                -76.5840930000331,
                39.304722998892,
                0
              ],
              [
                -76.5840230004095,
                39.3036549992261,
                0
              ],
              [
                -76.5839009997292,
                39.3023129989498,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 41,
          "Census_Tract": "24510080500",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "9d68e3a6-1c17-453d-a00b-3c48d7b4f2ba",
          "Shape__Area": 3749713.484375,
          "Shape__Length": 8763.385312559985
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.5898809999757,
                39.316122998632,
                0
              ],
              [
                -76.590156000196,
                39.3158559989322,
                0
              ],
              [
                -76.5903109997492,
                39.3157079995994,
                0
              ],
              [
                -76.5904430004216,
                39.3155529994138,
                0
              ],
              [
                -76.5905239995467,
                39.3154409990393,
                0
              ],
              [
                -76.5905669994619,
                39.3153529992355,
                0
              ],
              [
                -76.5905999994866,
                39.3152359990194,
                0
              ],
              [
                -76.5906189998169,
                39.3150729989371,
                0
              ],
              [
                -76.590612999582,
                39.3150029993236,
                0
              ],
              [
                -76.5905699994885,
                39.3143039991095,
                0
              ],
              [
                -76.5892519986184,
                39.314342999064,
                0
              ],
              [
                -76.588811999845,
                39.3143429988501,
                0
              ],
              [
                -76.5887729998156,
                39.3136409987449,
                0
              ],
              [
                -76.588744999402,
                39.3133089986831,
                0
              ],
              [
                -76.5886919984559,
                39.3124189986441,
                0
              ],
              [
                -76.5890769988967,
                39.3123969997611,
                0
              ],
              [
                -76.5892650012012,
                39.312386999277,
                0
              ],
              [
                -76.5894740002979,
                39.312376999784,
                0
              ],
              [
                -76.5904330005419,
                39.3123339985848,
                0
              ],
              [
                -76.5910979994845,
                39.3123129992382,
                0
              ],
              [
                -76.5917479994564,
                39.3122919989694,
                0
              ],
              [
                -76.5924100011065,
                39.3122429980286,
                0
              ],
              [
                -76.5930959996873,
                39.3122169988708,
                0
              ],
              [
                -76.5942010014925,
                39.3121929991178,
                0
              ],
              [
                -76.5950110002689,
                39.3121669989644,
                0
              ],
              [
                -76.5952329997547,
                39.3121579996452,
                0
              ],
              [
                -76.5969269995288,
                39.3120839991499,
                0
              ],
              [
                -76.5970749998911,
                39.312076998904,
                0
              ],
              [
                -76.597751001462,
                39.3120359992841,
                0
              ],
              [
                -76.5984769995095,
                39.3119919986615,
                0
              ],
              [
                -76.5993700000952,
                39.3119419992204,
                0
              ],
              [
                -76.5990570001699,
                39.3129609986752,
                0
              ],
              [
                -76.5989680003562,
                39.3131059993209,
                0
              ],
              [
                -76.5988719997086,
                39.3132489988414,
                0
              ],
              [
                -76.5987270001398,
                39.3134379991499,
                0
              ],
              [
                -76.5985250000526,
                39.3136559989064,
                0
              ],
              [
                -76.5982559994233,
                39.3139439992969,
                0
              ],
              [
                -76.5980329994699,
                39.3141829986396,
                0
              ],
              [
                -76.59794100053,
                39.3142619989459,
                0
              ],
              [
                -76.5971460010668,
                39.3150409986436,
                0
              ],
              [
                -76.5969270004608,
                39.3152409987824,
                0
              ],
              [
                -76.5964350000768,
                39.3157129988167,
                0
              ],
              [
                -76.5963269998674,
                39.3158159993224,
                0
              ],
              [
                -76.5958839994671,
                39.316239999282,
                0
              ],
              [
                -76.5954630003179,
                39.3166719990025,
                0
              ],
              [
                -76.5951760015609,
                39.3169569991518,
                0
              ],
              [
                -76.5948670011206,
                39.3172379990568,
                0
              ],
              [
                -76.5920440005506,
                39.3165789989622,
                0
              ],
              [
                -76.5909579997672,
                39.3163469991399,
                0
              ],
              [
                -76.5898809999757,
                39.316122998632,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 42,
          "Census_Tract": "24510080600",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "9b2ec32c-3f6f-446d-a768-9bc79f565006",
          "Shape__Area": 3620942.117126465,
          "Shape__Length": 8167.163857526915
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.5884829996931,
                39.308804998769,
                0
              ],
              [
                -76.5891760000754,
                39.3088019992679,
                0
              ],
              [
                -76.5893460000967,
                39.3087939993697,
                0
              ],
              [
                -76.5902279999518,
                39.3087529989532,
                0
              ],
              [
                -76.5908879998814,
                39.3087099996015,
                0
              ],
              [
                -76.5915330006104,
                39.3086819987453,
                0
              ],
              [
                -76.5921929999422,
                39.3086579989208,
                0
              ],
              [
                -76.5928459994614,
                39.3086409988365,
                0
              ],
              [
                -76.5939559993569,
                39.3086109991186,
                0
              ],
              [
                -76.5947820000984,
                39.3085749999088,
                0
              ],
              [
                -76.5950270003318,
                39.3085649994144,
                0
              ],
              [
                -76.5959560009327,
                39.3085339992871,
                0
              ],
              [
                -76.5968599993747,
                39.3084959999486,
                0
              ],
              [
                -76.5975400004445,
                39.3084619988964,
                0
              ],
              [
                -76.5982780005799,
                39.3084249990255,
                0
              ],
              [
                -76.5983180000042,
                39.3094769987185,
                0
              ],
              [
                -76.5983799994745,
                39.3105259989708,
                0
              ],
              [
                -76.5984500001223,
                39.3115049987895,
                0
              ],
              [
                -76.5984769995095,
                39.3119919986615,
                0
              ],
              [
                -76.597751001462,
                39.3120359992841,
                0
              ],
              [
                -76.5970749998911,
                39.312076998904,
                0
              ],
              [
                -76.5969269995288,
                39.3120839991499,
                0
              ],
              [
                -76.5952329997547,
                39.3121579996452,
                0
              ],
              [
                -76.5950110002689,
                39.3121669989644,
                0
              ],
              [
                -76.5942010014925,
                39.3121929991178,
                0
              ],
              [
                -76.5930959996873,
                39.3122169988708,
                0
              ],
              [
                -76.5924100011065,
                39.3122429980286,
                0
              ],
              [
                -76.5917479994564,
                39.3122919989694,
                0
              ],
              [
                -76.5910979994845,
                39.3123129992382,
                0
              ],
              [
                -76.5904330005419,
                39.3123339985848,
                0
              ],
              [
                -76.5894740002979,
                39.312376999784,
                0
              ],
              [
                -76.5892650012012,
                39.312386999277,
                0
              ],
              [
                -76.5890769988967,
                39.3123969997611,
                0
              ],
              [
                -76.5886919984559,
                39.3124189986441,
                0
              ],
              [
                -76.588617000212,
                39.3109029988918,
                0
              ],
              [
                -76.5885830008453,
                39.3103549987886,
                0
              ],
              [
                -76.5885509995419,
                39.3098679993671,
                0
              ],
              [
                -76.5885240003997,
                39.309445998823,
                0
              ],
              [
                -76.5884829996931,
                39.308804998769,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 43,
          "Census_Tract": "24510090100",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "f438cd7b-09bf-4a73-9cb9-530c78e4e65c",
          "Shape__Area": 7080984.796142578,
          "Shape__Length": 12038.812840970471
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6002109994748,
                39.3400639990285,
                0
              ],
              [
                -76.6002179995445,
                39.3398149986962,
                0
              ],
              [
                -76.6001999998985,
                39.3396469985876,
                0
              ],
              [
                -76.6001949995078,
                39.3395979989518,
                0
              ],
              [
                -76.6001659999588,
                39.3394229986407,
                0
              ],
              [
                -76.6001320009517,
                39.3392399988852,
                0
              ],
              [
                -76.6000199998789,
                39.3389609987143,
                0
              ],
              [
                -76.5999730013012,
                39.3388639976483,
                0
              ],
              [
                -76.5998999996854,
                39.3387209987703,
                0
              ],
              [
                -76.5998279994881,
                39.3385860000844,
                0
              ],
              [
                -76.5997309999468,
                39.3383969992869,
                0
              ],
              [
                -76.5996469994878,
                39.3382619992475,
                0
              ],
              [
                -76.5995569995457,
                39.3381390000827,
                0
              ],
              [
                -76.599439000171,
                39.3379639989588,
                0
              ],
              [
                -76.5993450004482,
                39.3378419993302,
                0
              ],
              [
                -76.5991889994319,
                39.3376479986492,
                0
              ],
              [
                -76.5988330002508,
                39.3372459992913,
                0
              ],
              [
                -76.5987420003258,
                39.3371609985965,
                0
              ],
              [
                -76.5985910000403,
                39.3370219993978,
                0
              ],
              [
                -76.5983419998282,
                39.3368139975743,
                0
              ],
              [
                -76.5979520005034,
                39.3364839994401,
                0
              ],
              [
                -76.5974780001027,
                39.3360999989461,
                0
              ],
              [
                -76.5969969996426,
                39.3357019991697,
                0
              ],
              [
                -76.5964360000629,
                39.3352409991207,
                0
              ],
              [
                -76.5961380001207,
                39.3349829993313,
                0
              ],
              [
                -76.5959879999776,
                39.3348309986906,
                0
              ],
              [
                -76.5958489987053,
                39.3346679996907,
                0
              ],
              [
                -76.5956869997758,
                39.3344340000613,
                0
              ],
              [
                -76.5956489986719,
                39.3343789993375,
                0
              ],
              [
                -76.5956010004247,
                39.3343109997305,
                0
              ],
              [
                -76.5955010001002,
                39.3341359986599,
                0
              ],
              [
                -76.5954430003879,
                39.3340299988996,
                0
              ],
              [
                -76.5957069990117,
                39.3340049998219,
                0
              ],
              [
                -76.5957879987329,
                39.3340059989743,
                0
              ],
              [
                -76.5963830003004,
                39.3340159988534,
                0
              ],
              [
                -76.5964510000098,
                39.3340169988505,
                0
              ],
              [
                -76.5969499999954,
                39.3340259987957,
                0
              ],
              [
                -76.597416999813,
                39.334033998896,
                0
              ],
              [
                -76.5978799999186,
                39.3340379994464,
                0
              ],
              [
                -76.5983540003199,
                39.3340409989972,
                0
              ],
              [
                -76.5988259998327,
                39.3340349994343,
                0
              ],
              [
                -76.5992799999681,
                39.3340279989405,
                0
              ],
              [
                -76.599778999704,
                39.3340329992597,
                0
              ],
              [
                -76.6001969998603,
                39.3340379994322,
                0
              ],
              [
                -76.600661000408,
                39.3340379994121,
                0
              ],
              [
                -76.6010860008628,
                39.3340379994307,
                0
              ],
              [
                -76.6015389989586,
                39.3340329990851,
                0
              ],
              [
                -76.6019690002492,
                39.3340299989575,
                0
              ],
              [
                -76.6028469997567,
                39.3340369994469,
                0
              ],
              [
                -76.6032549996835,
                39.3340369990393,
                0
              ],
              [
                -76.6044849990067,
                39.3340399999914,
                0
              ],
              [
                -76.6046300001497,
                39.3343269987572,
                0
              ],
              [
                -76.6051240007089,
                39.334270998711,
                0
              ],
              [
                -76.605879000039,
                39.334184998789,
                0
              ],
              [
                -76.6063150005279,
                39.3341380004134,
                0
              ],
              [
                -76.606762999749,
                39.3340919989573,
                0
              ],
              [
                -76.6071119996078,
                39.3340639978879,
                0
              ],
              [
                -76.6071469996122,
                39.3340610000738,
                0
              ],
              [
                -76.6075480003574,
                39.3340459990424,
                0
              ],
              [
                -76.6075370002768,
                39.3344829991127,
                0
              ],
              [
                -76.6095079998607,
                39.3344559993362,
                0
              ],
              [
                -76.6095139997489,
                39.3353389992004,
                0
              ],
              [
                -76.6095159997375,
                39.3363949993493,
                0
              ],
              [
                -76.6095189999133,
                39.3368189993213,
                0
              ],
              [
                -76.6095279997277,
                39.3373079990842,
                0
              ],
              [
                -76.609533000402,
                39.3386650003883,
                0
              ],
              [
                -76.609551001212,
                39.3393899993162,
                0
              ],
              [
                -76.6095800003707,
                39.3397979987985,
                0
              ],
              [
                -76.609600000314,
                39.3401809987398,
                0
              ],
              [
                -76.6076990004396,
                39.3402269994035,
                0
              ],
              [
                -76.6076670000609,
                39.3396770002387,
                0
              ],
              [
                -76.6063890004788,
                39.33970699898,
                0
              ],
              [
                -76.6064129986942,
                39.3400979989394,
                0
              ],
              [
                -76.6064040000565,
                39.3401329988535,
                0
              ],
              [
                -76.6063729997386,
                39.340171999179,
                0
              ],
              [
                -76.6063260001116,
                39.340193999272,
                0
              ],
              [
                -76.6060159995529,
                39.3403019988736,
                0
              ],
              [
                -76.6057740003025,
                39.3403810000808,
                0
              ],
              [
                -76.60559200012,
                39.3404309989862,
                0
              ],
              [
                -76.6055159995327,
                39.3404449992058,
                0
              ],
              [
                -76.6054139997608,
                39.3404579987585,
                0
              ],
              [
                -76.6052830003566,
                39.3404619978794,
                0
              ],
              [
                -76.6049600002856,
                39.3404569992152,
                0
              ],
              [
                -76.6042289990185,
                39.3404769998092,
                0
              ],
              [
                -76.6036810011188,
                39.3404899989182,
                0
              ],
              [
                -76.6031289998019,
                39.3405199988668,
                0
              ],
              [
                -76.6024840000728,
                39.3405439989931,
                0
              ],
              [
                -76.6017690006691,
                39.3405589987235,
                0
              ],
              [
                -76.601582999582,
                39.3405559995527,
                0
              ],
              [
                -76.6014350005761,
                39.3405499988347,
                0
              ],
              [
                -76.6013039990985,
                39.3405379989542,
                0
              ],
              [
                -76.601164000291,
                39.3405099990629,
                0
              ],
              [
                -76.6008660004354,
                39.340415999102,
                0
              ],
              [
                -76.6007579995748,
                39.3402999989938,
                0
              ],
              [
                -76.6006590004508,
                39.340231998639,
                0
              ],
              [
                -76.6005059997355,
                39.3401659990165,
                0
              ],
              [
                -76.6004050004674,
                39.3401289989616,
                0
              ],
              [
                -76.6003770002127,
                39.3401189991708,
                0
              ],
              [
                -76.6002109994748,
                39.3400639990285,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 44,
          "Census_Tract": "24510270802",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "23bff415-16b8-4b62-bb48-becf6f742d12",
          "Shape__Area": 11835192.500061035,
          "Shape__Length": 14368.603896861952
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.5855099999646,
                39.3660389985952,
                0
              ],
              [
                -76.5855560000065,
                39.3659619987948,
                0
              ],
              [
                -76.5855749998444,
                39.3659279988512,
                0
              ],
              [
                -76.585622001496,
                39.3658439992966,
                0
              ],
              [
                -76.5857169995193,
                39.3656629987402,
                0
              ],
              [
                -76.5857939998205,
                39.3655209989213,
                0
              ],
              [
                -76.5858800004155,
                39.3653389991328,
                0
              ],
              [
                -76.5859769995734,
                39.3651100004239,
                0
              ],
              [
                -76.585992001179,
                39.3650819987723,
                0
              ],
              [
                -76.5860599987966,
                39.3649479989673,
                0
              ],
              [
                -76.5861550002038,
                39.3647389994045,
                0
              ],
              [
                -76.5863090005649,
                39.3643809987148,
                0
              ],
              [
                -76.5863579999725,
                39.3642880002527,
                0
              ],
              [
                -76.5865859999302,
                39.3637969993092,
                0
              ],
              [
                -76.5869119989133,
                39.3631019982258,
                0
              ],
              [
                -76.5871629998821,
                39.3625639986579,
                0
              ],
              [
                -76.5872859988419,
                39.3622999997871,
                0
              ],
              [
                -76.5873810000453,
                39.3620909990809,
                0
              ],
              [
                -76.5874779999397,
                39.3618829988148,
                0
              ],
              [
                -76.5875780005225,
                39.3616409987858,
                0
              ],
              [
                -76.5876670005582,
                39.3614599988313,
                0
              ],
              [
                -76.5877539996915,
                39.3612809986385,
                0
              ],
              [
                -76.5878899998545,
                39.3609699988852,
                0
              ],
              [
                -76.5883700001545,
                39.3600109993499,
                0
              ],
              [
                -76.5884680002041,
                39.3598169991791,
                0
              ],
              [
                -76.5888180003175,
                39.3591059987014,
                0
              ],
              [
                -76.5889970013139,
                39.358743999188,
                0
              ],
              [
                -76.5891389990995,
                39.3584279988998,
                0
              ],
              [
                -76.589290000471,
                39.3580949986227,
                0
              ],
              [
                -76.5894650011967,
                39.3576779994019,
                0
              ],
              [
                -76.5895390005425,
                39.3574799988942,
                0
              ],
              [
                -76.5895820008918,
                39.3573149987349,
                0
              ],
              [
                -76.5896150003448,
                39.3571169991716,
                0
              ],
              [
                -76.5896390008507,
                39.356939997823,
                0
              ],
              [
                -76.5896529997837,
                39.3567639992141,
                0
              ],
              [
                -76.5896490002561,
                39.3565449993773,
                0
              ],
              [
                -76.5896350004885,
                39.3563219986555,
                0
              ],
              [
                -76.5896149995459,
                39.3560569987483,
                0
              ],
              [
                -76.589560999894,
                39.355417998812,
                0
              ],
              [
                -76.5897949998069,
                39.3553779990802,
                0
              ],
              [
                -76.590035999145,
                39.3553370000424,
                0
              ],
              [
                -76.5902290001356,
                39.3552829976657,
                0
              ],
              [
                -76.5904290001816,
                39.3552139985584,
                0
              ],
              [
                -76.5904990000365,
                39.355186999379,
                0
              ],
              [
                -76.5905860005184,
                39.3551499989514,
                0
              ],
              [
                -76.5907420002898,
                39.3550799994047,
                0
              ],
              [
                -76.5909329995719,
                39.3549789989349,
                0
              ],
              [
                -76.591176999749,
                39.3548369986565,
                0
              ],
              [
                -76.5912719997996,
                39.354782998783,
                0
              ],
              [
                -76.5913990004542,
                39.3547109987911,
                0
              ],
              [
                -76.5916519998304,
                39.3545699988928,
                0
              ],
              [
                -76.5918499997914,
                39.3544749985704,
                0
              ],
              [
                -76.5921360002665,
                39.3543669992104,
                0
              ],
              [
                -76.592289000068,
                39.3543239995909,
                0
              ],
              [
                -76.5923650005021,
                39.3543039990638,
                0
              ],
              [
                -76.5925640010093,
                39.3542499983385,
                0
              ],
              [
                -76.5927790009472,
                39.3542019993942,
                0
              ],
              [
                -76.5930420004466,
                39.354161999055,
                0
              ],
              [
                -76.5933260001456,
                39.3541309989279,
                0
              ],
              [
                -76.5943459985429,
                39.3540879988154,
                0
              ],
              [
                -76.5946660003363,
                39.3540749994053,
                0
              ],
              [
                -76.5946880015487,
                39.3541599991221,
                0
              ],
              [
                -76.5946990002047,
                39.3542419992647,
                0
              ],
              [
                -76.5947259995571,
                39.3543810004397,
                0
              ],
              [
                -76.5947750003231,
                39.3546169991888,
                0
              ],
              [
                -76.5948440005313,
                39.3548009993573,
                0
              ],
              [
                -76.5949250002981,
                39.3549859992018,
                0
              ],
              [
                -76.5950210006885,
                39.355218998991,
                0
              ],
              [
                -76.5951019994335,
                39.3553950002608,
                0
              ],
              [
                -76.5951719995284,
                39.355518997942,
                0
              ],
              [
                -76.5952380004691,
                39.3556039985615,
                0
              ],
              [
                -76.5953430004037,
                39.3557479995985,
                0
              ],
              [
                -76.5954239994251,
                39.3558239992533,
                0
              ],
              [
                -76.5955399997466,
                39.3559489989506,
                0
              ],
              [
                -76.5956260004205,
                39.3560549986852,
                0
              ],
              [
                -76.5956989995865,
                39.356160997787,
                0
              ],
              [
                -76.5957729998076,
                39.3563099990301,
                0
              ],
              [
                -76.5959340002783,
                39.3565569991444,
                0
              ],
              [
                -76.5959750000276,
                39.3565659988248,
                0
              ],
              [
                -76.5960319994384,
                39.3565949985985,
                0
              ],
              [
                -76.5961340007753,
                39.3566589990373,
                0
              ],
              [
                -76.5963689994562,
                39.356865999369,
                0
              ],
              [
                -76.5964879994399,
                39.3569739987555,
                0
              ],
              [
                -76.5966129997745,
                39.3570949991983,
                0
              ],
              [
                -76.596713999573,
                39.3572189986325,
                0
              ],
              [
                -76.5968140002428,
                39.3573179989503,
                0
              ],
              [
                -76.596888000471,
                39.3574050004364,
                0
              ],
              [
                -76.5969439996693,
                39.3574649998752,
                0
              ],
              [
                -76.597009999553,
                39.3575569990978,
                0
              ],
              [
                -76.597109000505,
                39.3576819983494,
                0
              ],
              [
                -76.5971949997137,
                39.3577969988742,
                0
              ],
              [
                -76.597284999963,
                39.3579129993459,
                0
              ],
              [
                -76.5974119996492,
                39.358048998591,
                0
              ],
              [
                -76.597641999728,
                39.3583659993689,
                0
              ],
              [
                -76.5977519998521,
                39.3585349990833,
                0
              ],
              [
                -76.5978280006698,
                39.3587239986773,
                0
              ],
              [
                -76.5979360000791,
                39.3589729988395,
                0
              ],
              [
                -76.5979739997551,
                39.359071998673,
                0
              ],
              [
                -76.5980080003738,
                39.3592279990657,
                0
              ],
              [
                -76.5980430005466,
                39.359377999414,
                0
              ],
              [
                -76.5980780003937,
                39.3595599985873,
                0
              ],
              [
                -76.5981020004073,
                39.3599089990517,
                0
              ],
              [
                -76.5981020004998,
                39.3599719987107,
                0
              ],
              [
                -76.5981500004932,
                39.3600529988861,
                0
              ],
              [
                -76.5981559998608,
                39.3600659990709,
                0
              ],
              [
                -76.5981629994424,
                39.3600879992785,
                0
              ],
              [
                -76.5981620004679,
                39.360167998815,
                0
              ],
              [
                -76.5981580004112,
                39.3601999992964,
                0
              ],
              [
                -76.5981470001605,
                39.3602319992756,
                0
              ],
              [
                -76.5981240004969,
                39.3603129991098,
                0
              ],
              [
                -76.5981090005592,
                39.3603270003133,
                0
              ],
              [
                -76.5980919994828,
                39.3603529988555,
                0
              ],
              [
                -76.5980809995576,
                39.3603789989902,
                0
              ],
              [
                -76.5980769998369,
                39.3604049987293,
                0
              ],
              [
                -76.5980840004902,
                39.3604529988407,
                0
              ],
              [
                -76.5980840008879,
                39.3604649994184,
                0
              ],
              [
                -76.5980909986908,
                39.3604909989127,
                0
              ],
              [
                -76.5981020002598,
                39.3605219985933,
                0
              ],
              [
                -76.5981120002292,
                39.3605599990137,
                0
              ],
              [
                -76.5981269995201,
                39.3605939992116,
                0
              ],
              [
                -76.5981930004893,
                39.3607309986985,
                0
              ],
              [
                -76.5982150000698,
                39.360800000384,
                0
              ],
              [
                -76.5982049992476,
                39.3608529991537,
                0
              ],
              [
                -76.5982130003893,
                39.3609109999947,
                0
              ],
              [
                -76.5982169996551,
                39.3609519991831,
                0
              ],
              [
                -76.598246000265,
                39.3610609987677,
                0
              ],
              [
                -76.5982340008036,
                39.3611889990216,
                0
              ],
              [
                -76.5982300002833,
                39.3612439990162,
                0
              ],
              [
                -76.5982299999741,
                39.361346998755,
                0
              ],
              [
                -76.5982260001754,
                39.3613899990772,
                0
              ],
              [
                -76.5982110004849,
                39.361424999266,
                0
              ],
              [
                -76.5981730003788,
                39.3614849992945,
                0
              ],
              [
                -76.5981539999891,
                39.3615479988497,
                0
              ],
              [
                -76.5981430004967,
                39.3616139990875,
                0
              ],
              [
                -76.5981349997612,
                39.3616479990386,
                0
              ],
              [
                -76.5981349996194,
                39.3617089990168,
                0
              ],
              [
                -76.5981459995017,
                39.3617609994495,
                0
              ],
              [
                -76.5981570005467,
                39.3618039987803,
                0
              ],
              [
                -76.598166999454,
                39.3618499995568,
                0
              ],
              [
                -76.5981780000652,
                39.3619159993014,
                0
              ],
              [
                -76.5981660001761,
                39.3620869999797,
                0
              ],
              [
                -76.5981549997203,
                39.3621549989481,
                0
              ],
              [
                -76.5981389999075,
                39.362209999354,
                0
              ],
              [
                -76.5981129999562,
                39.3622899989702,
                0
              ],
              [
                -76.5980949996369,
                39.3623449988366,
                0
              ],
              [
                -76.5980649995695,
                39.3624049991328,
                0
              ],
              [
                -76.5980349995785,
                39.3624569990414,
                0
              ],
              [
                -76.5980089991591,
                39.3625259987819,
                0
              ],
              [
                -76.597982999713,
                39.3626119990984,
                0
              ],
              [
                -76.5979789996684,
                39.3627359993996,
                0
              ],
              [
                -76.5979750004061,
                39.3627850004309,
                0
              ],
              [
                -76.5979679998233,
                39.362819999096,
                0
              ],
              [
                -76.5979600000342,
                39.3628449988257,
                0
              ],
              [
                -76.5979490004515,
                39.362867998563,
                0
              ],
              [
                -76.5978919985727,
                39.3629199988879,
                0
              ],
              [
                -76.5978620003711,
                39.3629339992077,
                0
              ],
              [
                -76.5978430000343,
                39.362965997897,
                0
              ],
              [
                -76.5978390000701,
                39.362991999408,
                0
              ],
              [
                -76.5978429998704,
                39.3630379985948,
                0
              ],
              [
                -76.5978830001209,
                39.3631399992248,
                0
              ],
              [
                -76.5979199999729,
                39.3631889990144,
                0
              ],
              [
                -76.5979489999245,
                39.3632349989982,
                0
              ],
              [
                -76.597977999529,
                39.363268999308,
                0
              ],
              [
                -76.5980410005427,
                39.3633589986714,
                0
              ],
              [
                -76.5980480001526,
                39.3633789992178,
                0
              ],
              [
                -76.598062999617,
                39.363409999926,
                0
              ],
              [
                -76.5980660002306,
                39.3634359992457,
                0
              ],
              [
                -76.5980769999338,
                39.36347599909,
                0
              ],
              [
                -76.5980840011432,
                39.3635169986004,
                0
              ],
              [
                -76.5981050008567,
                39.363582999161,
                0
              ],
              [
                -76.5981119995534,
                39.3636489987092,
                0
              ],
              [
                -76.5981529994695,
                39.3637409990186,
                0
              ],
              [
                -76.5981709996787,
                39.3638329990908,
                0
              ],
              [
                -76.5981889993132,
                39.3638849990798,
                0
              ],
              [
                -76.5982110002215,
                39.3639389988679,
                0
              ],
              [
                -76.5982590011349,
                39.3639969993873,
                0
              ],
              [
                -76.5982809995336,
                39.3640139994436,
                0
              ],
              [
                -76.59832499958,
                39.3640459990106,
                0
              ],
              [
                -76.5983799986297,
                39.3640760004504,
                0
              ],
              [
                -76.5984430003787,
                39.3641279991449,
                0
              ],
              [
                -76.5984950009249,
                39.3641479992808,
                0
              ],
              [
                -76.5985169995644,
                39.3641659991143,
                0
              ],
              [
                -76.5985320001639,
                39.3641939975904,
                0
              ],
              [
                -76.5985459994851,
                39.3642399993434,
                0
              ],
              [
                -76.5985489994249,
                39.3643019994243,
                0
              ],
              [
                -76.5985459999786,
                39.3643539988234,
                0
              ],
              [
                -76.5985340000957,
                39.3644109990311,
                0
              ],
              [
                -76.5985340003649,
                39.3644979988191,
                0
              ],
              [
                -76.5985480000246,
                39.3645119990739,
                0
              ],
              [
                -76.5985779999367,
                39.3645319988272,
                0
              ],
              [
                -76.5986180002434,
                39.3645699988667,
                0
              ],
              [
                -76.5986259995873,
                39.364600999017,
                0
              ],
              [
                -76.5986919990946,
                39.3647019990501,
                0
              ],
              [
                -76.5987099999456,
                39.3647249987206,
                0
              ],
              [
                -76.5987509997993,
                39.3647399990234,
                0
              ],
              [
                -76.5988030010987,
                39.3647449989962,
                0
              ],
              [
                -76.5988279995399,
                39.364745999426,
                0
              ],
              [
                -76.5988579995516,
                39.3647489994396,
                0
              ],
              [
                -76.5988729994735,
                39.3647539992686,
                0
              ],
              [
                -76.5988840012547,
                39.3647629991567,
                0
              ],
              [
                -76.5988949999551,
                39.3647829988703,
                0
              ],
              [
                -76.5989279988548,
                39.3648869991626,
                0
              ],
              [
                -76.5989639987151,
                39.3649589991785,
                0
              ],
              [
                -76.5989900001947,
                39.3649869990713,
                0
              ],
              [
                -76.5990119996362,
                39.365015998645,
                0
              ],
              [
                -76.5990560000248,
                39.3650679988563,
                0
              ],
              [
                -76.5991149994599,
                39.3651659996242,
                0
              ],
              [
                -76.5991520013696,
                39.3652399990302,
                0
              ],
              [
                -76.599194999477,
                39.3653719985814,
                0
              ],
              [
                -76.5992110005573,
                39.3655409985746,
                0
              ],
              [
                -76.59925899947,
                39.365785999419,
                0
              ],
              [
                -76.5992830001492,
                39.365911999204,
                0
              ],
              [
                -76.5988240012686,
                39.3660039986978,
                0
              ],
              [
                -76.598709000106,
                39.3660309987443,
                0
              ],
              [
                -76.598590000544,
                39.3660529994373,
                0
              ],
              [
                -76.597675999986,
                39.3662539991587,
                0
              ],
              [
                -76.5972560002637,
                39.3663519987671,
                0
              ],
              [
                -76.5967939997935,
                39.366465998645,
                0
              ],
              [
                -76.5963419994948,
                39.3665689987739,
                0
              ],
              [
                -76.5953079996723,
                39.3668019993024,
                0
              ],
              [
                -76.5950920000827,
                39.3668499993613,
                0
              ],
              [
                -76.5948670008381,
                39.3668949991846,
                0
              ],
              [
                -76.5946840005733,
                39.3669249991938,
                0
              ],
              [
                -76.5944879998035,
                39.3669539993094,
                0
              ],
              [
                -76.594270999463,
                39.3669789994302,
                0
              ],
              [
                -76.5940670009092,
                39.3669949988016,
                0
              ],
              [
                -76.5938479998859,
                39.3670059991481,
                0
              ],
              [
                -76.5937109999258,
                39.3670089991969,
                0
              ],
              [
                -76.5934930004966,
                39.3670059994448,
                0
              ],
              [
                -76.5933370003194,
                39.367000999668,
                0
              ],
              [
                -76.5931779999752,
                39.366987998845,
                0
              ],
              [
                -76.5930010003431,
                39.3669759992922,
                0
              ],
              [
                -76.5927850004004,
                39.3669509991762,
                0
              ],
              [
                -76.5925089986912,
                39.3669089991921,
                0
              ],
              [
                -76.5923070004399,
                39.3668759986,
                0
              ],
              [
                -76.5921409998825,
                39.3668420001831,
                0
              ],
              [
                -76.5906319994915,
                39.3666029991226,
                0
              ],
              [
                -76.5901530001784,
                39.366518998706,
                0
              ],
              [
                -76.5896110003905,
                39.3664239991546,
                0
              ],
              [
                -76.5889529997268,
                39.3663089988218,
                0
              ],
              [
                -76.5883399994554,
                39.3662349990813,
                0
              ],
              [
                -76.5880210003673,
                39.3661989990854,
                0
              ],
              [
                -76.587712998881,
                39.3661609993029,
                0
              ],
              [
                -76.587495999647,
                39.3661269992638,
                0
              ],
              [
                -76.587234999848,
                39.3661019986233,
                0
              ],
              [
                -76.5869690002712,
                39.3660669987419,
                0
              ],
              [
                -76.5866039989215,
                39.3660399992588,
                0
              ],
              [
                -76.5862739998372,
                39.3660319985944,
                0
              ],
              [
                -76.5859779987069,
                39.3660209992339,
                0
              ],
              [
                -76.5858099999266,
                39.3660219992948,
                0
              ],
              [
                -76.5857730001731,
                39.3660219986878,
                0
              ],
              [
                -76.585619000328,
                39.3660289989724,
                0
              ],
              [
                -76.5855099999646,
                39.3660389985952,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 45,
          "Census_Tract": "24510130100",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "bdfd6736-45ab-4a37-9900-bd4f46f74666",
          "Shape__Area": 3350319.4862060547,
          "Shape__Length": 8875.952089586774
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6278620015758,
                39.3147489987422,
                0
              ],
              [
                -76.6280409995923,
                39.3146559988116,
                0
              ],
              [
                -76.6285829994481,
                39.3143529991223,
                0
              ],
              [
                -76.6290829997413,
                39.3140739991439,
                0
              ],
              [
                -76.6292709985364,
                39.3139689988841,
                0
              ],
              [
                -76.6294790011095,
                39.3138289986775,
                0
              ],
              [
                -76.6296100000744,
                39.3137449993528,
                0
              ],
              [
                -76.6296629999649,
                39.3137169998345,
                0
              ],
              [
                -76.6297309997749,
                39.3136989990752,
                0
              ],
              [
                -76.6298399990437,
                39.3136869976337,
                0
              ],
              [
                -76.6301549999053,
                39.3136689988343,
                0
              ],
              [
                -76.6307520005775,
                39.313660999415,
                0
              ],
              [
                -76.6311449997484,
                39.3136529990708,
                0
              ],
              [
                -76.6313880007563,
                39.3136439991729,
                0
              ],
              [
                -76.6314120012714,
                39.3144189985606,
                0
              ],
              [
                -76.6326019999107,
                39.314422999609,
                0
              ],
              [
                -76.6339129985069,
                39.3144019986014,
                0
              ],
              [
                -76.6341420005372,
                39.3144029990931,
                0
              ],
              [
                -76.6343160001501,
                39.3144009987351,
                0
              ],
              [
                -76.6345250003257,
                39.3143939988052,
                0
              ],
              [
                -76.634591999471,
                39.3143860003908,
                0
              ],
              [
                -76.6346880003404,
                39.3143669993248,
                0
              ],
              [
                -76.6347949996632,
                39.3143229986389,
                0
              ],
              [
                -76.6350489994366,
                39.3141959988077,
                0
              ],
              [
                -76.635601000041,
                39.3138729993549,
                0
              ],
              [
                -76.6361270004672,
                39.313552999167,
                0
              ],
              [
                -76.6366830000392,
                39.3132459989502,
                0
              ],
              [
                -76.6372390002354,
                39.3129299993692,
                0
              ],
              [
                -76.6377829996,
                39.3126149987213,
                0
              ],
              [
                -76.6388980005423,
                39.3137199987924,
                0
              ],
              [
                -76.6393620002727,
                39.3142029993572,
                0
              ],
              [
                -76.6399560000004,
                39.3147940002431,
                0
              ],
              [
                -76.6401240000096,
                39.314960999094,
                0
              ],
              [
                -76.6403030004131,
                39.3151389989243,
                0
              ],
              [
                -76.6399450004979,
                39.3153559990935,
                0
              ],
              [
                -76.6394499985919,
                39.3156369988253,
                0
              ],
              [
                -76.6394020009126,
                39.3156839987333,
                0
              ],
              [
                -76.639390000654,
                39.3157429990132,
                0
              ],
              [
                -76.6394060010973,
                39.3158379991005,
                0
              ],
              [
                -76.6388630009862,
                39.3161279988914,
                0
              ],
              [
                -76.6387020003895,
                39.3162099994177,
                0
              ],
              [
                -76.6385689995989,
                39.3162679988258,
                0
              ],
              [
                -76.6383789996171,
                39.3163539991331,
                0
              ],
              [
                -76.6382119995746,
                39.3164229988861,
                0
              ],
              [
                -76.6379580001655,
                39.3165219992927,
                0
              ],
              [
                -76.6377459999965,
                39.3166029991804,
                0
              ],
              [
                -76.6375560005244,
                39.3166789989075,
                0
              ],
              [
                -76.6372410014453,
                39.3168030000516,
                0
              ],
              [
                -76.6370959997041,
                39.3168589989073,
                0
              ],
              [
                -76.6370039995912,
                39.3168889989622,
                0
              ],
              [
                -76.6369029997865,
                39.3169139989891,
                0
              ],
              [
                -76.6366830002943,
                39.3169429988529,
                0
              ],
              [
                -76.6365800014745,
                39.3169529994056,
                0
              ],
              [
                -76.6364380004058,
                39.3169629990194,
                0
              ],
              [
                -76.6361799999205,
                39.3169619988316,
                0
              ],
              [
                -76.635466000693,
                39.3169599988837,
                0
              ],
              [
                -76.634614000533,
                39.3169819994252,
                0
              ],
              [
                -76.6339559997087,
                39.3170109989384,
                0
              ],
              [
                -76.6326580004497,
                39.3168999990355,
                0
              ],
              [
                -76.6323859997332,
                39.316882998939,
                0
              ],
              [
                -76.6321230004244,
                39.3168610001924,
                0
              ],
              [
                -76.6317989995937,
                39.3168359994063,
                0
              ],
              [
                -76.6314759984803,
                39.3168069988188,
                0
              ],
              [
                -76.6311770011066,
                39.3167929990418,
                0
              ],
              [
                -76.6309349998063,
                39.3167969988902,
                0
              ],
              [
                -76.6307300008872,
                39.3168019999515,
                0
              ],
              [
                -76.6305940001227,
                39.3168020003991,
                0
              ],
              [
                -76.6303979997926,
                39.3168209989333,
                0
              ],
              [
                -76.6302089987733,
                39.3168539988398,
                0
              ],
              [
                -76.630100999507,
                39.3168669991058,
                0
              ],
              [
                -76.6299989994295,
                39.3168889986604,
                0
              ],
              [
                -76.6299060001477,
                39.316912999119,
                0
              ],
              [
                -76.6297849997504,
                39.3169469988239,
                0
              ],
              [
                -76.6296830000205,
                39.316971999412,
                0
              ],
              [
                -76.6295789997871,
                39.3170169993136,
                0
              ],
              [
                -76.6294300000675,
                39.3170809991263,
                0
              ],
              [
                -76.629107999716,
                39.3164169990149,
                0
              ],
              [
                -76.6286609999133,
                39.315668998706,
                0
              ],
              [
                -76.6285269994652,
                39.3154889993606,
                0
              ],
              [
                -76.6284659997368,
                39.3153999986156,
                0
              ],
              [
                -76.6283719991226,
                39.3152829998723,
                0
              ],
              [
                -76.6282340004848,
                39.3151379988852,
                0
              ],
              [
                -76.6278620015758,
                39.3147489987422,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 46,
          "Census_Tract": "24510170100",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "a2a6d02d-0538-4550-97e3-a83b8fd14751",
          "Shape__Area": 3036762.899597168,
          "Shape__Length": 8101.620678187677
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6198189999001,
                39.2949309989753,
                0
              ],
              [
                -76.6204239995375,
                39.2949149985638,
                0
              ],
              [
                -76.6210039997242,
                39.2948759990947,
                0
              ],
              [
                -76.6212580000368,
                39.2948659991881,
                0
              ],
              [
                -76.6212850000846,
                39.2948609987413,
                0
              ],
              [
                -76.6219419994965,
                39.2948359992121,
                0
              ],
              [
                -76.6219770003898,
                39.2948379989262,
                0
              ],
              [
                -76.6219940000394,
                39.29483899942,
                0
              ],
              [
                -76.6220359985942,
                39.2948369988431,
                0
              ],
              [
                -76.622638000568,
                39.2948119986286,
                0
              ],
              [
                -76.6239510002049,
                39.2947529988107,
                0
              ],
              [
                -76.6242219992593,
                39.2947299994196,
                0
              ],
              [
                -76.624792000092,
                39.2947079988333,
                0
              ],
              [
                -76.6250729996395,
                39.2947079987605,
                0
              ],
              [
                -76.625726000514,
                39.2946789992779,
                0
              ],
              [
                -76.627248999797,
                39.2946349994261,
                0
              ],
              [
                -76.6276880010437,
                39.294629998767,
                0
              ],
              [
                -76.6276560004547,
                39.2948339992994,
                0
              ],
              [
                -76.6276139984673,
                39.2949969989196,
                0
              ],
              [
                -76.6275659996089,
                39.2951559999572,
                0
              ],
              [
                -76.627487999799,
                39.2953269994287,
                0
              ],
              [
                -76.6274139994755,
                39.2954539986764,
                0
              ],
              [
                -76.6272909996452,
                39.2956349987244,
                0
              ],
              [
                -76.6271860002414,
                39.2957559986084,
                0
              ],
              [
                -76.6269860009811,
                39.2959649990339,
                0
              ],
              [
                -76.6261590005133,
                39.2966529987584,
                0
              ],
              [
                -76.6240489998351,
                39.2983569977492,
                0
              ],
              [
                -76.6233749997042,
                39.2990009984396,
                0
              ],
              [
                -76.6233469998376,
                39.2990269991207,
                0
              ],
              [
                -76.6230550000171,
                39.2993399991445,
                0
              ],
              [
                -76.6227209999219,
                39.2996869986608,
                0
              ],
              [
                -76.6226280002301,
                39.2997799986314,
                0
              ],
              [
                -76.6218219998025,
                39.3004649992113,
                0
              ],
              [
                -76.6212600002836,
                39.3008939994539,
                0
              ],
              [
                -76.6211010001443,
                39.3010099988345,
                0
              ],
              [
                -76.6208550002139,
                39.3011889990703,
                0
              ],
              [
                -76.6205289995494,
                39.3014469989385,
                0
              ],
              [
                -76.6204729998785,
                39.3014899994504,
                0
              ],
              [
                -76.6204049994561,
                39.3015559980217,
                0
              ],
              [
                -76.6202689997846,
                39.3017569993249,
                0
              ],
              [
                -76.6202380015626,
                39.3016249986153,
                0
              ],
              [
                -76.620207999515,
                39.301516998176,
                0
              ],
              [
                -76.6201940002736,
                39.301411999434,
                0
              ],
              [
                -76.6201820002477,
                39.301307998883,
                0
              ],
              [
                -76.6201740000724,
                39.3011699986747,
                0
              ],
              [
                -76.620174000462,
                39.3011419986454,
                0
              ],
              [
                -76.6201750002123,
                39.300988000354,
                0
              ],
              [
                -76.6201530002611,
                39.3006459991486,
                0
              ],
              [
                -76.6201360011539,
                39.3003259997529,
                0
              ],
              [
                -76.6200360003942,
                39.2984299989974,
                0
              ],
              [
                -76.6200370003922,
                39.2981519986627,
                0
              ],
              [
                -76.6200030010691,
                39.2976359976523,
                0
              ],
              [
                -76.6199829999618,
                39.2973589994258,
                0
              ],
              [
                -76.619945000323,
                39.2967679990185,
                0
              ],
              [
                -76.6199199998773,
                39.2962609993284,
                0
              ],
              [
                -76.6199170001004,
                39.2962089996553,
                0
              ],
              [
                -76.6198189999001,
                39.2949309989753,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 47,
          "Census_Tract": "24510170200",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "eb430549-b542-4448-99ff-243aed256ce5",
          "Shape__Area": 5317183.072509766,
          "Shape__Length": 9769.374723930327
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6207230005507,
                39.3043509994543,
                0
              ],
              [
                -76.6207119995131,
                39.3042359986418,
                0
              ],
              [
                -76.620692999653,
                39.3040070002271,
                0
              ],
              [
                -76.6206770004624,
                39.303852999436,
                0
              ],
              [
                -76.6206580002758,
                39.3036899993995,
                0
              ],
              [
                -76.6206030003378,
                39.3033489990536,
                0
              ],
              [
                -76.6202689997846,
                39.3017569993249,
                0
              ],
              [
                -76.6204049994561,
                39.3015559980217,
                0
              ],
              [
                -76.6204729998785,
                39.3014899994504,
                0
              ],
              [
                -76.6205289995494,
                39.3014469989385,
                0
              ],
              [
                -76.6208550002139,
                39.3011889990703,
                0
              ],
              [
                -76.6211010001443,
                39.3010099988345,
                0
              ],
              [
                -76.6212600002836,
                39.3008939994539,
                0
              ],
              [
                -76.6218219998025,
                39.3004649992113,
                0
              ],
              [
                -76.6226280002301,
                39.2997799986314,
                0
              ],
              [
                -76.6227209999219,
                39.2996869986608,
                0
              ],
              [
                -76.6230550000171,
                39.2993399991445,
                0
              ],
              [
                -76.6233469998376,
                39.2990269991207,
                0
              ],
              [
                -76.6233749997042,
                39.2990009984396,
                0
              ],
              [
                -76.6240489998351,
                39.2983569977492,
                0
              ],
              [
                -76.6261590005133,
                39.2966529987584,
                0
              ],
              [
                -76.6263190010401,
                39.296783998761,
                0
              ],
              [
                -76.6276959999586,
                39.2979159991766,
                0
              ],
              [
                -76.6281260001019,
                39.2982569996906,
                0
              ],
              [
                -76.6286159995419,
                39.2986659999653,
                0
              ],
              [
                -76.6289160004141,
                39.2989200003054,
                0
              ],
              [
                -76.6291300015474,
                39.2991019993292,
                0
              ],
              [
                -76.6296649994786,
                39.2995179990855,
                0
              ],
              [
                -76.6301489994933,
                39.2999029993001,
                0
              ],
              [
                -76.6306340000293,
                39.3002869998644,
                0
              ],
              [
                -76.6317320003024,
                39.3011809993527,
                0
              ],
              [
                -76.6311890004968,
                39.3015849986868,
                0
              ],
              [
                -76.6309180003492,
                39.3017929989095,
                0
              ],
              [
                -76.6306270002292,
                39.3020059987789,
                0
              ],
              [
                -76.630107999457,
                39.302395998686,
                0
              ],
              [
                -76.6295539994411,
                39.3027999998815,
                0
              ],
              [
                -76.6292070011589,
                39.3030679990509,
                0
              ],
              [
                -76.6287640002124,
                39.3034089992308,
                0
              ],
              [
                -76.6284219995377,
                39.3036659991987,
                0
              ],
              [
                -76.6280059996373,
                39.3039699986474,
                0
              ],
              [
                -76.6275700008054,
                39.3042839991663,
                0
              ],
              [
                -76.6271330003809,
                39.304613998599,
                0
              ],
              [
                -76.6269050005491,
                39.3047839987063,
                0
              ],
              [
                -76.6259119995485,
                39.3039959994218,
                0
              ],
              [
                -76.6253810001098,
                39.3035349986534,
                0
              ],
              [
                -76.6252370003625,
                39.303373998592,
                0
              ],
              [
                -76.6251740000163,
                39.3032869998706,
                0
              ],
              [
                -76.6251180002587,
                39.3031819993164,
                0
              ],
              [
                -76.6245700003339,
                39.303583999193,
                0
              ],
              [
                -76.6243650005318,
                39.3037249987189,
                0
              ],
              [
                -76.6243199995055,
                39.3037519991323,
                0
              ],
              [
                -76.6242719997597,
                39.3037779991078,
                0
              ],
              [
                -76.6241770005454,
                39.3038249993996,
                0
              ],
              [
                -76.6241319997149,
                39.3038409988072,
                0
              ],
              [
                -76.6240290005183,
                39.3038739990583,
                0
              ],
              [
                -76.6239209994454,
                39.3039019993264,
                0
              ],
              [
                -76.6228780005391,
                39.3041779988913,
                0
              ],
              [
                -76.6227149995111,
                39.3042119988999,
                0
              ],
              [
                -76.6225090005538,
                39.3042429997518,
                0
              ],
              [
                -76.6223819998229,
                39.3042599987838,
                0
              ],
              [
                -76.622127000832,
                39.3042909991152,
                0
              ],
              [
                -76.6220490001019,
                39.3042989991716,
                0
              ],
              [
                -76.621957999686,
                39.3043059989481,
                0
              ],
              [
                -76.621845999022,
                39.3043129986277,
                0
              ],
              [
                -76.6212509998326,
                39.3043349991122,
                0
              ],
              [
                -76.6207230005507,
                39.3043509994543,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 48,
          "Census_Tract": "24510170300",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "3e610577-2e11-4218-b387-ed6ed9b336d3",
          "Shape__Area": 3291752.433166504,
          "Shape__Length": 7286.677803181613
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6261590005133,
                39.2966529987584,
                0
              ],
              [
                -76.6269860009811,
                39.2959649990339,
                0
              ],
              [
                -76.6271860002414,
                39.2957559986084,
                0
              ],
              [
                -76.6272909996452,
                39.2956349987244,
                0
              ],
              [
                -76.6274139994755,
                39.2954539986764,
                0
              ],
              [
                -76.627487999799,
                39.2953269994287,
                0
              ],
              [
                -76.6275659996089,
                39.2951559999572,
                0
              ],
              [
                -76.6276139984673,
                39.2949969989196,
                0
              ],
              [
                -76.6276560004547,
                39.2948339992994,
                0
              ],
              [
                -76.6276880010437,
                39.294629998767,
                0
              ],
              [
                -76.6280309997273,
                39.2946189988593,
                0
              ],
              [
                -76.628587999171,
                39.2945999985737,
                0
              ],
              [
                -76.6304059995167,
                39.2945399990207,
                0
              ],
              [
                -76.6319220001725,
                39.2944579991697,
                0
              ],
              [
                -76.6320509995182,
                39.2946869985885,
                0
              ],
              [
                -76.6322579994325,
                39.2950539985713,
                0
              ],
              [
                -76.6324260005072,
                39.2953829992595,
                0
              ],
              [
                -76.632591999673,
                39.2956889988607,
                0
              ],
              [
                -76.6328169998735,
                39.2960959981262,
                0
              ],
              [
                -76.6332609995008,
                39.2968859991934,
                0
              ],
              [
                -76.6338090010836,
                39.2979029999472,
                0
              ],
              [
                -76.6338849998976,
                39.2980399987721,
                0
              ],
              [
                -76.6344750006051,
                39.2991419988984,
                0
              ],
              [
                -76.6341269995495,
                39.2993999986476,
                0
              ],
              [
                -76.6335619997448,
                39.2998129985808,
                0
              ],
              [
                -76.6330939999069,
                39.3001709976556,
                0
              ],
              [
                -76.6326440002546,
                39.300508999379,
                0
              ],
              [
                -76.6321899998715,
                39.3008409986042,
                0
              ],
              [
                -76.6319810004076,
                39.3010069994388,
                0
              ],
              [
                -76.6317320003024,
                39.3011809993527,
                0
              ],
              [
                -76.6306340000293,
                39.3002869998644,
                0
              ],
              [
                -76.6301489994933,
                39.2999029993001,
                0
              ],
              [
                -76.6296649994786,
                39.2995179990855,
                0
              ],
              [
                -76.6291300015474,
                39.2991019993292,
                0
              ],
              [
                -76.6289160004141,
                39.2989200003054,
                0
              ],
              [
                -76.6286159995419,
                39.2986659999653,
                0
              ],
              [
                -76.6281260001019,
                39.2982569996906,
                0
              ],
              [
                -76.6276959999586,
                39.2979159991766,
                0
              ],
              [
                -76.6263190010401,
                39.296783998761,
                0
              ],
              [
                -76.6261590005133,
                39.2966529987584,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 49,
          "Census_Tract": "24510260403",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "5517fbb5-0ff1-425f-aa56-ad8446560d70",
          "Shape__Area": 18371948.79333496,
          "Shape__Length": 26086.145242566912
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.5296860002985,
                39.3232639987372,
                0
              ],
              [
                -76.529685999655,
                39.323072999024,
                0
              ],
              [
                -76.5296859994399,
                39.3230260003235,
                0
              ],
              [
                -76.5296859995745,
                39.3228979994158,
                0
              ],
              [
                -76.529685999609,
                39.3226519986694,
                0
              ],
              [
                -76.5296859995596,
                39.3223379989854,
                0
              ],
              [
                -76.5296859996783,
                39.3199059983645,
                0
              ],
              [
                -76.5296859999436,
                39.3196749985837,
                0
              ],
              [
                -76.5299709994538,
                39.3195649989524,
                0
              ],
              [
                -76.5299709995067,
                39.3194629991355,
                0
              ],
              [
                -76.5299709998863,
                39.317825998827,
                0
              ],
              [
                -76.5297329996314,
                39.317823999138,
                0
              ],
              [
                -76.5297430001758,
                39.3174679997918,
                0
              ],
              [
                -76.5299920002536,
                39.3174619987998,
                0
              ],
              [
                -76.5299929999428,
                39.317135000195,
                0
              ],
              [
                -76.5297529994723,
                39.3171119985997,
                0
              ],
              [
                -76.5296270000248,
                39.3167679988631,
                0
              ],
              [
                -76.5297750005279,
                39.316268998917,
                0
              ],
              [
                -76.5297840003571,
                39.3143659987799,
                0
              ],
              [
                -76.5297849998888,
                39.3137089991916,
                0
              ],
              [
                -76.5297860004344,
                39.3129059983309,
                0
              ],
              [
                -76.5297860013248,
                39.3125429991805,
                0
              ],
              [
                -76.5297860010771,
                39.3116189987767,
                0
              ],
              [
                -76.5297860012701,
                39.3103909993055,
                0
              ],
              [
                -76.5301179994305,
                39.3101609989839,
                0
              ],
              [
                -76.5305549996462,
                39.309858998942,
                0
              ],
              [
                -76.5309780000246,
                39.3095809988498,
                0
              ],
              [
                -76.5314099994187,
                39.3092799989057,
                0
              ],
              [
                -76.5314450005798,
                39.3092559999391,
                0
              ],
              [
                -76.5317190009811,
                39.3090649990377,
                0
              ],
              [
                -76.5323459998647,
                39.3086679986219,
                0
              ],
              [
                -76.5329190001874,
                39.3082939990792,
                0
              ],
              [
                -76.5333139997754,
                39.308010998903,
                0
              ],
              [
                -76.534167999546,
                39.30739999863,
                0
              ],
              [
                -76.5342070005157,
                39.3073769992207,
                0
              ],
              [
                -76.5343549992952,
                39.3072879989849,
                0
              ],
              [
                -76.5343819994314,
                39.3072699989144,
                0
              ],
              [
                -76.5347070005627,
                39.3070509993077,
                0
              ],
              [
                -76.5349890003471,
                39.3068549988631,
                0
              ],
              [
                -76.5353920000554,
                39.3065749994107,
                0
              ],
              [
                -76.5356699994608,
                39.3063959986476,
                0
              ],
              [
                -76.5358510005514,
                39.3062799987524,
                0
              ],
              [
                -76.5360510003971,
                39.306165999416,
                0
              ],
              [
                -76.536410999695,
                39.3059620002796,
                0
              ],
              [
                -76.5372100005738,
                39.3056009989346,
                0
              ],
              [
                -76.5375910001129,
                39.3054129998066,
                0
              ],
              [
                -76.5378929999742,
                39.3052579988715,
                0
              ],
              [
                -76.5382119998602,
                39.3051099989185,
                0
              ],
              [
                -76.5392570004808,
                39.304628998862,
                0
              ],
              [
                -76.5397180003123,
                39.3044439988631,
                0
              ],
              [
                -76.5407229995043,
                39.3041209988627,
                0
              ],
              [
                -76.540966998501,
                39.304049998743,
                0
              ],
              [
                -76.5416939999827,
                39.3038459987721,
                0
              ],
              [
                -76.5418540005543,
                39.3037950001974,
                0
              ],
              [
                -76.5421040001183,
                39.3037159989483,
                0
              ],
              [
                -76.5423960002476,
                39.3036249986877,
                0
              ],
              [
                -76.5429590004724,
                39.3034519993718,
                0
              ],
              [
                -76.5430170001026,
                39.3034359986727,
                0
              ],
              [
                -76.5440869991369,
                39.3031249992329,
                0
              ],
              [
                -76.5445939993472,
                39.302978999353,
                0
              ],
              [
                -76.5459469999784,
                39.3025919987908,
                0
              ],
              [
                -76.5460890003714,
                39.3025479985602,
                0
              ],
              [
                -76.5460460000251,
                39.3026059990082,
                0
              ],
              [
                -76.5457070003599,
                39.3030709986673,
                0
              ],
              [
                -76.5453470012172,
                39.303574999109,
                0
              ],
              [
                -76.5449040003853,
                39.3042149987946,
                0
              ],
              [
                -76.5446980001334,
                39.3045589988736,
                0
              ],
              [
                -76.544198001086,
                39.305444999229,
                0
              ],
              [
                -76.5431180002065,
                39.3073519993414,
                0
              ],
              [
                -76.54281799994,
                39.3078349993281,
                0
              ],
              [
                -76.5422789998816,
                39.3087959992569,
                0
              ],
              [
                -76.541803000148,
                39.3096959987085,
                0
              ],
              [
                -76.5414249994912,
                39.310423998646,
                0
              ],
              [
                -76.5413160001228,
                39.3105779991877,
                0
              ],
              [
                -76.5412730004464,
                39.3106149993148,
                0
              ],
              [
                -76.5410799997594,
                39.3109839987654,
                0
              ],
              [
                -76.5407059997487,
                39.3117110002328,
                0
              ],
              [
                -76.5404740004189,
                39.3120850002935,
                0
              ],
              [
                -76.5402920003236,
                39.3123979980012,
                0
              ],
              [
                -76.540028999764,
                39.3127919987655,
                0
              ],
              [
                -76.5397359998228,
                39.3131760001052,
                0
              ],
              [
                -76.5394740005289,
                39.3134890001802,
                0
              ],
              [
                -76.5387930001611,
                39.3142529990645,
                0
              ],
              [
                -76.5376650005669,
                39.3153779988992,
                0
              ],
              [
                -76.5365040003582,
                39.3165399993099,
                0
              ],
              [
                -76.5352939999657,
                39.317680999383,
                0
              ],
              [
                -76.5354549996776,
                39.3178229987814,
                0
              ],
              [
                -76.5356510004374,
                39.3180029986354,
                0
              ],
              [
                -76.5357059996241,
                39.3180799990905,
                0
              ],
              [
                -76.5357080004088,
                39.3181799990369,
                0
              ],
              [
                -76.5357040003019,
                39.318288999048,
                0
              ],
              [
                -76.5356390006216,
                39.318569998827,
                0
              ],
              [
                -76.5356229999768,
                39.3187629991484,
                0
              ],
              [
                -76.5356240003867,
                39.3188159990804,
                0
              ],
              [
                -76.5356340000433,
                39.3188699992792,
                0
              ],
              [
                -76.5356459997649,
                39.3189259989501,
                0
              ],
              [
                -76.5356720003184,
                39.3189829988279,
                0
              ],
              [
                -76.5356920004723,
                39.3190049986406,
                0
              ],
              [
                -76.5357210003103,
                39.3190289994522,
                0
              ],
              [
                -76.5357619997919,
                39.3190519991769,
                0
              ],
              [
                -76.5357909995301,
                39.3190699991344,
                0
              ],
              [
                -76.5358219996765,
                39.3190879988787,
                0
              ],
              [
                -76.5358450004016,
                39.3191139990623,
                0
              ],
              [
                -76.535861998472,
                39.3191419986332,
                0
              ],
              [
                -76.5358690004554,
                39.3191729987765,
                0
              ],
              [
                -76.5358730003712,
                39.3191989986775,
                0
              ],
              [
                -76.5358729999088,
                39.3192259988328,
                0
              ],
              [
                -76.5358699999199,
                39.3192569991088,
                0
              ],
              [
                -76.5358599997863,
                39.3192839994061,
                0
              ],
              [
                -76.5358380002223,
                39.3193209984419,
                0
              ],
              [
                -76.535821999952,
                39.319344998941,
                0
              ],
              [
                -76.5357810002899,
                39.3194009991286,
                0
              ],
              [
                -76.5357340001053,
                39.3194559991782,
                0
              ],
              [
                -76.5355079990933,
                39.3195880000943,
                0
              ],
              [
                -76.5349579999891,
                39.3198669987023,
                0
              ],
              [
                -76.5348849998351,
                39.3199059980887,
                0
              ],
              [
                -76.5348219995217,
                39.3199599985622,
                0
              ],
              [
                -76.5347849984514,
                39.3200219988438,
                0
              ],
              [
                -76.534742001158,
                39.3201699993435,
                0
              ],
              [
                -76.5347119999496,
                39.3203849990331,
                0
              ],
              [
                -76.5346820000398,
                39.3204219985977,
                0
              ],
              [
                -76.5346309992325,
                39.3204579989317,
                0
              ],
              [
                -76.5345750003955,
                39.3205209994157,
                0
              ],
              [
                -76.5345460002265,
                39.3205909993811,
                0
              ],
              [
                -76.534521000228,
                39.3207359985745,
                0
              ],
              [
                -76.5344679999598,
                39.3209849988692,
                0
              ],
              [
                -76.5344600001898,
                39.3211289988754,
                0
              ],
              [
                -76.5344599997269,
                39.3211809985819,
                0
              ],
              [
                -76.5344700007038,
                39.3212249986618,
                0
              ],
              [
                -76.534494999462,
                39.3212649993398,
                0
              ],
              [
                -76.5345260006989,
                39.3212929987008,
                0
              ],
              [
                -76.5345760003332,
                39.3213280000982,
                0
              ],
              [
                -76.5346170004814,
                39.3213619993283,
                0
              ],
              [
                -76.5346389995878,
                39.3213939992967,
                0
              ],
              [
                -76.5346640010629,
                39.3214609991865,
                0
              ],
              [
                -76.5346709998144,
                39.3216399997644,
                0
              ],
              [
                -76.5346369999536,
                39.3218129993093,
                0
              ],
              [
                -76.5345470014807,
                39.3220589985654,
                0
              ],
              [
                -76.5344840001752,
                39.3221779991179,
                0
              ],
              [
                -76.5344139999175,
                39.3223059992752,
                0
              ],
              [
                -76.5343289997217,
                39.3224099987879,
                0
              ],
              [
                -76.5341680001133,
                39.3225669992195,
                0
              ],
              [
                -76.5341069989186,
                39.3226099990735,
                0
              ],
              [
                -76.5339569994485,
                39.3226859991852,
                0
              ],
              [
                -76.5338280003486,
                39.3227849994098,
                0
              ],
              [
                -76.5337359995672,
                39.3228699981154,
                0
              ],
              [
                -76.5337100006681,
                39.3228989992653,
                0
              ],
              [
                -76.5336929990865,
                39.3229469987994,
                0
              ],
              [
                -76.5336670004055,
                39.3230009985917,
                0
              ],
              [
                -76.5336209996551,
                39.3231329991466,
                0
              ],
              [
                -76.5336030001232,
                39.3231949996415,
                0
              ],
              [
                -76.5335949989167,
                39.3232489987707,
                0
              ],
              [
                -76.5335890003311,
                39.3232719991613,
                0
              ],
              [
                -76.5335429998121,
                39.3233259988122,
                0
              ],
              [
                -76.5334599995541,
                39.3233829988195,
                0
              ],
              [
                -76.5334039988759,
                39.3234069987133,
                0
              ],
              [
                -76.5333520012425,
                39.3234579992868,
                0
              ],
              [
                -76.5333180004246,
                39.3235129985879,
                0
              ],
              [
                -76.5332230007681,
                39.3236149993287,
                0
              ],
              [
                -76.5332150004419,
                39.3236630003039,
                0
              ],
              [
                -76.533225999767,
                39.3237199987105,
                0
              ],
              [
                -76.5332360005424,
                39.323813998856,
                0
              ],
              [
                -76.5332140005023,
                39.3238849990468,
                0
              ],
              [
                -76.5331879995598,
                39.3239069994008,
                0
              ],
              [
                -76.5330739996414,
                39.3239319991955,
                0
              ],
              [
                -76.5329849998735,
                39.3239319986892,
                0
              ],
              [
                -76.5328790004756,
                39.3239059987271,
                0
              ],
              [
                -76.5327620005138,
                39.3238939986052,
                0
              ],
              [
                -76.5326309997079,
                39.3238959989713,
                0
              ],
              [
                -76.5325570000991,
                39.323940999143,
                0
              ],
              [
                -76.5324539994595,
                39.3240379997724,
                0
              ],
              [
                -76.5324170001259,
                39.3240939993272,
                0
              ],
              [
                -76.5323950000034,
                39.3241959997344,
                0
              ],
              [
                -76.5323870004605,
                39.3242669987177,
                0
              ],
              [
                -76.5323820010815,
                39.3243890004533,
                0
              ],
              [
                -76.5323879998125,
                39.3244639986281,
                0
              ],
              [
                -76.5324099995392,
                39.3245679990004,
                0
              ],
              [
                -76.5324649997438,
                39.3247229980489,
                0
              ],
              [
                -76.5325550000582,
                39.3248589988363,
                0
              ],
              [
                -76.5326669999518,
                39.3250329988748,
                0
              ],
              [
                -76.533019999932,
                39.3256320001452,
                0
              ],
              [
                -76.5332830002907,
                39.3260619992058,
                0
              ],
              [
                -76.5333590001273,
                39.3261559992011,
                0
              ],
              [
                -76.5334349996848,
                39.3262609991509,
                0
              ],
              [
                -76.5335080000652,
                39.3263469992497,
                0
              ],
              [
                -76.5335250002654,
                39.3264059994506,
                0
              ],
              [
                -76.5335390001775,
                39.3265199985871,
                0
              ],
              [
                -76.5335620001473,
                39.3266619991406,
                0
              ],
              [
                -76.5335909996106,
                39.3267609989808,
                0
              ],
              [
                -76.5336409996305,
                39.3268519987712,
                0
              ],
              [
                -76.5336850014423,
                39.3269369991396,
                0
              ],
              [
                -76.5336989999046,
                39.3270249988733,
                0
              ],
              [
                -76.5336909994347,
                39.3270909986922,
                0
              ],
              [
                -76.5336609998779,
                39.3271529992561,
                0
              ],
              [
                -76.533649999836,
                39.3272089987105,
                0
              ],
              [
                -76.5336529998775,
                39.3272659986008,
                0
              ],
              [
                -76.5336450005438,
                39.3273229989859,
                0
              ],
              [
                -76.5336259999557,
                39.3274329993034,
                0
              ],
              [
                -76.5336259995899,
                39.3274959989156,
                0
              ],
              [
                -76.5336579995833,
                39.3275729989004,
                0
              ],
              [
                -76.5336949996007,
                39.327628997823,
                0
              ],
              [
                -76.5338060003776,
                39.3277919989374,
                0
              ],
              [
                -76.5341040003859,
                39.3282949992816,
                0
              ],
              [
                -76.5341439999862,
                39.3283559992099,
                0
              ],
              [
                -76.5341520003404,
                39.328391998902,
                0
              ],
              [
                -76.5341500001127,
                39.3284169985911,
                0
              ],
              [
                -76.5341339995475,
                39.3284499991301,
                0
              ],
              [
                -76.5340960010592,
                39.3285429999305,
                0
              ],
              [
                -76.5340829985883,
                39.328656999078,
                0
              ],
              [
                -76.5340949999365,
                39.3287579985765,
                0
              ],
              [
                -76.5341120005053,
                39.3288929988025,
                0
              ],
              [
                -76.5330800009289,
                39.3301179986459,
                0
              ],
              [
                -76.5329770000309,
                39.3305579990791,
                0
              ],
              [
                -76.532816999478,
                39.3305859991007,
                0
              ],
              [
                -76.5322509989436,
                39.3306869987716,
                0
              ],
              [
                -76.531857000347,
                39.3307569986896,
                0
              ],
              [
                -76.5304480005212,
                39.3310129987642,
                0
              ],
              [
                -76.5296850005635,
                39.3311499992488,
                0
              ],
              [
                -76.5296849995029,
                39.3302799997754,
                0
              ],
              [
                -76.5296859996922,
                39.3290899997225,
                0
              ],
              [
                -76.529723000552,
                39.3273289986819,
                0
              ],
              [
                -76.5297340004398,
                39.3267859988246,
                0
              ],
              [
                -76.5297459995319,
                39.3264019976997,
                0
              ],
              [
                -76.5297589996064,
                39.3260009987961,
                0
              ],
              [
                -76.5297149998743,
                39.325321998936,
                0
              ],
              [
                -76.5296859997936,
                39.3248710003015,
                0
              ],
              [
                -76.529685999909,
                39.3245040004265,
                0
              ],
              [
                -76.5296860005454,
                39.3244559992101,
                0
              ],
              [
                -76.5296859995642,
                39.3235969988536,
                0
              ],
              [
                -76.5296859999049,
                39.3233269993451,
                0
              ],
              [
                -76.5296860002985,
                39.3232639987372,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 50,
          "Census_Tract": "24510260402",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "55e9870f-6194-4f43-92ec-faca6283abcc",
          "Shape__Area": 14406832.719238281,
          "Shape__Length": 19724.619765578533
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.5431180002065,
                39.3073519993414,
                0
              ],
              [
                -76.5433309997304,
                39.3074069989556,
                0
              ],
              [
                -76.5435890000969,
                39.3074279990949,
                0
              ],
              [
                -76.5438789998727,
                39.3074809998323,
                0
              ],
              [
                -76.5440589999879,
                39.3075559992774,
                0
              ],
              [
                -76.5441639990863,
                39.307607999395,
                0
              ],
              [
                -76.5442959996895,
                39.3077229987053,
                0
              ],
              [
                -76.5443999987699,
                39.3078449989842,
                0
              ],
              [
                -76.5445129999868,
                39.3080119990249,
                0
              ],
              [
                -76.5447320000183,
                39.3082689991091,
                0
              ],
              [
                -76.5451859995328,
                39.308662998729,
                0
              ],
              [
                -76.5454230002933,
                39.3088669998567,
                0
              ],
              [
                -76.5454749997288,
                39.308913998996,
                0
              ],
              [
                -76.5455600002583,
                39.3089649999018,
                0
              ],
              [
                -76.5457449996269,
                39.3090459988782,
                0
              ],
              [
                -76.5461900001869,
                39.3092149998717,
                0
              ],
              [
                -76.5467980005141,
                39.3095379990875,
                0
              ],
              [
                -76.546902999737,
                39.3096039989904,
                0
              ],
              [
                -76.546990000259,
                39.3096779993028,
                0
              ],
              [
                -76.5471239999896,
                39.3098089986969,
                0
              ],
              [
                -76.5471950004349,
                39.3098939993942,
                0
              ],
              [
                -76.547240000947,
                39.3099939992765,
                0
              ],
              [
                -76.5473530001156,
                39.3101540002442,
                0
              ],
              [
                -76.5475799984424,
                39.3106789992034,
                0
              ],
              [
                -76.5477640004977,
                39.3110119996423,
                0
              ],
              [
                -76.5478540005195,
                39.3111529992512,
                0
              ],
              [
                -76.5478840001828,
                39.3111799986834,
                0
              ],
              [
                -76.5479179995931,
                39.3111959990327,
                0
              ],
              [
                -76.5479970005286,
                39.3112209989979,
                0
              ],
              [
                -76.5480610013478,
                39.3112329991389,
                0
              ],
              [
                -76.54816200005,
                39.3112349989792,
                0
              ],
              [
                -76.5482620003532,
                39.3112289988707,
                0
              ],
              [
                -76.5483769993073,
                39.3111919991045,
                0
              ],
              [
                -76.5484480005638,
                39.3111849992387,
                0
              ],
              [
                -76.5485289999117,
                39.3111929993234,
                0
              ],
              [
                -76.5486020005302,
                39.3112159986658,
                0
              ],
              [
                -76.5487199994375,
                39.3112559987269,
                0
              ],
              [
                -76.5488410007253,
                39.3112749991281,
                0
              ],
              [
                -76.548972000511,
                39.3112879991025,
                0
              ],
              [
                -76.5490949995866,
                39.3112969985938,
                0
              ],
              [
                -76.5495109997848,
                39.3113209986192,
                0
              ],
              [
                -76.5496649996851,
                39.3113219987266,
                0
              ],
              [
                -76.5497480000281,
                39.3113079992349,
                0
              ],
              [
                -76.5498019988795,
                39.3112889992708,
                0
              ],
              [
                -76.5498659996998,
                39.3112889994382,
                0
              ],
              [
                -76.5499280000533,
                39.3112979985819,
                0
              ],
              [
                -76.5500920011533,
                39.3113109993921,
                0
              ],
              [
                -76.55038699884,
                39.3113179986823,
                0
              ],
              [
                -76.5503209996972,
                39.3122149994064,
                0
              ],
              [
                -76.550261,
                39.3125039992812,
                0
              ],
              [
                -76.5502109997945,
                39.3126119996395,
                0
              ],
              [
                -76.5501199994373,
                39.312728000276,
                0
              ],
              [
                -76.5499759993807,
                39.3128589990629,
                0
              ],
              [
                -76.5498299998585,
                39.3130339991908,
                0
              ],
              [
                -76.5496439987796,
                39.3132589990795,
                0
              ],
              [
                -76.5494960000594,
                39.3134249988608,
                0
              ],
              [
                -76.5493759993824,
                39.3136200002882,
                0
              ],
              [
                -76.5493619995829,
                39.3136499985515,
                0
              ],
              [
                -76.5493559984349,
                39.3136819992421,
                0
              ],
              [
                -76.5493490006487,
                39.3137400000559,
                0
              ],
              [
                -76.5493909996181,
                39.3138779993976,
                0
              ],
              [
                -76.5494100004533,
                39.3139629991938,
                0
              ],
              [
                -76.5494119988673,
                39.3140329992499,
                0
              ],
              [
                -76.5494150002643,
                39.3141009989666,
                0
              ],
              [
                -76.5493990001341,
                39.3141809986658,
                0
              ],
              [
                -76.5493769996188,
                39.314253998993,
                0
              ],
              [
                -76.5493420001378,
                39.3143459995671,
                0
              ],
              [
                -76.5493220002435,
                39.3144139993464,
                0
              ],
              [
                -76.5493149987974,
                39.3144679989711,
                0
              ],
              [
                -76.5493099994237,
                39.3145519987616,
                0
              ],
              [
                -76.5492980001598,
                39.3146309986279,
                0
              ],
              [
                -76.549267999493,
                39.3147039988691,
                0
              ],
              [
                -76.5492369995978,
                39.3147679994142,
                0
              ],
              [
                -76.5491929996047,
                39.3149439987736,
                0
              ],
              [
                -76.5491010002447,
                39.315180998728,
                0
              ],
              [
                -76.5489380008862,
                39.3158879992101,
                0
              ],
              [
                -76.5481359995527,
                39.3162559991656,
                0
              ],
              [
                -76.5474669995127,
                39.3166549991459,
                0
              ],
              [
                -76.5458469996306,
                39.317619999064,
                0
              ],
              [
                -76.5457420007521,
                39.3176899990396,
                0
              ],
              [
                -76.5452409994793,
                39.3180229994042,
                0
              ],
              [
                -76.543525999957,
                39.3191639998863,
                0
              ],
              [
                -76.5423499999685,
                39.3199409992818,
                0
              ],
              [
                -76.542234999087,
                39.3200179992581,
                0
              ],
              [
                -76.5404589988352,
                39.3212179993496,
                0
              ],
              [
                -76.5403209996827,
                39.3213829986554,
                0
              ],
              [
                -76.5398069999072,
                39.3220009993638,
                0
              ],
              [
                -76.5383329996968,
                39.323769999113,
                0
              ],
              [
                -76.5368769994703,
                39.3255990003113,
                0
              ],
              [
                -76.53648600008,
                39.3261060004147,
                0
              ],
              [
                -76.5360229998806,
                39.32670499899,
                0
              ],
              [
                -76.5341040003859,
                39.3282949992816,
                0
              ],
              [
                -76.5338060003776,
                39.3277919989374,
                0
              ],
              [
                -76.5336949996007,
                39.327628997823,
                0
              ],
              [
                -76.5336579995833,
                39.3275729989004,
                0
              ],
              [
                -76.5336259995899,
                39.3274959989156,
                0
              ],
              [
                -76.5336259999557,
                39.3274329993034,
                0
              ],
              [
                -76.5336450005438,
                39.3273229989859,
                0
              ],
              [
                -76.5336529998775,
                39.3272659986008,
                0
              ],
              [
                -76.533649999836,
                39.3272089987105,
                0
              ],
              [
                -76.5336609998779,
                39.3271529992561,
                0
              ],
              [
                -76.5336909994347,
                39.3270909986922,
                0
              ],
              [
                -76.5336989999046,
                39.3270249988733,
                0
              ],
              [
                -76.5336850014423,
                39.3269369991396,
                0
              ],
              [
                -76.5336409996305,
                39.3268519987712,
                0
              ],
              [
                -76.5335909996106,
                39.3267609989808,
                0
              ],
              [
                -76.5335620001473,
                39.3266619991406,
                0
              ],
              [
                -76.5335390001775,
                39.3265199985871,
                0
              ],
              [
                -76.5335250002654,
                39.3264059994506,
                0
              ],
              [
                -76.5335080000652,
                39.3263469992497,
                0
              ],
              [
                -76.5334349996848,
                39.3262609991509,
                0
              ],
              [
                -76.5333590001273,
                39.3261559992011,
                0
              ],
              [
                -76.5332830002907,
                39.3260619992058,
                0
              ],
              [
                -76.533019999932,
                39.3256320001452,
                0
              ],
              [
                -76.5326669999518,
                39.3250329988748,
                0
              ],
              [
                -76.5325550000582,
                39.3248589988363,
                0
              ],
              [
                -76.5324649997438,
                39.3247229980489,
                0
              ],
              [
                -76.5324099995392,
                39.3245679990004,
                0
              ],
              [
                -76.5323879998125,
                39.3244639986281,
                0
              ],
              [
                -76.5323820010815,
                39.3243890004533,
                0
              ],
              [
                -76.5323870004605,
                39.3242669987177,
                0
              ],
              [
                -76.5323950000034,
                39.3241959997344,
                0
              ],
              [
                -76.5324170001259,
                39.3240939993272,
                0
              ],
              [
                -76.5324539994595,
                39.3240379997724,
                0
              ],
              [
                -76.5325570000991,
                39.323940999143,
                0
              ],
              [
                -76.5326309997079,
                39.3238959989713,
                0
              ],
              [
                -76.5327620005138,
                39.3238939986052,
                0
              ],
              [
                -76.5328790004756,
                39.3239059987271,
                0
              ],
              [
                -76.5329849998735,
                39.3239319986892,
                0
              ],
              [
                -76.5330739996414,
                39.3239319991955,
                0
              ],
              [
                -76.5331879995598,
                39.3239069994008,
                0
              ],
              [
                -76.5332140005023,
                39.3238849990468,
                0
              ],
              [
                -76.5332360005424,
                39.323813998856,
                0
              ],
              [
                -76.533225999767,
                39.3237199987105,
                0
              ],
              [
                -76.5332150004419,
                39.3236630003039,
                0
              ],
              [
                -76.5332230007681,
                39.3236149993287,
                0
              ],
              [
                -76.5333180004246,
                39.3235129985879,
                0
              ],
              [
                -76.5333520012425,
                39.3234579992868,
                0
              ],
              [
                -76.5334039988759,
                39.3234069987133,
                0
              ],
              [
                -76.5334599995541,
                39.3233829988195,
                0
              ],
              [
                -76.5335429998121,
                39.3233259988122,
                0
              ],
              [
                -76.5335890003311,
                39.3232719991613,
                0
              ],
              [
                -76.5335949989167,
                39.3232489987707,
                0
              ],
              [
                -76.5336030001232,
                39.3231949996415,
                0
              ],
              [
                -76.5336209996551,
                39.3231329991466,
                0
              ],
              [
                -76.5336670004055,
                39.3230009985917,
                0
              ],
              [
                -76.5336929990865,
                39.3229469987994,
                0
              ],
              [
                -76.5337100006681,
                39.3228989992653,
                0
              ],
              [
                -76.5337359995672,
                39.3228699981154,
                0
              ],
              [
                -76.5338280003486,
                39.3227849994098,
                0
              ],
              [
                -76.5339569994485,
                39.3226859991852,
                0
              ],
              [
                -76.5341069989186,
                39.3226099990735,
                0
              ],
              [
                -76.5341680001133,
                39.3225669992195,
                0
              ],
              [
                -76.5343289997217,
                39.3224099987879,
                0
              ],
              [
                -76.5344139999175,
                39.3223059992752,
                0
              ],
              [
                -76.5344840001752,
                39.3221779991179,
                0
              ],
              [
                -76.5345470014807,
                39.3220589985654,
                0
              ],
              [
                -76.5346369999536,
                39.3218129993093,
                0
              ],
              [
                -76.5346709998144,
                39.3216399997644,
                0
              ],
              [
                -76.5346640010629,
                39.3214609991865,
                0
              ],
              [
                -76.5346389995878,
                39.3213939992967,
                0
              ],
              [
                -76.5346170004814,
                39.3213619993283,
                0
              ],
              [
                -76.5345760003332,
                39.3213280000982,
                0
              ],
              [
                -76.5345260006989,
                39.3212929987008,
                0
              ],
              [
                -76.534494999462,
                39.3212649993398,
                0
              ],
              [
                -76.5344700007038,
                39.3212249986618,
                0
              ],
              [
                -76.5344599997269,
                39.3211809985819,
                0
              ],
              [
                -76.5344600001898,
                39.3211289988754,
                0
              ],
              [
                -76.5344679999598,
                39.3209849988692,
                0
              ],
              [
                -76.534521000228,
                39.3207359985745,
                0
              ],
              [
                -76.5345460002265,
                39.3205909993811,
                0
              ],
              [
                -76.5345750003955,
                39.3205209994157,
                0
              ],
              [
                -76.5346309992325,
                39.3204579989317,
                0
              ],
              [
                -76.5346820000398,
                39.3204219985977,
                0
              ],
              [
                -76.5347119999496,
                39.3203849990331,
                0
              ],
              [
                -76.534742001158,
                39.3201699993435,
                0
              ],
              [
                -76.5347849984514,
                39.3200219988438,
                0
              ],
              [
                -76.5348219995217,
                39.3199599985622,
                0
              ],
              [
                -76.5348849998351,
                39.3199059980887,
                0
              ],
              [
                -76.5349579999891,
                39.3198669987023,
                0
              ],
              [
                -76.5355079990933,
                39.3195880000943,
                0
              ],
              [
                -76.5357340001053,
                39.3194559991782,
                0
              ],
              [
                -76.5357810002899,
                39.3194009991286,
                0
              ],
              [
                -76.535821999952,
                39.319344998941,
                0
              ],
              [
                -76.5358380002223,
                39.3193209984419,
                0
              ],
              [
                -76.5358599997863,
                39.3192839994061,
                0
              ],
              [
                -76.5358699999199,
                39.3192569991088,
                0
              ],
              [
                -76.5358729999088,
                39.3192259988328,
                0
              ],
              [
                -76.5358730003712,
                39.3191989986775,
                0
              ],
              [
                -76.5358690004554,
                39.3191729987765,
                0
              ],
              [
                -76.535861998472,
                39.3191419986332,
                0
              ],
              [
                -76.5358450004016,
                39.3191139990623,
                0
              ],
              [
                -76.5358219996765,
                39.3190879988787,
                0
              ],
              [
                -76.5357909995301,
                39.3190699991344,
                0
              ],
              [
                -76.5357619997919,
                39.3190519991769,
                0
              ],
              [
                -76.5357210003103,
                39.3190289994522,
                0
              ],
              [
                -76.5356920004723,
                39.3190049986406,
                0
              ],
              [
                -76.5356720003184,
                39.3189829988279,
                0
              ],
              [
                -76.5356459997649,
                39.3189259989501,
                0
              ],
              [
                -76.5356340000433,
                39.3188699992792,
                0
              ],
              [
                -76.5356240003867,
                39.3188159990804,
                0
              ],
              [
                -76.5356229999768,
                39.3187629991484,
                0
              ],
              [
                -76.5356390006216,
                39.318569998827,
                0
              ],
              [
                -76.5357040003019,
                39.318288999048,
                0
              ],
              [
                -76.5357080004088,
                39.3181799990369,
                0
              ],
              [
                -76.5357059996241,
                39.3180799990905,
                0
              ],
              [
                -76.5356510004374,
                39.3180029986354,
                0
              ],
              [
                -76.5354549996776,
                39.3178229987814,
                0
              ],
              [
                -76.5352939999657,
                39.317680999383,
                0
              ],
              [
                -76.5365040003582,
                39.3165399993099,
                0
              ],
              [
                -76.5376650005669,
                39.3153779988992,
                0
              ],
              [
                -76.5387930001611,
                39.3142529990645,
                0
              ],
              [
                -76.5394740005289,
                39.3134890001802,
                0
              ],
              [
                -76.5397359998228,
                39.3131760001052,
                0
              ],
              [
                -76.540028999764,
                39.3127919987655,
                0
              ],
              [
                -76.5402920003236,
                39.3123979980012,
                0
              ],
              [
                -76.5404740004189,
                39.3120850002935,
                0
              ],
              [
                -76.5407059997487,
                39.3117110002328,
                0
              ],
              [
                -76.5410799997594,
                39.3109839987654,
                0
              ],
              [
                -76.5412730004464,
                39.3106149993148,
                0
              ],
              [
                -76.5413160001228,
                39.3105779991877,
                0
              ],
              [
                -76.5414249994912,
                39.310423998646,
                0
              ],
              [
                -76.541803000148,
                39.3096959987085,
                0
              ],
              [
                -76.5422789998816,
                39.3087959992569,
                0
              ],
              [
                -76.54281799994,
                39.3078349993281,
                0
              ],
              [
                -76.5431180002065,
                39.3073519993414,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 51,
          "Census_Tract": "24510200200",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "de756895-a363-4c7c-8a34-37b7b83bf91b",
          "Shape__Area": 9976071.079406738,
          "Shape__Length": 14757.320893809923
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6593530005165,
                39.293351999137,
                0
              ],
              [
                -76.6585739997248,
                39.2933669990243,
                0
              ],
              [
                -76.6581039997289,
                39.2933919991585,
                0
              ],
              [
                -76.657808000095,
                39.2933959987638,
                0
              ],
              [
                -76.657033999661,
                39.2934209987137,
                0
              ],
              [
                -76.6562740000379,
                39.2934389987115,
                0
              ],
              [
                -76.6560040007815,
                39.2934459991041,
                0
              ],
              [
                -76.6547389985862,
                39.2935129986871,
                0
              ],
              [
                -76.6540159996791,
                39.2935359992415,
                0
              ],
              [
                -76.6532230002164,
                39.2935649985707,
                0
              ],
              [
                -76.6530209999375,
                39.2935639986105,
                0
              ],
              [
                -76.6523510000429,
                39.2936029987747,
                0
              ],
              [
                -76.6517720012144,
                39.2936279986862,
                0
              ],
              [
                -76.6512360003446,
                39.2936639991473,
                0
              ],
              [
                -76.6505849999161,
                39.2936849989629,
                0
              ],
              [
                -76.6503829998594,
                39.2936979994509,
                0
              ],
              [
                -76.6503599998829,
                39.2929869988244,
                0
              ],
              [
                -76.6503559995851,
                39.2928039988282,
                0
              ],
              [
                -76.6503369997387,
                39.2924009989538,
                0
              ],
              [
                -76.6503119985735,
                39.2919279985515,
                0
              ],
              [
                -76.6502959987078,
                39.291585998744,
                0
              ],
              [
                -76.6502790002331,
                39.2911950000698,
                0
              ],
              [
                -76.6502560001186,
                39.2908539990005,
                0
              ],
              [
                -76.6502300004273,
                39.290476999148,
                0
              ],
              [
                -76.6502179998814,
                39.2899239993313,
                0
              ],
              [
                -76.6501640000402,
                39.2893899992726,
                0
              ],
              [
                -76.6501229998464,
                39.2887769989083,
                0
              ],
              [
                -76.6500949994369,
                39.2880289989031,
                0
              ],
              [
                -76.6514870001515,
                39.2879669985859,
                0
              ],
              [
                -76.6528690004596,
                39.2879109990268,
                0
              ],
              [
                -76.6536329994953,
                39.2878759987328,
                0
              ],
              [
                -76.6538349995585,
                39.2878780002346,
                0
              ],
              [
                -76.6547010005122,
                39.2878609988495,
                0
              ],
              [
                -76.6555730011938,
                39.2878309990078,
                0
              ],
              [
                -76.6556340014933,
                39.2878259993773,
                0
              ],
              [
                -76.6558639999436,
                39.2878239990235,
                0
              ],
              [
                -76.6560220004027,
                39.2878209992576,
                0
              ],
              [
                -76.6562219992723,
                39.2878139994173,
                0
              ],
              [
                -76.6564929992924,
                39.2878019986847,
                0
              ],
              [
                -76.6573360001153,
                39.2877679988688,
                0
              ],
              [
                -76.6581629998596,
                39.2877319990035,
                0
              ],
              [
                -76.6588290001098,
                39.2876650000221,
                0
              ],
              [
                -76.6589780004787,
                39.2876559990107,
                0
              ],
              [
                -76.6593590011758,
                39.287632999214,
                0
              ],
              [
                -76.6595919994615,
                39.2876189994485,
                0
              ],
              [
                -76.6611819997,
                39.2875599989187,
                0
              ],
              [
                -76.6620150003619,
                39.2875239991623,
                0
              ],
              [
                -76.6621940004645,
                39.2875149993145,
                0
              ],
              [
                -76.6623280005059,
                39.2875099989308,
                0
              ],
              [
                -76.6629239996804,
                39.2874239991878,
                0
              ],
              [
                -76.6630489996086,
                39.2874229994506,
                0
              ],
              [
                -76.663179000038,
                39.2874319988317,
                0
              ],
              [
                -76.6632699995351,
                39.2874509991026,
                0
              ],
              [
                -76.6633459996946,
                39.2874729990825,
                0
              ],
              [
                -76.6634379997772,
                39.2875119989396,
                0
              ],
              [
                -76.6635229996846,
                39.2875539989184,
                0
              ],
              [
                -76.6636130003712,
                39.2876159991945,
                0
              ],
              [
                -76.6640409984338,
                39.287848999169,
                0
              ],
              [
                -76.6644480004745,
                39.2880939987491,
                0
              ],
              [
                -76.6648149999674,
                39.2884179991012,
                0
              ],
              [
                -76.6649930011006,
                39.2885769989382,
                0
              ],
              [
                -76.6652290005884,
                39.2888229987171,
                0
              ],
              [
                -76.6654190012866,
                39.2890489998704,
                0
              ],
              [
                -76.6655630003653,
                39.2892689986035,
                0
              ],
              [
                -76.6657849996526,
                39.2896639986215,
                0
              ],
              [
                -76.6660559995099,
                39.2902529986416,
                0
              ],
              [
                -76.6662059989251,
                39.2904629989229,
                0
              ],
              [
                -76.6665300004171,
                39.291021999004,
                0
              ],
              [
                -76.6667129994682,
                39.291262999051,
                0
              ],
              [
                -76.6669230001901,
                39.2914939985726,
                0
              ],
              [
                -76.6672150006345,
                39.2918429977709,
                0
              ],
              [
                -76.6674580001287,
                39.2920739987802,
                0
              ],
              [
                -76.6678579998797,
                39.2924119992528,
                0
              ],
              [
                -76.6684660008303,
                39.2928649987831,
                0
              ],
              [
                -76.6686629993515,
                39.2929729995844,
                0
              ],
              [
                -76.6688340004098,
                39.2930189988049,
                0
              ],
              [
                -76.6689990002534,
                39.2930709988268,
                0
              ],
              [
                -76.6691830002402,
                39.2931529986951,
                0
              ],
              [
                -76.6693340001662,
                39.2932299989703,
                0
              ],
              [
                -76.6694389999324,
                39.2933229985859,
                0
              ],
              [
                -76.6695439997726,
                39.2934249993708,
                0
              ],
              [
                -76.6696420005143,
                39.2935279991334,
                0
              ],
              [
                -76.6696840001733,
                39.2935929996639,
                0
              ],
              [
                -76.6696950005218,
                39.2936279988839,
                0
              ],
              [
                -76.6697249998019,
                39.2938239987896,
                0
              ],
              [
                -76.6697119994649,
                39.2941629990742,
                0
              ],
              [
                -76.6697210002807,
                39.2942559987094,
                0
              ],
              [
                -76.669717000533,
                39.2942759995819,
                0
              ],
              [
                -76.6689640001683,
                39.2943089989796,
                0
              ],
              [
                -76.6686639988352,
                39.2943249992404,
                0
              ],
              [
                -76.668453999526,
                39.2943339989631,
                0
              ],
              [
                -76.6680369995121,
                39.2943559988114,
                0
              ],
              [
                -76.6675640004488,
                39.2943689987089,
                0
              ],
              [
                -76.6667110004863,
                39.2944119990234,
                0
              ],
              [
                -76.6658220002998,
                39.2944419991176,
                0
              ],
              [
                -76.6649269996901,
                39.294451999284,
                0
              ],
              [
                -76.664895001065,
                39.2939359993711,
                0
              ],
              [
                -76.664462999864,
                39.293630998585,
                0
              ],
              [
                -76.6644089996244,
                39.2935949996097,
                0
              ],
              [
                -76.6643310015722,
                39.2935429994502,
                0
              ],
              [
                -76.6641730002495,
                39.2934519992762,
                0
              ],
              [
                -76.6640299997608,
                39.2933830004489,
                0
              ],
              [
                -76.6638840013124,
                39.2933189992778,
                0
              ],
              [
                -76.6637250002951,
                39.2932649987471,
                0
              ],
              [
                -76.6636420005638,
                39.2932399993232,
                0
              ],
              [
                -76.6635339987837,
                39.2932159992385,
                0
              ],
              [
                -76.663403000093,
                39.2931959991877,
                0
              ],
              [
                -76.6632749994891,
                39.2931839991037,
                0
              ],
              [
                -76.6631240003261,
                39.2931799992182,
                0
              ],
              [
                -76.6628950002608,
                39.2931819986819,
                0
              ],
              [
                -76.6624550000374,
                39.2932080003488,
                0
              ],
              [
                -76.6613509995161,
                39.2932589992674,
                0
              ],
              [
                -76.6593530005165,
                39.293351999137,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 52,
          "Census_Tract": "24510200300",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "2cd16b96-22ea-4f7e-87f6-930f70f83559",
          "Shape__Area": 2627834.7353515625,
          "Shape__Length": 7877.388500814025
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6464260008483,
                39.2794889991443,
                0
              ],
              [
                -76.6478459994876,
                39.2791129994309,
                0
              ],
              [
                -76.6479769995152,
                39.2790749989397,
                0
              ],
              [
                -76.6481210003383,
                39.2793359991818,
                0
              ],
              [
                -76.6481699999001,
                39.2794229992088,
                0
              ],
              [
                -76.6487759994756,
                39.2805569989049,
                0
              ],
              [
                -76.6491259987161,
                39.2811829994114,
                0
              ],
              [
                -76.6491579996146,
                39.2812419993751,
                0
              ],
              [
                -76.649168999828,
                39.281260998658,
                0
              ],
              [
                -76.6491819992823,
                39.2812839987866,
                0
              ],
              [
                -76.6494880014056,
                39.2818199977222,
                0
              ],
              [
                -76.6495679996808,
                39.2819589986424,
                0
              ],
              [
                -76.6496879995751,
                39.2821919979102,
                0
              ],
              [
                -76.6497719990756,
                39.2823869982989,
                0
              ],
              [
                -76.6497830005527,
                39.2830089992088,
                0
              ],
              [
                -76.6498339998926,
                39.2835819989693,
                0
              ],
              [
                -76.6498780012175,
                39.2841639988651,
                0
              ],
              [
                -76.6499030002906,
                39.2849939987557,
                0
              ],
              [
                -76.6499619988415,
                39.2856829993081,
                0
              ],
              [
                -76.6499689998864,
                39.2857799986889,
                0
              ],
              [
                -76.65000299938,
                39.2865259994034,
                0
              ],
              [
                -76.6500370005509,
                39.2870069991799,
                0
              ],
              [
                -76.650074999676,
                39.2874930000923,
                0
              ],
              [
                -76.6500839996054,
                39.2876949987885,
                0
              ],
              [
                -76.6500949994369,
                39.2880289989031,
                0
              ],
              [
                -76.6486929996245,
                39.2880989993134,
                0
              ],
              [
                -76.6478299994477,
                39.2881239992889,
                0
              ],
              [
                -76.6469589997793,
                39.2881479987679,
                0
              ],
              [
                -76.6469399985476,
                39.2879149989618,
                0
              ],
              [
                -76.6469249998309,
                39.2876549991886,
                0
              ],
              [
                -76.6468910003575,
                39.2871789986639,
                0
              ],
              [
                -76.6468789989458,
                39.2870019993356,
                0
              ],
              [
                -76.646870000184,
                39.2868099996624,
                0
              ],
              [
                -76.6468369994867,
                39.2861609993467,
                0
              ],
              [
                -76.6468019993478,
                39.285656000105,
                0
              ],
              [
                -76.6467749996282,
                39.2851749976658,
                0
              ],
              [
                -76.6467339998143,
                39.2846329985946,
                0
              ],
              [
                -76.6467299995185,
                39.2845359989911,
                0
              ],
              [
                -76.6467190000109,
                39.2842419991384,
                0
              ],
              [
                -76.6466930000066,
                39.2836949980491,
                0
              ],
              [
                -76.6466660004712,
                39.2831469994178,
                0
              ],
              [
                -76.646642999768,
                39.2827579988197,
                0
              ],
              [
                -76.6466180004736,
                39.2821019993869,
                0
              ],
              [
                -76.6466099996178,
                39.2820079989146,
                0
              ],
              [
                -76.6465739999399,
                39.2815249988593,
                0
              ],
              [
                -76.6465379996094,
                39.281051998973,
                0
              ],
              [
                -76.6464579999977,
                39.2798949994034,
                0
              ],
              [
                -76.6464260008483,
                39.2794889991443,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 53,
          "Census_Tract": "24510200400",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "085d5bd5-3a17-4783-96b1-a44e04e9dd6e",
          "Shape__Area": 4175155.9130859375,
          "Shape__Length": 10511.862018456435
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6499689998864,
                39.2857799986889,
                0
              ],
              [
                -76.6503050000274,
                39.2856730000875,
                0
              ],
              [
                -76.6506380005701,
                39.2855539988854,
                0
              ],
              [
                -76.6513050006524,
                39.2853209994329,
                0
              ],
              [
                -76.6521580000688,
                39.2850419994311,
                0
              ],
              [
                -76.6526219998191,
                39.2848739989663,
                0
              ],
              [
                -76.6526840001701,
                39.2848519992787,
                0
              ],
              [
                -76.6531839991599,
                39.2846809990052,
                0
              ],
              [
                -76.6538079995428,
                39.2844619994012,
                0
              ],
              [
                -76.6545380001261,
                39.2842130003871,
                0
              ],
              [
                -76.6548629994487,
                39.2840739992169,
                0
              ],
              [
                -76.6549250004331,
                39.2840379987319,
                0
              ],
              [
                -76.6550149994816,
                39.2839879979583,
                0
              ],
              [
                -76.6550729994624,
                39.2839559994318,
                0
              ],
              [
                -76.6554789986549,
                39.2836969990883,
                0
              ],
              [
                -76.6555389991096,
                39.2836579991831,
                0
              ],
              [
                -76.6559279995053,
                39.2834049987338,
                0
              ],
              [
                -76.6561980001264,
                39.2832369994048,
                0
              ],
              [
                -76.6567129995604,
                39.2828989990805,
                0
              ],
              [
                -76.6572920013524,
                39.2825179989641,
                0
              ],
              [
                -76.6578720010501,
                39.2821409991533,
                0
              ],
              [
                -76.6582639999244,
                39.2818979989807,
                0
              ],
              [
                -76.6586670005403,
                39.2816249989986,
                0
              ],
              [
                -76.6589850010591,
                39.2814129990113,
                0
              ],
              [
                -76.6590260006935,
                39.2813840000404,
                0
              ],
              [
                -76.6598600000274,
                39.2823209986184,
                0
              ],
              [
                -76.6599650004248,
                39.2825089985829,
                0
              ],
              [
                -76.6599879998703,
                39.2826239985868,
                0
              ],
              [
                -76.659981000488,
                39.2828159988228,
                0
              ],
              [
                -76.6597869999263,
                39.2838369991907,
                0
              ],
              [
                -76.6596369994485,
                39.284426999341,
                0
              ],
              [
                -76.6593320001339,
                39.2853049991956,
                0
              ],
              [
                -76.659265999658,
                39.285629999131,
                0
              ],
              [
                -76.6592589997441,
                39.2857629994044,
                0
              ],
              [
                -76.6592760000931,
                39.2858959990285,
                0
              ],
              [
                -76.6593350003368,
                39.2860439991978,
                0
              ],
              [
                -76.6594360007691,
                39.2861999991445,
                0
              ],
              [
                -76.6595309995194,
                39.2863149988483,
                0
              ],
              [
                -76.6597029994724,
                39.2864499986304,
                0
              ],
              [
                -76.6599179994261,
                39.2866299993786,
                0
              ],
              [
                -76.6600840001469,
                39.286779998677,
                0
              ],
              [
                -76.660197000351,
                39.2868739991604,
                0
              ],
              [
                -76.6602919996839,
                39.2869229986906,
                0
              ],
              [
                -76.6603750005291,
                39.2869529988695,
                0
              ],
              [
                -76.6605259997855,
                39.2869909987896,
                0
              ],
              [
                -76.6607240010872,
                39.2870309988441,
                0
              ],
              [
                -76.661048999958,
                39.2871049994151,
                0
              ],
              [
                -76.6611880005638,
                39.2871439988318,
                0
              ],
              [
                -76.6614550005627,
                39.2872509987333,
                0
              ],
              [
                -76.661665999726,
                39.2873129987611,
                0
              ],
              [
                -76.661800000281,
                39.2873279994368,
                0
              ],
              [
                -76.6619030004458,
                39.2873409993309,
                0
              ],
              [
                -76.6621340000027,
                39.2873459992943,
                0
              ],
              [
                -76.6623699996212,
                39.2873449988058,
                0
              ],
              [
                -76.6625099996858,
                39.287352999001,
                0
              ],
              [
                -76.6626130010532,
                39.2873669990188,
                0
              ],
              [
                -76.6626910004371,
                39.2873789977327,
                0
              ],
              [
                -76.6627680003138,
                39.2873940002591,
                0
              ],
              [
                -76.6628349988674,
                39.2874029992953,
                0
              ],
              [
                -76.6629239996804,
                39.2874239991878,
                0
              ],
              [
                -76.6623280005059,
                39.2875099989308,
                0
              ],
              [
                -76.6621940004645,
                39.2875149993145,
                0
              ],
              [
                -76.6620150003619,
                39.2875239991623,
                0
              ],
              [
                -76.6611819997,
                39.2875599989187,
                0
              ],
              [
                -76.6595919994615,
                39.2876189994485,
                0
              ],
              [
                -76.6593590011758,
                39.287632999214,
                0
              ],
              [
                -76.6589780004787,
                39.2876559990107,
                0
              ],
              [
                -76.6588290001098,
                39.2876650000221,
                0
              ],
              [
                -76.6581629998596,
                39.2877319990035,
                0
              ],
              [
                -76.6573360001153,
                39.2877679988688,
                0
              ],
              [
                -76.6564929992924,
                39.2878019986847,
                0
              ],
              [
                -76.6562219992723,
                39.2878139994173,
                0
              ],
              [
                -76.6560220004027,
                39.2878209992576,
                0
              ],
              [
                -76.6558639999436,
                39.2878239990235,
                0
              ],
              [
                -76.6556340014933,
                39.2878259993773,
                0
              ],
              [
                -76.6555730011938,
                39.2878309990078,
                0
              ],
              [
                -76.6547010005122,
                39.2878609988495,
                0
              ],
              [
                -76.6538349995585,
                39.2878780002346,
                0
              ],
              [
                -76.6536329994953,
                39.2878759987328,
                0
              ],
              [
                -76.6528690004596,
                39.2879109990268,
                0
              ],
              [
                -76.6514870001515,
                39.2879669985859,
                0
              ],
              [
                -76.6500949994369,
                39.2880289989031,
                0
              ],
              [
                -76.6500839996054,
                39.2876949987885,
                0
              ],
              [
                -76.650074999676,
                39.2874930000923,
                0
              ],
              [
                -76.6500370005509,
                39.2870069991799,
                0
              ],
              [
                -76.65000299938,
                39.2865259994034,
                0
              ],
              [
                -76.6499689998864,
                39.2857799986889,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 54,
          "Census_Tract": "24510270803",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "557f92b0-9685-4dc5-9616-8783b1686885",
          "Shape__Area": 23603365.225646973,
          "Shape__Length": 21901.088541439512
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.573562999545,
                39.3685389993794,
                0
              ],
              [
                -76.5737479991969,
                39.3682779987142,
                0
              ],
              [
                -76.5738239998732,
                39.3681609986726,
                0
              ],
              [
                -76.5738970003399,
                39.3680119988213,
                0
              ],
              [
                -76.5740070005079,
                39.3677059988027,
                0
              ],
              [
                -76.5740479999396,
                39.3675399994456,
                0
              ],
              [
                -76.574061999661,
                39.3673279987533,
                0
              ],
              [
                -76.5740640002032,
                39.3671559988068,
                0
              ],
              [
                -76.5740479997303,
                39.3669249991055,
                0
              ],
              [
                -76.5740120002692,
                39.3667509987703,
                0
              ],
              [
                -76.5739329998159,
                39.3664749985958,
                0
              ],
              [
                -76.5736799995863,
                39.3656819991363,
                0
              ],
              [
                -76.5735409985244,
                39.3651260001071,
                0
              ],
              [
                -76.5734670003508,
                39.3646539992094,
                0
              ],
              [
                -76.5734160008811,
                39.3643199986227,
                0
              ],
              [
                -76.5733750013818,
                39.3639199991,
                0
              ],
              [
                -76.5733479997428,
                39.3635949991946,
                0
              ],
              [
                -76.5732910005706,
                39.3631429993321,
                0
              ],
              [
                -76.5732470002719,
                39.3627339993175,
                0
              ],
              [
                -76.5731910004661,
                39.3621869989524,
                0
              ],
              [
                -76.5731099990901,
                39.3612979986036,
                0
              ],
              [
                -76.5730930001217,
                39.3610009991134,
                0
              ],
              [
                -76.573086999905,
                39.3607149988537,
                0
              ],
              [
                -76.5730809994569,
                39.3605239998695,
                0
              ],
              [
                -76.5730840003917,
                39.3600899988145,
                0
              ],
              [
                -76.5731240005802,
                39.3596849990151,
                0
              ],
              [
                -76.573171000162,
                39.3592339993039,
                0
              ],
              [
                -76.5732370011623,
                39.3588309979015,
                0
              ],
              [
                -76.5732719997443,
                39.3585909985585,
                0
              ],
              [
                -76.5733190004546,
                39.3583599988254,
                0
              ],
              [
                -76.5733999997204,
                39.358010999853,
                0
              ],
              [
                -76.5732639995585,
                39.3578739987704,
                0
              ],
              [
                -76.5731119997655,
                39.3576269992268,
                0
              ],
              [
                -76.5730550003543,
                39.3574799990613,
                0
              ],
              [
                -76.5730149995024,
                39.3573469986874,
                0
              ],
              [
                -76.5729679991545,
                39.357217999198,
                0
              ],
              [
                -76.5729259998242,
                39.3570369990145,
                0
              ],
              [
                -76.5729270002436,
                39.3568809992888,
                0
              ],
              [
                -76.5729389995679,
                39.3567059986845,
                0
              ],
              [
                -76.5730069996604,
                39.3563139988269,
                0
              ],
              [
                -76.5730940003184,
                39.3557449987592,
                0
              ],
              [
                -76.5731170004235,
                39.3556379991348,
                0
              ],
              [
                -76.5731170002755,
                39.3555289992233,
                0
              ],
              [
                -76.5731159994848,
                39.355437998843,
                0
              ],
              [
                -76.5731190010971,
                39.3553749991029,
                0
              ],
              [
                -76.5730909998888,
                39.3553019993418,
                0
              ],
              [
                -76.572912000476,
                39.3551019993888,
                0
              ],
              [
                -76.5728169999622,
                39.3550529988113,
                0
              ],
              [
                -76.5727740003041,
                39.3550079999503,
                0
              ],
              [
                -76.572746000332,
                39.3549419988824,
                0
              ],
              [
                -76.5727559984329,
                39.3548279992131,
                0
              ],
              [
                -76.5727619996063,
                39.354636999319,
                0
              ],
              [
                -76.5728110015609,
                39.3544279993424,
                0
              ],
              [
                -76.5728550004195,
                39.3542289992355,
                0
              ],
              [
                -76.5729270000766,
                39.3540489993191,
                0
              ],
              [
                -76.5730150004039,
                39.353902999301,
                0
              ],
              [
                -76.573639000231,
                39.3540259993287,
                0
              ],
              [
                -76.573870999497,
                39.3540700003834,
                0
              ],
              [
                -76.5740560003133,
                39.3541169986573,
                0
              ],
              [
                -76.5743159995332,
                39.3542239992203,
                0
              ],
              [
                -76.5748370015168,
                39.3544559990973,
                0
              ],
              [
                -76.5756279998683,
                39.3548439993103,
                0
              ],
              [
                -76.5756580006305,
                39.3548589986782,
                0
              ],
              [
                -76.5757879996048,
                39.3549229990101,
                0
              ],
              [
                -76.5759919997703,
                39.354819998822,
                0
              ],
              [
                -76.5761450006836,
                39.3547409994312,
                0
              ],
              [
                -76.5763090005673,
                39.354659999288,
                0
              ],
              [
                -76.5764199988589,
                39.3546239992248,
                0
              ],
              [
                -76.576569000412,
                39.3545869991749,
                0
              ],
              [
                -76.5766440004743,
                39.3545759991198,
                0
              ],
              [
                -76.5766980000887,
                39.3545669987327,
                0
              ],
              [
                -76.5768450004143,
                39.3545479988021,
                0
              ],
              [
                -76.5770730002766,
                39.3545239990804,
                0
              ],
              [
                -76.5774349997249,
                39.3544879989341,
                0
              ],
              [
                -76.5776129997096,
                39.3544689986511,
                0
              ],
              [
                -76.5778950002619,
                39.3544539987773,
                0
              ],
              [
                -76.5780289995925,
                39.3544509992512,
                0
              ],
              [
                -76.5782329999967,
                39.3544469986448,
                0
              ],
              [
                -76.5784619999695,
                39.3544569992986,
                0
              ],
              [
                -76.5786580005095,
                39.3544859986534,
                0
              ],
              [
                -76.5787980007812,
                39.3545139990379,
                0
              ],
              [
                -76.5789469999143,
                39.3545499985579,
                0
              ],
              [
                -76.579094999468,
                39.3545999990753,
                0
              ],
              [
                -76.5791949991476,
                39.3546439989247,
                0
              ],
              [
                -76.579332999609,
                39.3546899991822,
                0
              ],
              [
                -76.5796600000625,
                39.3548179987023,
                0
              ],
              [
                -76.5797819995196,
                39.3548619992243,
                0
              ],
              [
                -76.5798839994508,
                39.3549029989471,
                0
              ],
              [
                -76.5799889996376,
                39.3549549992709,
                0
              ],
              [
                -76.5801109994706,
                39.3550089977041,
                0
              ],
              [
                -76.5802260003927,
                39.355057998919,
                0
              ],
              [
                -76.5803380009173,
                39.3550989988152,
                0
              ],
              [
                -76.5805029996377,
                39.3551719992508,
                0
              ],
              [
                -76.5806710003544,
                39.3552539986776,
                0
              ],
              [
                -76.580861999915,
                39.3553339991244,
                0
              ],
              [
                -76.5811370013702,
                39.3554339986746,
                0
              ],
              [
                -76.5815969999827,
                39.3555509990702,
                0
              ],
              [
                -76.5818019984932,
                39.3555849990804,
                0
              ],
              [
                -76.5819640002641,
                39.3556019992788,
                0
              ],
              [
                -76.5821340002354,
                39.355612999001,
                0
              ],
              [
                -76.5823249998012,
                39.3556079993042,
                0
              ],
              [
                -76.5826830004926,
                39.3555969986573,
                0
              ],
              [
                -76.5843590003687,
                39.3555599990662,
                0
              ],
              [
                -76.5865079997849,
                39.3555139993439,
                0
              ],
              [
                -76.586613000456,
                39.3555119995722,
                0
              ],
              [
                -76.587102000331,
                39.3555009991691,
                0
              ],
              [
                -76.5875589994545,
                39.3554899997893,
                0
              ],
              [
                -76.5880470000322,
                39.3554799989831,
                0
              ],
              [
                -76.5885160003779,
                39.3554679993721,
                0
              ],
              [
                -76.5889699998245,
                39.3554579991504,
                0
              ],
              [
                -76.5890159998336,
                39.355456999778,
                0
              ],
              [
                -76.5891870005246,
                39.3554469991789,
                0
              ],
              [
                -76.5893639995618,
                39.355431999437,
                0
              ],
              [
                -76.5894879988821,
                39.3554239987401,
                0
              ],
              [
                -76.589560999894,
                39.355417998812,
                0
              ],
              [
                -76.5896149995459,
                39.3560569987483,
                0
              ],
              [
                -76.5896350004885,
                39.3563219986555,
                0
              ],
              [
                -76.5896490002561,
                39.3565449993773,
                0
              ],
              [
                -76.5896529997837,
                39.3567639992141,
                0
              ],
              [
                -76.5896390008507,
                39.356939997823,
                0
              ],
              [
                -76.5896150003448,
                39.3571169991716,
                0
              ],
              [
                -76.5895820008918,
                39.3573149987349,
                0
              ],
              [
                -76.5895390005425,
                39.3574799988942,
                0
              ],
              [
                -76.5894650011967,
                39.3576779994019,
                0
              ],
              [
                -76.589290000471,
                39.3580949986227,
                0
              ],
              [
                -76.5891389990995,
                39.3584279988998,
                0
              ],
              [
                -76.5889970013139,
                39.358743999188,
                0
              ],
              [
                -76.5888180003175,
                39.3591059987014,
                0
              ],
              [
                -76.5884680002041,
                39.3598169991791,
                0
              ],
              [
                -76.5883700001545,
                39.3600109993499,
                0
              ],
              [
                -76.5878899998545,
                39.3609699988852,
                0
              ],
              [
                -76.5877539996915,
                39.3612809986385,
                0
              ],
              [
                -76.5876670005582,
                39.3614599988313,
                0
              ],
              [
                -76.5875780005225,
                39.3616409987858,
                0
              ],
              [
                -76.5874779999397,
                39.3618829988148,
                0
              ],
              [
                -76.5873810000453,
                39.3620909990809,
                0
              ],
              [
                -76.5872859988419,
                39.3622999997871,
                0
              ],
              [
                -76.5871629998821,
                39.3625639986579,
                0
              ],
              [
                -76.5869119989133,
                39.3631019982258,
                0
              ],
              [
                -76.5865859999302,
                39.3637969993092,
                0
              ],
              [
                -76.5863579999725,
                39.3642880002527,
                0
              ],
              [
                -76.5863090005649,
                39.3643809987148,
                0
              ],
              [
                -76.5861550002038,
                39.3647389994045,
                0
              ],
              [
                -76.5860599987966,
                39.3649479989673,
                0
              ],
              [
                -76.585992001179,
                39.3650819987723,
                0
              ],
              [
                -76.5859769995734,
                39.3651100004239,
                0
              ],
              [
                -76.5858800004155,
                39.3653389991328,
                0
              ],
              [
                -76.5857939998205,
                39.3655209989213,
                0
              ],
              [
                -76.5857169995193,
                39.3656629987402,
                0
              ],
              [
                -76.585622001496,
                39.3658439992966,
                0
              ],
              [
                -76.5855749998444,
                39.3659279988512,
                0
              ],
              [
                -76.5855560000065,
                39.3659619987948,
                0
              ],
              [
                -76.5855099999646,
                39.3660389985952,
                0
              ],
              [
                -76.585488999512,
                39.3660729986819,
                0
              ],
              [
                -76.5852979997274,
                39.3664029987694,
                0
              ],
              [
                -76.5851300005668,
                39.3667019987205,
                0
              ],
              [
                -76.5849460002669,
                39.3670169994302,
                0
              ],
              [
                -76.5848170004969,
                39.3672320001986,
                0
              ],
              [
                -76.5847030004546,
                39.3674349991795,
                0
              ],
              [
                -76.5845619998802,
                39.3676559994295,
                0
              ],
              [
                -76.5844829999236,
                39.3677989992241,
                0
              ],
              [
                -76.5844210002778,
                39.3679029993545,
                0
              ],
              [
                -76.5843579993087,
                39.3680019986067,
                0
              ],
              [
                -76.5843160000428,
                39.3680629986872,
                0
              ],
              [
                -76.584160001508,
                39.3683389986162,
                0
              ],
              [
                -76.5840529999662,
                39.3685249985749,
                0
              ],
              [
                -76.5838709998072,
                39.3688269987474,
                0
              ],
              [
                -76.5837790005661,
                39.3689779992364,
                0
              ],
              [
                -76.5836510005174,
                39.3691990001769,
                0
              ],
              [
                -76.5836090005565,
                39.3692829985625,
                0
              ],
              [
                -76.5831520002691,
                39.3700529989321,
                0
              ],
              [
                -76.5831080008304,
                39.3701229988514,
                0
              ],
              [
                -76.5830589999705,
                39.3702029990437,
                0
              ],
              [
                -76.5829949995112,
                39.3703139999148,
                0
              ],
              [
                -76.5819559998416,
                39.3721049986207,
                0
              ],
              [
                -76.5790290010703,
                39.3720909990097,
                0
              ],
              [
                -76.5780019994616,
                39.3720929987405,
                0
              ],
              [
                -76.571996000318,
                39.3721079986876,
                0
              ],
              [
                -76.5699970001291,
                39.3721209991969,
                0
              ],
              [
                -76.5701000000112,
                39.3720389986155,
                0
              ],
              [
                -76.5702179992857,
                39.3719259988674,
                0
              ],
              [
                -76.5704210004772,
                39.3717249992105,
                0
              ],
              [
                -76.5709479996475,
                39.3712009991626,
                0
              ],
              [
                -76.5713499999782,
                39.3708009999767,
                0
              ],
              [
                -76.5717209984294,
                39.370432999663,
                0
              ],
              [
                -76.5721379996475,
                39.3700379992027,
                0
              ],
              [
                -76.5724239985637,
                39.369788000428,
                0
              ],
              [
                -76.5727320003314,
                39.3694869990248,
                0
              ],
              [
                -76.5728539992764,
                39.3693539993625,
                0
              ],
              [
                -76.5729869995262,
                39.369203000395,
                0
              ],
              [
                -76.5731919994459,
                39.368965998715,
                0
              ],
              [
                -76.5734449999521,
                39.3686719989947,
                0
              ],
              [
                -76.5735130015626,
                39.368596998685,
                0
              ],
              [
                -76.573562999545,
                39.3685389993794,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 55,
          "Census_Tract": "24510270901",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "8294df52-77eb-46e7-a6f8-e4ea2796d791",
          "Shape__Area": 7291663.633178711,
          "Shape__Length": 11654.119752166795
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.5920060001953,
                39.3461629988287,
                0
              ],
              [
                -76.5922280002259,
                39.3461619990301,
                0
              ],
              [
                -76.5922470001322,
                39.346161999171,
                0
              ],
              [
                -76.5928440004817,
                39.3461789988791,
                0
              ],
              [
                -76.5930119996811,
                39.3461589994095,
                0
              ],
              [
                -76.5931820003692,
                39.3461269987856,
                0
              ],
              [
                -76.5933080000611,
                39.3460959986753,
                0
              ],
              [
                -76.5934410005626,
                39.3460619988357,
                0
              ],
              [
                -76.5935670005172,
                39.3460209992716,
                0
              ],
              [
                -76.5936690005175,
                39.3459799976975,
                0
              ],
              [
                -76.593991999329,
                39.3458369987467,
                0
              ],
              [
                -76.5942489994233,
                39.345717999414,
                0
              ],
              [
                -76.5954580001242,
                39.3451739996699,
                0
              ],
              [
                -76.5955259997805,
                39.3451469986771,
                0
              ],
              [
                -76.5956620000824,
                39.345092999279,
                0
              ],
              [
                -76.5958909998047,
                39.3450079986819,
                0
              ],
              [
                -76.5960130001242,
                39.3449679987879,
                0
              ],
              [
                -76.596149000503,
                39.3449329991588,
                0
              ],
              [
                -76.5962930003488,
                39.3449069991701,
                0
              ],
              [
                -76.5964450005386,
                39.3448870002128,
                0
              ],
              [
                -76.5965710001376,
                39.344877999124,
                0
              ],
              [
                -76.5966910003908,
                39.3448739989784,
                0
              ],
              [
                -76.5967980002178,
                39.3448739993759,
                0
              ],
              [
                -76.5969190002906,
                39.3448789990757,
                0
              ],
              [
                -76.5970970001056,
                39.3448929987886,
                0
              ],
              [
                -76.5976049998259,
                39.3449479987637,
                0
              ],
              [
                -76.5982400004338,
                39.3450069993503,
                0
              ],
              [
                -76.5991339994829,
                39.3450929987877,
                0
              ],
              [
                -76.5997289994598,
                39.3451489986641,
                0
              ],
              [
                -76.5996329995063,
                39.3456789992394,
                0
              ],
              [
                -76.5995319999107,
                39.3462669996288,
                0
              ],
              [
                -76.5994230002134,
                39.3469669991437,
                0
              ],
              [
                -76.5993759995072,
                39.3472769988553,
                0
              ],
              [
                -76.5992579996786,
                39.34804600042,
                0
              ],
              [
                -76.5991049997254,
                39.3489679990247,
                0
              ],
              [
                -76.5990419989932,
                39.3493979986841,
                0
              ],
              [
                -76.5988860000699,
                39.3503689985946,
                0
              ],
              [
                -76.5988330004838,
                39.3507139991366,
                0
              ],
              [
                -76.5988019999534,
                39.3508969993139,
                0
              ],
              [
                -76.5987460010879,
                39.351245998739,
                0
              ],
              [
                -76.5986890006591,
                39.3516049992439,
                0
              ],
              [
                -76.5986310001493,
                39.3519849998105,
                0
              ],
              [
                -76.5985710005065,
                39.3523769985905,
                0
              ],
              [
                -76.5984370001032,
                39.3532459989959,
                0
              ],
              [
                -76.5983680002698,
                39.3536679993671,
                0
              ],
              [
                -76.5982890005381,
                39.3541659990093,
                0
              ],
              [
                -76.5977599994943,
                39.3540849990433,
                0
              ],
              [
                -76.5973839988752,
                39.354036998766,
                0
              ],
              [
                -76.5971620004925,
                39.3540139999786,
                0
              ],
              [
                -76.5969440003437,
                39.3540009992148,
                0
              ],
              [
                -76.5966899999084,
                39.3539979980266,
                0
              ],
              [
                -76.5963880004336,
                39.3539969987308,
                0
              ],
              [
                -76.5959810004811,
                39.3540089986529,
                0
              ],
              [
                -76.5957329999027,
                39.354021998801,
                0
              ],
              [
                -76.5946660003363,
                39.3540749994053,
                0
              ],
              [
                -76.5943459985429,
                39.3540879988154,
                0
              ],
              [
                -76.5933260001456,
                39.3541309989279,
                0
              ],
              [
                -76.5930420004466,
                39.354161999055,
                0
              ],
              [
                -76.5927790009472,
                39.3542019993942,
                0
              ],
              [
                -76.5925640010093,
                39.3542499983385,
                0
              ],
              [
                -76.5923650005021,
                39.3543039990638,
                0
              ],
              [
                -76.592289000068,
                39.3543239995909,
                0
              ],
              [
                -76.5921360002665,
                39.3543669992104,
                0
              ],
              [
                -76.5918499997914,
                39.3544749985704,
                0
              ],
              [
                -76.5916519998304,
                39.3545699988928,
                0
              ],
              [
                -76.5913990004542,
                39.3547109987911,
                0
              ],
              [
                -76.5912719997996,
                39.354782998783,
                0
              ],
              [
                -76.591176999749,
                39.3548369986565,
                0
              ],
              [
                -76.5909329995719,
                39.3549789989349,
                0
              ],
              [
                -76.5907420002898,
                39.3550799994047,
                0
              ],
              [
                -76.5905860005184,
                39.3551499989514,
                0
              ],
              [
                -76.5904990000365,
                39.355186999379,
                0
              ],
              [
                -76.5904290001816,
                39.3552139985584,
                0
              ],
              [
                -76.5902290001356,
                39.3552829976657,
                0
              ],
              [
                -76.590035999145,
                39.3553370000424,
                0
              ],
              [
                -76.5897949998069,
                39.3553779990802,
                0
              ],
              [
                -76.589560999894,
                39.355417998812,
                0
              ],
              [
                -76.5895649989302,
                39.3552699990533,
                0
              ],
              [
                -76.5895659994415,
                39.3550749988491,
                0
              ],
              [
                -76.5895769996866,
                39.3548519988022,
                0
              ],
              [
                -76.5896040000029,
                39.3546889990521,
                0
              ],
              [
                -76.5896380004113,
                39.3544729987558,
                0
              ],
              [
                -76.5896649997905,
                39.354354999211,
                0
              ],
              [
                -76.5897170007752,
                39.3541509992383,
                0
              ],
              [
                -76.5897620003162,
                39.3540059987257,
                0
              ],
              [
                -76.5897869996636,
                39.3539309990605,
                0
              ],
              [
                -76.5899249997926,
                39.3535159989176,
                0
              ],
              [
                -76.5900129995566,
                39.3532509998358,
                0
              ],
              [
                -76.5900490014854,
                39.3531609987432,
                0
              ],
              [
                -76.5903740000791,
                39.352206998796,
                0
              ],
              [
                -76.5903940004155,
                39.3521479985783,
                0
              ],
              [
                -76.5905260000388,
                39.3517829994416,
                0
              ],
              [
                -76.59064799998,
                39.3514200000874,
                0
              ],
              [
                -76.5908070002984,
                39.3509450001818,
                0
              ],
              [
                -76.5909549998138,
                39.3505749993409,
                0
              ],
              [
                -76.591123999114,
                39.3500669988706,
                0
              ],
              [
                -76.5911369997385,
                39.3500299991562,
                0
              ],
              [
                -76.5913090003136,
                39.3495299992846,
                0
              ],
              [
                -76.5914190000181,
                39.3492629991023,
                0
              ],
              [
                -76.5914680002958,
                39.3491239988884,
                0
              ],
              [
                -76.5915219998739,
                39.3489359992818,
                0
              ],
              [
                -76.5915869998853,
                39.3486669987288,
                0
              ],
              [
                -76.5915949997786,
                39.3486279999395,
                0
              ],
              [
                -76.5916230001244,
                39.3484959984389,
                0
              ],
              [
                -76.5916309998986,
                39.3484549999909,
                0
              ],
              [
                -76.5917650002927,
                39.347807998934,
                0
              ],
              [
                -76.5917709994283,
                39.3477559990254,
                0
              ],
              [
                -76.591782000388,
                39.3476619994189,
                0
              ],
              [
                -76.5917869989882,
                39.3476259986736,
                0
              ],
              [
                -76.5918679985471,
                39.3470109987459,
                0
              ],
              [
                -76.5919129999582,
                39.3467129991933,
                0
              ],
              [
                -76.5919239984314,
                39.3466499986926,
                0
              ],
              [
                -76.5920060001953,
                39.3461629988287,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 56,
          "Census_Tract": "24510260404",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "af32fb53-da62-4e8b-9e5c-a0f30166bc83",
          "Shape__Area": 48081205.210754395,
          "Shape__Length": 39053.97873888905
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.5297860011706,
                39.2991099990386,
                0
              ],
              [
                -76.5297789999473,
                39.2988859993214,
                0
              ],
              [
                -76.5297749995676,
                39.2987309991428,
                0
              ],
              [
                -76.5296849996588,
                39.2984529997941,
                0
              ],
              [
                -76.5296239994807,
                39.2981789996399,
                0
              ],
              [
                -76.5295220003559,
                39.2973029991678,
                0
              ],
              [
                -76.5295100002618,
                39.2971799988744,
                0
              ],
              [
                -76.5295169994512,
                39.2970559991492,
                0
              ],
              [
                -76.5297179999735,
                39.2969589991188,
                0
              ],
              [
                -76.5301360001073,
                39.2967029985861,
                0
              ],
              [
                -76.5303409997156,
                39.296585999442,
                0
              ],
              [
                -76.5306630011745,
                39.2964109989091,
                0
              ],
              [
                -76.5309210005033,
                39.2962819988248,
                0
              ],
              [
                -76.5310009994516,
                39.2962439988682,
                0
              ],
              [
                -76.5312410001957,
                39.2961159990371,
                0
              ],
              [
                -76.5313510015298,
                39.2960569992682,
                0
              ],
              [
                -76.5319670000982,
                39.295777999007,
                0
              ],
              [
                -76.5321069995051,
                39.2957149988421,
                0
              ],
              [
                -76.5323979999301,
                39.2955979989813,
                0
              ],
              [
                -76.5326039992042,
                39.2955009985855,
                0
              ],
              [
                -76.5327849998236,
                39.2954139986666,
                0
              ],
              [
                -76.5328810003594,
                39.2954479986593,
                0
              ],
              [
                -76.5329469997935,
                39.2954739994399,
                0
              ],
              [
                -76.5330230010676,
                39.2954959991177,
                0
              ],
              [
                -76.5331989994421,
                39.2955309986699,
                0
              ],
              [
                -76.533859000543,
                39.2956709989466,
                0
              ],
              [
                -76.5344230005788,
                39.2957929988949,
                0
              ],
              [
                -76.5352030002083,
                39.2959619987057,
                0
              ],
              [
                -76.5359949992535,
                39.2961159988785,
                0
              ],
              [
                -76.5363399996128,
                39.2961710004079,
                0
              ],
              [
                -76.5366519998374,
                39.2961939991131,
                0
              ],
              [
                -76.5372710005593,
                39.2962070001458,
                0
              ],
              [
                -76.5392420014357,
                39.2961229993864,
                0
              ],
              [
                -76.5399120009071,
                39.2961019989799,
                0
              ],
              [
                -76.5410939998405,
                39.2960659992718,
                0
              ],
              [
                -76.5414510002026,
                39.296052999004,
                0
              ],
              [
                -76.5417979998948,
                39.2960409990294,
                0
              ],
              [
                -76.542825999983,
                39.2960039992792,
                0
              ],
              [
                -76.5430639997566,
                39.2959959986119,
                0
              ],
              [
                -76.5439400004801,
                39.2959669992308,
                0
              ],
              [
                -76.5448859994852,
                39.2959359990814,
                0
              ],
              [
                -76.5460680000017,
                39.2958899986415,
                0
              ],
              [
                -76.546812999674,
                39.2958629982636,
                0
              ],
              [
                -76.5471619995826,
                39.2958370004384,
                0
              ],
              [
                -76.5474920006253,
                39.2958079991262,
                0
              ],
              [
                -76.5478009995292,
                39.2957599991575,
                0
              ],
              [
                -76.5481200004745,
                39.2956649990719,
                0
              ],
              [
                -76.5483929996166,
                39.2955419985747,
                0
              ],
              [
                -76.5486040005396,
                39.2954149985729,
                0
              ],
              [
                -76.5488029996747,
                39.2952619993506,
                0
              ],
              [
                -76.549025999966,
                39.2950249985978,
                0
              ],
              [
                -76.549298000431,
                39.2946649990029,
                0
              ],
              [
                -76.5493779999723,
                39.2945589988537,
                0
              ],
              [
                -76.5494809996525,
                39.2944219988511,
                0
              ],
              [
                -76.5495650001942,
                39.294309998623,
                0
              ],
              [
                -76.5501020001235,
                39.2936419991808,
                0
              ],
              [
                -76.5503550001935,
                39.2933509992185,
                0
              ],
              [
                -76.5505580004631,
                39.2930909999209,
                0
              ],
              [
                -76.5508990002601,
                39.2926669991278,
                0
              ],
              [
                -76.5510809998951,
                39.2924829997028,
                0
              ],
              [
                -76.5511570003891,
                39.2924279985925,
                0
              ],
              [
                -76.551274999751,
                39.2923429994301,
                0
              ],
              [
                -76.5515029996553,
                39.2922159987328,
                0
              ],
              [
                -76.5518099996691,
                39.2920979985694,
                0
              ],
              [
                -76.5521230002264,
                39.2920329988259,
                0
              ],
              [
                -76.5524860002045,
                39.292003999435,
                0
              ],
              [
                -76.5535719999375,
                39.2919719990042,
                0
              ],
              [
                -76.5536730004843,
                39.2919689986017,
                0
              ],
              [
                -76.553781000288,
                39.2919659985755,
                0
              ],
              [
                -76.5538149995394,
                39.2919639992068,
                0
              ],
              [
                -76.5538280005012,
                39.2919629982943,
                0
              ],
              [
                -76.5539469997817,
                39.2919579996626,
                0
              ],
              [
                -76.5539599995814,
                39.291956998731,
                0
              ],
              [
                -76.5549919996018,
                39.29191099938,
                0
              ],
              [
                -76.5553339994831,
                39.2918829988657,
                0
              ],
              [
                -76.5555250005389,
                39.2918669990037,
                0
              ],
              [
                -76.5557240004169,
                39.2918649981036,
                0
              ],
              [
                -76.5557779994937,
                39.2918649978275,
                0
              ],
              [
                -76.5561659996944,
                39.2918639989302,
                0
              ],
              [
                -76.5570609995203,
                39.2918349988919,
                0
              ],
              [
                -76.5574170002275,
                39.2917989985951,
                0
              ],
              [
                -76.5589160003627,
                39.2917379987446,
                0
              ],
              [
                -76.5598890002872,
                39.2917049985865,
                0
              ],
              [
                -76.5608700004537,
                39.291667999275,
                0
              ],
              [
                -76.5616689994424,
                39.29163799905,
                0
              ],
              [
                -76.5623230004307,
                39.2916119976284,
                0
              ],
              [
                -76.562744000286,
                39.2915949988266,
                0
              ],
              [
                -76.5627909999274,
                39.2922479992107,
                0
              ],
              [
                -76.562827000073,
                39.2927539992333,
                0
              ],
              [
                -76.5641059995497,
                39.2927039988952,
                0
              ],
              [
                -76.5657009995289,
                39.2926409995711,
                0
              ],
              [
                -76.5665690000816,
                39.2925999993692,
                0
              ],
              [
                -76.5675500003455,
                39.2925679993291,
                0
              ],
              [
                -76.5694130003195,
                39.2924869991264,
                0
              ],
              [
                -76.5694619995132,
                39.2930659990142,
                0
              ],
              [
                -76.5695020005466,
                39.2936189986615,
                0
              ],
              [
                -76.5695469999351,
                39.2942689987572,
                0
              ],
              [
                -76.5695930012501,
                39.2949079986816,
                0
              ],
              [
                -76.5696250005223,
                39.2954919989661,
                0
              ],
              [
                -76.5696560004569,
                39.2960609987145,
                0
              ],
              [
                -76.5696790004352,
                39.2963779993353,
                0
              ],
              [
                -76.5697400004041,
                39.297224998736,
                0
              ],
              [
                -76.5698029996495,
                39.2982389998019,
                0
              ],
              [
                -76.5698399996141,
                39.2988069986291,
                0
              ],
              [
                -76.5698589995249,
                39.2990799993031,
                0
              ],
              [
                -76.5698689984518,
                39.2992019987754,
                0
              ],
              [
                -76.5698919999181,
                39.2992909987706,
                0
              ],
              [
                -76.5699110005099,
                39.2993499996259,
                0
              ],
              [
                -76.5703979996179,
                39.2993229993342,
                0
              ],
              [
                -76.5707880000905,
                39.2993009986362,
                0
              ],
              [
                -76.571536999783,
                39.2992769987756,
                0
              ],
              [
                -76.5722599997805,
                39.2992489992019,
                0
              ],
              [
                -76.5726610000556,
                39.2992369992396,
                0
              ],
              [
                -76.5727890001753,
                39.2992340004057,
                0
              ],
              [
                -76.5727910008012,
                39.2996399989059,
                0
              ],
              [
                -76.5727870004944,
                39.3003079992129,
                0
              ],
              [
                -76.5727799995501,
                39.3007209988799,
                0
              ],
              [
                -76.5727900011118,
                39.3013509991187,
                0
              ],
              [
                -76.5727939997959,
                39.3018779990581,
                0
              ],
              [
                -76.5727870001615,
                39.3022539989692,
                0
              ],
              [
                -76.5727929984757,
                39.3027209992984,
                0
              ],
              [
                -76.5728440004941,
                39.3035279986176,
                0
              ],
              [
                -76.5728989997405,
                39.3041099992414,
                0
              ],
              [
                -76.5729679988907,
                39.3048459991719,
                0
              ],
              [
                -76.5729789997448,
                39.3051499990327,
                0
              ],
              [
                -76.5729860012922,
                39.3061869993778,
                0
              ],
              [
                -76.5730160000705,
                39.3072789994379,
                0
              ],
              [
                -76.5730349999308,
                39.308323999092,
                0
              ],
              [
                -76.5730420007017,
                39.3088599992646,
                0
              ],
              [
                -76.5730459998483,
                39.3093379986219,
                0
              ],
              [
                -76.5728680004704,
                39.3093419987563,
                0
              ],
              [
                -76.572334000113,
                39.309353000396,
                0
              ],
              [
                -76.5721299991788,
                39.3093569993588,
                0
              ],
              [
                -76.5717360000984,
                39.3093659993562,
                0
              ],
              [
                -76.5701809995287,
                39.3093679990135,
                0
              ],
              [
                -76.5700480000917,
                39.3093699994512,
                0
              ],
              [
                -76.5698660010101,
                39.3093709997999,
                0
              ],
              [
                -76.5694749998178,
                39.3093719999657,
                0
              ],
              [
                -76.5688450003871,
                39.3093859992258,
                0
              ],
              [
                -76.5686149996021,
                39.3093789993304,
                0
              ],
              [
                -76.5684460000136,
                39.3093579982729,
                0
              ],
              [
                -76.5683500003182,
                39.3093459988864,
                0
              ],
              [
                -76.5680140014056,
                39.3092929985686,
                0
              ],
              [
                -76.5674179999886,
                39.3091369990719,
                0
              ],
              [
                -76.567312998462,
                39.309109998717,
                0
              ],
              [
                -76.567022999794,
                39.3090249988879,
                0
              ],
              [
                -76.5666569997774,
                39.3089599986375,
                0
              ],
              [
                -76.5661619998138,
                39.3089289993356,
                0
              ],
              [
                -76.565477999992,
                39.3089699993363,
                0
              ],
              [
                -76.5644980002439,
                39.3082509989107,
                0
              ],
              [
                -76.5636089986922,
                39.3076349991291,
                0
              ],
              [
                -76.5625560005765,
                39.3068309991711,
                0
              ],
              [
                -76.5621099988261,
                39.306483999944,
                0
              ],
              [
                -76.5609309995271,
                39.3056379994368,
                0
              ],
              [
                -76.5608779997867,
                39.3055969988298,
                0
              ],
              [
                -76.5607630003238,
                39.3055079992355,
                0
              ],
              [
                -76.5595880003415,
                39.3046179986697,
                0
              ],
              [
                -76.5592369998359,
                39.3043479988155,
                0
              ],
              [
                -76.5587869999903,
                39.3040059987333,
                0
              ],
              [
                -76.5582990002719,
                39.3036299990058,
                0
              ],
              [
                -76.5579519995798,
                39.3033480004099,
                0
              ],
              [
                -76.5576050002188,
                39.3030639992728,
                0
              ],
              [
                -76.5569790003598,
                39.3025729994319,
                0
              ],
              [
                -76.5562079999495,
                39.3019989993395,
                0
              ],
              [
                -76.5558429997152,
                39.3017229992498,
                0
              ],
              [
                -76.5554819995284,
                39.3014499991444,
                0
              ],
              [
                -76.5551299997936,
                39.301181999666,
                0
              ],
              [
                -76.5549799994424,
                39.3010769993288,
                0
              ],
              [
                -76.5548850014218,
                39.3010179991094,
                0
              ],
              [
                -76.5544720000818,
                39.3007619988162,
                0
              ],
              [
                -76.5542390002826,
                39.300621998992,
                0
              ],
              [
                -76.55366499845,
                39.3002759988497,
                0
              ],
              [
                -76.5534790008122,
                39.3001509989381,
                0
              ],
              [
                -76.55276300019,
                39.3003809987991,
                0
              ],
              [
                -76.5525129998131,
                39.3004649994128,
                0
              ],
              [
                -76.5519970003603,
                39.3006379994149,
                0
              ],
              [
                -76.551027000555,
                39.3009709982845,
                0
              ],
              [
                -76.5506740001128,
                39.3010769987577,
                0
              ],
              [
                -76.5506579995179,
                39.3010819989382,
                0
              ],
              [
                -76.5505529997256,
                39.3011219991299,
                0
              ],
              [
                -76.550520999736,
                39.3011339991478,
                0
              ],
              [
                -76.5500279998205,
                39.3013119993395,
                0
              ],
              [
                -76.5494759996977,
                39.3015029989099,
                0
              ],
              [
                -76.5488339997248,
                39.301718998626,
                0
              ],
              [
                -76.5487070008094,
                39.3017619986969,
                0
              ],
              [
                -76.5478410000881,
                39.3020249987985,
                0
              ],
              [
                -76.5476129998509,
                39.3020849990372,
                0
              ],
              [
                -76.5465429996761,
                39.3023979987197,
                0
              ],
              [
                -76.5460890003714,
                39.3025479985602,
                0
              ],
              [
                -76.5459469999784,
                39.3025919987908,
                0
              ],
              [
                -76.5445939993472,
                39.302978999353,
                0
              ],
              [
                -76.5440869991369,
                39.3031249992329,
                0
              ],
              [
                -76.5430170001026,
                39.3034359986727,
                0
              ],
              [
                -76.5429590004724,
                39.3034519993718,
                0
              ],
              [
                -76.5423960002476,
                39.3036249986877,
                0
              ],
              [
                -76.5421040001183,
                39.3037159989483,
                0
              ],
              [
                -76.5418540005543,
                39.3037950001974,
                0
              ],
              [
                -76.5416939999827,
                39.3038459987721,
                0
              ],
              [
                -76.540966998501,
                39.304049998743,
                0
              ],
              [
                -76.5407229995043,
                39.3041209988627,
                0
              ],
              [
                -76.5397180003123,
                39.3044439988631,
                0
              ],
              [
                -76.5392570004808,
                39.304628998862,
                0
              ],
              [
                -76.5382119998602,
                39.3051099989185,
                0
              ],
              [
                -76.5378929999742,
                39.3052579988715,
                0
              ],
              [
                -76.5375910001129,
                39.3054129998066,
                0
              ],
              [
                -76.5372100005738,
                39.3056009989346,
                0
              ],
              [
                -76.536410999695,
                39.3059620002796,
                0
              ],
              [
                -76.5360510003971,
                39.306165999416,
                0
              ],
              [
                -76.5358510005514,
                39.3062799987524,
                0
              ],
              [
                -76.5356699994608,
                39.3063959986476,
                0
              ],
              [
                -76.5353920000554,
                39.3065749994107,
                0
              ],
              [
                -76.5349890003471,
                39.3068549988631,
                0
              ],
              [
                -76.5347070005627,
                39.3070509993077,
                0
              ],
              [
                -76.5343819994314,
                39.3072699989144,
                0
              ],
              [
                -76.5343549992952,
                39.3072879989849,
                0
              ],
              [
                -76.5342070005157,
                39.3073769992207,
                0
              ],
              [
                -76.534167999546,
                39.30739999863,
                0
              ],
              [
                -76.5333139997754,
                39.308010998903,
                0
              ],
              [
                -76.5329190001874,
                39.3082939990792,
                0
              ],
              [
                -76.5323459998647,
                39.3086679986219,
                0
              ],
              [
                -76.5317190009811,
                39.3090649990377,
                0
              ],
              [
                -76.5314450005798,
                39.3092559999391,
                0
              ],
              [
                -76.5314099994187,
                39.3092799989057,
                0
              ],
              [
                -76.5309780000246,
                39.3095809988498,
                0
              ],
              [
                -76.5305549996462,
                39.309858998942,
                0
              ],
              [
                -76.5301179994305,
                39.3101609989839,
                0
              ],
              [
                -76.5297860012701,
                39.3103909993055,
                0
              ],
              [
                -76.5297860008822,
                39.3101589990088,
                0
              ],
              [
                -76.5297850002985,
                39.3101449990168,
                0
              ],
              [
                -76.5297850003833,
                39.3100919992772,
                0
              ],
              [
                -76.5297799995281,
                39.3100779985907,
                0
              ],
              [
                -76.5297820000314,
                39.3098979989741,
                0
              ],
              [
                -76.5297860008334,
                39.3096440001081,
                0
              ],
              [
                -76.5297860012511,
                39.3095919993033,
                0
              ],
              [
                -76.5297860013182,
                39.3094749979364,
                0
              ],
              [
                -76.5297860013963,
                39.3094219990867,
                0
              ],
              [
                -76.5297860004927,
                39.3088439991797,
                0
              ],
              [
                -76.529786000884,
                39.308830999427,
                0
              ],
              [
                -76.5297860012989,
                39.3085339993456,
                0
              ],
              [
                -76.5296969997326,
                39.3077169986362,
                0
              ],
              [
                -76.5296930011403,
                39.3064739993608,
                0
              ],
              [
                -76.5297430004853,
                39.3059639992406,
                0
              ],
              [
                -76.5296859999255,
                39.3055059986286,
                0
              ],
              [
                -76.5296850001243,
                39.3047059989956,
                0
              ],
              [
                -76.5296850005682,
                39.3046609988208,
                0
              ],
              [
                -76.5296110009332,
                39.3029109989094,
                0
              ],
              [
                -76.5296179991756,
                39.3026719992676,
                0
              ],
              [
                -76.5296620000618,
                39.3012479994427,
                0
              ],
              [
                -76.5297860006254,
                39.2995059990694,
                0
              ],
              [
                -76.529786000924,
                39.2994429989047,
                0
              ],
              [
                -76.5297860011706,
                39.2991099990386,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 57,
          "Census_Tract": "24510272007",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "89b5ef5a-ab00-4165-8c29-e16931a7df9c",
          "Shape__Area": 8635604.317749023,
          "Shape__Length": 14621.27887154993
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6997979994875,
                39.3623629989419,
                0
              ],
              [
                -76.7002949996378,
                39.3619779990784,
                0
              ],
              [
                -76.7004940003146,
                39.3618239990464,
                0
              ],
              [
                -76.701418999769,
                39.3611079989812,
                0
              ],
              [
                -76.7019019995532,
                39.3607289988141,
                0
              ],
              [
                -76.7025250003525,
                39.36024099864,
                0
              ],
              [
                -76.7032280002475,
                39.3597019991069,
                0
              ],
              [
                -76.702391000389,
                39.3590689990486,
                0
              ],
              [
                -76.7020569997163,
                39.3588169987583,
                0
              ],
              [
                -76.7017690004008,
                39.3585959986687,
                0
              ],
              [
                -76.7014350000026,
                39.3583369987296,
                0
              ],
              [
                -76.7008300000844,
                39.3578909990974,
                0
              ],
              [
                -76.7016830004367,
                39.3570029989566,
                0
              ],
              [
                -76.7021379998811,
                39.3565269987921,
                0
              ],
              [
                -76.7022660004791,
                39.3563909997831,
                0
              ],
              [
                -76.702339000944,
                39.3563249992279,
                0
              ],
              [
                -76.7024060001415,
                39.3562739987505,
                0
              ],
              [
                -76.7024460000401,
                39.3562459987329,
                0
              ],
              [
                -76.7029770003441,
                39.3566289994142,
                0
              ],
              [
                -76.7034609998905,
                39.3569769998299,
                0
              ],
              [
                -76.7035549996941,
                39.3570459992025,
                0
              ],
              [
                -76.7036169995692,
                39.3570919985624,
                0
              ],
              [
                -76.7037160001596,
                39.3571629992373,
                0
              ],
              [
                -76.7037739998936,
                39.3572069987025,
                0
              ],
              [
                -76.7039279998138,
                39.3573259993581,
                0
              ],
              [
                -76.7042280002069,
                39.357556999206,
                0
              ],
              [
                -76.7043459995015,
                39.3576509988293,
                0
              ],
              [
                -76.7050969999886,
                39.3582499991519,
                0
              ],
              [
                -76.7053970011345,
                39.3584809977334,
                0
              ],
              [
                -76.7059489996116,
                39.358906998828,
                0
              ],
              [
                -76.7067229996943,
                39.3595059991295,
                0
              ],
              [
                -76.7069179999736,
                39.3596579992396,
                0
              ],
              [
                -76.7073449994999,
                39.3599780002684,
                0
              ],
              [
                -76.7077510002314,
                39.3603229988243,
                0
              ],
              [
                -76.7081489995024,
                39.3606539993352,
                0
              ],
              [
                -76.7084090004026,
                39.360845998702,
                0
              ],
              [
                -76.7085420009181,
                39.3609399987575,
                0
              ],
              [
                -76.7085999999279,
                39.3609579987005,
                0
              ],
              [
                -76.7086720003619,
                39.3609689994464,
                0
              ],
              [
                -76.70911500026,
                39.3613449989974,
                0
              ],
              [
                -76.7102419986015,
                39.3621409988767,
                0
              ],
              [
                -76.710583000416,
                39.3623849987334,
                0
              ],
              [
                -76.7110589985108,
                39.3627089985737,
                0
              ],
              [
                -76.7111909994869,
                39.3627979994214,
                0
              ],
              [
                -76.7111900002725,
                39.3628489993646,
                0
              ],
              [
                -76.7111890001828,
                39.3628799993543,
                0
              ],
              [
                -76.7111849994705,
                39.3631489989423,
                0
              ],
              [
                -76.7112820002761,
                39.3636409985743,
                0
              ],
              [
                -76.7114079994314,
                39.3644089979658,
                0
              ],
              [
                -76.7114030004982,
                39.3646149993128,
                0
              ],
              [
                -76.7115189998844,
                39.3657629986496,
                0
              ],
              [
                -76.711508998577,
                39.3662149992072,
                0
              ],
              [
                -76.7115079994633,
                39.3662739994288,
                0
              ],
              [
                -76.711502001058,
                39.3665320003569,
                0
              ],
              [
                -76.7114999997722,
                39.3666059989597,
                0
              ],
              [
                -76.7114979999664,
                39.3667049992733,
                0
              ],
              [
                -76.7114940003231,
                39.3669049986222,
                0
              ],
              [
                -76.7113949999198,
                39.367687998934,
                0
              ],
              [
                -76.7113420001331,
                39.3683919994454,
                0
              ],
              [
                -76.7112880005802,
                39.3696449986026,
                0
              ],
              [
                -76.7113280008306,
                39.3707569991847,
                0
              ],
              [
                -76.7113129995261,
                39.3719329993095,
                0
              ],
              [
                -76.7111639997696,
                39.37176399902,
                0
              ],
              [
                -76.7110829992609,
                39.3716839986612,
                0
              ],
              [
                -76.7107449999709,
                39.3714219992093,
                0
              ],
              [
                -76.7103890008553,
                39.3711229991218,
                0
              ],
              [
                -76.7099559996119,
                39.3707499991972,
                0
              ],
              [
                -76.7099049994732,
                39.3707070002728,
                0
              ],
              [
                -76.7095720000687,
                39.3704229993351,
                0
              ],
              [
                -76.7090800004703,
                39.3700189993245,
                0
              ],
              [
                -76.7088709997383,
                39.3698279993579,
                0
              ],
              [
                -76.7086930001931,
                39.3696729988877,
                0
              ],
              [
                -76.7085909998883,
                39.3695809991896,
                0
              ],
              [
                -76.7080819996911,
                39.3691419988328,
                0
              ],
              [
                -76.7078099996017,
                39.3689239986336,
                0
              ],
              [
                -76.7075600003571,
                39.3687069991655,
                0
              ],
              [
                -76.7074700005071,
                39.3686279988797,
                0
              ],
              [
                -76.7071810003444,
                39.3683759989902,
                0
              ],
              [
                -76.7068690002632,
                39.3680969991574,
                0
              ],
              [
                -76.7065829994228,
                39.3678749996986,
                0
              ],
              [
                -76.7060709991579,
                39.3674769987297,
                0
              ],
              [
                -76.7058070005722,
                39.367271998747,
                0
              ],
              [
                -76.7056500005763,
                39.3671339987783,
                0
              ],
              [
                -76.7055089997745,
                39.367009999153,
                0
              ],
              [
                -76.7050580004319,
                39.3666399989072,
                0
              ],
              [
                -76.7048630001461,
                39.3664809991776,
                0
              ],
              [
                -76.7038690002854,
                39.3656819988624,
                0
              ],
              [
                -76.70376000152,
                39.3655939989893,
                0
              ],
              [
                -76.7028339999439,
                39.3648189979808,
                0
              ],
              [
                -76.7022520003916,
                39.3643509986324,
                0
              ],
              [
                -76.7014810004065,
                39.3637319991527,
                0
              ],
              [
                -76.7009049997174,
                39.3632679993206,
                0
              ],
              [
                -76.7008219991942,
                39.3632019992956,
                0
              ],
              [
                -76.7006479992439,
                39.3630619990776,
                0
              ],
              [
                -76.7004810004892,
                39.3629249996657,
                0
              ],
              [
                -76.7004400003129,
                39.3628909978099,
                0
              ],
              [
                -76.7003230003356,
                39.3627949991462,
                0
              ],
              [
                -76.6997979994875,
                39.3623629989419,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 58,
          "Census_Tract": "24510090800",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "8cdc49dc-b1f0-46c6-808d-ba41d4082dc9",
          "Shape__Area": 9106393.807983398,
          "Shape__Length": 12425.047019965992
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.60581199967,
                39.319456998941,
                0
              ],
              [
                -76.6054100003835,
                39.3194129993029,
                0
              ],
              [
                -76.6047910004226,
                39.3193599989662,
                0
              ],
              [
                -76.6042279999345,
                39.3192979989824,
                0
              ],
              [
                -76.6037279998716,
                39.3192329993552,
                0
              ],
              [
                -76.6033509999494,
                39.3191809990016,
                0
              ],
              [
                -76.6028940000541,
                39.3190989987092,
                0
              ],
              [
                -76.6025699994357,
                39.3190349994341,
                0
              ],
              [
                -76.6020949994383,
                39.3189299992838,
                0
              ],
              [
                -76.6014890005787,
                39.3187899992995,
                0
              ],
              [
                -76.5994119996495,
                39.318293998581,
                0
              ],
              [
                -76.5977169984538,
                39.3179219986268,
                0
              ],
              [
                -76.5948870014066,
                39.3172429987269,
                0
              ],
              [
                -76.5948670011206,
                39.3172379990568,
                0
              ],
              [
                -76.5951760015609,
                39.3169569991518,
                0
              ],
              [
                -76.5954630003179,
                39.3166719990025,
                0
              ],
              [
                -76.5958839994671,
                39.316239999282,
                0
              ],
              [
                -76.5963269998674,
                39.3158159993224,
                0
              ],
              [
                -76.5964350000768,
                39.3157129988167,
                0
              ],
              [
                -76.5969270004608,
                39.3152409987824,
                0
              ],
              [
                -76.5971460010668,
                39.3150409986436,
                0
              ],
              [
                -76.59794100053,
                39.3142619989459,
                0
              ],
              [
                -76.5980329994699,
                39.3141829986396,
                0
              ],
              [
                -76.5982559994233,
                39.3139439992969,
                0
              ],
              [
                -76.5985250000526,
                39.3136559989064,
                0
              ],
              [
                -76.5987270001398,
                39.3134379991499,
                0
              ],
              [
                -76.5988719997086,
                39.3132489988414,
                0
              ],
              [
                -76.5989680003562,
                39.3131059993209,
                0
              ],
              [
                -76.5990570001699,
                39.3129609986752,
                0
              ],
              [
                -76.5993700000952,
                39.3119419992204,
                0
              ],
              [
                -76.6007039999289,
                39.3118799989698,
                0
              ],
              [
                -76.6008660010768,
                39.3118749988639,
                0
              ],
              [
                -76.601688000007,
                39.3118339985977,
                0
              ],
              [
                -76.6022779998975,
                39.3118029986626,
                0
              ],
              [
                -76.6026440001101,
                39.3117839986501,
                0
              ],
              [
                -76.604131000011,
                39.3117169983715,
                0
              ],
              [
                -76.6051769999758,
                39.3116619989497,
                0
              ],
              [
                -76.6061579996685,
                39.311604998808,
                0
              ],
              [
                -76.6071329999186,
                39.3115360002953,
                0
              ],
              [
                -76.6075610011021,
                39.3115109986503,
                0
              ],
              [
                -76.6083090000434,
                39.3114599993138,
                0
              ],
              [
                -76.6094969988985,
                39.3114049987133,
                0
              ],
              [
                -76.6095029995367,
                39.3117520001231,
                0
              ],
              [
                -76.6095050001184,
                39.3118329981129,
                0
              ],
              [
                -76.6095080000464,
                39.3120169988928,
                0
              ],
              [
                -76.6095110006911,
                39.3120800004233,
                0
              ],
              [
                -76.6095269996343,
                39.3124769989248,
                0
              ],
              [
                -76.6095369999138,
                39.3127369988473,
                0
              ],
              [
                -76.6095370002449,
                39.3127660004329,
                0
              ],
              [
                -76.6095369997128,
                39.3127879986511,
                0
              ],
              [
                -76.6095339994755,
                39.3135219988155,
                0
              ],
              [
                -76.6095489994456,
                39.3139829986895,
                0
              ],
              [
                -76.6095320002956,
                39.3145079988255,
                0
              ],
              [
                -76.6095280000939,
                39.3150659988402,
                0
              ],
              [
                -76.6095240004939,
                39.3154909989082,
                0
              ],
              [
                -76.609490000811,
                39.3162339993763,
                0
              ],
              [
                -76.6094860002717,
                39.3165929993018,
                0
              ],
              [
                -76.6094850001602,
                39.3166389992451,
                0
              ],
              [
                -76.6094829994268,
                39.3171159999186,
                0
              ],
              [
                -76.6094639995909,
                39.3181110003231,
                0
              ],
              [
                -76.6094630003141,
                39.3181479990253,
                0
              ],
              [
                -76.6094860003179,
                39.3189649986545,
                0
              ],
              [
                -76.6094870005719,
                39.3190309992149,
                0
              ],
              [
                -76.60950899963,
                39.3195189991029,
                0
              ],
              [
                -76.6090669985567,
                39.319533999051,
                0
              ],
              [
                -76.6086359987013,
                39.3195399994253,
                0
              ],
              [
                -76.6078730004708,
                39.3195519988181,
                0
              ],
              [
                -76.6073109984409,
                39.3195459987186,
                0
              ],
              [
                -76.606757999497,
                39.3195150004492,
                0
              ],
              [
                -76.60581199967,
                39.319456998941,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 59,
          "Census_Tract": "24510100200",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "1569c066-d8ab-4c3f-9022-8c13dc4e4339",
          "Shape__Area": 3279492.8903808594,
          "Shape__Length": 7709.366896784031
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.5975970007148,
                39.2982509991579,
                0
              ],
              [
                -76.5983560005288,
                39.2982289992418,
                0
              ],
              [
                -76.5991409995193,
                39.2982069993611,
                0
              ],
              [
                -76.5996130000566,
                39.2981829993307,
                0
              ],
              [
                -76.6000740015528,
                39.2981709986051,
                0
              ],
              [
                -76.6009320011255,
                39.2981389990046,
                0
              ],
              [
                -76.6019109995773,
                39.298106998738,
                0
              ],
              [
                -76.6025480006813,
                39.2980719990469,
                0
              ],
              [
                -76.6029730001226,
                39.2980489993051,
                0
              ],
              [
                -76.6040560005546,
                39.2980010000187,
                0
              ],
              [
                -76.6042339998762,
                39.2979929993009,
                0
              ],
              [
                -76.6050549997327,
                39.2979609989937,
                0
              ],
              [
                -76.6058889996556,
                39.2979309993127,
                0
              ],
              [
                -76.6063319996534,
                39.2979119994331,
                0
              ],
              [
                -76.6065000000808,
                39.2985399989553,
                0
              ],
              [
                -76.6065799999069,
                39.298987998629,
                0
              ],
              [
                -76.6066240003286,
                39.2991259988771,
                0
              ],
              [
                -76.6067320002865,
                39.2994629989227,
                0
              ],
              [
                -76.606812000022,
                39.299712999109,
                0
              ],
              [
                -76.6068389999333,
                39.2998149994085,
                0
              ],
              [
                -76.6068980007894,
                39.3000349979564,
                0
              ],
              [
                -76.6070379997487,
                39.3005519985998,
                0
              ],
              [
                -76.6070899997965,
                39.3007329987021,
                0
              ],
              [
                -76.6072690007968,
                39.301360999103,
                0
              ],
              [
                -76.6063889996369,
                39.3014139986501,
                0
              ],
              [
                -76.6056650005589,
                39.301444999044,
                0
              ],
              [
                -76.6049059997923,
                39.3014910001049,
                0
              ],
              [
                -76.6041850014793,
                39.3015089990385,
                0
              ],
              [
                -76.6035499989832,
                39.3015540002121,
                0
              ],
              [
                -76.6027279999326,
                39.3015779988141,
                0
              ],
              [
                -76.6020600002382,
                39.3016089987912,
                0
              ],
              [
                -76.6015209997761,
                39.3016290001162,
                0
              ],
              [
                -76.6011369997469,
                39.3016439990997,
                0
              ],
              [
                -76.600316000125,
                39.3016589991681,
                0
              ],
              [
                -76.5999680001312,
                39.3016669989996,
                0
              ],
              [
                -76.5993700003735,
                39.3016819993457,
                0
              ],
              [
                -76.597828999503,
                39.3017439989562,
                0
              ],
              [
                -76.5977960004206,
                39.3012639982627,
                0
              ],
              [
                -76.5977939984429,
                39.301228998767,
                0
              ],
              [
                -76.5977389995547,
                39.3004019992988,
                0
              ],
              [
                -76.5976809986715,
                39.299336999041,
                0
              ],
              [
                -76.5976599988743,
                39.2990580000692,
                0
              ],
              [
                -76.5975970007148,
                39.2982509991579,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 60,
          "Census_Tract": "24510190100",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "33e778cb-7365-464f-940d-5fe384f64e39",
          "Shape__Area": 4123747.336669922,
          "Shape__Length": 8117.363461408574
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6381659996622,
                39.28856599897,
                0
              ],
              [
                -76.6389089998956,
                39.2885349993654,
                0
              ],
              [
                -76.6395729997612,
                39.288502998771,
                0
              ],
              [
                -76.640295000108,
                39.2884709990897,
                0
              ],
              [
                -76.6409969995452,
                39.2884399994502,
                0
              ],
              [
                -76.6424130002736,
                39.288372998787,
                0
              ],
              [
                -76.6430629999937,
                39.2883359987943,
                0
              ],
              [
                -76.6438039994591,
                39.2882930000763,
                0
              ],
              [
                -76.644152999581,
                39.2882749985975,
                0
              ],
              [
                -76.6445310000082,
                39.2882599986966,
                0
              ],
              [
                -76.6452219990104,
                39.2882279992386,
                0
              ],
              [
                -76.6452639998573,
                39.2889649985829,
                0
              ],
              [
                -76.6453010000833,
                39.2895799991515,
                0
              ],
              [
                -76.6453339999236,
                39.2901139993788,
                0
              ],
              [
                -76.6453359996051,
                39.2901519994286,
                0
              ],
              [
                -76.6453449998894,
                39.2902879988628,
                0
              ],
              [
                -76.6453740007474,
                39.2906409992291,
                0
              ],
              [
                -76.6454009992694,
                39.2910119987724,
                0
              ],
              [
                -76.6454209989318,
                39.2913219993878,
                0
              ],
              [
                -76.6454419986839,
                39.2917679986108,
                0
              ],
              [
                -76.6454479998679,
                39.2920629989076,
                0
              ],
              [
                -76.6454880005178,
                39.2929909997574,
                0
              ],
              [
                -76.6454929997474,
                39.293213999324,
                0
              ],
              [
                -76.6455019999205,
                39.2935739991316,
                0
              ],
              [
                -76.6455060000205,
                39.2936489993059,
                0
              ],
              [
                -76.6455080003826,
                39.2936759992574,
                0
              ],
              [
                -76.6455199994331,
                39.2938949989143,
                0
              ],
              [
                -76.6450380002635,
                39.2939129981752,
                0
              ],
              [
                -76.6448929984698,
                39.2939179987582,
                0
              ],
              [
                -76.6441189998147,
                39.2939559989649,
                0
              ],
              [
                -76.6426959998491,
                39.2940089986449,
                0
              ],
              [
                -76.6420779998216,
                39.2940339988176,
                0
              ],
              [
                -76.6413019985224,
                39.2940749991169,
                0
              ],
              [
                -76.6398819997442,
                39.2941359987416,
                0
              ],
              [
                -76.639374000031,
                39.2941600004104,
                0
              ],
              [
                -76.6391550013281,
                39.2941669988303,
                0
              ],
              [
                -76.6384619997957,
                39.2941889986873,
                0
              ],
              [
                -76.6384389992553,
                39.2937409988726,
                0
              ],
              [
                -76.6384379996913,
                39.2937189992799,
                0
              ],
              [
                -76.6384289997992,
                39.2934739986554,
                0
              ],
              [
                -76.6384279997939,
                39.2934579999114,
                0
              ],
              [
                -76.6384190001984,
                39.2932099979408,
                0
              ],
              [
                -76.6383650004048,
                39.2922949988604,
                0
              ],
              [
                -76.6383280002399,
                39.2918069989127,
                0
              ],
              [
                -76.6383039995734,
                39.2912289990426,
                0
              ],
              [
                -76.6382770010297,
                39.2908879975589,
                0
              ],
              [
                -76.6382299995959,
                39.2897769987828,
                0
              ],
              [
                -76.6381980003971,
                39.2891379987923,
                0
              ],
              [
                -76.6381659996622,
                39.28856599897,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 61,
          "Census_Tract": "24510200500",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "97c9551e-b0d3-46b4-8b1d-2f61d513c88e",
          "Shape__Area": 7029183.224853516,
          "Shape__Length": 11179.51575894419
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6479769995152,
                39.2790749989397,
                0
              ],
              [
                -76.6486099997845,
                39.2788930002053,
                0
              ],
              [
                -76.6493619999678,
                39.2787029987943,
                0
              ],
              [
                -76.6499080001248,
                39.2785569988922,
                0
              ],
              [
                -76.6500209999352,
                39.2785199999634,
                0
              ],
              [
                -76.6509999997756,
                39.2782270000377,
                0
              ],
              [
                -76.6518449997302,
                39.2779209985815,
                0
              ],
              [
                -76.6523310000965,
                39.2777199999879,
                0
              ],
              [
                -76.6526820004924,
                39.2775689978979,
                0
              ],
              [
                -76.6529020005214,
                39.2774649985995,
                0
              ],
              [
                -76.6531510002523,
                39.2773300001296,
                0
              ],
              [
                -76.6532719999394,
                39.2772569993175,
                0
              ],
              [
                -76.653547999928,
                39.2770689986923,
                0
              ],
              [
                -76.6537339998874,
                39.2769339986911,
                0
              ],
              [
                -76.6539110001845,
                39.2767929989201,
                0
              ],
              [
                -76.6541079994393,
                39.2766289991631,
                0
              ],
              [
                -76.6544940005512,
                39.276212998563,
                0
              ],
              [
                -76.6545520000133,
                39.2761519992928,
                0
              ],
              [
                -76.6549189994767,
                39.275523999164,
                0
              ],
              [
                -76.6550830004387,
                39.2757459990955,
                0
              ],
              [
                -76.6551799996317,
                39.2758700000196,
                0
              ],
              [
                -76.6552100004657,
                39.2758929989835,
                0
              ],
              [
                -76.6552400007815,
                39.2759079991682,
                0
              ],
              [
                -76.6552740001077,
                39.2759199989329,
                0
              ],
              [
                -76.6552999994847,
                39.2759259995523,
                0
              ],
              [
                -76.6553409999607,
                39.2759379991265,
                0
              ],
              [
                -76.6553689995054,
                39.2759499992727,
                0
              ],
              [
                -76.6553819998364,
                39.2759579992559,
                0
              ],
              [
                -76.6554469999373,
                39.2759999988378,
                0
              ],
              [
                -76.6554909999252,
                39.2760219993149,
                0
              ],
              [
                -76.6555949999298,
                39.2760569989789,
                0
              ],
              [
                -76.6556769999125,
                39.2760919989127,
                0
              ],
              [
                -76.6558140004933,
                39.2761449986714,
                0
              ],
              [
                -76.6559150002139,
                39.2761859991437,
                0
              ],
              [
                -76.655963999518,
                39.2761999991046,
                0
              ],
              [
                -76.6560179998784,
                39.2762129994331,
                0
              ],
              [
                -76.6560660005377,
                39.2762199993052,
                0
              ],
              [
                -76.656170999886,
                39.2762119989918,
                0
              ],
              [
                -76.6562489998975,
                39.2761959991666,
                0
              ],
              [
                -76.6563129995888,
                39.2761869986813,
                0
              ],
              [
                -76.6563370000704,
                39.2761869986482,
                0
              ],
              [
                -76.65638500012,
                39.2761969988273,
                0
              ],
              [
                -76.6564070005253,
                39.2762069985958,
                0
              ],
              [
                -76.6564390001912,
                39.2762229987619,
                0
              ],
              [
                -76.6565200002719,
                39.2762539993976,
                0
              ],
              [
                -76.6565619995337,
                39.2762689992008,
                0
              ],
              [
                -76.6565840004604,
                39.276270999268,
                0
              ],
              [
                -76.656611998569,
                39.2762689985642,
                0
              ],
              [
                -76.6566269999616,
                39.2762629992074,
                0
              ],
              [
                -76.6566400000658,
                39.2762559995568,
                0
              ],
              [
                -76.6566560000582,
                39.2762519992047,
                0
              ],
              [
                -76.656733000281,
                39.2762509992315,
                0
              ],
              [
                -76.6568499997064,
                39.2762350003841,
                0
              ],
              [
                -76.6569769994542,
                39.2762079989916,
                0
              ],
              [
                -76.6574159998689,
                39.2761009987392,
                0
              ],
              [
                -76.6576079998039,
                39.2760409994529,
                0
              ],
              [
                -76.6580150001269,
                39.2768709989552,
                0
              ],
              [
                -76.658325999909,
                39.2774189989316,
                0
              ],
              [
                -76.6586510005642,
                39.2779979978514,
                0
              ],
              [
                -76.658683998848,
                39.2780569990555,
                0
              ],
              [
                -76.6589830003627,
                39.2785939990364,
                0
              ],
              [
                -76.6592570010665,
                39.2791389991586,
                0
              ],
              [
                -76.6595790001736,
                39.2797259987357,
                0
              ],
              [
                -76.6599909998742,
                39.2803900000048,
                0
              ],
              [
                -76.660175001208,
                39.280656999193,
                0
              ],
              [
                -76.6597959996107,
                39.2808820002967,
                0
              ],
              [
                -76.6594449998517,
                39.2811069993886,
                0
              ],
              [
                -76.6590260006935,
                39.2813840000404,
                0
              ],
              [
                -76.6589850010591,
                39.2814129990113,
                0
              ],
              [
                -76.6586670005403,
                39.2816249989986,
                0
              ],
              [
                -76.6582639999244,
                39.2818979989807,
                0
              ],
              [
                -76.6578720010501,
                39.2821409991533,
                0
              ],
              [
                -76.6572920013524,
                39.2825179989641,
                0
              ],
              [
                -76.6567129995604,
                39.2828989990805,
                0
              ],
              [
                -76.6561980001264,
                39.2832369994048,
                0
              ],
              [
                -76.6559279995053,
                39.2834049987338,
                0
              ],
              [
                -76.6555389991096,
                39.2836579991831,
                0
              ],
              [
                -76.6554789986549,
                39.2836969990883,
                0
              ],
              [
                -76.6550729994624,
                39.2839559994318,
                0
              ],
              [
                -76.6550149994816,
                39.2839879979583,
                0
              ],
              [
                -76.6549250004331,
                39.2840379987319,
                0
              ],
              [
                -76.6548629994487,
                39.2840739992169,
                0
              ],
              [
                -76.6545380001261,
                39.2842130003871,
                0
              ],
              [
                -76.6538079995428,
                39.2844619994012,
                0
              ],
              [
                -76.6531839991599,
                39.2846809990052,
                0
              ],
              [
                -76.6526840001701,
                39.2848519992787,
                0
              ],
              [
                -76.6526219998191,
                39.2848739989663,
                0
              ],
              [
                -76.6521580000688,
                39.2850419994311,
                0
              ],
              [
                -76.6513050006524,
                39.2853209994329,
                0
              ],
              [
                -76.6506380005701,
                39.2855539988854,
                0
              ],
              [
                -76.6503050000274,
                39.2856730000875,
                0
              ],
              [
                -76.6499689998864,
                39.2857799986889,
                0
              ],
              [
                -76.6499619988415,
                39.2856829993081,
                0
              ],
              [
                -76.6499030002906,
                39.2849939987557,
                0
              ],
              [
                -76.6498780012175,
                39.2841639988651,
                0
              ],
              [
                -76.6498339998926,
                39.2835819989693,
                0
              ],
              [
                -76.6497830005527,
                39.2830089992088,
                0
              ],
              [
                -76.6497719990756,
                39.2823869982989,
                0
              ],
              [
                -76.6496879995751,
                39.2821919979102,
                0
              ],
              [
                -76.6495679996808,
                39.2819589986424,
                0
              ],
              [
                -76.6494880014056,
                39.2818199977222,
                0
              ],
              [
                -76.6491819992823,
                39.2812839987866,
                0
              ],
              [
                -76.649168999828,
                39.281260998658,
                0
              ],
              [
                -76.6491579996146,
                39.2812419993751,
                0
              ],
              [
                -76.6491259987161,
                39.2811829994114,
                0
              ],
              [
                -76.6487759994756,
                39.2805569989049,
                0
              ],
              [
                -76.6481699999001,
                39.2794229992088,
                0
              ],
              [
                -76.6481210003383,
                39.2793359991818,
                0
              ],
              [
                -76.6479769995152,
                39.2790749989397,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 62,
          "Census_Tract": "24510260604",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "1d142748-aebd-4816-8b7c-1005964a381e",
          "Shape__Area": 5421111.645446777,
          "Shape__Length": 9875.20483364255
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.5438050001567,
                39.2814429994251,
                0
              ],
              [
                -76.5432510002323,
                39.2814629999484,
                0
              ],
              [
                -76.5431990001318,
                39.2814649992072,
                0
              ],
              [
                -76.5421820003933,
                39.2815089992482,
                0
              ],
              [
                -76.5418890005055,
                39.281520999067,
                0
              ],
              [
                -76.5405119999916,
                39.2815729993846,
                0
              ],
              [
                -76.5400539994804,
                39.2815949988196,
                0
              ],
              [
                -76.5399060005393,
                39.2816009993036,
                0
              ],
              [
                -76.5395970005328,
                39.2816129991933,
                0
              ],
              [
                -76.539152999736,
                39.281622998642,
                0
              ],
              [
                -76.538740999902,
                39.2816409992787,
                0
              ],
              [
                -76.5383080012463,
                39.2816529988045,
                0
              ],
              [
                -76.5381940014324,
                39.2816699994046,
                0
              ],
              [
                -76.5376490000496,
                39.2816789988336,
                0
              ],
              [
                -76.5363569997421,
                39.2817379993177,
                0
              ],
              [
                -76.5357039999249,
                39.2817929987794,
                0
              ],
              [
                -76.5355350001379,
                39.2815159990364,
                0
              ],
              [
                -76.5352129998618,
                39.2809869988602,
                0
              ],
              [
                -76.5347250000388,
                39.2800229987732,
                0
              ],
              [
                -76.534700000157,
                39.2799759986289,
                0
              ],
              [
                -76.5346350003945,
                39.2798549987665,
                0
              ],
              [
                -76.5342520000805,
                39.2790789987885,
                0
              ],
              [
                -76.5338759994796,
                39.2783099988678,
                0
              ],
              [
                -76.5337269994733,
                39.2780029989298,
                0
              ],
              [
                -76.5335039996671,
                39.2775409990144,
                0
              ],
              [
                -76.5341810002655,
                39.2769159987932,
                0
              ],
              [
                -76.5350679996465,
                39.2760829993122,
                0
              ],
              [
                -76.5349930013702,
                39.2752929993733,
                0
              ],
              [
                -76.5350819995389,
                39.2752879993329,
                0
              ],
              [
                -76.535169999665,
                39.2752709988498,
                0
              ],
              [
                -76.5352680004615,
                39.2752489989767,
                0
              ],
              [
                -76.535412999662,
                39.2752049990255,
                0
              ],
              [
                -76.5355790003339,
                39.2751569987599,
                0
              ],
              [
                -76.5357460001811,
                39.2751099993593,
                0
              ],
              [
                -76.5358979995332,
                39.2750819988942,
                0
              ],
              [
                -76.536097999914,
                39.275063998997,
                0
              ],
              [
                -76.5363680002404,
                39.2750589993467,
                0
              ],
              [
                -76.5367500005306,
                39.2750349978055,
                0
              ],
              [
                -76.536819999581,
                39.2750209994071,
                0
              ],
              [
                -76.5368950003594,
                39.2749930002382,
                0
              ],
              [
                -76.5370079999486,
                39.2749459986939,
                0
              ],
              [
                -76.5370990004416,
                39.2749119993964,
                0
              ],
              [
                -76.5371879997913,
                39.2748869989202,
                0
              ],
              [
                -76.5373950010855,
                39.2748519989914,
                0
              ],
              [
                -76.537923999634,
                39.2748399987666,
                0
              ],
              [
                -76.5379499988929,
                39.2752519987069,
                0
              ],
              [
                -76.5379729995968,
                39.2756099992912,
                0
              ],
              [
                -76.5379859987341,
                39.2758129978561,
                0
              ],
              [
                -76.5380049997878,
                39.2764659992696,
                0
              ],
              [
                -76.5380520001562,
                39.2764639988709,
                0
              ],
              [
                -76.5383069999022,
                39.2764519989371,
                0
              ],
              [
                -76.5384720002178,
                39.2764479994534,
                0
              ],
              [
                -76.5385310003324,
                39.276445999175,
                0
              ],
              [
                -76.5387709998389,
                39.2764369983041,
                0
              ],
              [
                -76.5388609997801,
                39.2764329991828,
                0
              ],
              [
                -76.5389409988874,
                39.2764309991717,
                0
              ],
              [
                -76.5390830002065,
                39.2764279993754,
                0
              ],
              [
                -76.5393020003162,
                39.2764209993868,
                0
              ],
              [
                -76.5394020000989,
                39.2764179983911,
                0
              ],
              [
                -76.5394780007874,
                39.2764159994489,
                0
              ],
              [
                -76.5396229993248,
                39.2764109993384,
                0
              ],
              [
                -76.539900000312,
                39.2763969996089,
                0
              ],
              [
                -76.5400480002449,
                39.2763939987246,
                0
              ],
              [
                -76.5401710004581,
                39.2763909988674,
                0
              ],
              [
                -76.5405859996489,
                39.2763769999424,
                0
              ],
              [
                -76.5411350008772,
                39.2763579996397,
                0
              ],
              [
                -76.5416909995234,
                39.2763389997557,
                0
              ],
              [
                -76.5422280013881,
                39.2763219985705,
                0
              ],
              [
                -76.5429810000982,
                39.2762969999622,
                0
              ],
              [
                -76.5436399989428,
                39.2762819991632,
                0
              ],
              [
                -76.5436469999231,
                39.2764969980312,
                0
              ],
              [
                -76.5437379987066,
                39.2779309985759,
                0
              ],
              [
                -76.5437130000149,
                39.278301999296,
                0
              ],
              [
                -76.5436669999172,
                39.278627998958,
                0
              ],
              [
                -76.5436559998634,
                39.2789119994086,
                0
              ],
              [
                -76.5436589997604,
                39.2792169988459,
                0
              ],
              [
                -76.5436679998419,
                39.2794509988496,
                0
              ],
              [
                -76.5437780000057,
                39.2810679994457,
                0
              ],
              [
                -76.5438050001567,
                39.2814429994251,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 63,
          "Census_Tract": "24510120202",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "9a463b9f-1299-4611-989c-deb4f98635a4",
          "Shape__Area": 10567485.315979004,
          "Shape__Length": 14620.813767398227
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6162210007326,
                39.3315269990106,
                0
              ],
              [
                -76.6151010003882,
                39.3308299990432,
                0
              ],
              [
                -76.6148710003727,
                39.3306779991237,
                0
              ],
              [
                -76.6145869986294,
                39.3305039992448,
                0
              ],
              [
                -76.61439800015,
                39.3303859991747,
                0
              ],
              [
                -76.6138549998371,
                39.330052999436,
                0
              ],
              [
                -76.6136460004476,
                39.3299219985664,
                0
              ],
              [
                -76.6135890006053,
                39.3295049993374,
                0
              ],
              [
                -76.6135459996647,
                39.3283999994264,
                0
              ],
              [
                -76.6135369999731,
                39.3281709992443,
                0
              ],
              [
                -76.6134350002279,
                39.3270379986751,
                0
              ],
              [
                -76.613333001044,
                39.3259139988102,
                0
              ],
              [
                -76.6133099997031,
                39.3246429991417,
                0
              ],
              [
                -76.6132260002088,
                39.3233809994258,
                0
              ],
              [
                -76.6139060005304,
                39.3233649985658,
                0
              ],
              [
                -76.614621999577,
                39.3233309986094,
                0
              ],
              [
                -76.6151730005715,
                39.3233049986983,
                0
              ],
              [
                -76.6157430002515,
                39.3232869993416,
                0
              ],
              [
                -76.6165330013976,
                39.3232419981985,
                0
              ],
              [
                -76.6171719996522,
                39.3232069991542,
                0
              ],
              [
                -76.6173640001099,
                39.323206999258,
                0
              ],
              [
                -76.617566999846,
                39.3231969995712,
                0
              ],
              [
                -76.6187089996205,
                39.323143997712,
                0
              ],
              [
                -76.6193290005167,
                39.3231159989121,
                0
              ],
              [
                -76.6195929996317,
                39.3231069994512,
                0
              ],
              [
                -76.6198089999639,
                39.3231069993756,
                0
              ],
              [
                -76.6199119985943,
                39.3231049986603,
                0
              ],
              [
                -76.6199859994576,
                39.3231099993165,
                0
              ],
              [
                -76.6200680003687,
                39.3231289991362,
                0
              ],
              [
                -76.6200920000765,
                39.3231489986226,
                0
              ],
              [
                -76.6201139999187,
                39.3231519989737,
                0
              ],
              [
                -76.6201699999239,
                39.323839999603,
                0
              ],
              [
                -76.6201860004831,
                39.3240339991516,
                0
              ],
              [
                -76.6202209990199,
                39.3241659992558,
                0
              ],
              [
                -76.6202540007174,
                39.3242719999318,
                0
              ],
              [
                -76.6204019997993,
                39.3244919981331,
                0
              ],
              [
                -76.6204890004149,
                39.3246009987702,
                0
              ],
              [
                -76.6205529992794,
                39.3246869991816,
                0
              ],
              [
                -76.6208449996256,
                39.324820998555,
                0
              ],
              [
                -76.6212249998726,
                39.3249959983375,
                0
              ],
              [
                -76.6214810001258,
                39.3250879988025,
                0
              ],
              [
                -76.621981000272,
                39.3252939990084,
                0
              ],
              [
                -76.6220419999018,
                39.3253199989706,
                0
              ],
              [
                -76.6221239998973,
                39.3253699993516,
                0
              ],
              [
                -76.6222060002941,
                39.3254279992383,
                0
              ],
              [
                -76.6222789998124,
                39.3254879986306,
                0
              ],
              [
                -76.62237800016,
                39.3256099990802,
                0
              ],
              [
                -76.622558001278,
                39.3258269986761,
                0
              ],
              [
                -76.6228229998594,
                39.3261459996676,
                0
              ],
              [
                -76.6229100003069,
                39.3262619990666,
                0
              ],
              [
                -76.6229840012507,
                39.3263369987,
                0
              ],
              [
                -76.6230489997242,
                39.3263819987619,
                0
              ],
              [
                -76.6231569997721,
                39.3264409983031,
                0
              ],
              [
                -76.6232420002787,
                39.3264679987452,
                0
              ],
              [
                -76.6233350004519,
                39.3264749992903,
                0
              ],
              [
                -76.6234279998059,
                39.3264659988384,
                0
              ],
              [
                -76.6235569998597,
                39.3264319989105,
                0
              ],
              [
                -76.6238299995503,
                39.3262949987514,
                0
              ],
              [
                -76.6240920003554,
                39.3261629997736,
                0
              ],
              [
                -76.6244430001619,
                39.3259899996387,
                0
              ],
              [
                -76.6246989999197,
                39.3258729992333,
                0
              ],
              [
                -76.6250019991095,
                39.3257449987439,
                0
              ],
              [
                -76.6253480011112,
                39.3262239986156,
                0
              ],
              [
                -76.6251089994563,
                39.3264809987345,
                0
              ],
              [
                -76.6250049997116,
                39.3268739991757,
                0
              ],
              [
                -76.6249770001966,
                39.3271669993695,
                0
              ],
              [
                -76.6249729996105,
                39.3278239987124,
                0
              ],
              [
                -76.6250199997269,
                39.3281419987997,
                0
              ],
              [
                -76.6250749997945,
                39.3283699989682,
                0
              ],
              [
                -76.6251390003853,
                39.3285619987303,
                0
              ],
              [
                -76.6251960000099,
                39.3287479987501,
                0
              ],
              [
                -76.6252939990842,
                39.3293629985776,
                0
              ],
              [
                -76.6253560002739,
                39.3296649993486,
                0
              ],
              [
                -76.6254279991064,
                39.3298759986365,
                0
              ],
              [
                -76.6255519999933,
                39.3300709986955,
                0
              ],
              [
                -76.6256659994507,
                39.3302909985664,
                0
              ],
              [
                -76.6257809987188,
                39.330531999745,
                0
              ],
              [
                -76.6258530001079,
                39.3307059986675,
                0
              ],
              [
                -76.625913000904,
                39.3309529992412,
                0
              ],
              [
                -76.6259170004643,
                39.3311579998073,
                0
              ],
              [
                -76.62578699972,
                39.3312579987539,
                0
              ],
              [
                -76.6255390014315,
                39.3313479990227,
                0
              ],
              [
                -76.6252859998992,
                39.331405999044,
                0
              ],
              [
                -76.6250560012904,
                39.3314619992742,
                0
              ],
              [
                -76.6249920005232,
                39.331486000023,
                0
              ],
              [
                -76.6248469995903,
                39.3315419989533,
                0
              ],
              [
                -76.6246269994523,
                39.3316949994198,
                0
              ],
              [
                -76.6244279996085,
                39.3318799989981,
                0
              ],
              [
                -76.624312001384,
                39.3320579990024,
                0
              ],
              [
                -76.624217998757,
                39.3322280002997,
                0
              ],
              [
                -76.624186000305,
                39.3323809990761,
                0
              ],
              [
                -76.6242160005494,
                39.3325679993285,
                0
              ],
              [
                -76.6242249999162,
                39.3327540001552,
                0
              ],
              [
                -76.6241930004364,
                39.3329239987235,
                0
              ],
              [
                -76.6241510005395,
                39.3330849992547,
                0
              ],
              [
                -76.6239610004193,
                39.3333839992904,
                0
              ],
              [
                -76.6238450013709,
                39.3336099987125,
                0
              ],
              [
                -76.6237600001607,
                39.3339339985997,
                0
              ],
              [
                -76.6240239997172,
                39.3364789989042,
                0
              ],
              [
                -76.6237149999014,
                39.3362809988284,
                0
              ],
              [
                -76.6234550010465,
                39.3361129993457,
                0
              ],
              [
                -76.6232489997079,
                39.3359779991757,
                0
              ],
              [
                -76.623169998667,
                39.3359249991024,
                0
              ],
              [
                -76.6229649996179,
                39.335787999275,
                0
              ],
              [
                -76.6226289996809,
                39.3355659993428,
                0
              ],
              [
                -76.6221249996805,
                39.3352379990024,
                0
              ],
              [
                -76.6209650001477,
                39.3344619985854,
                0
              ],
              [
                -76.6206349993665,
                39.3342409993847,
                0
              ],
              [
                -76.6200949994712,
                39.3338879998058,
                0
              ],
              [
                -76.6193949997125,
                39.3334489987603,
                0
              ],
              [
                -76.6193170003892,
                39.3333979989414,
                0
              ],
              [
                -76.6187779995435,
                39.3330289991246,
                0
              ],
              [
                -76.6181479994645,
                39.3326049987569,
                0
              ],
              [
                -76.6179779990639,
                39.3324799998991,
                0
              ],
              [
                -76.6177550002613,
                39.3323369990453,
                0
              ],
              [
                -76.617182000486,
                39.3320229988792,
                0
              ],
              [
                -76.6162730001226,
                39.3314729986416,
                0
              ],
              [
                -76.6162210007326,
                39.3315269990106,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 64,
          "Census_Tract": "24510200600",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "8cb54bb7-a5dd-4f82-a04c-3ead3dd1fe4f",
          "Shape__Area": 19385021.473571777,
          "Shape__Length": 21216.634373806315
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6629239996804,
                39.2874239991878,
                0
              ],
              [
                -76.6628349988674,
                39.2874029992953,
                0
              ],
              [
                -76.6627680003138,
                39.2873940002591,
                0
              ],
              [
                -76.6626910004371,
                39.2873789977327,
                0
              ],
              [
                -76.6626130010532,
                39.2873669990188,
                0
              ],
              [
                -76.6625099996858,
                39.287352999001,
                0
              ],
              [
                -76.6623699996212,
                39.2873449988058,
                0
              ],
              [
                -76.6621340000027,
                39.2873459992943,
                0
              ],
              [
                -76.6619030004458,
                39.2873409993309,
                0
              ],
              [
                -76.661800000281,
                39.2873279994368,
                0
              ],
              [
                -76.661665999726,
                39.2873129987611,
                0
              ],
              [
                -76.6614550005627,
                39.2872509987333,
                0
              ],
              [
                -76.6611880005638,
                39.2871439988318,
                0
              ],
              [
                -76.661048999958,
                39.2871049994151,
                0
              ],
              [
                -76.6607240010872,
                39.2870309988441,
                0
              ],
              [
                -76.6605259997855,
                39.2869909987896,
                0
              ],
              [
                -76.6603750005291,
                39.2869529988695,
                0
              ],
              [
                -76.6602919996839,
                39.2869229986906,
                0
              ],
              [
                -76.660197000351,
                39.2868739991604,
                0
              ],
              [
                -76.6600840001469,
                39.286779998677,
                0
              ],
              [
                -76.6599179994261,
                39.2866299993786,
                0
              ],
              [
                -76.6597029994724,
                39.2864499986304,
                0
              ],
              [
                -76.6595309995194,
                39.2863149988483,
                0
              ],
              [
                -76.6594360007691,
                39.2861999991445,
                0
              ],
              [
                -76.6593350003368,
                39.2860439991978,
                0
              ],
              [
                -76.6592760000931,
                39.2858959990285,
                0
              ],
              [
                -76.6592589997441,
                39.2857629994044,
                0
              ],
              [
                -76.659265999658,
                39.285629999131,
                0
              ],
              [
                -76.6593320001339,
                39.2853049991956,
                0
              ],
              [
                -76.6596369994485,
                39.284426999341,
                0
              ],
              [
                -76.6597869999263,
                39.2838369991907,
                0
              ],
              [
                -76.659981000488,
                39.2828159988228,
                0
              ],
              [
                -76.6599879998703,
                39.2826239985868,
                0
              ],
              [
                -76.6599650004248,
                39.2825089985829,
                0
              ],
              [
                -76.6598600000274,
                39.2823209986184,
                0
              ],
              [
                -76.6590260006935,
                39.2813840000404,
                0
              ],
              [
                -76.6594449998517,
                39.2811069993886,
                0
              ],
              [
                -76.6597959996107,
                39.2808820002967,
                0
              ],
              [
                -76.660175001208,
                39.280656999193,
                0
              ],
              [
                -76.6599909998742,
                39.2803900000048,
                0
              ],
              [
                -76.6595790001736,
                39.2797259987357,
                0
              ],
              [
                -76.6592570010665,
                39.2791389991586,
                0
              ],
              [
                -76.6589830003627,
                39.2785939990364,
                0
              ],
              [
                -76.658683998848,
                39.2780569990555,
                0
              ],
              [
                -76.6586510005642,
                39.2779979978514,
                0
              ],
              [
                -76.658325999909,
                39.2774189989316,
                0
              ],
              [
                -76.6580150001269,
                39.2768709989552,
                0
              ],
              [
                -76.6576079998039,
                39.2760409994529,
                0
              ],
              [
                -76.6578089996104,
                39.2759319993849,
                0
              ],
              [
                -76.6580169993524,
                39.275674999784,
                0
              ],
              [
                -76.6581750001534,
                39.2755399976759,
                0
              ],
              [
                -76.6583369996023,
                39.2753479986322,
                0
              ],
              [
                -76.6583759999295,
                39.2752629990348,
                0
              ],
              [
                -76.6584100004749,
                39.2751850000196,
                0
              ],
              [
                -76.6584620014976,
                39.275079998937,
                0
              ],
              [
                -76.6585079997992,
                39.2749909986354,
                0
              ],
              [
                -76.6585519995215,
                39.274930998858,
                0
              ],
              [
                -76.6586219998821,
                39.274881999086,
                0
              ],
              [
                -76.6587880005195,
                39.2748179976686,
                0
              ],
              [
                -76.6590179995131,
                39.2747139997157,
                0
              ],
              [
                -76.6591039997759,
                39.274675999377,
                0
              ],
              [
                -76.6591929995078,
                39.2746569993566,
                0
              ],
              [
                -76.6593009994221,
                39.2746459991112,
                0
              ],
              [
                -76.659407999672,
                39.2746529994089,
                0
              ],
              [
                -76.6595759999724,
                39.2746779989165,
                0
              ],
              [
                -76.6596680015578,
                39.2747069989642,
                0
              ],
              [
                -76.6597909997147,
                39.2747569990289,
                0
              ],
              [
                -76.6598899990876,
                39.2748149994027,
                0
              ],
              [
                -76.6600000000289,
                39.2749039988525,
                0
              ],
              [
                -76.6601550013021,
                39.2750809986874,
                0
              ],
              [
                -76.6603229998018,
                39.2753019994038,
                0
              ],
              [
                -76.6606370000147,
                39.2756489988724,
                0
              ],
              [
                -76.6607409995895,
                39.2757719993461,
                0
              ],
              [
                -76.6609219994542,
                39.2759899984332,
                0
              ],
              [
                -76.6611059994821,
                39.2761769989475,
                0
              ],
              [
                -76.6611759996099,
                39.2762419990219,
                0
              ],
              [
                -76.6612189995401,
                39.2762769996638,
                0
              ],
              [
                -76.6612809994281,
                39.2763019989763,
                0
              ],
              [
                -76.6614989999635,
                39.2763519991206,
                0
              ],
              [
                -76.66157500057,
                39.276398998303,
                0
              ],
              [
                -76.6617359995172,
                39.2763479988484,
                0
              ],
              [
                -76.661870000155,
                39.2763190000307,
                0
              ],
              [
                -76.6620559999213,
                39.2762819987895,
                0
              ],
              [
                -76.6622909989415,
                39.2762399993015,
                0
              ],
              [
                -76.6623689996601,
                39.2762259987128,
                0
              ],
              [
                -76.6625009985623,
                39.2761949991342,
                0
              ],
              [
                -76.6628340000303,
                39.276135999006,
                0
              ],
              [
                -76.6631229994875,
                39.27608799795,
                0
              ],
              [
                -76.66327700055,
                39.2760539989134,
                0
              ],
              [
                -76.6633809999454,
                39.2760339992471,
                0
              ],
              [
                -76.6635029996498,
                39.2760270004148,
                0
              ],
              [
                -76.6637889990442,
                39.2760449996701,
                0
              ],
              [
                -76.6639069994358,
                39.2760589992442,
                0
              ],
              [
                -76.6639869997123,
                39.2760589993437,
                0
              ],
              [
                -76.6641060001747,
                39.2760509986651,
                0
              ],
              [
                -76.6642220004096,
                39.2760279988077,
                0
              ],
              [
                -76.6643739990194,
                39.2759849994014,
                0
              ],
              [
                -76.6645560000923,
                39.2759279993718,
                0
              ],
              [
                -76.6646219999975,
                39.2758929986778,
                0
              ],
              [
                -76.664681000338,
                39.2758399987532,
                0
              ],
              [
                -76.6647380003653,
                39.2757729988493,
                0
              ],
              [
                -76.6647879995197,
                39.275675999773,
                0
              ],
              [
                -76.6647990002423,
                39.2756219989545,
                0
              ],
              [
                -76.6648159998314,
                39.2755780002018,
                0
              ],
              [
                -76.6648310003304,
                39.2755199996996,
                0
              ],
              [
                -76.664834000906,
                39.2754529987656,
                0
              ],
              [
                -76.6648320000699,
                39.275379999795,
                0
              ],
              [
                -76.6648180005425,
                39.2753109992941,
                0
              ],
              [
                -76.6648270003235,
                39.2752369994396,
                0
              ],
              [
                -76.664859000961,
                39.2751659989988,
                0
              ],
              [
                -76.6648790000741,
                39.2751309983974,
                0
              ],
              [
                -76.6649399994521,
                39.2750829987635,
                0
              ],
              [
                -76.6649930015086,
                39.2750429993765,
                0
              ],
              [
                -76.6650050003272,
                39.2750369993937,
                0
              ],
              [
                -76.6650219996317,
                39.2750339987975,
                0
              ],
              [
                -76.6650409988923,
                39.2750349978822,
                0
              ],
              [
                -76.665061000017,
                39.2750429987435,
                0
              ],
              [
                -76.6651480005408,
                39.2751079990052,
                0
              ],
              [
                -76.66520099968,
                39.2751439986267,
                0
              ],
              [
                -76.6652750003894,
                39.275199999151,
                0
              ],
              [
                -76.6656400001189,
                39.2754519992304,
                0
              ],
              [
                -76.6659049998012,
                39.275650999346,
                0
              ],
              [
                -76.6663199997433,
                39.275948999974,
                0
              ],
              [
                -76.6665720002197,
                39.2760699988697,
                0
              ],
              [
                -76.6667559995674,
                39.2761159987304,
                0
              ],
              [
                -76.6669509999783,
                39.2761389988165,
                0
              ],
              [
                -76.6670820001271,
                39.2761469987562,
                0
              ],
              [
                -76.6674019996151,
                39.2761179991503,
                0
              ],
              [
                -76.6675779998904,
                39.2760849989711,
                0
              ],
              [
                -76.6679060004849,
                39.275919999287,
                0
              ],
              [
                -76.6680330005062,
                39.2758819993589,
                0
              ],
              [
                -76.6681540004728,
                39.275874999177,
                0
              ],
              [
                -76.6682219996075,
                39.2758789987986,
                0
              ],
              [
                -76.668341000079,
                39.2759099986229,
                0
              ],
              [
                -76.6684910005582,
                39.2759849988689,
                0
              ],
              [
                -76.6687239996167,
                39.2760649998776,
                0
              ],
              [
                -76.6688500001679,
                39.276072999057,
                0
              ],
              [
                -76.668962000308,
                39.2760579991241,
                0
              ],
              [
                -76.6690199999469,
                39.2760359993343,
                0
              ],
              [
                -76.6690809996426,
                39.2759869986243,
                0
              ],
              [
                -76.6692239996628,
                39.2757179988669,
                0
              ],
              [
                -76.6694180001051,
                39.2755219988043,
                0
              ],
              [
                -76.6695069997033,
                39.2754829985658,
                0
              ],
              [
                -76.669587999614,
                39.2754759987445,
                0
              ],
              [
                -76.6696890001986,
                39.2754729986525,
                0
              ],
              [
                -76.6698360004397,
                39.2754969993201,
                0
              ],
              [
                -76.6700219996937,
                39.275532999433,
                0
              ],
              [
                -76.6704939995041,
                39.2757219991857,
                0
              ],
              [
                -76.6709770001424,
                39.275887998965,
                0
              ],
              [
                -76.6712940012045,
                39.2759349992521,
                0
              ],
              [
                -76.6715630003993,
                39.2759329990384,
                0
              ],
              [
                -76.6715719992891,
                39.2764019985805,
                0
              ],
              [
                -76.6715749998568,
                39.276578999424,
                0
              ],
              [
                -76.6715820003307,
                39.2769709988983,
                0
              ],
              [
                -76.6715970003561,
                39.27756999764,
                0
              ],
              [
                -76.671614999903,
                39.278613998668,
                0
              ],
              [
                -76.6716179995539,
                39.2787959986156,
                0
              ],
              [
                -76.6716510004381,
                39.2796699991845,
                0
              ],
              [
                -76.6720660000949,
                39.2804469990174,
                0
              ],
              [
                -76.6721899999591,
                39.2806609992321,
                0
              ],
              [
                -76.6722200001245,
                39.2807519994102,
                0
              ],
              [
                -76.6722239999003,
                39.280824998291,
                0
              ],
              [
                -76.6722159998481,
                39.2809369990383,
                0
              ],
              [
                -76.6721670000798,
                39.2810869992342,
                0
              ],
              [
                -76.6721320005023,
                39.2812759990695,
                0
              ],
              [
                -76.6721189994277,
                39.2814919993298,
                0
              ],
              [
                -76.6721219996335,
                39.2818529999769,
                0
              ],
              [
                -76.6721229998525,
                39.2819299988475,
                0
              ],
              [
                -76.6721409995541,
                39.2824689990709,
                0
              ],
              [
                -76.6721630005228,
                39.2831569987537,
                0
              ],
              [
                -76.6721850002495,
                39.2838869989083,
                0
              ],
              [
                -76.6722749994223,
                39.2848599991379,
                0
              ],
              [
                -76.6723159990811,
                39.2858319994094,
                0
              ],
              [
                -76.6723410004837,
                39.2864029990488,
                0
              ],
              [
                -76.6723709995405,
                39.2869909990328,
                0
              ],
              [
                -76.672412000147,
                39.2876919991284,
                0
              ],
              [
                -76.6724510002213,
                39.288297998598,
                0
              ],
              [
                -76.6724750001715,
                39.2887129989652,
                0
              ],
              [
                -76.6725500004701,
                39.289789999603,
                0
              ],
              [
                -76.6725730001639,
                39.2905999991204,
                0
              ],
              [
                -76.6725699996015,
                39.2906809986099,
                0
              ],
              [
                -76.6725959995763,
                39.2907739986508,
                0
              ],
              [
                -76.6726120005432,
                39.2908669987421,
                0
              ],
              [
                -76.6726179999069,
                39.2909489988273,
                0
              ],
              [
                -76.6726330013919,
                39.2912919987143,
                0
              ],
              [
                -76.6726669998665,
                39.2915839992608,
                0
              ],
              [
                -76.6726660005363,
                39.291682998738,
                0
              ],
              [
                -76.6726709995002,
                39.2918619985872,
                0
              ],
              [
                -76.6726879996479,
                39.2925529989293,
                0
              ],
              [
                -76.6727109999927,
                39.292828999184,
                0
              ],
              [
                -76.6727769995162,
                39.2940859994311,
                0
              ],
              [
                -76.6727789987278,
                39.2941149985616,
                0
              ],
              [
                -76.6727800005528,
                39.2941739991249,
                0
              ],
              [
                -76.6725939996541,
                39.2941889991632,
                0
              ],
              [
                -76.6723829997514,
                39.2942009999364,
                0
              ],
              [
                -76.6722870002455,
                39.2942049981775,
                0
              ],
              [
                -76.6721669999179,
                39.2942069990479,
                0
              ],
              [
                -76.6718859995475,
                39.2942169993599,
                0
              ],
              [
                -76.6716339996558,
                39.2942279988313,
                0
              ],
              [
                -76.6712629996643,
                39.2942319992436,
                0
              ],
              [
                -76.6706179994981,
                39.2942559993635,
                0
              ],
              [
                -76.6704650002819,
                39.2942569989126,
                0
              ],
              [
                -76.6701700005527,
                39.2942659992496,
                0
              ],
              [
                -76.6699460005316,
                39.2942659988992,
                0
              ],
              [
                -76.6698710014896,
                39.294268999376,
                0
              ],
              [
                -76.669717000533,
                39.2942759995819,
                0
              ],
              [
                -76.6697210002807,
                39.2942559987094,
                0
              ],
              [
                -76.6697119994649,
                39.2941629990742,
                0
              ],
              [
                -76.6697249998019,
                39.2938239987896,
                0
              ],
              [
                -76.6696950005218,
                39.2936279988839,
                0
              ],
              [
                -76.6696840001733,
                39.2935929996639,
                0
              ],
              [
                -76.6696420005143,
                39.2935279991334,
                0
              ],
              [
                -76.6695439997726,
                39.2934249993708,
                0
              ],
              [
                -76.6694389999324,
                39.2933229985859,
                0
              ],
              [
                -76.6693340001662,
                39.2932299989703,
                0
              ],
              [
                -76.6691830002402,
                39.2931529986951,
                0
              ],
              [
                -76.6689990002534,
                39.2930709988268,
                0
              ],
              [
                -76.6688340004098,
                39.2930189988049,
                0
              ],
              [
                -76.6686629993515,
                39.2929729995844,
                0
              ],
              [
                -76.6684660008303,
                39.2928649987831,
                0
              ],
              [
                -76.6678579998797,
                39.2924119992528,
                0
              ],
              [
                -76.6674580001287,
                39.2920739987802,
                0
              ],
              [
                -76.6672150006345,
                39.2918429977709,
                0
              ],
              [
                -76.6669230001901,
                39.2914939985726,
                0
              ],
              [
                -76.6667129994682,
                39.291262999051,
                0
              ],
              [
                -76.6665300004171,
                39.291021999004,
                0
              ],
              [
                -76.6662059989251,
                39.2904629989229,
                0
              ],
              [
                -76.6660559995099,
                39.2902529986416,
                0
              ],
              [
                -76.6657849996526,
                39.2896639986215,
                0
              ],
              [
                -76.6655630003653,
                39.2892689986035,
                0
              ],
              [
                -76.6654190012866,
                39.2890489998704,
                0
              ],
              [
                -76.6652290005884,
                39.2888229987171,
                0
              ],
              [
                -76.6649930011006,
                39.2885769989382,
                0
              ],
              [
                -76.6648149999674,
                39.2884179991012,
                0
              ],
              [
                -76.6644480004745,
                39.2880939987491,
                0
              ],
              [
                -76.6640409984338,
                39.287848999169,
                0
              ],
              [
                -76.6636130003712,
                39.2876159991945,
                0
              ],
              [
                -76.6635229996846,
                39.2875539989184,
                0
              ],
              [
                -76.6634379997772,
                39.2875119989396,
                0
              ],
              [
                -76.6633459996946,
                39.2874729990825,
                0
              ],
              [
                -76.6632699995351,
                39.2874509991026,
                0
              ],
              [
                -76.663179000038,
                39.2874319988317,
                0
              ],
              [
                -76.6630489996086,
                39.2874229994506,
                0
              ],
              [
                -76.6629239996804,
                39.2874239991878,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 65,
          "Census_Tract": "24510200701",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "9e332623-e5d1-4934-8acd-92ed598ee1cb",
          "Shape__Area": 12955695.770568848,
          "Shape__Length": 15890.738705138876
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6723159990811,
                39.2858319994094,
                0
              ],
              [
                -76.6726850003121,
                39.2858049992398,
                0
              ],
              [
                -76.6728870005348,
                39.2858019994103,
                0
              ],
              [
                -76.672982000124,
                39.2858049986166,
                0
              ],
              [
                -76.6730650000951,
                39.2858259993488,
                0
              ],
              [
                -76.6731569997539,
                39.285860999439,
                0
              ],
              [
                -76.6732350001694,
                39.2859039988897,
                0
              ],
              [
                -76.673483999919,
                39.286111999151,
                0
              ],
              [
                -76.6739079985323,
                39.2864479989164,
                0
              ],
              [
                -76.6741540000543,
                39.2866289990526,
                0
              ],
              [
                -76.6748290005735,
                39.2871579988664,
                0
              ],
              [
                -76.6749429990409,
                39.2872499989858,
                0
              ],
              [
                -76.6755979999568,
                39.287684998806,
                0
              ],
              [
                -76.6756899999282,
                39.2877399991266,
                0
              ],
              [
                -76.6759869997287,
                39.2879249985618,
                0
              ],
              [
                -76.6762790003475,
                39.2881069992431,
                0
              ],
              [
                -76.6763679994584,
                39.2881649992863,
                0
              ],
              [
                -76.6767200001527,
                39.2878509994108,
                0
              ],
              [
                -76.677952999761,
                39.2867519999654,
                0
              ],
              [
                -76.6780970008903,
                39.2866239987099,
                0
              ],
              [
                -76.6804220002971,
                39.2845049998786,
                0
              ],
              [
                -76.6808129988467,
                39.2841489993037,
                0
              ],
              [
                -76.6810780009272,
                39.2841789991585,
                0
              ],
              [
                -76.6814469997717,
                39.2842419987601,
                0
              ],
              [
                -76.6816220003919,
                39.2842859987884,
                0
              ],
              [
                -76.6817389995295,
                39.2843259987842,
                0
              ],
              [
                -76.6818740001564,
                39.2843799992745,
                0
              ],
              [
                -76.6821300006044,
                39.2845189993568,
                0
              ],
              [
                -76.6825490002988,
                39.2847629986916,
                0
              ],
              [
                -76.6827920002129,
                39.284904998633,
                0
              ],
              [
                -76.683479999521,
                39.2853439990696,
                0
              ],
              [
                -76.6841549994389,
                39.2857549990933,
                0
              ],
              [
                -76.6848720004657,
                39.2861909994098,
                0
              ],
              [
                -76.6859919995108,
                39.286894999433,
                0
              ],
              [
                -76.6862729988389,
                39.2870309990824,
                0
              ],
              [
                -76.6867760002117,
                39.2872289993913,
                0
              ],
              [
                -76.6869850000995,
                39.287302998894,
                0
              ],
              [
                -76.687244000641,
                39.287398998859,
                0
              ],
              [
                -76.687473999471,
                39.2874849992448,
                0
              ],
              [
                -76.6878739994793,
                39.2876639993824,
                0
              ],
              [
                -76.6883670001897,
                39.2879169998576,
                0
              ],
              [
                -76.6889249986487,
                39.2882039992331,
                0
              ],
              [
                -76.6889779994791,
                39.2892079989701,
                0
              ],
              [
                -76.6889919999679,
                39.2894569991309,
                0
              ],
              [
                -76.6890150007451,
                39.2898730001132,
                0
              ],
              [
                -76.6890319999989,
                39.2900109988155,
                0
              ],
              [
                -76.6890490000028,
                39.2901379992638,
                0
              ],
              [
                -76.6890760010061,
                39.2902590001077,
                0
              ],
              [
                -76.6891099995274,
                39.2904099993645,
                0
              ],
              [
                -76.689221998525,
                39.2909810001658,
                0
              ],
              [
                -76.6892730001869,
                39.291473998722,
                0
              ],
              [
                -76.6893000003107,
                39.2917189985658,
                0
              ],
              [
                -76.6893349995735,
                39.2924119992321,
                0
              ],
              [
                -76.6893659996777,
                39.2927699986837,
                0
              ],
              [
                -76.6893999999081,
                39.2931719989701,
                0
              ],
              [
                -76.6894170005422,
                39.2934349990622,
                0
              ],
              [
                -76.6894249998167,
                39.2935809986026,
                0
              ],
              [
                -76.6884329994385,
                39.2936170000391,
                0
              ],
              [
                -76.6869949994535,
                39.293688998833,
                0
              ],
              [
                -76.6866120004764,
                39.2936969988827,
                0
              ],
              [
                -76.6859950004472,
                39.2937109993555,
                0
              ],
              [
                -76.6849749995663,
                39.2937509988052,
                0
              ],
              [
                -76.6840570004672,
                39.2937930004127,
                0
              ],
              [
                -76.6838919994595,
                39.2937979989396,
                0
              ],
              [
                -76.6826160000297,
                39.2938349991091,
                0
              ],
              [
                -76.6816310005191,
                39.2938749992312,
                0
              ],
              [
                -76.6812109997702,
                39.2938839992397,
                0
              ],
              [
                -76.6807769984367,
                39.2938979994395,
                0
              ],
              [
                -76.6806570004792,
                39.2939029985976,
                0
              ],
              [
                -76.6797940005184,
                39.2939319986703,
                0
              ],
              [
                -76.6797659995991,
                39.2939339985938,
                0
              ],
              [
                -76.6796659994739,
                39.2939399988438,
                0
              ],
              [
                -76.6784020000596,
                39.2939769985855,
                0
              ],
              [
                -76.6772469987553,
                39.2940339990844,
                0
              ],
              [
                -76.6764439997226,
                39.2940619990175,
                0
              ],
              [
                -76.6755740003829,
                39.2940969992066,
                0
              ],
              [
                -76.674167999139,
                39.2941329991192,
                0
              ],
              [
                -76.6727800005528,
                39.2941739991249,
                0
              ],
              [
                -76.6727789987278,
                39.2941149985616,
                0
              ],
              [
                -76.6727769995162,
                39.2940859994311,
                0
              ],
              [
                -76.6727109999927,
                39.292828999184,
                0
              ],
              [
                -76.6726879996479,
                39.2925529989293,
                0
              ],
              [
                -76.6726709995002,
                39.2918619985872,
                0
              ],
              [
                -76.6726660005363,
                39.291682998738,
                0
              ],
              [
                -76.6726669998665,
                39.2915839992608,
                0
              ],
              [
                -76.6726330013919,
                39.2912919987143,
                0
              ],
              [
                -76.6726179999069,
                39.2909489988273,
                0
              ],
              [
                -76.6726120005432,
                39.2908669987421,
                0
              ],
              [
                -76.6725959995763,
                39.2907739986508,
                0
              ],
              [
                -76.6725699996015,
                39.2906809986099,
                0
              ],
              [
                -76.6725730001639,
                39.2905999991204,
                0
              ],
              [
                -76.6725500004701,
                39.289789999603,
                0
              ],
              [
                -76.6724750001715,
                39.2887129989652,
                0
              ],
              [
                -76.6724510002213,
                39.288297998598,
                0
              ],
              [
                -76.672412000147,
                39.2876919991284,
                0
              ],
              [
                -76.6723709995405,
                39.2869909990328,
                0
              ],
              [
                -76.6723410004837,
                39.2864029990488,
                0
              ],
              [
                -76.6723159990811,
                39.2858319994094,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 66,
          "Census_Tract": "24510200800",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "bcf86a60-60d2-47d2-a709-c40275afda06",
          "Shape__Area": 11487289.403259277,
          "Shape__Length": 15637.912422099396
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6808129988467,
                39.2841489993037,
                0
              ],
              [
                -76.6796830001083,
                39.2839709986348,
                0
              ],
              [
                -76.678925000216,
                39.2838149993537,
                0
              ],
              [
                -76.6785629994734,
                39.2837399993322,
                0
              ],
              [
                -76.6775799993354,
                39.2834909989446,
                0
              ],
              [
                -76.6772860002066,
                39.2834179993352,
                0
              ],
              [
                -76.6765320003754,
                39.2832099991942,
                0
              ],
              [
                -76.6763800003523,
                39.2831709991921,
                0
              ],
              [
                -76.6762080015583,
                39.2831229993241,
                0
              ],
              [
                -76.676046000135,
                39.2830629989302,
                0
              ],
              [
                -76.6758590002021,
                39.2829799986906,
                0
              ],
              [
                -76.675532000405,
                39.2828229987271,
                0
              ],
              [
                -76.6745769994755,
                39.2823420002439,
                0
              ],
              [
                -76.6740040002431,
                39.2820529987044,
                0
              ],
              [
                -76.6739260014406,
                39.2820139990839,
                0
              ],
              [
                -76.6727209999856,
                39.2814069989257,
                0
              ],
              [
                -76.6721670000798,
                39.2810869992342,
                0
              ],
              [
                -76.6722159998481,
                39.2809369990383,
                0
              ],
              [
                -76.6722239999003,
                39.280824998291,
                0
              ],
              [
                -76.6722200001245,
                39.2807519994102,
                0
              ],
              [
                -76.6721899999591,
                39.2806609992321,
                0
              ],
              [
                -76.6720660000949,
                39.2804469990174,
                0
              ],
              [
                -76.6716510004381,
                39.2796699991845,
                0
              ],
              [
                -76.6716179995539,
                39.2787959986156,
                0
              ],
              [
                -76.671614999903,
                39.278613998668,
                0
              ],
              [
                -76.6715970003561,
                39.27756999764,
                0
              ],
              [
                -76.6715820003307,
                39.2769709988983,
                0
              ],
              [
                -76.6715749998568,
                39.276578999424,
                0
              ],
              [
                -76.6715719992891,
                39.2764019985805,
                0
              ],
              [
                -76.6715630003993,
                39.2759329990384,
                0
              ],
              [
                -76.6717109997818,
                39.2759260004293,
                0
              ],
              [
                -76.6718709998513,
                39.2759129982552,
                0
              ],
              [
                -76.6720239997681,
                39.2758909984238,
                0
              ],
              [
                -76.6723999995287,
                39.2758189986834,
                0
              ],
              [
                -76.6725170003515,
                39.2757989992735,
                0
              ],
              [
                -76.6726709994928,
                39.2757549975772,
                0
              ],
              [
                -76.6728470001149,
                39.2756859986714,
                0
              ],
              [
                -76.6729310003732,
                39.2756339992399,
                0
              ],
              [
                -76.673029000464,
                39.275542998804,
                0
              ],
              [
                -76.673096999869,
                39.2754769992042,
                0
              ],
              [
                -76.6731170001204,
                39.2754589990975,
                0
              ],
              [
                -76.6731879987533,
                39.2753959992211,
                0
              ],
              [
                -76.6732920001207,
                39.275337999358,
                0
              ],
              [
                -76.6736379994863,
                39.2752089993628,
                0
              ],
              [
                -76.6738169995004,
                39.275171997892,
                0
              ],
              [
                -76.673958999888,
                39.2751709977836,
                0
              ],
              [
                -76.6740859986103,
                39.2751839987547,
                0
              ],
              [
                -76.6741689994748,
                39.2751839993471,
                0
              ],
              [
                -76.6742439998558,
                39.2751739990516,
                0
              ],
              [
                -76.6743300004303,
                39.2751579986091,
                0
              ],
              [
                -76.674438000015,
                39.2751259994005,
                0
              ],
              [
                -76.674680000128,
                39.2750329988139,
                0
              ],
              [
                -76.6748309995374,
                39.274971999407,
                0
              ],
              [
                -76.6749139998281,
                39.2749229989246,
                0
              ],
              [
                -76.6750310005125,
                39.274814998875,
                0
              ],
              [
                -76.6751060004781,
                39.2747249986565,
                0
              ],
              [
                -76.6751549996139,
                39.2746479992372,
                0
              ],
              [
                -76.6751930010888,
                39.2745999991406,
                0
              ],
              [
                -76.6752689994419,
                39.2744679990413,
                0
              ],
              [
                -76.6753339987304,
                39.2743429989325,
                0
              ],
              [
                -76.6754189995423,
                39.2742399993275,
                0
              ],
              [
                -76.6754819999856,
                39.2741829993433,
                0
              ],
              [
                -76.6755460004361,
                39.2741439993141,
                0
              ],
              [
                -76.6756109997823,
                39.2741229992357,
                0
              ],
              [
                -76.6757069999885,
                39.2741049986874,
                0
              ],
              [
                -76.6758109997655,
                39.2740999992227,
                0
              ],
              [
                -76.6759229986305,
                39.2741169994325,
                0
              ],
              [
                -76.6760180003743,
                39.2741409993125,
                0
              ],
              [
                -76.6761510002075,
                39.2741949992868,
                0
              ],
              [
                -76.6763869998662,
                39.2743189992303,
                0
              ],
              [
                -76.6766769998346,
                39.2743849986683,
                0
              ],
              [
                -76.6768829997225,
                39.2745869993672,
                0
              ],
              [
                -76.6770220002286,
                39.2747180002707,
                0
              ],
              [
                -76.6771329999519,
                39.2748269985896,
                0
              ],
              [
                -76.677252000541,
                39.274941998943,
                0
              ],
              [
                -76.6778610009841,
                39.2755409983802,
                0
              ],
              [
                -76.678033000151,
                39.2757099988951,
                0
              ],
              [
                -76.6782909999584,
                39.2759929991181,
                0
              ],
              [
                -76.6784630004598,
                39.2761989986567,
                0
              ],
              [
                -76.6785709994554,
                39.2762849990096,
                0
              ],
              [
                -76.6787030002866,
                39.2763699993192,
                0
              ],
              [
                -76.6788419993073,
                39.2764459992892,
                0
              ],
              [
                -76.678963000289,
                39.2765329986386,
                0
              ],
              [
                -76.6790189998563,
                39.2765999989889,
                0
              ],
              [
                -76.67910899997,
                39.2767219990128,
                0
              ],
              [
                -76.6791819997043,
                39.2768129987686,
                0
              ],
              [
                -76.6792409999992,
                39.2768679991543,
                0
              ],
              [
                -76.6795909986276,
                39.2771229988325,
                0
              ],
              [
                -76.6797030003388,
                39.2771549993936,
                0
              ],
              [
                -76.6797800005451,
                39.2771679992527,
                0
              ],
              [
                -76.6798890004758,
                39.2771699988077,
                0
              ],
              [
                -76.6799769998106,
                39.2771599978526,
                0
              ],
              [
                -76.6800429994633,
                39.2771469986221,
                0
              ],
              [
                -76.6801089998827,
                39.2771219994165,
                0
              ],
              [
                -76.6802159996511,
                39.277098999801,
                0
              ],
              [
                -76.6804190000734,
                39.2770759992108,
                0
              ],
              [
                -76.6805229998705,
                39.2771019988655,
                0
              ],
              [
                -76.6805800000603,
                39.2771319988101,
                0
              ],
              [
                -76.68064099985,
                39.2771619987924,
                0
              ],
              [
                -76.680712000051,
                39.2771729991507,
                0
              ],
              [
                -76.6808060008171,
                39.2771749994162,
                0
              ],
              [
                -76.680858000499,
                39.2771559986428,
                0
              ],
              [
                -76.6808939998207,
                39.2771299986999,
                0
              ],
              [
                -76.6809549995483,
                39.2770919991603,
                0
              ],
              [
                -76.680987999192,
                39.2770559997976,
                0
              ],
              [
                -76.6810260014066,
                39.2770239989783,
                0
              ],
              [
                -76.6810929999186,
                39.2769299991214,
                0
              ],
              [
                -76.6811369998658,
                39.2768999989267,
                0
              ],
              [
                -76.6812649995546,
                39.2768879987114,
                0
              ],
              [
                -76.6814239995283,
                39.2768969990187,
                0
              ],
              [
                -76.6815480001314,
                39.2769119987735,
                0
              ],
              [
                -76.6816029996571,
                39.2769379988232,
                0
              ],
              [
                -76.6816729999663,
                39.2769979990988,
                0
              ],
              [
                -76.6817089998941,
                39.2770560002878,
                0
              ],
              [
                -76.6818600004998,
                39.2771899985613,
                0
              ],
              [
                -76.681986998959,
                39.2772439990154,
                0
              ],
              [
                -76.6820140003845,
                39.2772519988163,
                0
              ],
              [
                -76.6820710004659,
                39.277268999151,
                0
              ],
              [
                -76.6821499998609,
                39.2772710000696,
                0
              ],
              [
                -76.6822930005173,
                39.2772669993528,
                0
              ],
              [
                -76.6824609995022,
                39.2772319987986,
                0
              ],
              [
                -76.6826020008742,
                39.2771709993474,
                0
              ],
              [
                -76.6826990004439,
                39.2771479992729,
                0
              ],
              [
                -76.6828280001486,
                39.2771340003666,
                0
              ],
              [
                -76.6829730001868,
                39.2771329992521,
                0
              ],
              [
                -76.6830300000065,
                39.2771269990882,
                0
              ],
              [
                -76.6830859997832,
                39.2771149989312,
                0
              ],
              [
                -76.6831130001796,
                39.2770959990648,
                0
              ],
              [
                -76.6831489996417,
                39.2770349993615,
                0
              ],
              [
                -76.6831910001212,
                39.2769469993052,
                0
              ],
              [
                -76.6832630005028,
                39.2768219994029,
                0
              ],
              [
                -76.683300999448,
                39.2767709989857,
                0
              ],
              [
                -76.6834029999239,
                39.2766859989116,
                0
              ],
              [
                -76.6835810004618,
                39.276568998599,
                0
              ],
              [
                -76.6836660004045,
                39.2765659992271,
                0
              ],
              [
                -76.6837140007684,
                39.276567999375,
                0
              ],
              [
                -76.6838149986318,
                39.2765899985623,
                0
              ],
              [
                -76.683894000159,
                39.2766269991925,
                0
              ],
              [
                -76.684288999507,
                39.2769039998475,
                0
              ],
              [
                -76.6846090004754,
                39.2771459986827,
                0
              ],
              [
                -76.6849370003533,
                39.2774469999042,
                0
              ],
              [
                -76.6855949996349,
                39.277969999125,
                0
              ],
              [
                -76.6859029987786,
                39.2782199987942,
                0
              ],
              [
                -76.6857889990756,
                39.2783719990034,
                0
              ],
              [
                -76.6856390000189,
                39.278580999266,
                0
              ],
              [
                -76.6855550003326,
                39.2787149985557,
                0
              ],
              [
                -76.6855240005665,
                39.2787749989933,
                0
              ],
              [
                -76.6855009998963,
                39.2788399993433,
                0
              ],
              [
                -76.6855000004197,
                39.2789119989584,
                0
              ],
              [
                -76.6855020000871,
                39.279164999103,
                0
              ],
              [
                -76.6855060001847,
                39.2794749992956,
                0
              ],
              [
                -76.6855269995758,
                39.2799569992023,
                0
              ],
              [
                -76.6855290005127,
                39.280004998865,
                0
              ],
              [
                -76.6856099992908,
                39.2816789988822,
                0
              ],
              [
                -76.6867060000926,
                39.2816559988407,
                0
              ],
              [
                -76.6867389995549,
                39.2820849988808,
                0
              ],
              [
                -76.6867730007208,
                39.282523999057,
                0
              ],
              [
                -76.6868170000203,
                39.2833799990216,
                0
              ],
              [
                -76.6868319995528,
                39.2838089985614,
                0
              ],
              [
                -76.6868469997729,
                39.2842089990095,
                0
              ],
              [
                -76.6867849994766,
                39.2842589978802,
                0
              ],
              [
                -76.6867240000149,
                39.28433299921,
                0
              ],
              [
                -76.6866879996884,
                39.2844139994288,
                0
              ],
              [
                -76.686664999871,
                39.2845179991631,
                0
              ],
              [
                -76.6866689999341,
                39.2846819993039,
                0
              ],
              [
                -76.6866810001826,
                39.2848099994276,
                0
              ],
              [
                -76.6867090003892,
                39.2850219992477,
                0
              ],
              [
                -76.6867250003797,
                39.2855319992854,
                0
              ],
              [
                -76.68674499944,
                39.2859629989688,
                0
              ],
              [
                -76.6867559995621,
                39.28640499898,
                0
              ],
              [
                -76.6867760002117,
                39.2872289993913,
                0
              ],
              [
                -76.6862729988389,
                39.2870309990824,
                0
              ],
              [
                -76.6859919995108,
                39.286894999433,
                0
              ],
              [
                -76.6848720004657,
                39.2861909994098,
                0
              ],
              [
                -76.6841549994389,
                39.2857549990933,
                0
              ],
              [
                -76.683479999521,
                39.2853439990696,
                0
              ],
              [
                -76.6827920002129,
                39.284904998633,
                0
              ],
              [
                -76.6825490002988,
                39.2847629986916,
                0
              ],
              [
                -76.6821300006044,
                39.2845189993568,
                0
              ],
              [
                -76.6818740001564,
                39.2843799992745,
                0
              ],
              [
                -76.6817389995295,
                39.2843259987842,
                0
              ],
              [
                -76.6816220003919,
                39.2842859987884,
                0
              ],
              [
                -76.6814469997717,
                39.2842419987601,
                0
              ],
              [
                -76.6810780009272,
                39.2841789991585,
                0
              ],
              [
                -76.6808129988467,
                39.2841489993037,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 67,
          "Census_Tract": "24510270903",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "716c1364-1bd0-43b2-875c-0bb4b25b4d1b",
          "Shape__Area": 11724999.514831543,
          "Shape__Length": 17825.17911596072
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.5920060001953,
                39.3461629988287,
                0
              ],
              [
                -76.5915530003977,
                39.3461409988624,
                0
              ],
              [
                -76.5910670003264,
                39.3461329988611,
                0
              ],
              [
                -76.5899239996715,
                39.3460789993638,
                0
              ],
              [
                -76.5893229996239,
                39.3460579985629,
                0
              ],
              [
                -76.5890690000182,
                39.3460519993383,
                0
              ],
              [
                -76.5886189994782,
                39.3460189986355,
                0
              ],
              [
                -76.5881299994692,
                39.3460009984305,
                0
              ],
              [
                -76.5878099984779,
                39.3459829988107,
                0
              ],
              [
                -76.5874250004674,
                39.3459639992153,
                0
              ],
              [
                -76.5872290001153,
                39.3459419987103,
                0
              ],
              [
                -76.5870890001255,
                39.3458919994147,
                0
              ],
              [
                -76.5867559996993,
                39.3458839981887,
                0
              ],
              [
                -76.5863919998088,
                39.345869998793,
                0
              ],
              [
                -76.5861779998802,
                39.3458559993912,
                0
              ],
              [
                -76.5859470004949,
                39.3458629982747,
                0
              ],
              [
                -76.5859129995878,
                39.3458639990564,
                0
              ],
              [
                -76.5854290004496,
                39.3458619988702,
                0
              ],
              [
                -76.585021000225,
                39.3458679987665,
                0
              ],
              [
                -76.5848270005768,
                39.3458709988196,
                0
              ],
              [
                -76.5847859997126,
                39.3458719988768,
                0
              ],
              [
                -76.5847209999792,
                39.3458769990383,
                0
              ],
              [
                -76.5845599995232,
                39.3458879994344,
                0
              ],
              [
                -76.5842749996536,
                39.3458869992453,
                0
              ],
              [
                -76.5841459984815,
                39.3458859989844,
                0
              ],
              [
                -76.5838979999967,
                39.3458939992982,
                0
              ],
              [
                -76.5835169997368,
                39.3458929988565,
                0
              ],
              [
                -76.5833699997827,
                39.3458780003424,
                0
              ],
              [
                -76.583244999033,
                39.3458569986895,
                0
              ],
              [
                -76.5830850002123,
                39.3458169985685,
                0
              ],
              [
                -76.5828959994654,
                39.3457639993599,
                0
              ],
              [
                -76.5828080002529,
                39.3457379987543,
                0
              ],
              [
                -76.5826520001908,
                39.3456909990199,
                0
              ],
              [
                -76.5822230003631,
                39.3455539986559,
                0
              ],
              [
                -76.5819759996371,
                39.345474998977,
                0
              ],
              [
                -76.5815210001071,
                39.3453529991959,
                0
              ],
              [
                -76.5814209999882,
                39.3453359992231,
                0
              ],
              [
                -76.5813109995495,
                39.3453239987248,
                0
              ],
              [
                -76.5811929999975,
                39.3453159995687,
                0
              ],
              [
                -76.5811170008405,
                39.3453089993454,
                0
              ],
              [
                -76.5808050014597,
                39.3452769998375,
                0
              ],
              [
                -76.5807439998367,
                39.3450570001883,
                0
              ],
              [
                -76.5807049995055,
                39.3448650002984,
                0
              ],
              [
                -76.580687999676,
                39.344715999425,
                0
              ],
              [
                -76.5806839999327,
                39.3445939988498,
                0
              ],
              [
                -76.580684999434,
                39.3444069993054,
                0
              ],
              [
                -76.5807079997648,
                39.344357998748,
                0
              ],
              [
                -76.5807620002421,
                39.344288998662,
                0
              ],
              [
                -76.5809220015685,
                39.3441399992091,
                0
              ],
              [
                -76.5809990004356,
                39.3439809991055,
                0
              ],
              [
                -76.5810720010033,
                39.343773000284,
                0
              ],
              [
                -76.5811230005416,
                39.3434619991759,
                0
              ],
              [
                -76.581249999888,
                39.3430829993207,
                0
              ],
              [
                -76.5813720001013,
                39.3429269992599,
                0
              ],
              [
                -76.5814439995738,
                39.3428200000557,
                0
              ],
              [
                -76.5814939990858,
                39.3427329992445,
                0
              ],
              [
                -76.5815210004601,
                39.3426499987359,
                0
              ],
              [
                -76.5815540005026,
                39.3423959992081,
                0
              ],
              [
                -76.581552000518,
                39.3420819988071,
                0
              ],
              [
                -76.5815389995979,
                39.3419189992373,
                0
              ],
              [
                -76.5815260000218,
                39.3418669978591,
                0
              ],
              [
                -76.5815169997311,
                39.3418529988336,
                0
              ],
              [
                -76.5814550001532,
                39.341820998856,
                0
              ],
              [
                -76.5813430001302,
                39.3418029985639,
                0
              ],
              [
                -76.5808600004449,
                39.3417529993111,
                0
              ],
              [
                -76.5804569993776,
                39.3416749992123,
                0
              ],
              [
                -76.5802070004671,
                39.3416429985797,
                0
              ],
              [
                -76.5798229998568,
                39.3416069993454,
                0
              ],
              [
                -76.5794649997314,
                39.341582998845,
                0
              ],
              [
                -76.5792569998402,
                39.3415679994009,
                0
              ],
              [
                -76.5791899988726,
                39.3415579990959,
                0
              ],
              [
                -76.5791319999706,
                39.3415369986235,
                0
              ],
              [
                -76.5790979997051,
                39.341513997913,
                0
              ],
              [
                -76.5790380002536,
                39.3414899988487,
                0
              ],
              [
                -76.5789849996107,
                39.3414629992063,
                0
              ],
              [
                -76.5789280004148,
                39.3414279991902,
                0
              ],
              [
                -76.5788490004379,
                39.34136899918,
                0
              ],
              [
                -76.5787889994497,
                39.3412919990901,
                0
              ],
              [
                -76.5785670000667,
                39.3408879990975,
                0
              ],
              [
                -76.5784729998249,
                39.3407579994501,
                0
              ],
              [
                -76.5784279995346,
                39.3406899991701,
                0
              ],
              [
                -76.5783760001858,
                39.3405259990858,
                0
              ],
              [
                -76.5782599996772,
                39.3402219994313,
                0
              ],
              [
                -76.5781859997019,
                39.3400339991442,
                0
              ],
              [
                -76.5781649996714,
                39.3399929992079,
                0
              ],
              [
                -76.5781399999849,
                39.3399599988701,
                0
              ],
              [
                -76.5781240005442,
                39.3399429992863,
                0
              ],
              [
                -76.5780389996932,
                39.3399009985975,
                0
              ],
              [
                -76.5778529997702,
                39.3398319991936,
                0
              ],
              [
                -76.5775089997429,
                39.3396779992506,
                0
              ],
              [
                -76.5771620001325,
                39.3394619989079,
                0
              ],
              [
                -76.5768219997639,
                39.3392859988241,
                0
              ],
              [
                -76.5767619995219,
                39.339254998854,
                0
              ],
              [
                -76.5765880003927,
                39.3391509997168,
                0
              ],
              [
                -76.5764639998485,
                39.3390679985552,
                0
              ],
              [
                -76.576380000213,
                39.3389969997599,
                0
              ],
              [
                -76.5763699996248,
                39.3389799990277,
                0
              ],
              [
                -76.5763579994769,
                39.3389419982464,
                0
              ],
              [
                -76.5763540000974,
                39.3389079985963,
                0
              ],
              [
                -76.5763549996503,
                39.3388770002391,
                0
              ],
              [
                -76.5763639992724,
                39.3388539987315,
                0
              ],
              [
                -76.5763809999875,
                39.3388329986938,
                0
              ],
              [
                -76.5764220003791,
                39.3387989999565,
                0
              ],
              [
                -76.5764770000365,
                39.3387669990579,
                0
              ],
              [
                -76.5769520002231,
                39.3386249994364,
                0
              ],
              [
                -76.5776850014559,
                39.3391409993438,
                0
              ],
              [
                -76.5780430003788,
                39.3393619989658,
                0
              ],
              [
                -76.5782079997854,
                39.3394489989523,
                0
              ],
              [
                -76.5785189997685,
                39.3396119986265,
                0
              ],
              [
                -76.5789900004172,
                39.3398219987254,
                0
              ],
              [
                -76.579328998602,
                39.3399529992354,
                0
              ],
              [
                -76.5795730003799,
                39.3400339990318,
                0
              ],
              [
                -76.5798959999149,
                39.3401269993714,
                0
              ],
              [
                -76.5802690002172,
                39.3402129992863,
                0
              ],
              [
                -76.5805719997597,
                39.3402759990027,
                0
              ],
              [
                -76.5809399996707,
                39.3403420003526,
                0
              ],
              [
                -76.5812890003583,
                39.3403789990603,
                0
              ],
              [
                -76.5815490003128,
                39.3403989990269,
                0
              ],
              [
                -76.5819599996898,
                39.3404249993901,
                0
              ],
              [
                -76.5820930015019,
                39.3404329989045,
                0
              ],
              [
                -76.582466000573,
                39.3404509988811,
                0
              ],
              [
                -76.582775999622,
                39.340465998902,
                0
              ],
              [
                -76.5831340002656,
                39.3404699990533,
                0
              ],
              [
                -76.5833530005033,
                39.3404669985707,
                0
              ],
              [
                -76.5834619999887,
                39.3404589988593,
                0
              ],
              [
                -76.583586000494,
                39.3404509990385,
                0
              ],
              [
                -76.5838100011237,
                39.3404189996324,
                0
              ],
              [
                -76.5839699996128,
                39.3403939991236,
                0
              ],
              [
                -76.5842659996775,
                39.3403409986771,
                0
              ],
              [
                -76.5844320010549,
                39.3402929992608,
                0
              ],
              [
                -76.5846519997426,
                39.3402259999668,
                0
              ],
              [
                -76.585134000573,
                39.3400629992822,
                0
              ],
              [
                -76.5851710012741,
                39.3400519993097,
                0
              ],
              [
                -76.5854559999937,
                39.3399749989622,
                0
              ],
              [
                -76.5856640004553,
                39.339926999074,
                0
              ],
              [
                -76.5858440000284,
                39.3398999992918,
                0
              ],
              [
                -76.5860819995815,
                39.3398799986995,
                0
              ],
              [
                -76.5863090005672,
                39.3398769992679,
                0
              ],
              [
                -76.5863770011193,
                39.339878998599,
                0
              ],
              [
                -76.586496000293,
                39.3398839993241,
                0
              ],
              [
                -76.5878359996557,
                39.3399549990531,
                0
              ],
              [
                -76.5880170000865,
                39.339977999054,
                0
              ],
              [
                -76.5885479996693,
                39.340050998833,
                0
              ],
              [
                -76.5893789999994,
                39.3401189986196,
                0
              ],
              [
                -76.5896880003342,
                39.3401460001048,
                0
              ],
              [
                -76.5900130005315,
                39.3401659992198,
                0
              ],
              [
                -76.5903109996849,
                39.3401789991142,
                0
              ],
              [
                -76.5906700004461,
                39.3401909991603,
                0
              ],
              [
                -76.5909450004957,
                39.3401969987249,
                0
              ],
              [
                -76.5911319999966,
                39.34019399941,
                0
              ],
              [
                -76.5913780002102,
                39.3401959986648,
                0
              ],
              [
                -76.5920490002434,
                39.3401579989517,
                0
              ],
              [
                -76.5923980005735,
                39.3401169986763,
                0
              ],
              [
                -76.5927350001465,
                39.3400709989799,
                0
              ],
              [
                -76.5930839994292,
                39.3400069987847,
                0
              ],
              [
                -76.5933400004903,
                39.3399549990232,
                0
              ],
              [
                -76.5936570008204,
                39.3398789992726,
                0
              ],
              [
                -76.593994999857,
                39.3397739995683,
                0
              ],
              [
                -76.594692000485,
                39.3395579986179,
                0
              ],
              [
                -76.5953399996869,
                39.339356998867,
                0
              ],
              [
                -76.5957570002059,
                39.3392469993346,
                0
              ],
              [
                -76.5961140009673,
                39.3391589992338,
                0
              ],
              [
                -76.5963920005319,
                39.3391209993663,
                0
              ],
              [
                -76.5966639999287,
                39.3390889988522,
                0
              ],
              [
                -76.596793999428,
                39.3390819992163,
                0
              ],
              [
                -76.5970429994984,
                39.3390879989402,
                0
              ],
              [
                -76.5972460004988,
                39.3390999989656,
                0
              ],
              [
                -76.5974239994688,
                39.3391209988644,
                0
              ],
              [
                -76.5976390001479,
                39.3391579990124,
                0
              ],
              [
                -76.5979100010348,
                39.3392129989926,
                0
              ],
              [
                -76.5981230002853,
                39.3392689998784,
                0
              ],
              [
                -76.5983849994257,
                39.3393499977824,
                0
              ],
              [
                -76.5986149985321,
                39.3394369992174,
                0
              ],
              [
                -76.5987839995611,
                39.3395319987455,
                0
              ],
              [
                -76.5990679995006,
                39.3396779987582,
                0
              ],
              [
                -76.5995849999347,
                39.339926998781,
                0
              ],
              [
                -76.5997630004522,
                39.3399929991549,
                0
              ],
              [
                -76.5999029989391,
                39.3400289993573,
                0
              ],
              [
                -76.6000470003188,
                39.3400479997,
                0
              ],
              [
                -76.6002109994748,
                39.3400639990285,
                0
              ],
              [
                -76.6000309999527,
                39.3416779988502,
                0
              ],
              [
                -76.5999350000584,
                39.34274299943,
                0
              ],
              [
                -76.5998850002688,
                39.3432119991585,
                0
              ],
              [
                -76.5998489999759,
                39.3435359993125,
                0
              ],
              [
                -76.5998450004462,
                39.3437699986181,
                0
              ],
              [
                -76.5998380000678,
                39.3440279988768,
                0
              ],
              [
                -76.5998680003004,
                39.3442529992177,
                0
              ],
              [
                -76.5997289994598,
                39.3451489986641,
                0
              ],
              [
                -76.5991339994829,
                39.3450929987877,
                0
              ],
              [
                -76.5982400004338,
                39.3450069993503,
                0
              ],
              [
                -76.5976049998259,
                39.3449479987637,
                0
              ],
              [
                -76.5970970001056,
                39.3448929987886,
                0
              ],
              [
                -76.5969190002906,
                39.3448789990757,
                0
              ],
              [
                -76.5967980002178,
                39.3448739993759,
                0
              ],
              [
                -76.5966910003908,
                39.3448739989784,
                0
              ],
              [
                -76.5965710001376,
                39.344877999124,
                0
              ],
              [
                -76.5964450005386,
                39.3448870002128,
                0
              ],
              [
                -76.5962930003488,
                39.3449069991701,
                0
              ],
              [
                -76.596149000503,
                39.3449329991588,
                0
              ],
              [
                -76.5960130001242,
                39.3449679987879,
                0
              ],
              [
                -76.5958909998047,
                39.3450079986819,
                0
              ],
              [
                -76.5956620000824,
                39.345092999279,
                0
              ],
              [
                -76.5955259997805,
                39.3451469986771,
                0
              ],
              [
                -76.5954580001242,
                39.3451739996699,
                0
              ],
              [
                -76.5942489994233,
                39.345717999414,
                0
              ],
              [
                -76.593991999329,
                39.3458369987467,
                0
              ],
              [
                -76.5936690005175,
                39.3459799976975,
                0
              ],
              [
                -76.5935670005172,
                39.3460209992716,
                0
              ],
              [
                -76.5934410005626,
                39.3460619988357,
                0
              ],
              [
                -76.5933080000611,
                39.3460959986753,
                0
              ],
              [
                -76.5931820003692,
                39.3461269987856,
                0
              ],
              [
                -76.5930119996811,
                39.3461589994095,
                0
              ],
              [
                -76.5928440004817,
                39.3461789988791,
                0
              ],
              [
                -76.5922470001322,
                39.346161999171,
                0
              ],
              [
                -76.5922280002259,
                39.3461619990301,
                0
              ],
              [
                -76.5920060001953,
                39.3461629988287,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 68,
          "Census_Tract": "24510271001",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "6758a395-529d-417f-8b08-202850c70f94",
          "Shape__Area": 5436413.6622924805,
          "Shape__Length": 9986.199237451168
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.5997289994598,
                39.3451489986641,
                0
              ],
              [
                -76.5998680003004,
                39.3442529992177,
                0
              ],
              [
                -76.5998380000678,
                39.3440279988768,
                0
              ],
              [
                -76.5998450004462,
                39.3437699986181,
                0
              ],
              [
                -76.5998489999759,
                39.3435359993125,
                0
              ],
              [
                -76.5998850002688,
                39.3432119991585,
                0
              ],
              [
                -76.5999350000584,
                39.34274299943,
                0
              ],
              [
                -76.6000309999527,
                39.3416779988502,
                0
              ],
              [
                -76.6002109994748,
                39.3400639990285,
                0
              ],
              [
                -76.6003770002127,
                39.3401189991708,
                0
              ],
              [
                -76.6004050004674,
                39.3401289989616,
                0
              ],
              [
                -76.6005059997355,
                39.3401659990165,
                0
              ],
              [
                -76.6006590004508,
                39.340231998639,
                0
              ],
              [
                -76.6007579995748,
                39.3402999989938,
                0
              ],
              [
                -76.6008660004354,
                39.340415999102,
                0
              ],
              [
                -76.601164000291,
                39.3405099990629,
                0
              ],
              [
                -76.6013039990985,
                39.3405379989542,
                0
              ],
              [
                -76.6014350005761,
                39.3405499988347,
                0
              ],
              [
                -76.601582999582,
                39.3405559995527,
                0
              ],
              [
                -76.6017690006691,
                39.3405589987235,
                0
              ],
              [
                -76.6024840000728,
                39.3405439989931,
                0
              ],
              [
                -76.6031289998019,
                39.3405199988668,
                0
              ],
              [
                -76.6036810011188,
                39.3404899989182,
                0
              ],
              [
                -76.6042289990185,
                39.3404769998092,
                0
              ],
              [
                -76.6049600002856,
                39.3404569992152,
                0
              ],
              [
                -76.6052830003566,
                39.3404619978794,
                0
              ],
              [
                -76.6054139997608,
                39.3404579987585,
                0
              ],
              [
                -76.6055159995327,
                39.3404449992058,
                0
              ],
              [
                -76.60559200012,
                39.3404309989862,
                0
              ],
              [
                -76.6057740003025,
                39.3403810000808,
                0
              ],
              [
                -76.6060159995529,
                39.3403019988736,
                0
              ],
              [
                -76.6063260001116,
                39.340193999272,
                0
              ],
              [
                -76.6063729997386,
                39.340171999179,
                0
              ],
              [
                -76.6064040000565,
                39.3401329988535,
                0
              ],
              [
                -76.6064129986942,
                39.3400979989394,
                0
              ],
              [
                -76.6063890004788,
                39.33970699898,
                0
              ],
              [
                -76.6076670000609,
                39.3396770002387,
                0
              ],
              [
                -76.6076990004396,
                39.3402269994035,
                0
              ],
              [
                -76.609600000314,
                39.3401809987398,
                0
              ],
              [
                -76.6096820005099,
                39.3403489990365,
                0
              ],
              [
                -76.6096959995843,
                39.3404999989218,
                0
              ],
              [
                -76.6096820004744,
                39.3410399985682,
                0
              ],
              [
                -76.609679000258,
                39.3417059985884,
                0
              ],
              [
                -76.6096790003076,
                39.3429819989506,
                0
              ],
              [
                -76.6096790001447,
                39.3430169992295,
                0
              ],
              [
                -76.609655998707,
                39.3434549987473,
                0
              ],
              [
                -76.6096449997011,
                39.3440699994185,
                0
              ],
              [
                -76.6096360001336,
                39.344295999001,
                0
              ],
              [
                -76.6096619994628,
                39.3455259989255,
                0
              ],
              [
                -76.6096820001379,
                39.3461769986,
                0
              ],
              [
                -76.6095630004988,
                39.3461759990829,
                0
              ],
              [
                -76.6095399994647,
                39.3461759992614,
                0
              ],
              [
                -76.6087059997349,
                39.3461729986807,
                0
              ],
              [
                -76.6084199995992,
                39.3461709989241,
                0
              ],
              [
                -76.6081959994722,
                39.346165999349,
                0
              ],
              [
                -76.6080590003941,
                39.3461579989865,
                0
              ],
              [
                -76.6078880000152,
                39.3461399993961,
                0
              ],
              [
                -76.6077740003464,
                39.3461299991866,
                0
              ],
              [
                -76.6074079995877,
                39.3460919993012,
                0
              ],
              [
                -76.6071790000537,
                39.3460699993474,
                0
              ],
              [
                -76.6070660000713,
                39.3460579994343,
                0
              ],
              [
                -76.6062859997594,
                39.3459729988754,
                0
              ],
              [
                -76.6059340000216,
                39.3459379993258,
                0
              ],
              [
                -76.6057419999305,
                39.3459159998745,
                0
              ],
              [
                -76.605569000243,
                39.3458909986177,
                0
              ],
              [
                -76.6054110000466,
                39.3458589991164,
                0
              ],
              [
                -76.6052480002737,
                39.3458230004214,
                0
              ],
              [
                -76.6049410001196,
                39.3457469993284,
                0
              ],
              [
                -76.6047740005199,
                39.3456989994155,
                0
              ],
              [
                -76.6046379999463,
                39.3456629987516,
                0
              ],
              [
                -76.6045449999458,
                39.3456419985632,
                0
              ],
              [
                -76.6044299998435,
                39.3456189993906,
                0
              ],
              [
                -76.6043170002296,
                39.3455979992862,
                0
              ],
              [
                -76.6041959996318,
                39.3455769991602,
                0
              ],
              [
                -76.6038600004182,
                39.3455369985741,
                0
              ],
              [
                -76.6037760001381,
                39.3455299995591,
                0
              ],
              [
                -76.6032539992467,
                39.3454829992784,
                0
              ],
              [
                -76.6026210001793,
                39.3454209988646,
                0
              ],
              [
                -76.601653000405,
                39.3453310002528,
                0
              ],
              [
                -76.6006919997691,
                39.3452360002792,
                0
              ],
              [
                -76.5997289994598,
                39.3451489986641,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 69,
          "Census_Tract": "24510271002",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "bfd4882c-3008-49e3-865e-f52407a2e7da",
          "Shape__Area": 10286208.215881348,
          "Shape__Length": 12890.540033905145
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.5982890005381,
                39.3541659990093,
                0
              ],
              [
                -76.5983680002698,
                39.3536679993671,
                0
              ],
              [
                -76.5984370001032,
                39.3532459989959,
                0
              ],
              [
                -76.5985710005065,
                39.3523769985905,
                0
              ],
              [
                -76.5986310001493,
                39.3519849998105,
                0
              ],
              [
                -76.5986890006591,
                39.3516049992439,
                0
              ],
              [
                -76.5987460010879,
                39.351245998739,
                0
              ],
              [
                -76.5988019999534,
                39.3508969993139,
                0
              ],
              [
                -76.5988330004838,
                39.3507139991366,
                0
              ],
              [
                -76.5988860000699,
                39.3503689985946,
                0
              ],
              [
                -76.5990419989932,
                39.3493979986841,
                0
              ],
              [
                -76.5991049997254,
                39.3489679990247,
                0
              ],
              [
                -76.5992579996786,
                39.34804600042,
                0
              ],
              [
                -76.5993759995072,
                39.3472769988553,
                0
              ],
              [
                -76.5994230002134,
                39.3469669991437,
                0
              ],
              [
                -76.5995319999107,
                39.3462669996288,
                0
              ],
              [
                -76.5996329995063,
                39.3456789992394,
                0
              ],
              [
                -76.5997289994598,
                39.3451489986641,
                0
              ],
              [
                -76.6006919997691,
                39.3452360002792,
                0
              ],
              [
                -76.601653000405,
                39.3453310002528,
                0
              ],
              [
                -76.6026210001793,
                39.3454209988646,
                0
              ],
              [
                -76.6032539992467,
                39.3454829992784,
                0
              ],
              [
                -76.6037760001381,
                39.3455299995591,
                0
              ],
              [
                -76.6038600004182,
                39.3455369985741,
                0
              ],
              [
                -76.6041959996318,
                39.3455769991602,
                0
              ],
              [
                -76.6043170002296,
                39.3455979992862,
                0
              ],
              [
                -76.6044299998435,
                39.3456189993906,
                0
              ],
              [
                -76.6045449999458,
                39.3456419985632,
                0
              ],
              [
                -76.6046379999463,
                39.3456629987516,
                0
              ],
              [
                -76.6047740005199,
                39.3456989994155,
                0
              ],
              [
                -76.6049410001196,
                39.3457469993284,
                0
              ],
              [
                -76.6052480002737,
                39.3458230004214,
                0
              ],
              [
                -76.6054110000466,
                39.3458589991164,
                0
              ],
              [
                -76.605569000243,
                39.3458909986177,
                0
              ],
              [
                -76.6057419999305,
                39.3459159998745,
                0
              ],
              [
                -76.6059340000216,
                39.3459379993258,
                0
              ],
              [
                -76.6062859997594,
                39.3459729988754,
                0
              ],
              [
                -76.6070660000713,
                39.3460579994343,
                0
              ],
              [
                -76.6071790000537,
                39.3460699993474,
                0
              ],
              [
                -76.6074079995877,
                39.3460919993012,
                0
              ],
              [
                -76.6077740003464,
                39.3461299991866,
                0
              ],
              [
                -76.6078880000152,
                39.3461399993961,
                0
              ],
              [
                -76.6080590003941,
                39.3461579989865,
                0
              ],
              [
                -76.6081959994722,
                39.346165999349,
                0
              ],
              [
                -76.6084199995992,
                39.3461709989241,
                0
              ],
              [
                -76.6087059997349,
                39.3461729986807,
                0
              ],
              [
                -76.6095399994647,
                39.3461759992614,
                0
              ],
              [
                -76.6095630004988,
                39.3461759990829,
                0
              ],
              [
                -76.6096820001379,
                39.3461769986,
                0
              ],
              [
                -76.609707999907,
                39.3470799986707,
                0
              ],
              [
                -76.6097149994658,
                39.3472399986531,
                0
              ],
              [
                -76.6097169999962,
                39.3477069989951,
                0
              ],
              [
                -76.609718000317,
                39.3479169991694,
                0
              ],
              [
                -76.6097179998625,
                39.3479469993607,
                0
              ],
              [
                -76.6097249996846,
                39.3481429993483,
                0
              ],
              [
                -76.6097460006749,
                39.3490109991542,
                0
              ],
              [
                -76.6097880004843,
                39.3501449986025,
                0
              ],
              [
                -76.6098020003858,
                39.3508019988537,
                0
              ],
              [
                -76.6098049999712,
                39.350905998751,
                0
              ],
              [
                -76.609828000239,
                39.3515139994445,
                0
              ],
              [
                -76.6098310002829,
                39.351634999048,
                0
              ],
              [
                -76.6098319998907,
                39.3517549993896,
                0
              ],
              [
                -76.6098330003138,
                39.3518149994184,
                0
              ],
              [
                -76.6098399996185,
                39.3519519986716,
                0
              ],
              [
                -76.6098589994418,
                39.3523459990451,
                0
              ],
              [
                -76.6098810004189,
                39.3528010004335,
                0
              ],
              [
                -76.6099210005629,
                39.3540039986184,
                0
              ],
              [
                -76.6099220003284,
                39.3540379986647,
                0
              ],
              [
                -76.6099279987111,
                39.3543309986054,
                0
              ],
              [
                -76.6099289999104,
                39.3543619991803,
                0
              ],
              [
                -76.6099439994376,
                39.3546629987184,
                0
              ],
              [
                -76.6099450005578,
                39.3548769986248,
                0
              ],
              [
                -76.6099519995017,
                39.3552839988493,
                0
              ],
              [
                -76.6099529998221,
                39.3555029987306,
                0
              ],
              [
                -76.6098520003662,
                39.355492999602,
                0
              ],
              [
                -76.6083949994279,
                39.3553429990289,
                0
              ],
              [
                -76.6076849998778,
                39.3552739990393,
                0
              ],
              [
                -76.6069209986084,
                39.3551959986822,
                0
              ],
              [
                -76.6062950002288,
                39.3551259983127,
                0
              ],
              [
                -76.6060730000364,
                39.3551019994337,
                0
              ],
              [
                -76.6048700002861,
                39.35497499916,
                0
              ],
              [
                -76.6046859994746,
                39.3549549994361,
                0
              ],
              [
                -76.6032929996423,
                39.3548099993912,
                0
              ],
              [
                -76.6031809985412,
                39.3548059986882,
                0
              ],
              [
                -76.6026660014677,
                39.3547479992124,
                0
              ],
              [
                -76.6023340000892,
                39.3547109994012,
                0
              ],
              [
                -76.6011179995627,
                39.3545389993683,
                0
              ],
              [
                -76.5995219994814,
                39.3543249993633,
                0
              ],
              [
                -76.5982890005381,
                39.3541659990093,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 70,
          "Census_Tract": "24510280402",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "81395a7e-2207-4d4a-aa5a-129e9b272c66",
          "Shape__Area": 6045935.581481934,
          "Shape__Length": 12598.658689490101
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6862749997365,
                39.2992169991019,
                0
              ],
              [
                -76.6862350005479,
                39.2984709985901,
                0
              ],
              [
                -76.6861930014049,
                39.2977419988157,
                0
              ],
              [
                -76.6861400002801,
                39.2969959992382,
                0
              ],
              [
                -76.6861009995656,
                39.2962499999421,
                0
              ],
              [
                -76.6860259998856,
                39.2955080000026,
                0
              ],
              [
                -76.6860089996217,
                39.2946989989872,
                0
              ],
              [
                -76.6859990005263,
                39.294105998063,
                0
              ],
              [
                -76.6859919996291,
                39.2937239991599,
                0
              ],
              [
                -76.6859950004472,
                39.2937109993555,
                0
              ],
              [
                -76.6866120004764,
                39.2936969988827,
                0
              ],
              [
                -76.6869949994535,
                39.293688998833,
                0
              ],
              [
                -76.6884329994385,
                39.2936170000391,
                0
              ],
              [
                -76.6894249998167,
                39.2935809986026,
                0
              ],
              [
                -76.6894269996308,
                39.2936129996585,
                0
              ],
              [
                -76.6894390005407,
                39.2940499991082,
                0
              ],
              [
                -76.6894420001858,
                39.2941109990484,
                0
              ],
              [
                -76.6894500004865,
                39.2941620002998,
                0
              ],
              [
                -76.6894660011647,
                39.2941969991434,
                0
              ],
              [
                -76.6904779996471,
                39.2948209986743,
                0
              ],
              [
                -76.6913780001037,
                39.2954709990465,
                0
              ],
              [
                -76.692248000176,
                39.2961169990898,
                0
              ],
              [
                -76.6915719995858,
                39.2967339995622,
                0
              ],
              [
                -76.6925729993227,
                39.2973209989683,
                0
              ],
              [
                -76.6935120001649,
                39.2979219986642,
                0
              ],
              [
                -76.6929079998917,
                39.2984819990626,
                0
              ],
              [
                -76.69240600033,
                39.2989459987925,
                0
              ],
              [
                -76.6945920004684,
                39.3008059992257,
                0
              ],
              [
                -76.6944870001224,
                39.3013679986648,
                0
              ],
              [
                -76.6945839999205,
                39.3016179993356,
                0
              ],
              [
                -76.6947100006836,
                39.3018369992477,
                0
              ],
              [
                -76.6948660000233,
                39.3020159987692,
                0
              ],
              [
                -76.6945190015634,
                39.302244999259,
                0
              ],
              [
                -76.6943459995295,
                39.3024339986106,
                0
              ],
              [
                -76.694274998471,
                39.302574998952,
                0
              ],
              [
                -76.6942840004514,
                39.3027399990393,
                0
              ],
              [
                -76.6943540003836,
                39.3029359987124,
                0
              ],
              [
                -76.6945760011447,
                39.3032199990347,
                0
              ],
              [
                -76.6948970000311,
                39.3037629992642,
                0
              ],
              [
                -76.6949520000674,
                39.303882999025,
                0
              ],
              [
                -76.6949599999019,
                39.3040139992526,
                0
              ],
              [
                -76.6949290003972,
                39.3041149986179,
                0
              ],
              [
                -76.6948720001958,
                39.3041779988308,
                0
              ],
              [
                -76.6947729997732,
                39.3042450000588,
                0
              ],
              [
                -76.6947289994376,
                39.3042829993306,
                0
              ],
              [
                -76.6946979995847,
                39.3043459994466,
                0
              ],
              [
                -76.6946220000158,
                39.3045629988003,
                0
              ],
              [
                -76.6945089995918,
                39.3047369990235,
                0
              ],
              [
                -76.6944149997994,
                39.3048429993434,
                0
              ],
              [
                -76.6943309996413,
                39.3048959991583,
                0
              ],
              [
                -76.6942440003951,
                39.3049289988916,
                0
              ],
              [
                -76.6940200005247,
                39.3049289985912,
                0
              ],
              [
                -76.6935220005812,
                39.3049229987996,
                0
              ],
              [
                -76.6932979997872,
                39.3048829991727,
                0
              ],
              [
                -76.6929190011443,
                39.3047959990825,
                0
              ],
              [
                -76.6923129999889,
                39.3046539989639,
                0
              ],
              [
                -76.691822000378,
                39.304584998991,
                0
              ],
              [
                -76.6915169997025,
                39.3045599981151,
                0
              ],
              [
                -76.6913280000778,
                39.3045689993184,
                0
              ],
              [
                -76.6912029994271,
                39.3045739988379,
                0
              ],
              [
                -76.6910849999122,
                39.3046019993538,
                0
              ],
              [
                -76.6909480000589,
                39.3046549988294,
                0
              ],
              [
                -76.6907729998072,
                39.3048139987861,
                0
              ],
              [
                -76.6906170000084,
                39.3049339990482,
                0
              ],
              [
                -76.6905109996417,
                39.3049919986425,
                0
              ],
              [
                -76.6904050006706,
                39.3050260002748,
                0
              ],
              [
                -76.6901869995294,
                39.3050829991348,
                0
              ],
              [
                -76.6895820002095,
                39.3050989986276,
                0
              ],
              [
                -76.6894820013003,
                39.3044339991138,
                0
              ],
              [
                -76.6894999999551,
                39.3043719991725,
                0
              ],
              [
                -76.6900920010517,
                39.3023059988643,
                0
              ],
              [
                -76.688138999775,
                39.2991719993165,
                0
              ],
              [
                -76.6875910005122,
                39.2991929993082,
                0
              ],
              [
                -76.6871509994318,
                39.2992099985692,
                0
              ],
              [
                -76.6867559996265,
                39.2992130004361,
                0
              ],
              [
                -76.6862749997365,
                39.2992169991019,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 71,
          "Census_Tract": "24510030100",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "4b6b827b-775a-4f0e-858d-6cdbaee1a244",
          "Shape__Area": 4600536.266784668,
          "Shape__Length": 8963.294118369206
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.5939439998038,
                39.2915419989477,
                0
              ],
              [
                -76.5939160002912,
                39.2911309994359,
                0
              ],
              [
                -76.5938690003106,
                39.2903990002591,
                0
              ],
              [
                -76.5938029995307,
                39.2892569987566,
                0
              ],
              [
                -76.5937729996253,
                39.2886250000945,
                0
              ],
              [
                -76.5937220005016,
                39.2877269986096,
                0
              ],
              [
                -76.5937040001908,
                39.2876229992593,
                0
              ],
              [
                -76.5936380005198,
                39.2866089985949,
                0
              ],
              [
                -76.5935570005734,
                39.2855779987396,
                0
              ],
              [
                -76.5944739996374,
                39.2855449978584,
                0
              ],
              [
                -76.5953550007504,
                39.285509999446,
                0
              ],
              [
                -76.5960879999736,
                39.2854779985979,
                0
              ],
              [
                -76.5967539995074,
                39.2854469981469,
                0
              ],
              [
                -76.5975390003632,
                39.2854169988976,
                0
              ],
              [
                -76.5983149999567,
                39.2853679989786,
                0
              ],
              [
                -76.5987470005049,
                39.2853579987974,
                0
              ],
              [
                -76.5992269996438,
                39.285336998552,
                0
              ],
              [
                -76.5992540005239,
                39.2857469986604,
                0
              ],
              [
                -76.5992809995207,
                39.2863549987758,
                0
              ],
              [
                -76.5993470014516,
                39.2872559991396,
                0
              ],
              [
                -76.5993489997255,
                39.2873809992356,
                0
              ],
              [
                -76.5993690000551,
                39.2877459992667,
                0
              ],
              [
                -76.599414999454,
                39.288363999178,
                0
              ],
              [
                -76.5994420001128,
                39.2887419993243,
                0
              ],
              [
                -76.5994599999689,
                39.2890330002472,
                0
              ],
              [
                -76.5994670001382,
                39.2891649991277,
                0
              ],
              [
                -76.5995039994823,
                39.2895529992769,
                0
              ],
              [
                -76.5995649997243,
                39.2902170004386,
                0
              ],
              [
                -76.5995779997868,
                39.2903699993348,
                0
              ],
              [
                -76.5996000001826,
                39.2908089987951,
                0
              ],
              [
                -76.5996220001592,
                39.2913579981635,
                0
              ],
              [
                -76.5996360000908,
                39.291863999401,
                0
              ],
              [
                -76.5996869984865,
                39.2925359989237,
                0
              ],
              [
                -76.599146000557,
                39.292699998607,
                0
              ],
              [
                -76.5987780003522,
                39.2928069993497,
                0
              ],
              [
                -76.5981450003668,
                39.2929879990997,
                0
              ],
              [
                -76.5972840005136,
                39.2932369988469,
                0
              ],
              [
                -76.5965600002828,
                39.2934249985641,
                0
              ],
              [
                -76.5962359994643,
                39.2935149991689,
                0
              ],
              [
                -76.5958919999886,
                39.2936049994512,
                0
              ],
              [
                -76.5956129989525,
                39.2936969987737,
                0
              ],
              [
                -76.5952629998768,
                39.2938119987765,
                0
              ],
              [
                -76.5952220002096,
                39.293824998711,
                0
              ],
              [
                -76.5950669997145,
                39.2938679992015,
                0
              ],
              [
                -76.5948160003903,
                39.2939489993818,
                0
              ],
              [
                -76.5941170004714,
                39.2939680003205,
                0
              ],
              [
                -76.5940719999609,
                39.2932869990017,
                0
              ],
              [
                -76.5940289995255,
                39.2926319985788,
                0
              ],
              [
                -76.5939919986651,
                39.2920719994405,
                0
              ],
              [
                -76.5939439998038,
                39.2915419989477,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 72,
          "Census_Tract": "24510272006",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "2147c31a-eac7-40a9-accf-ca7a360911fa",
          "Shape__Area": 7930305.16607666,
          "Shape__Length": 12508.460443444723
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6881439998482,
                39.3557599993882,
                0
              ],
              [
                -76.6886760005086,
                39.3554869988998,
                0
              ],
              [
                -76.6892489997645,
                39.355191999303,
                0
              ],
              [
                -76.6897020005683,
                39.3549599986741,
                0
              ],
              [
                -76.6900740004141,
                39.3547649986733,
                0
              ],
              [
                -76.6903110003573,
                39.3546409985949,
                0
              ],
              [
                -76.6906829997161,
                39.3544479989991,
                0
              ],
              [
                -76.6910620004155,
                39.3542519991375,
                0
              ],
              [
                -76.6917120005091,
                39.3539419987844,
                0
              ],
              [
                -76.691979000208,
                39.353778999892,
                0
              ],
              [
                -76.6921020010518,
                39.3536979987571,
                0
              ],
              [
                -76.6922439986209,
                39.3535969994514,
                0
              ],
              [
                -76.6927240008098,
                39.3532369987145,
                0
              ],
              [
                -76.6928939995917,
                39.3530999989575,
                0
              ],
              [
                -76.6936330002874,
                39.3525459991313,
                0
              ],
              [
                -76.6953549999125,
                39.3512539993629,
                0
              ],
              [
                -76.6956979998148,
                39.3514959985858,
                0
              ],
              [
                -76.6963839996583,
                39.3519800002612,
                0
              ],
              [
                -76.6965279998977,
                39.3520839994352,
                0
              ],
              [
                -76.6973109996486,
                39.3526349988148,
                0
              ],
              [
                -76.6974869992243,
                39.3527539990085,
                0
              ],
              [
                -76.698059000419,
                39.3531649986208,
                0
              ],
              [
                -76.6984869995711,
                39.353465999016,
                0
              ],
              [
                -76.6987890012535,
                39.3536769993088,
                0
              ],
              [
                -76.6989650004838,
                39.3537969988591,
                0
              ],
              [
                -76.6996849996249,
                39.3543009994024,
                0
              ],
              [
                -76.6998050010581,
                39.3543849989078,
                0
              ],
              [
                -76.7001879998419,
                39.3546499989238,
                0
              ],
              [
                -76.7005230005527,
                39.3548979991826,
                0
              ],
              [
                -76.7005840014406,
                39.3549419988988,
                0
              ],
              [
                -76.7013809995804,
                39.3554789978673,
                0
              ],
              [
                -76.7019200001528,
                39.3558439990788,
                0
              ],
              [
                -76.7020430001213,
                39.3559329993434,
                0
              ],
              [
                -76.7024240000408,
                39.3561869987284,
                0
              ],
              [
                -76.7024280000747,
                39.3562199993023,
                0
              ],
              [
                -76.7024460000401,
                39.3562459987329,
                0
              ],
              [
                -76.7024060001415,
                39.3562739987505,
                0
              ],
              [
                -76.702339000944,
                39.3563249992279,
                0
              ],
              [
                -76.7022660004791,
                39.3563909997831,
                0
              ],
              [
                -76.7021379998811,
                39.3565269987921,
                0
              ],
              [
                -76.7016830004367,
                39.3570029989566,
                0
              ],
              [
                -76.7008300000844,
                39.3578909990974,
                0
              ],
              [
                -76.7014350000026,
                39.3583369987296,
                0
              ],
              [
                -76.7017690004008,
                39.3585959986687,
                0
              ],
              [
                -76.7020569997163,
                39.3588169987583,
                0
              ],
              [
                -76.702391000389,
                39.3590689990486,
                0
              ],
              [
                -76.7032280002475,
                39.3597019991069,
                0
              ],
              [
                -76.7025250003525,
                39.36024099864,
                0
              ],
              [
                -76.7019019995532,
                39.3607289988141,
                0
              ],
              [
                -76.701418999769,
                39.3611079989812,
                0
              ],
              [
                -76.7004940003146,
                39.3618239990464,
                0
              ],
              [
                -76.7002949996378,
                39.3619779990784,
                0
              ],
              [
                -76.6997979994875,
                39.3623629989419,
                0
              ],
              [
                -76.6991070002509,
                39.3617999990608,
                0
              ],
              [
                -76.6988829995122,
                39.3616170003246,
                0
              ],
              [
                -76.6987110007293,
                39.3614769986709,
                0
              ],
              [
                -76.6984059995131,
                39.3612279988977,
                0
              ],
              [
                -76.698258999838,
                39.3611069986732,
                0
              ],
              [
                -76.697884999475,
                39.3607989995928,
                0
              ],
              [
                -76.6977990004602,
                39.3607449991962,
                0
              ],
              [
                -76.6977719999853,
                39.3607269988274,
                0
              ],
              [
                -76.6977460000936,
                39.3607099990411,
                0
              ],
              [
                -76.6976370005009,
                39.3606379994164,
                0
              ],
              [
                -76.6974550001839,
                39.3605359992906,
                0
              ],
              [
                -76.6973850004398,
                39.3604949986564,
                0
              ],
              [
                -76.6971900003123,
                39.3603919990698,
                0
              ],
              [
                -76.6969970013856,
                39.3602769992808,
                0
              ],
              [
                -76.6967119991615,
                39.3601219979594,
                0
              ],
              [
                -76.6961060003588,
                39.3597999987518,
                0
              ],
              [
                -76.6950859994516,
                39.3592729992704,
                0
              ],
              [
                -76.6943439996858,
                39.3588789988359,
                0
              ],
              [
                -76.694038000092,
                39.3587149983312,
                0
              ],
              [
                -76.6931690004099,
                39.3582569992972,
                0
              ],
              [
                -76.6928120000115,
                39.3580690001092,
                0
              ],
              [
                -76.6926020002678,
                39.3579579991948,
                0
              ],
              [
                -76.6920689984374,
                39.3576979999569,
                0
              ],
              [
                -76.6919179999114,
                39.357623998801,
                0
              ],
              [
                -76.6917519985405,
                39.357542999016,
                0
              ],
              [
                -76.691584999719,
                39.3574619990797,
                0
              ],
              [
                -76.6913700000153,
                39.3573569988533,
                0
              ],
              [
                -76.6911869994469,
                39.3572709986799,
                0
              ],
              [
                -76.6904389998593,
                39.356911998926,
                0
              ],
              [
                -76.6896650005827,
                39.3565389994152,
                0
              ],
              [
                -76.6895899999674,
                39.3565050003269,
                0
              ],
              [
                -76.6888319989317,
                39.3561319987602,
                0
              ],
              [
                -76.6885539996696,
                39.356000999699,
                0
              ],
              [
                -76.6884540003935,
                39.3559479992264,
                0
              ],
              [
                -76.6882979995065,
                39.3558599988343,
                0
              ],
              [
                -76.6882319999615,
                39.3558199985848,
                0
              ],
              [
                -76.6881439998482,
                39.3557599993882,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 73,
          "Census_Tract": "24510280500",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "2a30b6f7-4aee-441f-a7bb-427cc9620a31",
          "Shape__Area": 9945118.303894043,
          "Shape__Length": 13240.874550890218
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.5944079998758,
                39.2983729991555,
                0
              ],
              [
                -76.5943630002832,
                39.2972979987501,
                0
              ],
              [
                -76.5943120000968,
                39.296292998688,
                0
              ],
              [
                -76.5941919995574,
                39.2953259990308,
                0
              ],
              [
                -76.5941850008896,
                39.2952920000036,
                0
              ],
              [
                -76.5941840002632,
                39.2952739993691,
                0
              ],
              [
                -76.5941789998418,
                39.2951429990273,
                0
              ],
              [
                -76.5941529995373,
                39.2946849989773,
                0
              ],
              [
                -76.5941170004714,
                39.2939680003205,
                0
              ],
              [
                -76.5948160003903,
                39.2939489993818,
                0
              ],
              [
                -76.5950669997145,
                39.2938679992015,
                0
              ],
              [
                -76.5952220002096,
                39.293824998711,
                0
              ],
              [
                -76.5952629998768,
                39.2938119987765,
                0
              ],
              [
                -76.5956129989525,
                39.2936969987737,
                0
              ],
              [
                -76.5958919999886,
                39.2936049994512,
                0
              ],
              [
                -76.5962359994643,
                39.2935149991689,
                0
              ],
              [
                -76.5965600002828,
                39.2934249985641,
                0
              ],
              [
                -76.5972840005136,
                39.2932369988469,
                0
              ],
              [
                -76.5981450003668,
                39.2929879990997,
                0
              ],
              [
                -76.5987780003522,
                39.2928069993497,
                0
              ],
              [
                -76.599146000557,
                39.292699998607,
                0
              ],
              [
                -76.5996869984865,
                39.2925359989237,
                0
              ],
              [
                -76.6016150012913,
                39.2919919990849,
                0
              ],
              [
                -76.6026749996608,
                39.2917289989441,
                0
              ],
              [
                -76.6027789997752,
                39.2917019990483,
                0
              ],
              [
                -76.603005999887,
                39.2916410003265,
                0
              ],
              [
                -76.6032299998296,
                39.2915809989844,
                0
              ],
              [
                -76.6037299999277,
                39.2914389991193,
                0
              ],
              [
                -76.6040999995019,
                39.291328999084,
                0
              ],
              [
                -76.6046850001626,
                39.2911649985649,
                0
              ],
              [
                -76.6057619998961,
                39.2908839990756,
                0
              ],
              [
                -76.6063939988132,
                39.2907149990126,
                0
              ],
              [
                -76.6064289994987,
                39.2907119987442,
                0
              ],
              [
                -76.6067369994373,
                39.2906849994285,
                0
              ],
              [
                -76.6069950002993,
                39.2909299985861,
                0
              ],
              [
                -76.6072609996606,
                39.29118199938,
                0
              ],
              [
                -76.6074460004192,
                39.2913599989998,
                0
              ],
              [
                -76.6076460005339,
                39.2915409993009,
                0
              ],
              [
                -76.607904999609,
                39.2917589994286,
                0
              ],
              [
                -76.6082190000235,
                39.291973999115,
                0
              ],
              [
                -76.6086690001796,
                39.2922639988265,
                0
              ],
              [
                -76.6088319997148,
                39.2923719987137,
                0
              ],
              [
                -76.608873999561,
                39.2924029985814,
                0
              ],
              [
                -76.6090869995457,
                39.2925180004281,
                0
              ],
              [
                -76.6093209996238,
                39.2926379988749,
                0
              ],
              [
                -76.6096540003093,
                39.2928039988505,
                0
              ],
              [
                -76.6098400001981,
                39.292903999322,
                0
              ],
              [
                -76.6099719995014,
                39.2929839990154,
                0
              ],
              [
                -76.6100979996669,
                39.2930739986973,
                0
              ],
              [
                -76.610218000374,
                39.2931689991695,
                0
              ],
              [
                -76.6103320009763,
                39.2932629986871,
                0
              ],
              [
                -76.6103789992093,
                39.2933009990724,
                0
              ],
              [
                -76.6105410005443,
                39.2934719986501,
                0
              ],
              [
                -76.6107150002757,
                39.2937169991044,
                0
              ],
              [
                -76.6107289994889,
                39.2937369991122,
                0
              ],
              [
                -76.6108349999194,
                39.2939669988814,
                0
              ],
              [
                -76.6108690000042,
                39.2940559993297,
                0
              ],
              [
                -76.6108730002327,
                39.2940699986686,
                0
              ],
              [
                -76.6109130001078,
                39.294175999186,
                0
              ],
              [
                -76.6109370012585,
                39.2942589998643,
                0
              ],
              [
                -76.6109740000185,
                39.2944019990078,
                0
              ],
              [
                -76.6110070001174,
                39.2945319986488,
                0
              ],
              [
                -76.6110309997679,
                39.2946279990489,
                0
              ],
              [
                -76.6110679997342,
                39.2948809988469,
                0
              ],
              [
                -76.611112000088,
                39.2951209977112,
                0
              ],
              [
                -76.6111500005763,
                39.2953909989774,
                0
              ],
              [
                -76.6111740004475,
                39.295592998825,
                0
              ],
              [
                -76.6111970000692,
                39.2958319994168,
                0
              ],
              [
                -76.6112130002629,
                39.2962219989293,
                0
              ],
              [
                -76.6112230003021,
                39.2965129986809,
                0
              ],
              [
                -76.6112309988123,
                39.2967429987203,
                0
              ],
              [
                -76.6113129994888,
                39.2977069986583,
                0
              ],
              [
                -76.6110569987598,
                39.2977189989792,
                0
              ],
              [
                -76.6104509987143,
                39.2977529982062,
                0
              ],
              [
                -76.6098469999687,
                39.2978019985808,
                0
              ],
              [
                -76.6089210010239,
                39.2978009988911,
                0
              ],
              [
                -76.6079059999138,
                39.2978619985704,
                0
              ],
              [
                -76.606766999408,
                39.2979079993612,
                0
              ],
              [
                -76.6063319996534,
                39.2979119994331,
                0
              ],
              [
                -76.6058889996556,
                39.2979309993127,
                0
              ],
              [
                -76.6050549997327,
                39.2979609989937,
                0
              ],
              [
                -76.6042339998762,
                39.2979929993009,
                0
              ],
              [
                -76.6040560005546,
                39.2980010000187,
                0
              ],
              [
                -76.6029730001226,
                39.2980489993051,
                0
              ],
              [
                -76.6025480006813,
                39.2980719990469,
                0
              ],
              [
                -76.6019109995773,
                39.298106998738,
                0
              ],
              [
                -76.6009320011255,
                39.2981389990046,
                0
              ],
              [
                -76.6000740015528,
                39.2981709986051,
                0
              ],
              [
                -76.5996130000566,
                39.2981829993307,
                0
              ],
              [
                -76.5991409995193,
                39.2982069993611,
                0
              ],
              [
                -76.5983560005288,
                39.2982289992418,
                0
              ],
              [
                -76.5975970007148,
                39.2982509991579,
                0
              ],
              [
                -76.5964530004649,
                39.2983069992967,
                0
              ],
              [
                -76.5962790003807,
                39.2983169998562,
                0
              ],
              [
                -76.5956769999751,
                39.2983499989696,
                0
              ],
              [
                -76.5951819994968,
                39.2983709990033,
                0
              ],
              [
                -76.5949309994992,
                39.2983849991318,
                0
              ],
              [
                -76.5948339997508,
                39.2983909988058,
                0
              ],
              [
                -76.5945870001316,
                39.2984019989568,
                0
              ],
              [
                -76.5945100000344,
                39.2983999992756,
                0
              ],
              [
                -76.5944739994744,
                39.2983919996892,
                0
              ],
              [
                -76.5944079998758,
                39.2983729991555,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 74,
          "Census_Tract": "24510160500",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "fd848d1a-8978-4e09-a672-9b80ea6fd179",
          "Shape__Area": 11281271.38482666,
          "Shape__Length": 15255.157965910208
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6516069996175,
                39.3033499990853,
                0
              ],
              [
                -76.6507519995648,
                39.3032479985667,
                0
              ],
              [
                -76.6503980000016,
                39.3031989986286,
                0
              ],
              [
                -76.6501029994714,
                39.3031500003824,
                0
              ],
              [
                -76.6498409996483,
                39.3031019986972,
                0
              ],
              [
                -76.6492930012554,
                39.3030269987146,
                0
              ],
              [
                -76.6490609999927,
                39.3029869988565,
                0
              ],
              [
                -76.6486499994657,
                39.3029169988167,
                0
              ],
              [
                -76.6484830003275,
                39.3028629989651,
                0
              ],
              [
                -76.6483529997836,
                39.3027969998528,
                0
              ],
              [
                -76.6481329996261,
                39.3026449990099,
                0
              ],
              [
                -76.6477170012986,
                39.3023049990689,
                0
              ],
              [
                -76.6479349989847,
                39.3022599985729,
                0
              ],
              [
                -76.6481650013061,
                39.3021980003319,
                0
              ],
              [
                -76.6483510002162,
                39.3021339990854,
                0
              ],
              [
                -76.6486179992818,
                39.3020210000016,
                0
              ],
              [
                -76.6489479995502,
                39.3018779988322,
                0
              ],
              [
                -76.6492260003716,
                39.3017379986554,
                0
              ],
              [
                -76.6494789995066,
                39.301594999382,
                0
              ],
              [
                -76.650177000277,
                39.3010699987856,
                0
              ],
              [
                -76.650461000459,
                39.300775998691,
                0
              ],
              [
                -76.6506300002953,
                39.3005659991784,
                0
              ],
              [
                -76.6507699995859,
                39.3003719989179,
                0
              ],
              [
                -76.6509050004478,
                39.3001649992324,
                0
              ],
              [
                -76.6510460001439,
                39.2997729991908,
                0
              ],
              [
                -76.6513449997492,
                39.2989469989156,
                0
              ],
              [
                -76.6513539996553,
                39.2986379986245,
                0
              ],
              [
                -76.6510520014609,
                39.2986459997571,
                0
              ],
              [
                -76.6506070000847,
                39.298662998657,
                0
              ],
              [
                -76.6505989994592,
                39.2981339992915,
                0
              ],
              [
                -76.6505610011268,
                39.2975089989473,
                0
              ],
              [
                -76.6505699999506,
                39.2972549987825,
                0
              ],
              [
                -76.6505669989625,
                39.2969329989985,
                0
              ],
              [
                -76.6505380004187,
                39.296585998812,
                0
              ],
              [
                -76.6505179997967,
                39.2963529990432,
                0
              ],
              [
                -76.6504769999504,
                39.2950719993607,
                0
              ],
              [
                -76.6503839999317,
                39.2937229993566,
                0
              ],
              [
                -76.6503829998594,
                39.2936979994509,
                0
              ],
              [
                -76.6505849999161,
                39.2936849989629,
                0
              ],
              [
                -76.6512360003446,
                39.2936639991473,
                0
              ],
              [
                -76.6517720012144,
                39.2936279986862,
                0
              ],
              [
                -76.6523510000429,
                39.2936029987747,
                0
              ],
              [
                -76.6530209999375,
                39.2935639986105,
                0
              ],
              [
                -76.6532230002164,
                39.2935649985707,
                0
              ],
              [
                -76.6540159996791,
                39.2935359992415,
                0
              ],
              [
                -76.6547389985862,
                39.2935129986871,
                0
              ],
              [
                -76.6560040007815,
                39.2934459991041,
                0
              ],
              [
                -76.6562740000379,
                39.2934389987115,
                0
              ],
              [
                -76.657033999661,
                39.2934209987137,
                0
              ],
              [
                -76.657808000095,
                39.2933959987638,
                0
              ],
              [
                -76.6581039997289,
                39.2933919991585,
                0
              ],
              [
                -76.6585739997248,
                39.2933669990243,
                0
              ],
              [
                -76.6593530005165,
                39.293351999137,
                0
              ],
              [
                -76.6593699997507,
                39.2939319993288,
                0
              ],
              [
                -76.6594120003689,
                39.2946329985562,
                0
              ],
              [
                -76.6594309996294,
                39.2949829986926,
                0
              ],
              [
                -76.6594560011465,
                39.2954069989633,
                0
              ],
              [
                -76.659476000442,
                39.2957549986252,
                0
              ],
              [
                -76.6594859995973,
                39.2959359986715,
                0
              ],
              [
                -76.6594889995913,
                39.2960859986927,
                0
              ],
              [
                -76.6595179999009,
                39.2964689989443,
                0
              ],
              [
                -76.6595299995353,
                39.2967819989214,
                0
              ],
              [
                -76.6595890001187,
                39.2983389976379,
                0
              ],
              [
                -76.659662999962,
                39.2986959988262,
                0
              ],
              [
                -76.6596819997654,
                39.2987469988244,
                0
              ],
              [
                -76.6597009994365,
                39.2987989986575,
                0
              ],
              [
                -76.6597579996414,
                39.2989049989704,
                0
              ],
              [
                -76.6598520003066,
                39.2990349998301,
                0
              ],
              [
                -76.6599519998127,
                39.2991489989262,
                0
              ],
              [
                -76.660232001545,
                39.2994179991429,
                0
              ],
              [
                -76.6604749992731,
                39.2996439986475,
                0
              ],
              [
                -76.6606029996599,
                39.2997959989924,
                0
              ],
              [
                -76.6606689998434,
                39.2998999990229,
                0
              ],
              [
                -76.6607319997138,
                39.3000209993191,
                0
              ],
              [
                -76.6607720004136,
                39.300145999187,
                0
              ],
              [
                -76.6608020015709,
                39.3002739994098,
                0
              ],
              [
                -76.6608239986558,
                39.3004509992368,
                0
              ],
              [
                -76.6608679994478,
                39.3015419987278,
                0
              ],
              [
                -76.6608849985794,
                39.30177099906,
                0
              ],
              [
                -76.6608739997882,
                39.3019559986469,
                0
              ],
              [
                -76.6608480003591,
                39.3021299990403,
                0
              ],
              [
                -76.6607410001857,
                39.3025129992587,
                0
              ],
              [
                -76.6607209999116,
                39.3026239991979,
                0
              ],
              [
                -76.6607440005357,
                39.3027919987648,
                0
              ],
              [
                -76.6607660004872,
                39.3028659989513,
                0
              ],
              [
                -76.6607990003581,
                39.3029579991462,
                0
              ],
              [
                -76.6608290004346,
                39.3030779987421,
                0
              ],
              [
                -76.6608370008099,
                39.3032659985627,
                0
              ],
              [
                -76.6608270002117,
                39.3035769994194,
                0
              ],
              [
                -76.6608010015341,
                39.3036689986165,
                0
              ],
              [
                -76.6607589994315,
                39.3037629990178,
                0
              ],
              [
                -76.6607779996219,
                39.3042169990738,
                0
              ],
              [
                -76.660797999909,
                39.3045320002252,
                0
              ],
              [
                -76.6608179996539,
                39.3048199994266,
                0
              ],
              [
                -76.6608980010421,
                39.3061439994399,
                0
              ],
              [
                -76.6601710004467,
                39.3061839986105,
                0
              ],
              [
                -76.6592039992176,
                39.3062379977687,
                0
              ],
              [
                -76.659037999989,
                39.3062520003336,
                0
              ],
              [
                -76.6588670015633,
                39.3060689986335,
                0
              ],
              [
                -76.6585840001564,
                39.305832998791,
                0
              ],
              [
                -76.6585000003543,
                39.3057649999618,
                0
              ],
              [
                -76.6584180000994,
                39.3057069989502,
                0
              ],
              [
                -76.6583539995272,
                39.3056579992096,
                0
              ],
              [
                -76.6579360000665,
                39.3053719988338,
                0
              ],
              [
                -76.6576639988161,
                39.305223999109,
                0
              ],
              [
                -76.6573779997693,
                39.3050949989783,
                0
              ],
              [
                -76.6570190009337,
                39.304952998875,
                0
              ],
              [
                -76.6569370003068,
                39.3049250000404,
                0
              ],
              [
                -76.6556660001582,
                39.3045039987414,
                0
              ],
              [
                -76.6537880002363,
                39.3039089993536,
                0
              ],
              [
                -76.6533160001969,
                39.3037779989458,
                0
              ],
              [
                -76.652742000331,
                39.3036189988123,
                0
              ],
              [
                -76.6516069996175,
                39.3033499990853,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 75,
          "Census_Tract": "24510200702",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "13b2df9c-df4f-4f4f-aa93-c11b0f91596b",
          "Shape__Area": 3101687.645690918,
          "Shape__Length": 7863.630834047051
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6723159990811,
                39.2858319994094,
                0
              ],
              [
                -76.6722749994223,
                39.2848599991379,
                0
              ],
              [
                -76.6721850002495,
                39.2838869989083,
                0
              ],
              [
                -76.6721630005228,
                39.2831569987537,
                0
              ],
              [
                -76.6721409995541,
                39.2824689990709,
                0
              ],
              [
                -76.6721229998525,
                39.2819299988475,
                0
              ],
              [
                -76.6721219996335,
                39.2818529999769,
                0
              ],
              [
                -76.6721189994277,
                39.2814919993298,
                0
              ],
              [
                -76.6721320005023,
                39.2812759990695,
                0
              ],
              [
                -76.6721670000798,
                39.2810869992342,
                0
              ],
              [
                -76.6727209999856,
                39.2814069989257,
                0
              ],
              [
                -76.6739260014406,
                39.2820139990839,
                0
              ],
              [
                -76.6740040002431,
                39.2820529987044,
                0
              ],
              [
                -76.6745769994755,
                39.2823420002439,
                0
              ],
              [
                -76.675532000405,
                39.2828229987271,
                0
              ],
              [
                -76.6758590002021,
                39.2829799986906,
                0
              ],
              [
                -76.676046000135,
                39.2830629989302,
                0
              ],
              [
                -76.6762080015583,
                39.2831229993241,
                0
              ],
              [
                -76.6763800003523,
                39.2831709991921,
                0
              ],
              [
                -76.6765320003754,
                39.2832099991942,
                0
              ],
              [
                -76.6772860002066,
                39.2834179993352,
                0
              ],
              [
                -76.6775799993354,
                39.2834909989446,
                0
              ],
              [
                -76.6785629994734,
                39.2837399993322,
                0
              ],
              [
                -76.678925000216,
                39.2838149993537,
                0
              ],
              [
                -76.6796830001083,
                39.2839709986348,
                0
              ],
              [
                -76.6808129988467,
                39.2841489993037,
                0
              ],
              [
                -76.6804220002971,
                39.2845049998786,
                0
              ],
              [
                -76.6780970008903,
                39.2866239987099,
                0
              ],
              [
                -76.677952999761,
                39.2867519999654,
                0
              ],
              [
                -76.6767200001527,
                39.2878509994108,
                0
              ],
              [
                -76.6763679994584,
                39.2881649992863,
                0
              ],
              [
                -76.6762790003475,
                39.2881069992431,
                0
              ],
              [
                -76.6759869997287,
                39.2879249985618,
                0
              ],
              [
                -76.6756899999282,
                39.2877399991266,
                0
              ],
              [
                -76.6755979999568,
                39.287684998806,
                0
              ],
              [
                -76.6749429990409,
                39.2872499989858,
                0
              ],
              [
                -76.6748290005735,
                39.2871579988664,
                0
              ],
              [
                -76.6741540000543,
                39.2866289990526,
                0
              ],
              [
                -76.6739079985323,
                39.2864479989164,
                0
              ],
              [
                -76.673483999919,
                39.286111999151,
                0
              ],
              [
                -76.6732350001694,
                39.2859039988897,
                0
              ],
              [
                -76.6731569997539,
                39.285860999439,
                0
              ],
              [
                -76.6730650000951,
                39.2858259993488,
                0
              ],
              [
                -76.672982000124,
                39.2858049986166,
                0
              ],
              [
                -76.6728870005348,
                39.2858019994103,
                0
              ],
              [
                -76.6726850003121,
                39.2858049992398,
                0
              ],
              [
                -76.6723159990811,
                39.2858319994094,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 76,
          "Census_Tract": "24510160600",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "da63c367-a40e-4def-bc9d-573c09b299ae",
          "Shape__Area": 5988740.0556640625,
          "Shape__Length": 10549.191965202186
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6593530005165,
                39.293351999137,
                0
              ],
              [
                -76.6613509995161,
                39.2932589992674,
                0
              ],
              [
                -76.6624550000374,
                39.2932080003488,
                0
              ],
              [
                -76.6628950002608,
                39.2931819986819,
                0
              ],
              [
                -76.6631240003261,
                39.2931799992182,
                0
              ],
              [
                -76.6632749994891,
                39.2931839991037,
                0
              ],
              [
                -76.663403000093,
                39.2931959991877,
                0
              ],
              [
                -76.6635339987837,
                39.2932159992385,
                0
              ],
              [
                -76.6636420005638,
                39.2932399993232,
                0
              ],
              [
                -76.6637250002951,
                39.2932649987471,
                0
              ],
              [
                -76.6638840013124,
                39.2933189992778,
                0
              ],
              [
                -76.6640299997608,
                39.2933830004489,
                0
              ],
              [
                -76.6641730002495,
                39.2934519992762,
                0
              ],
              [
                -76.6643310015722,
                39.2935429994502,
                0
              ],
              [
                -76.6644089996244,
                39.2935949996097,
                0
              ],
              [
                -76.664462999864,
                39.293630998585,
                0
              ],
              [
                -76.664895001065,
                39.2939359993711,
                0
              ],
              [
                -76.6649269996901,
                39.294451999284,
                0
              ],
              [
                -76.6658220002998,
                39.2944419991176,
                0
              ],
              [
                -76.6667110004863,
                39.2944119990234,
                0
              ],
              [
                -76.6675640004488,
                39.2943689987089,
                0
              ],
              [
                -76.6680369995121,
                39.2943559988114,
                0
              ],
              [
                -76.668453999526,
                39.2943339989631,
                0
              ],
              [
                -76.6686639988352,
                39.2943249992404,
                0
              ],
              [
                -76.6689640001683,
                39.2943089989796,
                0
              ],
              [
                -76.669717000533,
                39.2942759995819,
                0
              ],
              [
                -76.6696789985565,
                39.2944489993041,
                0
              ],
              [
                -76.6696120001891,
                39.2946839994292,
                0
              ],
              [
                -76.6695049984663,
                39.2950089986814,
                0
              ],
              [
                -76.6693509995893,
                39.2956699990951,
                0
              ],
              [
                -76.6691210005764,
                39.296047998992,
                0
              ],
              [
                -76.6690720002777,
                39.2961489988195,
                0
              ],
              [
                -76.6690799994651,
                39.2962629985663,
                0
              ],
              [
                -76.6691029999102,
                39.2964079986557,
                0
              ],
              [
                -76.669175999353,
                39.2965279994225,
                0
              ],
              [
                -76.6692450002024,
                39.2966229991996,
                0
              ],
              [
                -76.6693009999297,
                39.2968119985921,
                0
              ],
              [
                -76.6692770002465,
                39.2968709999302,
                0
              ],
              [
                -76.6691130000821,
                39.2970639989869,
                0
              ],
              [
                -76.669025000111,
                39.2971499976231,
                0
              ],
              [
                -76.6689540010492,
                39.2971889994026,
                0
              ],
              [
                -76.6689840004196,
                39.2982639993324,
                0
              ],
              [
                -76.668981999545,
                39.2988089987,
                0
              ],
              [
                -76.6689600004569,
                39.2990039989706,
                0
              ],
              [
                -76.6689440002452,
                39.2990989989244,
                0
              ],
              [
                -76.6689490013437,
                39.2991819987327,
                0
              ],
              [
                -76.6689829996871,
                39.2992899987404,
                0
              ],
              [
                -76.6689419997635,
                39.2993129984131,
                0
              ],
              [
                -76.6688769995272,
                39.2993389993097,
                0
              ],
              [
                -76.6687839998585,
                39.2993509991641,
                0
              ],
              [
                -76.6687170005763,
                39.299350999431,
                0
              ],
              [
                -76.6686019996826,
                39.2993529990683,
                0
              ],
              [
                -76.6684739997575,
                39.2993439988183,
                0
              ],
              [
                -76.6683730001712,
                39.299339999072,
                0
              ],
              [
                -76.6682630005392,
                39.2993429988209,
                0
              ],
              [
                -76.6681510005358,
                39.2993589988274,
                0
              ],
              [
                -76.6680130003703,
                39.2993769988037,
                0
              ],
              [
                -76.6678930005544,
                39.299401998829,
                0
              ],
              [
                -76.667783001403,
                39.2994169988972,
                0
              ],
              [
                -76.6676410014313,
                39.2994099992657,
                0
              ],
              [
                -76.6674850003559,
                39.2993809994168,
                0
              ],
              [
                -76.6673810001834,
                39.2993599993721,
                0
              ],
              [
                -76.6672289997832,
                39.2993159994148,
                0
              ],
              [
                -76.6671309997028,
                39.2992659991984,
                0
              ],
              [
                -76.6670430000137,
                39.2992159993156,
                0
              ],
              [
                -76.6669600002306,
                39.2991519986803,
                0
              ],
              [
                -76.6651870001847,
                39.2992099990253,
                0
              ],
              [
                -76.6652709997025,
                39.300282998668,
                0
              ],
              [
                -76.6635059996092,
                39.3003609995795,
                0
              ],
              [
                -76.6617459999436,
                39.3004069989493,
                0
              ],
              [
                -76.6613299999111,
                39.3004269989792,
                0
              ],
              [
                -76.6608239986558,
                39.3004509992368,
                0
              ],
              [
                -76.6608020015709,
                39.3002739994098,
                0
              ],
              [
                -76.6607720004136,
                39.300145999187,
                0
              ],
              [
                -76.6607319997138,
                39.3000209993191,
                0
              ],
              [
                -76.6606689998434,
                39.2998999990229,
                0
              ],
              [
                -76.6606029996599,
                39.2997959989924,
                0
              ],
              [
                -76.6604749992731,
                39.2996439986475,
                0
              ],
              [
                -76.660232001545,
                39.2994179991429,
                0
              ],
              [
                -76.6599519998127,
                39.2991489989262,
                0
              ],
              [
                -76.6598520003066,
                39.2990349998301,
                0
              ],
              [
                -76.6597579996414,
                39.2989049989704,
                0
              ],
              [
                -76.6597009994365,
                39.2987989986575,
                0
              ],
              [
                -76.6596819997654,
                39.2987469988244,
                0
              ],
              [
                -76.659662999962,
                39.2986959988262,
                0
              ],
              [
                -76.6595890001187,
                39.2983389976379,
                0
              ],
              [
                -76.6595299995353,
                39.2967819989214,
                0
              ],
              [
                -76.6595179999009,
                39.2964689989443,
                0
              ],
              [
                -76.6594889995913,
                39.2960859986927,
                0
              ],
              [
                -76.6594859995973,
                39.2959359986715,
                0
              ],
              [
                -76.659476000442,
                39.2957549986252,
                0
              ],
              [
                -76.6594560011465,
                39.2954069989633,
                0
              ],
              [
                -76.6594309996294,
                39.2949829986926,
                0
              ],
              [
                -76.6594120003689,
                39.2946329985562,
                0
              ],
              [
                -76.6593699997507,
                39.2939319993288,
                0
              ],
              [
                -76.6593530005165,
                39.293351999137,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 77,
          "Census_Tract": "24510120600",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "1a923e0f-1a0f-493b-add0-c4311cee25ee",
          "Shape__Area": 5435180.571899414,
          "Shape__Length": 11398.403854867736
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.615301999533,
                39.3164129996725,
                0
              ],
              [
                -76.6152889991845,
                39.3159429991145,
                0
              ],
              [
                -76.6152729999342,
                39.315362998588,
                0
              ],
              [
                -76.6151759988294,
                39.3142919986172,
                0
              ],
              [
                -76.615131999521,
                39.3132789992979,
                0
              ],
              [
                -76.6150639996697,
                39.3123049993475,
                0
              ],
              [
                -76.6149639995726,
                39.3111969988725,
                0
              ],
              [
                -76.6149549995483,
                39.3110649989458,
                0
              ],
              [
                -76.6158299997103,
                39.3110409986351,
                0
              ],
              [
                -76.6159299994558,
                39.3110379990236,
                0
              ],
              [
                -76.6165540003862,
                39.3110159992749,
                0
              ],
              [
                -76.6179150015104,
                39.3109899985796,
                0
              ],
              [
                -76.6193150001178,
                39.3109549982352,
                0
              ],
              [
                -76.6193539994924,
                39.3109559992007,
                0
              ],
              [
                -76.6193460003432,
                39.3110699997784,
                0
              ],
              [
                -76.6193200008703,
                39.3114349993611,
                0
              ],
              [
                -76.6193360014898,
                39.3115789989175,
                0
              ],
              [
                -76.6193509994468,
                39.3117289987435,
                0
              ],
              [
                -76.6193590002392,
                39.3118019992533,
                0
              ],
              [
                -76.6193760003277,
                39.3119589990053,
                0
              ],
              [
                -76.6193930000235,
                39.3121229994058,
                0
              ],
              [
                -76.6194619997318,
                39.3131269986523,
                0
              ],
              [
                -76.619504000158,
                39.3139009991084,
                0
              ],
              [
                -76.6195169999368,
                39.3141449985686,
                0
              ],
              [
                -76.6195589987901,
                39.3151589990406,
                0
              ],
              [
                -76.6196280000831,
                39.3162559990792,
                0
              ],
              [
                -76.619702999992,
                39.3171399991344,
                0
              ],
              [
                -76.6197310012928,
                39.3177529986923,
                0
              ],
              [
                -76.6197660002559,
                39.3181929988612,
                0
              ],
              [
                -76.6198179995672,
                39.3190199990598,
                0
              ],
              [
                -76.6198360003081,
                39.3192659986295,
                0
              ],
              [
                -76.6198889995056,
                39.3201350002058,
                0
              ],
              [
                -76.6199079988337,
                39.3205309987814,
                0
              ],
              [
                -76.6199110003648,
                39.320634999366,
                0
              ],
              [
                -76.61991400032,
                39.320692998557,
                0
              ],
              [
                -76.6199580001595,
                39.321815998703,
                0
              ],
              [
                -76.6200340003873,
                39.3227499991281,
                0
              ],
              [
                -76.6200500004461,
                39.3229679992709,
                0
              ],
              [
                -76.6200610005171,
                39.3230739991746,
                0
              ],
              [
                -76.6200800011118,
                39.3231159986581,
                0
              ],
              [
                -76.6201139999187,
                39.3231519989737,
                0
              ],
              [
                -76.6200920000765,
                39.3231489986226,
                0
              ],
              [
                -76.6200680003687,
                39.3231289991362,
                0
              ],
              [
                -76.6199859994576,
                39.3231099993165,
                0
              ],
              [
                -76.6199119985943,
                39.3231049986603,
                0
              ],
              [
                -76.6198089999639,
                39.3231069993756,
                0
              ],
              [
                -76.6195929996317,
                39.3231069994512,
                0
              ],
              [
                -76.6193290005167,
                39.3231159989121,
                0
              ],
              [
                -76.6187089996205,
                39.323143997712,
                0
              ],
              [
                -76.617566999846,
                39.3231969995712,
                0
              ],
              [
                -76.6173640001099,
                39.323206999258,
                0
              ],
              [
                -76.6171719996522,
                39.3232069991542,
                0
              ],
              [
                -76.6165330013976,
                39.3232419981985,
                0
              ],
              [
                -76.6157430002515,
                39.3232869993416,
                0
              ],
              [
                -76.6156649997007,
                39.3220029990195,
                0
              ],
              [
                -76.6155889997634,
                39.3207119986245,
                0
              ],
              [
                -76.6155259995494,
                39.3194199989167,
                0
              ],
              [
                -76.6155029996273,
                39.3191189985771,
                0
              ],
              [
                -76.6154449994524,
                39.3185049992436,
                0
              ],
              [
                -76.6154179999871,
                39.3182239986326,
                0
              ],
              [
                -76.6154059998666,
                39.3179289989391,
                0
              ],
              [
                -76.6153589998112,
                39.3173039993076,
                0
              ],
              [
                -76.6153479996776,
                39.3171579990209,
                0
              ],
              [
                -76.615301999533,
                39.3164129996725,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 78,
          "Census_Tract": "24510280600",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "9fdb90be-f6c4-452f-8b99-241125d8c64d",
          "Shape__Area": 6203115.240478516,
          "Shape__Length": 10122.12581315267
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6277660001658,
                39.288973999719,
                0
              ],
              [
                -76.6280480003884,
                39.2889779987506,
                0
              ],
              [
                -76.6289089994226,
                39.2889919992153,
                0
              ],
              [
                -76.6303800000251,
                39.288923999449,
                0
              ],
              [
                -76.6313969999099,
                39.2888769991561,
                0
              ],
              [
                -76.6321490001636,
                39.2888379988209,
                0
              ],
              [
                -76.6329709999013,
                39.2887999996592,
                0
              ],
              [
                -76.6330470004436,
                39.2887979986961,
                0
              ],
              [
                -76.6338100001485,
                39.288765999376,
                0
              ],
              [
                -76.6353030005023,
                39.2886849986934,
                0
              ],
              [
                -76.6360119998176,
                39.2886469976139,
                0
              ],
              [
                -76.6367340006293,
                39.2886229987413,
                0
              ],
              [
                -76.6374830000136,
                39.2885909989368,
                0
              ],
              [
                -76.6381659996622,
                39.28856599897,
                0
              ],
              [
                -76.6381980003971,
                39.2891379987923,
                0
              ],
              [
                -76.6382299995959,
                39.2897769987828,
                0
              ],
              [
                -76.6382770010297,
                39.2908879975589,
                0
              ],
              [
                -76.6383039995734,
                39.2912289990426,
                0
              ],
              [
                -76.6383280002399,
                39.2918069989127,
                0
              ],
              [
                -76.6383650004048,
                39.2922949988604,
                0
              ],
              [
                -76.6384190001984,
                39.2932099979408,
                0
              ],
              [
                -76.6384279997939,
                39.2934579999114,
                0
              ],
              [
                -76.6384289997992,
                39.2934739986554,
                0
              ],
              [
                -76.6384379996913,
                39.2937189992799,
                0
              ],
              [
                -76.6384389992553,
                39.2937409988726,
                0
              ],
              [
                -76.6384619997957,
                39.2941889986873,
                0
              ],
              [
                -76.6370579994447,
                39.2942449989021,
                0
              ],
              [
                -76.6369530004291,
                39.2942499988653,
                0
              ],
              [
                -76.6366000014007,
                39.2942669992348,
                0
              ],
              [
                -76.6363120005347,
                39.2942769991112,
                0
              ],
              [
                -76.6356229994652,
                39.2943019986396,
                0
              ],
              [
                -76.6341320003966,
                39.2943539991309,
                0
              ],
              [
                -76.6325210011949,
                39.2944259985877,
                0
              ],
              [
                -76.6319220001725,
                39.2944579991697,
                0
              ],
              [
                -76.6304059995167,
                39.2945399990207,
                0
              ],
              [
                -76.628587999171,
                39.2945999985737,
                0
              ],
              [
                -76.6280309997273,
                39.2946189988593,
                0
              ],
              [
                -76.6276880010437,
                39.294629998767,
                0
              ],
              [
                -76.6277070002735,
                39.2943809992579,
                0
              ],
              [
                -76.6277100000371,
                39.294318999647,
                0
              ],
              [
                -76.6277280005682,
                39.2938639988567,
                0
              ],
              [
                -76.6277269999013,
                39.2938169986035,
                0
              ],
              [
                -76.6277200001397,
                39.2935899987458,
                0
              ],
              [
                -76.6277189996811,
                39.2935730000601,
                0
              ],
              [
                -76.62770800125,
                39.293272999029,
                0
              ],
              [
                -76.6276450001029,
                39.2927199991398,
                0
              ],
              [
                -76.6275409996798,
                39.291857999735,
                0
              ],
              [
                -76.6274790002414,
                39.2912409992349,
                0
              ],
              [
                -76.6274630001775,
                39.2908089992286,
                0
              ],
              [
                -76.6274769996849,
                39.2904599993075,
                0
              ],
              [
                -76.6275029999235,
                39.2901279978048,
                0
              ],
              [
                -76.6276270005363,
                39.2895229993121,
                0
              ],
              [
                -76.6277660001658,
                39.288973999719,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 79,
          "Census_Tract": "24510140200",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "44bf1be4-60eb-441f-8b78-3ed66f4654b2",
          "Shape__Area": 4253992.897766113,
          "Shape__Length": 8633.593842333685
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6269050005491,
                39.3047839987063,
                0
              ],
              [
                -76.6271330003809,
                39.304613998599,
                0
              ],
              [
                -76.6275700008054,
                39.3042839991663,
                0
              ],
              [
                -76.6280059996373,
                39.3039699986474,
                0
              ],
              [
                -76.6284219995377,
                39.3036659991987,
                0
              ],
              [
                -76.6287640002124,
                39.3034089992308,
                0
              ],
              [
                -76.6292070011589,
                39.3030679990509,
                0
              ],
              [
                -76.6295539994411,
                39.3027999998815,
                0
              ],
              [
                -76.630107999457,
                39.302395998686,
                0
              ],
              [
                -76.6306270002292,
                39.3020059987789,
                0
              ],
              [
                -76.6309180003492,
                39.3017929989095,
                0
              ],
              [
                -76.6311890004968,
                39.3015849986868,
                0
              ],
              [
                -76.6317320003024,
                39.3011809993527,
                0
              ],
              [
                -76.6319810004076,
                39.3010069994388,
                0
              ],
              [
                -76.6321899998715,
                39.3008409986042,
                0
              ],
              [
                -76.6326440002546,
                39.300508999379,
                0
              ],
              [
                -76.6330939999069,
                39.3001709976556,
                0
              ],
              [
                -76.6335619997448,
                39.2998129985808,
                0
              ],
              [
                -76.6341269995495,
                39.2993999986476,
                0
              ],
              [
                -76.6344750006051,
                39.2991419988984,
                0
              ],
              [
                -76.634510999785,
                39.2991979992528,
                0
              ],
              [
                -76.6347720000779,
                39.299657998696,
                0
              ],
              [
                -76.6348799996447,
                39.2998479986072,
                0
              ],
              [
                -76.6350829987424,
                39.3001979985533,
                0
              ],
              [
                -76.6351189995163,
                39.3002619992257,
                0
              ],
              [
                -76.635243000261,
                39.3005129990464,
                0
              ],
              [
                -76.6353410002456,
                39.3006809988834,
                0
              ],
              [
                -76.6356940002138,
                39.3012889992656,
                0
              ],
              [
                -76.6358780001487,
                39.3016849989197,
                0
              ],
              [
                -76.6359749996092,
                39.3018709993721,
                0
              ],
              [
                -76.6363689998231,
                39.3025489988312,
                0
              ],
              [
                -76.6366049996498,
                39.302981999003,
                0
              ],
              [
                -76.6366770014203,
                39.3031139986342,
                0
              ],
              [
                -76.6368289998164,
                39.3034209993124,
                0
              ],
              [
                -76.6363259996595,
                39.3037819986059,
                0
              ],
              [
                -76.6355909993862,
                39.3043389987457,
                0
              ],
              [
                -76.635404000175,
                39.3044669987953,
                0
              ],
              [
                -76.6350939997989,
                39.3046779986533,
                0
              ],
              [
                -76.6350069995234,
                39.3047409993006,
                0
              ],
              [
                -76.6345259994752,
                39.3051619999002,
                0
              ],
              [
                -76.6340010003365,
                39.3055880002637,
                0
              ],
              [
                -76.6336539995253,
                39.3058119987226,
                0
              ],
              [
                -76.6334070003508,
                39.3059689992524,
                0
              ],
              [
                -76.6330900006013,
                39.3062169983677,
                0
              ],
              [
                -76.6326659996815,
                39.3065299984316,
                0
              ],
              [
                -76.6322579999428,
                39.3068069988129,
                0
              ],
              [
                -76.6318739997331,
                39.307100999038,
                0
              ],
              [
                -76.6314569997741,
                39.3074069988406,
                0
              ],
              [
                -76.630994999566,
                39.307760999381,
                0
              ],
              [
                -76.6307610000497,
                39.3079469988846,
                0
              ],
              [
                -76.6297689996803,
                39.3071509989339,
                0
              ],
              [
                -76.6289510007711,
                39.3064909981921,
                0
              ],
              [
                -76.6287829995738,
                39.3063549993938,
                0
              ],
              [
                -76.6280550000266,
                39.3057399989944,
                0
              ],
              [
                -76.6278990005688,
                39.3056049997874,
                0
              ],
              [
                -76.6278229998527,
                39.3055489987237,
                0
              ],
              [
                -76.6273209991973,
                39.3051249992166,
                0
              ],
              [
                -76.6269050005491,
                39.3047839987063,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 80,
          "Census_Tract": "24510140300",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "16b7a236-472b-45b6-92ec-764e94eeaaed",
          "Shape__Area": 4189985.7603149414,
          "Shape__Length": 9048.260933443418
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6307610000497,
                39.3079469988846,
                0
              ],
              [
                -76.630994999566,
                39.307760999381,
                0
              ],
              [
                -76.6314569997741,
                39.3074069988406,
                0
              ],
              [
                -76.6318739997331,
                39.307100999038,
                0
              ],
              [
                -76.6322579999428,
                39.3068069988129,
                0
              ],
              [
                -76.6326659996815,
                39.3065299984316,
                0
              ],
              [
                -76.6330900006013,
                39.3062169983677,
                0
              ],
              [
                -76.6334070003508,
                39.3059689992524,
                0
              ],
              [
                -76.6336539995253,
                39.3058119987226,
                0
              ],
              [
                -76.6340010003365,
                39.3055880002637,
                0
              ],
              [
                -76.6345259994752,
                39.3051619999002,
                0
              ],
              [
                -76.6350069995234,
                39.3047409993006,
                0
              ],
              [
                -76.6350939997989,
                39.3046779986533,
                0
              ],
              [
                -76.635404000175,
                39.3044669987953,
                0
              ],
              [
                -76.6355909993862,
                39.3043389987457,
                0
              ],
              [
                -76.6363259996595,
                39.3037819986059,
                0
              ],
              [
                -76.6368289998164,
                39.3034209993124,
                0
              ],
              [
                -76.6373000005712,
                39.3042769991393,
                0
              ],
              [
                -76.6374709997901,
                39.3045889990563,
                0
              ],
              [
                -76.6377849997352,
                39.305152998907,
                0
              ],
              [
                -76.6380329989852,
                39.3055969985967,
                0
              ],
              [
                -76.6381469996478,
                39.3057729987482,
                0
              ],
              [
                -76.6384680004206,
                39.3063369991814,
                0
              ],
              [
                -76.6386079998655,
                39.3066099991393,
                0
              ],
              [
                -76.6386959995798,
                39.3067759987136,
                0
              ],
              [
                -76.6388230003318,
                39.306991999186,
                0
              ],
              [
                -76.6394489995392,
                39.3075109988906,
                0
              ],
              [
                -76.6397370000319,
                39.3077429986932,
                0
              ],
              [
                -76.6403920000874,
                39.3082999993728,
                0
              ],
              [
                -76.6407960000858,
                39.3086569986938,
                0
              ],
              [
                -76.6416189997489,
                39.3093569987113,
                0
              ],
              [
                -76.6425140003439,
                39.310088999422,
                0
              ],
              [
                -76.6415020004704,
                39.3101309991354,
                0
              ],
              [
                -76.6411679985205,
                39.3101449988695,
                0
              ],
              [
                -76.6409119994071,
                39.3101530001217,
                0
              ],
              [
                -76.6403890004007,
                39.3101459989704,
                0
              ],
              [
                -76.6397200007322,
                39.310176999331,
                0
              ],
              [
                -76.6390370009561,
                39.3102099993932,
                0
              ],
              [
                -76.6388550004284,
                39.3102179991581,
                0
              ],
              [
                -76.6383719998501,
                39.3102369987129,
                0
              ],
              [
                -76.6383310000367,
                39.310236998639,
                0
              ],
              [
                -76.6382899999935,
                39.3102399989609,
                0
              ],
              [
                -76.6380229997842,
                39.3102559992859,
                0
              ],
              [
                -76.6369859997117,
                39.3103189985796,
                0
              ],
              [
                -76.6369009996449,
                39.3102819987245,
                0
              ],
              [
                -76.6368420005207,
                39.3102660000719,
                0
              ],
              [
                -76.6366949997212,
                39.3102629992568,
                0
              ],
              [
                -76.636506999647,
                39.3102660001727,
                0
              ],
              [
                -76.6362169985582,
                39.3102689994282,
                0
              ],
              [
                -76.6357609996033,
                39.3102779987102,
                0
              ],
              [
                -76.63496099975,
                39.310306998553,
                0
              ],
              [
                -76.6347159995594,
                39.3103079991008,
                0
              ],
              [
                -76.634193000145,
                39.3103249988854,
                0
              ],
              [
                -76.6340309993334,
                39.3103299998819,
                0
              ],
              [
                -76.6338959997555,
                39.3103349992082,
                0
              ],
              [
                -76.6336579990218,
                39.3103409987247,
                0
              ],
              [
                -76.6326580001494,
                39.3094989992983,
                0
              ],
              [
                -76.6317210010342,
                39.3087249991304,
                0
              ],
              [
                -76.6307610000497,
                39.3079469988846,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 81,
          "Census_Tract": "24510250102",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "4a04cc20-2d22-4300-bfa5-35aa6b5a7500",
          "Shape__Area": 7939406.232727051,
          "Shape__Length": 11704.376992108257
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6835810004618,
                39.276568998599,
                0
              ],
              [
                -76.685392000739,
                39.2755049993769,
                0
              ],
              [
                -76.6881919999044,
                39.2745049986021,
                0
              ],
              [
                -76.6894539994848,
                39.2721159988598,
                0
              ],
              [
                -76.6900099999608,
                39.2720179992201,
                0
              ],
              [
                -76.6908979999612,
                39.2718879987753,
                0
              ],
              [
                -76.6914479999006,
                39.2718520003199,
                0
              ],
              [
                -76.6921459991761,
                39.2718389991546,
                0
              ],
              [
                -76.69268000053,
                39.2718239993021,
                0
              ],
              [
                -76.6927660000568,
                39.2720630001224,
                0
              ],
              [
                -76.6929219991211,
                39.2724959990553,
                0
              ],
              [
                -76.6932900004854,
                39.2734689988402,
                0
              ],
              [
                -76.6936180005627,
                39.2743579986113,
                0
              ],
              [
                -76.6937209998496,
                39.2745909987738,
                0
              ],
              [
                -76.6938149996539,
                39.2747949987773,
                0
              ],
              [
                -76.6938940007794,
                39.2749469991897,
                0
              ],
              [
                -76.694053001105,
                39.2751769985945,
                0
              ],
              [
                -76.6940859995673,
                39.2752249996372,
                0
              ],
              [
                -76.6941539997481,
                39.2752939993869,
                0
              ],
              [
                -76.6946319999066,
                39.2757999990108,
                0
              ],
              [
                -76.6951520004365,
                39.2763519993801,
                0
              ],
              [
                -76.6956369994837,
                39.2773459990607,
                0
              ],
              [
                -76.6956769999821,
                39.2774269991123,
                0
              ],
              [
                -76.695726000574,
                39.2775499988047,
                0
              ],
              [
                -76.6957640003536,
                39.2776959988204,
                0
              ],
              [
                -76.6957579999496,
                39.2778379998744,
                0
              ],
              [
                -76.6957240000592,
                39.277939998584,
                0
              ],
              [
                -76.6956349987393,
                39.2780749991486,
                0
              ],
              [
                -76.6953139995164,
                39.2785069993662,
                0
              ],
              [
                -76.6946330007469,
                39.279373999669,
                0
              ],
              [
                -76.6946619995037,
                39.2795089990027,
                0
              ],
              [
                -76.6946360001593,
                39.2797090001203,
                0
              ],
              [
                -76.6946070000269,
                39.279901999018,
                0
              ],
              [
                -76.6945839998763,
                39.2799899984067,
                0
              ],
              [
                -76.6945459995415,
                39.2800629989618,
                0
              ],
              [
                -76.6944009996435,
                39.2802899988142,
                0
              ],
              [
                -76.6940129996996,
                39.2808749986975,
                0
              ],
              [
                -76.6938140001651,
                39.2812179992435,
                0
              ],
              [
                -76.6936820003303,
                39.2814429990149,
                0
              ],
              [
                -76.6933350001555,
                39.2814539989402,
                0
              ],
              [
                -76.6929310002901,
                39.2814689986466,
                0
              ],
              [
                -76.6919289995595,
                39.2815009992648,
                0
              ],
              [
                -76.6917590004648,
                39.2815039986897,
                0
              ],
              [
                -76.6906650004672,
                39.2815129992882,
                0
              ],
              [
                -76.6902769997407,
                39.2815269979286,
                0
              ],
              [
                -76.6894930002564,
                39.2815539992045,
                0
              ],
              [
                -76.6885220005658,
                39.2816000000745,
                0
              ],
              [
                -76.6872860012069,
                39.2816379996831,
                0
              ],
              [
                -76.6867060000926,
                39.2816559988407,
                0
              ],
              [
                -76.6856099992908,
                39.2816789988822,
                0
              ],
              [
                -76.6855290005127,
                39.280004998865,
                0
              ],
              [
                -76.6855269995758,
                39.2799569992023,
                0
              ],
              [
                -76.6855060001847,
                39.2794749992956,
                0
              ],
              [
                -76.6855020000871,
                39.279164999103,
                0
              ],
              [
                -76.6855000004197,
                39.2789119989584,
                0
              ],
              [
                -76.6855009998963,
                39.2788399993433,
                0
              ],
              [
                -76.6855240005665,
                39.2787749989933,
                0
              ],
              [
                -76.6855550003326,
                39.2787149985557,
                0
              ],
              [
                -76.6856390000189,
                39.278580999266,
                0
              ],
              [
                -76.6857889990756,
                39.2783719990034,
                0
              ],
              [
                -76.6859029987786,
                39.2782199987942,
                0
              ],
              [
                -76.6855949996349,
                39.277969999125,
                0
              ],
              [
                -76.6849370003533,
                39.2774469999042,
                0
              ],
              [
                -76.6846090004754,
                39.2771459986827,
                0
              ],
              [
                -76.684288999507,
                39.2769039998475,
                0
              ],
              [
                -76.683894000159,
                39.2766269991925,
                0
              ],
              [
                -76.6838149986318,
                39.2765899985623,
                0
              ],
              [
                -76.6837140007684,
                39.276567999375,
                0
              ],
              [
                -76.6836660004045,
                39.2765659992271,
                0
              ],
              [
                -76.6835810004618,
                39.276568998599,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 82,
          "Census_Tract": "24510250103",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "f0209cfc-da1a-4429-beca-9248df695ad0",
          "Shape__Area": 27854853.68609619,
          "Shape__Length": 28020.3344833373
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6715630003993,
                39.2759329990384,
                0
              ],
              [
                -76.6715529995798,
                39.2753529993413,
                0
              ],
              [
                -76.6715460000633,
                39.2748809994006,
                0
              ],
              [
                -76.6715440003091,
                39.2747849986942,
                0
              ],
              [
                -76.6715179994841,
                39.2743189986554,
                0
              ],
              [
                -76.6714890011154,
                39.2738869993441,
                0
              ],
              [
                -76.6713560003939,
                39.27374199996,
                0
              ],
              [
                -76.6712500001072,
                39.2735589989684,
                0
              ],
              [
                -76.6711270005332,
                39.2733309986204,
                0
              ],
              [
                -76.6708859984532,
                39.2729069993701,
                0
              ],
              [
                -76.6706489997367,
                39.2724770000013,
                0
              ],
              [
                -76.6704520004489,
                39.2721299987285,
                0
              ],
              [
                -76.6701459994024,
                39.2715679986536,
                0
              ],
              [
                -76.6700029997071,
                39.2712239990856,
                0
              ],
              [
                -76.6696889994357,
                39.2706719988668,
                0
              ],
              [
                -76.6690100010105,
                39.2698329988305,
                0
              ],
              [
                -76.6687879997349,
                39.2694299991812,
                0
              ],
              [
                -76.6680599999382,
                39.2680789986935,
                0
              ],
              [
                -76.6676940004941,
                39.2673669995629,
                0
              ],
              [
                -76.6672630002176,
                39.2664259991977,
                0
              ],
              [
                -76.6672090000259,
                39.2663179985592,
                0
              ],
              [
                -76.6671219996916,
                39.2661389988777,
                0
              ],
              [
                -76.667113999463,
                39.2661189999459,
                0
              ],
              [
                -76.6670909999498,
                39.2660599986271,
                0
              ],
              [
                -76.6670549995786,
                39.2659709992141,
                0
              ],
              [
                -76.6669650004153,
                39.2657449989047,
                0
              ],
              [
                -76.6669349996958,
                39.2656690000815,
                0
              ],
              [
                -76.6669110005786,
                39.2656079988887,
                0
              ],
              [
                -76.6668499995531,
                39.2654539986652,
                0
              ],
              [
                -76.6659370003619,
                39.2631659993247,
                0
              ],
              [
                -76.6658990002645,
                39.2630819993386,
                0
              ],
              [
                -76.6655309999388,
                39.2622179986281,
                0
              ],
              [
                -76.6648819994,
                39.2605539993611,
                0
              ],
              [
                -76.6648080003983,
                39.2603009989637,
                0
              ],
              [
                -76.6646689994335,
                39.2595179992936,
                0
              ],
              [
                -76.6646219998369,
                39.2593079991171,
                0
              ],
              [
                -76.6645870003992,
                39.2591779978254,
                0
              ],
              [
                -76.6645179995618,
                39.2590049985769,
                0
              ],
              [
                -76.6643650000624,
                39.2587209991602,
                0
              ],
              [
                -76.6642749997624,
                39.2585589993307,
                0
              ],
              [
                -76.6642469998705,
                39.2585100004408,
                0
              ],
              [
                -76.6643449994867,
                39.2583779994307,
                0
              ],
              [
                -76.6644459997402,
                39.2582819988432,
                0
              ],
              [
                -76.6644240007219,
                39.2579709976161,
                0
              ],
              [
                -76.6643220002341,
                39.2574420000889,
                0
              ],
              [
                -76.6643429997082,
                39.2574499985773,
                0
              ],
              [
                -76.6643839999123,
                39.2574659989934,
                0
              ],
              [
                -76.664455000396,
                39.2574970000252,
                0
              ],
              [
                -76.6655669999884,
                39.2579819988441,
                0
              ],
              [
                -76.6673489996271,
                39.2588579991715,
                0
              ],
              [
                -76.6690339991892,
                39.2595159988903,
                0
              ],
              [
                -76.6698189997616,
                39.2598229992253,
                0
              ],
              [
                -76.6708170005693,
                39.2602089987347,
                0
              ],
              [
                -76.6714310014635,
                39.260446998255,
                0
              ],
              [
                -76.6716499999748,
                39.2605319990685,
                0
              ],
              [
                -76.6716779996488,
                39.2605429991431,
                0
              ],
              [
                -76.6731390001881,
                39.2611549989995,
                0
              ],
              [
                -76.6731740001247,
                39.2611699986821,
                0
              ],
              [
                -76.6734319996843,
                39.2612809989907,
                0
              ],
              [
                -76.6739279995194,
                39.2615259992525,
                0
              ],
              [
                -76.6741620003833,
                39.2616409991547,
                0
              ],
              [
                -76.6754219997594,
                39.2623009987693,
                0
              ],
              [
                -76.6759819998001,
                39.262590999104,
                0
              ],
              [
                -76.6767769995066,
                39.2630039992031,
                0
              ],
              [
                -76.677191000219,
                39.2633049990269,
                0
              ],
              [
                -76.6772360000093,
                39.2633249989962,
                0
              ],
              [
                -76.6777739997988,
                39.2635559994511,
                0
              ],
              [
                -76.6788009998287,
                39.263996998972,
                0
              ],
              [
                -76.6800249998454,
                39.2644129986885,
                0
              ],
              [
                -76.6816439995376,
                39.2650319993858,
                0
              ],
              [
                -76.6822139995379,
                39.2652810002711,
                0
              ],
              [
                -76.6824739996366,
                39.2653949989717,
                0
              ],
              [
                -76.6827379996223,
                39.2655099987373,
                0
              ],
              [
                -76.6830660005245,
                39.2656539986986,
                0
              ],
              [
                -76.6835410003261,
                39.2658619995972,
                0
              ],
              [
                -76.6844490001908,
                39.2663819993175,
                0
              ],
              [
                -76.6845060000221,
                39.2664039986859,
                0
              ],
              [
                -76.6845190001475,
                39.26640899862,
                0
              ],
              [
                -76.6845479995102,
                39.2664199991817,
                0
              ],
              [
                -76.6846050003702,
                39.2664409986565,
                0
              ],
              [
                -76.6846490013066,
                39.2664579989344,
                0
              ],
              [
                -76.6846679996757,
                39.2664649993414,
                0
              ],
              [
                -76.6847150005286,
                39.2664869987815,
                0
              ],
              [
                -76.6851529995707,
                39.266696998825,
                0
              ],
              [
                -76.6855399998828,
                39.2667779992179,
                0
              ],
              [
                -76.6860480000366,
                39.2668849990356,
                0
              ],
              [
                -76.6869130002645,
                39.267361998973,
                0
              ],
              [
                -76.6872829995866,
                39.2674779987741,
                0
              ],
              [
                -76.6885899999581,
                39.268154998636,
                0
              ],
              [
                -76.6886339997531,
                39.2681779991893,
                0
              ],
              [
                -76.6886669998466,
                39.268194999407,
                0
              ],
              [
                -76.6898889997406,
                39.2687289991073,
                0
              ],
              [
                -76.6912170000586,
                39.2693099989868,
                0
              ],
              [
                -76.6918679994451,
                39.2695949987042,
                0
              ],
              [
                -76.6927240008017,
                39.2700129992697,
                0
              ],
              [
                -76.6933389998069,
                39.2703179988633,
                0
              ],
              [
                -76.6944859987486,
                39.2708139988997,
                0
              ],
              [
                -76.6956759988343,
                39.2712219991063,
                0
              ],
              [
                -76.6967929997871,
                39.2718609991237,
                0
              ],
              [
                -76.6973789996721,
                39.2721959986973,
                0
              ],
              [
                -76.6988919995722,
                39.2727049985923,
                0
              ],
              [
                -76.6974099993217,
                39.272385998801,
                0
              ],
              [
                -76.6959949994619,
                39.2720399993206,
                0
              ],
              [
                -76.6953709995709,
                39.2719099986683,
                0
              ],
              [
                -76.6950670002286,
                39.2718709994479,
                0
              ],
              [
                -76.6945259997108,
                39.2718409988836,
                0
              ],
              [
                -76.6934409999795,
                39.2718259989347,
                0
              ],
              [
                -76.69268000053,
                39.2718239993021,
                0
              ],
              [
                -76.6921459991761,
                39.2718389991546,
                0
              ],
              [
                -76.6914479999006,
                39.2718520003199,
                0
              ],
              [
                -76.6908979999612,
                39.2718879987753,
                0
              ],
              [
                -76.6900099999608,
                39.2720179992201,
                0
              ],
              [
                -76.6894539994848,
                39.2721159988598,
                0
              ],
              [
                -76.6881919999044,
                39.2745049986021,
                0
              ],
              [
                -76.685392000739,
                39.2755049993769,
                0
              ],
              [
                -76.6835810004618,
                39.276568998599,
                0
              ],
              [
                -76.6834029999239,
                39.2766859989116,
                0
              ],
              [
                -76.683300999448,
                39.2767709989857,
                0
              ],
              [
                -76.6832630005028,
                39.2768219994029,
                0
              ],
              [
                -76.6831910001212,
                39.2769469993052,
                0
              ],
              [
                -76.6831489996417,
                39.2770349993615,
                0
              ],
              [
                -76.6831130001796,
                39.2770959990648,
                0
              ],
              [
                -76.6830859997832,
                39.2771149989312,
                0
              ],
              [
                -76.6830300000065,
                39.2771269990882,
                0
              ],
              [
                -76.6829730001868,
                39.2771329992521,
                0
              ],
              [
                -76.6828280001486,
                39.2771340003666,
                0
              ],
              [
                -76.6826990004439,
                39.2771479992729,
                0
              ],
              [
                -76.6826020008742,
                39.2771709993474,
                0
              ],
              [
                -76.6824609995022,
                39.2772319987986,
                0
              ],
              [
                -76.6822930005173,
                39.2772669993528,
                0
              ],
              [
                -76.6821499998609,
                39.2772710000696,
                0
              ],
              [
                -76.6820710004659,
                39.277268999151,
                0
              ],
              [
                -76.6820140003845,
                39.2772519988163,
                0
              ],
              [
                -76.681986998959,
                39.2772439990154,
                0
              ],
              [
                -76.6818600004998,
                39.2771899985613,
                0
              ],
              [
                -76.6817089998941,
                39.2770560002878,
                0
              ],
              [
                -76.6816729999663,
                39.2769979990988,
                0
              ],
              [
                -76.6816029996571,
                39.2769379988232,
                0
              ],
              [
                -76.6815480001314,
                39.2769119987735,
                0
              ],
              [
                -76.6814239995283,
                39.2768969990187,
                0
              ],
              [
                -76.6812649995546,
                39.2768879987114,
                0
              ],
              [
                -76.6811369998658,
                39.2768999989267,
                0
              ],
              [
                -76.6810929999186,
                39.2769299991214,
                0
              ],
              [
                -76.6810260014066,
                39.2770239989783,
                0
              ],
              [
                -76.680987999192,
                39.2770559997976,
                0
              ],
              [
                -76.6809549995483,
                39.2770919991603,
                0
              ],
              [
                -76.6808939998207,
                39.2771299986999,
                0
              ],
              [
                -76.680858000499,
                39.2771559986428,
                0
              ],
              [
                -76.6808060008171,
                39.2771749994162,
                0
              ],
              [
                -76.680712000051,
                39.2771729991507,
                0
              ],
              [
                -76.68064099985,
                39.2771619987924,
                0
              ],
              [
                -76.6805800000603,
                39.2771319988101,
                0
              ],
              [
                -76.6805229998705,
                39.2771019988655,
                0
              ],
              [
                -76.6804190000734,
                39.2770759992108,
                0
              ],
              [
                -76.6802159996511,
                39.277098999801,
                0
              ],
              [
                -76.6801089998827,
                39.2771219994165,
                0
              ],
              [
                -76.6800429994633,
                39.2771469986221,
                0
              ],
              [
                -76.6799769998106,
                39.2771599978526,
                0
              ],
              [
                -76.6798890004758,
                39.2771699988077,
                0
              ],
              [
                -76.6797800005451,
                39.2771679992527,
                0
              ],
              [
                -76.6797030003388,
                39.2771549993936,
                0
              ],
              [
                -76.6795909986276,
                39.2771229988325,
                0
              ],
              [
                -76.6792409999992,
                39.2768679991543,
                0
              ],
              [
                -76.6791819997043,
                39.2768129987686,
                0
              ],
              [
                -76.67910899997,
                39.2767219990128,
                0
              ],
              [
                -76.6790189998563,
                39.2765999989889,
                0
              ],
              [
                -76.678963000289,
                39.2765329986386,
                0
              ],
              [
                -76.6788419993073,
                39.2764459992892,
                0
              ],
              [
                -76.6787030002866,
                39.2763699993192,
                0
              ],
              [
                -76.6785709994554,
                39.2762849990096,
                0
              ],
              [
                -76.6784630004598,
                39.2761989986567,
                0
              ],
              [
                -76.6782909999584,
                39.2759929991181,
                0
              ],
              [
                -76.678033000151,
                39.2757099988951,
                0
              ],
              [
                -76.6778610009841,
                39.2755409983802,
                0
              ],
              [
                -76.677252000541,
                39.274941998943,
                0
              ],
              [
                -76.6771329999519,
                39.2748269985896,
                0
              ],
              [
                -76.6770220002286,
                39.2747180002707,
                0
              ],
              [
                -76.6768829997225,
                39.2745869993672,
                0
              ],
              [
                -76.6766769998346,
                39.2743849986683,
                0
              ],
              [
                -76.6763869998662,
                39.2743189992303,
                0
              ],
              [
                -76.6761510002075,
                39.2741949992868,
                0
              ],
              [
                -76.6760180003743,
                39.2741409993125,
                0
              ],
              [
                -76.6759229986305,
                39.2741169994325,
                0
              ],
              [
                -76.6758109997655,
                39.2740999992227,
                0
              ],
              [
                -76.6757069999885,
                39.2741049986874,
                0
              ],
              [
                -76.6756109997823,
                39.2741229992357,
                0
              ],
              [
                -76.6755460004361,
                39.2741439993141,
                0
              ],
              [
                -76.6754819999856,
                39.2741829993433,
                0
              ],
              [
                -76.6754189995423,
                39.2742399993275,
                0
              ],
              [
                -76.6753339987304,
                39.2743429989325,
                0
              ],
              [
                -76.6752689994419,
                39.2744679990413,
                0
              ],
              [
                -76.6751930010888,
                39.2745999991406,
                0
              ],
              [
                -76.6751549996139,
                39.2746479992372,
                0
              ],
              [
                -76.6751060004781,
                39.2747249986565,
                0
              ],
              [
                -76.6750310005125,
                39.274814998875,
                0
              ],
              [
                -76.6749139998281,
                39.2749229989246,
                0
              ],
              [
                -76.6748309995374,
                39.274971999407,
                0
              ],
              [
                -76.674680000128,
                39.2750329988139,
                0
              ],
              [
                -76.674438000015,
                39.2751259994005,
                0
              ],
              [
                -76.6743300004303,
                39.2751579986091,
                0
              ],
              [
                -76.6742439998558,
                39.2751739990516,
                0
              ],
              [
                -76.6741689994748,
                39.2751839993471,
                0
              ],
              [
                -76.6740859986103,
                39.2751839987547,
                0
              ],
              [
                -76.673958999888,
                39.2751709977836,
                0
              ],
              [
                -76.6738169995004,
                39.275171997892,
                0
              ],
              [
                -76.6736379994863,
                39.2752089993628,
                0
              ],
              [
                -76.6732920001207,
                39.275337999358,
                0
              ],
              [
                -76.6731879987533,
                39.2753959992211,
                0
              ],
              [
                -76.6731170001204,
                39.2754589990975,
                0
              ],
              [
                -76.673096999869,
                39.2754769992042,
                0
              ],
              [
                -76.673029000464,
                39.275542998804,
                0
              ],
              [
                -76.6729310003732,
                39.2756339992399,
                0
              ],
              [
                -76.6728470001149,
                39.2756859986714,
                0
              ],
              [
                -76.6726709994928,
                39.2757549975772,
                0
              ],
              [
                -76.6725170003515,
                39.2757989992735,
                0
              ],
              [
                -76.6723999995287,
                39.2758189986834,
                0
              ],
              [
                -76.6720239997681,
                39.2758909984238,
                0
              ],
              [
                -76.6718709998513,
                39.2759129982552,
                0
              ],
              [
                -76.6717109997818,
                39.2759260004293,
                0
              ],
              [
                -76.6715630003993,
                39.2759329990384,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 83,
          "Census_Tract": "24510250203",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "23865d09-ae7e-4297-b4a8-f97edc1b6ead",
          "Shape__Area": 10007612.323364258,
          "Shape__Length": 16087.656355057235
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6153189165405,
                39.2411448760821,
                0
              ],
              [
                -76.6157559993788,
                39.2411799991229,
                0
              ],
              [
                -76.6163849994973,
                39.2412350000466,
                0
              ],
              [
                -76.6173740004186,
                39.2413299993166,
                0
              ],
              [
                -76.6183399997882,
                39.2414249992379,
                0
              ],
              [
                -76.6193069995342,
                39.2415129990425,
                0
              ],
              [
                -76.6202639994267,
                39.2415939991562,
                0
              ],
              [
                -76.6212209999201,
                39.2416639993334,
                0
              ],
              [
                -76.6217210011725,
                39.2417019991435,
                0
              ],
              [
                -76.6214889999602,
                39.2419059987508,
                0
              ],
              [
                -76.6211880002992,
                39.242345999246,
                0
              ],
              [
                -76.6198119998703,
                39.2441439991455,
                0
              ],
              [
                -76.6194959999531,
                39.2445929992675,
                0
              ],
              [
                -76.6192009994349,
                39.2450849991962,
                0
              ],
              [
                -76.618824000385,
                39.2457499991639,
                0
              ],
              [
                -76.6200949998811,
                39.2463299992599,
                0
              ],
              [
                -76.6208869988699,
                39.2467609987094,
                0
              ],
              [
                -76.6212349999912,
                39.2469680004168,
                0
              ],
              [
                -76.6216150002317,
                39.2471929989288,
                0
              ],
              [
                -76.621973999614,
                39.2474399992647,
                0
              ],
              [
                -76.6224679998893,
                39.2477799985976,
                0
              ],
              [
                -76.6225809985839,
                39.2478669989572,
                0
              ],
              [
                -76.622723999741,
                39.2479610000287,
                0
              ],
              [
                -76.6229500003341,
                39.2480999997872,
                0
              ],
              [
                -76.6230010000803,
                39.2481309987506,
                0
              ],
              [
                -76.623205998465,
                39.248238998995,
                0
              ],
              [
                -76.6233589995288,
                39.2483079989494,
                0
              ],
              [
                -76.6236189994672,
                39.2484209994242,
                0
              ],
              [
                -76.6238570002401,
                39.2485169988529,
                0
              ],
              [
                -76.6240150000851,
                39.2485880001572,
                0
              ],
              [
                -76.6241200000725,
                39.2486279990986,
                0
              ],
              [
                -76.6243030000422,
                39.2486999988329,
                0
              ],
              [
                -76.6244239999785,
                39.2487440003789,
                0
              ],
              [
                -76.6245270006285,
                39.2487719987961,
                0
              ],
              [
                -76.6247099994667,
                39.248814999378,
                0
              ],
              [
                -76.6247859993643,
                39.2488339990319,
                0
              ],
              [
                -76.6248889994819,
                39.2488649993967,
                0
              ],
              [
                -76.6251009995955,
                39.2489559986035,
                0
              ],
              [
                -76.6253979998937,
                39.249081998765,
                0
              ],
              [
                -76.6252729994578,
                39.2490669992821,
                0
              ],
              [
                -76.6252080002347,
                39.2490659991302,
                0
              ],
              [
                -76.6251429998202,
                39.2490739994378,
                0
              ],
              [
                -76.6250430002717,
                39.2491029993,
                0
              ],
              [
                -76.6249569999461,
                39.2491319996585,
                0
              ],
              [
                -76.6248090003206,
                39.2491979991639,
                0
              ],
              [
                -76.6245419998347,
                39.2493229985859,
                0
              ],
              [
                -76.6236389998159,
                39.2497119993415,
                0
              ],
              [
                -76.6232440004954,
                39.2498819986715,
                0
              ],
              [
                -76.6226389994629,
                39.2501409989979,
                0
              ],
              [
                -76.6223870002575,
                39.2502489991477,
                0
              ],
              [
                -76.6220680004531,
                39.2503859977909,
                0
              ],
              [
                -76.6220010005565,
                39.2504149985914,
                0
              ],
              [
                -76.6208809995654,
                39.2508949993091,
                0
              ],
              [
                -76.6204980001668,
                39.2510579994227,
                0
              ],
              [
                -76.6200840000447,
                39.2512339987798,
                0
              ],
              [
                -76.6197689994268,
                39.2513699988475,
                0
              ],
              [
                -76.6184360005584,
                39.2519459992222,
                0
              ],
              [
                -76.6173490001939,
                39.2524119989014,
                0
              ],
              [
                -76.6174209996742,
                39.2524839987722,
                0
              ],
              [
                -76.6175040005235,
                39.2525979986065,
                0
              ],
              [
                -76.6175999996056,
                39.252737999099,
                0
              ],
              [
                -76.6176609996169,
                39.2528339991337,
                0
              ],
              [
                -76.6177140003944,
                39.2529339986299,
                0
              ],
              [
                -76.6177659997583,
                39.2530439987884,
                0
              ],
              [
                -76.6178100000071,
                39.253146999123,
                0
              ],
              [
                -76.6178399997884,
                39.2532459985899,
                0
              ],
              [
                -76.6178699995089,
                39.2533729993741,
                0
              ],
              [
                -76.6179150004702,
                39.2535309994096,
                0
              ],
              [
                -76.617922999642,
                39.2536959987033,
                0
              ],
              [
                -76.617912000109,
                39.2538939989141,
                0
              ],
              [
                -76.6178909997628,
                39.2540129988022,
                0
              ],
              [
                -76.6178620002211,
                39.2541539991668,
                0
              ],
              [
                -76.6178160005684,
                39.2543259991151,
                0
              ],
              [
                -76.6177749998474,
                39.2544549999659,
                0
              ],
              [
                -76.6177180004659,
                39.2546049987922,
                0
              ],
              [
                -76.6176489995647,
                39.2547649993812,
                0
              ],
              [
                -76.6175870003293,
                39.2549149989656,
                0
              ],
              [
                -76.6175119994591,
                39.2550659992504,
                0
              ],
              [
                -76.6174299998818,
                39.2552129988819,
                0
              ],
              [
                -76.6173280003195,
                39.2553689986136,
                0
              ],
              [
                -76.617230999517,
                39.255512999186,
                0
              ],
              [
                -76.6171430003222,
                39.2556269991817,
                0
              ],
              [
                -76.6169340003562,
                39.2560129997075,
                0
              ],
              [
                -76.6169099369079,
                39.2560634849732,
                0
              ],
              [
                -76.6154556268025,
                39.2555065164109,
                0
              ],
              [
                -76.6149978634585,
                39.2544116984261,
                0
              ],
              [
                -76.6136341101174,
                39.2533092498358,
                0
              ],
              [
                -76.6116638177834,
                39.249986648142,
                0
              ],
              [
                -76.6118831635778,
                39.2486591342982,
                0
              ],
              [
                -76.6115341186942,
                39.2479953770621,
                0
              ],
              [
                -76.6129989623518,
                39.2471294407591,
                0
              ],
              [
                -76.6135292047265,
                39.2463932041262,
                0
              ],
              [
                -76.6153189165405,
                39.2411448760821,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 84,
          "Census_Tract": "24510150200",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "57870279-c60a-4715-a013-06f224d8473a",
          "Shape__Area": 4524137.291381836,
          "Shape__Length": 9122.552539234157
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6446430000691,
                39.3031759994514,
                0
              ],
              [
                -76.6453880000429,
                39.3031339988022,
                0
              ],
              [
                -76.6459859989987,
                39.3031149990888,
                0
              ],
              [
                -76.6460269996713,
                39.3031139993706,
                0
              ],
              [
                -76.6461180012849,
                39.303111999075,
                0
              ],
              [
                -76.6466870002697,
                39.303093000327,
                0
              ],
              [
                -76.6467800007437,
                39.3030939987395,
                0
              ],
              [
                -76.6473139996532,
                39.3030900001054,
                0
              ],
              [
                -76.6477869998294,
                39.3030619993398,
                0
              ],
              [
                -76.6477590002897,
                39.3027639977618,
                0
              ],
              [
                -76.6477170012986,
                39.3023049990689,
                0
              ],
              [
                -76.6481329996261,
                39.3026449990099,
                0
              ],
              [
                -76.6483529997836,
                39.3027969998528,
                0
              ],
              [
                -76.6484830003275,
                39.3028629989651,
                0
              ],
              [
                -76.6486499994657,
                39.3029169988167,
                0
              ],
              [
                -76.6490609999927,
                39.3029869988565,
                0
              ],
              [
                -76.6492930012554,
                39.3030269987146,
                0
              ],
              [
                -76.6498409996483,
                39.3031019986972,
                0
              ],
              [
                -76.6501029994714,
                39.3031500003824,
                0
              ],
              [
                -76.6503980000016,
                39.3031989986286,
                0
              ],
              [
                -76.6507519995648,
                39.3032479985667,
                0
              ],
              [
                -76.6516069996175,
                39.3033499990853,
                0
              ],
              [
                -76.6516569999517,
                39.3034699991025,
                0
              ],
              [
                -76.6516750001101,
                39.303530999356,
                0
              ],
              [
                -76.6516849995629,
                39.3036039991674,
                0
              ],
              [
                -76.6516870004411,
                39.3037319987883,
                0
              ],
              [
                -76.6517059998348,
                39.3040569988664,
                0
              ],
              [
                -76.6517200000061,
                39.3046369985896,
                0
              ],
              [
                -76.6517150013252,
                39.3050929989583,
                0
              ],
              [
                -76.651048001473,
                39.3051149990292,
                0
              ],
              [
                -76.6510660001177,
                39.305792999113,
                0
              ],
              [
                -76.6511060000229,
                39.3065139988354,
                0
              ],
              [
                -76.6511779995419,
                39.307402999344,
                0
              ],
              [
                -76.6511909995021,
                39.3077659985596,
                0
              ],
              [
                -76.6512590007134,
                39.3086939993485,
                0
              ],
              [
                -76.651338999837,
                39.3096799989133,
                0
              ],
              [
                -76.6499209992209,
                39.3097299994129,
                0
              ],
              [
                -76.6490469998074,
                39.3097649979645,
                0
              ],
              [
                -76.6481800009228,
                39.3098129989421,
                0
              ],
              [
                -76.6473410002343,
                39.3098539994327,
                0
              ],
              [
                -76.6465180004457,
                39.3098889989128,
                0
              ],
              [
                -76.6464959999171,
                39.3098899992236,
                0
              ],
              [
                -76.6464009994625,
                39.3098929993475,
                0
              ],
              [
                -76.6463890010503,
                39.3098929992729,
                0
              ],
              [
                -76.6457129999426,
                39.3099169994032,
                0
              ],
              [
                -76.6450060005635,
                39.3099439987967,
                0
              ],
              [
                -76.6449460004572,
                39.3088929991181,
                0
              ],
              [
                -76.6449129998661,
                39.3080059989972,
                0
              ],
              [
                -76.644886001393,
                39.3076180004172,
                0
              ],
              [
                -76.6448720003777,
                39.3073749985575,
                0
              ],
              [
                -76.6448450011869,
                39.3069149989869,
                0
              ],
              [
                -76.6448389999231,
                39.306726998799,
                0
              ],
              [
                -76.6448059999387,
                39.3062889990353,
                0
              ],
              [
                -76.6447970000171,
                39.3057739986769,
                0
              ],
              [
                -76.6447690000003,
                39.3053519986841,
                0
              ],
              [
                -76.6447310001812,
                39.3048369987717,
                0
              ],
              [
                -76.6446940002428,
                39.3042629987234,
                0
              ],
              [
                -76.6446900004014,
                39.3041069992517,
                0
              ],
              [
                -76.6446800003781,
                39.3039269990199,
                0
              ],
              [
                -76.64467100153,
                39.3037049986845,
                0
              ],
              [
                -76.6446430000691,
                39.3031759994514,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 85,
          "Census_Tract": "24510150300",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "60ef1d45-587d-43c5-83e5-0f65ab6784c7",
          "Shape__Area": 4296435.97857666,
          "Shape__Length": 8528.23323745828
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6516069996175,
                39.3033499990853,
                0
              ],
              [
                -76.652742000331,
                39.3036189988123,
                0
              ],
              [
                -76.6533160001969,
                39.3037779989458,
                0
              ],
              [
                -76.6537880002363,
                39.3039089993536,
                0
              ],
              [
                -76.6556660001582,
                39.3045039987414,
                0
              ],
              [
                -76.6569370003068,
                39.3049250000404,
                0
              ],
              [
                -76.6570190009337,
                39.304952998875,
                0
              ],
              [
                -76.6573779997693,
                39.3050949989783,
                0
              ],
              [
                -76.6576639988161,
                39.305223999109,
                0
              ],
              [
                -76.6579360000665,
                39.3053719988338,
                0
              ],
              [
                -76.6583539995272,
                39.3056579992096,
                0
              ],
              [
                -76.6584180000994,
                39.3057069989502,
                0
              ],
              [
                -76.6585000003543,
                39.3057649999618,
                0
              ],
              [
                -76.6585840001564,
                39.305832998791,
                0
              ],
              [
                -76.6588670015633,
                39.3060689986335,
                0
              ],
              [
                -76.659037999989,
                39.3062520003336,
                0
              ],
              [
                -76.6592919998088,
                39.3065179992391,
                0
              ],
              [
                -76.6595359991718,
                39.3068899990365,
                0
              ],
              [
                -76.6596649998602,
                39.3071269989677,
                0
              ],
              [
                -76.6597509993205,
                39.3073159991707,
                0
              ],
              [
                -76.6598000005118,
                39.3074069991761,
                0
              ],
              [
                -76.6598729997223,
                39.3075960003658,
                0
              ],
              [
                -76.6599309990783,
                39.3077799994406,
                0
              ],
              [
                -76.659969000041,
                39.3079439997256,
                0
              ],
              [
                -76.6599850001213,
                39.3080579985549,
                0
              ],
              [
                -76.6600150002784,
                39.3083309992578,
                0
              ],
              [
                -76.6600259994317,
                39.3086699990049,
                0
              ],
              [
                -76.660007999124,
                39.3090529985807,
                0
              ],
              [
                -76.6599850002943,
                39.3093679993008,
                0
              ],
              [
                -76.6596430004002,
                39.3093699988271,
                0
              ],
              [
                -76.6595660000455,
                39.309371999737,
                0
              ],
              [
                -76.6594869995863,
                39.3093739993046,
                0
              ],
              [
                -76.6593970002837,
                39.309375997565,
                0
              ],
              [
                -76.6591309998694,
                39.309383998697,
                0
              ],
              [
                -76.658180000366,
                39.3094309992366,
                0
              ],
              [
                -76.6580739985512,
                39.3094349991475,
                0
              ],
              [
                -76.6571959993379,
                39.3094669994024,
                0
              ],
              [
                -76.6559940004393,
                39.3095079992757,
                0
              ],
              [
                -76.6556789995249,
                39.3095149988277,
                0
              ],
              [
                -76.6551340005062,
                39.309533998169,
                0
              ],
              [
                -76.6548769988781,
                39.3095369988872,
                0
              ],
              [
                -76.6541299994492,
                39.3095669991333,
                0
              ],
              [
                -76.6527119984684,
                39.3096129988257,
                0
              ],
              [
                -76.651338999837,
                39.3096799989133,
                0
              ],
              [
                -76.6512590007134,
                39.3086939993485,
                0
              ],
              [
                -76.6511909995021,
                39.3077659985596,
                0
              ],
              [
                -76.6511779995419,
                39.307402999344,
                0
              ],
              [
                -76.6511060000229,
                39.3065139988354,
                0
              ],
              [
                -76.6510660001177,
                39.305792999113,
                0
              ],
              [
                -76.651048001473,
                39.3051149990292,
                0
              ],
              [
                -76.6517150013252,
                39.3050929989583,
                0
              ],
              [
                -76.6517200000061,
                39.3046369985896,
                0
              ],
              [
                -76.6517059998348,
                39.3040569988664,
                0
              ],
              [
                -76.6516870004411,
                39.3037319987883,
                0
              ],
              [
                -76.6516849995629,
                39.3036039991674,
                0
              ],
              [
                -76.6516750001101,
                39.303530999356,
                0
              ],
              [
                -76.6516569999517,
                39.3034699991025,
                0
              ],
              [
                -76.6516069996175,
                39.3033499990853,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 86,
          "Census_Tract": "24510150400",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "31210b58-5488-4873-a4d7-49b8d477baa9",
          "Shape__Area": 8778375.651489258,
          "Shape__Length": 13230.470085566745
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6463159999163,
                39.3132479992724,
                0
              ],
              [
                -76.6458760001665,
                39.3128979991386,
                0
              ],
              [
                -76.6454080000283,
                39.3125149993121,
                0
              ],
              [
                -76.64396400004,
                39.3112929988719,
                0
              ],
              [
                -76.643510000215,
                39.3108999992601,
                0
              ],
              [
                -76.6433710001247,
                39.3107799988849,
                0
              ],
              [
                -76.6425140003439,
                39.310088999422,
                0
              ],
              [
                -76.6437200004107,
                39.3100239994145,
                0
              ],
              [
                -76.6442389998035,
                39.3099969990098,
                0
              ],
              [
                -76.644379000322,
                39.3099849986792,
                0
              ],
              [
                -76.6450060005635,
                39.3099439987967,
                0
              ],
              [
                -76.6457129999426,
                39.3099169994032,
                0
              ],
              [
                -76.6463890010503,
                39.3098929992729,
                0
              ],
              [
                -76.6464009994625,
                39.3098929993475,
                0
              ],
              [
                -76.6464959999171,
                39.3098899992236,
                0
              ],
              [
                -76.6465180004457,
                39.3098889989128,
                0
              ],
              [
                -76.6473410002343,
                39.3098539994327,
                0
              ],
              [
                -76.6481800009228,
                39.3098129989421,
                0
              ],
              [
                -76.6490469998074,
                39.3097649979645,
                0
              ],
              [
                -76.6499209992209,
                39.3097299994129,
                0
              ],
              [
                -76.651338999837,
                39.3096799989133,
                0
              ],
              [
                -76.6527119984684,
                39.3096129988257,
                0
              ],
              [
                -76.6541299994492,
                39.3095669991333,
                0
              ],
              [
                -76.6548769988781,
                39.3095369988872,
                0
              ],
              [
                -76.6551340005062,
                39.309533998169,
                0
              ],
              [
                -76.6556789995249,
                39.3095149988277,
                0
              ],
              [
                -76.6559940004393,
                39.3095079992757,
                0
              ],
              [
                -76.6571959993379,
                39.3094669994024,
                0
              ],
              [
                -76.6580739985512,
                39.3094349991475,
                0
              ],
              [
                -76.658180000366,
                39.3094309992366,
                0
              ],
              [
                -76.6591309998694,
                39.309383998697,
                0
              ],
              [
                -76.6593970002837,
                39.309375997565,
                0
              ],
              [
                -76.6594869995863,
                39.3093739993046,
                0
              ],
              [
                -76.6595660000455,
                39.309371999737,
                0
              ],
              [
                -76.6596430004002,
                39.3093699988271,
                0
              ],
              [
                -76.6599850002943,
                39.3093679993008,
                0
              ],
              [
                -76.6599349996991,
                39.3099079993236,
                0
              ],
              [
                -76.6599160001749,
                39.3102399988233,
                0
              ],
              [
                -76.6599070004658,
                39.3104219987295,
                0
              ],
              [
                -76.6598139998224,
                39.3115279989352,
                0
              ],
              [
                -76.6597909995834,
                39.3118049993342,
                0
              ],
              [
                -76.6597769998219,
                39.3119339988058,
                0
              ],
              [
                -76.6597020004904,
                39.3129029992895,
                0
              ],
              [
                -76.6596500000077,
                39.3136349989402,
                0
              ],
              [
                -76.6596339986525,
                39.3142639999185,
                0
              ],
              [
                -76.6596250003835,
                39.3144509987598,
                0
              ],
              [
                -76.6596510014863,
                39.3146799983255,
                0
              ],
              [
                -76.659672999804,
                39.3148519993215,
                0
              ],
              [
                -76.6596930000316,
                39.3149389986914,
                0
              ],
              [
                -76.6597109984856,
                39.315013998751,
                0
              ],
              [
                -76.659778999525,
                39.3152239996006,
                0
              ],
              [
                -76.6589309984907,
                39.3154859986327,
                0
              ],
              [
                -76.6587589996347,
                39.31553499923,
                0
              ],
              [
                -76.6586360008492,
                39.3155719988857,
                0
              ],
              [
                -76.6582379998827,
                39.3156909987818,
                0
              ],
              [
                -76.6579120002911,
                39.315769999193,
                0
              ],
              [
                -76.6577009997985,
                39.315811999362,
                0
              ],
              [
                -76.6576069990603,
                39.3158239991717,
                0
              ],
              [
                -76.6575070007099,
                39.3158369992768,
                0
              ],
              [
                -76.6572880005798,
                39.315856998856,
                0
              ],
              [
                -76.6570939995406,
                39.3158669987698,
                0
              ],
              [
                -76.6569180010925,
                39.3158709987708,
                0
              ],
              [
                -76.6567189995219,
                39.3158709986369,
                0
              ],
              [
                -76.6563940011519,
                39.3158569987734,
                0
              ],
              [
                -76.6559940000965,
                39.3158079995693,
                0
              ],
              [
                -76.655739999505,
                39.3157649988282,
                0
              ],
              [
                -76.6555510002993,
                39.315724999317,
                0
              ],
              [
                -76.6553089999129,
                39.315659998627,
                0
              ],
              [
                -76.655130000478,
                39.315608998962,
                0
              ],
              [
                -76.654947999618,
                39.3155609987209,
                0
              ],
              [
                -76.6548510004004,
                39.3155359999577,
                0
              ],
              [
                -76.6546320004318,
                39.315496000023,
                0
              ],
              [
                -76.6544150005219,
                39.315457998924,
                0
              ],
              [
                -76.6541960002602,
                39.3154309987234,
                0
              ],
              [
                -76.6540459994447,
                39.3154249987105,
                0
              ],
              [
                -76.6540080004546,
                39.3154229988679,
                0
              ],
              [
                -76.6538259998751,
                39.3154169989381,
                0
              ],
              [
                -76.6536570004703,
                39.3154160001847,
                0
              ],
              [
                -76.6536230015587,
                39.3154159999653,
                0
              ],
              [
                -76.6533690004778,
                39.3154279993925,
                0
              ],
              [
                -76.6531409995889,
                39.3154439986875,
                0
              ],
              [
                -76.6529049999423,
                39.315472998787,
                0
              ],
              [
                -76.6526739997986,
                39.3155169998968,
                0
              ],
              [
                -76.6524530004749,
                39.3155709987485,
                0
              ],
              [
                -76.6522359999716,
                39.3156389985935,
                0
              ],
              [
                -76.651958000113,
                39.3157459992013,
                0
              ],
              [
                -76.6512070011037,
                39.3161589994088,
                0
              ],
              [
                -76.6504940003019,
                39.316704000346,
                0
              ],
              [
                -76.6498980005638,
                39.3162039990257,
                0
              ],
              [
                -76.6497839995271,
                39.3161119988635,
                0
              ],
              [
                -76.6493350008618,
                39.3157219990991,
                0
              ],
              [
                -76.6491150005025,
                39.3155429989784,
                0
              ],
              [
                -76.6487249995848,
                39.3152249997972,
                0
              ],
              [
                -76.6481900000718,
                39.3147699986647,
                0
              ],
              [
                -76.6476289995612,
                39.314314999022,
                0
              ],
              [
                -76.6469240004797,
                39.3137219993506,
                0
              ],
              [
                -76.6467750004603,
                39.3135959993038,
                0
              ],
              [
                -76.6466460005071,
                39.3134979987428,
                0
              ],
              [
                -76.6463159999163,
                39.3132479992724,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 87,
          "Census_Tract": "24510150500",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "7ff95eff-48c4-4bf0-96ff-c3572f9ebb47",
          "Shape__Area": 10441819.502380371,
          "Shape__Length": 13888.259117974814
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6575280001275,
                39.3254529990482,
                0
              ],
              [
                -76.6574769994664,
                39.3253729990499,
                0
              ],
              [
                -76.6573630003901,
                39.3252159986284,
                0
              ],
              [
                -76.6572340004896,
                39.3250179990886,
                0
              ],
              [
                -76.6571050000956,
                39.3247849989865,
                0
              ],
              [
                -76.6568439986045,
                39.3244379992197,
                0
              ],
              [
                -76.6562230002045,
                39.3236239987113,
                0
              ],
              [
                -76.6555399990679,
                39.3227129986028,
                0
              ],
              [
                -76.6552669985924,
                39.3223339985962,
                0
              ],
              [
                -76.6549120007336,
                39.3218530003586,
                0
              ],
              [
                -76.6548810005591,
                39.3218099994082,
                0
              ],
              [
                -76.6542889999198,
                39.3209719986844,
                0
              ],
              [
                -76.6536160003731,
                39.3200599998758,
                0
              ],
              [
                -76.6524769992528,
                39.3185489987076,
                0
              ],
              [
                -76.6523970010225,
                39.3184559991897,
                0
              ],
              [
                -76.6522690000409,
                39.318310998657,
                0
              ],
              [
                -76.6521550004614,
                39.318185000228,
                0
              ],
              [
                -76.6520139995523,
                39.3180499988953,
                0
              ],
              [
                -76.6518490012639,
                39.3179089993572,
                0
              ],
              [
                -76.6516499997944,
                39.3177479994012,
                0
              ],
              [
                -76.6514479998018,
                39.3175809993082,
                0
              ],
              [
                -76.6512749997346,
                39.3174079994353,
                0
              ],
              [
                -76.6512160000167,
                39.3173449987499,
                0
              ],
              [
                -76.6511619999394,
                39.3172679989843,
                0
              ],
              [
                -76.6511369997504,
                39.3172189986641,
                0
              ],
              [
                -76.6506169997335,
                39.3168149990775,
                0
              ],
              [
                -76.650596000157,
                39.3167959992466,
                0
              ],
              [
                -76.6504940003019,
                39.316704000346,
                0
              ],
              [
                -76.6512070011037,
                39.3161589994088,
                0
              ],
              [
                -76.651958000113,
                39.3157459992013,
                0
              ],
              [
                -76.6522359999716,
                39.3156389985935,
                0
              ],
              [
                -76.6524530004749,
                39.3155709987485,
                0
              ],
              [
                -76.6526739997986,
                39.3155169998968,
                0
              ],
              [
                -76.6529049999423,
                39.315472998787,
                0
              ],
              [
                -76.6531409995889,
                39.3154439986875,
                0
              ],
              [
                -76.6533690004778,
                39.3154279993925,
                0
              ],
              [
                -76.6536230015587,
                39.3154159999653,
                0
              ],
              [
                -76.6536570004703,
                39.3154160001847,
                0
              ],
              [
                -76.6538259998751,
                39.3154169989381,
                0
              ],
              [
                -76.6540080004546,
                39.3154229988679,
                0
              ],
              [
                -76.6540459994447,
                39.3154249987105,
                0
              ],
              [
                -76.6541960002602,
                39.3154309987234,
                0
              ],
              [
                -76.6544150005219,
                39.315457998924,
                0
              ],
              [
                -76.6546320004318,
                39.315496000023,
                0
              ],
              [
                -76.6548510004004,
                39.3155359999577,
                0
              ],
              [
                -76.654947999618,
                39.3155609987209,
                0
              ],
              [
                -76.655130000478,
                39.315608998962,
                0
              ],
              [
                -76.6553089999129,
                39.315659998627,
                0
              ],
              [
                -76.6555510002993,
                39.315724999317,
                0
              ],
              [
                -76.655739999505,
                39.3157649988282,
                0
              ],
              [
                -76.6559940000965,
                39.3158079995693,
                0
              ],
              [
                -76.6563940011519,
                39.3158569987734,
                0
              ],
              [
                -76.6567189995219,
                39.3158709986369,
                0
              ],
              [
                -76.6569180010925,
                39.3158709987708,
                0
              ],
              [
                -76.6570939995406,
                39.3158669987698,
                0
              ],
              [
                -76.6572880005798,
                39.315856998856,
                0
              ],
              [
                -76.6575070007099,
                39.3158369992768,
                0
              ],
              [
                -76.6576069990603,
                39.3158239991717,
                0
              ],
              [
                -76.6577009997985,
                39.315811999362,
                0
              ],
              [
                -76.6579120002911,
                39.315769999193,
                0
              ],
              [
                -76.6582379998827,
                39.3156909987818,
                0
              ],
              [
                -76.6586360008492,
                39.3155719988857,
                0
              ],
              [
                -76.6587589996347,
                39.31553499923,
                0
              ],
              [
                -76.6589309984907,
                39.3154859986327,
                0
              ],
              [
                -76.659778999525,
                39.3152239996006,
                0
              ],
              [
                -76.6598520003609,
                39.3154019985554,
                0
              ],
              [
                -76.6603670002275,
                39.3162529992809,
                0
              ],
              [
                -76.6604580000692,
                39.316379998834,
                0
              ],
              [
                -76.6608010005226,
                39.3167479976874,
                0
              ],
              [
                -76.661094000994,
                39.3170669990803,
                0
              ],
              [
                -76.6611870000371,
                39.3171689989481,
                0
              ],
              [
                -76.6615000001831,
                39.3174979994219,
                0
              ],
              [
                -76.6624770003881,
                39.318476998876,
                0
              ],
              [
                -76.6631959998284,
                39.3191899986977,
                0
              ],
              [
                -76.6638269994312,
                39.3198239986658,
                0
              ],
              [
                -76.6640590007069,
                39.3200810002176,
                0
              ],
              [
                -76.6642170000232,
                39.3202889989577,
                0
              ],
              [
                -76.6643100010679,
                39.3204489991282,
                0
              ],
              [
                -76.6644119998359,
                39.3206270002736,
                0
              ],
              [
                -76.6645000004909,
                39.3208079986897,
                0
              ],
              [
                -76.6646109999996,
                39.3210799987581,
                0
              ],
              [
                -76.6647030004995,
                39.3214259987322,
                0
              ],
              [
                -76.6647560000284,
                39.3216999976293,
                0
              ],
              [
                -76.6647699997459,
                39.3219599992922,
                0
              ],
              [
                -76.6647730013058,
                39.3220739986061,
                0
              ],
              [
                -76.6647760000182,
                39.3221939987005,
                0
              ],
              [
                -76.6647790002638,
                39.3223489992156,
                0
              ],
              [
                -76.6647679997736,
                39.3224749997967,
                0
              ],
              [
                -76.664727998457,
                39.3227069988985,
                0
              ],
              [
                -76.6645150004148,
                39.3237899986888,
                0
              ],
              [
                -76.6642540004288,
                39.3252799990478,
                0
              ],
              [
                -76.6641839989918,
                39.3256909988994,
                0
              ],
              [
                -76.6641399995958,
                39.3259719985839,
                0
              ],
              [
                -76.6641389994133,
                39.32624899928,
                0
              ],
              [
                -76.6641350000052,
                39.3264439989666,
                0
              ],
              [
                -76.6641499998716,
                39.3266029986796,
                0
              ],
              [
                -76.6641709999324,
                39.3267789991341,
                0
              ],
              [
                -76.6641909996891,
                39.3269859977665,
                0
              ],
              [
                -76.6642210002834,
                39.3271449988644,
                0
              ],
              [
                -76.6643019996071,
                39.3275119986251,
                0
              ],
              [
                -76.6639680003203,
                39.3274249993877,
                0
              ],
              [
                -76.6638390005572,
                39.3273919991251,
                0
              ],
              [
                -76.663331001549,
                39.3272609986802,
                0
              ],
              [
                -76.6615939996374,
                39.3269139991785,
                0
              ],
              [
                -76.6607479996623,
                39.3266819993166,
                0
              ],
              [
                -76.6597950002812,
                39.3266219986613,
                0
              ],
              [
                -76.6588670009304,
                39.3270679987987,
                0
              ],
              [
                -76.6586839987074,
                39.3267739992085,
                0
              ],
              [
                -76.65853100034,
                39.3265559979522,
                0
              ],
              [
                -76.6583880001776,
                39.3263759992955,
                0
              ],
              [
                -76.6582810005287,
                39.326222998773,
                0
              ],
              [
                -76.6582090007733,
                39.3261829988574,
                0
              ],
              [
                -76.6581620003036,
                39.3261329994342,
                0
              ],
              [
                -76.65805799854,
                39.326003998854,
                0
              ],
              [
                -76.6578420000255,
                39.3257130004162,
                0
              ],
              [
                -76.6577089990969,
                39.3255579987411,
                0
              ],
              [
                -76.6575939996963,
                39.3253999994136,
                0
              ],
              [
                -76.6575280001275,
                39.3254529990482,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 88,
          "Census_Tract": "24510150600",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "dad32a9d-3820-4e03-b5bc-c2977efb085a",
          "Shape__Area": 10322468.85736084,
          "Shape__Length": 18381.628956526714
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6599850002943,
                39.3093679993008,
                0
              ],
              [
                -76.660007999124,
                39.3090529985807,
                0
              ],
              [
                -76.6600259994317,
                39.3086699990049,
                0
              ],
              [
                -76.6600150002784,
                39.3083309992578,
                0
              ],
              [
                -76.6599850001213,
                39.3080579985549,
                0
              ],
              [
                -76.659969000041,
                39.3079439997256,
                0
              ],
              [
                -76.6599309990783,
                39.3077799994406,
                0
              ],
              [
                -76.6598729997223,
                39.3075960003658,
                0
              ],
              [
                -76.6598000005118,
                39.3074069991761,
                0
              ],
              [
                -76.6597509993205,
                39.3073159991707,
                0
              ],
              [
                -76.6596649998602,
                39.3071269989677,
                0
              ],
              [
                -76.6595359991718,
                39.3068899990365,
                0
              ],
              [
                -76.6592919998088,
                39.3065179992391,
                0
              ],
              [
                -76.659037999989,
                39.3062520003336,
                0
              ],
              [
                -76.6592039992176,
                39.3062379977687,
                0
              ],
              [
                -76.6601710004467,
                39.3061839986105,
                0
              ],
              [
                -76.6608980010421,
                39.3061439994399,
                0
              ],
              [
                -76.6620909991222,
                39.3061059988253,
                0
              ],
              [
                -76.6630830001739,
                39.3060749997139,
                0
              ],
              [
                -76.6638250000986,
                39.3060429989207,
                0
              ],
              [
                -76.6645389998322,
                39.3060289988473,
                0
              ],
              [
                -76.6655949996012,
                39.3059599989849,
                0
              ],
              [
                -76.666483999668,
                39.3059249984152,
                0
              ],
              [
                -76.6673239996393,
                39.3059039987431,
                0
              ],
              [
                -76.6674089998483,
                39.3060739990349,
                0
              ],
              [
                -76.6675189995916,
                39.3062310000573,
                0
              ],
              [
                -76.6676039995123,
                39.3063299991761,
                0
              ],
              [
                -76.6677900001711,
                39.3065299979929,
                0
              ],
              [
                -76.6684050014106,
                39.3071169988443,
                0
              ],
              [
                -76.6692050012912,
                39.3070959989159,
                0
              ],
              [
                -76.6708299994622,
                39.3070569991184,
                0
              ],
              [
                -76.6721920005059,
                39.3070179991938,
                0
              ],
              [
                -76.6722909992221,
                39.3072049996993,
                0
              ],
              [
                -76.6733030000276,
                39.3067420002763,
                0
              ],
              [
                -76.6736120005525,
                39.3065739992311,
                0
              ],
              [
                -76.6737199998469,
                39.3065169986342,
                0
              ],
              [
                -76.6739540003218,
                39.3063719990209,
                0
              ],
              [
                -76.6741229993262,
                39.3062679993366,
                0
              ],
              [
                -76.6743440003263,
                39.3062099990998,
                0
              ],
              [
                -76.6752319994901,
                39.3059769988962,
                0
              ],
              [
                -76.675353999341,
                39.3059459988093,
                0
              ],
              [
                -76.6754700001121,
                39.3059319990637,
                0
              ],
              [
                -76.6755930000787,
                39.30593299896,
                0
              ],
              [
                -76.6757029990397,
                39.305945998716,
                0
              ],
              [
                -76.6757959995433,
                39.3059739985581,
                0
              ],
              [
                -76.6759530002675,
                39.3061009992104,
                0
              ],
              [
                -76.6760910008053,
                39.3062769987032,
                0
              ],
              [
                -76.6761959995798,
                39.3063680002677,
                0
              ],
              [
                -76.6763349995391,
                39.3065129991802,
                0
              ],
              [
                -76.6765319997211,
                39.3066579990645,
                0
              ],
              [
                -76.6767169997045,
                39.3067489987635,
                0
              ],
              [
                -76.6768680004806,
                39.3067939986871,
                0
              ],
              [
                -76.6770599996894,
                39.3068170003077,
                0
              ],
              [
                -76.6773739995594,
                39.3068229989458,
                0
              ],
              [
                -76.6776009998915,
                39.3068049989091,
                0
              ],
              [
                -76.6777350003662,
                39.3067869992283,
                0
              ],
              [
                -76.6780259997145,
                39.3067389986398,
                0
              ],
              [
                -76.6782880000394,
                39.3067029988425,
                0
              ],
              [
                -76.6784630004515,
                39.3066989992908,
                0
              ],
              [
                -76.678655000317,
                39.3067039985549,
                0
              ],
              [
                -76.6788700003412,
                39.30672299862,
                0
              ],
              [
                -76.6790150010188,
                39.3067459992036,
                0
              ],
              [
                -76.6791309997799,
                39.3067909987787,
                0
              ],
              [
                -76.679260999939,
                39.3068649992746,
                0
              ],
              [
                -76.679867000094,
                39.3074669992455,
                0
              ],
              [
                -76.6796960000423,
                39.3082519987833,
                0
              ],
              [
                -76.6796980010796,
                39.3084699990152,
                0
              ],
              [
                -76.679710999999,
                39.3086999993117,
                0
              ],
              [
                -76.6797600002488,
                39.3089739985877,
                0
              ],
              [
                -76.6798569996644,
                39.3093029988369,
                0
              ],
              [
                -76.6800449994683,
                39.3097849990696,
                0
              ],
              [
                -76.6802959996585,
                39.3102589987164,
                0
              ],
              [
                -76.68036900025,
                39.3103469990218,
                0
              ],
              [
                -76.680427999528,
                39.3104219993798,
                0
              ],
              [
                -76.6804999988867,
                39.3105379985573,
                0
              ],
              [
                -76.6805319996897,
                39.3106319988754,
                0
              ],
              [
                -76.6805650002495,
                39.3107619977539,
                0
              ],
              [
                -76.6800090004223,
                39.3107859988635,
                0
              ],
              [
                -76.6795659992351,
                39.3108059990271,
                0
              ],
              [
                -76.6780309999605,
                39.3108549999759,
                0
              ],
              [
                -76.6778319991041,
                39.3108589988661,
                0
              ],
              [
                -76.6776660013136,
                39.3108639986109,
                0
              ],
              [
                -76.677498999364,
                39.3108689989685,
                0
              ],
              [
                -76.6760159985818,
                39.3109159986275,
                0
              ],
              [
                -76.6759720008434,
                39.3109290003755,
                0
              ],
              [
                -76.6758450000843,
                39.3109459986039,
                0
              ],
              [
                -76.6756739994399,
                39.3109629986702,
                0
              ],
              [
                -76.6755199997552,
                39.3109669989379,
                0
              ],
              [
                -76.6754430004841,
                39.3109689994481,
                0
              ],
              [
                -76.6749730001959,
                39.3109929989475,
                0
              ],
              [
                -76.674436999457,
                39.3110219993662,
                0
              ],
              [
                -76.6742390011377,
                39.3110319993652,
                0
              ],
              [
                -76.6725050002556,
                39.3110769994047,
                0
              ],
              [
                -76.6710679997229,
                39.3111159985899,
                0
              ],
              [
                -76.6694460001259,
                39.3111469990346,
                0
              ],
              [
                -76.6676870003946,
                39.3112279985616,
                0
              ],
              [
                -76.6668229996022,
                39.3112639998133,
                0
              ],
              [
                -76.66591000007,
                39.3113199989482,
                0
              ],
              [
                -76.6641370002187,
                39.3113739991758,
                0
              ],
              [
                -76.6636859996476,
                39.3113899992582,
                0
              ],
              [
                -76.6632590009353,
                39.3114049989996,
                0
              ],
              [
                -76.6628480005609,
                39.3114139990415,
                0
              ],
              [
                -76.6623760001818,
                39.3114239978872,
                0
              ],
              [
                -76.6618499997283,
                39.3114349987309,
                0
              ],
              [
                -76.6617659995279,
                39.31143699896,
                0
              ],
              [
                -76.6613190004353,
                39.3114459981266,
                0
              ],
              [
                -76.6613809998693,
                39.3125379986119,
                0
              ],
              [
                -76.6614119995178,
                39.3129579987936,
                0
              ],
              [
                -76.6614439994892,
                39.3132639990123,
                0
              ],
              [
                -76.6614929999075,
                39.3136299986116,
                0
              ],
              [
                -76.6615440000294,
                39.3139519985758,
                0
              ],
              [
                -76.6616679995211,
                39.3144409990709,
                0
              ],
              [
                -76.6617280005535,
                39.3147269992224,
                0
              ],
              [
                -76.6614509995381,
                39.3147839991949,
                0
              ],
              [
                -76.6611970002615,
                39.3148259988581,
                0
              ],
              [
                -76.6608210008505,
                39.3149089994324,
                0
              ],
              [
                -76.6606359998279,
                39.3149519995726,
                0
              ],
              [
                -76.6604500001079,
                39.3150109992894,
                0
              ],
              [
                -76.660225999732,
                39.3150769993832,
                0
              ],
              [
                -76.659778999525,
                39.3152239996006,
                0
              ],
              [
                -76.6597109984856,
                39.315013998751,
                0
              ],
              [
                -76.6596930000316,
                39.3149389986914,
                0
              ],
              [
                -76.659672999804,
                39.3148519993215,
                0
              ],
              [
                -76.6596510014863,
                39.3146799983255,
                0
              ],
              [
                -76.6596250003835,
                39.3144509987598,
                0
              ],
              [
                -76.6596339986525,
                39.3142639999185,
                0
              ],
              [
                -76.6596500000077,
                39.3136349989402,
                0
              ],
              [
                -76.6597020004904,
                39.3129029992895,
                0
              ],
              [
                -76.6597769998219,
                39.3119339988058,
                0
              ],
              [
                -76.6597909995834,
                39.3118049993342,
                0
              ],
              [
                -76.6598139998224,
                39.3115279989352,
                0
              ],
              [
                -76.6599070004658,
                39.3104219987295,
                0
              ],
              [
                -76.6599160001749,
                39.3102399988233,
                0
              ],
              [
                -76.6599349996991,
                39.3099079993236,
                0
              ],
              [
                -76.6599850002943,
                39.3093679993008,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 89,
          "Census_Tract": "24510150701",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "6e1ac272-60e2-442f-8d26-39648e36f7ba",
          "Shape__Area": 10499222.96661377,
          "Shape__Length": 13587.5908523341
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6647760000182,
                39.3221939987005,
                0
              ],
              [
                -76.6647730013058,
                39.3220739986061,
                0
              ],
              [
                -76.6647699997459,
                39.3219599992922,
                0
              ],
              [
                -76.6647560000284,
                39.3216999976293,
                0
              ],
              [
                -76.6647030004995,
                39.3214259987322,
                0
              ],
              [
                -76.6646109999996,
                39.3210799987581,
                0
              ],
              [
                -76.6645000004909,
                39.3208079986897,
                0
              ],
              [
                -76.6644119998359,
                39.3206270002736,
                0
              ],
              [
                -76.6643100010679,
                39.3204489991282,
                0
              ],
              [
                -76.6642170000232,
                39.3202889989577,
                0
              ],
              [
                -76.6640590007069,
                39.3200810002176,
                0
              ],
              [
                -76.6638269994312,
                39.3198239986658,
                0
              ],
              [
                -76.6631959998284,
                39.3191899986977,
                0
              ],
              [
                -76.6624770003881,
                39.318476998876,
                0
              ],
              [
                -76.6615000001831,
                39.3174979994219,
                0
              ],
              [
                -76.6611870000371,
                39.3171689989481,
                0
              ],
              [
                -76.661094000994,
                39.3170669990803,
                0
              ],
              [
                -76.6608010005226,
                39.3167479976874,
                0
              ],
              [
                -76.6604580000692,
                39.316379998834,
                0
              ],
              [
                -76.6603670002275,
                39.3162529992809,
                0
              ],
              [
                -76.6598520003609,
                39.3154019985554,
                0
              ],
              [
                -76.659778999525,
                39.3152239996006,
                0
              ],
              [
                -76.660225999732,
                39.3150769993832,
                0
              ],
              [
                -76.6604500001079,
                39.3150109992894,
                0
              ],
              [
                -76.6606359998279,
                39.3149519995726,
                0
              ],
              [
                -76.6608210008505,
                39.3149089994324,
                0
              ],
              [
                -76.6611970002615,
                39.3148259988581,
                0
              ],
              [
                -76.6614509995381,
                39.3147839991949,
                0
              ],
              [
                -76.6617280005535,
                39.3147269992224,
                0
              ],
              [
                -76.662081000025,
                39.3146819989826,
                0
              ],
              [
                -76.6623189997915,
                39.3146579988977,
                0
              ],
              [
                -76.6625720012024,
                39.3146299988324,
                0
              ],
              [
                -76.6627339996601,
                39.314620998763,
                0
              ],
              [
                -76.6634549998519,
                39.3145699988588,
                0
              ],
              [
                -76.6643759998644,
                39.314542000006,
                0
              ],
              [
                -76.6651949984354,
                39.3144939994436,
                0
              ],
              [
                -76.6656760010903,
                39.3144649981709,
                0
              ],
              [
                -76.6660910005409,
                39.3144579992284,
                0
              ],
              [
                -76.6678679986745,
                39.3144039995719,
                0
              ],
              [
                -76.6696320000443,
                39.3143439987627,
                0
              ],
              [
                -76.6712489995051,
                39.3142779991056,
                0
              ],
              [
                -76.6719519995212,
                39.3142490002754,
                0
              ],
              [
                -76.6726809985981,
                39.3142189986648,
                0
              ],
              [
                -76.6744180000781,
                39.3141629987916,
                0
              ],
              [
                -76.6744300003035,
                39.3143339991423,
                0
              ],
              [
                -76.6744580005495,
                39.3147059987017,
                0
              ],
              [
                -76.6744950001156,
                39.3152379992301,
                0
              ],
              [
                -76.6745020004775,
                39.3155989990859,
                0
              ],
              [
                -76.6745150003756,
                39.315762998782,
                0
              ],
              [
                -76.6745659997468,
                39.3162989975863,
                0
              ],
              [
                -76.6745939989,
                39.3168299991847,
                0
              ],
              [
                -76.6746209995654,
                39.3173279998319,
                0
              ],
              [
                -76.6746540000301,
                39.3178399993527,
                0
              ],
              [
                -76.6746870003148,
                39.3183619998113,
                0
              ],
              [
                -76.6747159995254,
                39.318867998987,
                0
              ],
              [
                -76.6747460008492,
                39.3193919987328,
                0
              ],
              [
                -76.6747779995003,
                39.3198929987637,
                0
              ],
              [
                -76.6748070004682,
                39.3203419991451,
                0
              ],
              [
                -76.6748459993081,
                39.3208129990991,
                0
              ],
              [
                -76.6748630011678,
                39.3211389994372,
                0
              ],
              [
                -76.67486200029,
                39.3211809986128,
                0
              ],
              [
                -76.6748369996782,
                39.3212619986937,
                0
              ],
              [
                -76.6747789994437,
                39.321368997663,
                0
              ],
              [
                -76.6745320000841,
                39.3218289994474,
                0
              ],
              [
                -76.6728879999794,
                39.3213449989241,
                0
              ],
              [
                -76.6724569997185,
                39.3222789988297,
                0
              ],
              [
                -76.6719710009072,
                39.3232409990427,
                0
              ],
              [
                -76.6717100000094,
                39.3237139993653,
                0
              ],
              [
                -76.6716079985746,
                39.3238999991724,
                0
              ],
              [
                -76.6714990000895,
                39.3240999976777,
                0
              ],
              [
                -76.6714499999611,
                39.3241889988065,
                0
              ],
              [
                -76.6712969998113,
                39.3241429994421,
                0
              ],
              [
                -76.6704730014805,
                39.3238959992254,
                0
              ],
              [
                -76.66989299988,
                39.3237309992489,
                0
              ],
              [
                -76.6694990004242,
                39.3236189990048,
                0
              ],
              [
                -76.6685440015761,
                39.3233489989402,
                0
              ],
              [
                -76.6685240002379,
                39.3233439992222,
                0
              ],
              [
                -76.6675859995427,
                39.3230519988375,
                0
              ],
              [
                -76.6665840003972,
                39.3227409990392,
                0
              ],
              [
                -76.6662160004534,
                39.3226289993259,
                0
              ],
              [
                -76.6647760000182,
                39.3221939987005,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 90,
          "Census_Tract": "24510150702",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "dfeb68ed-4b0f-404a-acc5-b49088ba2bb5",
          "Shape__Area": 4214068.871765137,
          "Shape__Length": 9601.158573275989
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6742390011377,
                39.3110319993652,
                0
              ],
              [
                -76.6742999998291,
                39.312064998693,
                0
              ],
              [
                -76.6743689996936,
                39.3131169986666,
                0
              ],
              [
                -76.6743909998107,
                39.3136669990788,
                0
              ],
              [
                -76.6744180000781,
                39.3141629987916,
                0
              ],
              [
                -76.6726809985981,
                39.3142189986648,
                0
              ],
              [
                -76.6719519995212,
                39.3142490002754,
                0
              ],
              [
                -76.6712489995051,
                39.3142779991056,
                0
              ],
              [
                -76.6696320000443,
                39.3143439987627,
                0
              ],
              [
                -76.6678679986745,
                39.3144039995719,
                0
              ],
              [
                -76.6660910005409,
                39.3144579992284,
                0
              ],
              [
                -76.6656760010903,
                39.3144649981709,
                0
              ],
              [
                -76.6651949984354,
                39.3144939994436,
                0
              ],
              [
                -76.6643759998644,
                39.314542000006,
                0
              ],
              [
                -76.6634549998519,
                39.3145699988588,
                0
              ],
              [
                -76.6627339996601,
                39.314620998763,
                0
              ],
              [
                -76.6625720012024,
                39.3146299988324,
                0
              ],
              [
                -76.6623189997915,
                39.3146579988977,
                0
              ],
              [
                -76.662081000025,
                39.3146819989826,
                0
              ],
              [
                -76.6617280005535,
                39.3147269992224,
                0
              ],
              [
                -76.6616679995211,
                39.3144409990709,
                0
              ],
              [
                -76.6615440000294,
                39.3139519985758,
                0
              ],
              [
                -76.6614929999075,
                39.3136299986116,
                0
              ],
              [
                -76.6614439994892,
                39.3132639990123,
                0
              ],
              [
                -76.6614119995178,
                39.3129579987936,
                0
              ],
              [
                -76.6613809998693,
                39.3125379986119,
                0
              ],
              [
                -76.6613190004353,
                39.3114459981266,
                0
              ],
              [
                -76.6617659995279,
                39.31143699896,
                0
              ],
              [
                -76.6618499997283,
                39.3114349987309,
                0
              ],
              [
                -76.6623760001818,
                39.3114239978872,
                0
              ],
              [
                -76.6628480005609,
                39.3114139990415,
                0
              ],
              [
                -76.6632590009353,
                39.3114049989996,
                0
              ],
              [
                -76.6636859996476,
                39.3113899992582,
                0
              ],
              [
                -76.6641370002187,
                39.3113739991758,
                0
              ],
              [
                -76.66591000007,
                39.3113199989482,
                0
              ],
              [
                -76.6668229996022,
                39.3112639998133,
                0
              ],
              [
                -76.6676870003946,
                39.3112279985616,
                0
              ],
              [
                -76.6694460001259,
                39.3111469990346,
                0
              ],
              [
                -76.6710679997229,
                39.3111159985899,
                0
              ],
              [
                -76.6725050002556,
                39.3110769994047,
                0
              ],
              [
                -76.6742390011377,
                39.3110319993652,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 91,
          "Census_Tract": "24510271802",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "3b37b903-c584-4654-a4f3-38e5e7131243",
          "Shape__Area": 5707557.150878906,
          "Shape__Length": 9754.825607931627
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6713970004263,
                39.3451949987826,
                0
              ],
              [
                -76.6718900003434,
                39.3449169985643,
                0
              ],
              [
                -76.6721139997045,
                39.3447939992247,
                0
              ],
              [
                -76.6723250011157,
                39.3446779989331,
                0
              ],
              [
                -76.6723860010024,
                39.3446429994217,
                0
              ],
              [
                -76.6725489998718,
                39.3442609989585,
                0
              ],
              [
                -76.6729950004879,
                39.3431429993918,
                0
              ],
              [
                -76.6735029996447,
                39.3419039992411,
                0
              ],
              [
                -76.6735530002005,
                39.3417849994295,
                0
              ],
              [
                -76.6738480009793,
                39.3410260003007,
                0
              ],
              [
                -76.6748889999107,
                39.3413229990565,
                0
              ],
              [
                -76.6757150002665,
                39.3415539990066,
                0
              ],
              [
                -76.6758289999521,
                39.3415879994138,
                0
              ],
              [
                -76.6767099996939,
                39.3418409987185,
                0
              ],
              [
                -76.6769580000855,
                39.341913999324,
                0
              ],
              [
                -76.6777449994662,
                39.3421359991315,
                0
              ],
              [
                -76.6780109994323,
                39.34220699945,
                0
              ],
              [
                -76.6782159996809,
                39.3422369988208,
                0
              ],
              [
                -76.6783180000122,
                39.3422359980006,
                0
              ],
              [
                -76.6783790004337,
                39.3422329987804,
                0
              ],
              [
                -76.6784010000765,
                39.3422319996879,
                0
              ],
              [
                -76.6784679999036,
                39.3422269991674,
                0
              ],
              [
                -76.6785420000109,
                39.3422179986329,
                0
              ],
              [
                -76.6786129999682,
                39.3422059993823,
                0
              ],
              [
                -76.6787020011497,
                39.3421839987917,
                0
              ],
              [
                -76.6789710001831,
                39.3421129993358,
                0
              ],
              [
                -76.6791919996814,
                39.3420429987279,
                0
              ],
              [
                -76.6793969996131,
                39.3419909986668,
                0
              ],
              [
                -76.6801970005664,
                39.3417599994135,
                0
              ],
              [
                -76.6803570005074,
                39.3417219989166,
                0
              ],
              [
                -76.6804400004577,
                39.3417049996359,
                0
              ],
              [
                -76.6805840002289,
                39.3416849990309,
                0
              ],
              [
                -76.680662000501,
                39.3416769988486,
                0
              ],
              [
                -76.6807529996087,
                39.3416759993626,
                0
              ],
              [
                -76.6808870010872,
                39.3416809992932,
                0
              ],
              [
                -76.6809930002363,
                39.341687999305,
                0
              ],
              [
                -76.6811459984436,
                39.3417119994249,
                0
              ],
              [
                -76.6813180014769,
                39.3417619985783,
                0
              ],
              [
                -76.6814919999767,
                39.3418199996844,
                0
              ],
              [
                -76.6817550001287,
                39.3419279994526,
                0
              ],
              [
                -76.6820929997002,
                39.3420519986911,
                0
              ],
              [
                -76.6822959990028,
                39.3421259985533,
                0
              ],
              [
                -76.6824640002389,
                39.3422169987463,
                0
              ],
              [
                -76.6826699990947,
                39.3423409991071,
                0
              ],
              [
                -76.6827230005193,
                39.3423769989394,
                0
              ],
              [
                -76.6828360001171,
                39.3424519988662,
                0
              ],
              [
                -76.6835189998209,
                39.3429399992977,
                0
              ],
              [
                -76.6834489998003,
                39.3431109988456,
                0
              ],
              [
                -76.6832600000723,
                39.3433729987231,
                0
              ],
              [
                -76.6831209996905,
                39.3435499993437,
                0
              ],
              [
                -76.6830870005724,
                39.3435939990631,
                0
              ],
              [
                -76.683040999812,
                39.3436459992412,
                0
              ],
              [
                -76.6829329996025,
                39.3437479990821,
                0
              ],
              [
                -76.6825269994236,
                39.3441709992531,
                0
              ],
              [
                -76.6824399994862,
                39.3442599990689,
                0
              ],
              [
                -76.682317000152,
                39.3443829991626,
                0
              ],
              [
                -76.6819609998476,
                39.3447409988139,
                0
              ],
              [
                -76.6819109999453,
                39.3447929994269,
                0
              ],
              [
                -76.6816149994795,
                39.3451009988647,
                0
              ],
              [
                -76.6814120003717,
                39.3453129989527,
                0
              ],
              [
                -76.6809269999613,
                39.3458309986101,
                0
              ],
              [
                -76.6807999995413,
                39.3459509993507,
                0
              ],
              [
                -76.6806920005285,
                39.3460259991341,
                0
              ],
              [
                -76.6802810004879,
                39.3463049986125,
                0
              ],
              [
                -76.6796009998325,
                39.3467349992984,
                0
              ],
              [
                -76.6793599995083,
                39.346889998633,
                0
              ],
              [
                -76.6789189994609,
                39.3471689997571,
                0
              ],
              [
                -76.6784490004779,
                39.3474719994401,
                0
              ],
              [
                -76.6782270005414,
                39.3476209990095,
                0
              ],
              [
                -76.6769379994234,
                39.3484409989664,
                0
              ],
              [
                -76.6766450002127,
                39.3486279999674,
                0
              ],
              [
                -76.6762320003541,
                39.3488909986909,
                0
              ],
              [
                -76.6759600004651,
                39.3490279988832,
                0
              ],
              [
                -76.6758259996795,
                39.3489759989993,
                0
              ],
              [
                -76.6756899994758,
                39.3489129989948,
                0
              ],
              [
                -76.6755089998649,
                39.3488209986755,
                0
              ],
              [
                -76.6752399996448,
                39.3486729991315,
                0
              ],
              [
                -76.6747329995371,
                39.3483719992444,
                0
              ],
              [
                -76.6745220005475,
                39.3482519985978,
                0
              ],
              [
                -76.6742519995664,
                39.3480709989099,
                0
              ],
              [
                -76.6740440011632,
                39.3479229989345,
                0
              ],
              [
                -76.6739050006383,
                39.3478209990011,
                0
              ],
              [
                -76.6738040004789,
                39.3477349988247,
                0
              ],
              [
                -76.6736590000487,
                39.3476179990038,
                0
              ],
              [
                -76.673565999643,
                39.3475389997689,
                0
              ],
              [
                -76.6734889999821,
                39.3474709988181,
                0
              ],
              [
                -76.6734840005529,
                39.3474549985644,
                0
              ],
              [
                -76.6734830000331,
                39.3474399993312,
                0
              ],
              [
                -76.6734750002096,
                39.3474129989889,
                0
              ],
              [
                -76.6734530000689,
                39.3473799986516,
                0
              ],
              [
                -76.6734030002226,
                39.3473269988229,
                0
              ],
              [
                -76.6731070002176,
                39.3470429991059,
                0
              ],
              [
                -76.6729570000993,
                39.3468849989125,
                0
              ],
              [
                -76.6726689996464,
                39.346574998749,
                0
              ],
              [
                -76.6717969994925,
                39.3456359991761,
                0
              ],
              [
                -76.6713970004263,
                39.3451949987826,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 92,
          "Census_Tract": "24510151000",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "6a4eec40-dbe2-4f3d-a403-9582f33b0d0a",
          "Shape__Area": 15973079.415161133,
          "Shape__Length": 18933.06779917333
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6779640003796,
                39.3399249986507,
                0
              ],
              [
                -76.6780480005308,
                39.3398319990102,
                0
              ],
              [
                -76.6781330015264,
                39.3397389984447,
                0
              ],
              [
                -76.6782210003297,
                39.3396409987846,
                0
              ],
              [
                -76.6784650005324,
                39.3392769992171,
                0
              ],
              [
                -76.6785459995849,
                39.3391619993271,
                0
              ],
              [
                -76.6786850002358,
                39.3389609990298,
                0
              ],
              [
                -76.6789480003169,
                39.3386059992196,
                0
              ],
              [
                -76.6791209999456,
                39.33835899923,
                0
              ],
              [
                -76.6791719998461,
                39.3382789991899,
                0
              ],
              [
                -76.6791929990313,
                39.3382329987297,
                0
              ],
              [
                -76.6791969985321,
                39.3381719986172,
                0
              ],
              [
                -76.6791770002148,
                39.3378909991215,
                0
              ],
              [
                -76.6790779985092,
                39.3370349989214,
                0
              ],
              [
                -76.6789829996817,
                39.3362199986377,
                0
              ],
              [
                -76.6789720002508,
                39.3361270000004,
                0
              ],
              [
                -76.6788910005476,
                39.335312998729,
                0
              ],
              [
                -76.6788010003714,
                39.3345060002142,
                0
              ],
              [
                -76.6787410002407,
                39.3339679992485,
                0
              ],
              [
                -76.6786820013635,
                39.333434999135,
                0
              ],
              [
                -76.67863299952,
                39.3329059994225,
                0
              ],
              [
                -76.6785940005318,
                39.3324709990922,
                0
              ],
              [
                -76.6785629999371,
                39.3321639985834,
                0
              ],
              [
                -76.678560999508,
                39.3320679987877,
                0
              ],
              [
                -76.6785709985895,
                39.3320239985548,
                0
              ],
              [
                -76.678584001249,
                39.3319869990264,
                0
              ],
              [
                -76.6786129995802,
                39.3319189990109,
                0
              ],
              [
                -76.6786739996181,
                39.3317569990155,
                0
              ],
              [
                -76.6791659997004,
                39.330768998151,
                0
              ],
              [
                -76.6796669997669,
                39.3297779992843,
                0
              ],
              [
                -76.6801610003584,
                39.3287869987862,
                0
              ],
              [
                -76.6805880002316,
                39.3279329986131,
                0
              ],
              [
                -76.681068000281,
                39.326945000286,
                0
              ],
              [
                -76.6812809995122,
                39.3264909986383,
                0
              ],
              [
                -76.6814979996105,
                39.3260299977702,
                0
              ],
              [
                -76.6817370000892,
                39.3255569986052,
                0
              ],
              [
                -76.6819669992456,
                39.3251159988338,
                0
              ],
              [
                -76.6820920005757,
                39.3250269990038,
                0
              ],
              [
                -76.6825640004003,
                39.3258419986821,
                0
              ],
              [
                -76.6831649994451,
                39.325659998319,
                0
              ],
              [
                -76.6833759996881,
                39.3255960003948,
                0
              ],
              [
                -76.6835879992625,
                39.3255319993774,
                0
              ],
              [
                -76.6841889990111,
                39.3253509990115,
                0
              ],
              [
                -76.684388999586,
                39.3252869994367,
                0
              ],
              [
                -76.6856850013337,
                39.3249009988218,
                0
              ],
              [
                -76.6865970002168,
                39.3246299985787,
                0
              ],
              [
                -76.6870690005475,
                39.324498999359,
                0
              ],
              [
                -76.6871399996863,
                39.3244759986093,
                0
              ],
              [
                -76.6882100000056,
                39.324157999039,
                0
              ],
              [
                -76.6886350005037,
                39.3240289991093,
                0
              ],
              [
                -76.690068999962,
                39.323585999212,
                0
              ],
              [
                -76.6899529994249,
                39.3236939992308,
                0
              ],
              [
                -76.6896000014515,
                39.3244469999703,
                0
              ],
              [
                -76.6891349997581,
                39.3253859977703,
                0
              ],
              [
                -76.6888460004434,
                39.3259569988569,
                0
              ],
              [
                -76.6888160005723,
                39.3260149987388,
                0
              ],
              [
                -76.6885859998709,
                39.3264719999467,
                0
              ],
              [
                -76.6885570004473,
                39.326529998802,
                0
              ],
              [
                -76.6882809998511,
                39.3271059985834,
                0
              ],
              [
                -76.6879989997212,
                39.3276959991277,
                0
              ],
              [
                -76.6877110005828,
                39.3282639993312,
                0
              ],
              [
                -76.6874209996478,
                39.3288369988681,
                0
              ],
              [
                -76.688579999188,
                39.329183999268,
                0
              ],
              [
                -76.6885920000741,
                39.329504998619,
                0
              ],
              [
                -76.6886460005001,
                39.3304309991502,
                0
              ],
              [
                -76.6897739999876,
                39.3307309990452,
                0
              ],
              [
                -76.690866000365,
                39.3310129991727,
                0
              ],
              [
                -76.6906439994285,
                39.3314609992703,
                0
              ],
              [
                -76.6905109995765,
                39.3317289994069,
                0
              ],
              [
                -76.6903579997999,
                39.332023998792,
                0
              ],
              [
                -76.6900690000597,
                39.3325839991454,
                0
              ],
              [
                -76.6896750003405,
                39.3333939991019,
                0
              ],
              [
                -76.6895000001862,
                39.3337169991753,
                0
              ],
              [
                -76.6893610000754,
                39.3339769986902,
                0
              ],
              [
                -76.6893579996626,
                39.3350759998504,
                0
              ],
              [
                -76.6893559986686,
                39.33562899881,
                0
              ],
              [
                -76.6893480005608,
                39.3356989988767,
                0
              ],
              [
                -76.689348000603,
                39.3361270003693,
                0
              ],
              [
                -76.6893480007235,
                39.3361949993893,
                0
              ],
              [
                -76.6893470000125,
                39.336632999138,
                0
              ],
              [
                -76.6893549988183,
                39.3371549990127,
                0
              ],
              [
                -76.6893619999317,
                39.337675999041,
                0
              ],
              [
                -76.6893620000626,
                39.3381759994513,
                0
              ],
              [
                -76.689364000225,
                39.3387039992909,
                0
              ],
              [
                -76.6893679995579,
                39.3392159990081,
                0
              ],
              [
                -76.6893729998798,
                39.3397319987882,
                0
              ],
              [
                -76.6893699999817,
                39.3402439987619,
                0
              ],
              [
                -76.6893690011193,
                39.3403739986362,
                0
              ],
              [
                -76.6893789996579,
                39.3407539991823,
                0
              ],
              [
                -76.6870580000101,
                39.3407569989793,
                0
              ],
              [
                -76.6854759992924,
                39.3407579988162,
                0
              ],
              [
                -76.684484000156,
                39.3407759992324,
                0
              ],
              [
                -76.6841759995638,
                39.340781998954,
                0
              ],
              [
                -76.6840399998588,
                39.3407839988764,
                0
              ],
              [
                -76.6834769994317,
                39.3407939986299,
                0
              ],
              [
                -76.6833170004516,
                39.3409769987721,
                0
              ],
              [
                -76.683104000281,
                39.3412219990296,
                0
              ],
              [
                -76.6830499997362,
                39.3412829986279,
                0
              ],
              [
                -76.6829870004722,
                39.3413549990358,
                0
              ],
              [
                -76.6829159995381,
                39.3414349998486,
                0
              ],
              [
                -76.6793390002272,
                39.340347999386,
                0
              ],
              [
                -76.6779640003796,
                39.3399249986507,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 93,
          "Census_Tract": "24510150800",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "e44a457b-7e61-437a-aea8-2a3763156754",
          "Shape__Area": 11726644.54901123,
          "Shape__Length": 16677.203040000786
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6714499999611,
                39.3241889988065,
                0
              ],
              [
                -76.6714990000895,
                39.3240999976777,
                0
              ],
              [
                -76.6716079985746,
                39.3238999991724,
                0
              ],
              [
                -76.6717100000094,
                39.3237139993653,
                0
              ],
              [
                -76.6719710009072,
                39.3232409990427,
                0
              ],
              [
                -76.6724569997185,
                39.3222789988297,
                0
              ],
              [
                -76.6728879999794,
                39.3213449989241,
                0
              ],
              [
                -76.6745320000841,
                39.3218289994474,
                0
              ],
              [
                -76.6747789994437,
                39.321368997663,
                0
              ],
              [
                -76.6748369996782,
                39.3212619986937,
                0
              ],
              [
                -76.67486200029,
                39.3211809986128,
                0
              ],
              [
                -76.6748630011678,
                39.3211389994372,
                0
              ],
              [
                -76.6748459993081,
                39.3208129990991,
                0
              ],
              [
                -76.6748070004682,
                39.3203419991451,
                0
              ],
              [
                -76.6747779995003,
                39.3198929987637,
                0
              ],
              [
                -76.6747460008492,
                39.3193919987328,
                0
              ],
              [
                -76.6747159995254,
                39.318867998987,
                0
              ],
              [
                -76.6746870003148,
                39.3183619998113,
                0
              ],
              [
                -76.6746540000301,
                39.3178399993527,
                0
              ],
              [
                -76.6746209995654,
                39.3173279998319,
                0
              ],
              [
                -76.6745939989,
                39.3168299991847,
                0
              ],
              [
                -76.6745659997468,
                39.3162989975863,
                0
              ],
              [
                -76.6745150003756,
                39.315762998782,
                0
              ],
              [
                -76.6745020004775,
                39.3155989990859,
                0
              ],
              [
                -76.6744950001156,
                39.3152379992301,
                0
              ],
              [
                -76.6744580005495,
                39.3147059987017,
                0
              ],
              [
                -76.6744300003035,
                39.3143339991423,
                0
              ],
              [
                -76.6744180000781,
                39.3141629987916,
                0
              ],
              [
                -76.6743909998107,
                39.3136669990788,
                0
              ],
              [
                -76.6743689996936,
                39.3131169986666,
                0
              ],
              [
                -76.6742999998291,
                39.312064998693,
                0
              ],
              [
                -76.6742390011377,
                39.3110319993652,
                0
              ],
              [
                -76.674436999457,
                39.3110219993662,
                0
              ],
              [
                -76.6749730001959,
                39.3109929989475,
                0
              ],
              [
                -76.6754430004841,
                39.3109689994481,
                0
              ],
              [
                -76.6755199997552,
                39.3109669989379,
                0
              ],
              [
                -76.6756739994399,
                39.3109629986702,
                0
              ],
              [
                -76.6758450000843,
                39.3109459986039,
                0
              ],
              [
                -76.6759720008434,
                39.3109290003755,
                0
              ],
              [
                -76.6760159985818,
                39.3109159986275,
                0
              ],
              [
                -76.677498999364,
                39.3108689989685,
                0
              ],
              [
                -76.6776660013136,
                39.3108639986109,
                0
              ],
              [
                -76.6778319991041,
                39.3108589988661,
                0
              ],
              [
                -76.6780309999605,
                39.3108549999759,
                0
              ],
              [
                -76.6795659992351,
                39.3108059990271,
                0
              ],
              [
                -76.6800090004223,
                39.3107859988635,
                0
              ],
              [
                -76.6805650002495,
                39.3107619977539,
                0
              ],
              [
                -76.6809650014224,
                39.3130279994352,
                0
              ],
              [
                -76.6811019998704,
                39.3139219976417,
                0
              ],
              [
                -76.6811330003095,
                39.3140919985582,
                0
              ],
              [
                -76.6813009994386,
                39.3150019993112,
                0
              ],
              [
                -76.6813870000447,
                39.3155029986074,
                0
              ],
              [
                -76.6814949990911,
                39.3160659992979,
                0
              ],
              [
                -76.681513999493,
                39.3164479987375,
                0
              ],
              [
                -76.6815250000283,
                39.3169089992789,
                0
              ],
              [
                -76.6815209999751,
                39.3171729992546,
                0
              ],
              [
                -76.6815549994363,
                39.3175639989638,
                0
              ],
              [
                -76.6816010005423,
                39.3178869992802,
                0
              ],
              [
                -76.6816400002653,
                39.318100998838,
                0
              ],
              [
                -76.6817889998526,
                39.3191429988772,
                0
              ],
              [
                -76.6818410002862,
                39.3200899986147,
                0
              ],
              [
                -76.681903999967,
                39.3211479992169,
                0
              ],
              [
                -76.6819069994619,
                39.3212429994389,
                0
              ],
              [
                -76.6819139999719,
                39.3213159988806,
                0
              ],
              [
                -76.6819320002108,
                39.3213749989218,
                0
              ],
              [
                -76.6819650005218,
                39.3214389990743,
                0
              ],
              [
                -76.6824109999204,
                39.3222519987739,
                0
              ],
              [
                -76.6827469985612,
                39.322851997801,
                0
              ],
              [
                -76.6810840003552,
                39.3233579991538,
                0
              ],
              [
                -76.6812250002573,
                39.3235289987447,
                0
              ],
              [
                -76.6813469999224,
                39.3236829990623,
                0
              ],
              [
                -76.6814610001445,
                39.3238669977083,
                0
              ],
              [
                -76.6816830013286,
                39.3242619990325,
                0
              ],
              [
                -76.6820920005757,
                39.3250269990038,
                0
              ],
              [
                -76.6819669992456,
                39.3251159988338,
                0
              ],
              [
                -76.6817370000892,
                39.3255569986052,
                0
              ],
              [
                -76.6814979996105,
                39.3260299977702,
                0
              ],
              [
                -76.6812809995122,
                39.3264909986383,
                0
              ],
              [
                -76.681068000281,
                39.326945000286,
                0
              ],
              [
                -76.678911999987,
                39.3263319994403,
                0
              ],
              [
                -76.6788450004655,
                39.3263399996885,
                0
              ],
              [
                -76.6787739996244,
                39.326335999109,
                0
              ],
              [
                -76.6786749994576,
                39.3263169992568,
                0
              ],
              [
                -76.6785519995316,
                39.3262779992377,
                0
              ],
              [
                -76.6776759995445,
                39.3260239988557,
                0
              ],
              [
                -76.6764910005585,
                39.3256719988537,
                0
              ],
              [
                -76.6755820010324,
                39.3254009993128,
                0
              ],
              [
                -76.6746590001459,
                39.3251339983051,
                0
              ],
              [
                -76.6740840001742,
                39.3249629988595,
                0
              ],
              [
                -76.6737090000001,
                39.3248509988343,
                0
              ],
              [
                -76.6731180001284,
                39.3246739989717,
                0
              ],
              [
                -76.6714499999611,
                39.3241889988065,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 94,
          "Census_Tract": "24510250204",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "0957f0c5-5321-4cc5-bbcb-41971a3d2623",
          "Shape__Area": 9275002.040405273,
          "Shape__Length": 19732.779659345026
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.632768000132,
                39.2577309986594,
                0
              ],
              [
                -76.6328090001704,
                39.2576550002702,
                0
              ],
              [
                -76.632944000269,
                39.2574389993156,
                0
              ],
              [
                -76.6330820005725,
                39.2572269988735,
                0
              ],
              [
                -76.6331799995499,
                39.2570909990223,
                0
              ],
              [
                -76.6333690000571,
                39.2568679988215,
                0
              ],
              [
                -76.6334179995052,
                39.2568089992574,
                0
              ],
              [
                -76.6335709994546,
                39.256628998891,
                0
              ],
              [
                -76.6338559998543,
                39.2563189985657,
                0
              ],
              [
                -76.6340030000565,
                39.2561489990563,
                0
              ],
              [
                -76.6341530002734,
                39.2558989988502,
                0
              ],
              [
                -76.6342130004366,
                39.2557509985607,
                0
              ],
              [
                -76.6342419987462,
                39.2556759990319,
                0
              ],
              [
                -76.6342669992581,
                39.2556109990843,
                0
              ],
              [
                -76.6342970014095,
                39.2554699997532,
                0
              ],
              [
                -76.6343130000781,
                39.2552919991638,
                0
              ],
              [
                -76.6343109996208,
                39.255109998943,
                0
              ],
              [
                -76.6342880003306,
                39.2549579991677,
                0
              ],
              [
                -76.6342389994932,
                39.2547489988129,
                0
              ],
              [
                -76.6342059990971,
                39.2546089994189,
                0
              ],
              [
                -76.6340499996658,
                39.2540629987104,
                0
              ],
              [
                -76.6340240005381,
                39.2539310000673,
                0
              ],
              [
                -76.6339260005316,
                39.2535780002719,
                0
              ],
              [
                -76.6338770005085,
                39.253388997654,
                0
              ],
              [
                -76.6337990003854,
                39.2531409987624,
                0
              ],
              [
                -76.6337419995593,
                39.2529769980802,
                0
              ],
              [
                -76.6336890000073,
                39.2528669992508,
                0
              ],
              [
                -76.6336590000823,
                39.2528079989477,
                0
              ],
              [
                -76.6336260002835,
                39.2527409994517,
                0
              ],
              [
                -76.6335260000013,
                39.2525689980434,
                0
              ],
              [
                -76.6334769996183,
                39.2524779989026,
                0
              ],
              [
                -76.6334459997705,
                39.252421998581,
                0
              ],
              [
                -76.6333649985356,
                39.2523039989041,
                0
              ],
              [
                -76.6332840002626,
                39.252193998909,
                0
              ],
              [
                -76.6331450000965,
                39.2520439991282,
                0
              ],
              [
                -76.6329930004947,
                39.2518939990765,
                0
              ],
              [
                -76.632867999927,
                39.2517659998687,
                0
              ],
              [
                -76.6327420000817,
                39.2516549994219,
                0
              ],
              [
                -76.632600999875,
                39.2515439987379,
                0
              ],
              [
                -76.6322559990383,
                39.251320998757,
                0
              ],
              [
                -76.6321980004282,
                39.2512829991711,
                0
              ],
              [
                -76.6320570001965,
                39.2511959988263,
                0
              ],
              [
                -76.6319409995966,
                39.2511269992958,
                0
              ],
              [
                -76.631832000092,
                39.2510749993108,
                0
              ],
              [
                -76.6316240007368,
                39.2509919994278,
                0
              ],
              [
                -76.6314010000463,
                39.2509069992097,
                0
              ],
              [
                -76.6313730005402,
                39.2508969992338,
                0
              ],
              [
                -76.6312209990343,
                39.2508459986275,
                0
              ],
              [
                -76.6303259997607,
                39.2506239988467,
                0
              ],
              [
                -76.6297819997145,
                39.2504929990569,
                0
              ],
              [
                -76.6293690004921,
                39.2503810004335,
                0
              ],
              [
                -76.6289739999883,
                39.2502809987378,
                0
              ],
              [
                -76.6284759997041,
                39.2501569993885,
                0
              ],
              [
                -76.6283770005415,
                39.2501270002993,
                0
              ],
              [
                -76.6282500004084,
                39.2500869985944,
                0
              ],
              [
                -76.6280769997005,
                39.2500310001896,
                0
              ],
              [
                -76.6280259999063,
                39.2501259986881,
                0
              ],
              [
                -76.6279350013361,
                39.2503309985713,
                0
              ],
              [
                -76.6277149997808,
                39.2508599990254,
                0
              ],
              [
                -76.6274270000005,
                39.2515799986653,
                0
              ],
              [
                -76.6267450002926,
                39.2514149985897,
                0
              ],
              [
                -76.6266639998653,
                39.2517799987255,
                0
              ],
              [
                -76.6265089999748,
                39.2518199989761,
                0
              ],
              [
                -76.6263709994861,
                39.2518319986436,
                0
              ],
              [
                -76.6262580001983,
                39.2518129993748,
                0
              ],
              [
                -76.6261690003029,
                39.251780999936,
                0
              ],
              [
                -76.6260999999021,
                39.2517369992083,
                0
              ],
              [
                -76.6259709997339,
                39.2515310002271,
                0
              ],
              [
                -76.6258459998218,
                39.2513009993104,
                0
              ],
              [
                -76.6256089997816,
                39.2509189992267,
                0
              ],
              [
                -76.6250860001515,
                39.250073998687,
                0
              ],
              [
                -76.6251999995142,
                39.2500429987351,
                0
              ],
              [
                -76.6252569997344,
                39.2500319976166,
                0
              ],
              [
                -76.6252979999239,
                39.2500349992271,
                0
              ],
              [
                -76.6253509989808,
                39.2500449993638,
                0
              ],
              [
                -76.6258600004481,
                39.2502339988879,
                0
              ],
              [
                -76.6261540003542,
                39.2503409992731,
                0
              ],
              [
                -76.6264920001182,
                39.2504579996283,
                0
              ],
              [
                -76.6265550004502,
                39.2504709990722,
                0
              ],
              [
                -76.6266330002753,
                39.2504819987313,
                0
              ],
              [
                -76.6267139998992,
                39.2504849991287,
                0
              ],
              [
                -76.626778999461,
                39.250481999024,
                0
              ],
              [
                -76.6268579994726,
                39.2504719993567,
                0
              ],
              [
                -76.6269149987016,
                39.2504589986224,
                0
              ],
              [
                -76.626979999977,
                39.2504419986427,
                0
              ],
              [
                -76.6270279987747,
                39.2504249986634,
                0
              ],
              [
                -76.6270780008794,
                39.2504019977916,
                0
              ],
              [
                -76.6271369999413,
                39.2503659994337,
                0
              ],
              [
                -76.627188999644,
                39.2503329991035,
                0
              ],
              [
                -76.6272400001111,
                39.2502839988005,
                0
              ],
              [
                -76.627288000394,
                39.2502229997001,
                0
              ],
              [
                -76.6273579993328,
                39.2501079989691,
                0
              ],
              [
                -76.6274779995439,
                39.24992499917,
                0
              ],
              [
                -76.6275349995946,
                39.2498209987232,
                0
              ],
              [
                -76.6267639996099,
                39.249541999394,
                0
              ],
              [
                -76.6264129994558,
                39.249426998658,
                0
              ],
              [
                -76.6262000001556,
                39.2493649989654,
                0
              ],
              [
                -76.6260999996819,
                39.2493369989691,
                0
              ],
              [
                -76.6259729990841,
                39.2492909992541,
                0
              ],
              [
                -76.6256410005332,
                39.2491619993012,
                0
              ],
              [
                -76.6253979998937,
                39.249081998765,
                0
              ],
              [
                -76.6251009995955,
                39.2489559986035,
                0
              ],
              [
                -76.6248889994819,
                39.2488649993967,
                0
              ],
              [
                -76.6247859993643,
                39.2488339990319,
                0
              ],
              [
                -76.6247099994667,
                39.248814999378,
                0
              ],
              [
                -76.6245270006285,
                39.2487719987961,
                0
              ],
              [
                -76.6244239999785,
                39.2487440003789,
                0
              ],
              [
                -76.6243030000422,
                39.2486999988329,
                0
              ],
              [
                -76.6241200000725,
                39.2486279990986,
                0
              ],
              [
                -76.6240150000851,
                39.2485880001572,
                0
              ],
              [
                -76.6238570002401,
                39.2485169988529,
                0
              ],
              [
                -76.6236189994672,
                39.2484209994242,
                0
              ],
              [
                -76.6233589995288,
                39.2483079989494,
                0
              ],
              [
                -76.623205998465,
                39.248238998995,
                0
              ],
              [
                -76.6230010000803,
                39.2481309987506,
                0
              ],
              [
                -76.6229500003341,
                39.2480999997872,
                0
              ],
              [
                -76.622723999741,
                39.2479610000287,
                0
              ],
              [
                -76.6225809985839,
                39.2478669989572,
                0
              ],
              [
                -76.6224679998893,
                39.2477799985976,
                0
              ],
              [
                -76.621973999614,
                39.2474399992647,
                0
              ],
              [
                -76.6216150002317,
                39.2471929989288,
                0
              ],
              [
                -76.6212349999912,
                39.2469680004168,
                0
              ],
              [
                -76.6208869988699,
                39.2467609987094,
                0
              ],
              [
                -76.6200949998811,
                39.2463299992599,
                0
              ],
              [
                -76.618824000385,
                39.2457499991639,
                0
              ],
              [
                -76.6192009994349,
                39.2450849991962,
                0
              ],
              [
                -76.6194959999531,
                39.2445929992675,
                0
              ],
              [
                -76.6198119998703,
                39.2441439991455,
                0
              ],
              [
                -76.6211880002992,
                39.242345999246,
                0
              ],
              [
                -76.6214889999602,
                39.2419059987508,
                0
              ],
              [
                -76.6217210011725,
                39.2417019991435,
                0
              ],
              [
                -76.6219069996993,
                39.2417119987946,
                0
              ],
              [
                -76.6226439999332,
                39.2417639990844,
                0
              ],
              [
                -76.6235299995918,
                39.2418289987981,
                0
              ],
              [
                -76.6243169997951,
                39.2419009983281,
                0
              ],
              [
                -76.6249419999987,
                39.2419649987171,
                0
              ],
              [
                -76.6253199995807,
                39.2420229994435,
                0
              ],
              [
                -76.6255839997977,
                39.2420699991031,
                0
              ],
              [
                -76.6257559999411,
                39.2421029987673,
                0
              ],
              [
                -76.6259859998052,
                39.2421499990204,
                0
              ],
              [
                -76.6262289994913,
                39.2422169986226,
                0
              ],
              [
                -76.6264790004347,
                39.24229399875,
                0
              ],
              [
                -76.6266510003146,
                39.2423529987877,
                0
              ],
              [
                -76.626870999982,
                39.2424410001728,
                0
              ],
              [
                -76.627234999803,
                39.242605998877,
                0
              ],
              [
                -76.6276640004362,
                39.2428120003814,
                0
              ],
              [
                -76.6279849996396,
                39.2429959990458,
                0
              ],
              [
                -76.6284740005028,
                39.2433259978665,
                0
              ],
              [
                -76.6286699992865,
                39.2434729988058,
                0
              ],
              [
                -76.6288489997578,
                39.2436229992874,
                0
              ],
              [
                -76.6289600002102,
                39.243709998999,
                0
              ],
              [
                -76.6291320003039,
                39.2438719986097,
                0
              ],
              [
                -76.6292430012619,
                39.2439809993955,
                0
              ],
              [
                -76.6293300003654,
                39.2440679986094,
                0
              ],
              [
                -76.629487999699,
                39.2442409987323,
                0
              ],
              [
                -76.6297619997623,
                39.2445470004215,
                0
              ],
              [
                -76.6301310001159,
                39.2449959991782,
                0
              ],
              [
                -76.6314819994866,
                39.2466419985622,
                0
              ],
              [
                -76.6341089985249,
                39.2498449990476,
                0
              ],
              [
                -76.6341690004277,
                39.2499579993532,
                0
              ],
              [
                -76.6344970005537,
                39.2504349994146,
                0
              ],
              [
                -76.6346539999224,
                39.2506919993664,
                0
              ],
              [
                -76.6347089995803,
                39.2507939989114,
                0
              ],
              [
                -76.6347600002325,
                39.2508799991265,
                0
              ],
              [
                -76.6348810014252,
                39.2511049986027,
                0
              ],
              [
                -76.6349460003152,
                39.2512629993371,
                0
              ],
              [
                -76.6350069999627,
                39.2514579993152,
                0
              ],
              [
                -76.6350449997502,
                39.2516409988706,
                0
              ],
              [
                -76.6350650003383,
                39.2517879990575,
                0
              ],
              [
                -76.6350819994226,
                39.2519620003775,
                0
              ],
              [
                -76.6350930003576,
                39.2521779994314,
                0
              ],
              [
                -76.6350879989799,
                39.2524839986434,
                0
              ],
              [
                -76.6350739998842,
                39.2528179990986,
                0
              ],
              [
                -76.6350579995322,
                39.2529379975782,
                0
              ],
              [
                -76.635028999527,
                39.2530589987349,
                0
              ],
              [
                -76.6350120003315,
                39.2531949989608,
                0
              ],
              [
                -76.6349929996636,
                39.2535029993086,
                0
              ],
              [
                -76.6349549996674,
                39.253732998824,
                0
              ],
              [
                -76.6348729995561,
                39.2543319992726,
                0
              ],
              [
                -76.6347650003569,
                39.254965000179,
                0
              ],
              [
                -76.6346500004781,
                39.2555859988735,
                0
              ],
              [
                -76.6345989999418,
                39.2557999987768,
                0
              ],
              [
                -76.6345530009388,
                39.2559709989185,
                0
              ],
              [
                -76.6345039999868,
                39.2561819991178,
                0
              ],
              [
                -76.6343580005888,
                39.2567509985627,
                0
              ],
              [
                -76.6342750000606,
                39.2570239989069,
                0
              ],
              [
                -76.6341910004786,
                39.2572829990256,
                0
              ],
              [
                -76.6340190001772,
                39.2577559986055,
                0
              ],
              [
                -76.6339630004267,
                39.2579139989019,
                0
              ],
              [
                -76.6337569996728,
                39.2584249990107,
                0
              ],
              [
                -76.633707999607,
                39.2585979989562,
                0
              ],
              [
                -76.6336319998224,
                39.2585039991407,
                0
              ],
              [
                -76.6335050003071,
                39.2583479987939,
                0
              ],
              [
                -76.6334080004604,
                39.2582279992718,
                0
              ],
              [
                -76.633194998854,
                39.2580009990478,
                0
              ],
              [
                -76.6330550003922,
                39.2578919983842,
                0
              ],
              [
                -76.6328619985761,
                39.2577819986282,
                0
              ],
              [
                -76.6328289997731,
                39.2577639989899,
                0
              ],
              [
                -76.632768000132,
                39.2577309986594,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 95,
          "Census_Tract": "24510260800",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "f6f74c8b-e469-4e71-ad41-86dd6f8dbfd7",
          "Shape__Area": 3355001.56842041,
          "Shape__Length": 7323.5476060159335
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.562744000286,
                39.2915949988266,
                0
              ],
              [
                -76.5626600005554,
                39.2904609993917,
                0
              ],
              [
                -76.5625779999261,
                39.2888159988161,
                0
              ],
              [
                -76.5625470004745,
                39.2883509996444,
                0
              ],
              [
                -76.5625130010537,
                39.2878250003576,
                0
              ],
              [
                -76.5627190004548,
                39.287817999168,
                0
              ],
              [
                -76.5631280000724,
                39.2878049988111,
                0
              ],
              [
                -76.5631839997411,
                39.2878029992853,
                0
              ],
              [
                -76.5634250005775,
                39.2877949992481,
                0
              ],
              [
                -76.5636549995682,
                39.287784998692,
                0
              ],
              [
                -76.5653670000679,
                39.2877080004202,
                0
              ],
              [
                -76.5665860001687,
                39.2876659987314,
                0
              ],
              [
                -76.5672359991809,
                39.2876409992894,
                0
              ],
              [
                -76.5681559996622,
                39.2876049990654,
                0
              ],
              [
                -76.5690909994278,
                39.2875649986319,
                0
              ],
              [
                -76.5691579995527,
                39.2885749994134,
                0
              ],
              [
                -76.569213999845,
                39.2894179987036,
                0
              ],
              [
                -76.569258000262,
                39.2901990002318,
                0
              ],
              [
                -76.5693059995362,
                39.2908669994158,
                0
              ],
              [
                -76.5693200003073,
                39.2910979989024,
                0
              ],
              [
                -76.5693340004036,
                39.2913359981889,
                0
              ],
              [
                -76.5693690001482,
                39.2917569993323,
                0
              ],
              [
                -76.5693849995504,
                39.2919549985633,
                0
              ],
              [
                -76.5694130003195,
                39.2924869991264,
                0
              ],
              [
                -76.5675500003455,
                39.2925679993291,
                0
              ],
              [
                -76.5665690000816,
                39.2925999993692,
                0
              ],
              [
                -76.5657009995289,
                39.2926409995711,
                0
              ],
              [
                -76.5641059995497,
                39.2927039988952,
                0
              ],
              [
                -76.562827000073,
                39.2927539992333,
                0
              ],
              [
                -76.5627909999274,
                39.2922479992107,
                0
              ],
              [
                -76.562744000286,
                39.2915949988266,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 96,
          "Census_Tract": "24510080800",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "ba77ec1b-6494-48b0-9aec-533520a83528",
          "Shape__Area": 3524542.8509521484,
          "Shape__Length": 8082.08139419697
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.5881350003318,
                39.303217998809,
                0
              ],
              [
                -76.5880950005023,
                39.3024510001647,
                0
              ],
              [
                -76.5880790011215,
                39.3021379991153,
                0
              ],
              [
                -76.5883499998112,
                39.302128999093,
                0
              ],
              [
                -76.588920999692,
                39.3021089989793,
                0
              ],
              [
                -76.5898169984298,
                39.3020749992777,
                0
              ],
              [
                -76.5904789995009,
                39.3020539986423,
                0
              ],
              [
                -76.5911380006804,
                39.3020269992035,
                0
              ],
              [
                -76.5917880000748,
                39.3020009988664,
                0
              ],
              [
                -76.5924639996272,
                39.3019669990146,
                0
              ],
              [
                -76.5934989997056,
                39.3019269993563,
                0
              ],
              [
                -76.5943510005648,
                39.3018929993241,
                0
              ],
              [
                -76.5943669996982,
                39.3018919988705,
                0
              ],
              [
                -76.5946580000484,
                39.3018809987257,
                0
              ],
              [
                -76.5964420002493,
                39.3018229993777,
                0
              ],
              [
                -76.5973250012087,
                39.3017729994265,
                0
              ],
              [
                -76.597828999503,
                39.3017439989562,
                0
              ],
              [
                -76.5978440006541,
                39.302083998964,
                0
              ],
              [
                -76.5978680002572,
                39.3023999993212,
                0
              ],
              [
                -76.5979200001566,
                39.3031059991284,
                0
              ],
              [
                -76.5980049995683,
                39.3041789990515,
                0
              ],
              [
                -76.5980689994396,
                39.305221999082,
                0
              ],
              [
                -76.5973659998791,
                39.3052629988615,
                0
              ],
              [
                -76.5966399997655,
                39.3053009988334,
                0
              ],
              [
                -76.5952359998446,
                39.3053429993876,
                0
              ],
              [
                -76.5948529996132,
                39.3053570004107,
                0
              ],
              [
                -76.5945640001954,
                39.3053689988127,
                0
              ],
              [
                -76.5925210001188,
                39.3054520003088,
                0
              ],
              [
                -76.5913310003077,
                39.3055519995972,
                0
              ],
              [
                -76.5906859997273,
                39.3055639991259,
                0
              ],
              [
                -76.590027000458,
                39.3056019988699,
                0
              ],
              [
                -76.5894679993497,
                39.3056050004293,
                0
              ],
              [
                -76.5882860000078,
                39.3056399991187,
                0
              ],
              [
                -76.5882499998093,
                39.3051059986907,
                0
              ],
              [
                -76.58823700033,
                39.3048529988698,
                0
              ],
              [
                -76.5882220002451,
                39.3045509989204,
                0
              ],
              [
                -76.5881469995744,
                39.3034889987072,
                0
              ],
              [
                -76.5881350003318,
                39.303217998809,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 97,
          "Census_Tract": "24510160200",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "97aee2a5-5bb0-4695-b344-8ef2dbb1088c",
          "Shape__Area": 4026220.832885742,
          "Shape__Length": 9131.056186561826
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6384619997957,
                39.2941889986873,
                0
              ],
              [
                -76.6391550013281,
                39.2941669988303,
                0
              ],
              [
                -76.639374000031,
                39.2941600004104,
                0
              ],
              [
                -76.6398819997442,
                39.2941359987416,
                0
              ],
              [
                -76.6413019985224,
                39.2940749991169,
                0
              ],
              [
                -76.6420779998216,
                39.2940339988176,
                0
              ],
              [
                -76.6426959998491,
                39.2940089986449,
                0
              ],
              [
                -76.6427439994688,
                39.2947969988219,
                0
              ],
              [
                -76.6427750003897,
                39.2953129993725,
                0
              ],
              [
                -76.6427820010693,
                39.2954700001952,
                0
              ],
              [
                -76.6428369999499,
                39.2965549991635,
                0
              ],
              [
                -76.6428569996093,
                39.2967329991594,
                0
              ],
              [
                -76.6429099994813,
                39.29772799877,
                0
              ],
              [
                -76.6429449994213,
                39.2982779992265,
                0
              ],
              [
                -76.6429750003094,
                39.2988939990456,
                0
              ],
              [
                -76.6429990002742,
                39.2995529988369,
                0
              ],
              [
                -76.6430360004855,
                39.3000179988577,
                0
              ],
              [
                -76.6430580005767,
                39.3005649986135,
                0
              ],
              [
                -76.6430769991821,
                39.3008689993873,
                0
              ],
              [
                -76.643083999548,
                39.3010240002464,
                0
              ],
              [
                -76.6430900003992,
                39.3011089994072,
                0
              ],
              [
                -76.6431459996925,
                39.30171699874,
                0
              ],
              [
                -76.6431810001374,
                39.3022399992019,
                0
              ],
              [
                -76.6431810005637,
                39.3023449994001,
                0
              ],
              [
                -76.6431880012616,
                39.3025060001175,
                0
              ],
              [
                -76.6432020004079,
                39.3028339987512,
                0
              ],
              [
                -76.6432180000639,
                39.3032109991197,
                0
              ],
              [
                -76.6432170002894,
                39.3032709990101,
                0
              ],
              [
                -76.6431310011232,
                39.3032729978411,
                0
              ],
              [
                -76.6425559994742,
                39.30329000017,
                0
              ],
              [
                -76.6423989999832,
                39.3032939992141,
                0
              ],
              [
                -76.6418030004648,
                39.3033079992902,
                0
              ],
              [
                -76.6411160004657,
                39.3033059993476,
                0
              ],
              [
                -76.6404069994913,
                39.3033239986949,
                0
              ],
              [
                -76.6396760003938,
                39.3033619987453,
                0
              ],
              [
                -76.6389669993524,
                39.3033779987359,
                0
              ],
              [
                -76.6389400005169,
                39.302495999344,
                0
              ],
              [
                -76.638853000091,
                39.3011619987099,
                0
              ],
              [
                -76.638816000037,
                39.3005389993782,
                0
              ],
              [
                -76.6388079986853,
                39.3003979991966,
                0
              ],
              [
                -76.6387969994658,
                39.3001369991198,
                0
              ],
              [
                -76.6387870002391,
                39.2997219979386,
                0
              ],
              [
                -76.6387859997715,
                39.2996709994273,
                0
              ],
              [
                -76.6387780000343,
                39.2993689988609,
                0
              ],
              [
                -76.6387569997719,
                39.2990619987286,
                0
              ],
              [
                -76.6386819994631,
                39.2978709989309,
                0
              ],
              [
                -76.6386550002318,
                39.2973799987242,
                0
              ],
              [
                -76.6386489986584,
                39.2972809996524,
                0
              ],
              [
                -76.6386199999015,
                39.2968690004332,
                0
              ],
              [
                -76.6386189995297,
                39.2966889990006,
                0
              ],
              [
                -76.6385519984718,
                39.2954470003371,
                0
              ],
              [
                -76.6384619997957,
                39.2941889986873,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 98,
          "Census_Tract": "24510100100",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "2ea24f2d-da52-4af1-a8a6-23b27028c5ab",
          "Shape__Area": 4884511.409423828,
          "Shape__Length": 10195.966076334362
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.597828999503,
                39.3017439989562,
                0
              ],
              [
                -76.5993700003735,
                39.3016819993457,
                0
              ],
              [
                -76.5999680001312,
                39.3016669989996,
                0
              ],
              [
                -76.600316000125,
                39.3016589991681,
                0
              ],
              [
                -76.6011369997469,
                39.3016439990997,
                0
              ],
              [
                -76.6015209997761,
                39.3016290001162,
                0
              ],
              [
                -76.6020600002382,
                39.3016089987912,
                0
              ],
              [
                -76.6027279999326,
                39.3015779988141,
                0
              ],
              [
                -76.6035499989832,
                39.3015540002121,
                0
              ],
              [
                -76.6041850014793,
                39.3015089990385,
                0
              ],
              [
                -76.6049059997923,
                39.3014910001049,
                0
              ],
              [
                -76.6056650005589,
                39.301444999044,
                0
              ],
              [
                -76.6063889996369,
                39.3014139986501,
                0
              ],
              [
                -76.6072690007968,
                39.301360999103,
                0
              ],
              [
                -76.6077300000016,
                39.3013379997533,
                0
              ],
              [
                -76.6080340005562,
                39.3013279989266,
                0
              ],
              [
                -76.6083089994686,
                39.3013209992414,
                0
              ],
              [
                -76.6090939996509,
                39.3013009991197,
                0
              ],
              [
                -76.6095680005653,
                39.3012839988308,
                0
              ],
              [
                -76.6098310001133,
                39.301273999425,
                0
              ],
              [
                -76.6102759998231,
                39.3012619991605,
                0
              ],
              [
                -76.6107829997928,
                39.3012519987194,
                0
              ],
              [
                -76.6109199997421,
                39.3012499988022,
                0
              ],
              [
                -76.6109600002219,
                39.3012479991616,
                0
              ],
              [
                -76.6111689997934,
                39.301239998684,
                0
              ],
              [
                -76.6112820001864,
                39.3012349986651,
                0
              ],
              [
                -76.6113230000099,
                39.3012329986041,
                0
              ],
              [
                -76.6115509997714,
                39.3012239992063,
                0
              ],
              [
                -76.6115940015382,
                39.3025339989684,
                0
              ],
              [
                -76.6115529995287,
                39.3031799988446,
                0
              ],
              [
                -76.6115479998378,
                39.3032619989219,
                0
              ],
              [
                -76.6115159996334,
                39.3036029988836,
                0
              ],
              [
                -76.6115110002015,
                39.3036569989295,
                0
              ],
              [
                -76.6114970002936,
                39.3038160001402,
                0
              ],
              [
                -76.6114690001653,
                39.303998998944,
                0
              ],
              [
                -76.6114319998073,
                39.3041939993735,
                0
              ],
              [
                -76.6113840002333,
                39.304407999089,
                0
              ],
              [
                -76.6113499995557,
                39.3047149986309,
                0
              ],
              [
                -76.6113100002972,
                39.3047159976723,
                0
              ],
              [
                -76.6112080008314,
                39.3047179985828,
                0
              ],
              [
                -76.6111869996231,
                39.3047189991903,
                0
              ],
              [
                -76.6110769990803,
                39.3047209987326,
                0
              ],
              [
                -76.6108819995336,
                39.3047289985959,
                0
              ],
              [
                -76.6093459998273,
                39.3047959994039,
                0
              ],
              [
                -76.6087859996569,
                39.3048100003833,
                0
              ],
              [
                -76.6081989995343,
                39.3048389990416,
                0
              ],
              [
                -76.6075910001871,
                39.3048699990842,
                0
              ],
              [
                -76.6072900004103,
                39.3048859997654,
                0
              ],
              [
                -76.6065889986906,
                39.3049149993462,
                0
              ],
              [
                -76.6061409993915,
                39.3049279998181,
                0
              ],
              [
                -76.6058849994529,
                39.3049349987452,
                0
              ],
              [
                -76.6051180005452,
                39.3049639987669,
                0
              ],
              [
                -76.604376000313,
                39.3049879985893,
                0
              ],
              [
                -76.6036269991019,
                39.3050179988754,
                0
              ],
              [
                -76.6029920004916,
                39.3050499991878,
                0
              ],
              [
                -76.602239999777,
                39.3050739985767,
                0
              ],
              [
                -76.6018240000217,
                39.3050639991145,
                0
              ],
              [
                -76.6005290003302,
                39.3051349988022,
                0
              ],
              [
                -76.6000209988898,
                39.3051569992967,
                0
              ],
              [
                -76.5995810004749,
                39.3051719989783,
                0
              ],
              [
                -76.5988270001784,
                39.3052089991646,
                0
              ],
              [
                -76.5980689994396,
                39.305221999082,
                0
              ],
              [
                -76.5980049995683,
                39.3041789990515,
                0
              ],
              [
                -76.5979200001566,
                39.3031059991284,
                0
              ],
              [
                -76.5978680002572,
                39.3023999993212,
                0
              ],
              [
                -76.5978440006541,
                39.302083998964,
                0
              ],
              [
                -76.597828999503,
                39.3017439989562,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 99,
          "Census_Tract": "24510130300",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "d677aa7e-7eed-4c7b-83e6-af6d860cbc58",
          "Shape__Area": 3871932.09967041,
          "Shape__Length": 9504.13332115183
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6403030004131,
                39.3151389989243,
                0
              ],
              [
                -76.6401240000096,
                39.314960999094,
                0
              ],
              [
                -76.6399560000004,
                39.3147940002431,
                0
              ],
              [
                -76.6393620002727,
                39.3142029993572,
                0
              ],
              [
                -76.6388980005423,
                39.3137199987924,
                0
              ],
              [
                -76.6377829996,
                39.3126149987213,
                0
              ],
              [
                -76.6372390002354,
                39.3129299993692,
                0
              ],
              [
                -76.6366830000392,
                39.3132459989502,
                0
              ],
              [
                -76.6353189990111,
                39.3117999986638,
                0
              ],
              [
                -76.6340479987828,
                39.3104919993639,
                0
              ],
              [
                -76.6338959997555,
                39.3103349992082,
                0
              ],
              [
                -76.6340309993334,
                39.3103299998819,
                0
              ],
              [
                -76.634193000145,
                39.3103249988854,
                0
              ],
              [
                -76.6347159995594,
                39.3103079991008,
                0
              ],
              [
                -76.63496099975,
                39.310306998553,
                0
              ],
              [
                -76.6357609996033,
                39.3102779987102,
                0
              ],
              [
                -76.6362169985582,
                39.3102689994282,
                0
              ],
              [
                -76.636506999647,
                39.3102660001727,
                0
              ],
              [
                -76.6366949997212,
                39.3102629992568,
                0
              ],
              [
                -76.6368420005207,
                39.3102660000719,
                0
              ],
              [
                -76.6369009996449,
                39.3102819987245,
                0
              ],
              [
                -76.6369859997117,
                39.3103189985796,
                0
              ],
              [
                -76.6380229997842,
                39.3102559992859,
                0
              ],
              [
                -76.6382899999935,
                39.3102399989609,
                0
              ],
              [
                -76.6383310000367,
                39.310236998639,
                0
              ],
              [
                -76.6383719998501,
                39.3102369987129,
                0
              ],
              [
                -76.6388550004284,
                39.3102179991581,
                0
              ],
              [
                -76.6390370009561,
                39.3102099993932,
                0
              ],
              [
                -76.6397200007322,
                39.310176999331,
                0
              ],
              [
                -76.6403890004007,
                39.3101459989704,
                0
              ],
              [
                -76.6409119994071,
                39.3101530001217,
                0
              ],
              [
                -76.6411679985205,
                39.3101449988695,
                0
              ],
              [
                -76.6415020004704,
                39.3101309991354,
                0
              ],
              [
                -76.6425140003439,
                39.310088999422,
                0
              ],
              [
                -76.6433710001247,
                39.3107799988849,
                0
              ],
              [
                -76.643510000215,
                39.3108999992601,
                0
              ],
              [
                -76.64396400004,
                39.3112929988719,
                0
              ],
              [
                -76.6454080000283,
                39.3125149993121,
                0
              ],
              [
                -76.6458760001665,
                39.3128979991386,
                0
              ],
              [
                -76.6463159999163,
                39.3132479992724,
                0
              ],
              [
                -76.6455850001594,
                39.3139219981999,
                0
              ],
              [
                -76.6454419992108,
                39.3140559978437,
                0
              ],
              [
                -76.6450960005794,
                39.3143789991171,
                0
              ],
              [
                -76.6448309992661,
                39.3146239994204,
                0
              ],
              [
                -76.644557001021,
                39.3148759986704,
                0
              ],
              [
                -76.6443350001635,
                39.3150929991884,
                0
              ],
              [
                -76.6441749999355,
                39.3152599989092,
                0
              ],
              [
                -76.6436309997932,
                39.3157929991538,
                0
              ],
              [
                -76.6434499995378,
                39.3156239987062,
                0
              ],
              [
                -76.6432919991697,
                39.3154760003609,
                0
              ],
              [
                -76.6430959998884,
                39.3152989992767,
                0
              ],
              [
                -76.642989000562,
                39.3152089989882,
                0
              ],
              [
                -76.6418490002011,
                39.3140320002914,
                0
              ],
              [
                -76.6410750004148,
                39.3145279991403,
                0
              ],
              [
                -76.6403030004131,
                39.3151389989243,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 100,
          "Census_Tract": "24510060100",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "965c80e1-1d47-438d-a21a-760867566dac",
          "Shape__Area": 2569415.1391601562,
          "Shape__Length": 6456.76345861771
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.5723800011925,
                39.2923809993384,
                0
              ],
              [
                -76.5726320015347,
                39.2923659989724,
                0
              ],
              [
                -76.5733530000392,
                39.2923349986666,
                0
              ],
              [
                -76.5740760004856,
                39.2923119990562,
                0
              ],
              [
                -76.5747980000754,
                39.2922829986102,
                0
              ],
              [
                -76.5755079995299,
                39.2922569994466,
                0
              ],
              [
                -76.5761739994401,
                39.2922319992502,
                0
              ],
              [
                -76.5768870001793,
                39.2922059989802,
                0
              ],
              [
                -76.577623000474,
                39.2921779990209,
                0
              ],
              [
                -76.5776960003374,
                39.2933269993688,
                0
              ],
              [
                -76.5777830012659,
                39.2945819988498,
                0
              ],
              [
                -76.5777869999502,
                39.294905998774,
                0
              ],
              [
                -76.5778430003642,
                39.2958059992812,
                0
              ],
              [
                -76.5779499999459,
                39.2968649993243,
                0
              ],
              [
                -76.5779549998092,
                39.2969110001802,
                0
              ],
              [
                -76.5772359994727,
                39.2969429989491,
                0
              ],
              [
                -76.5765319996404,
                39.2969679989406,
                0
              ],
              [
                -76.5758039996074,
                39.2969939988848,
                0
              ],
              [
                -76.5754899998707,
                39.2970039990554,
                0
              ],
              [
                -76.5750840003831,
                39.2970259997992,
                0
              ],
              [
                -76.5743720004431,
                39.2970479989222,
                0
              ],
              [
                -76.573682000268,
                39.2970839993132,
                0
              ],
              [
                -76.572986999017,
                39.2971060003828,
                0
              ],
              [
                -76.5725969992631,
                39.2971149986721,
                0
              ],
              [
                -76.5725870001013,
                39.2963379989317,
                0
              ],
              [
                -76.572579000382,
                39.2956439996576,
                0
              ],
              [
                -76.5725649997023,
                39.2947769990122,
                0
              ],
              [
                -76.5725219999436,
                39.2941869991294,
                0
              ],
              [
                -76.5724680004419,
                39.2935039987468,
                0
              ],
              [
                -76.5724370015608,
                39.2929379989216,
                0
              ],
              [
                -76.5723800011925,
                39.2923809993384,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 101,
          "Census_Tract": "24510250207",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "fec3e948-13c7-4d46-a2b1-76b6f89a97be",
          "Shape__Area": 9886884.978881836,
          "Shape__Length": 16591.647813197447
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6294884889477,
                39.2586712210299,
                0
              ],
              [
                -76.6289196018444,
                39.2584857940753,
                0
              ],
              [
                -76.6285133357929,
                39.2577152247336,
                0
              ],
              [
                -76.6273097987089,
                39.2577457428465,
                0
              ],
              [
                -76.6269340516111,
                39.256864547616,
                0
              ],
              [
                -76.6264667514124,
                39.2567119598824,
                0
              ],
              [
                -76.6253967291072,
                39.2557048803937,
                0
              ],
              [
                -76.6240978242985,
                39.2552089689085,
                0
              ],
              [
                -76.6224212639393,
                39.2554798122375,
                0
              ],
              [
                -76.6198081972325,
                39.2555294025679,
                0
              ],
              [
                -76.6170692449075,
                39.2561244957655,
                0
              ],
              [
                -76.6169099369079,
                39.2560634849732,
                0
              ],
              [
                -76.6169340003562,
                39.2560129997075,
                0
              ],
              [
                -76.6171430003222,
                39.2556269991817,
                0
              ],
              [
                -76.617230999517,
                39.255512999186,
                0
              ],
              [
                -76.6173280003195,
                39.2553689986136,
                0
              ],
              [
                -76.6174299998818,
                39.2552129988819,
                0
              ],
              [
                -76.6175119994591,
                39.2550659992504,
                0
              ],
              [
                -76.6175870003293,
                39.2549149989656,
                0
              ],
              [
                -76.6176489995647,
                39.2547649993812,
                0
              ],
              [
                -76.6177180004659,
                39.2546049987922,
                0
              ],
              [
                -76.6177749998474,
                39.2544549999659,
                0
              ],
              [
                -76.6178160005684,
                39.2543259991151,
                0
              ],
              [
                -76.6178620002211,
                39.2541539991668,
                0
              ],
              [
                -76.6178909997628,
                39.2540129988022,
                0
              ],
              [
                -76.617912000109,
                39.2538939989141,
                0
              ],
              [
                -76.617922999642,
                39.2536959987033,
                0
              ],
              [
                -76.6179150004702,
                39.2535309994096,
                0
              ],
              [
                -76.6178699995089,
                39.2533729993741,
                0
              ],
              [
                -76.6178399997884,
                39.2532459985899,
                0
              ],
              [
                -76.6178100000071,
                39.253146999123,
                0
              ],
              [
                -76.6177659997583,
                39.2530439987884,
                0
              ],
              [
                -76.6177140003944,
                39.2529339986299,
                0
              ],
              [
                -76.6176609996169,
                39.2528339991337,
                0
              ],
              [
                -76.6175999996056,
                39.252737999099,
                0
              ],
              [
                -76.6175040005235,
                39.2525979986065,
                0
              ],
              [
                -76.6174209996742,
                39.2524839987722,
                0
              ],
              [
                -76.6173490001939,
                39.2524119989014,
                0
              ],
              [
                -76.6184360005584,
                39.2519459992222,
                0
              ],
              [
                -76.6197689994268,
                39.2513699988475,
                0
              ],
              [
                -76.6200840000447,
                39.2512339987798,
                0
              ],
              [
                -76.6204980001668,
                39.2510579994227,
                0
              ],
              [
                -76.6208809995654,
                39.2508949993091,
                0
              ],
              [
                -76.6220010005565,
                39.2504149985914,
                0
              ],
              [
                -76.6220680004531,
                39.2503859977909,
                0
              ],
              [
                -76.6223870002575,
                39.2502489991477,
                0
              ],
              [
                -76.6226389994629,
                39.2501409989979,
                0
              ],
              [
                -76.6232440004954,
                39.2498819986715,
                0
              ],
              [
                -76.6236389998159,
                39.2497119993415,
                0
              ],
              [
                -76.6245419998347,
                39.2493229985859,
                0
              ],
              [
                -76.6248090003206,
                39.2491979991639,
                0
              ],
              [
                -76.6249569999461,
                39.2491319996585,
                0
              ],
              [
                -76.6250430002717,
                39.2491029993,
                0
              ],
              [
                -76.6251429998202,
                39.2490739994378,
                0
              ],
              [
                -76.6252080002347,
                39.2490659991302,
                0
              ],
              [
                -76.6252729994578,
                39.2490669992821,
                0
              ],
              [
                -76.6253979998937,
                39.249081998765,
                0
              ],
              [
                -76.6256410005332,
                39.2491619993012,
                0
              ],
              [
                -76.6259729990841,
                39.2492909992541,
                0
              ],
              [
                -76.6260999996819,
                39.2493369989691,
                0
              ],
              [
                -76.6262000001556,
                39.2493649989654,
                0
              ],
              [
                -76.6264129994558,
                39.249426998658,
                0
              ],
              [
                -76.6267639996099,
                39.249541999394,
                0
              ],
              [
                -76.6275349995946,
                39.2498209987232,
                0
              ],
              [
                -76.6274779995439,
                39.24992499917,
                0
              ],
              [
                -76.6273579993328,
                39.2501079989691,
                0
              ],
              [
                -76.627288000394,
                39.2502229997001,
                0
              ],
              [
                -76.6272400001111,
                39.2502839988005,
                0
              ],
              [
                -76.627188999644,
                39.2503329991035,
                0
              ],
              [
                -76.6271369999413,
                39.2503659994337,
                0
              ],
              [
                -76.6270780008794,
                39.2504019977916,
                0
              ],
              [
                -76.6270279987747,
                39.2504249986634,
                0
              ],
              [
                -76.626979999977,
                39.2504419986427,
                0
              ],
              [
                -76.6269149987016,
                39.2504589986224,
                0
              ],
              [
                -76.6268579994726,
                39.2504719993567,
                0
              ],
              [
                -76.626778999461,
                39.250481999024,
                0
              ],
              [
                -76.6267139998992,
                39.2504849991287,
                0
              ],
              [
                -76.6266330002753,
                39.2504819987313,
                0
              ],
              [
                -76.6265550004502,
                39.2504709990722,
                0
              ],
              [
                -76.6264920001182,
                39.2504579996283,
                0
              ],
              [
                -76.6261540003542,
                39.2503409992731,
                0
              ],
              [
                -76.6258600004481,
                39.2502339988879,
                0
              ],
              [
                -76.6253509989808,
                39.2500449993638,
                0
              ],
              [
                -76.6252979999239,
                39.2500349992271,
                0
              ],
              [
                -76.6252569997344,
                39.2500319976166,
                0
              ],
              [
                -76.6251999995142,
                39.2500429987351,
                0
              ],
              [
                -76.6250860001515,
                39.250073998687,
                0
              ],
              [
                -76.6256089997816,
                39.2509189992267,
                0
              ],
              [
                -76.6258459998218,
                39.2513009993104,
                0
              ],
              [
                -76.6259709997339,
                39.2515310002271,
                0
              ],
              [
                -76.6260999999021,
                39.2517369992083,
                0
              ],
              [
                -76.6261690003029,
                39.251780999936,
                0
              ],
              [
                -76.6262580001983,
                39.2518129993748,
                0
              ],
              [
                -76.6263709994861,
                39.2518319986436,
                0
              ],
              [
                -76.6265089999748,
                39.2518199989761,
                0
              ],
              [
                -76.6266639998653,
                39.2517799987255,
                0
              ],
              [
                -76.6267450002926,
                39.2514149985897,
                0
              ],
              [
                -76.6274270000005,
                39.2515799986653,
                0
              ],
              [
                -76.6277149997808,
                39.2508599990254,
                0
              ],
              [
                -76.6279350013361,
                39.2503309985713,
                0
              ],
              [
                -76.6280259999063,
                39.2501259986881,
                0
              ],
              [
                -76.6280769997005,
                39.2500310001896,
                0
              ],
              [
                -76.6282500004084,
                39.2500869985944,
                0
              ],
              [
                -76.6283770005415,
                39.2501270002993,
                0
              ],
              [
                -76.6284759997041,
                39.2501569993885,
                0
              ],
              [
                -76.6289739999883,
                39.2502809987378,
                0
              ],
              [
                -76.6293690004921,
                39.2503810004335,
                0
              ],
              [
                -76.6297819997145,
                39.2504929990569,
                0
              ],
              [
                -76.6303259997607,
                39.2506239988467,
                0
              ],
              [
                -76.6312209990343,
                39.2508459986275,
                0
              ],
              [
                -76.6313730005402,
                39.2508969992338,
                0
              ],
              [
                -76.6314010000463,
                39.2509069992097,
                0
              ],
              [
                -76.6316240007368,
                39.2509919994278,
                0
              ],
              [
                -76.631832000092,
                39.2510749993108,
                0
              ],
              [
                -76.6319409995966,
                39.2511269992958,
                0
              ],
              [
                -76.6320570001965,
                39.2511959988263,
                0
              ],
              [
                -76.6321980004282,
                39.2512829991711,
                0
              ],
              [
                -76.6322559990383,
                39.251320998757,
                0
              ],
              [
                -76.632600999875,
                39.2515439987379,
                0
              ],
              [
                -76.6327420000817,
                39.2516549994219,
                0
              ],
              [
                -76.632867999927,
                39.2517659998687,
                0
              ],
              [
                -76.6329930004947,
                39.2518939990765,
                0
              ],
              [
                -76.6331450000965,
                39.2520439991282,
                0
              ],
              [
                -76.6332840002626,
                39.252193998909,
                0
              ],
              [
                -76.6333649985356,
                39.2523039989041,
                0
              ],
              [
                -76.6334459997705,
                39.252421998581,
                0
              ],
              [
                -76.6334769996183,
                39.2524779989026,
                0
              ],
              [
                -76.6335260000013,
                39.2525689980434,
                0
              ],
              [
                -76.6336260002835,
                39.2527409994517,
                0
              ],
              [
                -76.6336590000823,
                39.2528079989477,
                0
              ],
              [
                -76.6336890000073,
                39.2528669992508,
                0
              ],
              [
                -76.6337419995593,
                39.2529769980802,
                0
              ],
              [
                -76.6337990003854,
                39.2531409987624,
                0
              ],
              [
                -76.6338770005085,
                39.253388997654,
                0
              ],
              [
                -76.6339260005316,
                39.2535780002719,
                0
              ],
              [
                -76.6340240005381,
                39.2539310000673,
                0
              ],
              [
                -76.6340499996658,
                39.2540629987104,
                0
              ],
              [
                -76.6342059990971,
                39.2546089994189,
                0
              ],
              [
                -76.6342389994932,
                39.2547489988129,
                0
              ],
              [
                -76.6342880003306,
                39.2549579991677,
                0
              ],
              [
                -76.6343109996208,
                39.255109998943,
                0
              ],
              [
                -76.6343130000781,
                39.2552919991638,
                0
              ],
              [
                -76.6342970014095,
                39.2554699997532,
                0
              ],
              [
                -76.6342669992581,
                39.2556109990843,
                0
              ],
              [
                -76.6342419987462,
                39.2556759990319,
                0
              ],
              [
                -76.6342130004366,
                39.2557509985607,
                0
              ],
              [
                -76.6341530002734,
                39.2558989988502,
                0
              ],
              [
                -76.6340030000565,
                39.2561489990563,
                0
              ],
              [
                -76.6338559998543,
                39.2563189985657,
                0
              ],
              [
                -76.6335709994546,
                39.256628998891,
                0
              ],
              [
                -76.6334179995052,
                39.2568089992574,
                0
              ],
              [
                -76.6333690000571,
                39.2568679988215,
                0
              ],
              [
                -76.6331799995499,
                39.2570909990223,
                0
              ],
              [
                -76.6330820005725,
                39.2572269988735,
                0
              ],
              [
                -76.632944000269,
                39.2574389993156,
                0
              ],
              [
                -76.6328090001704,
                39.2576550002702,
                0
              ],
              [
                -76.632768000132,
                39.2577309986594,
                0
              ],
              [
                -76.6325399995778,
                39.2576669992204,
                0
              ],
              [
                -76.6322700009524,
                39.257596999315,
                0
              ],
              [
                -76.6319459997705,
                39.2575399987594,
                0
              ],
              [
                -76.6300899997128,
                39.2588239996694,
                0
              ],
              [
                -76.6299979999886,
                39.2587959985945,
                0
              ],
              [
                -76.6298009994835,
                39.2587319987572,
                0
              ],
              [
                -76.6294939995239,
                39.2586689991084,
                0
              ],
              [
                -76.6294884889477,
                39.2586712210299,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 102,
          "Census_Tract": "24510250301",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "1886100e-e315-4e53-baa3-c04819485fdd",
          "Shape__Area": 20566605.43371582,
          "Shape__Length": 24075.100950006934
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6334719994538,
                39.2695449989991,
                0
              ],
              [
                -76.63332099996,
                39.2695169993696,
                0
              ],
              [
                -76.6333010006501,
                39.2695129996827,
                0
              ],
              [
                -76.6321439996211,
                39.2692999985777,
                0
              ],
              [
                -76.6319750002602,
                39.2692629980361,
                0
              ],
              [
                -76.6318609994374,
                39.2692419979073,
                0
              ],
              [
                -76.6316919990435,
                39.2691989996598,
                0
              ],
              [
                -76.6315960001694,
                39.2691770000304,
                0
              ],
              [
                -76.6311419998302,
                39.269073999321,
                0
              ],
              [
                -76.6299700015367,
                39.268813997955,
                0
              ],
              [
                -76.6287970015052,
                39.268539998199,
                0
              ],
              [
                -76.6284819999923,
                39.26861999895,
                0
              ],
              [
                -76.6280809988901,
                39.2685269993792,
                0
              ],
              [
                -76.6274640002317,
                39.2683909991047,
                0
              ],
              [
                -76.6265609990593,
                39.2682009998724,
                0
              ],
              [
                -76.6264559999533,
                39.2681979987803,
                0
              ],
              [
                -76.6263709987688,
                39.2681999992148,
                0
              ],
              [
                -76.6261369998102,
                39.2681949993118,
                0
              ],
              [
                -76.6258757474473,
                39.2681894401244,
                0
              ],
              [
                -76.6258592744726,
                39.2681827183779,
                0
              ],
              [
                -76.6259039999046,
                39.2681169986793,
                0
              ],
              [
                -76.626010000783,
                39.2679619992638,
                0
              ],
              [
                -76.6260839999833,
                39.267853999797,
                0
              ],
              [
                -76.6259169999904,
                39.2676299988145,
                0
              ],
              [
                -76.6257919995355,
                39.2674619987051,
                0
              ],
              [
                -76.62563100049,
                39.2672469988424,
                0
              ],
              [
                -76.625651876448,
                39.2671698481397,
                0
              ],
              [
                -76.6256940956655,
                39.2671477130769,
                0
              ],
              [
                -76.6257409990711,
                39.2671310002241,
                0
              ],
              [
                -76.6257999998438,
                39.2671369990765,
                0
              ],
              [
                -76.6258400002275,
                39.2671569992205,
                0
              ],
              [
                -76.6259330013756,
                39.2671699989865,
                0
              ],
              [
                -76.626088001345,
                39.267111998662,
                0
              ],
              [
                -76.6262079992271,
                39.2670199990188,
                0
              ],
              [
                -76.6263020003553,
                39.2668859993908,
                0
              ],
              [
                -76.6265819991233,
                39.2665470004341,
                0
              ],
              [
                -76.6267079995632,
                39.2664189986257,
                0
              ],
              [
                -76.6268520005449,
                39.2661469988685,
                0
              ],
              [
                -76.6268529999528,
                39.2660289989876,
                0
              ],
              [
                -76.6268495274634,
                39.2660007237158,
                0
              ],
              [
                -76.6271286008893,
                39.265180587878,
                0
              ],
              [
                -76.6276149749914,
                39.2649974821867,
                0
              ],
              [
                -76.6283950805463,
                39.2640972142227,
                0
              ],
              [
                -76.6294994352647,
                39.2622852326489,
                0
              ],
              [
                -76.6291694653899,
                39.2619190210618,
                0
              ],
              [
                -76.6293830865361,
                39.2614154811587,
                0
              ],
              [
                -76.6303520195492,
                39.2597064971202,
                0
              ],
              [
                -76.6309280404068,
                39.2594890594431,
                0
              ],
              [
                -76.6309776298746,
                39.2592754361078,
                0
              ],
              [
                -76.6300258631632,
                39.2592067716424,
                0
              ],
              [
                -76.6303825385354,
                39.2589626311416,
                0
              ],
              [
                -76.6294884889477,
                39.2586712210299,
                0
              ],
              [
                -76.6294939995239,
                39.2586689991084,
                0
              ],
              [
                -76.6298009994835,
                39.2587319987572,
                0
              ],
              [
                -76.6299979999886,
                39.2587959985945,
                0
              ],
              [
                -76.6300899997128,
                39.2588239996694,
                0
              ],
              [
                -76.6319459997705,
                39.2575399987594,
                0
              ],
              [
                -76.6322700009524,
                39.257596999315,
                0
              ],
              [
                -76.6325399995778,
                39.2576669992204,
                0
              ],
              [
                -76.632768000132,
                39.2577309986594,
                0
              ],
              [
                -76.6328289997731,
                39.2577639989899,
                0
              ],
              [
                -76.6328619985761,
                39.2577819986282,
                0
              ],
              [
                -76.6330550003922,
                39.2578919983842,
                0
              ],
              [
                -76.633194998854,
                39.2580009990478,
                0
              ],
              [
                -76.6334080004604,
                39.2582279992718,
                0
              ],
              [
                -76.6335050003071,
                39.2583479987939,
                0
              ],
              [
                -76.6336319998224,
                39.2585039991407,
                0
              ],
              [
                -76.633707999607,
                39.2585979989562,
                0
              ],
              [
                -76.6337569996728,
                39.2584249990107,
                0
              ],
              [
                -76.6339630004267,
                39.2579139989019,
                0
              ],
              [
                -76.6340190001772,
                39.2577559986055,
                0
              ],
              [
                -76.6341910004786,
                39.2572829990256,
                0
              ],
              [
                -76.6342750000606,
                39.2570239989069,
                0
              ],
              [
                -76.6343580005888,
                39.2567509985627,
                0
              ],
              [
                -76.6345039999868,
                39.2561819991178,
                0
              ],
              [
                -76.6345530009388,
                39.2559709989185,
                0
              ],
              [
                -76.6345989999418,
                39.2557999987768,
                0
              ],
              [
                -76.6346500004781,
                39.2555859988735,
                0
              ],
              [
                -76.6347650003569,
                39.254965000179,
                0
              ],
              [
                -76.6348729995561,
                39.2543319992726,
                0
              ],
              [
                -76.6349549996674,
                39.253732998824,
                0
              ],
              [
                -76.6349929996636,
                39.2535029993086,
                0
              ],
              [
                -76.6350120003315,
                39.2531949989608,
                0
              ],
              [
                -76.635028999527,
                39.2530589987349,
                0
              ],
              [
                -76.6350579995322,
                39.2529379975782,
                0
              ],
              [
                -76.6350739998842,
                39.2528179990986,
                0
              ],
              [
                -76.6350879989799,
                39.2524839986434,
                0
              ],
              [
                -76.6350930003576,
                39.2521779994314,
                0
              ],
              [
                -76.6350819994226,
                39.2519620003775,
                0
              ],
              [
                -76.6350650003383,
                39.2517879990575,
                0
              ],
              [
                -76.6350449997502,
                39.2516409988706,
                0
              ],
              [
                -76.6350069999627,
                39.2514579993152,
                0
              ],
              [
                -76.6349460003152,
                39.2512629993371,
                0
              ],
              [
                -76.6348810014252,
                39.2511049986027,
                0
              ],
              [
                -76.6347600002325,
                39.2508799991265,
                0
              ],
              [
                -76.6347089995803,
                39.2507939989114,
                0
              ],
              [
                -76.6346539999224,
                39.2506919993664,
                0
              ],
              [
                -76.6344970005537,
                39.2504349994146,
                0
              ],
              [
                -76.6341690004277,
                39.2499579993532,
                0
              ],
              [
                -76.6341089985249,
                39.2498449990476,
                0
              ],
              [
                -76.6355230012499,
                39.2514870000549,
                0
              ],
              [
                -76.6363570001404,
                39.2524549991071,
                0
              ],
              [
                -76.6374619994305,
                39.2538069989348,
                0
              ],
              [
                -76.6375550009631,
                39.2539189994021,
                0
              ],
              [
                -76.638463000314,
                39.2550269986082,
                0
              ],
              [
                -76.6386539993745,
                39.2552449987248,
                0
              ],
              [
                -76.6392869999199,
                39.2559790003259,
                0
              ],
              [
                -76.6395980000024,
                39.25635499913,
                0
              ],
              [
                -76.6399109996336,
                39.2567390002097,
                0
              ],
              [
                -76.6401040002815,
                39.2569629985811,
                0
              ],
              [
                -76.640214999689,
                39.2570919990232,
                0
              ],
              [
                -76.6403990004836,
                39.2572899992679,
                0
              ],
              [
                -76.6405560013668,
                39.2574639993772,
                0
              ],
              [
                -76.6406599991392,
                39.2575669988997,
                0
              ],
              [
                -76.6407619999619,
                39.2576639994092,
                0
              ],
              [
                -76.6409010004639,
                39.2578059991378,
                0
              ],
              [
                -76.6409969994901,
                39.2578909990686,
                0
              ],
              [
                -76.6412160004424,
                39.2580719994003,
                0
              ],
              [
                -76.6413489995226,
                39.2581839990922,
                0
              ],
              [
                -76.6414439997371,
                39.2582549985678,
                0
              ],
              [
                -76.6417790005456,
                39.2584909997344,
                0
              ],
              [
                -76.6418919996222,
                39.2585659991071,
                0
              ],
              [
                -76.6420569999991,
                39.2586789990346,
                0
              ],
              [
                -76.6422829997422,
                39.2588199993619,
                0
              ],
              [
                -76.6424419998437,
                39.2589119988841,
                0
              ],
              [
                -76.6425650004589,
                39.2589759990553,
                0
              ],
              [
                -76.6427029995925,
                39.259052998668,
                0
              ],
              [
                -76.6429029995786,
                39.2591489992047,
                0
              ],
              [
                -76.6433509995024,
                39.259374998573,
                0
              ],
              [
                -76.6434869992833,
                39.2594339992551,
                0
              ],
              [
                -76.6436539994432,
                39.2595049992965,
                0
              ],
              [
                -76.6440600001479,
                39.259647998794,
                0
              ],
              [
                -76.6445619999523,
                39.2598149992872,
                0
              ],
              [
                -76.6448929988937,
                39.2599099993606,
                0
              ],
              [
                -76.6453599985216,
                39.2600139990238,
                0
              ],
              [
                -76.645670000332,
                39.2600809988976,
                0
              ],
              [
                -76.6458750004993,
                39.2601199989749,
                0
              ],
              [
                -76.6461890005106,
                39.260170999301,
                0
              ],
              [
                -76.6465119998503,
                39.2602169986966,
                0
              ],
              [
                -76.6468000006625,
                39.2602489994112,
                0
              ],
              [
                -76.6469540005407,
                39.2602599987846,
                0
              ],
              [
                -76.6472729994464,
                39.2602829991898,
                0
              ],
              [
                -76.6478939991251,
                39.260313999107,
                0
              ],
              [
                -76.648858999508,
                39.2603139990443,
                0
              ],
              [
                -76.649834000424,
                39.2603139992548,
                0
              ],
              [
                -76.6485409984789,
                39.2613789995597,
                0
              ],
              [
                -76.6483899995145,
                39.2615049989233,
                0
              ],
              [
                -76.6460350005736,
                39.2633029991516,
                0
              ],
              [
                -76.6445040003106,
                39.2644929990299,
                0
              ],
              [
                -76.644071998845,
                39.2648279985839,
                0
              ],
              [
                -76.6440209995338,
                39.2648680001364,
                0
              ],
              [
                -76.6433750001483,
                39.2653759996192,
                0
              ],
              [
                -76.6426909995818,
                39.2659139987819,
                0
              ],
              [
                -76.641243999865,
                39.2670379985907,
                0
              ],
              [
                -76.6405229992782,
                39.2676049990708,
                0
              ],
              [
                -76.6399489999575,
                39.2680679994325,
                0
              ],
              [
                -76.6388739996449,
                39.268937999376,
                0
              ],
              [
                -76.6386800003072,
                39.2690719985625,
                0
              ],
              [
                -76.638222999089,
                39.26942799892,
                0
              ],
              [
                -76.6378279995672,
                39.2697409988303,
                0
              ],
              [
                -76.6375480002166,
                39.2699649992154,
                0
              ],
              [
                -76.637329998474,
                39.2701399978358,
                0
              ],
              [
                -76.6365230015744,
                39.2700239985774,
                0
              ],
              [
                -76.6353649996819,
                39.2698829999995,
                0
              ],
              [
                -76.6348410009556,
                39.2697969990966,
                0
              ],
              [
                -76.6344400005263,
                39.2697299993766,
                0
              ],
              [
                -76.6339320001995,
                39.2696269990305,
                0
              ],
              [
                -76.6334860000351,
                39.2695479990033,
                0
              ],
              [
                -76.6334719994538,
                39.2695449989991,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 103,
          "Census_Tract": "24510250303",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "e483d8a6-a997-41c4-aa39-71445afa1fa3",
          "Shape__Area": 11144363.699157715,
          "Shape__Length": 14681.111180727652
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.637329998474,
                39.2701399978358,
                0
              ],
              [
                -76.6375480002166,
                39.2699649992154,
                0
              ],
              [
                -76.6378279995672,
                39.2697409988303,
                0
              ],
              [
                -76.638222999089,
                39.26942799892,
                0
              ],
              [
                -76.6386800003072,
                39.2690719985625,
                0
              ],
              [
                -76.6388739996449,
                39.268937999376,
                0
              ],
              [
                -76.6399489999575,
                39.2680679994325,
                0
              ],
              [
                -76.6405229992782,
                39.2676049990708,
                0
              ],
              [
                -76.641243999865,
                39.2670379985907,
                0
              ],
              [
                -76.6426909995818,
                39.2659139987819,
                0
              ],
              [
                -76.6433750001483,
                39.2653759996192,
                0
              ],
              [
                -76.6440209995338,
                39.2648680001364,
                0
              ],
              [
                -76.644071998845,
                39.2648279985839,
                0
              ],
              [
                -76.6445040003106,
                39.2644929990299,
                0
              ],
              [
                -76.6460350005736,
                39.2633029991516,
                0
              ],
              [
                -76.6483899995145,
                39.2615049989233,
                0
              ],
              [
                -76.6485409984789,
                39.2613789995597,
                0
              ],
              [
                -76.649834000424,
                39.2603139992548,
                0
              ],
              [
                -76.6506150005502,
                39.2603599992607,
                0
              ],
              [
                -76.6507179995643,
                39.2603789992818,
                0
              ],
              [
                -76.6508349999033,
                39.2604069980687,
                0
              ],
              [
                -76.6509550001968,
                39.2604429999594,
                0
              ],
              [
                -76.651045000558,
                39.2604769993523,
                0
              ],
              [
                -76.6511319994483,
                39.2605129993689,
                0
              ],
              [
                -76.6511970002037,
                39.2605469991333,
                0
              ],
              [
                -76.6512599997319,
                39.2605859993783,
                0
              ],
              [
                -76.6513970008743,
                39.2606759991103,
                0
              ],
              [
                -76.6514480004278,
                39.2607180001117,
                0
              ],
              [
                -76.6515570002694,
                39.2608239988194,
                0
              ],
              [
                -76.6516370013499,
                39.2609149992089,
                0
              ],
              [
                -76.6516769993722,
                39.2609699988573,
                0
              ],
              [
                -76.6516900014433,
                39.2609939987119,
                0
              ],
              [
                -76.6517169992204,
                39.2610439992633,
                0
              ],
              [
                -76.6519029995571,
                39.2614339989127,
                0
              ],
              [
                -76.651886000342,
                39.2615879993717,
                0
              ],
              [
                -76.6518520004987,
                39.2618319990187,
                0
              ],
              [
                -76.6517839999434,
                39.2623759988571,
                0
              ],
              [
                -76.6517559997316,
                39.2625329986135,
                0
              ],
              [
                -76.6517360001429,
                39.262660999404,
                0
              ],
              [
                -76.6517180000899,
                39.2628199996718,
                0
              ],
              [
                -76.6517089996509,
                39.2629369986861,
                0
              ],
              [
                -76.6516940010753,
                39.2632849993248,
                0
              ],
              [
                -76.6516929999686,
                39.2634629993884,
                0
              ],
              [
                -76.6516919994444,
                39.2635709991371,
                0
              ],
              [
                -76.6516969990494,
                39.2636909986644,
                0
              ],
              [
                -76.6517150014087,
                39.2638089992198,
                0
              ],
              [
                -76.6517440000619,
                39.2639320001016,
                0
              ],
              [
                -76.6517730004481,
                39.2640319990257,
                0
              ],
              [
                -76.6518490005067,
                39.2642309990126,
                0
              ],
              [
                -76.6518959991544,
                39.264333998559,
                0
              ],
              [
                -76.651941999711,
                39.2644389993281,
                0
              ],
              [
                -76.6520119997935,
                39.2645549992818,
                0
              ],
              [
                -76.6520729997353,
                39.2646419994036,
                0
              ],
              [
                -76.6521829998896,
                39.2647859991419,
                0
              ],
              [
                -76.6522669997715,
                39.2648839989634,
                0
              ],
              [
                -76.6524449997261,
                39.2650689990414,
                0
              ],
              [
                -76.6525479997381,
                39.2651609990369,
                0
              ],
              [
                -76.6527399997761,
                39.2653159986474,
                0
              ],
              [
                -76.6529899998613,
                39.2654999992238,
                0
              ],
              [
                -76.6534220001298,
                39.2658219986764,
                0
              ],
              [
                -76.6536250004561,
                39.2660529988854,
                0
              ],
              [
                -76.6537670003682,
                39.2662039994093,
                0
              ],
              [
                -76.6539289996097,
                39.2664199993378,
                0
              ],
              [
                -76.6540839998333,
                39.2666689986487,
                0
              ],
              [
                -76.6541650002159,
                39.2668479993937,
                0
              ],
              [
                -76.654239000246,
                39.2669949987101,
                0
              ],
              [
                -76.6542860010832,
                39.2671159989911,
                0
              ],
              [
                -76.6545160000358,
                39.2678569989627,
                0
              ],
              [
                -76.6545929995583,
                39.2681939987732,
                0
              ],
              [
                -76.6547019994963,
                39.2687209989284,
                0
              ],
              [
                -76.6547839995577,
                39.269180999964,
                0
              ],
              [
                -76.6548750004641,
                39.2697919989814,
                0
              ],
              [
                -76.6549130000847,
                39.2703909988495,
                0
              ],
              [
                -76.6549310004668,
                39.2705689994327,
                0
              ],
              [
                -76.6549339994455,
                39.2705949988826,
                0
              ],
              [
                -76.6549749992738,
                39.2709839988594,
                0
              ],
              [
                -76.6549960003978,
                39.2711919991414,
                0
              ],
              [
                -76.6541909998933,
                39.2713999986796,
                0
              ],
              [
                -76.6535590002042,
                39.2715009997123,
                0
              ],
              [
                -76.6532639996989,
                39.271538999804,
                0
              ],
              [
                -76.6531329994513,
                39.2715479989356,
                0
              ],
              [
                -76.6524750008993,
                39.2715839993174,
                0
              ],
              [
                -76.6521110002544,
                39.2715799995919,
                0
              ],
              [
                -76.6518849999494,
                39.2715659986333,
                0
              ],
              [
                -76.6514740000877,
                39.2715299994068,
                0
              ],
              [
                -76.6510780001236,
                39.2714969987104,
                0
              ],
              [
                -76.6484079995614,
                39.2712509983617,
                0
              ],
              [
                -76.6480779997232,
                39.2712209990884,
                0
              ],
              [
                -76.6473699999759,
                39.2711639991137,
                0
              ],
              [
                -76.6443709995681,
                39.2708949994067,
                0
              ],
              [
                -76.6435990013485,
                39.27082599907,
                0
              ],
              [
                -76.6423670002831,
                39.2707409987073,
                0
              ],
              [
                -76.6398290003914,
                39.2704999988449,
                0
              ],
              [
                -76.6395050001302,
                39.270466998812,
                0
              ],
              [
                -76.639053999929,
                39.2704209987376,
                0
              ],
              [
                -76.6380489984249,
                39.2702419990253,
                0
              ],
              [
                -76.637329998474,
                39.2701399978358,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 104,
          "Census_Tract": "24510250401",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "2fa27f76-ad7a-44a0-b1e7-59c9572c885c",
          "Shape__Area": 12709264.468078613,
          "Shape__Length": 16915.807462235418
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.5955519991532,
                39.2391429989933,
                0
              ],
              [
                -76.5956149994972,
                39.2390039986529,
                0
              ],
              [
                -76.5956850001751,
                39.2388609986256,
                0
              ],
              [
                -76.5958200000209,
                39.2385969988413,
                0
              ],
              [
                -76.5968539995785,
                39.2365399989829,
                0
              ],
              [
                -76.5974160002318,
                39.2354579989912,
                0
              ],
              [
                -76.5977319995377,
                39.234913998895,
                0
              ],
              [
                -76.5977420003413,
                39.2348979993661,
                0
              ],
              [
                -76.599318999909,
                39.2353889990319,
                0
              ],
              [
                -76.59959499952,
                39.2354709988542,
                0
              ],
              [
                -76.5996919984457,
                39.235501999272,
                0
              ],
              [
                -76.5998140012988,
                39.2355409999651,
                0
              ],
              [
                -76.6007829994286,
                39.2358259988135,
                0
              ],
              [
                -76.6010190003112,
                39.2358969985841,
                0
              ],
              [
                -76.6013370003138,
                39.2359949987775,
                0
              ],
              [
                -76.6016369987929,
                39.2360849993869,
                0
              ],
              [
                -76.6023530011262,
                39.2363029986644,
                0
              ],
              [
                -76.6026139994354,
                39.2357859991393,
                0
              ],
              [
                -76.6028639990349,
                39.2352719991745,
                0
              ],
              [
                -76.6031259997885,
                39.2347489990124,
                0
              ],
              [
                -76.6033919992142,
                39.2342409988108,
                0
              ],
              [
                -76.6036210009931,
                39.2337249993402,
                0
              ],
              [
                -76.6036869997062,
                39.2335999990973,
                0
              ],
              [
                -76.6039050003381,
                39.2332339986202,
                0
              ],
              [
                -76.6042050008912,
                39.2326229993447,
                0
              ],
              [
                -76.6043209997819,
                39.2327279992974,
                0
              ],
              [
                -76.6047140002416,
                39.2325589993573,
                0
              ],
              [
                -76.6051050001673,
                39.2323969994038,
                0
              ],
              [
                -76.6064169994246,
                39.2318249987264,
                0
              ],
              [
                -76.6066990006834,
                39.2317169987455,
                0
              ],
              [
                -76.607474000321,
                39.2313949993417,
                0
              ],
              [
                -76.6078080004279,
                39.2312599986714,
                0
              ],
              [
                -76.6081670001726,
                39.2310989994434,
                0
              ],
              [
                -76.6081920002585,
                39.2311209987728,
                0
              ],
              [
                -76.6082309996828,
                39.2311729992219,
                0
              ],
              [
                -76.6083510003876,
                39.2313289987937,
                0
              ],
              [
                -76.6083920005464,
                39.2313819994169,
                0
              ],
              [
                -76.6084879997934,
                39.2314650000634,
                0
              ],
              [
                -76.6087769995861,
                39.2317140003519,
                0
              ],
              [
                -76.6088740004334,
                39.2317970004072,
                0
              ],
              [
                -76.6090259999604,
                39.2319629990926,
                0
              ],
              [
                -76.6092400005719,
                39.2321959991988,
                0
              ],
              [
                -76.6094839998562,
                39.2324619986247,
                0
              ],
              [
                -76.6096069997309,
                39.2325949992126,
                0
              ],
              [
                -76.6096380001698,
                39.2326279986298,
                0
              ],
              [
                -76.609852000121,
                39.2328099992652,
                0
              ],
              [
                -76.6104940002149,
                39.2333579993754,
                0
              ],
              [
                -76.6107079990736,
                39.2335409991559,
                0
              ],
              [
                -76.6107399996131,
                39.2335689995829,
                0
              ],
              [
                -76.6108039996196,
                39.2336249986047,
                0
              ],
              [
                -76.6108330001418,
                39.2336559994487,
                0
              ],
              [
                -76.6108619986886,
                39.2336879992382,
                0
              ],
              [
                -76.6110190005418,
                39.2338219991656,
                0
              ],
              [
                -76.6114909997597,
                39.2342269987131,
                0
              ],
              [
                -76.6116490004087,
                39.2343619991339,
                0
              ],
              [
                -76.6116580000102,
                39.2343690000045,
                0
              ],
              [
                -76.6116790004098,
                39.2343869994025,
                0
              ],
              [
                -76.6116950001593,
                39.234399999168,
                0
              ],
              [
                -76.6117259997043,
                39.2344139988652,
                0
              ],
              [
                -76.6117990001199,
                39.2344459989282,
                0
              ],
              [
                -76.6118910013136,
                39.2344870001584,
                0
              ],
              [
                -76.6122749996509,
                39.2346589993098,
                0
              ],
              [
                -76.6125460003577,
                39.2347819977473,
                0
              ],
              [
                -76.6138510000024,
                39.2353639998414,
                0
              ],
              [
                -76.6144359996187,
                39.2356239991859,
                0
              ],
              [
                -76.6151579996962,
                39.2359469999836,
                0
              ],
              [
                -76.6152910001821,
                39.2360009986846,
                0
              ],
              [
                -76.6154250004636,
                39.2360549987075,
                0
              ],
              [
                -76.6155220003895,
                39.2360929994454,
                0
              ],
              [
                -76.6162050004451,
                39.2363629986488,
                0
              ],
              [
                -76.6166190005432,
                39.2365259990126,
                0
              ],
              [
                -76.6169850002109,
                39.236670999663,
                0
              ],
              [
                -76.617110999566,
                39.2367229989415,
                0
              ],
              [
                -76.6171560000463,
                39.2367419989144,
                0
              ],
              [
                -76.6173260002031,
                39.2368119993,
                0
              ],
              [
                -76.6174460004107,
                39.2368619996579,
                0
              ],
              [
                -76.6174919995252,
                39.236880999152,
                0
              ],
              [
                -76.6175669996495,
                39.2369129994026,
                0
              ],
              [
                -76.6176189996361,
                39.2369339991983,
                0
              ],
              [
                -76.6176580003282,
                39.2369499987716,
                0
              ],
              [
                -76.6176889999569,
                39.2369699987337,
                0
              ],
              [
                -76.6177030008718,
                39.2369769992071,
                0
              ],
              [
                -76.6177480005737,
                39.2369989994261,
                0
              ],
              [
                -76.6177639999829,
                39.2370069990528,
                0
              ],
              [
                -76.6177970007358,
                39.2370229997602,
                0
              ],
              [
                -76.6178980004215,
                39.2370719991789,
                0
              ],
              [
                -76.6179123248286,
                39.2370791619185,
                0
              ],
              [
                -76.6168060298301,
                39.2381801612262,
                0
              ],
              [
                -76.6157016765597,
                39.2388782501575,
                0
              ],
              [
                -76.6155014025431,
                39.239427566112,
                0
              ],
              [
                -76.6145038604733,
                39.2402706152757,
                0
              ],
              [
                -76.6140410577079,
                39.241037894596,
                0
              ],
              [
                -76.6140199996204,
                39.2410359985933,
                0
              ],
              [
                -76.6126850004188,
                39.24087099922,
                0
              ],
              [
                -76.6112389996545,
                39.2407149986504,
                0
              ],
              [
                -76.6107020002698,
                39.2406819991942,
                0
              ],
              [
                -76.6101679997299,
                39.2406429990799,
                0
              ],
              [
                -76.6101489999801,
                39.2406419991811,
                0
              ],
              [
                -76.610092000439,
                39.2406379987063,
                0
              ],
              [
                -76.6100549997487,
                39.2406369993549,
                0
              ],
              [
                -76.6094090002789,
                39.2406219986335,
                0
              ],
              [
                -76.6088430004793,
                39.2406300000671,
                0
              ],
              [
                -76.6084800001976,
                39.2406429987839,
                0
              ],
              [
                -76.6086420003898,
                39.2403639992388,
                0
              ],
              [
                -76.6086569997385,
                39.2403299991039,
                0
              ],
              [
                -76.6086809991043,
                39.2402779990857,
                0
              ],
              [
                -76.6086999994547,
                39.2402359990005,
                0
              ],
              [
                -76.6087220005575,
                39.2401879989526,
                0
              ],
              [
                -76.6088080005172,
                39.2400199994515,
                0
              ],
              [
                -76.6082219995735,
                39.2400959990791,
                0
              ],
              [
                -76.6076109999725,
                39.2401759990377,
                0
              ],
              [
                -76.6073590002683,
                39.2402169991843,
                0
              ],
              [
                -76.6072130003363,
                39.2402359990073,
                0
              ],
              [
                -76.6070379996132,
                39.2402499986646,
                0
              ],
              [
                -76.6065529999338,
                39.2402929993952,
                0
              ],
              [
                -76.6063080004391,
                39.240310998778,
                0
              ],
              [
                -76.6060319997087,
                39.2403289990051,
                0
              ],
              [
                -76.6057910004736,
                39.2403499986003,
                0
              ],
              [
                -76.6045119997919,
                39.2404209986903,
                0
              ],
              [
                -76.6038029998684,
                39.2404759989792,
                0
              ],
              [
                -76.6032210000625,
                39.2405069989279,
                0
              ],
              [
                -76.6019730005108,
                39.2405699998105,
                0
              ],
              [
                -76.6015310002642,
                39.2405969990385,
                0
              ],
              [
                -76.6012309994792,
                39.2406089992446,
                0
              ],
              [
                -76.601099000176,
                39.2406059988957,
                0
              ],
              [
                -76.6010039994607,
                39.2406059994244,
                0
              ],
              [
                -76.6008979993971,
                39.2405949991651,
                0
              ],
              [
                -76.6007429998323,
                39.2405719987075,
                0
              ],
              [
                -76.600525999456,
                39.2405299987414,
                0
              ],
              [
                -76.6002309986852,
                39.2404579991353,
                0
              ],
              [
                -76.5986709989533,
                39.2400379987929,
                0
              ],
              [
                -76.5978300002828,
                39.2397999988224,
                0
              ],
              [
                -76.596788000328,
                39.2395059986414,
                0
              ],
              [
                -76.5962660003263,
                39.239368999225,
                0
              ],
              [
                -76.5961219998419,
                39.2393229985741,
                0
              ],
              [
                -76.5955519991532,
                39.2391429989933,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 105,
          "Census_Tract": "24510280301",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "22f2cd20-5bc7-4aeb-b268-87f704a4f8cc",
          "Shape__Area": 34240216.749938965,
          "Shape__Length": 30214.347090694344
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.7017700006791,
                39.3195959992515,
                0
              ],
              [
                -76.7024140004208,
                39.3193049990422,
                0
              ],
              [
                -76.702605000064,
                39.3192179999666,
                0
              ],
              [
                -76.7032589988237,
                39.3189179994103,
                0
              ],
              [
                -76.7035730005358,
                39.318773999999,
                0
              ],
              [
                -76.7035929984758,
                39.3187639989774,
                0
              ],
              [
                -76.7039470000862,
                39.3185819986511,
                0
              ],
              [
                -76.7035929989733,
                39.3182870000535,
                0
              ],
              [
                -76.703353000151,
                39.3180669999169,
                0
              ],
              [
                -76.7033070002398,
                39.3180209987283,
                0
              ],
              [
                -76.703270000095,
                39.3179619990118,
                0
              ],
              [
                -76.7032169995065,
                39.3178669991624,
                0
              ],
              [
                -76.7031770002373,
                39.3177709989636,
                0
              ],
              [
                -76.7031229994853,
                39.3175919989533,
                0
              ],
              [
                -76.7030210009957,
                39.3170229989984,
                0
              ],
              [
                -76.70292299951,
                39.3164629993387,
                0
              ],
              [
                -76.7028830006568,
                39.316266998655,
                0
              ],
              [
                -76.702826001343,
                39.3161669992124,
                0
              ],
              [
                -76.702565000477,
                39.3159289976489,
                0
              ],
              [
                -76.7023319998319,
                39.3157759990247,
                0
              ],
              [
                -76.7021690004579,
                39.3157229993679,
                0
              ],
              [
                -76.7020450004761,
                39.3157019993285,
                0
              ],
              [
                -76.7017110003179,
                39.3156949990285,
                0
              ],
              [
                -76.7011710000343,
                39.3157229988283,
                0
              ],
              [
                -76.7009670000306,
                39.3157609986989,
                0
              ],
              [
                -76.7007340003256,
                39.3158419991377,
                0
              ],
              [
                -76.7005680002001,
                39.3159209990333,
                0
              ],
              [
                -76.700442999509,
                39.3160230002703,
                0
              ],
              [
                -76.7003549985457,
                39.3161639982046,
                0
              ],
              [
                -76.7002849994811,
                39.3163799987806,
                0
              ],
              [
                -76.7000369997979,
                39.3170429988528,
                0
              ],
              [
                -76.6998709994336,
                39.3170159993219,
                0
              ],
              [
                -76.6998310002906,
                39.3170509993815,
                0
              ],
              [
                -76.6996860006376,
                39.3171279988392,
                0
              ],
              [
                -76.6993420003073,
                39.317268999075,
                0
              ],
              [
                -76.6989930005528,
                39.3173919993282,
                0
              ],
              [
                -76.6986929996235,
                39.3174480003155,
                0
              ],
              [
                -76.6984179999237,
                39.3174569987272,
                0
              ],
              [
                -76.697981999928,
                39.3174669997398,
                0
              ],
              [
                -76.6973150002228,
                39.31741399868,
                0
              ],
              [
                -76.6970310003656,
                39.3173459998035,
                0
              ],
              [
                -76.6969240000634,
                39.3172739990163,
                0
              ],
              [
                -76.6968580002935,
                39.3171829989919,
                0
              ],
              [
                -76.6967920003957,
                39.3170559995612,
                0
              ],
              [
                -76.6967410004325,
                39.3169199997706,
                0
              ],
              [
                -76.6967010011404,
                39.3167339988928,
                0
              ],
              [
                -76.6966979995995,
                39.316539999341,
                0
              ],
              [
                -76.6968070001531,
                39.3154709992802,
                0
              ],
              [
                -76.6968039998845,
                39.3152299994108,
                0
              ],
              [
                -76.696789999666,
                39.3151609991447,
                0
              ],
              [
                -76.6967629997171,
                39.3150669992358,
                0
              ],
              [
                -76.6967109998215,
                39.3149899986169,
                0
              ],
              [
                -76.6966320001835,
                39.314898999074,
                0
              ],
              [
                -76.6965570005581,
                39.314847998618,
                0
              ],
              [
                -76.696412001074,
                39.3147929990221,
                0
              ],
              [
                -76.6960969994732,
                39.3147729988717,
                0
              ],
              [
                -76.6957290002178,
                39.3147469985874,
                0
              ],
              [
                -76.6948840003067,
                39.3146829991495,
                0
              ],
              [
                -76.6939550014405,
                39.3145999996648,
                0
              ],
              [
                -76.6928459996725,
                39.3144789990312,
                0
              ],
              [
                -76.6927630002225,
                39.3144669993507,
                0
              ],
              [
                -76.6926759998896,
                39.3144459987567,
                0
              ],
              [
                -76.6925870003564,
                39.3144129993734,
                0
              ],
              [
                -76.6924700002173,
                39.314365999245,
                0
              ],
              [
                -76.6920310000024,
                39.3141719988944,
                0
              ],
              [
                -76.6917670003383,
                39.314002998775,
                0
              ],
              [
                -76.6914630005388,
                39.3138289992596,
                0
              ],
              [
                -76.6912360005168,
                39.3136409991385,
                0
              ],
              [
                -76.690908999642,
                39.3133229986201,
                0
              ],
              [
                -76.6907729997792,
                39.3132299985934,
                0
              ],
              [
                -76.6906530001268,
                39.3131429989936,
                0
              ],
              [
                -76.6905020014154,
                39.3130679994058,
                0
              ],
              [
                -76.6903659995117,
                39.3129679991557,
                0
              ],
              [
                -76.6902859999889,
                39.312892998977,
                0
              ],
              [
                -76.6901589997614,
                39.3127309991791,
                0
              ],
              [
                -76.6900590002792,
                39.3125749991952,
                0
              ],
              [
                -76.690003999601,
                39.3123859990058,
                0
              ],
              [
                -76.6899819999789,
                39.3121079988318,
                0
              ],
              [
                -76.6899790001387,
                39.3119289990036,
                0
              ],
              [
                -76.6899880000722,
                39.3117669991787,
                0
              ],
              [
                -76.6900139994614,
                39.3116129987255,
                0
              ],
              [
                -76.6901690004457,
                39.3111699990239,
                0
              ],
              [
                -76.6903930004958,
                39.3103229991293,
                0
              ],
              [
                -76.6904309995079,
                39.3100169994245,
                0
              ],
              [
                -76.6904319987232,
                39.3098799985851,
                0
              ],
              [
                -76.6903919995465,
                39.309682998726,
                0
              ],
              [
                -76.6903599994441,
                39.3095569991823,
                0
              ],
              [
                -76.6902950004554,
                39.3094089991617,
                0
              ],
              [
                -76.6901959993019,
                39.3092539988887,
                0
              ],
              [
                -76.6901179998469,
                39.3091409983353,
                0
              ],
              [
                -76.689618000191,
                39.3085209988274,
                0
              ],
              [
                -76.6890389995429,
                39.3077829993054,
                0
              ],
              [
                -76.688179000987,
                39.3065569990285,
                0
              ],
              [
                -76.6877380005457,
                39.3059139990375,
                0
              ],
              [
                -76.6875029990675,
                39.3056979988059,
                0
              ],
              [
                -76.6873699996358,
                39.3055919983793,
                0
              ],
              [
                -76.6872029995083,
                39.3054909992504,
                0
              ],
              [
                -76.6869299996841,
                39.3054079991969,
                0
              ],
              [
                -76.6866330004586,
                39.3053559987849,
                0
              ],
              [
                -76.686430998501,
                39.305347998957,
                0
              ],
              [
                -76.6866379995277,
                39.3050689987623,
                0
              ],
              [
                -76.6868619987089,
                39.3048759987852,
                0
              ],
              [
                -76.6869380005508,
                39.304856999039,
                0
              ],
              [
                -76.6870100001239,
                39.3048639987401,
                0
              ],
              [
                -76.6870809998177,
                39.3048739988462,
                0
              ],
              [
                -76.6871359994299,
                39.3048929989723,
                0
              ],
              [
                -76.6871990002781,
                39.3049329989203,
                0
              ],
              [
                -76.6872770001675,
                39.3049919987121,
                0
              ],
              [
                -76.6874190008925,
                39.3051170002844,
                0
              ],
              [
                -76.6875500002161,
                39.3051959988759,
                0
              ],
              [
                -76.6876889998763,
                39.3052159994231,
                0
              ],
              [
                -76.6878110002258,
                39.3052159993526,
                0
              ],
              [
                -76.6879329995423,
                39.3051969986618,
                0
              ],
              [
                -76.6881229995751,
                39.3051639986927,
                0
              ],
              [
                -76.688224000416,
                39.3051249992848,
                0
              ],
              [
                -76.6883429999678,
                39.3050769985616,
                0
              ],
              [
                -76.6883809984772,
                39.3050769993566,
                0
              ],
              [
                -76.6884269996757,
                39.3050929989226,
                0
              ],
              [
                -76.6885070000145,
                39.3051159991846,
                0
              ],
              [
                -76.6885970003067,
                39.3051529992803,
                0
              ],
              [
                -76.6887490000769,
                39.3051659990423,
                0
              ],
              [
                -76.6890210002188,
                39.3051469990296,
                0
              ],
              [
                -76.6895820002095,
                39.3050989986276,
                0
              ],
              [
                -76.6901869995294,
                39.3050829991348,
                0
              ],
              [
                -76.6904050006706,
                39.3050260002748,
                0
              ],
              [
                -76.6905109996417,
                39.3049919986425,
                0
              ],
              [
                -76.6906170000084,
                39.3049339990482,
                0
              ],
              [
                -76.6907729998072,
                39.3048139987861,
                0
              ],
              [
                -76.6909480000589,
                39.3046549988294,
                0
              ],
              [
                -76.6910849999122,
                39.3046019993538,
                0
              ],
              [
                -76.6912029994271,
                39.3045739988379,
                0
              ],
              [
                -76.6913280000778,
                39.3045689993184,
                0
              ],
              [
                -76.6915169997025,
                39.3045599981151,
                0
              ],
              [
                -76.691822000378,
                39.304584998991,
                0
              ],
              [
                -76.6923129999889,
                39.3046539989639,
                0
              ],
              [
                -76.6929190011443,
                39.3047959990825,
                0
              ],
              [
                -76.6932979997872,
                39.3048829991727,
                0
              ],
              [
                -76.6935220005812,
                39.3049229987996,
                0
              ],
              [
                -76.6940200005247,
                39.3049289985912,
                0
              ],
              [
                -76.6942440003951,
                39.3049289988916,
                0
              ],
              [
                -76.6943309996413,
                39.3048959991583,
                0
              ],
              [
                -76.6944149997994,
                39.3048429993434,
                0
              ],
              [
                -76.6945089995918,
                39.3047369990235,
                0
              ],
              [
                -76.6946220000158,
                39.3045629988003,
                0
              ],
              [
                -76.6946979995847,
                39.3043459994466,
                0
              ],
              [
                -76.6947289994376,
                39.3042829993306,
                0
              ],
              [
                -76.6947729997732,
                39.3042450000588,
                0
              ],
              [
                -76.6948720001958,
                39.3041779988308,
                0
              ],
              [
                -76.6949290003972,
                39.3041149986179,
                0
              ],
              [
                -76.6949599999019,
                39.3040139992526,
                0
              ],
              [
                -76.6949520000674,
                39.303882999025,
                0
              ],
              [
                -76.6948970000311,
                39.3037629992642,
                0
              ],
              [
                -76.6945760011447,
                39.3032199990347,
                0
              ],
              [
                -76.6943540003836,
                39.3029359987124,
                0
              ],
              [
                -76.6942840004514,
                39.3027399990393,
                0
              ],
              [
                -76.694274998471,
                39.302574998952,
                0
              ],
              [
                -76.6943459995295,
                39.3024339986106,
                0
              ],
              [
                -76.6945190015634,
                39.302244999259,
                0
              ],
              [
                -76.6948660000233,
                39.3020159987692,
                0
              ],
              [
                -76.6956850007948,
                39.3021059985583,
                0
              ],
              [
                -76.6958889999278,
                39.3020999989672,
                0
              ],
              [
                -76.696180999766,
                39.3020759989457,
                0
              ],
              [
                -76.6964759993693,
                39.3020409987351,
                0
              ],
              [
                -76.6966500003722,
                39.3019979993252,
                0
              ],
              [
                -76.6968310005233,
                39.3018759990779,
                0
              ],
              [
                -76.6969500000054,
                39.3017729985904,
                0
              ],
              [
                -76.6971240003897,
                39.3016329989808,
                0
              ],
              [
                -76.6973129993805,
                39.3015169978059,
                0
              ],
              [
                -76.6974549996002,
                39.3014559987613,
                0
              ],
              [
                -76.6976479995318,
                39.3014139988873,
                0
              ],
              [
                -76.6979790002224,
                39.3014029989573,
                0
              ],
              [
                -76.6981360004747,
                39.3014149987231,
                0
              ],
              [
                -76.6983569995944,
                39.3014340002208,
                0
              ],
              [
                -76.6984510000885,
                39.3014709985743,
                0
              ],
              [
                -76.6985370015502,
                39.3015389991971,
                0
              ],
              [
                -76.6986240003227,
                39.3016609989098,
                0
              ],
              [
                -76.6986859995275,
                39.3018199986677,
                0
              ],
              [
                -76.6987720005974,
                39.3019179987166,
                0
              ],
              [
                -76.6988980002753,
                39.3019609993917,
                0
              ],
              [
                -76.6991299996474,
                39.3020109991364,
                0
              ],
              [
                -76.6995239995183,
                39.3020359989471,
                0
              ],
              [
                -76.699720000077,
                39.3020309991103,
                0
              ],
              [
                -76.700271999859,
                39.3019339993613,
                0
              ],
              [
                -76.7005400004026,
                39.3018859987631,
                0
              ],
              [
                -76.7006980000152,
                39.3018499991779,
                0
              ],
              [
                -76.700857000073,
                39.3017699992016,
                0
              ],
              [
                -76.7010210004202,
                39.3015479988757,
                0
              ],
              [
                -76.7011929996804,
                39.3012969999615,
                0
              ],
              [
                -76.7012740003144,
                39.301229998872,
                0
              ],
              [
                -76.7013560000121,
                39.3011979990614,
                0
              ],
              [
                -76.7014240002987,
                39.3011789993314,
                0
              ],
              [
                -76.7015580005525,
                39.301150999347,
                0
              ],
              [
                -76.7017679995451,
                39.3011209988003,
                0
              ],
              [
                -76.7018939990619,
                39.3010879987568,
                0
              ],
              [
                -76.7020539997842,
                39.301026000357,
                0
              ],
              [
                -76.7027330002299,
                39.300689998689,
                0
              ],
              [
                -76.7028080003969,
                39.3006309989659,
                0
              ],
              [
                -76.7028519995838,
                39.3005559990665,
                0
              ],
              [
                -76.7028709995294,
                39.3004929988316,
                0
              ],
              [
                -76.7028780000604,
                39.3003129990159,
                0
              ],
              [
                -76.7028470010502,
                39.3001299990608,
                0
              ],
              [
                -76.7028559994445,
                39.300017998616,
                0
              ],
              [
                -76.7029149998731,
                39.2999119993273,
                0
              ],
              [
                -76.7031219984788,
                39.2997449993568,
                0
              ],
              [
                -76.703303999821,
                39.2996719989694,
                0
              ],
              [
                -76.7035549998318,
                39.2996339991742,
                0
              ],
              [
                -76.7038000004842,
                39.2996269975915,
                0
              ],
              [
                -76.7042590005687,
                39.2996980001175,
                0
              ],
              [
                -76.7046090004022,
                39.2997409998423,
                0
              ],
              [
                -76.704778998857,
                39.2997459993402,
                0
              ],
              [
                -76.7048859999665,
                39.2997319992992,
                0
              ],
              [
                -76.7049710013952,
                39.2997099992686,
                0
              ],
              [
                -76.7052020005784,
                39.2996369991693,
                0
              ],
              [
                -76.7054390003897,
                39.2995529992359,
                0
              ],
              [
                -76.7055730001952,
                39.2995169986734,
                0
              ],
              [
                -76.7057110001174,
                39.2995059994056,
                0
              ],
              [
                -76.705854999334,
                39.2995159989674,
                0
              ],
              [
                -76.7059579995598,
                39.2995359986149,
                0
              ],
              [
                -76.7060640013601,
                39.2995889994093,
                0
              ],
              [
                -76.7061779994256,
                39.2996729988439,
                0
              ],
              [
                -76.70629500105,
                39.2997909992366,
                0
              ],
              [
                -76.7064280003767,
                39.2999899992647,
                0
              ],
              [
                -76.7065330000239,
                39.3001999985639,
                0
              ],
              [
                -76.7066069994644,
                39.3004719994156,
                0
              ],
              [
                -76.7066349986796,
                39.3006549998526,
                0
              ],
              [
                -76.7066349993876,
                39.3007789994443,
                0
              ],
              [
                -76.7066219999691,
                39.3008789993119,
                0
              ],
              [
                -76.7066030002508,
                39.3009359993161,
                0
              ],
              [
                -76.7065460002893,
                39.3010129993326,
                0
              ],
              [
                -76.7064820004205,
                39.3010929993591,
                0
              ],
              [
                -76.7063160003339,
                39.3012459991478,
                0
              ],
              [
                -76.7058549990713,
                39.3016769987999,
                0
              ],
              [
                -76.7057369994568,
                39.301784999154,
                0
              ],
              [
                -76.7056560004221,
                39.3018359987127,
                0
              ],
              [
                -76.7055269995616,
                39.3019019988742,
                0
              ],
              [
                -76.7054709995925,
                39.3019579988858,
                0
              ],
              [
                -76.7054369998638,
                39.30204099917,
                0
              ],
              [
                -76.7054180000972,
                39.3021579999646,
                0
              ],
              [
                -76.7054130002359,
                39.3022379986678,
                0
              ],
              [
                -76.705444999292,
                39.302346998911,
                0
              ],
              [
                -76.7054740013997,
                39.3024079985814,
                0
              ],
              [
                -76.7055210005148,
                39.3024739992951,
                0
              ],
              [
                -76.7056979995385,
                39.3026109978911,
                0
              ],
              [
                -76.7058439997063,
                39.302711999268,
                0
              ],
              [
                -76.7061050012048,
                39.3028349990219,
                0
              ],
              [
                -76.7063290004978,
                39.302921998983,
                0
              ],
              [
                -76.706531999705,
                39.3029979992101,
                0
              ],
              [
                -76.7067209994456,
                39.303056999354,
                0
              ],
              [
                -76.7069720004136,
                39.3031039990661,
                0
              ],
              [
                -76.7071160010334,
                39.3031339991836,
                0
              ],
              [
                -76.7073149999081,
                39.3031789985631,
                0
              ],
              [
                -76.7077650005334,
                39.3033079985612,
                0
              ],
              [
                -76.7081919997995,
                39.3033799985944,
                0
              ],
              [
                -76.7084030012482,
                39.3033949993254,
                0
              ],
              [
                -76.7086740005519,
                39.3033919991737,
                0
              ],
              [
                -76.7089129998472,
                39.3033739990517,
                0
              ],
              [
                -76.7090290010604,
                39.3033509991968,
                0
              ],
              [
                -76.7090919995829,
                39.3033229994439,
                0
              ],
              [
                -76.7092189998635,
                39.3032269998706,
                0
              ],
              [
                -76.7094239999224,
                39.3030249987763,
                0
              ],
              [
                -76.7097329998797,
                39.3027689992069,
                0
              ],
              [
                -76.7098680001364,
                39.3027299994367,
                0
              ],
              [
                -76.7100079998096,
                39.3027169985828,
                0
              ],
              [
                -76.7101669997181,
                39.302725999392,
                0
              ],
              [
                -76.7103660001753,
                39.3027619986896,
                0
              ],
              [
                -76.7105979996292,
                39.3028159994168,
                0
              ],
              [
                -76.7111909998206,
                39.302954998999,
                0
              ],
              [
                -76.71118500052,
                39.3034089989615,
                0
              ],
              [
                -76.7112060002986,
                39.3047409992793,
                0
              ],
              [
                -76.7112070002761,
                39.3047829993318,
                0
              ],
              [
                -76.7112079996353,
                39.3048279988886,
                0
              ],
              [
                -76.7112080003201,
                39.3048619987009,
                0
              ],
              [
                -76.7111929999988,
                39.3051019989009,
                0
              ],
              [
                -76.7112129996407,
                39.3053229990603,
                0
              ],
              [
                -76.7111930001122,
                39.3066049997684,
                0
              ],
              [
                -76.7111820000756,
                39.3070429985892,
                0
              ],
              [
                -76.711192999832,
                39.3076049993951,
                0
              ],
              [
                -76.711318998545,
                39.3084879989306,
                0
              ],
              [
                -76.7112489998631,
                39.3093119993194,
                0
              ],
              [
                -76.7111519998299,
                39.3101219993759,
                0
              ],
              [
                -76.711180999534,
                39.3110339982865,
                0
              ],
              [
                -76.7112040000188,
                39.311368999051,
                0
              ],
              [
                -76.7112279995812,
                39.311708998696,
                0
              ],
              [
                -76.7111189990277,
                39.3124749994136,
                0
              ],
              [
                -76.7110989993955,
                39.3131879987524,
                0
              ],
              [
                -76.7110970008224,
                39.3132689992221,
                0
              ],
              [
                -76.7110960006737,
                39.3133089990872,
                0
              ],
              [
                -76.7110929994347,
                39.3134049990859,
                0
              ],
              [
                -76.7110850005301,
                39.3147179993226,
                0
              ],
              [
                -76.7110279998561,
                39.3189159990159,
                0
              ],
              [
                -76.7114930000996,
                39.3208049986843,
                0
              ],
              [
                -76.711331999482,
                39.3208569989831,
                0
              ],
              [
                -76.711112000798,
                39.3209279985623,
                0
              ],
              [
                -76.708891999928,
                39.3216439985569,
                0
              ],
              [
                -76.7083929999673,
                39.3218049988924,
                0
              ],
              [
                -76.7045179997842,
                39.3220229992691,
                0
              ],
              [
                -76.7017700006791,
                39.3195959992515,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 106,
          "Census_Tract": "24510160100",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "a35e3875-eac9-4994-ab92-5317431c4380",
          "Shape__Area": 4118451.673034668,
          "Shape__Length": 9357.766484918007
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6368289998164,
                39.3034209993124,
                0
              ],
              [
                -76.6366770014203,
                39.3031139986342,
                0
              ],
              [
                -76.6366049996498,
                39.302981999003,
                0
              ],
              [
                -76.6363689998231,
                39.3025489988312,
                0
              ],
              [
                -76.6359749996092,
                39.3018709993721,
                0
              ],
              [
                -76.6358780001487,
                39.3016849989197,
                0
              ],
              [
                -76.6356940002138,
                39.3012889992656,
                0
              ],
              [
                -76.6353410002456,
                39.3006809988834,
                0
              ],
              [
                -76.635243000261,
                39.3005129990464,
                0
              ],
              [
                -76.6351189995163,
                39.3002619992257,
                0
              ],
              [
                -76.6350829987424,
                39.3001979985533,
                0
              ],
              [
                -76.6348799996447,
                39.2998479986072,
                0
              ],
              [
                -76.6347720000779,
                39.299657998696,
                0
              ],
              [
                -76.634510999785,
                39.2991979992528,
                0
              ],
              [
                -76.6344750006051,
                39.2991419988984,
                0
              ],
              [
                -76.6338849998976,
                39.2980399987721,
                0
              ],
              [
                -76.6338090010836,
                39.2979029999472,
                0
              ],
              [
                -76.6332609995008,
                39.2968859991934,
                0
              ],
              [
                -76.6328169998735,
                39.2960959981262,
                0
              ],
              [
                -76.632591999673,
                39.2956889988607,
                0
              ],
              [
                -76.6324260005072,
                39.2953829992595,
                0
              ],
              [
                -76.6322579994325,
                39.2950539985713,
                0
              ],
              [
                -76.6320509995182,
                39.2946869985885,
                0
              ],
              [
                -76.6319220001725,
                39.2944579991697,
                0
              ],
              [
                -76.6325210011949,
                39.2944259985877,
                0
              ],
              [
                -76.6341320003966,
                39.2943539991309,
                0
              ],
              [
                -76.6356229994652,
                39.2943019986396,
                0
              ],
              [
                -76.6363120005347,
                39.2942769991112,
                0
              ],
              [
                -76.6366000014007,
                39.2942669992348,
                0
              ],
              [
                -76.6369530004291,
                39.2942499988653,
                0
              ],
              [
                -76.6370579994447,
                39.2942449989021,
                0
              ],
              [
                -76.6384619997957,
                39.2941889986873,
                0
              ],
              [
                -76.6385519984718,
                39.2954470003371,
                0
              ],
              [
                -76.6386189995297,
                39.2966889990006,
                0
              ],
              [
                -76.6386199999015,
                39.2968690004332,
                0
              ],
              [
                -76.6386489986584,
                39.2972809996524,
                0
              ],
              [
                -76.6386550002318,
                39.2973799987242,
                0
              ],
              [
                -76.6386819994631,
                39.2978709989309,
                0
              ],
              [
                -76.6387569997719,
                39.2990619987286,
                0
              ],
              [
                -76.6387780000343,
                39.2993689988609,
                0
              ],
              [
                -76.6387859997715,
                39.2996709994273,
                0
              ],
              [
                -76.6387870002391,
                39.2997219979386,
                0
              ],
              [
                -76.6387969994658,
                39.3001369991198,
                0
              ],
              [
                -76.6388079986853,
                39.3003979991966,
                0
              ],
              [
                -76.638816000037,
                39.3005389993782,
                0
              ],
              [
                -76.638853000091,
                39.3011619987099,
                0
              ],
              [
                -76.6389400005169,
                39.302495999344,
                0
              ],
              [
                -76.6389669993524,
                39.3033779987359,
                0
              ],
              [
                -76.638245999498,
                39.3034039991322,
                0
              ],
              [
                -76.6373900004275,
                39.3034319988999,
                0
              ],
              [
                -76.6368289998164,
                39.3034209993124,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 107,
          "Census_Tract": "24510130400",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "8b212370-3739-433b-b754-06ef0ef14475",
          "Shape__Area": 30176715.4967041,
          "Shape__Length": 23680.572882861896
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6405279998134,
                39.3272159992551,
                0
              ],
              [
                -76.6402819997853,
                39.3269709986507,
                0
              ],
              [
                -76.6400139997762,
                39.3267359987047,
                0
              ],
              [
                -76.6396190003698,
                39.3265039992264,
                0
              ],
              [
                -76.6393189999208,
                39.3263769993517,
                0
              ],
              [
                -76.6390360001678,
                39.3262990003333,
                0
              ],
              [
                -76.6387070003904,
                39.3262209988586,
                0
              ],
              [
                -76.6384210005717,
                39.3261729993964,
                0
              ],
              [
                -76.637530999577,
                39.3260469996001,
                0
              ],
              [
                -76.6367979991972,
                39.3259199992692,
                0
              ],
              [
                -76.6362640002858,
                39.3257799991323,
                0
              ],
              [
                -76.635795999523,
                39.3255899986994,
                0
              ],
              [
                -76.6354500010293,
                39.3254199985792,
                0
              ],
              [
                -76.6350000010762,
                39.3251559992324,
                0
              ],
              [
                -76.6343000003977,
                39.324736998655,
                0
              ],
              [
                -76.6336650003668,
                39.3243089988825,
                0
              ],
              [
                -76.6333420012235,
                39.3240649990564,
                0
              ],
              [
                -76.6331039996696,
                39.3238629990376,
                0
              ],
              [
                -76.6327009996335,
                39.3234959987969,
                0
              ],
              [
                -76.632531999924,
                39.3232769998472,
                0
              ],
              [
                -76.6323579996926,
                39.3229789990867,
                0
              ],
              [
                -76.6322809998254,
                39.3228349993263,
                0
              ],
              [
                -76.6321799996169,
                39.3226329989326,
                0
              ],
              [
                -76.6319499995802,
                39.3222719993758,
                0
              ],
              [
                -76.6309410005514,
                39.3207299987485,
                0
              ],
              [
                -76.6308959998688,
                39.3206619993412,
                0
              ],
              [
                -76.630817999441,
                39.3205149985606,
                0
              ],
              [
                -76.6307229997001,
                39.320355999447,
                0
              ],
              [
                -76.6306339999593,
                39.3202039990264,
                0
              ],
              [
                -76.6305360014769,
                39.3200299991143,
                0
              ],
              [
                -76.6304449984853,
                39.3198519992513,
                0
              ],
              [
                -76.6303730002867,
                39.3196679997237,
                0
              ],
              [
                -76.6301709998448,
                39.31899199873,
                0
              ],
              [
                -76.6300359998766,
                39.3185319985864,
                0
              ],
              [
                -76.6299039997542,
                39.3181889991259,
                0
              ],
              [
                -76.6298879998385,
                39.3181539986646,
                0
              ],
              [
                -76.6298460000878,
                39.3180429991397,
                0
              ],
              [
                -76.629733000282,
                39.317740999353,
                0
              ],
              [
                -76.6296840004705,
                39.3176139992591,
                0
              ],
              [
                -76.6296170014693,
                39.3174470003638,
                0
              ],
              [
                -76.6295519994657,
                39.3173100000606,
                0
              ],
              [
                -76.6294740002946,
                39.3171619992861,
                0
              ],
              [
                -76.6294590015036,
                39.3171349996892,
                0
              ],
              [
                -76.6294439998364,
                39.3171069993454,
                0
              ],
              [
                -76.629438000678,
                39.3170959993592,
                0
              ],
              [
                -76.6294300000675,
                39.3170809991263,
                0
              ],
              [
                -76.6295789997871,
                39.3170169993136,
                0
              ],
              [
                -76.6296830000205,
                39.316971999412,
                0
              ],
              [
                -76.6297849997504,
                39.3169469988239,
                0
              ],
              [
                -76.6299060001477,
                39.316912999119,
                0
              ],
              [
                -76.6299989994295,
                39.3168889986604,
                0
              ],
              [
                -76.630100999507,
                39.3168669991058,
                0
              ],
              [
                -76.6302089987733,
                39.3168539988398,
                0
              ],
              [
                -76.6303979997926,
                39.3168209989333,
                0
              ],
              [
                -76.6305940001227,
                39.3168020003991,
                0
              ],
              [
                -76.6307300008872,
                39.3168019999515,
                0
              ],
              [
                -76.6309349998063,
                39.3167969988902,
                0
              ],
              [
                -76.6311770011066,
                39.3167929990418,
                0
              ],
              [
                -76.6314759984803,
                39.3168069988188,
                0
              ],
              [
                -76.6317989995937,
                39.3168359994063,
                0
              ],
              [
                -76.6321230004244,
                39.3168610001924,
                0
              ],
              [
                -76.6323859997332,
                39.316882998939,
                0
              ],
              [
                -76.6326580004497,
                39.3168999990355,
                0
              ],
              [
                -76.6339559997087,
                39.3170109989384,
                0
              ],
              [
                -76.634614000533,
                39.3169819994252,
                0
              ],
              [
                -76.635466000693,
                39.3169599988837,
                0
              ],
              [
                -76.6361799999205,
                39.3169619988316,
                0
              ],
              [
                -76.6364380004058,
                39.3169629990194,
                0
              ],
              [
                -76.6365800014745,
                39.3169529994056,
                0
              ],
              [
                -76.6366830002943,
                39.3169429988529,
                0
              ],
              [
                -76.6369029997865,
                39.3169139989891,
                0
              ],
              [
                -76.6370039995912,
                39.3168889989622,
                0
              ],
              [
                -76.6370959997041,
                39.3168589989073,
                0
              ],
              [
                -76.6372410014453,
                39.3168030000516,
                0
              ],
              [
                -76.6375560005244,
                39.3166789989075,
                0
              ],
              [
                -76.6377459999965,
                39.3166029991804,
                0
              ],
              [
                -76.6379580001655,
                39.3165219992927,
                0
              ],
              [
                -76.6382119995746,
                39.3164229988861,
                0
              ],
              [
                -76.6383789996171,
                39.3163539991331,
                0
              ],
              [
                -76.6385689995989,
                39.3162679988258,
                0
              ],
              [
                -76.6387020003895,
                39.3162099994177,
                0
              ],
              [
                -76.6388630009862,
                39.3161279988914,
                0
              ],
              [
                -76.6394060010973,
                39.3158379991005,
                0
              ],
              [
                -76.639390000654,
                39.3157429990132,
                0
              ],
              [
                -76.6394020009126,
                39.3156839987333,
                0
              ],
              [
                -76.6394499985919,
                39.3156369988253,
                0
              ],
              [
                -76.6399450004979,
                39.3153559990935,
                0
              ],
              [
                -76.6403030004131,
                39.3151389989243,
                0
              ],
              [
                -76.6410750004148,
                39.3145279991403,
                0
              ],
              [
                -76.6418490002011,
                39.3140320002914,
                0
              ],
              [
                -76.642989000562,
                39.3152089989882,
                0
              ],
              [
                -76.6430959998884,
                39.3152989992767,
                0
              ],
              [
                -76.6432919991697,
                39.3154760003609,
                0
              ],
              [
                -76.6434499995378,
                39.3156239987062,
                0
              ],
              [
                -76.6436309997932,
                39.3157929991538,
                0
              ],
              [
                -76.6441749999355,
                39.3152599989092,
                0
              ],
              [
                -76.6443350001635,
                39.3150929991884,
                0
              ],
              [
                -76.644557001021,
                39.3148759986704,
                0
              ],
              [
                -76.6448309992661,
                39.3146239994204,
                0
              ],
              [
                -76.6450960005794,
                39.3143789991171,
                0
              ],
              [
                -76.6454419992108,
                39.3140559978437,
                0
              ],
              [
                -76.6455850001594,
                39.3139219981999,
                0
              ],
              [
                -76.6463159999163,
                39.3132479992724,
                0
              ],
              [
                -76.6466460005071,
                39.3134979987428,
                0
              ],
              [
                -76.6467750004603,
                39.3135959993038,
                0
              ],
              [
                -76.6469240004797,
                39.3137219993506,
                0
              ],
              [
                -76.6476289995612,
                39.314314999022,
                0
              ],
              [
                -76.6481900000718,
                39.3147699986647,
                0
              ],
              [
                -76.6487249995848,
                39.3152249997972,
                0
              ],
              [
                -76.6491150005025,
                39.3155429989784,
                0
              ],
              [
                -76.6493350008618,
                39.3157219990991,
                0
              ],
              [
                -76.6497839995271,
                39.3161119988635,
                0
              ],
              [
                -76.6498980005638,
                39.3162039990257,
                0
              ],
              [
                -76.6504940003019,
                39.316704000346,
                0
              ],
              [
                -76.650596000157,
                39.3167959992466,
                0
              ],
              [
                -76.6506169997335,
                39.3168149990775,
                0
              ],
              [
                -76.6511369997504,
                39.3172189986641,
                0
              ],
              [
                -76.6511619999394,
                39.3172679989843,
                0
              ],
              [
                -76.6512160000167,
                39.3173449987499,
                0
              ],
              [
                -76.6512749997346,
                39.3174079994353,
                0
              ],
              [
                -76.6514479998018,
                39.3175809993082,
                0
              ],
              [
                -76.6516499997944,
                39.3177479994012,
                0
              ],
              [
                -76.6518490012639,
                39.3179089993572,
                0
              ],
              [
                -76.6520139995523,
                39.3180499988953,
                0
              ],
              [
                -76.6521550004614,
                39.318185000228,
                0
              ],
              [
                -76.6522690000409,
                39.318310998657,
                0
              ],
              [
                -76.6523970010225,
                39.3184559991897,
                0
              ],
              [
                -76.6524769992528,
                39.3185489987076,
                0
              ],
              [
                -76.6536160003731,
                39.3200599998758,
                0
              ],
              [
                -76.6542889999198,
                39.3209719986844,
                0
              ],
              [
                -76.6548810005591,
                39.3218099994082,
                0
              ],
              [
                -76.6549120007336,
                39.3218530003586,
                0
              ],
              [
                -76.6552669985924,
                39.3223339985962,
                0
              ],
              [
                -76.6555399990679,
                39.3227129986028,
                0
              ],
              [
                -76.6562230002045,
                39.3236239987113,
                0
              ],
              [
                -76.6568439986045,
                39.3244379992197,
                0
              ],
              [
                -76.6571050000956,
                39.3247849989865,
                0
              ],
              [
                -76.6572340004896,
                39.3250179990886,
                0
              ],
              [
                -76.6573630003901,
                39.3252159986284,
                0
              ],
              [
                -76.6574769994664,
                39.3253729990499,
                0
              ],
              [
                -76.6575280001275,
                39.3254529990482,
                0
              ],
              [
                -76.6573010003591,
                39.3256229986877,
                0
              ],
              [
                -76.6567189994242,
                39.3262129985712,
                0
              ],
              [
                -76.6566140001941,
                39.3263749986619,
                0
              ],
              [
                -76.6562989990546,
                39.3269359991423,
                0
              ],
              [
                -76.6557919999976,
                39.3281569994191,
                0
              ],
              [
                -76.6556629996546,
                39.328510999306,
                0
              ],
              [
                -76.6554850003044,
                39.3289949990768,
                0
              ],
              [
                -76.6552960004822,
                39.3293259985579,
                0
              ],
              [
                -76.6550609997726,
                39.329542998298,
                0
              ],
              [
                -76.6545849992314,
                39.3298809986378,
                0
              ],
              [
                -76.6542669997788,
                39.3300990003731,
                0
              ],
              [
                -76.6540440000201,
                39.3302139993542,
                0
              ],
              [
                -76.6540320005283,
                39.3302909986759,
                0
              ],
              [
                -76.6522710001881,
                39.330914998896,
                0
              ],
              [
                -76.6518909992582,
                39.3310509994486,
                0
              ],
              [
                -76.6479790005784,
                39.3301439995792,
                0
              ],
              [
                -76.6461909994915,
                39.3299049989151,
                0
              ],
              [
                -76.6453909997459,
                39.3307049987777,
                0
              ],
              [
                -76.6448910002323,
                39.3309049992293,
                0
              ],
              [
                -76.6445829996163,
                39.330363998844,
                0
              ],
              [
                -76.6445910005055,
                39.3297049988389,
                0
              ],
              [
                -76.6438629997754,
                39.3296049993598,
                0
              ],
              [
                -76.6432229997537,
                39.3295839987048,
                0
              ],
              [
                -76.6427879996815,
                39.3296579990295,
                0
              ],
              [
                -76.6425429998247,
                39.3291439997445,
                0
              ],
              [
                -76.6423659994804,
                39.3287489992843,
                0
              ],
              [
                -76.642117999522,
                39.3283459989824,
                0
              ],
              [
                -76.6417620009316,
                39.3279649985551,
                0
              ],
              [
                -76.6414109995165,
                39.3276769992426,
                0
              ],
              [
                -76.6410720001215,
                39.3274489992537,
                0
              ],
              [
                -76.6409020001646,
                39.3273609992751,
                0
              ],
              [
                -76.6406239984297,
                39.3272469993402,
                0
              ],
              [
                -76.6405279998134,
                39.3272159992551,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 108,
          "Census_Tract": "24510250402",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "8db46c90-66c9-4858-9fb7-1561186b3c51",
          "Shape__Area": 7560437.323303223,
          "Shape__Length": 12398.727315736876
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.5977420003413,
                39.2348979993661,
                0
              ],
              [
                -76.5973360005229,
                39.2347719986008,
                0
              ],
              [
                -76.5965739995192,
                39.2345329989255,
                0
              ],
              [
                -76.5959419986958,
                39.2343539993092,
                0
              ],
              [
                -76.5957869994338,
                39.2343089988801,
                0
              ],
              [
                -76.5960029986783,
                39.2339079992694,
                0
              ],
              [
                -76.5961829995871,
                39.2335749992554,
                0
              ],
              [
                -76.5965229996329,
                39.2329219989293,
                0
              ],
              [
                -76.5968330007672,
                39.2323169986275,
                0
              ],
              [
                -76.5973139998607,
                39.2313969990476,
                0
              ],
              [
                -76.5974760001419,
                39.2310639990582,
                0
              ],
              [
                -76.5975740002334,
                39.2308819990463,
                0
              ],
              [
                -76.59764800004,
                39.2307410001877,
                0
              ],
              [
                -76.5977550003494,
                39.2305279991148,
                0
              ],
              [
                -76.5979810001962,
                39.2300929993516,
                0
              ],
              [
                -76.5981820011735,
                39.229726998595,
                0
              ],
              [
                -76.5982360001383,
                39.229628998789,
                0
              ],
              [
                -76.598368000467,
                39.2293779987357,
                0
              ],
              [
                -76.5984819994931,
                39.229160998913,
                0
              ],
              [
                -76.5987080003431,
                39.2287299997687,
                0
              ],
              [
                -76.5989429994388,
                39.2282809991409,
                0
              ],
              [
                -76.5991610003844,
                39.2278449994126,
                0
              ],
              [
                -76.5993599998618,
                39.2274599994324,
                0
              ],
              [
                -76.5994080004925,
                39.2273670003941,
                0
              ],
              [
                -76.5995949996848,
                39.2270019986063,
                0
              ],
              [
                -76.5996089999702,
                39.2269759985915,
                0
              ],
              [
                -76.5997719996046,
                39.2266649990871,
                0
              ],
              [
                -76.5997970000288,
                39.2266109989625,
                0
              ],
              [
                -76.5998539997449,
                39.2265129986659,
                0
              ],
              [
                -76.5998889995075,
                39.2264599991441,
                0
              ],
              [
                -76.5999469997188,
                39.2263849990562,
                0
              ],
              [
                -76.5999149995063,
                39.2263259989555,
                0
              ],
              [
                -76.599629000184,
                39.2258339990962,
                0
              ],
              [
                -76.5994509994129,
                39.2255319987904,
                0
              ],
              [
                -76.5993080001665,
                39.2252980002905,
                0
              ],
              [
                -76.5996509994773,
                39.2249029988394,
                0
              ],
              [
                -76.6000500005323,
                39.2244339991426,
                0
              ],
              [
                -76.6002080012085,
                39.2242399991606,
                0
              ],
              [
                -76.6004049997157,
                39.223995999845,
                0
              ],
              [
                -76.6004779994264,
                39.223921999039,
                0
              ],
              [
                -76.6006649995865,
                39.2237339990331,
                0
              ],
              [
                -76.6009010002632,
                39.223972999011,
                0
              ],
              [
                -76.6016100002045,
                39.2246929998476,
                0
              ],
              [
                -76.6018469999214,
                39.2249329992907,
                0
              ],
              [
                -76.6022099997468,
                39.2252879988515,
                0
              ],
              [
                -76.603301000197,
                39.2263529990781,
                0
              ],
              [
                -76.6036650003053,
                39.2267089989942,
                0
              ],
              [
                -76.603706000007,
                39.2267559985631,
                0
              ],
              [
                -76.6038300000599,
                39.2268969987563,
                0
              ],
              [
                -76.6038720006074,
                39.2269439989399,
                0
              ],
              [
                -76.6039220000755,
                39.2269999987414,
                0
              ],
              [
                -76.6039710003598,
                39.2270569986145,
                0
              ],
              [
                -76.6040420001174,
                39.2271379991238,
                0
              ],
              [
                -76.6043480003892,
                39.2274859986086,
                0
              ],
              [
                -76.6045539999307,
                39.2277209993165,
                0
              ],
              [
                -76.6047250005512,
                39.22791599989,
                0
              ],
              [
                -76.6047470004427,
                39.2279399986084,
                0
              ],
              [
                -76.6048009995791,
                39.2279819990007,
                0
              ],
              [
                -76.6050420008785,
                39.2281679991049,
                0
              ],
              [
                -76.6050990004533,
                39.2282119992683,
                0
              ],
              [
                -76.6051230007105,
                39.2282309990277,
                0
              ],
              [
                -76.6051959998946,
                39.2282879980309,
                0
              ],
              [
                -76.6054150004416,
                39.2284589992741,
                0
              ],
              [
                -76.6054889998217,
                39.228516998612,
                0
              ],
              [
                -76.605570000698,
                39.2285859991946,
                0
              ],
              [
                -76.6056719998387,
                39.2286720003626,
                0
              ],
              [
                -76.6058140005377,
                39.2287940002038,
                0
              ],
              [
                -76.6058539990925,
                39.2288279992206,
                0
              ],
              [
                -76.6058959994773,
                39.2288639992639,
                0
              ],
              [
                -76.6059600004555,
                39.2289189993675,
                0
              ],
              [
                -76.6061520005105,
                39.2290839994521,
                0
              ],
              [
                -76.6062160009675,
                39.2291400001722,
                0
              ],
              [
                -76.6062850002852,
                39.2292009998185,
                0
              ],
              [
                -76.6064920001028,
                39.2293839994124,
                0
              ],
              [
                -76.60656199965,
                39.2294459994029,
                0
              ],
              [
                -76.6066319998221,
                39.2295099990755,
                0
              ],
              [
                -76.6068449989767,
                39.2297039985934,
                0
              ],
              [
                -76.6069160005812,
                39.229768998604,
                0
              ],
              [
                -76.6069400001716,
                39.2297860000563,
                0
              ],
              [
                -76.6070279998028,
                39.2299019994147,
                0
              ],
              [
                -76.6073450006787,
                39.2303219986651,
                0
              ],
              [
                -76.6074509995887,
                39.2304629985823,
                0
              ],
              [
                -76.6075989994883,
                39.2305939987821,
                0
              ],
              [
                -76.6080429995265,
                39.2309889988464,
                0
              ],
              [
                -76.6081670001726,
                39.2310989994434,
                0
              ],
              [
                -76.6078080004279,
                39.2312599986714,
                0
              ],
              [
                -76.607474000321,
                39.2313949993417,
                0
              ],
              [
                -76.6066990006834,
                39.2317169987455,
                0
              ],
              [
                -76.6064169994246,
                39.2318249987264,
                0
              ],
              [
                -76.6051050001673,
                39.2323969994038,
                0
              ],
              [
                -76.6047140002416,
                39.2325589993573,
                0
              ],
              [
                -76.6043209997819,
                39.2327279992974,
                0
              ],
              [
                -76.6042050008912,
                39.2326229993447,
                0
              ],
              [
                -76.6039050003381,
                39.2332339986202,
                0
              ],
              [
                -76.6036869997062,
                39.2335999990973,
                0
              ],
              [
                -76.6036210009931,
                39.2337249993402,
                0
              ],
              [
                -76.6033919992142,
                39.2342409988108,
                0
              ],
              [
                -76.6031259997885,
                39.2347489990124,
                0
              ],
              [
                -76.6028639990349,
                39.2352719991745,
                0
              ],
              [
                -76.6026139994354,
                39.2357859991393,
                0
              ],
              [
                -76.6023530011262,
                39.2363029986644,
                0
              ],
              [
                -76.6016369987929,
                39.2360849993869,
                0
              ],
              [
                -76.6013370003138,
                39.2359949987775,
                0
              ],
              [
                -76.6010190003112,
                39.2358969985841,
                0
              ],
              [
                -76.6007829994286,
                39.2358259988135,
                0
              ],
              [
                -76.5998140012988,
                39.2355409999651,
                0
              ],
              [
                -76.5996919984457,
                39.235501999272,
                0
              ],
              [
                -76.59959499952,
                39.2354709988542,
                0
              ],
              [
                -76.599318999909,
                39.2353889990319,
                0
              ],
              [
                -76.5977420003413,
                39.2348979993661,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 109,
          "Census_Tract": "24510280101",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "3543dd21-14e2-4b78-9be9-100d342aaa31",
          "Shape__Area": 15158456.751708984,
          "Shape__Length": 29774.60682940868
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.7024460000401,
                39.3562459987329,
                0
              ],
              [
                -76.7024280000747,
                39.3562199993023,
                0
              ],
              [
                -76.7024240000408,
                39.3561869987284,
                0
              ],
              [
                -76.7020430001213,
                39.3559329993434,
                0
              ],
              [
                -76.7019200001528,
                39.3558439990788,
                0
              ],
              [
                -76.7013809995804,
                39.3554789978673,
                0
              ],
              [
                -76.7005840014406,
                39.3549419988988,
                0
              ],
              [
                -76.7005230005527,
                39.3548979991826,
                0
              ],
              [
                -76.7001879998419,
                39.3546499989238,
                0
              ],
              [
                -76.6998050010581,
                39.3543849989078,
                0
              ],
              [
                -76.6996849996249,
                39.3543009994024,
                0
              ],
              [
                -76.6989650004838,
                39.3537969988591,
                0
              ],
              [
                -76.6987890012535,
                39.3536769993088,
                0
              ],
              [
                -76.6984869995711,
                39.353465999016,
                0
              ],
              [
                -76.698059000419,
                39.3531649986208,
                0
              ],
              [
                -76.6974869992243,
                39.3527539990085,
                0
              ],
              [
                -76.6973109996486,
                39.3526349988148,
                0
              ],
              [
                -76.6965279998977,
                39.3520839994352,
                0
              ],
              [
                -76.6963839996583,
                39.3519800002612,
                0
              ],
              [
                -76.6956979998148,
                39.3514959985858,
                0
              ],
              [
                -76.6953549999125,
                39.3512539993629,
                0
              ],
              [
                -76.6949829996571,
                39.3509849989589,
                0
              ],
              [
                -76.6945790001279,
                39.350693999218,
                0
              ],
              [
                -76.6941800000914,
                39.3504190001019,
                0
              ],
              [
                -76.6932660000642,
                39.349784999228,
                0
              ],
              [
                -76.6932400003095,
                39.3497669994519,
                0
              ],
              [
                -76.6927970001911,
                39.3494669995672,
                0
              ],
              [
                -76.6924219998963,
                39.3492119994495,
                0
              ],
              [
                -76.6923369988358,
                39.3491599988688,
                0
              ],
              [
                -76.6922539996497,
                39.349101999126,
                0
              ],
              [
                -76.691838999946,
                39.3488079993108,
                0
              ],
              [
                -76.6916920009692,
                39.3487099979338,
                0
              ],
              [
                -76.6908789987953,
                39.3481569987983,
                0
              ],
              [
                -76.690058999483,
                39.3475849986453,
                0
              ],
              [
                -76.6890450000363,
                39.3468709993164,
                0
              ],
              [
                -76.6889900005756,
                39.346831999449,
                0
              ],
              [
                -76.6889110001375,
                39.3467749986827,
                0
              ],
              [
                -76.6887560002853,
                39.34665899988,
                0
              ],
              [
                -76.6886929994348,
                39.3466129988403,
                0
              ],
              [
                -76.6881979996059,
                39.3462670002724,
                0
              ],
              [
                -76.6880080005556,
                39.3461239988714,
                0
              ],
              [
                -76.6875270005466,
                39.3457789992514,
                0
              ],
              [
                -76.6873320005069,
                39.3456399989458,
                0
              ],
              [
                -76.6873010006236,
                39.3456179987436,
                0
              ],
              [
                -76.6870300002437,
                39.3454259987669,
                0
              ],
              [
                -76.6869439998629,
                39.3453649994332,
                0
              ],
              [
                -76.6866600008973,
                39.3451639988835,
                0
              ],
              [
                -76.6863989994346,
                39.344978999412,
                0
              ],
              [
                -76.6860799997825,
                39.3447389991988,
                0
              ],
              [
                -76.6860180006478,
                39.3446959988356,
                0
              ],
              [
                -76.6857170002838,
                39.3444879986158,
                0
              ],
              [
                -76.6853130001201,
                39.3442019995885,
                0
              ],
              [
                -76.6835189998209,
                39.3429399992977,
                0
              ],
              [
                -76.6828360001171,
                39.3424519988662,
                0
              ],
              [
                -76.6827230005193,
                39.3423769989394,
                0
              ],
              [
                -76.6826699990947,
                39.3423409991071,
                0
              ],
              [
                -76.6824640002389,
                39.3422169987463,
                0
              ],
              [
                -76.6822959990028,
                39.3421259985533,
                0
              ],
              [
                -76.6820929997002,
                39.3420519986911,
                0
              ],
              [
                -76.6817550001287,
                39.3419279994526,
                0
              ],
              [
                -76.6814919999767,
                39.3418199996844,
                0
              ],
              [
                -76.6813180014769,
                39.3417619985783,
                0
              ],
              [
                -76.6811459984436,
                39.3417119994249,
                0
              ],
              [
                -76.6809930002363,
                39.341687999305,
                0
              ],
              [
                -76.6808870010872,
                39.3416809992932,
                0
              ],
              [
                -76.6807529996087,
                39.3416759993626,
                0
              ],
              [
                -76.680662000501,
                39.3416769988486,
                0
              ],
              [
                -76.6805840002289,
                39.3416849990309,
                0
              ],
              [
                -76.6804400004577,
                39.3417049996359,
                0
              ],
              [
                -76.6803570005074,
                39.3417219989166,
                0
              ],
              [
                -76.6801970005664,
                39.3417599994135,
                0
              ],
              [
                -76.6793969996131,
                39.3419909986668,
                0
              ],
              [
                -76.6791919996814,
                39.3420429987279,
                0
              ],
              [
                -76.6789710001831,
                39.3421129993358,
                0
              ],
              [
                -76.6787020011497,
                39.3421839987917,
                0
              ],
              [
                -76.6786129999682,
                39.3422059993823,
                0
              ],
              [
                -76.6785420000109,
                39.3422179986329,
                0
              ],
              [
                -76.6784679999036,
                39.3422269991674,
                0
              ],
              [
                -76.6784010000765,
                39.3422319996879,
                0
              ],
              [
                -76.6783790004337,
                39.3422329987804,
                0
              ],
              [
                -76.6783180000122,
                39.3422359980006,
                0
              ],
              [
                -76.6782159996809,
                39.3422369988208,
                0
              ],
              [
                -76.6780109994323,
                39.34220699945,
                0
              ],
              [
                -76.6777449994662,
                39.3421359991315,
                0
              ],
              [
                -76.6769580000855,
                39.341913999324,
                0
              ],
              [
                -76.6767099996939,
                39.3418409987185,
                0
              ],
              [
                -76.6768939998415,
                39.341474999194,
                0
              ],
              [
                -76.6770669999176,
                39.3411339989961,
                0
              ],
              [
                -76.6771399996675,
                39.3410359986105,
                0
              ],
              [
                -76.6771979994625,
                39.3409669996732,
                0
              ],
              [
                -76.6772660000056,
                39.340903999191,
                0
              ],
              [
                -76.6776649999266,
                39.3403589998704,
                0
              ],
              [
                -76.6779640003796,
                39.3399249986507,
                0
              ],
              [
                -76.6793390002272,
                39.340347999386,
                0
              ],
              [
                -76.6829159995381,
                39.3414349998486,
                0
              ],
              [
                -76.6846980005377,
                39.3419359985672,
                0
              ],
              [
                -76.6874770001702,
                39.3428539997305,
                0
              ],
              [
                -76.6877540004362,
                39.3429749993251,
                0
              ],
              [
                -76.6879420005355,
                39.3430619986179,
                0
              ],
              [
                -76.6882580002292,
                39.3432109992277,
                0
              ],
              [
                -76.6889659990057,
                39.3435599990369,
                0
              ],
              [
                -76.6903939999951,
                39.3443659992008,
                0
              ],
              [
                -76.6910279994416,
                39.3447509986518,
                0
              ],
              [
                -76.6915799996485,
                39.3450559990114,
                0
              ],
              [
                -76.6925180000507,
                39.3455640000602,
                0
              ],
              [
                -76.6940629996403,
                39.3464199989152,
                0
              ],
              [
                -76.6943630005642,
                39.3465939989843,
                0
              ],
              [
                -76.6944939997221,
                39.3466699990397,
                0
              ],
              [
                -76.6946639996856,
                39.3468069993721,
                0
              ],
              [
                -76.694907999959,
                39.3469839988658,
                0
              ],
              [
                -76.6949959998534,
                39.3470449993083,
                0
              ],
              [
                -76.695160000549,
                39.347147999267,
                0
              ],
              [
                -76.6953159998277,
                39.3472489993287,
                0
              ],
              [
                -76.6956679999526,
                39.3474539991497,
                0
              ],
              [
                -76.6963130003986,
                39.3478139988837,
                0
              ],
              [
                -76.6969370007136,
                39.3481599992233,
                0
              ],
              [
                -76.6976269998098,
                39.3485349986635,
                0
              ],
              [
                -76.6982369997231,
                39.3488719990197,
                0
              ],
              [
                -76.6986390001411,
                39.3490909994291,
                0
              ],
              [
                -76.6991210004346,
                39.3493549988217,
                0
              ],
              [
                -76.6994939994521,
                39.3495509990962,
                0
              ],
              [
                -76.6998109989996,
                39.3497259985649,
                0
              ],
              [
                -76.7004950002705,
                39.3501119996672,
                0
              ],
              [
                -76.701129000534,
                39.3504649989251,
                0
              ],
              [
                -76.7017150002553,
                39.3507950004535,
                0
              ],
              [
                -76.7020320003864,
                39.3509699992431,
                0
              ],
              [
                -76.7022940001693,
                39.3511139985669,
                0
              ],
              [
                -76.7024410004485,
                39.3511889978805,
                0
              ],
              [
                -76.7026660003495,
                39.3512879990318,
                0
              ],
              [
                -76.7029190010746,
                39.3513859977167,
                0
              ],
              [
                -76.7034049999079,
                39.3515949992094,
                0
              ],
              [
                -76.7035970001557,
                39.3516989990907,
                0
              ],
              [
                -76.7039880000555,
                39.351915998597,
                0
              ],
              [
                -76.70435199953,
                39.3521139989505,
                0
              ],
              [
                -76.7045140001774,
                39.3522029993221,
                0
              ],
              [
                -76.7047399995128,
                39.3523219989916,
                0
              ],
              [
                -76.7051670000031,
                39.3525149991359,
                0
              ],
              [
                -76.7054370005662,
                39.3526319991394,
                0
              ],
              [
                -76.7056019995783,
                39.3526999993567,
                0
              ],
              [
                -76.705713000383,
                39.3527469985771,
                0
              ],
              [
                -76.7058899999532,
                39.3528129990548,
                0
              ],
              [
                -76.7061690004853,
                39.3529189993249,
                0
              ],
              [
                -76.7064409999185,
                39.353026999105,
                0
              ],
              [
                -76.7065789995005,
                39.3529279992044,
                0
              ],
              [
                -76.7066419997393,
                39.3528829978296,
                0
              ],
              [
                -76.7066989995665,
                39.3528430003735,
                0
              ],
              [
                -76.707067000441,
                39.3525799992813,
                0
              ],
              [
                -76.7074059995979,
                39.3523459989286,
                0
              ],
              [
                -76.707489000494,
                39.3522809991023,
                0
              ],
              [
                -76.708111000789,
                39.3517949987827,
                0
              ],
              [
                -76.7085270005256,
                39.3514980002901,
                0
              ],
              [
                -76.7085719999501,
                39.3514649988361,
                0
              ],
              [
                -76.7088459999361,
                39.3512659989371,
                0
              ],
              [
                -76.7096009998787,
                39.3507459989911,
                0
              ],
              [
                -76.7103069999426,
                39.3502399988283,
                0
              ],
              [
                -76.7110569996023,
                39.3497109994203,
                0
              ],
              [
                -76.7113879997273,
                39.3494959986226,
                0
              ],
              [
                -76.7113630004917,
                39.3499889988105,
                0
              ],
              [
                -76.7112040002194,
                39.3509910004303,
                0
              ],
              [
                -76.711357999452,
                39.3516619990952,
                0
              ],
              [
                -76.7113440005352,
                39.3522599981211,
                0
              ],
              [
                -76.7112579984252,
                39.3533179988901,
                0
              ],
              [
                -76.7111930004007,
                39.3537400003533,
                0
              ],
              [
                -76.7111930003216,
                39.3542339989159,
                0
              ],
              [
                -76.7111879999499,
                39.3543449990952,
                0
              ],
              [
                -76.7111860003532,
                39.3543829990574,
                0
              ],
              [
                -76.7111910005555,
                39.355298998641,
                0
              ],
              [
                -76.7111910001267,
                39.3553289986385,
                0
              ],
              [
                -76.7111909996092,
                39.3553649993556,
                0
              ],
              [
                -76.7111929995573,
                39.3556699997292,
                0
              ],
              [
                -76.7111940006629,
                39.3558049985602,
                0
              ],
              [
                -76.7112280000529,
                39.3561609980172,
                0
              ],
              [
                -76.7113499994238,
                39.3567709991536,
                0
              ],
              [
                -76.7113499998892,
                39.3572619986814,
                0
              ],
              [
                -76.7113500002461,
                39.3579059992621,
                0
              ],
              [
                -76.7112090000593,
                39.3586679987334,
                0
              ],
              [
                -76.7112739985448,
                39.3589450000286,
                0
              ],
              [
                -76.7114000005723,
                39.3594839989558,
                0
              ],
              [
                -76.7112939993739,
                39.3605009989445,
                0
              ],
              [
                -76.7113419997985,
                39.3612249994413,
                0
              ],
              [
                -76.7112929996818,
                39.3617249988436,
                0
              ],
              [
                -76.7112360000348,
                39.3623099990287,
                0
              ],
              [
                -76.7112030002042,
                39.3626509989832,
                0
              ],
              [
                -76.7111910004553,
                39.3627709989491,
                0
              ],
              [
                -76.7111909994869,
                39.3627979994214,
                0
              ],
              [
                -76.7110589985108,
                39.3627089985737,
                0
              ],
              [
                -76.710583000416,
                39.3623849987334,
                0
              ],
              [
                -76.7102419986015,
                39.3621409988767,
                0
              ],
              [
                -76.70911500026,
                39.3613449989974,
                0
              ],
              [
                -76.7086720003619,
                39.3609689994464,
                0
              ],
              [
                -76.7085999999279,
                39.3609579987005,
                0
              ],
              [
                -76.7085420009181,
                39.3609399987575,
                0
              ],
              [
                -76.7084090004026,
                39.360845998702,
                0
              ],
              [
                -76.7081489995024,
                39.3606539993352,
                0
              ],
              [
                -76.7077510002314,
                39.3603229988243,
                0
              ],
              [
                -76.7073449994999,
                39.3599780002684,
                0
              ],
              [
                -76.7069179999736,
                39.3596579992396,
                0
              ],
              [
                -76.7067229996943,
                39.3595059991295,
                0
              ],
              [
                -76.7059489996116,
                39.358906998828,
                0
              ],
              [
                -76.7053970011345,
                39.3584809977334,
                0
              ],
              [
                -76.7050969999886,
                39.3582499991519,
                0
              ],
              [
                -76.7043459995015,
                39.3576509988293,
                0
              ],
              [
                -76.7042280002069,
                39.357556999206,
                0
              ],
              [
                -76.7039279998138,
                39.3573259993581,
                0
              ],
              [
                -76.7037739998936,
                39.3572069987025,
                0
              ],
              [
                -76.7037160001596,
                39.3571629992373,
                0
              ],
              [
                -76.7036169995692,
                39.3570919985624,
                0
              ],
              [
                -76.7035549996941,
                39.3570459992025,
                0
              ],
              [
                -76.7034609998905,
                39.3569769998299,
                0
              ],
              [
                -76.7029770003441,
                39.3566289994142,
                0
              ],
              [
                -76.7024460000401,
                39.3562459987329,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 110,
          "Census_Tract": "24510280102",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "efa68876-2f3a-4ee7-b44f-31ebf15b1d1b",
          "Shape__Area": 37658095.05731201,
          "Shape__Length": 28180.918125092943
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.6829159995381,
                39.3414349998486,
                0
              ],
              [
                -76.6829870004722,
                39.3413549990358,
                0
              ],
              [
                -76.6830499997362,
                39.3412829986279,
                0
              ],
              [
                -76.683104000281,
                39.3412219990296,
                0
              ],
              [
                -76.6833170004516,
                39.3409769987721,
                0
              ],
              [
                -76.6834769994317,
                39.3407939986299,
                0
              ],
              [
                -76.6840399998588,
                39.3407839988764,
                0
              ],
              [
                -76.6841759995638,
                39.340781998954,
                0
              ],
              [
                -76.684484000156,
                39.3407759992324,
                0
              ],
              [
                -76.6854759992924,
                39.3407579988162,
                0
              ],
              [
                -76.6870580000101,
                39.3407569989793,
                0
              ],
              [
                -76.6893789996579,
                39.3407539991823,
                0
              ],
              [
                -76.6893690011193,
                39.3403739986362,
                0
              ],
              [
                -76.6893699999817,
                39.3402439987619,
                0
              ],
              [
                -76.6893729998798,
                39.3397319987882,
                0
              ],
              [
                -76.6893679995579,
                39.3392159990081,
                0
              ],
              [
                -76.689364000225,
                39.3387039992909,
                0
              ],
              [
                -76.6893620000626,
                39.3381759994513,
                0
              ],
              [
                -76.6893619999317,
                39.337675999041,
                0
              ],
              [
                -76.6893549988183,
                39.3371549990127,
                0
              ],
              [
                -76.6893470000125,
                39.336632999138,
                0
              ],
              [
                -76.6893480007235,
                39.3361949993893,
                0
              ],
              [
                -76.689348000603,
                39.3361270003693,
                0
              ],
              [
                -76.6893480005608,
                39.3356989988767,
                0
              ],
              [
                -76.6893559986686,
                39.33562899881,
                0
              ],
              [
                -76.6893579996626,
                39.3350759998504,
                0
              ],
              [
                -76.6893610000754,
                39.3339769986902,
                0
              ],
              [
                -76.6895000001862,
                39.3337169991753,
                0
              ],
              [
                -76.6896750003405,
                39.3333939991019,
                0
              ],
              [
                -76.6900690000597,
                39.3325839991454,
                0
              ],
              [
                -76.6903579997999,
                39.332023998792,
                0
              ],
              [
                -76.6905109995765,
                39.3317289994069,
                0
              ],
              [
                -76.6906439994285,
                39.3314609992703,
                0
              ],
              [
                -76.690866000365,
                39.3310129991727,
                0
              ],
              [
                -76.6897739999876,
                39.3307309990452,
                0
              ],
              [
                -76.6886460005001,
                39.3304309991502,
                0
              ],
              [
                -76.6885920000741,
                39.329504998619,
                0
              ],
              [
                -76.688579999188,
                39.329183999268,
                0
              ],
              [
                -76.6897769998671,
                39.3295539998606,
                0
              ],
              [
                -76.6903889998902,
                39.329738998239,
                0
              ],
              [
                -76.6913459993262,
                39.3300319985745,
                0
              ],
              [
                -76.6930070003824,
                39.3305379991487,
                0
              ],
              [
                -76.6942590001334,
                39.3309199999076,
                0
              ],
              [
                -76.6956740000318,
                39.3313999988731,
                0
              ],
              [
                -76.6964339996381,
                39.3316439998202,
                0
              ],
              [
                -76.6968339999095,
                39.3317719994488,
                0
              ],
              [
                -76.6970860000964,
                39.3318519993964,
                0
              ],
              [
                -76.6984699998659,
                39.3322929993964,
                0
              ],
              [
                -76.6995039996994,
                39.3326189985949,
                0
              ],
              [
                -76.6995970003867,
                39.3326439986896,
                0
              ],
              [
                -76.7006370001671,
                39.3329619991707,
                0
              ],
              [
                -76.7007900004553,
                39.3330119990588,
                0
              ],
              [
                -76.7012849994971,
                39.3331709991744,
                0
              ],
              [
                -76.7016810000048,
                39.3332979992354,
                0
              ],
              [
                -76.7024560005428,
                39.3335419990668,
                0
              ],
              [
                -76.7025780003401,
                39.3335799985817,
                0
              ],
              [
                -76.7030740005008,
                39.333731999364,
                0
              ],
              [
                -76.7053670000435,
                39.3344449985997,
                0
              ],
              [
                -76.7056180004088,
                39.3345239994268,
                0
              ],
              [
                -76.7073930004932,
                39.3350859991248,
                0
              ],
              [
                -76.7076440007312,
                39.3351649992015,
                0
              ],
              [
                -76.7085869996201,
                39.3355269988477,
                0
              ],
              [
                -76.7086700000415,
                39.3355549988386,
                0
              ],
              [
                -76.70978400115,
                39.3359439988358,
                0
              ],
              [
                -76.7098210002373,
                39.3359569987356,
                0
              ],
              [
                -76.7099119996775,
                39.335989998703,
                0
              ],
              [
                -76.7103530010146,
                39.3361480002397,
                0
              ],
              [
                -76.7108510003219,
                39.3363139993106,
                0
              ],
              [
                -76.7110250002214,
                39.3363329987033,
                0
              ],
              [
                -76.7110110001637,
                39.3363909992205,
                0
              ],
              [
                -76.7110309999472,
                39.3368219993864,
                0
              ],
              [
                -76.7111929996413,
                39.3404049986219,
                0
              ],
              [
                -76.7111930001489,
                39.3424049992133,
                0
              ],
              [
                -76.7111699994342,
                39.3436279991111,
                0
              ],
              [
                -76.7111940007272,
                39.3448049987377,
                0
              ],
              [
                -76.7112480002373,
                39.3467049992164,
                0
              ],
              [
                -76.7112939993322,
                39.3483049989591,
                0
              ],
              [
                -76.7113879997273,
                39.3494959986226,
                0
              ],
              [
                -76.7110569996023,
                39.3497109994203,
                0
              ],
              [
                -76.7103069999426,
                39.3502399988283,
                0
              ],
              [
                -76.7096009998787,
                39.3507459989911,
                0
              ],
              [
                -76.7088459999361,
                39.3512659989371,
                0
              ],
              [
                -76.7085719999501,
                39.3514649988361,
                0
              ],
              [
                -76.7085270005256,
                39.3514980002901,
                0
              ],
              [
                -76.708111000789,
                39.3517949987827,
                0
              ],
              [
                -76.707489000494,
                39.3522809991023,
                0
              ],
              [
                -76.7074059995979,
                39.3523459989286,
                0
              ],
              [
                -76.707067000441,
                39.3525799992813,
                0
              ],
              [
                -76.7066989995665,
                39.3528430003735,
                0
              ],
              [
                -76.7066419997393,
                39.3528829978296,
                0
              ],
              [
                -76.7065789995005,
                39.3529279992044,
                0
              ],
              [
                -76.7064409999185,
                39.353026999105,
                0
              ],
              [
                -76.7061690004853,
                39.3529189993249,
                0
              ],
              [
                -76.7058899999532,
                39.3528129990548,
                0
              ],
              [
                -76.705713000383,
                39.3527469985771,
                0
              ],
              [
                -76.7056019995783,
                39.3526999993567,
                0
              ],
              [
                -76.7054370005662,
                39.3526319991394,
                0
              ],
              [
                -76.7051670000031,
                39.3525149991359,
                0
              ],
              [
                -76.7047399995128,
                39.3523219989916,
                0
              ],
              [
                -76.7045140001774,
                39.3522029993221,
                0
              ],
              [
                -76.70435199953,
                39.3521139989505,
                0
              ],
              [
                -76.7039880000555,
                39.351915998597,
                0
              ],
              [
                -76.7035970001557,
                39.3516989990907,
                0
              ],
              [
                -76.7034049999079,
                39.3515949992094,
                0
              ],
              [
                -76.7029190010746,
                39.3513859977167,
                0
              ],
              [
                -76.7026660003495,
                39.3512879990318,
                0
              ],
              [
                -76.7024410004485,
                39.3511889978805,
                0
              ],
              [
                -76.7022940001693,
                39.3511139985669,
                0
              ],
              [
                -76.7020320003864,
                39.3509699992431,
                0
              ],
              [
                -76.7017150002553,
                39.3507950004535,
                0
              ],
              [
                -76.701129000534,
                39.3504649989251,
                0
              ],
              [
                -76.7004950002705,
                39.3501119996672,
                0
              ],
              [
                -76.6998109989996,
                39.3497259985649,
                0
              ],
              [
                -76.6994939994521,
                39.3495509990962,
                0
              ],
              [
                -76.6991210004346,
                39.3493549988217,
                0
              ],
              [
                -76.6986390001411,
                39.3490909994291,
                0
              ],
              [
                -76.6982369997231,
                39.3488719990197,
                0
              ],
              [
                -76.6976269998098,
                39.3485349986635,
                0
              ],
              [
                -76.6969370007136,
                39.3481599992233,
                0
              ],
              [
                -76.6963130003986,
                39.3478139988837,
                0
              ],
              [
                -76.6956679999526,
                39.3474539991497,
                0
              ],
              [
                -76.6953159998277,
                39.3472489993287,
                0
              ],
              [
                -76.695160000549,
                39.347147999267,
                0
              ],
              [
                -76.6949959998534,
                39.3470449993083,
                0
              ],
              [
                -76.694907999959,
                39.3469839988658,
                0
              ],
              [
                -76.6946639996856,
                39.3468069993721,
                0
              ],
              [
                -76.6944939997221,
                39.3466699990397,
                0
              ],
              [
                -76.6943630005642,
                39.3465939989843,
                0
              ],
              [
                -76.6940629996403,
                39.3464199989152,
                0
              ],
              [
                -76.6925180000507,
                39.3455640000602,
                0
              ],
              [
                -76.6915799996485,
                39.3450559990114,
                0
              ],
              [
                -76.6910279994416,
                39.3447509986518,
                0
              ],
              [
                -76.6903939999951,
                39.3443659992008,
                0
              ],
              [
                -76.6889659990057,
                39.3435599990369,
                0
              ],
              [
                -76.6882580002292,
                39.3432109992277,
                0
              ],
              [
                -76.6879420005355,
                39.3430619986179,
                0
              ],
              [
                -76.6877540004362,
                39.3429749993251,
                0
              ],
              [
                -76.6874770001702,
                39.3428539997305,
                0
              ],
              [
                -76.6846980005377,
                39.3419359985672,
                0
              ],
              [
                -76.6829159995381,
                39.3414349998486,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 111,
          "Census_Tract": "24510260202",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "cb84c387-f4ab-4237-8994-24822004474e",
          "Shape__Area": 11254628.552368164,
          "Shape__Length": 15454.590364910897
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.5484419987673,
                39.3218299987812,
                0
              ],
              [
                -76.5486069999967,
                39.321806998611,
                0
              ],
              [
                -76.5489439998145,
                39.3217339999942,
                0
              ],
              [
                -76.5490609996161,
                39.3216619985669,
                0
              ],
              [
                -76.5496499994716,
                39.3214129986869,
                0
              ],
              [
                -76.549895999569,
                39.3213059991259,
                0
              ],
              [
                -76.550162000221,
                39.3211559988141,
                0
              ],
              [
                -76.5502909999533,
                39.321084998688,
                0
              ],
              [
                -76.5506330004383,
                39.3208579988304,
                0
              ],
              [
                -76.5514270000489,
                39.3203309990744,
                0
              ],
              [
                -76.5520550000271,
                39.3199069976911,
                0
              ],
              [
                -76.5538559989122,
                39.3186699993194,
                0
              ],
              [
                -76.5543280000965,
                39.3183579985929,
                0
              ],
              [
                -76.5545219992346,
                39.3182469990281,
                0
              ],
              [
                -76.5546980001309,
                39.3181579994506,
                0
              ],
              [
                -76.5550240004388,
                39.3179559977145,
                0
              ],
              [
                -76.5551130001387,
                39.3180229986524,
                0
              ],
              [
                -76.55523599969,
                39.3181329987404,
                0
              ],
              [
                -76.5553440005406,
                39.318287998622,
                0
              ],
              [
                -76.5553890003724,
                39.318397998847,
                0
              ],
              [
                -76.5554370003852,
                39.3185619989573,
                0
              ],
              [
                -76.5554759994781,
                39.3187949988598,
                0
              ],
              [
                -76.5555270005602,
                39.3191229999072,
                0
              ],
              [
                -76.5556100001377,
                39.3195059985804,
                0
              ],
              [
                -76.555667999761,
                39.3196629987486,
                0
              ],
              [
                -76.5557540001014,
                39.3198039992297,
                0
              ],
              [
                -76.5559370012104,
                39.3200810000213,
                0
              ],
              [
                -76.5563590003953,
                39.3206369991474,
                0
              ],
              [
                -76.5564070004942,
                39.3206949988538,
                0
              ],
              [
                -76.5569749997495,
                39.3211829991935,
                0
              ],
              [
                -76.5572559998442,
                39.3213229994252,
                0
              ],
              [
                -76.5573720001648,
                39.321370997975,
                0
              ],
              [
                -76.5574849999291,
                39.3214019986888,
                0
              ],
              [
                -76.5575839997423,
                39.3214179985786,
                0
              ],
              [
                -76.5576859997366,
                39.3214259992687,
                0
              ],
              [
                -76.5579800000474,
                39.3214219989713,
                0
              ],
              [
                -76.5582879987479,
                39.321385999014,
                0
              ],
              [
                -76.5587380001495,
                39.3212739989033,
                0
              ],
              [
                -76.5590020000971,
                39.3211869996159,
                0
              ],
              [
                -76.5592849996646,
                39.3210719989779,
                0
              ],
              [
                -76.5595119996883,
                39.3210189992809,
                0
              ],
              [
                -76.559759000424,
                39.3209939992484,
                0
              ],
              [
                -76.5599249986476,
                39.3209719993866,
                0
              ],
              [
                -76.5601710004983,
                39.3209730004232,
                0
              ],
              [
                -76.5603140003332,
                39.3209929989804,
                0
              ],
              [
                -76.5603860004023,
                39.3210469992032,
                0
              ],
              [
                -76.5604910005555,
                39.3211759988792,
                0
              ],
              [
                -76.5605440009171,
                39.3212759988186,
                0
              ],
              [
                -76.5605820005481,
                39.3214059999091,
                0
              ],
              [
                -76.5606249994529,
                39.3215279975559,
                0
              ],
              [
                -76.5606459995647,
                39.3216519990937,
                0
              ],
              [
                -76.5606560004295,
                39.321780999225,
                0
              ],
              [
                -76.560639000515,
                39.3219179988972,
                0
              ],
              [
                -76.560591999452,
                39.3221009986938,
                0
              ],
              [
                -76.5605860004117,
                39.3221589992254,
                0
              ],
              [
                -76.5605910005165,
                39.3222329986329,
                0
              ],
              [
                -76.560606999319,
                39.3223620004521,
                0
              ],
              [
                -76.5606160013754,
                39.3225529993074,
                0
              ],
              [
                -76.5606240004113,
                39.3226039992612,
                0
              ],
              [
                -76.5606370002107,
                39.3226459986609,
                0
              ],
              [
                -76.5606740000211,
                39.3227319986127,
                0
              ],
              [
                -76.5607089999485,
                39.3228049986048,
                0
              ],
              [
                -76.5607649998828,
                39.3228839986207,
                0
              ],
              [
                -76.5608210000474,
                39.3229509987688,
                0
              ],
              [
                -76.5609390004695,
                39.3230569989504,
                0
              ],
              [
                -76.5614329997331,
                39.3234719991325,
                0
              ],
              [
                -76.5626050005576,
                39.3246699987444,
                0
              ],
              [
                -76.5626599997612,
                39.3247049985942,
                0
              ],
              [
                -76.56271799952,
                39.3247329990202,
                0
              ],
              [
                -76.5634850001065,
                39.3249609986912,
                0
              ],
              [
                -76.5638609994125,
                39.3250449989534,
                0
              ],
              [
                -76.5642309985022,
                39.3251139980431,
                0
              ],
              [
                -76.5644409998822,
                39.3251389985866,
                0
              ],
              [
                -76.564918,
                39.3251269990529,
                0
              ],
              [
                -76.565331999804,
                39.3251479987905,
                0
              ],
              [
                -76.5654809995587,
                39.3251749994258,
                0
              ],
              [
                -76.5655890004944,
                39.3252219990881,
                0
              ],
              [
                -76.5657479996753,
                39.3253099983845,
                0
              ],
              [
                -76.5659549995453,
                39.3254319988951,
                0
              ],
              [
                -76.5663610001878,
                39.3256580001759,
                0
              ],
              [
                -76.5670459995034,
                39.3260449990008,
                0
              ],
              [
                -76.5675429998164,
                39.3264059991751,
                0
              ],
              [
                -76.5670830004561,
                39.3268040002284,
                0
              ],
              [
                -76.5667159998621,
                39.3271309991332,
                0
              ],
              [
                -76.5664839995305,
                39.3273209986556,
                0
              ],
              [
                -76.5660449998536,
                39.3276729986594,
                0
              ],
              [
                -76.5659650001384,
                39.3277339994531,
                0
              ],
              [
                -76.5656590004981,
                39.3279969993246,
                0
              ],
              [
                -76.5654100001951,
                39.3282109992667,
                0
              ],
              [
                -76.565338000429,
                39.3282729993158,
                0
              ],
              [
                -76.5651040002639,
                39.3284659998927,
                0
              ],
              [
                -76.5648000004883,
                39.3287159998364,
                0
              ],
              [
                -76.5645290001404,
                39.32893099913,
                0
              ],
              [
                -76.564465998813,
                39.3289799989965,
                0
              ],
              [
                -76.5641200004404,
                39.3292489987199,
                0
              ],
              [
                -76.5639879999742,
                39.3293479989806,
                0
              ],
              [
                -76.5632109996383,
                39.3299329987914,
                0
              ],
              [
                -76.5631380004122,
                39.3299839991862,
                0
              ],
              [
                -76.5624490003042,
                39.3304779991373,
                0
              ],
              [
                -76.5621620003459,
                39.3306860002663,
                0
              ],
              [
                -76.5619439995017,
                39.3308429996888,
                0
              ],
              [
                -76.5618059997381,
                39.3309430001699,
                0
              ],
              [
                -76.5616769995829,
                39.3310439987514,
                0
              ],
              [
                -76.5616119998502,
                39.3310950000952,
                0
              ],
              [
                -76.5615059997978,
                39.3309319992893,
                0
              ],
              [
                -76.5614260002713,
                39.3308379992696,
                0
              ],
              [
                -76.5613329995798,
                39.3307429985795,
                0
              ],
              [
                -76.5610769999836,
                39.3305339990783,
                0
              ],
              [
                -76.5609080005327,
                39.3304019986969,
                0
              ],
              [
                -76.5602440000258,
                39.3299639994223,
                0
              ],
              [
                -76.5594050003567,
                39.3294009997901,
                0
              ],
              [
                -76.5587559997044,
                39.3289629985868,
                0
              ],
              [
                -76.5582539999046,
                39.3286249992084,
                0
              ],
              [
                -76.5580869997479,
                39.3285239997551,
                0
              ],
              [
                -76.5578180002162,
                39.3283889976153,
                0
              ],
              [
                -76.5576760014497,
                39.3283309989512,
                0
              ],
              [
                -76.5576059995837,
                39.3283019988047,
                0
              ],
              [
                -76.5573180000266,
                39.3282079991988,
                0
              ],
              [
                -76.5570579995688,
                39.3281429987305,
                0
              ],
              [
                -76.556745000358,
                39.3280859991847,
                0
              ],
              [
                -76.5564149991238,
                39.3280339986704,
                0
              ],
              [
                -76.5561839994094,
                39.3280019993787,
                0
              ],
              [
                -76.5559249999911,
                39.327957999415,
                0
              ],
              [
                -76.5558740004964,
                39.3279479993328,
                0
              ],
              [
                -76.5558079998243,
                39.3279339990451,
                0
              ],
              [
                -76.5555529985773,
                39.3278679989773,
                0
              ],
              [
                -76.5553659998788,
                39.3278089986468,
                0
              ],
              [
                -76.5552169997782,
                39.3277569992415,
                0
              ],
              [
                -76.5550309998049,
                39.3276769993055,
                0
              ],
              [
                -76.5547799994567,
                39.3275500002171,
                0
              ],
              [
                -76.5545290001209,
                39.3274179987085,
                0
              ],
              [
                -76.5539910010039,
                39.3271119985746,
                0
              ],
              [
                -76.5537410000802,
                39.3269769987349,
                0
              ],
              [
                -76.5534080000292,
                39.326808999208,
                0
              ],
              [
                -76.5532300002267,
                39.326723998775,
                0
              ],
              [
                -76.5530949997192,
                39.3266519990993,
                0
              ],
              [
                -76.5523939992886,
                39.3262199994398,
                0
              ],
              [
                -76.5517879997114,
                39.3257809986661,
                0
              ],
              [
                -76.5516690000434,
                39.325843999281,
                0
              ],
              [
                -76.5512899994314,
                39.3254939993206,
                0
              ],
              [
                -76.5510270005899,
                39.3252499987511,
                0
              ],
              [
                -76.5508900004636,
                39.3250989990775,
                0
              ],
              [
                -76.5506550005726,
                39.324839998079,
                0
              ],
              [
                -76.5504299997688,
                39.3245929986402,
                0
              ],
              [
                -76.549678999799,
                39.3237969991485,
                0
              ],
              [
                -76.5495330000587,
                39.3236439987776,
                0
              ],
              [
                -76.5489519994805,
                39.3230009993294,
                0
              ],
              [
                -76.5488439987126,
                39.3228639989492,
                0
              ],
              [
                -76.5487329995887,
                39.3227019991261,
                0
              ],
              [
                -76.5486470000546,
                39.322534998728,
                0
              ],
              [
                -76.548620999853,
                39.3224689987904,
                0
              ],
              [
                -76.5485959987473,
                39.322399998667,
                0
              ],
              [
                -76.5484970001757,
                39.322060998698,
                0
              ],
              [
                -76.5484419987673,
                39.3218299987812,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 112,
          "Census_Tract": "24510260203",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "4ea0a082-5dd3-4b30-890c-1b2d0d89b746",
          "Shape__Area": 9184324.447265625,
          "Shape__Length": 18376.90175863653
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.5341040003859,
                39.3282949992816,
                0
              ],
              [
                -76.5360229998806,
                39.32670499899,
                0
              ],
              [
                -76.53648600008,
                39.3261060004147,
                0
              ],
              [
                -76.5368769994703,
                39.3255990003113,
                0
              ],
              [
                -76.5383329996968,
                39.323769999113,
                0
              ],
              [
                -76.5398069999072,
                39.3220009993638,
                0
              ],
              [
                -76.5403209996827,
                39.3213829986554,
                0
              ],
              [
                -76.5404589988352,
                39.3212179993496,
                0
              ],
              [
                -76.542234999087,
                39.3200179992581,
                0
              ],
              [
                -76.5423499999685,
                39.3199409992818,
                0
              ],
              [
                -76.543525999957,
                39.3191639998863,
                0
              ],
              [
                -76.5452409994793,
                39.3180229994042,
                0
              ],
              [
                -76.5457420007521,
                39.3176899990396,
                0
              ],
              [
                -76.5458469996306,
                39.317619999064,
                0
              ],
              [
                -76.5474669995127,
                39.3166549991459,
                0
              ],
              [
                -76.5481359995527,
                39.3162559991656,
                0
              ],
              [
                -76.5489380008862,
                39.3158879992101,
                0
              ],
              [
                -76.5489249992237,
                39.3159399985993,
                0
              ],
              [
                -76.5489240001604,
                39.3161099989675,
                0
              ],
              [
                -76.5489429998384,
                39.3161929990982,
                0
              ],
              [
                -76.5489640003705,
                39.3162380004025,
                0
              ],
              [
                -76.5490009997774,
                39.3162729998542,
                0
              ],
              [
                -76.5490299995065,
                39.3162970000905,
                0
              ],
              [
                -76.5490690001932,
                39.3163179986422,
                0
              ],
              [
                -76.5491519999,
                39.3163509992144,
                0
              ],
              [
                -76.5492549999949,
                39.3163869993923,
                0
              ],
              [
                -76.5493900006992,
                39.3164269990365,
                0
              ],
              [
                -76.5494929999289,
                39.3164419987765,
                0
              ],
              [
                -76.549588000148,
                39.3164529990385,
                0
              ],
              [
                -76.5497099996774,
                39.3164719987026,
                0
              ],
              [
                -76.54989200012,
                39.316491999106,
                0
              ],
              [
                -76.5500379993555,
                39.3164869987276,
                0
              ],
              [
                -76.5501359996237,
                39.3164639992905,
                0
              ],
              [
                -76.5502790002345,
                39.3164479988129,
                0
              ],
              [
                -76.5504309998151,
                39.3164609990954,
                0
              ],
              [
                -76.5505699995522,
                39.3164989985878,
                0
              ],
              [
                -76.5507890002094,
                39.3165419993757,
                0
              ],
              [
                -76.5509529996956,
                39.316580999228,
                0
              ],
              [
                -76.5512569997847,
                39.3166199993616,
                0
              ],
              [
                -76.5516179987334,
                39.3166869991007,
                0
              ],
              [
                -76.552049999743,
                39.316758999151,
                0
              ],
              [
                -76.5523110000442,
                39.316807998573,
                0
              ],
              [
                -76.5524499995619,
                39.3168699991685,
                0
              ],
              [
                -76.5526260007786,
                39.316973998574,
                0
              ],
              [
                -76.5530089996642,
                39.3170979992163,
                0
              ],
              [
                -76.5534729996097,
                39.3172789990445,
                0
              ],
              [
                -76.5547410001816,
                39.317755998555,
                0
              ],
              [
                -76.5548259998201,
                39.3177939991557,
                0
              ],
              [
                -76.5548730001269,
                39.3178239993883,
                0
              ],
              [
                -76.5549189998471,
                39.3178609991848,
                0
              ],
              [
                -76.5550240004388,
                39.3179559977145,
                0
              ],
              [
                -76.5546980001309,
                39.3181579994506,
                0
              ],
              [
                -76.5545219992346,
                39.3182469990281,
                0
              ],
              [
                -76.5543280000965,
                39.3183579985929,
                0
              ],
              [
                -76.5538559989122,
                39.3186699993194,
                0
              ],
              [
                -76.5520550000271,
                39.3199069976911,
                0
              ],
              [
                -76.5514270000489,
                39.3203309990744,
                0
              ],
              [
                -76.5506330004383,
                39.3208579988304,
                0
              ],
              [
                -76.5502909999533,
                39.321084998688,
                0
              ],
              [
                -76.550162000221,
                39.3211559988141,
                0
              ],
              [
                -76.549895999569,
                39.3213059991259,
                0
              ],
              [
                -76.5496499994716,
                39.3214129986869,
                0
              ],
              [
                -76.5490609996161,
                39.3216619985669,
                0
              ],
              [
                -76.5489439998145,
                39.3217339999942,
                0
              ],
              [
                -76.5486069999967,
                39.321806998611,
                0
              ],
              [
                -76.5484419987673,
                39.3218299987812,
                0
              ],
              [
                -76.5482000014999,
                39.3218659988016,
                0
              ],
              [
                -76.5477469996026,
                39.3219169993227,
                0
              ],
              [
                -76.5469230005335,
                39.3220149993737,
                0
              ],
              [
                -76.5460219997045,
                39.3221229990807,
                0
              ],
              [
                -76.5458750006746,
                39.3221429990166,
                0
              ],
              [
                -76.5456830003773,
                39.3221729988476,
                0
              ],
              [
                -76.5454299999568,
                39.322215999042,
                0
              ],
              [
                -76.5452660000606,
                39.3222499977448,
                0
              ],
              [
                -76.5450860005523,
                39.3222899990728,
                0
              ],
              [
                -76.5445769996387,
                39.3224359992986,
                0
              ],
              [
                -76.5441269993004,
                39.3225739986914,
                0
              ],
              [
                -76.5428919998522,
                39.322951999241,
                0
              ],
              [
                -76.5428180000391,
                39.3229749986226,
                0
              ],
              [
                -76.5407539999846,
                39.3236229992952,
                0
              ],
              [
                -76.5407849995232,
                39.3238810000861,
                0
              ],
              [
                -76.5408339989474,
                39.3242989991808,
                0
              ],
              [
                -76.5409309993613,
                39.3250069988013,
                0
              ],
              [
                -76.5410859999451,
                39.3261469991546,
                0
              ],
              [
                -76.541273001471,
                39.3271799989811,
                0
              ],
              [
                -76.5413779993354,
                39.3277210003124,
                0
              ],
              [
                -76.5414590002368,
                39.3281579987663,
                0
              ],
              [
                -76.5415789997988,
                39.3288029988476,
                0
              ],
              [
                -76.5416070013682,
                39.3289259986702,
                0
              ],
              [
                -76.5416470008177,
                39.3290339990914,
                0
              ],
              [
                -76.5417209994592,
                39.3292129987835,
                0
              ],
              [
                -76.5407010000165,
                39.3293439998786,
                0
              ],
              [
                -76.5404560003991,
                39.3293749991981,
                0
              ],
              [
                -76.5398300003119,
                39.3294689991481,
                0
              ],
              [
                -76.5389130015387,
                39.3296019993829,
                0
              ],
              [
                -76.5380420001252,
                39.3297349994093,
                0
              ],
              [
                -76.5379149999201,
                39.3297539997159,
                0
              ],
              [
                -76.5365879997771,
                39.3299509981853,
                0
              ],
              [
                -76.5350070004205,
                39.3301979994181,
                0
              ],
              [
                -76.5345329988126,
                39.3302799996722,
                0
              ],
              [
                -76.5340960013133,
                39.3303579994288,
                0
              ],
              [
                -76.5330840005142,
                39.3305389994224,
                0
              ],
              [
                -76.5329770000309,
                39.3305579990791,
                0
              ],
              [
                -76.5330800009289,
                39.3301179986459,
                0
              ],
              [
                -76.5341120005053,
                39.3288929988025,
                0
              ],
              [
                -76.5340949999365,
                39.3287579985765,
                0
              ],
              [
                -76.5340829985883,
                39.328656999078,
                0
              ],
              [
                -76.5340960010592,
                39.3285429999305,
                0
              ],
              [
                -76.5341339995475,
                39.3284499991301,
                0
              ],
              [
                -76.5341500001127,
                39.3284169985911,
                0
              ],
              [
                -76.5341520003404,
                39.328391998902,
                0
              ],
              [
                -76.5341439999862,
                39.3283559992099,
                0
              ],
              [
                -76.5341040003859,
                39.3282949992816,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 113,
          "Census_Tract": "24510260301",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "1f0eaa5b-f557-426d-bf44-6cfb1b37ff58",
          "Shape__Area": 6537322.746398926,
          "Shape__Length": 10821.45587400194
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.559759000424,
                39.3209939992484,
                0
              ],
              [
                -76.5603649996566,
                39.3204239986438,
                0
              ],
              [
                -76.5602660002092,
                39.3203859992645,
                0
              ],
              [
                -76.560219000316,
                39.3203709987889,
                0
              ],
              [
                -76.5601450003716,
                39.3203519996842,
                0
              ],
              [
                -76.5600080002108,
                39.3203249992911,
                0
              ],
              [
                -76.5605400003576,
                39.320223999293,
                0
              ],
              [
                -76.5610170004359,
                39.3201180003565,
                0
              ],
              [
                -76.5611800004762,
                39.320081998811,
                0
              ],
              [
                -76.5616879994234,
                39.3199679988964,
                0
              ],
              [
                -76.562232999986,
                39.3198639996803,
                0
              ],
              [
                -76.5628270004384,
                39.3197499989908,
                0
              ],
              [
                -76.5628990012648,
                39.3197339991702,
                0
              ],
              [
                -76.5632639997002,
                39.319659998975,
                0
              ],
              [
                -76.5633330000294,
                39.3196479987982,
                0
              ],
              [
                -76.5638150000754,
                39.3195629991756,
                0
              ],
              [
                -76.5639230004156,
                39.319547998856,
                0
              ],
              [
                -76.5646510000537,
                39.3194579993709,
                0
              ],
              [
                -76.5649659996684,
                39.3194169987737,
                0
              ],
              [
                -76.5652009995601,
                39.3193889992316,
                0
              ],
              [
                -76.5656550002566,
                39.3193329990619,
                0
              ],
              [
                -76.5659230005108,
                39.3192989994071,
                0
              ],
              [
                -76.5660500000014,
                39.3192829990109,
                0
              ],
              [
                -76.5664700014975,
                39.3192209999373,
                0
              ],
              [
                -76.5665609996808,
                39.3192079990063,
                0
              ],
              [
                -76.5667239998895,
                39.3191889987254,
                0
              ],
              [
                -76.5670169999676,
                39.319150999316,
                0
              ],
              [
                -76.567533999578,
                39.3190850004129,
                0
              ],
              [
                -76.5680960005382,
                39.3190229991362,
                0
              ],
              [
                -76.568140999689,
                39.3190179986718,
                0
              ],
              [
                -76.5688050005508,
                39.3189439987114,
                0
              ],
              [
                -76.5694729998163,
                39.3188649987538,
                0
              ],
              [
                -76.5696640003325,
                39.3188329990994,
                0
              ],
              [
                -76.5699619996506,
                39.3187919994385,
                0
              ],
              [
                -76.5702710000573,
                39.3187379990281,
                0
              ],
              [
                -76.5704260009271,
                39.3187069987474,
                0
              ],
              [
                -76.5703029998562,
                39.3184649991978,
                0
              ],
              [
                -76.5704390000383,
                39.3184229987725,
                0
              ],
              [
                -76.5706000005396,
                39.3187189994323,
                0
              ],
              [
                -76.5707600003412,
                39.3190199989739,
                0
              ],
              [
                -76.5708620004236,
                39.3192069987283,
                0
              ],
              [
                -76.5710050001526,
                39.3194689989104,
                0
              ],
              [
                -76.5711030001354,
                39.319611999103,
                0
              ],
              [
                -76.5712569999982,
                39.3198029993178,
                0
              ],
              [
                -76.5714540004477,
                39.3200099985796,
                0
              ],
              [
                -76.5715950002251,
                39.3201379999319,
                0
              ],
              [
                -76.5717290001641,
                39.3202589983616,
                0
              ],
              [
                -76.5717700002178,
                39.3202969992362,
                0
              ],
              [
                -76.5721280011415,
                39.3205299977085,
                0
              ],
              [
                -76.5727700010612,
                39.3209479985979,
                0
              ],
              [
                -76.5732129996331,
                39.3212469990952,
                0
              ],
              [
                -76.573653000483,
                39.32150899937,
                0
              ],
              [
                -76.5737090005063,
                39.3215469990135,
                0
              ],
              [
                -76.5737339999794,
                39.3215789988748,
                0
              ],
              [
                -76.5737450006833,
                39.3216119991401,
                0
              ],
              [
                -76.5736729994736,
                39.3216649986328,
                0
              ],
              [
                -76.5732670004903,
                39.3219679996674,
                0
              ],
              [
                -76.5731929997453,
                39.3220239992181,
                0
              ],
              [
                -76.5728539990705,
                39.3222769989735,
                0
              ],
              [
                -76.5726939995416,
                39.322391999328,
                0
              ],
              [
                -76.572550000801,
                39.3224979996827,
                0
              ],
              [
                -76.5722599999122,
                39.3227119994441,
                0
              ],
              [
                -76.5722250011252,
                39.3227369985751,
                0
              ],
              [
                -76.5712860002941,
                39.3233889993756,
                0
              ],
              [
                -76.5709620004936,
                39.3236399991188,
                0
              ],
              [
                -76.5706979994708,
                39.3238439996564,
                0
              ],
              [
                -76.5704169988981,
                39.3240699987013,
                0
              ],
              [
                -76.5701809994406,
                39.3242579994464,
                0
              ],
              [
                -76.5701720001465,
                39.3242659994497,
                0
              ],
              [
                -76.5701269995385,
                39.3243039988681,
                0
              ],
              [
                -76.5698029994359,
                39.3245769989627,
                0
              ],
              [
                -76.569633999988,
                39.3247199989945,
                0
              ],
              [
                -76.5694469995151,
                39.3248799994011,
                0
              ],
              [
                -76.5690289994987,
                39.3252139987155,
                0
              ],
              [
                -76.5684049999044,
                39.3257269989488,
                0
              ],
              [
                -76.5675429998164,
                39.3264059991751,
                0
              ],
              [
                -76.5670459995034,
                39.3260449990008,
                0
              ],
              [
                -76.5663610001878,
                39.3256580001759,
                0
              ],
              [
                -76.5659549995453,
                39.3254319988951,
                0
              ],
              [
                -76.5657479996753,
                39.3253099983845,
                0
              ],
              [
                -76.5655890004944,
                39.3252219990881,
                0
              ],
              [
                -76.5654809995587,
                39.3251749994258,
                0
              ],
              [
                -76.565331999804,
                39.3251479987905,
                0
              ],
              [
                -76.564918,
                39.3251269990529,
                0
              ],
              [
                -76.5644409998822,
                39.3251389985866,
                0
              ],
              [
                -76.5642309985022,
                39.3251139980431,
                0
              ],
              [
                -76.5638609994125,
                39.3250449989534,
                0
              ],
              [
                -76.5634850001065,
                39.3249609986912,
                0
              ],
              [
                -76.56271799952,
                39.3247329990202,
                0
              ],
              [
                -76.5626599997612,
                39.3247049985942,
                0
              ],
              [
                -76.5626050005576,
                39.3246699987444,
                0
              ],
              [
                -76.5614329997331,
                39.3234719991325,
                0
              ],
              [
                -76.5609390004695,
                39.3230569989504,
                0
              ],
              [
                -76.5608210000474,
                39.3229509987688,
                0
              ],
              [
                -76.5607649998828,
                39.3228839986207,
                0
              ],
              [
                -76.5607089999485,
                39.3228049986048,
                0
              ],
              [
                -76.5606740000211,
                39.3227319986127,
                0
              ],
              [
                -76.5606370002107,
                39.3226459986609,
                0
              ],
              [
                -76.5606240004113,
                39.3226039992612,
                0
              ],
              [
                -76.5606160013754,
                39.3225529993074,
                0
              ],
              [
                -76.560606999319,
                39.3223620004521,
                0
              ],
              [
                -76.5605910005165,
                39.3222329986329,
                0
              ],
              [
                -76.5605860004117,
                39.3221589992254,
                0
              ],
              [
                -76.560591999452,
                39.3221009986938,
                0
              ],
              [
                -76.560639000515,
                39.3219179988972,
                0
              ],
              [
                -76.5606560004295,
                39.321780999225,
                0
              ],
              [
                -76.5606459995647,
                39.3216519990937,
                0
              ],
              [
                -76.5606249994529,
                39.3215279975559,
                0
              ],
              [
                -76.5605820005481,
                39.3214059999091,
                0
              ],
              [
                -76.5605440009171,
                39.3212759988186,
                0
              ],
              [
                -76.5604910005555,
                39.3211759988792,
                0
              ],
              [
                -76.5603860004023,
                39.3210469992032,
                0
              ],
              [
                -76.5603140003332,
                39.3209929989804,
                0
              ],
              [
                -76.5601710004983,
                39.3209730004232,
                0
              ],
              [
                -76.5599249986476,
                39.3209719993866,
                0
              ],
              [
                -76.559759000424,
                39.3209939992484,
                0
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "OBJECTID": 114,
          "Census_Tract": "24510260302",
          "County": "Baltimore City",
          "QualifiedC": "Yes",
          "GlobalID": "678fedc3-367f-4df1-b97d-6612bf9d5373",
          "Shape__Area": 9653329.633666992,
          "Shape__Length": 14395.206937894785
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [
                -76.5550240004388,
                39.3179559977145,
                0
              ],
              [
                -76.5555789991921,
                39.3175859993611,
                0
              ],
              [
                -76.5556819996272,
                39.3175179989674,
                0
              ],
              [
                -76.5560659990791,
                39.3172639985962,
                0
              ],
              [
                -76.5564070000566,
                39.3170369996526,
                0
              ],
              [
                -76.5564969991951,
                39.3169699988447,
                0
              ],
              [
                -76.556752999433,
                39.3167989987213,
                0
              ],
              [
                -76.5571230002956,
                39.3165609989399,
                0
              ],
              [
                -76.5575069996332,
                39.3163309989613,
                0
              ],
              [
                -76.5578829995859,
                39.3161069990873,
                0
              ],
              [
                -76.5580200000874,
                39.316029998979,
                0
              ],
              [
                -76.5580849999155,
                39.3159929989716,
                0
              ],
              [
                -76.55841700008,
                39.3158069996393,
                0
              ],
              [
                -76.5588589999809,
                39.3155649988967,
                0
              ],
              [
                -76.5592779984341,
                39.3153350001716,
                0
              ],
              [
                -76.5593140002863,
                39.3153149987845,
                0
              ],
              [
                -76.5594609997589,
                39.3152419987102,
                0
              ],
              [
                -76.5599419994393,
                39.3150089990034,
                0
              ],
              [
                -76.5603320004752,
                39.3148310002512,
                0
              ],
              [
                -76.5606940005421,
                39.3146849993743,
                0
              ],
              [
                -76.5610799999236,
                39.3145389987449,
                0
              ],
              [
                -76.5613590003465,
                39.3144239987707,
                0
              ],
              [
                -76.5614890000622,
                39.3143689991633,
                0
              ],
              [
                -76.5617449995553,
                39.31426199943,
                0
              ],
              [
                -76.56208800054,
                39.314120999161,
                0
              ],
              [
                -76.5625649998637,
                39.3139249993689,
                0
              ],
              [
                -76.5628310003576,
                39.3138349993329,
                0
              ],
              [
                -76.5630039985067,
                39.3137779988841,
                0
              ],
              [
                -76.5632789997123,
                39.3137099989425,
                0
              ],
              [
                -76.5635689997001,
                39.3136569994053,
                0
              ],
              [
                -76.5636679998889,
                39.3136420001299,
                0
              ],
              [
                -76.5638110001289,
                39.3136249986777,
                0
              ],
              [
                -76.5639819998466,
                39.3136119994126,
                0
              ],
              [
                -76.5640809998744,
                39.3136069990819,
                0
              ],
              [
                -76.564215999813,
                39.3136009990198,
                0
              ],
              [
                -76.5645109990845,
                39.3135939992945,
                0
              ],
              [
                -76.5649799997506,
                39.31358799887,
                0
              ],
              [
                -76.56543700008,
                39.3135819990381,
                0
              ],
              [
                -76.5658299984639,
                39.3135729992711,
                0
              ],
              [
                -76.5659270005697,
                39.3135709994301,
                0
              ],
              [
                -76.5664070005758,
                39.3135609994536,
                0
              ],
              [
                -76.566871999973,
                39.3135449990429,
                0
              ],
              [
                -76.5670190006214,
                39.3135399992971,
                0
              ],
              [
                -76.5671640001031,
                39.31353799872,
                0
              ],
              [
                -76.5675400000308,
                39.3135329993408,
                0
              ],
              [
                -76.5677130004043,
                39.3135309993407,
                0
              ],
              [
                -76.5681110008118,
                39.3135089998297,
                0
              ],
              [
                -76.5683549997431,
                39.3134939988646,
                0
              ],
              [
                -76.5689939994639,
                39.3134539987769,
                0
              ],
              [
                -76.5696729987201,
                39.3134169988932,
                0
              ],
              [
                -76.5699530001049,
                39.3134099999488,
                0
              ],
              [
                -76.5699859986536,
                39.3134099999999,
                0
              ],
              [
                -76.5701829999505,
                39.3134090002549,
                0
              ],
              [
                -76.5703150004003,
                39.3134249993927,
                0
              ],
              [
                -76.570446999472,
                39.3134509985677,
                0
              ],
              [
                -76.5705399994835,
                39.3134899989078,
                0
              ],
              [
                -76.5706800002271,
                39.3135409987132,
                0
              ],
              [
                -76.5708239998872,
                39.3136079986664,
                0
              ],
              [
                -76.5710949996814,
                39.3137699990369,
                0
              ],
              [
                -76.5713940004729,
                39.3139750002841,
                0
              ],
              [
                -76.5715759998566,
                39.314101999399,
                0
              ],
              [
                -76.5721949999976,
                39.3145089989678,
                0
              ],
              [
                -76.5724899999087,
                39.3145819987125,
                0
              ],
              [
                -76.5727569988449,
                39.3145639988926,
                0
              ],
              [
                -76.5729620001386,
                39.3144419989698,
                0
              ],
              [
                -76.5731369998857,
                39.3144739990568,
                0
              ],
              [
                -76.573124999847,
                39.3150629998928,
                0
              ],
              [
                -76.573104000623,
                39.3153779987668,
                0
              ],
              [
                -76.573087999749,
                39.3156219993353,
                0
              ],
              [
                -76.5730709999965,
                39.3158519994231,
                0
              ],
              [
                -76.5730150001442,
                39.3165199993882,
                0
              ],
              [
                -76.573010000176,
                39.3165759991639,
                0
              ],
              [
                -76.5729689995606,
                39.3170749989251,
                0
              ],
              [
                -76.5729410000399,
                39.3173259987513,
                0
              ],
              [
                -76.5729280013198,
                39.3174059988738,
                0
              ],
              [
                -76.572913000127,
                39.3174849999851,
                0
              ],
              [
                -76.5729019999675,
                39.3175159991105,
                0
              ],
              [
                -76.572874999486,
                39.3176029994439,
                0
              ],
              [
                -76.5728389996245,
                39.3176979990874,
                0
              ],
              [
                -76.5727350000633,
                39.3179579976281,
                0
              ],
              [
                -76.5726780005255,
                39.3181019993707,
                0
              ],
              [
                -76.5725960013004,
                39.3182869998775,
                0
              ],
              [
                -76.5724450001854,
                39.3186409992388,
                0
              ],
              [
                -76.572212999695,
                39.3192379990633,
                0
              ],
              [
                -76.5718349998033,
                39.3201409975952,
                0
              ],
              [
                -76.5717290001641,
                39.3202589983616,
                0
              ],
              [
                -76.5715950002251,
                39.3201379999319,
                0
              ],
              [
                -76.5714540004477,
                39.3200099985796,
                0
              ],
              [
                -76.5712569999982,
                39.3198029993178,
                0
              ],
              [
                -76.5711030001354,
                39.319611999103,
                0
              ],
              [
                -76.5710050001526,
                39.3194689989104,
                0
              ],
              [
                -76.5708620004236,
                39.3192069987283,
                0
              ],
              [
                -76.5707600003412,
                39.3190199989739,
                0
              ],
              [
                -76.5706000005396,
                39.3187189994323,
                0
              ],
              [
                -76.5704390000383,
                39.3184229987725,
                0
              ],
              [
                -76.5703029998562,
                39.3184649991978,
                0
              ],
              [
                -76.5704260009271,
                39.3187069987474,
                0
              ],
              [
                -76.5702710000573,
                39.3187379990281,
                0
              ],
              [
                -76.5699619996506,
                39.3187919994385,
                0
              ],
              [
                -76.5696640003325,
                39.3188329990994,
                0
              ],
              [
                -76.5694729998163,
                39.3188649987538,
                0
              ],
              [
                -76.5688050005508,
                39.3189439987114,
                0
              ],
              [
                -76.568140999689,
                39.3190179986718,
                0
              ],
              [
                -76.5680960005382,
                39.3190229991362,
                0
              ],
              [
                -76.567533999578,
                39.3190850004129,
                0
              ],
              [
                -76.5670169999676,
                39.319150999316,
                0
              ],
              [
                -76.5667239998895,
                39.3191889987254,
                0
              ],
              [
                -76.5665609996808,
                39.3192079990063,
                0
              ],
              [
                -76.5664700014975,
                39.3192209999373,
                0
              ],
              [
                -76.5660500000014,
                39.3192829990109,
                0
              ],
              [
                -76.5659230005108,
                39.3192989994071,
                0
              ],
              [
                -76.5656550002566,
                39.3193329990619,
                0
              ],
              [
                -76.5652009995601,
                39.3193889992316,
                0
              ],
              [
                -76.5649659996684,
                39.3194169987737,
                0
              ],
              [
                -76.5646510000537,
                39.3194579993709,
                0
              ],
              [
                -76.5639230004156,
                39.319547998856,
                0
              ],
              [
                -76.5638150000754,
                39.3195629991756,
                0
              ],
              [
                -76.5633330000294,
                39.3196479987982,
                0
              ],
              [
                -76.5632639997002,
                39.319659998975,
                0
              ],
              [
                -76.5628990012648,
                39.3197339991702,
                0
              ],
              [
                -76.5628270004384,
                39.3197499989908,
                0
              ],
              [
                -76.562232999986,
                39.3198639996803,
                0
              ],
              [
                -76.5616879994234,
                39.3199679988964,
                0
              ],
              [
                -76.5611800004762,
                39.320081998811,
                0
              ],
              [
                -76.5610170004359,
                39.3201180003565,
                0
              ],
              [
                -76.5605400003576,
                39.320223999293,
                0
              ],
              [
                -76.5600080002108,
                39.3203249992911,
                0
              ],
              [
                -76.5601450003716,
                39.3203519996842,
                0
              ],
              [
                -76.560219000316,
                39.3203709987889,
                0
              ],
              [
                -76.5602660002092,
                39.3203859992645,
                0
              ],
              [
                -76.5603649996566,
                39.3204239986438,
                0
              ],
              [
                -76.559759000424,
                39.3209939992484,
                0
              ],
              [
                -76.5595119996883,
                39.3210189992809,
                0
              ],
              [
                -76.5592849996646,
                39.3210719989779,
                0
              ],
              [
                -76.5590020000971,
                39.3211869996159,
                0
              ],
              [
                -76.5587380001495,
                39.3212739989033,
                0
              ],
              [
                -76.5582879987479,
                39.321385999014,
                0
              ],
              [
                -76.5579800000474,
                39.3214219989713,
                0
              ],
              [
                -76.5576859997366,
                39.3214259992687,
                0
              ],
              [
                -76.5575839997423,
                39.3214179985786,
                0
              ],
              [
                -76.5574849999291,
                39.3214019986888,
                0
              ],
              [
                -76.5573720001648,
                39.321370997975,
                0
              ],
              [
                -76.5572559998442,
                39.3213229994252,
                0
              ],
              [
                -76.5569749997495,
                39.3211829991935,
                0
              ],
              [
                -76.5564070004942,
                39.3206949988538,
                0
              ],
              [
                -76.5563590003953,
                39.3206369991474,
                0
              ],
              [
                -76.5559370012104,
                39.3200810000213,
                0
              ],
              [
                -76.5557540001014,
                39.3198039992297,
                0
              ],
              [
                -76.555667999761,
                39.3196629987486,
                0
              ],
              [
                -76.5556100001377,
                39.3195059985804,
                0
              ],
              [
                -76.5555270005602,
                39.3191229999072,
                0
              ],
              [
                -76.5554759994781,
                39.3187949988598,
                0
              ],
              [
                -76.5554370003852,
                39.3185619989573,
                0
              ],
              [
                -76.5553890003724,
                39.318397998847,
                0
              ],
              [
                -76.5553440005406,
                39.318287998622,
                0
              ],
              [
                -76.55523599969,
                39.3181329987404,
                0
              ],
              [
                -76.5551130001387,
                39.3180229986524,
                0
              ],
              [
                -76.5550240004388,
                39.3179559977145,
                0
              ]
            ]
          ]
        }
      }
    ]
  }

  const cleanCoordinates = (data) => {
    data.features.forEach((feature) => {
      if (feature.geometry && feature.geometry.type === "Polygon") {
        feature.geometry.coordinates = feature.geometry.coordinates.map((polygon) => {
          return polygon.map((coords) => {
            return coords.slice(0, 2); // Keep only the first two values (longitude, latitude)
          });
        });
      } else if (feature.geometry && feature.geometry.type === "MultiPolygon") {
        feature.geometry.coordinates = feature.geometry.coordinates.map((multiPolygon) => {
          return multiPolygon.map((polygon) => {
            return polygon.map((coords) => {
              return coords.slice(0, 2); // Keep only the first two values (longitude, latitude)
            });
          });
        });
      }
    });
    return data;
  };

  const data = {
    "type": "FeatureCollection",
    "name": "Bcityonly",
    "crs": {
      "type": "name",
      "properties": {
        "name": "urn:ogc:def:crs:EPSG::4269"
      }
    },
    "features": [
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "151200",
          "AFFGEOID": "1400000US24510151200",
          "GEOID": "24510151200",
          "NAME": "1512",
          "NAMELSAD": "Census Tract 1512",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 779694,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.66589,
                  39.332968
                ],
                [
                  -76.665061,
                  39.333385
                ],
                [
                  -76.662664,
                  39.33451
                ],
                [
                  -76.659844,
                  39.335652
                ],
                [
                  -76.656856,
                  39.336385
                ],
                [
                  -76.656796,
                  39.336399
                ],
                [
                  -76.656359,
                  39.336504
                ],
                [
                  -76.655937,
                  39.334611
                ],
                [
                  -76.655964,
                  39.333549
                ],
                [
                  -76.655735,
                  39.333053
                ],
                [
                  -76.654092,
                  39.330397
                ],
                [
                  -76.654032,
                  39.330291
                ],
                [
                  -76.655061,
                  39.329543
                ],
                [
                  -76.657528,
                  39.325453
                ],
                [
                  -76.657842,
                  39.325713
                ],
                [
                  -76.659355,
                  39.32771
                ],
                [
                  -76.660985,
                  39.326947
                ],
                [
                  -76.664302,
                  39.327512
                ],
                [
                  -76.66545,
                  39.331547
                ],
                [
                  -76.66589,
                  39.332968
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "271200",
          "AFFGEOID": "1400000US24510271200",
          "GEOID": "24510271200",
          "NAME": "2712",
          "NAMELSAD": "Census Tract 2712",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 3599462,
          "AWATER": 933
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.633944,
                  39.372009
                ],
                [
                  -76.631691,
                  39.371705
                ],
                [
                  -76.626193,
                  39.372017
                ],
                [
                  -76.619643,
                  39.371951
                ],
                [
                  -76.618344,
                  39.372034
                ],
                [
                  -76.613875,
                  39.371762
                ],
                [
                  -76.609805,
                  39.3722
                ],
                [
                  -76.609919,
                  39.36784
                ],
                [
                  -76.609926,
                  39.36697
                ],
                [
                  -76.609985,
                  39.365126
                ],
                [
                  -76.609998,
                  39.364123
                ],
                [
                  -76.610005,
                  39.358549
                ],
                [
                  -76.610001,
                  39.358417
                ],
                [
                  -76.60997,
                  39.356525
                ],
                [
                  -76.609953,
                  39.355503
                ],
                [
                  -76.609928,
                  39.354331
                ],
                [
                  -76.616098,
                  39.353789
                ],
                [
                  -76.623522,
                  39.353226
                ],
                [
                  -76.623669,
                  39.353872
                ],
                [
                  -76.629227,
                  39.353429
                ],
                [
                  -76.630267,
                  39.35861
                ],
                [
                  -76.629483,
                  39.361881
                ],
                [
                  -76.627969,
                  39.36588
                ],
                [
                  -76.631666,
                  39.365489
                ],
                [
                  -76.63159,
                  39.368707
                ],
                [
                  -76.634218,
                  39.369374
                ],
                [
                  -76.633944,
                  39.372009
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "140100",
          "AFFGEOID": "1400000US24510140100",
          "GEOID": "24510140100",
          "NAME": "1401",
          "NAMELSAD": "Census Tract 1401",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 566966,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.633658,
                  39.310341
                ],
                [
                  -76.632189,
                  39.310386
                ],
                [
                  -76.629938,
                  39.310496
                ],
                [
                  -76.628003,
                  39.310574
                ],
                [
                  -76.623277,
                  39.310848
                ],
                [
                  -76.62304,
                  39.310709
                ],
                [
                  -76.621549,
                  39.30985
                ],
                [
                  -76.620355,
                  39.309123
                ],
                [
                  -76.621005,
                  39.307234
                ],
                [
                  -76.620906,
                  39.306183
                ],
                [
                  -76.62076,
                  39.304815
                ],
                [
                  -76.620723,
                  39.304351
                ],
                [
                  -76.624132,
                  39.303841
                ],
                [
                  -76.62457,
                  39.303584
                ],
                [
                  -76.625118,
                  39.303182
                ],
                [
                  -76.626905,
                  39.304784
                ],
                [
                  -76.628783,
                  39.306355
                ],
                [
                  -76.630761,
                  39.307947
                ],
                [
                  -76.632658,
                  39.309499
                ],
                [
                  -76.633658,
                  39.310341
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "090600",
          "AFFGEOID": "1400000US24510090600",
          "GEOID": "24510090600",
          "NAME": "906",
          "NAMELSAD": "Census Tract 906",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 397270,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.595145,
                  39.328347
                ],
                [
                  -76.589311,
                  39.328364
                ],
                [
                  -76.589334,
                  39.327297
                ],
                [
                  -76.585153,
                  39.327308
                ],
                [
                  -76.584576,
                  39.327047
                ],
                [
                  -76.58747,
                  39.323564
                ],
                [
                  -76.588534,
                  39.32283
                ],
                [
                  -76.589978,
                  39.321861
                ],
                [
                  -76.590658,
                  39.321239
                ],
                [
                  -76.592814,
                  39.323209
                ],
                [
                  -76.593584,
                  39.325271
                ],
                [
                  -76.59381,
                  39.325967
                ],
                [
                  -76.593929,
                  39.326225
                ],
                [
                  -76.595145,
                  39.328347
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "160801",
          "AFFGEOID": "1400000US24510160801",
          "GEOID": "24510160801",
          "NAME": "1608.01",
          "NAMELSAD": "Census Tract 1608.01",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 389703,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.687483,
                  39.302416
                ],
                [
                  -76.685791,
                  39.303005
                ],
                [
                  -76.681244,
                  39.30045
                ],
                [
                  -76.681507,
                  39.29939
                ],
                [
                  -76.681429,
                  39.297906
                ],
                [
                  -76.681341,
                  39.296407
                ],
                [
                  -76.681303,
                  39.295669
                ],
                [
                  -76.681211,
                  39.293884
                ],
                [
                  -76.685995,
                  39.293711
                ],
                [
                  -76.686101,
                  39.29625
                ],
                [
                  -76.686193,
                  39.297742
                ],
                [
                  -76.686275,
                  39.299217
                ],
                [
                  -76.686292,
                  39.300184
                ],
                [
                  -76.687501,
                  39.301894
                ],
                [
                  -76.687483,
                  39.302416
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "010300",
          "AFFGEOID": "1400000US24510010300",
          "GEOID": "24510010300",
          "NAME": "103",
          "NAMELSAD": "Census Tract 103",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 673883,
          "AWATER": 10498
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.584722,
                  39.291891
                ],
                [
                  -76.583325,
                  39.291956
                ],
                [
                  -76.581886,
                  39.292012
                ],
                [
                  -76.579727,
                  39.292099
                ],
                [
                  -76.577623,
                  39.292178
                ],
                [
                  -76.576174,
                  39.292232
                ],
                [
                  -76.575814,
                  39.2863
                ],
                [
                  -76.577242,
                  39.286242
                ],
                [
                  -76.57709,
                  39.284207
                ],
                [
                  -76.577043,
                  39.28321
                ],
                [
                  -76.579853,
                  39.283085
                ],
                [
                  -76.582736,
                  39.283099
                ],
                [
                  -76.583895,
                  39.283844
                ],
                [
                  -76.584019,
                  39.283916
                ],
                [
                  -76.584222,
                  39.28403
                ],
                [
                  -76.584262,
                  39.284949
                ],
                [
                  -76.584332,
                  39.285956
                ],
                [
                  -76.584572,
                  39.289599
                ],
                [
                  -76.584722,
                  39.291891
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "060300",
          "AFFGEOID": "1400000US24510060300",
          "GEOID": "24510060300",
          "NAME": "603",
          "NAMELSAD": "Census Tract 603",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 187111,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.58773,
                  39.296519
                ],
                [
                  -76.585752,
                  39.296601
                ],
                [
                  -76.584271,
                  39.29635
                ],
                [
                  -76.583568,
                  39.296393
                ],
                [
                  -76.583456,
                  39.294361
                ],
                [
                  -76.583325,
                  39.291956
                ],
                [
                  -76.584722,
                  39.291891
                ],
                [
                  -76.587414,
                  39.291813
                ],
                [
                  -76.587584,
                  39.294208
                ],
                [
                  -76.587706,
                  39.296205
                ],
                [
                  -76.58773,
                  39.296519
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "260203",
          "AFFGEOID": "1400000US24510260203",
          "GEOID": "24510260203",
          "NAME": "2602.03",
          "NAMELSAD": "Census Tract 2602.03",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 853290,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.553856,
                  39.31867
                ],
                [
                  -76.550291,
                  39.321085
                ],
                [
                  -76.548442,
                  39.32183
                ],
                [
                  -76.545266,
                  39.32225
                ],
                [
                  -76.542892,
                  39.322952
                ],
                [
                  -76.540754,
                  39.323623
                ],
                [
                  -76.541721,
                  39.329213
                ],
                [
                  -76.538042,
                  39.329735
                ],
                [
                  -76.535007,
                  39.330198
                ],
                [
                  -76.534533,
                  39.33028
                ],
                [
                  -76.532977,
                  39.330558
                ],
                [
                  -76.534112,
                  39.328893
                ],
                [
                  -76.534104,
                  39.328295
                ],
                [
                  -76.536023,
                  39.326705
                ],
                [
                  -76.540459,
                  39.321218
                ],
                [
                  -76.545847,
                  39.31762
                ],
                [
                  -76.548136,
                  39.316256
                ],
                [
                  -76.548938,
                  39.315888
                ],
                [
                  -76.549152,
                  39.316351
                ],
                [
                  -76.552311,
                  39.316808
                ],
                [
                  -76.555024,
                  39.317956
                ],
                [
                  -76.553856,
                  39.31867
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "270701",
          "AFFGEOID": "1400000US24510270701",
          "GEOID": "24510270701",
          "NAME": "2707.01",
          "NAMELSAD": "Census Tract 2707.01",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 399831,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.5701,
                  39.372039
                ],
                [
                  -76.569997,
                  39.372121
                ],
                [
                  -76.567243,
                  39.372104
                ],
                [
                  -76.561788,
                  39.372205
                ],
                [
                  -76.561919,
                  39.367889
                ],
                [
                  -76.562545,
                  39.366828
                ],
                [
                  -76.562615,
                  39.366716
                ],
                [
                  -76.567071,
                  39.368301
                ],
                [
                  -76.567643,
                  39.368509
                ],
                [
                  -76.573563,
                  39.368539
                ],
                [
                  -76.5701,
                  39.372039
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "090500",
          "AFFGEOID": "1400000US24510090500",
          "GEOID": "24510090500",
          "NAME": "905",
          "NAMELSAD": "Census Tract 905",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 741595,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.609428,
                  39.328314
                ],
                [
                  -76.608472,
                  39.328332
                ],
                [
                  -76.603629,
                  39.328332
                ],
                [
                  -76.597897,
                  39.328329
                ],
                [
                  -76.595145,
                  39.328347
                ],
                [
                  -76.593929,
                  39.326225
                ],
                [
                  -76.596764,
                  39.323456
                ],
                [
                  -76.597881,
                  39.32236
                ],
                [
                  -76.600574,
                  39.319701
                ],
                [
                  -76.601489,
                  39.31879
                ],
                [
                  -76.603351,
                  39.319181
                ],
                [
                  -76.605812,
                  39.319457
                ],
                [
                  -76.603584,
                  39.321572
                ],
                [
                  -76.602731,
                  39.322401
                ],
                [
                  -76.601468,
                  39.323707
                ],
                [
                  -76.603324,
                  39.32443
                ],
                [
                  -76.605107,
                  39.325133
                ],
                [
                  -76.608864,
                  39.32647
                ],
                [
                  -76.609426,
                  39.3254
                ],
                [
                  -76.609428,
                  39.328314
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "190300",
          "AFFGEOID": "1400000US24510190300",
          "GEOID": "24510190300",
          "NAME": "1903",
          "NAMELSAD": "Census Tract 1903",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 352929,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.646959,
                  39.288148
                ],
                [
                  -76.645222,
                  39.288228
                ],
                [
                  -76.642413,
                  39.288373
                ],
                [
                  -76.642197,
                  39.285389
                ],
                [
                  -76.642168,
                  39.284421
                ],
                [
                  -76.641988,
                  39.281604
                ],
                [
                  -76.641861,
                  39.280991
                ],
                [
                  -76.646426,
                  39.279489
                ],
                [
                  -76.646719,
                  39.284242
                ],
                [
                  -76.646775,
                  39.285175
                ],
                [
                  -76.646959,
                  39.288148
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "130100",
          "AFFGEOID": "1400000US24510130100",
          "GEOID": "24510130100",
          "NAME": "1301",
          "NAMELSAD": "Census Tract 1301",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 311272,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.639406,
                  39.315838
                ],
                [
                  -76.636903,
                  39.316914
                ],
                [
                  -76.63618,
                  39.316962
                ],
                [
                  -76.633956,
                  39.317011
                ],
                [
                  -76.631476,
                  39.316807
                ],
                [
                  -76.62943,
                  39.317081
                ],
                [
                  -76.628466,
                  39.3154
                ],
                [
                  -76.627862,
                  39.314749
                ],
                [
                  -76.62961,
                  39.313745
                ],
                [
                  -76.631388,
                  39.313644
                ],
                [
                  -76.631412,
                  39.314419
                ],
                [
                  -76.633913,
                  39.314402
                ],
                [
                  -76.635049,
                  39.314196
                ],
                [
                  -76.635601,
                  39.313873
                ],
                [
                  -76.636683,
                  39.313246
                ],
                [
                  -76.637783,
                  39.312615
                ],
                [
                  -76.640303,
                  39.315139
                ],
                [
                  -76.639406,
                  39.315838
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "120400",
          "AFFGEOID": "1400000US24510120400",
          "GEOID": "24510120400",
          "NAME": "1204",
          "NAMELSAD": "Census Tract 1204",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 281025,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.615302,
                  39.316413
                ],
                [
                  -76.611292,
                  39.316558
                ],
                [
                  -76.60949,
                  39.316234
                ],
                [
                  -76.609528,
                  39.315066
                ],
                [
                  -76.609532,
                  39.314508
                ],
                [
                  -76.609505,
                  39.311833
                ],
                [
                  -76.609497,
                  39.311405
                ],
                [
                  -76.609737,
                  39.311313
                ],
                [
                  -76.612464,
                  39.311194
                ],
                [
                  -76.614955,
                  39.311065
                ],
                [
                  -76.614964,
                  39.311197
                ],
                [
                  -76.615064,
                  39.312305
                ],
                [
                  -76.615132,
                  39.313279
                ],
                [
                  -76.615176,
                  39.314292
                ],
                [
                  -76.615273,
                  39.315363
                ],
                [
                  -76.615302,
                  39.316413
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "080800",
          "AFFGEOID": "1400000US24510080800",
          "GEOID": "24510080800",
          "NAME": "808",
          "NAMELSAD": "Census Tract 808",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 327456,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.598069,
                  39.305222
                ],
                [
                  -76.592521,
                  39.305452
                ],
                [
                  -76.588286,
                  39.30564
                ],
                [
                  -76.58825,
                  39.305106
                ],
                [
                  -76.588147,
                  39.303489
                ],
                [
                  -76.588135,
                  39.303218
                ],
                [
                  -76.588079,
                  39.302138
                ],
                [
                  -76.591138,
                  39.302027
                ],
                [
                  -76.592464,
                  39.301967
                ],
                [
                  -76.594658,
                  39.301881
                ],
                [
                  -76.597829,
                  39.301744
                ],
                [
                  -76.59792,
                  39.303106
                ],
                [
                  -76.598069,
                  39.305222
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "280600",
          "AFFGEOID": "1400000US24510280600",
          "GEOID": "24510280600",
          "NAME": "2806",
          "NAMELSAD": "Census Tract 2806",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 576317,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.638462,
                  39.294189
                ],
                [
                  -76.635623,
                  39.294302
                ],
                [
                  -76.634132,
                  39.294354
                ],
                [
                  -76.631922,
                  39.294458
                ],
                [
                  -76.627688,
                  39.29463
                ],
                [
                  -76.627719,
                  39.293573
                ],
                [
                  -76.627479,
                  39.291241
                ],
                [
                  -76.627503,
                  39.290128
                ],
                [
                  -76.627766,
                  39.288974
                ],
                [
                  -76.628909,
                  39.288992
                ],
                [
                  -76.632149,
                  39.288838
                ],
                [
                  -76.63381,
                  39.288766
                ],
                [
                  -76.638166,
                  39.288566
                ],
                [
                  -76.63823,
                  39.289777
                ],
                [
                  -76.638365,
                  39.292295
                ],
                [
                  -76.638462,
                  39.294189
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "270502",
          "AFFGEOID": "1400000US24510270502",
          "GEOID": "24510270502",
          "NAME": "2705.02",
          "NAMELSAD": "Census Tract 2705.02",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1539775,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.554173,
                  39.360778
                ],
                [
                  -76.553385,
                  39.361697
                ],
                [
                  -76.551894,
                  39.363406
                ],
                [
                  -76.54775,
                  39.361901
                ],
                [
                  -76.544112,
                  39.360572
                ],
                [
                  -76.539224,
                  39.358825
                ],
                [
                  -76.537491,
                  39.358266
                ],
                [
                  -76.536979,
                  39.358255
                ],
                [
                  -76.535294,
                  39.358001
                ],
                [
                  -76.529785,
                  39.356552
                ],
                [
                  -76.529773,
                  39.355575
                ],
                [
                  -76.534763,
                  39.351196
                ],
                [
                  -76.535667,
                  39.351832
                ],
                [
                  -76.537116,
                  39.352742
                ],
                [
                  -76.5403,
                  39.353628
                ],
                [
                  -76.540381,
                  39.353638
                ],
                [
                  -76.542666,
                  39.353531
                ],
                [
                  -76.543894,
                  39.353469
                ],
                [
                  -76.545862,
                  39.353607
                ],
                [
                  -76.547015,
                  39.353734
                ],
                [
                  -76.548048,
                  39.354
                ],
                [
                  -76.551914,
                  39.355052
                ],
                [
                  -76.557731,
                  39.356658
                ],
                [
                  -76.554173,
                  39.360778
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "150900",
          "AFFGEOID": "1400000US24510150900",
          "GEOID": "24510150900",
          "NAME": "1509",
          "NAMELSAD": "Census Tract 1509",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1464150,
          "AWATER": 1171
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.690004,
                  39.312386
                ],
                [
                  -76.689421,
                  39.312335
                ],
                [
                  -76.686069,
                  39.312516
                ],
                [
                  -76.685457,
                  39.312767
                ],
                [
                  -76.685822,
                  39.314413
                ],
                [
                  -76.686725,
                  39.315368
                ],
                [
                  -76.687295,
                  39.315497
                ],
                [
                  -76.688122,
                  39.31795
                ],
                [
                  -76.688862,
                  39.31903
                ],
                [
                  -76.687508,
                  39.321083
                ],
                [
                  -76.690145,
                  39.320985
                ],
                [
                  -76.689193,
                  39.32202
                ],
                [
                  -76.689789,
                  39.323065
                ],
                [
                  -76.690069,
                  39.323586
                ],
                [
                  -76.684189,
                  39.325351
                ],
                [
                  -76.682564,
                  39.325842
                ],
                [
                  -76.682092,
                  39.325027
                ],
                [
                  -76.681084,
                  39.323358
                ],
                [
                  -76.682747,
                  39.322852
                ],
                [
                  -76.681914,
                  39.321316
                ],
                [
                  -76.681841,
                  39.32009
                ],
                [
                  -76.68164,
                  39.318101
                ],
                [
                  -76.681301,
                  39.315002
                ],
                [
                  -76.681133,
                  39.314092
                ],
                [
                  -76.681102,
                  39.313922
                ],
                [
                  -76.680965,
                  39.313028
                ],
                [
                  -76.680565,
                  39.310762
                ],
                [
                  -76.679261,
                  39.306865
                ],
                [
                  -76.676717,
                  39.306749
                ],
                [
                  -76.674123,
                  39.306268
                ],
                [
                  -76.674142,
                  39.305682
                ],
                [
                  -76.673682,
                  39.304243
                ],
                [
                  -76.673976,
                  39.302639
                ],
                [
                  -76.67421,
                  39.302373
                ],
                [
                  -76.678672,
                  39.304768
                ],
                [
                  -76.679427,
                  39.305515
                ],
                [
                  -76.681565,
                  39.306584
                ],
                [
                  -76.686302,
                  39.305506
                ],
                [
                  -76.686431,
                  39.305348
                ],
                [
                  -76.687203,
                  39.305491
                ],
                [
                  -76.689039,
                  39.307783
                ],
                [
                  -76.69036,
                  39.309557
                ],
                [
                  -76.690004,
                  39.312386
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "250303",
          "AFFGEOID": "1400000US24510250303",
          "GEOID": "24510250303",
          "NAME": "2503.03",
          "NAMELSAD": "Census Tract 2503.03",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1004607,
          "AWATER": 30795
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.654996,
                  39.271192
                ],
                [
                  -76.653264,
                  39.271539
                ],
                [
                  -76.648408,
                  39.271251
                ],
                [
                  -76.648078,
                  39.271221
                ],
                [
                  -76.64737,
                  39.271164
                ],
                [
                  -76.639054,
                  39.270421
                ],
                [
                  -76.63733,
                  39.27014
                ],
                [
                  -76.63868,
                  39.269072
                ],
                [
                  -76.638874,
                  39.268938
                ],
                [
                  -76.649834,
                  39.260314
                ],
                [
                  -76.651677,
                  39.26097
                ],
                [
                  -76.651693,
                  39.263463
                ],
                [
                  -76.652073,
                  39.264642
                ],
                [
                  -76.653422,
                  39.265822
                ],
                [
                  -76.654239,
                  39.266995
                ],
                [
                  -76.654996,
                  39.271192
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "130803",
          "AFFGEOID": "1400000US24510130803",
          "GEOID": "24510130803",
          "NAME": "1308.03",
          "NAMELSAD": "Census Tract 1308.03",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 693566,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.647767,
                  39.339615
                ],
                [
                  -76.647222,
                  39.345243
                ],
                [
                  -76.644364,
                  39.3454
                ],
                [
                  -76.642314,
                  39.344748
                ],
                [
                  -76.640283,
                  39.343372
                ],
                [
                  -76.640218,
                  39.343174
                ],
                [
                  -76.639511,
                  39.341087
                ],
                [
                  -76.638982,
                  39.340027
                ],
                [
                  -76.637361,
                  39.337635
                ],
                [
                  -76.639186,
                  39.336919
                ],
                [
                  -76.640385,
                  39.336448
                ],
                [
                  -76.644627,
                  39.334753
                ],
                [
                  -76.647326,
                  39.33837
                ],
                [
                  -76.647767,
                  39.339615
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "120201",
          "AFFGEOID": "1400000US24510120201",
          "GEOID": "24510120201",
          "NAME": "1202.01",
          "NAMELSAD": "Census Tract 1202.01",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 348020,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.614979,
                  39.332664
                ],
                [
                  -76.609476,
                  39.330965
                ],
                [
                  -76.60943,
                  39.328495
                ],
                [
                  -76.609428,
                  39.328314
                ],
                [
                  -76.609426,
                  39.3254
                ],
                [
                  -76.609425,
                  39.324785
                ],
                [
                  -76.609456,
                  39.323443
                ],
                [
                  -76.611136,
                  39.323466
                ],
                [
                  -76.613226,
                  39.323381
                ],
                [
                  -76.61331,
                  39.324643
                ],
                [
                  -76.613333,
                  39.325914
                ],
                [
                  -76.613546,
                  39.3284
                ],
                [
                  -76.613646,
                  39.329922
                ],
                [
                  -76.616221,
                  39.331527
                ],
                [
                  -76.614979,
                  39.332664
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "170300",
          "AFFGEOID": "1400000US24510170300",
          "GEOID": "24510170300",
          "NAME": "1703",
          "NAMELSAD": "Census Tract 1703",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 305829,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.634475,
                  39.299142
                ],
                [
                  -76.631732,
                  39.301181
                ],
                [
                  -76.629665,
                  39.299518
                ],
                [
                  -76.628616,
                  39.298666
                ],
                [
                  -76.626159,
                  39.296653
                ],
                [
                  -76.627291,
                  39.295635
                ],
                [
                  -76.627688,
                  39.29463
                ],
                [
                  -76.631922,
                  39.294458
                ],
                [
                  -76.632592,
                  39.295689
                ],
                [
                  -76.633261,
                  39.296886
                ],
                [
                  -76.634475,
                  39.299142
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "120300",
          "AFFGEOID": "1400000US24510120300",
          "GEOID": "24510120300",
          "NAME": "1203",
          "NAMELSAD": "Census Tract 1203",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 403945,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.615743,
                  39.323287
                ],
                [
                  -76.614622,
                  39.323331
                ],
                [
                  -76.613226,
                  39.323381
                ],
                [
                  -76.611136,
                  39.323466
                ],
                [
                  -76.609456,
                  39.323443
                ],
                [
                  -76.609484,
                  39.322149
                ],
                [
                  -76.609532,
                  39.320922
                ],
                [
                  -76.609509,
                  39.319519
                ],
                [
                  -76.609464,
                  39.318111
                ],
                [
                  -76.60949,
                  39.316234
                ],
                [
                  -76.611292,
                  39.316558
                ],
                [
                  -76.615302,
                  39.316413
                ],
                [
                  -76.615406,
                  39.317929
                ],
                [
                  -76.615526,
                  39.31942
                ],
                [
                  -76.615589,
                  39.320712
                ],
                [
                  -76.615665,
                  39.322003
                ],
                [
                  -76.615743,
                  39.323287
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "270804",
          "AFFGEOID": "1400000US24510270804",
          "GEOID": "24510270804",
          "NAME": "2708.04",
          "NAMELSAD": "Census Tract 2708.04",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 721489,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.609926,
                  39.36697
                ],
                [
                  -76.609919,
                  39.36784
                ],
                [
                  -76.609805,
                  39.3722
                ],
                [
                  -76.605891,
                  39.372037
                ],
                [
                  -76.597879,
                  39.371808
                ],
                [
                  -76.597045,
                  39.371868
                ],
                [
                  -76.599799,
                  39.369331
                ],
                [
                  -76.599805,
                  39.36701
                ],
                [
                  -76.599283,
                  39.365912
                ],
                [
                  -76.60296,
                  39.36502
                ],
                [
                  -76.605527,
                  39.36458
                ],
                [
                  -76.607244,
                  39.364853
                ],
                [
                  -76.608656,
                  39.365059
                ],
                [
                  -76.609985,
                  39.365126
                ],
                [
                  -76.609926,
                  39.36697
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "260101",
          "AFFGEOID": "1400000US24510260101",
          "GEOID": "24510260101",
          "NAME": "2601.01",
          "NAMELSAD": "Census Tract 2601.01",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1635742,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.544753,
                  39.342946
                ],
                [
                  -76.544006,
                  39.34347
                ],
                [
                  -76.543673,
                  39.343707
                ],
                [
                  -76.541004,
                  39.345612
                ],
                [
                  -76.538996,
                  39.34741
                ],
                [
                  -76.536321,
                  39.349793
                ],
                [
                  -76.534763,
                  39.351196
                ],
                [
                  -76.529773,
                  39.355575
                ],
                [
                  -76.529774,
                  39.353707
                ],
                [
                  -76.529453,
                  39.350723
                ],
                [
                  -76.529594,
                  39.349741
                ],
                [
                  -76.529706,
                  39.348811
                ],
                [
                  -76.529782,
                  39.345364
                ],
                [
                  -76.529783,
                  39.342151
                ],
                [
                  -76.529693,
                  39.336142
                ],
                [
                  -76.530318,
                  39.335969
                ],
                [
                  -76.533694,
                  39.337208
                ],
                [
                  -76.535872,
                  39.336957
                ],
                [
                  -76.537755,
                  39.336732
                ],
                [
                  -76.53896,
                  39.336832
                ],
                [
                  -76.539931,
                  39.337283
                ],
                [
                  -76.540625,
                  39.337798
                ],
                [
                  -76.541467,
                  39.339465
                ],
                [
                  -76.545574,
                  39.342364
                ],
                [
                  -76.544753,
                  39.342946
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "261100",
          "AFFGEOID": "1400000US24510261100",
          "GEOID": "24510261100",
          "NAME": "2611",
          "NAMELSAD": "Census Tract 2611",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 219783,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.571607,
                  39.287477
                ],
                [
                  -76.569091,
                  39.287565
                ],
                [
                  -76.569022,
                  39.286561
                ],
                [
                  -76.568845,
                  39.283509
                ],
                [
                  -76.56878,
                  39.282488
                ],
                [
                  -76.568652,
                  39.280452
                ],
                [
                  -76.568512,
                  39.278417
                ],
                [
                  -76.571008,
                  39.278337
                ],
                [
                  -76.571151,
                  39.280366
                ],
                [
                  -76.571261,
                  39.282382
                ],
                [
                  -76.571339,
                  39.283407
                ],
                [
                  -76.571396,
                  39.284423
                ],
                [
                  -76.571533,
                  39.286455
                ],
                [
                  -76.571607,
                  39.287477
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "250101",
          "AFFGEOID": "1400000US24510250101",
          "GEOID": "24510250101",
          "NAME": "2501.01",
          "NAMELSAD": "Census Tract 2501.01",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 962784,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.709839,
                  39.278359
                ],
                [
                  -76.708944,
                  39.278713
                ],
                [
                  -76.706764,
                  39.279696
                ],
                [
                  -76.705495,
                  39.280813
                ],
                [
                  -76.70264,
                  39.280857
                ],
                [
                  -76.699012,
                  39.281274
                ],
                [
                  -76.698046,
                  39.281334
                ],
                [
                  -76.695717,
                  39.281391
                ],
                [
                  -76.693682,
                  39.281443
                ],
                [
                  -76.694546,
                  39.280063
                ],
                [
                  -76.694633,
                  39.279374
                ],
                [
                  -76.695724,
                  39.27794
                ],
                [
                  -76.695152,
                  39.276352
                ],
                [
                  -76.694154,
                  39.275294
                ],
                [
                  -76.692922,
                  39.272496
                ],
                [
                  -76.69268,
                  39.271824
                ],
                [
                  -76.695371,
                  39.27191
                ],
                [
                  -76.698892,
                  39.272705
                ],
                [
                  -76.709098,
                  39.277018
                ],
                [
                  -76.711054,
                  39.277889
                ],
                [
                  -76.709839,
                  39.278359
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "260800",
          "AFFGEOID": "1400000US24510260800",
          "GEOID": "24510260800",
          "NAME": "2608",
          "NAMELSAD": "Census Tract 2608",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 311708,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.569413,
                  39.292487
                ],
                [
                  -76.56755,
                  39.292568
                ],
                [
                  -76.562827,
                  39.292754
                ],
                [
                  -76.562744,
                  39.291595
                ],
                [
                  -76.562578,
                  39.288816
                ],
                [
                  -76.562513,
                  39.287825
                ],
                [
                  -76.567236,
                  39.287641
                ],
                [
                  -76.569091,
                  39.287565
                ],
                [
                  -76.569306,
                  39.290867
                ],
                [
                  -76.569334,
                  39.291336
                ],
                [
                  -76.569413,
                  39.292487
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "260302",
          "AFFGEOID": "1400000US24510260302",
          "GEOID": "24510260302",
          "NAME": "2603.02",
          "NAMELSAD": "Census Tract 2603.02",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 896864,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.572969,
                  39.317075
                ],
                [
                  -76.571729,
                  39.320259
                ],
                [
                  -76.571103,
                  39.319612
                ],
                [
                  -76.570439,
                  39.318423
                ],
                [
                  -76.569962,
                  39.318792
                ],
                [
                  -76.567534,
                  39.319085
                ],
                [
                  -76.56647,
                  39.319221
                ],
                [
                  -76.565923,
                  39.319299
                ],
                [
                  -76.564966,
                  39.319417
                ],
                [
                  -76.563815,
                  39.319563
                ],
                [
                  -76.562827,
                  39.31975
                ],
                [
                  -76.56054,
                  39.320224
                ],
                [
                  -76.559759,
                  39.320994
                ],
                [
                  -76.557686,
                  39.321426
                ],
                [
                  -76.556407,
                  39.320695
                ],
                [
                  -76.555024,
                  39.317956
                ],
                [
                  -76.557123,
                  39.316561
                ],
                [
                  -76.559314,
                  39.315315
                ],
                [
                  -76.56108,
                  39.314539
                ],
                [
                  -76.563668,
                  39.313642
                ],
                [
                  -76.566407,
                  39.313561
                ],
                [
                  -76.567713,
                  39.313531
                ],
                [
                  -76.570447,
                  39.313451
                ],
                [
                  -76.573137,
                  39.314474
                ],
                [
                  -76.572969,
                  39.317075
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "080500",
          "AFFGEOID": "1400000US24510080500",
          "GEOID": "24510080500",
          "NAME": "805",
          "NAMELSAD": "Census Tract 805",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 348376,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.599057,
                  39.312961
                ],
                [
                  -76.597941,
                  39.314262
                ],
                [
                  -76.596927,
                  39.315241
                ],
                [
                  -76.596435,
                  39.315713
                ],
                [
                  -76.595463,
                  39.316672
                ],
                [
                  -76.594867,
                  39.317238
                ],
                [
                  -76.589881,
                  39.316123
                ],
                [
                  -76.590619,
                  39.315073
                ],
                [
                  -76.59057,
                  39.314304
                ],
                [
                  -76.588812,
                  39.314343
                ],
                [
                  -76.588692,
                  39.312419
                ],
                [
                  -76.591098,
                  39.312313
                ],
                [
                  -76.593096,
                  39.312217
                ],
                [
                  -76.595233,
                  39.312158
                ],
                [
                  -76.598477,
                  39.311992
                ],
                [
                  -76.59937,
                  39.311942
                ],
                [
                  -76.599057,
                  39.312961
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "270302",
          "AFFGEOID": "1400000US24510270302",
          "GEOID": "24510270302",
          "NAME": "2703.02",
          "NAMELSAD": "Census Tract 2703.02",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 519259,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.568321,
                  39.34376
                ],
                [
                  -76.567246,
                  39.345389
                ],
                [
                  -76.56618,
                  39.346778
                ],
                [
                  -76.565937,
                  39.347063
                ],
                [
                  -76.565274,
                  39.347859
                ],
                [
                  -76.564377,
                  39.348936
                ],
                [
                  -76.563355,
                  39.350138
                ],
                [
                  -76.560885,
                  39.348354
                ],
                [
                  -76.560257,
                  39.347685
                ],
                [
                  -76.558147,
                  39.345185
                ],
                [
                  -76.55939,
                  39.344439
                ],
                [
                  -76.560887,
                  39.343606
                ],
                [
                  -76.561687,
                  39.343016
                ],
                [
                  -76.562998,
                  39.342016
                ],
                [
                  -76.563815,
                  39.341549
                ],
                [
                  -76.567424,
                  39.339556
                ],
                [
                  -76.567956,
                  39.342076
                ],
                [
                  -76.569136,
                  39.342826
                ],
                [
                  -76.568321,
                  39.34376
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "130200",
          "AFFGEOID": "1400000US24510130200",
          "GEOID": "24510130200",
          "NAME": "1302",
          "NAMELSAD": "Census Tract 1302",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 352623,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.635601,
                  39.313873
                ],
                [
                  -76.635049,
                  39.314196
                ],
                [
                  -76.633913,
                  39.314402
                ],
                [
                  -76.631412,
                  39.314419
                ],
                [
                  -76.631388,
                  39.313644
                ],
                [
                  -76.62961,
                  39.313745
                ],
                [
                  -76.627862,
                  39.314749
                ],
                [
                  -76.625574,
                  39.312345
                ],
                [
                  -76.623277,
                  39.310848
                ],
                [
                  -76.628003,
                  39.310574
                ],
                [
                  -76.629938,
                  39.310496
                ],
                [
                  -76.632189,
                  39.310386
                ],
                [
                  -76.633658,
                  39.310341
                ],
                [
                  -76.633896,
                  39.310335
                ],
                [
                  -76.635319,
                  39.3118
                ],
                [
                  -76.636683,
                  39.313246
                ],
                [
                  -76.635601,
                  39.313873
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "170100",
          "AFFGEOID": "1400000US24510170100",
          "GEOID": "24510170100",
          "NAME": "1701",
          "NAMELSAD": "Census Tract 1701",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 282140,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.627291,
                  39.295635
                ],
                [
                  -76.626159,
                  39.296653
                ],
                [
                  -76.624049,
                  39.298357
                ],
                [
                  -76.622721,
                  39.299687
                ],
                [
                  -76.621822,
                  39.300465
                ],
                [
                  -76.620269,
                  39.301757
                ],
                [
                  -76.620174,
                  39.301142
                ],
                [
                  -76.620036,
                  39.29843
                ],
                [
                  -76.619983,
                  39.297359
                ],
                [
                  -76.619819,
                  39.294931
                ],
                [
                  -76.621285,
                  39.294861
                ],
                [
                  -76.622638,
                  39.294812
                ],
                [
                  -76.627688,
                  39.29463
                ],
                [
                  -76.627291,
                  39.295635
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "100200",
          "AFFGEOID": "1400000US24510100200",
          "GEOID": "24510100200",
          "NAME": "1002",
          "NAMELSAD": "Census Tract 1002",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 304692,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.606389,
                  39.301414
                ],
                [
                  -76.604906,
                  39.301491
                ],
                [
                  -76.600316,
                  39.301659
                ],
                [
                  -76.59937,
                  39.301682
                ],
                [
                  -76.597829,
                  39.301744
                ],
                [
                  -76.597597,
                  39.298251
                ],
                [
                  -76.600074,
                  39.298171
                ],
                [
                  -76.601911,
                  39.298107
                ],
                [
                  -76.604056,
                  39.298001
                ],
                [
                  -76.606332,
                  39.297912
                ],
                [
                  -76.607269,
                  39.301361
                ],
                [
                  -76.606389,
                  39.301414
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "070200",
          "AFFGEOID": "1400000US24510070200",
          "GEOID": "24510070200",
          "NAME": "702",
          "NAMELSAD": "Census Tract 702",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 311145,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.585358,
                  39.302297
                ],
                [
                  -76.583901,
                  39.302313
                ],
                [
                  -76.582555,
                  39.302365
                ],
                [
                  -76.581122,
                  39.302431
                ],
                [
                  -76.579704,
                  39.302482
                ],
                [
                  -76.578278,
                  39.302549
                ],
                [
                  -76.578211,
                  39.301131
                ],
                [
                  -76.578085,
                  39.299029
                ],
                [
                  -76.577955,
                  39.296911
                ],
                [
                  -76.578653,
                  39.296879
                ],
                [
                  -76.580041,
                  39.296817
                ],
                [
                  -76.580754,
                  39.29679
                ],
                [
                  -76.582169,
                  39.296752
                ],
                [
                  -76.583585,
                  39.296687
                ],
                [
                  -76.583721,
                  39.298807
                ],
                [
                  -76.583903,
                  39.301807
                ],
                [
                  -76.585358,
                  39.302297
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "090400",
          "AFFGEOID": "1400000US24510090400",
          "GEOID": "24510090400",
          "NAME": "904",
          "NAMELSAD": "Census Tract 904",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 352240,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.609532,
                  39.320922
                ],
                [
                  -76.609484,
                  39.322149
                ],
                [
                  -76.609456,
                  39.323443
                ],
                [
                  -76.609425,
                  39.324785
                ],
                [
                  -76.609426,
                  39.3254
                ],
                [
                  -76.608864,
                  39.32647
                ],
                [
                  -76.605107,
                  39.325133
                ],
                [
                  -76.603324,
                  39.32443
                ],
                [
                  -76.601468,
                  39.323707
                ],
                [
                  -76.602731,
                  39.322401
                ],
                [
                  -76.603584,
                  39.321572
                ],
                [
                  -76.605812,
                  39.319457
                ],
                [
                  -76.607873,
                  39.319552
                ],
                [
                  -76.609509,
                  39.319519
                ],
                [
                  -76.609532,
                  39.320922
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "250401",
          "AFFGEOID": "1400000US24510250401",
          "GEOID": "24510250401",
          "NAME": "2504.01",
          "NAMELSAD": "Census Tract 2504.01",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1181295,
          "AWATER": 31347
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.618612,
                  39.237398
                ],
                [
                  -76.615641,
                  39.239922
                ],
                [
                  -76.614642,
                  39.241092
                ],
                [
                  -76.61402,
                  39.241036
                ],
                [
                  -76.610055,
                  39.240637
                ],
                [
                  -76.60848,
                  39.240643
                ],
                [
                  -76.608657,
                  39.24033
                ],
                [
                  -76.601004,
                  39.240606
                ],
                [
                  -76.595552,
                  39.239143
                ],
                [
                  -76.597742,
                  39.234898
                ],
                [
                  -76.599319,
                  39.235389
                ],
                [
                  -76.602353,
                  39.236303
                ],
                [
                  -76.604205,
                  39.232623
                ],
                [
                  -76.606417,
                  39.231825
                ],
                [
                  -76.608167,
                  39.231099
                ],
                [
                  -76.608874,
                  39.231797
                ],
                [
                  -76.609638,
                  39.232628
                ],
                [
                  -76.611679,
                  39.234387
                ],
                [
                  -76.617932,
                  39.237089
                ],
                [
                  -76.618612,
                  39.237398
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "030100",
          "AFFGEOID": "1400000US24510030100",
          "GEOID": "24510030100",
          "NAME": "301",
          "NAMELSAD": "Census Tract 301",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 427427,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.599687,
                  39.292536
                ],
                [
                  -76.594816,
                  39.293949
                ],
                [
                  -76.594117,
                  39.293968
                ],
                [
                  -76.593944,
                  39.291542
                ],
                [
                  -76.593869,
                  39.290399
                ],
                [
                  -76.593803,
                  39.289257
                ],
                [
                  -76.593638,
                  39.286609
                ],
                [
                  -76.593557,
                  39.285578
                ],
                [
                  -76.595355,
                  39.28551
                ],
                [
                  -76.598747,
                  39.285358
                ],
                [
                  -76.599227,
                  39.285337
                ],
                [
                  -76.599281,
                  39.286355
                ],
                [
                  -76.599415,
                  39.288364
                ],
                [
                  -76.599442,
                  39.288742
                ],
                [
                  -76.59946,
                  39.289033
                ],
                [
                  -76.599565,
                  39.290217
                ],
                [
                  -76.599636,
                  39.291864
                ],
                [
                  -76.599687,
                  39.292536
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "271503",
          "AFFGEOID": "1400000US24510271503",
          "GEOID": "24510271503",
          "NAME": "2715.03",
          "NAMELSAD": "Census Tract 2715.03",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 742763,
          "AWATER": 1671
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.650551,
                  39.360533
                ],
                [
                  -76.648588,
                  39.361042
                ],
                [
                  -76.646257,
                  39.361444
                ],
                [
                  -76.643328,
                  39.35316
                ],
                [
                  -76.642035,
                  39.348863
                ],
                [
                  -76.640283,
                  39.343372
                ],
                [
                  -76.642314,
                  39.344748
                ],
                [
                  -76.644364,
                  39.3454
                ],
                [
                  -76.647222,
                  39.345243
                ],
                [
                  -76.646458,
                  39.35031
                ],
                [
                  -76.648014,
                  39.354048
                ],
                [
                  -76.649936,
                  39.3567
                ],
                [
                  -76.650551,
                  39.360533
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "130805",
          "AFFGEOID": "1400000US24510130805",
          "GEOID": "24510130805",
          "NAME": "1308.05",
          "NAMELSAD": "Census Tract 1308.05",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1632325,
          "AWATER": 6396
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.660408,
                  39.355193
                ],
                [
                  -76.654802,
                  39.357503
                ],
                [
                  -76.651161,
                  39.360396
                ],
                [
                  -76.650551,
                  39.360533
                ],
                [
                  -76.649936,
                  39.3567
                ],
                [
                  -76.648014,
                  39.354048
                ],
                [
                  -76.646458,
                  39.35031
                ],
                [
                  -76.647222,
                  39.345243
                ],
                [
                  -76.64814,
                  39.345128
                ],
                [
                  -76.650654,
                  39.344798
                ],
                [
                  -76.654396,
                  39.342125
                ],
                [
                  -76.655484,
                  39.341854
                ],
                [
                  -76.656798,
                  39.34149
                ],
                [
                  -76.658181,
                  39.340866
                ],
                [
                  -76.657193,
                  39.342303
                ],
                [
                  -76.658853,
                  39.344383
                ],
                [
                  -76.659582,
                  39.345717
                ],
                [
                  -76.659447,
                  39.346506
                ],
                [
                  -76.659133,
                  39.347887
                ],
                [
                  -76.659428,
                  39.349958
                ],
                [
                  -76.659604,
                  39.350934
                ],
                [
                  -76.660408,
                  39.355193
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "040200",
          "AFFGEOID": "1400000US24510040200",
          "GEOID": "24510040200",
          "NAME": "402",
          "NAMELSAD": "Census Tract 402",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 435698,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.628062,
                  39.287786
                ],
                [
                  -76.627766,
                  39.288974
                ],
                [
                  -76.627503,
                  39.290128
                ],
                [
                  -76.627479,
                  39.291241
                ],
                [
                  -76.627719,
                  39.293573
                ],
                [
                  -76.627688,
                  39.29463
                ],
                [
                  -76.622638,
                  39.294812
                ],
                [
                  -76.622571,
                  39.293837
                ],
                [
                  -76.62233,
                  39.289245
                ],
                [
                  -76.622129,
                  39.286257
                ],
                [
                  -76.623548,
                  39.286203
                ],
                [
                  -76.627539,
                  39.286057
                ],
                [
                  -76.628021,
                  39.287165
                ],
                [
                  -76.628062,
                  39.287786
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "271600",
          "AFFGEOID": "1400000US24510271600",
          "GEOID": "24510271600",
          "NAME": "2716",
          "NAMELSAD": "Census Tract 2716",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 850296,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.672549,
                  39.344261
                ],
                [
                  -76.672386,
                  39.344643
                ],
                [
                  -76.671397,
                  39.345195
                ],
                [
                  -76.668919,
                  39.346591
                ],
                [
                  -76.668784,
                  39.346607
                ],
                [
                  -76.665551,
                  39.346678
                ],
                [
                  -76.661894,
                  39.346719
                ],
                [
                  -76.660418,
                  39.346594
                ],
                [
                  -76.659447,
                  39.346506
                ],
                [
                  -76.659582,
                  39.345717
                ],
                [
                  -76.658853,
                  39.344383
                ],
                [
                  -76.657193,
                  39.342303
                ],
                [
                  -76.658181,
                  39.340866
                ],
                [
                  -76.65841,
                  39.340832
                ],
                [
                  -76.661279,
                  39.340698
                ],
                [
                  -76.663183,
                  39.340936
                ],
                [
                  -76.663952,
                  39.340931
                ],
                [
                  -76.66514,
                  39.340336
                ],
                [
                  -76.666473,
                  39.339632
                ],
                [
                  -76.667926,
                  39.338921
                ],
                [
                  -76.668324,
                  39.339392
                ],
                [
                  -76.673848,
                  39.341026
                ],
                [
                  -76.672549,
                  39.344261
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "280500",
          "AFFGEOID": "1400000US24510280500",
          "GEOID": "24510280500",
          "NAME": "2805",
          "NAMELSAD": "Census Tract 2805",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 923979,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.611313,
                  39.297707
                ],
                [
                  -76.610451,
                  39.297753
                ],
                [
                  -76.606332,
                  39.297912
                ],
                [
                  -76.604056,
                  39.298001
                ],
                [
                  -76.601911,
                  39.298107
                ],
                [
                  -76.600074,
                  39.298171
                ],
                [
                  -76.597597,
                  39.298251
                ],
                [
                  -76.594408,
                  39.298373
                ],
                [
                  -76.594184,
                  39.295274
                ],
                [
                  -76.594179,
                  39.295143
                ],
                [
                  -76.594117,
                  39.293968
                ],
                [
                  -76.594816,
                  39.293949
                ],
                [
                  -76.599687,
                  39.292536
                ],
                [
                  -76.603006,
                  39.291641
                ],
                [
                  -76.605762,
                  39.290884
                ],
                [
                  -76.606429,
                  39.290712
                ],
                [
                  -76.610541,
                  39.293472
                ],
                [
                  -76.611007,
                  39.294532
                ],
                [
                  -76.611313,
                  39.297707
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "271002",
          "AFFGEOID": "1400000US24510271002",
          "GEOID": "24510271002",
          "NAME": "2710.02",
          "NAMELSAD": "Census Tract 2710.02",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 955654,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.609953,
                  39.355503
                ],
                [
                  -76.607685,
                  39.355274
                ],
                [
                  -76.602334,
                  39.354711
                ],
                [
                  -76.598289,
                  39.354166
                ],
                [
                  -76.598571,
                  39.352377
                ],
                [
                  -76.598746,
                  39.351246
                ],
                [
                  -76.598833,
                  39.350714
                ],
                [
                  -76.599042,
                  39.349398
                ],
                [
                  -76.599376,
                  39.347277
                ],
                [
                  -76.599729,
                  39.345149
                ],
                [
                  -76.604196,
                  39.345577
                ],
                [
                  -76.604941,
                  39.345747
                ],
                [
                  -76.607066,
                  39.346058
                ],
                [
                  -76.608196,
                  39.346166
                ],
                [
                  -76.609682,
                  39.346177
                ],
                [
                  -76.609718,
                  39.347917
                ],
                [
                  -76.609788,
                  39.350145
                ],
                [
                  -76.60984,
                  39.351952
                ],
                [
                  -76.609881,
                  39.352801
                ],
                [
                  -76.609928,
                  39.354331
                ],
                [
                  -76.609953,
                  39.355503
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "190100",
          "AFFGEOID": "1400000US24510190100",
          "GEOID": "24510190100",
          "NAME": "1901",
          "NAMELSAD": "Census Tract 1901",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 383127,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.64552,
                  39.293895
                ],
                [
                  -76.642696,
                  39.294009
                ],
                [
                  -76.639882,
                  39.294136
                ],
                [
                  -76.638462,
                  39.294189
                ],
                [
                  -76.638365,
                  39.292295
                ],
                [
                  -76.63823,
                  39.289777
                ],
                [
                  -76.638166,
                  39.288566
                ],
                [
                  -76.640997,
                  39.28844
                ],
                [
                  -76.642413,
                  39.288373
                ],
                [
                  -76.645222,
                  39.288228
                ],
                [
                  -76.645301,
                  39.28958
                ],
                [
                  -76.645448,
                  39.292063
                ],
                [
                  -76.64552,
                  39.293895
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "240300",
          "AFFGEOID": "1400000US24510240300",
          "GEOID": "24510240300",
          "NAME": "2403",
          "NAMELSAD": "Census Tract 2403",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 200576,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.612623,
                  39.27889
                ],
                [
                  -76.609234,
                  39.278994
                ],
                [
                  -76.609034,
                  39.277376
                ],
                [
                  -76.608891,
                  39.276344
                ],
                [
                  -76.608592,
                  39.274266
                ],
                [
                  -76.608388,
                  39.272851
                ],
                [
                  -76.611754,
                  39.2727
                ],
                [
                  -76.611843,
                  39.273257
                ],
                [
                  -76.611963,
                  39.274215
                ],
                [
                  -76.612049,
                  39.2747
                ],
                [
                  -76.612227,
                  39.276019
                ],
                [
                  -76.612375,
                  39.277052
                ],
                [
                  -76.612623,
                  39.27889
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "160100",
          "AFFGEOID": "1400000US24510160100",
          "GEOID": "24510160100",
          "NAME": "1601",
          "NAMELSAD": "Census Tract 1601",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 382639,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.638967,
                  39.303378
                ],
                [
                  -76.638246,
                  39.303404
                ],
                [
                  -76.636829,
                  39.303421
                ],
                [
                  -76.634511,
                  39.299198
                ],
                [
                  -76.634475,
                  39.299142
                ],
                [
                  -76.633261,
                  39.296886
                ],
                [
                  -76.632592,
                  39.295689
                ],
                [
                  -76.631922,
                  39.294458
                ],
                [
                  -76.634132,
                  39.294354
                ],
                [
                  -76.635623,
                  39.294302
                ],
                [
                  -76.638462,
                  39.294189
                ],
                [
                  -76.638552,
                  39.295447
                ],
                [
                  -76.638757,
                  39.299062
                ],
                [
                  -76.638797,
                  39.300137
                ],
                [
                  -76.638967,
                  39.303378
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "080301",
          "AFFGEOID": "1400000US24510080301",
          "GEOID": "24510080301",
          "NAME": "803.01",
          "NAMELSAD": "Census Tract 803.01",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 268608,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.584365,
                  39.308929
                ],
                [
                  -76.582908,
                  39.308978
                ],
                [
                  -76.580103,
                  39.30906
                ],
                [
                  -76.579921,
                  39.305941
                ],
                [
                  -76.579852,
                  39.304889
                ],
                [
                  -76.579769,
                  39.303515
                ],
                [
                  -76.579704,
                  39.302482
                ],
                [
                  -76.581122,
                  39.302431
                ],
                [
                  -76.582555,
                  39.302365
                ],
                [
                  -76.583901,
                  39.302313
                ],
                [
                  -76.584175,
                  39.30578
                ],
                [
                  -76.584365,
                  39.308929
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "080302",
          "AFFGEOID": "1400000US24510080302",
          "GEOID": "24510080302",
          "NAME": "803.02",
          "NAMELSAD": "Census Tract 803.02",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 439533,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.580103,
                  39.30906
                ],
                [
                  -76.575875,
                  39.309241
                ],
                [
                  -76.573046,
                  39.309338
                ],
                [
                  -76.572793,
                  39.302721
                ],
                [
                  -76.57688,
                  39.302593
                ],
                [
                  -76.578278,
                  39.302549
                ],
                [
                  -76.579704,
                  39.302482
                ],
                [
                  -76.579769,
                  39.303515
                ],
                [
                  -76.579852,
                  39.304889
                ],
                [
                  -76.579921,
                  39.305941
                ],
                [
                  -76.580103,
                  39.30906
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "261000",
          "AFFGEOID": "1400000US24510261000",
          "GEOID": "24510261000",
          "NAME": "2610",
          "NAMELSAD": "Census Tract 2610",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 310026,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.572661,
                  39.299237
                ],
                [
                  -76.569911,
                  39.29935
                ],
                [
                  -76.569869,
                  39.299202
                ],
                [
                  -76.56974,
                  39.297225
                ],
                [
                  -76.569656,
                  39.296061
                ],
                [
                  -76.569462,
                  39.293066
                ],
                [
                  -76.569413,
                  39.292487
                ],
                [
                  -76.569334,
                  39.291336
                ],
                [
                  -76.569306,
                  39.290867
                ],
                [
                  -76.569091,
                  39.287565
                ],
                [
                  -76.571607,
                  39.287477
                ],
                [
                  -76.571669,
                  39.288471
                ],
                [
                  -76.571839,
                  39.291243
                ],
                [
                  -76.57238,
                  39.292381
                ],
                [
                  -76.572468,
                  39.293504
                ],
                [
                  -76.572565,
                  39.294777
                ],
                [
                  -76.572579,
                  39.295644
                ],
                [
                  -76.572597,
                  39.297115
                ],
                [
                  -76.572661,
                  39.299237
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "270802",
          "AFFGEOID": "1400000US24510270802",
          "GEOID": "24510270802",
          "NAME": "2708.02",
          "NAMELSAD": "Census Tract 2708.02",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1099564,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.59859,
                  39.366053
                ],
                [
                  -76.596794,
                  39.366466
                ],
                [
                  -76.595308,
                  39.366802
                ],
                [
                  -76.593337,
                  39.367001
                ],
                [
                  -76.590632,
                  39.366603
                ],
                [
                  -76.586604,
                  39.36604
                ],
                [
                  -76.58551,
                  39.366039
                ],
                [
                  -76.586309,
                  39.364381
                ],
                [
                  -76.587754,
                  39.361281
                ],
                [
                  -76.588468,
                  39.359817
                ],
                [
                  -76.589582,
                  39.357315
                ],
                [
                  -76.589561,
                  39.355418
                ],
                [
                  -76.592136,
                  39.354367
                ],
                [
                  -76.593326,
                  39.354131
                ],
                [
                  -76.594666,
                  39.354075
                ],
                [
                  -76.595172,
                  39.355519
                ],
                [
                  -76.595934,
                  39.356557
                ],
                [
                  -76.597752,
                  39.358535
                ],
                [
                  -76.598102,
                  39.359909
                ],
                [
                  -76.597883,
                  39.36314
                ],
                [
                  -76.599283,
                  39.365912
                ],
                [
                  -76.59859,
                  39.366053
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "150100",
          "AFFGEOID": "1400000US24510150100",
          "GEOID": "24510150100",
          "NAME": "1501",
          "NAMELSAD": "Census Tract 1501",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 369345,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.645006,
                  39.309944
                ],
                [
                  -76.642514,
                  39.310089
                ],
                [
                  -76.640392,
                  39.3083
                ],
                [
                  -76.638823,
                  39.306992
                ],
                [
                  -76.638033,
                  39.305597
                ],
                [
                  -76.636829,
                  39.303421
                ],
                [
                  -76.638246,
                  39.303404
                ],
                [
                  -76.638967,
                  39.303378
                ],
                [
                  -76.640407,
                  39.303324
                ],
                [
                  -76.643218,
                  39.303211
                ],
                [
                  -76.644643,
                  39.303176
                ],
                [
                  -76.644769,
                  39.305352
                ],
                [
                  -76.644839,
                  39.306727
                ],
                [
                  -76.644913,
                  39.308006
                ],
                [
                  -76.645006,
                  39.309944
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "020300",
          "AFFGEOID": "1400000US24510020300",
          "GEOID": "24510020300",
          "NAME": "203",
          "NAMELSAD": "Census Tract 203",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 662772,
          "AWATER": 384067
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.600513,
                  39.280822
                ],
                [
                  -76.600218,
                  39.281526
                ],
                [
                  -76.599009,
                  39.282253
                ],
                [
                  -76.599227,
                  39.285337
                ],
                [
                  -76.598747,
                  39.285358
                ],
                [
                  -76.595355,
                  39.28551
                ],
                [
                  -76.593557,
                  39.285578
                ],
                [
                  -76.590113,
                  39.285735
                ],
                [
                  -76.587056,
                  39.285853
                ],
                [
                  -76.58693,
                  39.283806
                ],
                [
                  -76.586889,
                  39.28323
                ],
                [
                  -76.586588,
                  39.277306
                ],
                [
                  -76.589884,
                  39.278005
                ],
                [
                  -76.592991,
                  39.277527
                ],
                [
                  -76.595079,
                  39.277199
                ],
                [
                  -76.598977,
                  39.276916
                ],
                [
                  -76.602588,
                  39.279506
                ],
                [
                  -76.600513,
                  39.280822
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "070300",
          "AFFGEOID": "1400000US24510070300",
          "GEOID": "24510070300",
          "NAME": "703",
          "NAMELSAD": "Census Tract 703",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 228689,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.588135,
                  39.303218
                ],
                [
                  -76.586917,
                  39.302613
                ],
                [
                  -76.586519,
                  39.302495
                ],
                [
                  -76.586192,
                  39.302416
                ],
                [
                  -76.585799,
                  39.302343
                ],
                [
                  -76.585358,
                  39.302297
                ],
                [
                  -76.583903,
                  39.301807
                ],
                [
                  -76.583721,
                  39.298807
                ],
                [
                  -76.583585,
                  39.296687
                ],
                [
                  -76.583568,
                  39.296393
                ],
                [
                  -76.584271,
                  39.29635
                ],
                [
                  -76.585752,
                  39.296601
                ],
                [
                  -76.58773,
                  39.296519
                ],
                [
                  -76.587869,
                  39.298647
                ],
                [
                  -76.587936,
                  39.299699
                ],
                [
                  -76.588079,
                  39.302138
                ],
                [
                  -76.588135,
                  39.303218
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "271300",
          "AFFGEOID": "1400000US24510271300",
          "GEOID": "24510271300",
          "NAME": "2713",
          "NAMELSAD": "Census Tract 2713",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 2861713,
          "AWATER": 3175
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.649353,
                  39.370648
                ],
                [
                  -76.648769,
                  39.371166
                ],
                [
                  -76.649041,
                  39.372181
                ],
                [
                  -76.646926,
                  39.372006
                ],
                [
                  -76.633944,
                  39.372009
                ],
                [
                  -76.634218,
                  39.369374
                ],
                [
                  -76.63159,
                  39.368707
                ],
                [
                  -76.631666,
                  39.365489
                ],
                [
                  -76.627969,
                  39.36588
                ],
                [
                  -76.629483,
                  39.361881
                ],
                [
                  -76.630267,
                  39.35861
                ],
                [
                  -76.629227,
                  39.353429
                ],
                [
                  -76.632222,
                  39.353076
                ],
                [
                  -76.634064,
                  39.353133
                ],
                [
                  -76.637464,
                  39.353843
                ],
                [
                  -76.639668,
                  39.353044
                ],
                [
                  -76.643328,
                  39.35316
                ],
                [
                  -76.646257,
                  39.361444
                ],
                [
                  -76.649165,
                  39.37014
                ],
                [
                  -76.649353,
                  39.370648
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "150500",
          "AFFGEOID": "1400000US24510150500",
          "GEOID": "24510150500",
          "NAME": "1505",
          "NAMELSAD": "Census Tract 1505",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 960450,
          "AWATER": 9673
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.664776,
                  39.322194
                ],
                [
                  -76.66414,
                  39.325972
                ],
                [
                  -76.664302,
                  39.327512
                ],
                [
                  -76.660985,
                  39.326947
                ],
                [
                  -76.659355,
                  39.32771
                ],
                [
                  -76.657842,
                  39.325713
                ],
                [
                  -76.657528,
                  39.325453
                ],
                [
                  -76.657105,
                  39.324785
                ],
                [
                  -76.654881,
                  39.32181
                ],
                [
                  -76.652477,
                  39.318549
                ],
                [
                  -76.652014,
                  39.31805
                ],
                [
                  -76.650494,
                  39.316704
                ],
                [
                  -76.651958,
                  39.315746
                ],
                [
                  -76.657701,
                  39.315812
                ],
                [
                  -76.659779,
                  39.315224
                ],
                [
                  -76.664217,
                  39.320289
                ],
                [
                  -76.664776,
                  39.322194
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "090100",
          "AFFGEOID": "1400000US24510090100",
          "GEOID": "24510090100",
          "NAME": "901",
          "NAMELSAD": "Census Tract 901",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 657875,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.6096,
                  39.340181
                ],
                [
                  -76.607699,
                  39.340227
                ],
                [
                  -76.607667,
                  39.339677
                ],
                [
                  -76.604229,
                  39.340477
                ],
                [
                  -76.601435,
                  39.34055
                ],
                [
                  -76.600866,
                  39.340416
                ],
                [
                  -76.600211,
                  39.340064
                ],
                [
                  -76.600132,
                  39.33924
                ],
                [
                  -76.599439,
                  39.337964
                ],
                [
                  -76.595443,
                  39.33403
                ],
                [
                  -76.600197,
                  39.334038
                ],
                [
                  -76.604485,
                  39.33404
                ],
                [
                  -76.60463,
                  39.334327
                ],
                [
                  -76.605879,
                  39.334185
                ],
                [
                  -76.607537,
                  39.334483
                ],
                [
                  -76.609508,
                  39.334456
                ],
                [
                  -76.609516,
                  39.336395
                ],
                [
                  -76.609533,
                  39.338665
                ],
                [
                  -76.60958,
                  39.339798
                ],
                [
                  -76.6096,
                  39.340181
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "271801",
          "AFFGEOID": "1400000US24510271801",
          "GEOID": "24510271801",
          "NAME": "2718.01",
          "NAMELSAD": "Census Tract 2718.01",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 557962,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.687608,
                  39.349407
                ],
                [
                  -76.685732,
                  39.350438
                ],
                [
                  -76.683358,
                  39.351757
                ],
                [
                  -76.681322,
                  39.350604
                ],
                [
                  -76.67596,
                  39.349028
                ],
                [
                  -76.67936,
                  39.34689
                ],
                [
                  -76.679601,
                  39.346735
                ],
                [
                  -76.6808,
                  39.345951
                ],
                [
                  -76.683519,
                  39.34294
                ],
                [
                  -76.686399,
                  39.344979
                ],
                [
                  -76.690059,
                  39.347585
                ],
                [
                  -76.687608,
                  39.349407
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "080400",
          "AFFGEOID": "1400000US24510080400",
          "GEOID": "24510080400",
          "NAME": "804",
          "NAMELSAD": "Census Tract 804",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 250976,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.588507,
                  39.308679
                ],
                [
                  -76.587394,
                  39.30885
                ],
                [
                  -76.585764,
                  39.308887
                ],
                [
                  -76.584365,
                  39.308929
                ],
                [
                  -76.584175,
                  39.30578
                ],
                [
                  -76.583901,
                  39.302313
                ],
                [
                  -76.585358,
                  39.302297
                ],
                [
                  -76.585799,
                  39.302343
                ],
                [
                  -76.586192,
                  39.302416
                ],
                [
                  -76.586519,
                  39.302495
                ],
                [
                  -76.586917,
                  39.302613
                ],
                [
                  -76.588135,
                  39.303218
                ],
                [
                  -76.588147,
                  39.303489
                ],
                [
                  -76.58825,
                  39.305106
                ],
                [
                  -76.588286,
                  39.30564
                ],
                [
                  -76.588507,
                  39.308679
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "100300",
          "AFFGEOID": "1400000US24510100300",
          "GEOID": "24510100300",
          "NAME": "1003",
          "NAMELSAD": "Census Tract 1003",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 156309,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.611551,
                  39.301224
                ],
                [
                  -76.61096,
                  39.301248
                ],
                [
                  -76.607269,
                  39.301361
                ],
                [
                  -76.606332,
                  39.297912
                ],
                [
                  -76.610451,
                  39.297753
                ],
                [
                  -76.611313,
                  39.297707
                ],
                [
                  -76.611424,
                  39.29877
                ],
                [
                  -76.611551,
                  39.301224
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "200400",
          "AFFGEOID": "1400000US24510200400",
          "GEOID": "24510200400",
          "NAME": "2004",
          "NAMELSAD": "Census Tract 2004",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 387906,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.662328,
                  39.28751
                ],
                [
                  -76.658829,
                  39.287665
                ],
                [
                  -76.656222,
                  39.287814
                ],
                [
                  -76.652869,
                  39.287911
                ],
                [
                  -76.651487,
                  39.287967
                ],
                [
                  -76.650095,
                  39.288029
                ],
                [
                  -76.650037,
                  39.287007
                ],
                [
                  -76.649969,
                  39.28578
                ],
                [
                  -76.652622,
                  39.284874
                ],
                [
                  -76.654538,
                  39.284213
                ],
                [
                  -76.655928,
                  39.283405
                ],
                [
                  -76.657872,
                  39.282141
                ],
                [
                  -76.659026,
                  39.281384
                ],
                [
                  -76.65986,
                  39.282321
                ],
                [
                  -76.659259,
                  39.285763
                ],
                [
                  -76.659436,
                  39.2862
                ],
                [
                  -76.662924,
                  39.287424
                ],
                [
                  -76.662328,
                  39.28751
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "280401",
          "AFFGEOID": "1400000US24510280401",
          "GEOID": "24510280401",
          "NAME": "2804.01",
          "NAMELSAD": "Census Tract 2804.01",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1645634,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.711255,
                  39.297362
                ],
                [
                  -76.711193,
                  39.29823
                ],
                [
                  -76.711255,
                  39.299212
                ],
                [
                  -76.71121,
                  39.299778
                ],
                [
                  -76.711201,
                  39.301184
                ],
                [
                  -76.711191,
                  39.302955
                ],
                [
                  -76.708403,
                  39.303395
                ],
                [
                  -76.705413,
                  39.302238
                ],
                [
                  -76.706482,
                  39.301093
                ],
                [
                  -76.706178,
                  39.299673
                ],
                [
                  -76.703122,
                  39.299745
                ],
                [
                  -76.701021,
                  39.301548
                ],
                [
                  -76.697979,
                  39.301403
                ],
                [
                  -76.694866,
                  39.302016
                ],
                [
                  -76.69471,
                  39.301837
                ],
                [
                  -76.692406,
                  39.298946
                ],
                [
                  -76.693512,
                  39.297922
                ],
                [
                  -76.691572,
                  39.296734
                ],
                [
                  -76.692248,
                  39.296117
                ],
                [
                  -76.689442,
                  39.294111
                ],
                [
                  -76.689425,
                  39.293581
                ],
                [
                  -76.696359,
                  39.293298
                ],
                [
                  -76.697993,
                  39.29306
                ],
                [
                  -76.699264,
                  39.292847
                ],
                [
                  -76.703902,
                  39.292431
                ],
                [
                  -76.708124,
                  39.291882
                ],
                [
                  -76.711195,
                  39.291749
                ],
                [
                  -76.711393,
                  39.296805
                ],
                [
                  -76.711255,
                  39.297362
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "010500",
          "AFFGEOID": "1400000US24510010500",
          "GEOID": "24510010500",
          "NAME": "105",
          "NAMELSAD": "Census Tract 105",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 155243,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.587414,
                  39.291813
                ],
                [
                  -76.584722,
                  39.291891
                ],
                [
                  -76.584572,
                  39.289599
                ],
                [
                  -76.584332,
                  39.285956
                ],
                [
                  -76.587056,
                  39.285853
                ],
                [
                  -76.587185,
                  39.287897
                ],
                [
                  -76.587297,
                  39.289509
                ],
                [
                  -76.587414,
                  39.291813
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "260303",
          "AFFGEOID": "1400000US24510260303",
          "GEOID": "24510260303",
          "NAME": "2603.03",
          "NAMELSAD": "Census Tract 2603.03",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1218862,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.573137,
                  39.314474
                ],
                [
                  -76.570447,
                  39.313451
                ],
                [
                  -76.567713,
                  39.313531
                ],
                [
                  -76.566407,
                  39.313561
                ],
                [
                  -76.563668,
                  39.313642
                ],
                [
                  -76.56108,
                  39.314539
                ],
                [
                  -76.559314,
                  39.315315
                ],
                [
                  -76.557123,
                  39.316561
                ],
                [
                  -76.555024,
                  39.317956
                ],
                [
                  -76.552311,
                  39.316808
                ],
                [
                  -76.549152,
                  39.316351
                ],
                [
                  -76.548938,
                  39.315888
                ],
                [
                  -76.549349,
                  39.31374
                ],
                [
                  -76.550387,
                  39.311318
                ],
                [
                  -76.552046,
                  39.311094
                ],
                [
                  -76.55361,
                  39.310102
                ],
                [
                  -76.554023,
                  39.310807
                ],
                [
                  -76.560857,
                  39.309016
                ],
                [
                  -76.561215,
                  39.308986
                ],
                [
                  -76.562293,
                  39.308966
                ],
                [
                  -76.565478,
                  39.30897
                ],
                [
                  -76.568615,
                  39.309379
                ],
                [
                  -76.573046,
                  39.309338
                ],
                [
                  -76.573145,
                  39.314316
                ],
                [
                  -76.573137,
                  39.314474
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "020100",
          "AFFGEOID": "1400000US24510020100",
          "GEOID": "24510020100",
          "NAME": "201",
          "NAMELSAD": "Census Tract 201",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 174536,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.590468,
                  39.291679
                ],
                [
                  -76.587414,
                  39.291813
                ],
                [
                  -76.587297,
                  39.289509
                ],
                [
                  -76.587185,
                  39.287897
                ],
                [
                  -76.587056,
                  39.285853
                ],
                [
                  -76.590113,
                  39.285735
                ],
                [
                  -76.590344,
                  39.289387
                ],
                [
                  -76.590468,
                  39.291679
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "130804",
          "AFFGEOID": "1400000US24510130804",
          "GEOID": "24510130804",
          "NAME": "1308.04",
          "NAMELSAD": "Census Tract 1308.04",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 737978,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.644627,
                  39.334753
                ],
                [
                  -76.640385,
                  39.336448
                ],
                [
                  -76.639186,
                  39.336919
                ],
                [
                  -76.637361,
                  39.337635
                ],
                [
                  -76.636825,
                  39.336893
                ],
                [
                  -76.636612,
                  39.336424
                ],
                [
                  -76.635638,
                  39.333202
                ],
                [
                  -76.635446,
                  39.332613
                ],
                [
                  -76.633125,
                  39.326472
                ],
                [
                  -76.633653,
                  39.325568
                ],
                [
                  -76.633781,
                  39.325413
                ],
                [
                  -76.633998,
                  39.325174
                ],
                [
                  -76.6343,
                  39.324737
                ],
                [
                  -76.640014,
                  39.326736
                ],
                [
                  -76.640528,
                  39.327216
                ],
                [
                  -76.641929,
                  39.331495
                ],
                [
                  -76.642269,
                  39.331922
                ],
                [
                  -76.643234,
                  39.332892
                ],
                [
                  -76.644627,
                  39.334753
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "200800",
          "AFFGEOID": "1400000US24510200800",
          "GEOID": "24510200800",
          "NAME": "2008",
          "NAMELSAD": "Census Tract 2008",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1067262,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.686776,
                  39.287229
                ],
                [
                  -76.681447,
                  39.284242
                ],
                [
                  -76.680813,
                  39.284149
                ],
                [
                  -76.676208,
                  39.283123
                ],
                [
                  -76.672167,
                  39.281087
                ],
                [
                  -76.672216,
                  39.280937
                ],
                [
                  -76.671651,
                  39.27967
                ],
                [
                  -76.671582,
                  39.276971
                ],
                [
                  -76.671563,
                  39.275933
                ],
                [
                  -76.675482,
                  39.274183
                ],
                [
                  -76.676677,
                  39.274385
                ],
                [
                  -76.679977,
                  39.27716
                ],
                [
                  -76.681673,
                  39.276998
                ],
                [
                  -76.683581,
                  39.276569
                ],
                [
                  -76.685903,
                  39.27822
                ],
                [
                  -76.68561,
                  39.281679
                ],
                [
                  -76.686706,
                  39.281656
                ],
                [
                  -76.686776,
                  39.287229
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "270801",
          "AFFGEOID": "1400000US24510270801",
          "GEOID": "24510270801",
          "NAME": "2708.01",
          "NAMELSAD": "Census Tract 2708.01",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 806701,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.599799,
                  39.369331
                ],
                [
                  -76.597045,
                  39.371868
                ],
                [
                  -76.594904,
                  39.371931
                ],
                [
                  -76.588305,
                  39.371941
                ],
                [
                  -76.587701,
                  39.371782
                ],
                [
                  -76.585599,
                  39.372024
                ],
                [
                  -76.583457,
                  39.37211
                ],
                [
                  -76.582208,
                  39.372106
                ],
                [
                  -76.581956,
                  39.372105
                ],
                [
                  -76.584053,
                  39.368525
                ],
                [
                  -76.58551,
                  39.366039
                ],
                [
                  -76.586604,
                  39.36604
                ],
                [
                  -76.590632,
                  39.366603
                ],
                [
                  -76.593337,
                  39.367001
                ],
                [
                  -76.595308,
                  39.366802
                ],
                [
                  -76.596794,
                  39.366466
                ],
                [
                  -76.59859,
                  39.366053
                ],
                [
                  -76.599283,
                  39.365912
                ],
                [
                  -76.599805,
                  39.36701
                ],
                [
                  -76.599799,
                  39.369331
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "260604",
          "AFFGEOID": "1400000US24510260604",
          "GEOID": "24510260604",
          "NAME": "2606.04",
          "NAMELSAD": "Census Tract 2606.04",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 503666,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.543805,
                  39.281443
                ],
                [
                  -76.540512,
                  39.281573
                ],
                [
                  -76.535704,
                  39.281793
                ],
                [
                  -76.535213,
                  39.280987
                ],
                [
                  -76.534252,
                  39.279079
                ],
                [
                  -76.533504,
                  39.277541
                ],
                [
                  -76.534181,
                  39.276916
                ],
                [
                  -76.534993,
                  39.275293
                ],
                [
                  -76.537924,
                  39.27484
                ],
                [
                  -76.538005,
                  39.276466
                ],
                [
                  -76.54364,
                  39.276282
                ],
                [
                  -76.543647,
                  39.276497
                ],
                [
                  -76.543738,
                  39.277931
                ],
                [
                  -76.543667,
                  39.278628
                ],
                [
                  -76.543805,
                  39.281443
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "200300",
          "AFFGEOID": "1400000US24510200300",
          "GEOID": "24510200300",
          "NAME": "2003",
          "NAMELSAD": "Census Tract 2003",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 244150,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.650095,
                  39.288029
                ],
                [
                  -76.646959,
                  39.288148
                ],
                [
                  -76.646775,
                  39.285175
                ],
                [
                  -76.646719,
                  39.284242
                ],
                [
                  -76.646426,
                  39.279489
                ],
                [
                  -76.647977,
                  39.279075
                ],
                [
                  -76.648776,
                  39.280557
                ],
                [
                  -76.649772,
                  39.282387
                ],
                [
                  -76.649878,
                  39.284164
                ],
                [
                  -76.649903,
                  39.284994
                ],
                [
                  -76.649969,
                  39.28578
                ],
                [
                  -76.650037,
                  39.287007
                ],
                [
                  -76.650095,
                  39.288029
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "271001",
          "AFFGEOID": "1400000US24510271001",
          "GEOID": "24510271001",
          "NAME": "2710.01",
          "NAMELSAD": "Census Tract 2710.01",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 505077,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.609636,
                  39.344296
                ],
                [
                  -76.609682,
                  39.346177
                ],
                [
                  -76.608196,
                  39.346166
                ],
                [
                  -76.607066,
                  39.346058
                ],
                [
                  -76.604941,
                  39.345747
                ],
                [
                  -76.604196,
                  39.345577
                ],
                [
                  -76.599729,
                  39.345149
                ],
                [
                  -76.599868,
                  39.344253
                ],
                [
                  -76.599935,
                  39.342743
                ],
                [
                  -76.600211,
                  39.340064
                ],
                [
                  -76.600866,
                  39.340416
                ],
                [
                  -76.601435,
                  39.34055
                ],
                [
                  -76.604229,
                  39.340477
                ],
                [
                  -76.607667,
                  39.339677
                ],
                [
                  -76.607699,
                  39.340227
                ],
                [
                  -76.6096,
                  39.340181
                ],
                [
                  -76.609682,
                  39.34104
                ],
                [
                  -76.609636,
                  39.344296
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "070100",
          "AFFGEOID": "1400000US24510070100",
          "GEOID": "24510070100",
          "NAME": "701",
          "NAMELSAD": "Census Tract 701",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 290634,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.578278,
                  39.302549
                ],
                [
                  -76.57688,
                  39.302593
                ],
                [
                  -76.572793,
                  39.302721
                ],
                [
                  -76.572789,
                  39.299234
                ],
                [
                  -76.572661,
                  39.299237
                ],
                [
                  -76.572597,
                  39.297115
                ],
                [
                  -76.575804,
                  39.296994
                ],
                [
                  -76.577955,
                  39.296911
                ],
                [
                  -76.578085,
                  39.299029
                ],
                [
                  -76.578211,
                  39.301131
                ],
                [
                  -76.578278,
                  39.302549
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "150701",
          "AFFGEOID": "1400000US24510150701",
          "GEOID": "24510150701",
          "NAME": "1507.01",
          "NAMELSAD": "Census Tract 1507.01",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 858013,
          "AWATER": 117437
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.674532,
                  39.321829
                ],
                [
                  -76.672888,
                  39.321345
                ],
                [
                  -76.67171,
                  39.323714
                ],
                [
                  -76.67145,
                  39.324189
                ],
                [
                  -76.669499,
                  39.323619
                ],
                [
                  -76.664776,
                  39.322194
                ],
                [
                  -76.664217,
                  39.320289
                ],
                [
                  -76.659779,
                  39.315224
                ],
                [
                  -76.661728,
                  39.314727
                ],
                [
                  -76.666091,
                  39.314458
                ],
                [
                  -76.667868,
                  39.314404
                ],
                [
                  -76.671249,
                  39.314278
                ],
                [
                  -76.672681,
                  39.314219
                ],
                [
                  -76.674418,
                  39.314163
                ],
                [
                  -76.67443,
                  39.314334
                ],
                [
                  -76.674495,
                  39.315238
                ],
                [
                  -76.674862,
                  39.321181
                ],
                [
                  -76.674532,
                  39.321829
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "260900",
          "AFFGEOID": "1400000US24510260900",
          "GEOID": "24510260900",
          "NAME": "2609",
          "NAMELSAD": "Census Tract 2609",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 552102,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.569091,
                  39.287565
                ],
                [
                  -76.567236,
                  39.287641
                ],
                [
                  -76.562513,
                  39.287825
                ],
                [
                  -76.562446,
                  39.286877
                ],
                [
                  -76.562312,
                  39.284791
                ],
                [
                  -76.562123,
                  39.281749
                ],
                [
                  -76.562057,
                  39.280707
                ],
                [
                  -76.562477,
                  39.280693
                ],
                [
                  -76.5645,
                  39.278595
                ],
                [
                  -76.568512,
                  39.278417
                ],
                [
                  -76.568652,
                  39.280452
                ],
                [
                  -76.56878,
                  39.282488
                ],
                [
                  -76.568845,
                  39.283509
                ],
                [
                  -76.569022,
                  39.286561
                ],
                [
                  -76.569091,
                  39.287565
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "220100",
          "AFFGEOID": "1400000US24510220100",
          "GEOID": "24510220100",
          "NAME": "2201",
          "NAMELSAD": "Census Tract 2201",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1154889,
          "AWATER": 284941
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.627539,
                  39.286057
                ],
                [
                  -76.623548,
                  39.286203
                ],
                [
                  -76.622129,
                  39.286257
                ],
                [
                  -76.620755,
                  39.286261
                ],
                [
                  -76.619332,
                  39.286316
                ],
                [
                  -76.617551,
                  39.286378
                ],
                [
                  -76.614896,
                  39.286513
                ],
                [
                  -76.612128,
                  39.286603
                ],
                [
                  -76.610722,
                  39.286652
                ],
                [
                  -76.605139,
                  39.286851
                ],
                [
                  -76.605001,
                  39.286855
                ],
                [
                  -76.60515,
                  39.286689
                ],
                [
                  -76.604604,
                  39.285099
                ],
                [
                  -76.604436,
                  39.284283
                ],
                [
                  -76.60401,
                  39.282894
                ],
                [
                  -76.603688,
                  39.280906
                ],
                [
                  -76.602788,
                  39.279806
                ],
                [
                  -76.604293,
                  39.279303
                ],
                [
                  -76.605926,
                  39.279258
                ],
                [
                  -76.606433,
                  39.279228
                ],
                [
                  -76.609234,
                  39.278994
                ],
                [
                  -76.612623,
                  39.27889
                ],
                [
                  -76.614525,
                  39.278985
                ],
                [
                  -76.615689,
                  39.278942
                ],
                [
                  -76.616446,
                  39.278919
                ],
                [
                  -76.618254,
                  39.279381
                ],
                [
                  -76.618821,
                  39.279354
                ],
                [
                  -76.618999,
                  39.279052
                ],
                [
                  -76.61979,
                  39.280205
                ],
                [
                  -76.619884,
                  39.280047
                ],
                [
                  -76.620207,
                  39.28027
                ],
                [
                  -76.623186,
                  39.281238
                ],
                [
                  -76.625384,
                  39.282235
                ],
                [
                  -76.627539,
                  39.286057
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "280101",
          "AFFGEOID": "1400000US24510280101",
          "GEOID": "24510280101",
          "NAME": "2801.01",
          "NAMELSAD": "Census Tract 2801.01",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1408316,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.711186,
                  39.354383
                ],
                [
                  -76.711228,
                  39.356161
                ],
                [
                  -76.71135,
                  39.356771
                ],
                [
                  -76.711191,
                  39.362798
                ],
                [
                  -76.707751,
                  39.360323
                ],
                [
                  -76.706918,
                  39.359658
                ],
                [
                  -76.705097,
                  39.35825
                ],
                [
                  -76.702446,
                  39.356246
                ],
                [
                  -76.700188,
                  39.35465
                ],
                [
                  -76.699685,
                  39.354301
                ],
                [
                  -76.698965,
                  39.353797
                ],
                [
                  -76.696528,
                  39.352084
                ],
                [
                  -76.695355,
                  39.351254
                ],
                [
                  -76.691839,
                  39.348808
                ],
                [
                  -76.690059,
                  39.347585
                ],
                [
                  -76.686399,
                  39.344979
                ],
                [
                  -76.683519,
                  39.34294
                ],
                [
                  -76.680993,
                  39.341688
                ],
                [
                  -76.678216,
                  39.342237
                ],
                [
                  -76.677745,
                  39.342136
                ],
                [
                  -76.67671,
                  39.341841
                ],
                [
                  -76.677067,
                  39.341134
                ],
                [
                  -76.677964,
                  39.339925
                ],
                [
                  -76.682916,
                  39.341435
                ],
                [
                  -76.687477,
                  39.342854
                ],
                [
                  -76.688966,
                  39.34356
                ],
                [
                  -76.692518,
                  39.345564
                ],
                [
                  -76.694494,
                  39.34667
                ],
                [
                  -76.695316,
                  39.347249
                ],
                [
                  -76.699494,
                  39.349551
                ],
                [
                  -76.705602,
                  39.3527
                ],
                [
                  -76.706441,
                  39.353027
                ],
                [
                  -76.711388,
                  39.349496
                ],
                [
                  -76.711186,
                  39.354383
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "260401",
          "AFFGEOID": "1400000US24510260401",
          "GEOID": "24510260401",
          "NAME": "2604.01",
          "NAMELSAD": "Census Tract 2604.01",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1341147,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.565478,
                  39.30897
                ],
                [
                  -76.562293,
                  39.308966
                ],
                [
                  -76.561215,
                  39.308986
                ],
                [
                  -76.560857,
                  39.309016
                ],
                [
                  -76.554023,
                  39.310807
                ],
                [
                  -76.55361,
                  39.310102
                ],
                [
                  -76.552046,
                  39.311094
                ],
                [
                  -76.550387,
                  39.311318
                ],
                [
                  -76.547918,
                  39.311196
                ],
                [
                  -76.546903,
                  39.309604
                ],
                [
                  -76.543118,
                  39.307352
                ],
                [
                  -76.544698,
                  39.304559
                ],
                [
                  -76.546089,
                  39.302548
                ],
                [
                  -76.549476,
                  39.301503
                ],
                [
                  -76.550674,
                  39.301077
                ],
                [
                  -76.553479,
                  39.300151
                ],
                [
                  -76.554885,
                  39.301018
                ],
                [
                  -76.563609,
                  39.307635
                ],
                [
                  -76.565478,
                  39.30897
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "200200",
          "AFFGEOID": "1400000US24510200200",
          "GEOID": "24510200200",
          "NAME": "2002",
          "NAMELSAD": "Census Tract 2002",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 926853,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.669717,
                  39.294276
                ],
                [
                  -76.668664,
                  39.294325
                ],
                [
                  -76.666711,
                  39.294412
                ],
                [
                  -76.664927,
                  39.294452
                ],
                [
                  -76.664895,
                  39.293936
                ],
                [
                  -76.661351,
                  39.293259
                ],
                [
                  -76.659353,
                  39.293352
                ],
                [
                  -76.656274,
                  39.293439
                ],
                [
                  -76.650383,
                  39.293698
                ],
                [
                  -76.650218,
                  39.289924
                ],
                [
                  -76.650164,
                  39.28939
                ],
                [
                  -76.650095,
                  39.288029
                ],
                [
                  -76.651487,
                  39.287967
                ],
                [
                  -76.652869,
                  39.287911
                ],
                [
                  -76.656222,
                  39.287814
                ],
                [
                  -76.658829,
                  39.287665
                ],
                [
                  -76.662328,
                  39.28751
                ],
                [
                  -76.662924,
                  39.287424
                ],
                [
                  -76.663613,
                  39.287616
                ],
                [
                  -76.66653,
                  39.291022
                ],
                [
                  -76.667858,
                  39.292412
                ],
                [
                  -76.669642,
                  39.293528
                ],
                [
                  -76.669712,
                  39.294163
                ],
                [
                  -76.669717,
                  39.294276
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "260605",
          "AFFGEOID": "1400000US24510260605",
          "GEOID": "24510260605",
          "NAME": "2606.05",
          "NAMELSAD": "Census Tract 2606.05",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 9979929,
          "AWATER": 7154314
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.577586,
                  39.271606
                ],
                [
                  -76.572687,
                  39.275007
                ],
                [
                  -76.571987,
                  39.275406
                ],
                [
                  -76.570978,
                  39.276345
                ],
                [
                  -76.571008,
                  39.278337
                ],
                [
                  -76.568512,
                  39.278417
                ],
                [
                  -76.5645,
                  39.278595
                ],
                [
                  -76.562477,
                  39.280693
                ],
                [
                  -76.562057,
                  39.280707
                ],
                [
                  -76.560994,
                  39.280738
                ],
                [
                  -76.55542,
                  39.280953
                ],
                [
                  -76.554581,
                  39.280977
                ],
                [
                  -76.550608,
                  39.281172
                ],
                [
                  -76.547586,
                  39.281286
                ],
                [
                  -76.543805,
                  39.281443
                ],
                [
                  -76.543667,
                  39.278628
                ],
                [
                  -76.543738,
                  39.277931
                ],
                [
                  -76.543647,
                  39.276497
                ],
                [
                  -76.54364,
                  39.276282
                ],
                [
                  -76.538005,
                  39.276466
                ],
                [
                  -76.537924,
                  39.27484
                ],
                [
                  -76.534993,
                  39.275293
                ],
                [
                  -76.534181,
                  39.276916
                ],
                [
                  -76.533504,
                  39.277541
                ],
                [
                  -76.534252,
                  39.279079
                ],
                [
                  -76.535213,
                  39.280987
                ],
                [
                  -76.535704,
                  39.281793
                ],
                [
                  -76.530393,
                  39.284818
                ],
                [
                  -76.529592,
                  39.284852
                ],
                [
                  -76.529663,
                  39.284203
                ],
                [
                  -76.529788,
                  39.281527
                ],
                [
                  -76.529781,
                  39.273101
                ],
                [
                  -76.529623,
                  39.272307
                ],
                [
                  -76.529685,
                  39.270207
                ],
                [
                  -76.529788,
                  39.269722
                ],
                [
                  -76.529784,
                  39.264989
                ],
                [
                  -76.529785,
                  39.263995
                ],
                [
                  -76.529758,
                  39.257584
                ],
                [
                  -76.529785,
                  39.255781
                ],
                [
                  -76.529487,
                  39.247045
                ],
                [
                  -76.5295838667757,
                  39.2402981429609
                ],
                [
                  -76.533245,
                  39.23925
                ],
                [
                  -76.5358828979451,
                  39.2421445657851
                ],
                [
                  -76.538827693461,
                  39.2453758903177
                ],
                [
                  -76.538949,
                  39.245509
                ],
                [
                  -76.540256,
                  39.250387
                ],
                [
                  -76.5405117299536,
                  39.2505321916597
                ],
                [
                  -76.5439321062706,
                  39.2524741234015
                ],
                [
                  -76.5455929668454,
                  39.253417083348
                ],
                [
                  -76.552735,
                  39.257472
                ],
                [
                  -76.5527475271446,
                  39.2574713461626
                ],
                [
                  -76.5588640885588,
                  39.2571521005215
                ],
                [
                  -76.5598736153201,
                  39.2570994096391
                ],
                [
                  -76.5629709057749,
                  39.2569377507576
                ],
                [
                  -76.563311,
                  39.25692
                ],
                [
                  -76.566282,
                  39.259589
                ],
                [
                  -76.5688667301173,
                  39.2592410919228
                ],
                [
                  -76.569016,
                  39.259221
                ],
                [
                  -76.571511,
                  39.260693
                ],
                [
                  -76.571868,
                  39.262165
                ],
                [
                  -76.5721627680034,
                  39.2642979280244
                ],
                [
                  -76.572224,
                  39.264741
                ],
                [
                  -76.5750309389132,
                  39.2646422283878
                ],
                [
                  -76.575218,
                  39.265652
                ],
                [
                  -76.575486,
                  39.267105
                ],
                [
                  -76.577586,
                  39.271606
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "230100",
          "AFFGEOID": "1400000US24510230100",
          "GEOID": "24510230100",
          "NAME": "2301",
          "NAMELSAD": "Census Tract 2301",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 336352,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.620945,
                  39.274549
                ],
                [
                  -76.62013,
                  39.276446
                ],
                [
                  -76.619237,
                  39.278248
                ],
                [
                  -76.618999,
                  39.279052
                ],
                [
                  -76.618821,
                  39.279354
                ],
                [
                  -76.618254,
                  39.279381
                ],
                [
                  -76.616446,
                  39.278919
                ],
                [
                  -76.615689,
                  39.278942
                ],
                [
                  -76.614525,
                  39.278985
                ],
                [
                  -76.614295,
                  39.275772
                ],
                [
                  -76.614159,
                  39.273657
                ],
                [
                  -76.614111,
                  39.272617
                ],
                [
                  -76.615266,
                  39.272582
                ],
                [
                  -76.616111,
                  39.272553
                ],
                [
                  -76.616773,
                  39.272538
                ],
                [
                  -76.618636,
                  39.272459
                ],
                [
                  -76.618719,
                  39.27391
                ],
                [
                  -76.620656,
                  39.274469
                ],
                [
                  -76.620945,
                  39.274549
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "160802",
          "AFFGEOID": "1400000US24510160802",
          "GEOID": "24510160802",
          "NAME": "1608.02",
          "NAMELSAD": "Census Tract 1608.02",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1226587,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.6895,
                  39.304372
                ],
                [
                  -76.689582,
                  39.305099
                ],
                [
                  -76.687081,
                  39.304874
                ],
                [
                  -76.686431,
                  39.305348
                ],
                [
                  -76.686302,
                  39.305506
                ],
                [
                  -76.681565,
                  39.306584
                ],
                [
                  -76.679427,
                  39.305515
                ],
                [
                  -76.678672,
                  39.304768
                ],
                [
                  -76.67421,
                  39.302373
                ],
                [
                  -76.67275,
                  39.297609
                ],
                [
                  -76.670726,
                  39.296354
                ],
                [
                  -76.670465,
                  39.294257
                ],
                [
                  -76.672383,
                  39.294201
                ],
                [
                  -76.67278,
                  39.294174
                ],
                [
                  -76.675574,
                  39.294097
                ],
                [
                  -76.679766,
                  39.293934
                ],
                [
                  -76.680657,
                  39.293903
                ],
                [
                  -76.681211,
                  39.293884
                ],
                [
                  -76.681303,
                  39.295669
                ],
                [
                  -76.681341,
                  39.296407
                ],
                [
                  -76.681429,
                  39.297906
                ],
                [
                  -76.681507,
                  39.29939
                ],
                [
                  -76.681244,
                  39.30045
                ],
                [
                  -76.685791,
                  39.303005
                ],
                [
                  -76.687483,
                  39.302416
                ],
                [
                  -76.687501,
                  39.301894
                ],
                [
                  -76.686292,
                  39.300184
                ],
                [
                  -76.686275,
                  39.299217
                ],
                [
                  -76.688139,
                  39.299172
                ],
                [
                  -76.690092,
                  39.302306
                ],
                [
                  -76.6895,
                  39.304372
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "060400",
          "AFFGEOID": "1400000US24510060400",
          "GEOID": "24510060400",
          "NAME": "604",
          "NAMELSAD": "Census Tract 604",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 430129,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.594408,
                  39.298373
                ],
                [
                  -76.592378,
                  39.298465
                ],
                [
                  -76.590874,
                  39.298524
                ],
                [
                  -76.588713,
                  39.298613
                ],
                [
                  -76.587869,
                  39.298647
                ],
                [
                  -76.58773,
                  39.296519
                ],
                [
                  -76.587706,
                  39.296205
                ],
                [
                  -76.587584,
                  39.294208
                ],
                [
                  -76.587414,
                  39.291813
                ],
                [
                  -76.590468,
                  39.291679
                ],
                [
                  -76.593944,
                  39.291542
                ],
                [
                  -76.594117,
                  39.293968
                ],
                [
                  -76.594179,
                  39.295143
                ],
                [
                  -76.594184,
                  39.295274
                ],
                [
                  -76.594408,
                  39.298373
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "070400",
          "AFFGEOID": "1400000US24510070400",
          "GEOID": "24510070400",
          "NAME": "704",
          "NAMELSAD": "Census Tract 704",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 326989,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.597829,
                  39.301744
                ],
                [
                  -76.594658,
                  39.301881
                ],
                [
                  -76.592464,
                  39.301967
                ],
                [
                  -76.591138,
                  39.302027
                ],
                [
                  -76.588079,
                  39.302138
                ],
                [
                  -76.587936,
                  39.299699
                ],
                [
                  -76.587869,
                  39.298647
                ],
                [
                  -76.588713,
                  39.298613
                ],
                [
                  -76.590874,
                  39.298524
                ],
                [
                  -76.592378,
                  39.298465
                ],
                [
                  -76.594408,
                  39.298373
                ],
                [
                  -76.597597,
                  39.298251
                ],
                [
                  -76.597829,
                  39.301744
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "260501",
          "AFFGEOID": "1400000US24510260501",
          "GEOID": "24510260501",
          "NAME": "2605.01",
          "NAMELSAD": "Census Tract 2605.01",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 3217418,
          "AWATER": 3813
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.554992,
                  39.291911
                ],
                [
                  -76.553828,
                  39.291963
                ],
                [
                  -76.551503,
                  39.292216
                ],
                [
                  -76.547801,
                  39.29576
                ],
                [
                  -76.537271,
                  39.296207
                ],
                [
                  -76.532785,
                  39.295414
                ],
                [
                  -76.531351,
                  39.296057
                ],
                [
                  -76.529517,
                  39.297056
                ],
                [
                  -76.529681,
                  39.288152
                ],
                [
                  -76.529592,
                  39.284852
                ],
                [
                  -76.530393,
                  39.284818
                ],
                [
                  -76.535704,
                  39.281793
                ],
                [
                  -76.540512,
                  39.281573
                ],
                [
                  -76.543805,
                  39.281443
                ],
                [
                  -76.547586,
                  39.281286
                ],
                [
                  -76.550608,
                  39.281172
                ],
                [
                  -76.554581,
                  39.280977
                ],
                [
                  -76.554644,
                  39.282287
                ],
                [
                  -76.5548,
                  39.284053
                ],
                [
                  -76.554922,
                  39.286077
                ],
                [
                  -76.554983,
                  39.287127
                ],
                [
                  -76.554135,
                  39.288054
                ],
                [
                  -76.555724,
                  39.291783
                ],
                [
                  -76.554992,
                  39.291911
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "270702",
          "AFFGEOID": "1400000US24510270702",
          "GEOID": "24510270702",
          "NAME": "2707.02",
          "NAMELSAD": "Census Tract 2707.02",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 837141,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.573563,
                  39.368539
                ],
                [
                  -76.567643,
                  39.368509
                ],
                [
                  -76.567071,
                  39.368301
                ],
                [
                  -76.562615,
                  39.366716
                ],
                [
                  -76.562545,
                  39.366828
                ],
                [
                  -76.55918,
                  39.365669
                ],
                [
                  -76.558206,
                  39.365423
                ],
                [
                  -76.551894,
                  39.363406
                ],
                [
                  -76.553385,
                  39.361697
                ],
                [
                  -76.554173,
                  39.360778
                ],
                [
                  -76.557731,
                  39.356658
                ],
                [
                  -76.557859,
                  39.356511
                ],
                [
                  -76.558607,
                  39.36268
                ],
                [
                  -76.561605,
                  39.362648
                ],
                [
                  -76.562529,
                  39.362991
                ],
                [
                  -76.564453,
                  39.363651
                ],
                [
                  -76.568269,
                  39.364621
                ],
                [
                  -76.569197,
                  39.364566
                ],
                [
                  -76.572298,
                  39.364707
                ],
                [
                  -76.572247,
                  39.365409
                ],
                [
                  -76.573541,
                  39.365126
                ],
                [
                  -76.574048,
                  39.36754
                ],
                [
                  -76.573563,
                  39.368539
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "280102",
          "AFFGEOID": "1400000US24510280102",
          "GEOID": "24510280102",
          "NAME": "2801.02",
          "NAMELSAD": "Census Tract 2801.02",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 3498689,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.711388,
                  39.349496
                ],
                [
                  -76.706441,
                  39.353027
                ],
                [
                  -76.705602,
                  39.3527
                ],
                [
                  -76.699494,
                  39.349551
                ],
                [
                  -76.695316,
                  39.347249
                ],
                [
                  -76.694494,
                  39.34667
                ],
                [
                  -76.692518,
                  39.345564
                ],
                [
                  -76.688966,
                  39.34356
                ],
                [
                  -76.687477,
                  39.342854
                ],
                [
                  -76.682916,
                  39.341435
                ],
                [
                  -76.683477,
                  39.340794
                ],
                [
                  -76.689379,
                  39.340754
                ],
                [
                  -76.689373,
                  39.339732
                ],
                [
                  -76.689362,
                  39.337676
                ],
                [
                  -76.689347,
                  39.336633
                ],
                [
                  -76.689361,
                  39.333977
                ],
                [
                  -76.689675,
                  39.333394
                ],
                [
                  -76.690866,
                  39.331013
                ],
                [
                  -76.688646,
                  39.330431
                ],
                [
                  -76.68858,
                  39.329184
                ],
                [
                  -76.694259,
                  39.33092
                ],
                [
                  -76.695674,
                  39.3314
                ],
                [
                  -76.697086,
                  39.331852
                ],
                [
                  -76.700637,
                  39.332962
                ],
                [
                  -76.703074,
                  39.333732
                ],
                [
                  -76.705367,
                  39.334445
                ],
                [
                  -76.70867,
                  39.335555
                ],
                [
                  -76.709912,
                  39.33599
                ],
                [
                  -76.711025,
                  39.336333
                ],
                [
                  -76.711011,
                  39.336391
                ],
                [
                  -76.711388,
                  39.349496
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "272004",
          "AFFGEOID": "1400000US24510272004",
          "GEOID": "24510272004",
          "NAME": "2720.04",
          "NAMELSAD": "Census Tract 2720.04",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 708925,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.694728,
                  39.36801
                ],
                [
                  -76.6942,
                  39.369634
                ],
                [
                  -76.692496,
                  39.371365
                ],
                [
                  -76.692444,
                  39.372033
                ],
                [
                  -76.683656,
                  39.372028
                ],
                [
                  -76.682343,
                  39.372201
                ],
                [
                  -76.682273,
                  39.370982
                ],
                [
                  -76.682172,
                  39.370525
                ],
                [
                  -76.680807,
                  39.369059
                ],
                [
                  -76.685228,
                  39.36897
                ],
                [
                  -76.685093,
                  39.365505
                ],
                [
                  -76.689003,
                  39.364605
                ],
                [
                  -76.689582,
                  39.36421
                ],
                [
                  -76.69075,
                  39.365684
                ],
                [
                  -76.692191,
                  39.365918
                ],
                [
                  -76.697167,
                  39.364952
                ],
                [
                  -76.694728,
                  39.36801
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "151300",
          "AFFGEOID": "1400000US24510151300",
          "GEOID": "24510151300",
          "NAME": "1513",
          "NAMELSAD": "Census Tract 1513",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 927386,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.677067,
                  39.341134
                ],
                [
                  -76.67671,
                  39.341841
                ],
                [
                  -76.673848,
                  39.341026
                ],
                [
                  -76.668324,
                  39.339392
                ],
                [
                  -76.667926,
                  39.338921
                ],
                [
                  -76.666473,
                  39.339632
                ],
                [
                  -76.66514,
                  39.340336
                ],
                [
                  -76.663952,
                  39.340931
                ],
                [
                  -76.663183,
                  39.340936
                ],
                [
                  -76.661279,
                  39.340698
                ],
                [
                  -76.65841,
                  39.340832
                ],
                [
                  -76.657829,
                  39.339069
                ],
                [
                  -76.656903,
                  39.338201
                ],
                [
                  -76.656604,
                  39.337847
                ],
                [
                  -76.656359,
                  39.336504
                ],
                [
                  -76.656796,
                  39.336399
                ],
                [
                  -76.656856,
                  39.336385
                ],
                [
                  -76.659844,
                  39.335652
                ],
                [
                  -76.662664,
                  39.33451
                ],
                [
                  -76.665061,
                  39.333385
                ],
                [
                  -76.66589,
                  39.332968
                ],
                [
                  -76.666471,
                  39.333761
                ],
                [
                  -76.668475,
                  39.33485
                ],
                [
                  -76.670831,
                  39.335692
                ],
                [
                  -76.67167,
                  39.336104
                ],
                [
                  -76.673019,
                  39.336977
                ],
                [
                  -76.676243,
                  39.339098
                ],
                [
                  -76.677964,
                  39.339925
                ],
                [
                  -76.677067,
                  39.341134
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "230300",
          "AFFGEOID": "1400000US24510230300",
          "GEOID": "24510230300",
          "NAME": "2303",
          "NAMELSAD": "Census Tract 2303",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1312475,
          "AWATER": 711520
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.625654,
                  39.267162
                ],
                [
                  -76.625855,
                  39.268189
                ],
                [
                  -76.624502,
                  39.26861
                ],
                [
                  -76.621815,
                  39.27289
                ],
                [
                  -76.620945,
                  39.274549
                ],
                [
                  -76.620656,
                  39.274469
                ],
                [
                  -76.618719,
                  39.27391
                ],
                [
                  -76.618636,
                  39.272459
                ],
                [
                  -76.616773,
                  39.272538
                ],
                [
                  -76.616111,
                  39.272553
                ],
                [
                  -76.615953,
                  39.270453
                ],
                [
                  -76.611579,
                  39.270613
                ],
                [
                  -76.611922,
                  39.268516
                ],
                [
                  -76.611919,
                  39.267292
                ],
                [
                  -76.611855,
                  39.266951
                ],
                [
                  -76.607303,
                  39.267175
                ],
                [
                  -76.605578,
                  39.267235
                ],
                [
                  -76.606813,
                  39.263865
                ],
                [
                  -76.610626,
                  39.262249
                ],
                [
                  -76.610295,
                  39.25602
                ],
                [
                  -76.610488,
                  39.254706
                ],
                [
                  -76.616437,
                  39.257216
                ],
                [
                  -76.623289,
                  39.260106
                ],
                [
                  -76.623793,
                  39.265075
                ],
                [
                  -76.627205,
                  39.265108
                ],
                [
                  -76.625654,
                  39.267162
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "090700",
          "AFFGEOID": "1400000US24510090700",
          "GEOID": "24510090700",
          "NAME": "907",
          "NAMELSAD": "Census Tract 907",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 435082,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.600574,
                  39.319701
                ],
                [
                  -76.597881,
                  39.32236
                ],
                [
                  -76.596764,
                  39.323456
                ],
                [
                  -76.593929,
                  39.326225
                ],
                [
                  -76.59381,
                  39.325967
                ],
                [
                  -76.593584,
                  39.325271
                ],
                [
                  -76.592814,
                  39.323209
                ],
                [
                  -76.590658,
                  39.321239
                ],
                [
                  -76.591683,
                  39.32026
                ],
                [
                  -76.592821,
                  39.319178
                ],
                [
                  -76.594867,
                  39.317238
                ],
                [
                  -76.597717,
                  39.317922
                ],
                [
                  -76.601489,
                  39.31879
                ],
                [
                  -76.600574,
                  39.319701
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "260202",
          "AFFGEOID": "1400000US24510260202",
          "GEOID": "24510260202",
          "NAME": "2602.02",
          "NAMELSAD": "Census Tract 2602.02",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1044018,
          "AWATER": 1618
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.565965,
                  39.327734
                ],
                [
                  -76.56412,
                  39.329249
                ],
                [
                  -76.561612,
                  39.331095
                ],
                [
                  -76.560908,
                  39.330402
                ],
                [
                  -76.558756,
                  39.328963
                ],
                [
                  -76.555031,
                  39.327677
                ],
                [
                  -76.551788,
                  39.325781
                ],
                [
                  -76.551669,
                  39.325844
                ],
                [
                  -76.548647,
                  39.322535
                ],
                [
                  -76.548442,
                  39.32183
                ],
                [
                  -76.550291,
                  39.321085
                ],
                [
                  -76.553856,
                  39.31867
                ],
                [
                  -76.555024,
                  39.317956
                ],
                [
                  -76.556407,
                  39.320695
                ],
                [
                  -76.557686,
                  39.321426
                ],
                [
                  -76.559759,
                  39.320994
                ],
                [
                  -76.560491,
                  39.321176
                ],
                [
                  -76.561433,
                  39.323472
                ],
                [
                  -76.562605,
                  39.32467
                ],
                [
                  -76.565589,
                  39.325222
                ],
                [
                  -76.567543,
                  39.326406
                ],
                [
                  -76.565965,
                  39.327734
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "180300",
          "AFFGEOID": "1400000US24510180300",
          "GEOID": "24510180300",
          "NAME": "1803",
          "NAMELSAD": "Census Tract 1803",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 289563,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.638166,
                  39.288566
                ],
                [
                  -76.63381,
                  39.288766
                ],
                [
                  -76.632149,
                  39.288838
                ],
                [
                  -76.628909,
                  39.288992
                ],
                [
                  -76.627766,
                  39.288974
                ],
                [
                  -76.628062,
                  39.287786
                ],
                [
                  -76.628021,
                  39.287165
                ],
                [
                  -76.627539,
                  39.286057
                ],
                [
                  -76.62786,
                  39.286046
                ],
                [
                  -76.629019,
                  39.286009
                ],
                [
                  -76.630025,
                  39.285965
                ],
                [
                  -76.630532,
                  39.285937
                ],
                [
                  -76.631959,
                  39.285866
                ],
                [
                  -76.637984,
                  39.285587
                ],
                [
                  -76.638101,
                  39.287556
                ],
                [
                  -76.638166,
                  39.288566
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "250103",
          "AFFGEOID": "1400000US24510250103",
          "GEOID": "24510250103",
          "NAME": "2501.03",
          "NAMELSAD": "Census Tract 2501.03",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 2587957,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.698892,
                  39.272705
                ],
                [
                  -76.695371,
                  39.27191
                ],
                [
                  -76.69268,
                  39.271824
                ],
                [
                  -76.689454,
                  39.272116
                ],
                [
                  -76.688192,
                  39.274505
                ],
                [
                  -76.683581,
                  39.276569
                ],
                [
                  -76.681673,
                  39.276998
                ],
                [
                  -76.679977,
                  39.27716
                ],
                [
                  -76.676677,
                  39.274385
                ],
                [
                  -76.675482,
                  39.274183
                ],
                [
                  -76.671563,
                  39.275933
                ],
                [
                  -76.671489,
                  39.273887
                ],
                [
                  -76.669689,
                  39.270672
                ],
                [
                  -76.668788,
                  39.26943
                ],
                [
                  -76.667055,
                  39.265971
                ],
                [
                  -76.664882,
                  39.260554
                ],
                [
                  -76.664247,
                  39.25851
                ],
                [
                  -76.664322,
                  39.257442
                ],
                [
                  -76.667349,
                  39.258858
                ],
                [
                  -76.673139,
                  39.261155
                ],
                [
                  -76.676777,
                  39.263004
                ],
                [
                  -76.677191,
                  39.263305
                ],
                [
                  -76.678801,
                  39.263997
                ],
                [
                  -76.680025,
                  39.264413
                ],
                [
                  -76.683541,
                  39.265862
                ],
                [
                  -76.684649,
                  39.266458
                ],
                [
                  -76.686048,
                  39.266885
                ],
                [
                  -76.688634,
                  39.268178
                ],
                [
                  -76.691868,
                  39.269595
                ],
                [
                  -76.695676,
                  39.271222
                ],
                [
                  -76.696793,
                  39.271861
                ],
                [
                  -76.698892,
                  39.272705
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "270703",
          "AFFGEOID": "1400000US24510270703",
          "GEOID": "24510270703",
          "NAME": "2707.03",
          "NAMELSAD": "Census Tract 2707.03",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 993947,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.561919,
                  39.367889
                ],
                [
                  -76.561788,
                  39.372205
                ],
                [
                  -76.553749,
                  39.37207
                ],
                [
                  -76.549357,
                  39.372067
                ],
                [
                  -76.545145,
                  39.372104
                ],
                [
                  -76.544243,
                  39.372181
                ],
                [
                  -76.547824,
                  39.36807
                ],
                [
                  -76.548423,
                  39.367386
                ],
                [
                  -76.551464,
                  39.363897
                ],
                [
                  -76.551894,
                  39.363406
                ],
                [
                  -76.558206,
                  39.365423
                ],
                [
                  -76.55918,
                  39.365669
                ],
                [
                  -76.562545,
                  39.366828
                ],
                [
                  -76.561919,
                  39.367889
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "270903",
          "AFFGEOID": "1400000US24510270903",
          "GEOID": "24510270903",
          "NAME": "2709.03",
          "NAMELSAD": "Census Tract 2709.03",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1089334,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.599935,
                  39.342743
                ],
                [
                  -76.599868,
                  39.344253
                ],
                [
                  -76.599729,
                  39.345149
                ],
                [
                  -76.597097,
                  39.344893
                ],
                [
                  -76.595891,
                  39.345008
                ],
                [
                  -76.595458,
                  39.345174
                ],
                [
                  -76.593567,
                  39.346021
                ],
                [
                  -76.592247,
                  39.346162
                ],
                [
                  -76.592006,
                  39.346163
                ],
                [
                  -76.589323,
                  39.346058
                ],
                [
                  -76.586178,
                  39.345856
                ],
                [
                  -76.585947,
                  39.345863
                ],
                [
                  -76.583517,
                  39.345893
                ],
                [
                  -76.580805,
                  39.345277
                ],
                [
                  -76.581539,
                  39.341919
                ],
                [
                  -76.579257,
                  39.341568
                ],
                [
                  -76.576952,
                  39.338625
                ],
                [
                  -76.578519,
                  39.339612
                ],
                [
                  -76.58094,
                  39.340342
                ],
                [
                  -76.583586,
                  39.340451
                ],
                [
                  -76.587836,
                  39.339955
                ],
                [
                  -76.588017,
                  39.339978
                ],
                [
                  -76.592049,
                  39.340158
                ],
                [
                  -76.593995,
                  39.339774
                ],
                [
                  -76.596794,
                  39.339082
                ],
                [
                  -76.600211,
                  39.340064
                ],
                [
                  -76.599935,
                  39.342743
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "010100",
          "AFFGEOID": "1400000US24510010100",
          "GEOID": "24510010100",
          "NAME": "101",
          "NAMELSAD": "Census Tract 101",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 393198,
          "AWATER": 148387
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.576147,
                  39.276733
                ],
                [
                  -76.575615,
                  39.277213
                ],
                [
                  -76.575321,
                  39.278216
                ],
                [
                  -76.57674,
                  39.278534
                ],
                [
                  -76.576864,
                  39.28028
                ],
                [
                  -76.57698,
                  39.282175
                ],
                [
                  -76.577043,
                  39.28321
                ],
                [
                  -76.57709,
                  39.284207
                ],
                [
                  -76.572821,
                  39.284364
                ],
                [
                  -76.571396,
                  39.284423
                ],
                [
                  -76.571339,
                  39.283407
                ],
                [
                  -76.571261,
                  39.282382
                ],
                [
                  -76.571151,
                  39.280366
                ],
                [
                  -76.571008,
                  39.278337
                ],
                [
                  -76.570978,
                  39.276345
                ],
                [
                  -76.571987,
                  39.275406
                ],
                [
                  -76.572687,
                  39.275007
                ],
                [
                  -76.577586,
                  39.271606
                ],
                [
                  -76.576147,
                  39.276733
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "160600",
          "AFFGEOID": "1400000US24510160600",
          "GEOID": "24510160600",
          "NAME": "1606",
          "NAMELSAD": "Census Tract 1606",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 556403,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.669245,
                  39.296623
                ],
                [
                  -76.668954,
                  39.297189
                ],
                [
                  -76.668949,
                  39.299182
                ],
                [
                  -76.668983,
                  39.29929
                ],
                [
                  -76.667641,
                  39.29941
                ],
                [
                  -76.665187,
                  39.29921
                ],
                [
                  -76.665271,
                  39.300283
                ],
                [
                  -76.660824,
                  39.300451
                ],
                [
                  -76.660603,
                  39.299796
                ],
                [
                  -76.659589,
                  39.298339
                ],
                [
                  -76.659518,
                  39.296469
                ],
                [
                  -76.659431,
                  39.294983
                ],
                [
                  -76.659412,
                  39.294633
                ],
                [
                  -76.659353,
                  39.293352
                ],
                [
                  -76.661351,
                  39.293259
                ],
                [
                  -76.664895,
                  39.293936
                ],
                [
                  -76.664927,
                  39.294452
                ],
                [
                  -76.666711,
                  39.294412
                ],
                [
                  -76.668664,
                  39.294325
                ],
                [
                  -76.669717,
                  39.294276
                ],
                [
                  -76.669245,
                  39.296623
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "120100",
          "AFFGEOID": "1400000US24510120100",
          "GEOID": "24510120100",
          "NAME": "1201",
          "NAMELSAD": "Census Tract 1201",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1036127,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.625785,
                  39.341591
                ],
                [
                  -76.622849,
                  39.340659
                ],
                [
                  -76.621404,
                  39.341089
                ],
                [
                  -76.620426,
                  39.340469
                ],
                [
                  -76.618401,
                  39.339254
                ],
                [
                  -76.618363,
                  39.338531
                ],
                [
                  -76.616574,
                  39.338842
                ],
                [
                  -76.61466,
                  39.33954
                ],
                [
                  -76.613276,
                  39.340278
                ],
                [
                  -76.612288,
                  39.340963
                ],
                [
                  -76.610776,
                  39.340043
                ],
                [
                  -76.60958,
                  39.339798
                ],
                [
                  -76.609533,
                  39.338665
                ],
                [
                  -76.609516,
                  39.336395
                ],
                [
                  -76.609508,
                  39.334456
                ],
                [
                  -76.609476,
                  39.330965
                ],
                [
                  -76.614979,
                  39.332664
                ],
                [
                  -76.616221,
                  39.331527
                ],
                [
                  -76.616273,
                  39.331473
                ],
                [
                  -76.617978,
                  39.33248
                ],
                [
                  -76.62317,
                  39.335925
                ],
                [
                  -76.624024,
                  39.336479
                ],
                [
                  -76.625744,
                  39.339604
                ],
                [
                  -76.625785,
                  39.341591
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "280301",
          "AFFGEOID": "1400000US24510280301",
          "GEOID": "24510280301",
          "NAME": "2803.01",
          "NAMELSAD": "Census Tract 2803.01",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 3160921,
          "AWATER": 20250
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.711493,
                  39.320805
                ],
                [
                  -76.708393,
                  39.321805
                ],
                [
                  -76.704518,
                  39.322023
                ],
                [
                  -76.70177,
                  39.319596
                ],
                [
                  -76.703947,
                  39.318582
                ],
                [
                  -76.702045,
                  39.315702
                ],
                [
                  -76.700037,
                  39.317043
                ],
                [
                  -76.697315,
                  39.317414
                ],
                [
                  -76.696412,
                  39.314793
                ],
                [
                  -76.692676,
                  39.314446
                ],
                [
                  -76.690004,
                  39.312386
                ],
                [
                  -76.69036,
                  39.309557
                ],
                [
                  -76.689039,
                  39.307783
                ],
                [
                  -76.687203,
                  39.305491
                ],
                [
                  -76.686431,
                  39.305348
                ],
                [
                  -76.687081,
                  39.304874
                ],
                [
                  -76.689582,
                  39.305099
                ],
                [
                  -76.694509,
                  39.304737
                ],
                [
                  -76.694866,
                  39.302016
                ],
                [
                  -76.697979,
                  39.301403
                ],
                [
                  -76.701021,
                  39.301548
                ],
                [
                  -76.703122,
                  39.299745
                ],
                [
                  -76.706178,
                  39.299673
                ],
                [
                  -76.706482,
                  39.301093
                ],
                [
                  -76.705413,
                  39.302238
                ],
                [
                  -76.708403,
                  39.303395
                ],
                [
                  -76.711191,
                  39.302955
                ],
                [
                  -76.711185,
                  39.303409
                ],
                [
                  -76.711208,
                  39.304828
                ],
                [
                  -76.711228,
                  39.311709
                ],
                [
                  -76.711119,
                  39.312475
                ],
                [
                  -76.711028,
                  39.318916
                ],
                [
                  -76.711493,
                  39.320805
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "090200",
          "AFFGEOID": "1400000US24510090200",
          "GEOID": "24510090200",
          "NAME": "902",
          "NAMELSAD": "Census Tract 902",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1738449,
          "AWATER": 288605
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.600211,
                  39.340064
                ],
                [
                  -76.596794,
                  39.339082
                ],
                [
                  -76.593995,
                  39.339774
                ],
                [
                  -76.592049,
                  39.340158
                ],
                [
                  -76.588017,
                  39.339978
                ],
                [
                  -76.587836,
                  39.339955
                ],
                [
                  -76.583586,
                  39.340451
                ],
                [
                  -76.58094,
                  39.340342
                ],
                [
                  -76.578519,
                  39.339612
                ],
                [
                  -76.576952,
                  39.338625
                ],
                [
                  -76.578427,
                  39.335492
                ],
                [
                  -76.576547,
                  39.333861
                ],
                [
                  -76.578105,
                  39.332461
                ],
                [
                  -76.579515,
                  39.331409
                ],
                [
                  -76.580342,
                  39.330907
                ],
                [
                  -76.580827,
                  39.330558
                ],
                [
                  -76.581792,
                  39.329725
                ],
                [
                  -76.583702,
                  39.328021
                ],
                [
                  -76.584576,
                  39.327047
                ],
                [
                  -76.585153,
                  39.327308
                ],
                [
                  -76.589334,
                  39.327297
                ],
                [
                  -76.589311,
                  39.328364
                ],
                [
                  -76.595145,
                  39.328347
                ],
                [
                  -76.595115,
                  39.330136
                ],
                [
                  -76.595159,
                  39.333147
                ],
                [
                  -76.595443,
                  39.33403
                ],
                [
                  -76.599439,
                  39.337964
                ],
                [
                  -76.600132,
                  39.33924
                ],
                [
                  -76.600211,
                  39.340064
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "150400",
          "AFFGEOID": "1400000US24510150400",
          "GEOID": "24510150400",
          "NAME": "1504",
          "NAMELSAD": "Census Tract 1504",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 815573,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.659625,
                  39.314451
                ],
                [
                  -76.659779,
                  39.315224
                ],
                [
                  -76.657701,
                  39.315812
                ],
                [
                  -76.651958,
                  39.315746
                ],
                [
                  -76.650494,
                  39.316704
                ],
                [
                  -76.649115,
                  39.315543
                ],
                [
                  -76.648725,
                  39.315225
                ],
                [
                  -76.646316,
                  39.313248
                ],
                [
                  -76.645408,
                  39.312515
                ],
                [
                  -76.642514,
                  39.310089
                ],
                [
                  -76.645006,
                  39.309944
                ],
                [
                  -76.646496,
                  39.30989
                ],
                [
                  -76.651339,
                  39.30968
                ],
                [
                  -76.652712,
                  39.309613
                ],
                [
                  -76.65413,
                  39.309567
                ],
                [
                  -76.655994,
                  39.309508
                ],
                [
                  -76.659985,
                  39.309368
                ],
                [
                  -76.659625,
                  39.314451
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "272005",
          "AFFGEOID": "1400000US24510272005",
          "GEOID": "24510272005",
          "NAME": "2720.05",
          "NAMELSAD": "Census Tract 2720.05",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 927829,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.711313,
                  39.371933
                ],
                [
                  -76.705204,
                  39.372007
                ],
                [
                  -76.702892,
                  39.372092
                ],
                [
                  -76.700106,
                  39.372005
                ],
                [
                  -76.697454,
                  39.372011
                ],
                [
                  -76.692444,
                  39.372033
                ],
                [
                  -76.692496,
                  39.371365
                ],
                [
                  -76.6942,
                  39.369634
                ],
                [
                  -76.694728,
                  39.36801
                ],
                [
                  -76.697167,
                  39.364952
                ],
                [
                  -76.698246,
                  39.363623
                ],
                [
                  -76.699798,
                  39.362363
                ],
                [
                  -76.701481,
                  39.363732
                ],
                [
                  -76.702834,
                  39.364819
                ],
                [
                  -76.706869,
                  39.368097
                ],
                [
                  -76.711313,
                  39.371933
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "130806",
          "AFFGEOID": "1400000US24510130806",
          "GEOID": "24510130806",
          "NAME": "1308.06",
          "NAMELSAD": "Census Tract 1308.06",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1406474,
          "AWATER": 707
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.658181,
                  39.340866
                ],
                [
                  -76.656798,
                  39.34149
                ],
                [
                  -76.655484,
                  39.341854
                ],
                [
                  -76.654396,
                  39.342125
                ],
                [
                  -76.650654,
                  39.344798
                ],
                [
                  -76.64814,
                  39.345128
                ],
                [
                  -76.647222,
                  39.345243
                ],
                [
                  -76.647767,
                  39.339615
                ],
                [
                  -76.647326,
                  39.33837
                ],
                [
                  -76.644627,
                  39.334753
                ],
                [
                  -76.643234,
                  39.332892
                ],
                [
                  -76.642269,
                  39.331922
                ],
                [
                  -76.641929,
                  39.331495
                ],
                [
                  -76.640528,
                  39.327216
                ],
                [
                  -76.641762,
                  39.327965
                ],
                [
                  -76.642788,
                  39.329658
                ],
                [
                  -76.644891,
                  39.330905
                ],
                [
                  -76.646191,
                  39.329905
                ],
                [
                  -76.651891,
                  39.331051
                ],
                [
                  -76.654032,
                  39.330291
                ],
                [
                  -76.654092,
                  39.330397
                ],
                [
                  -76.655735,
                  39.333053
                ],
                [
                  -76.655964,
                  39.333549
                ],
                [
                  -76.655937,
                  39.334611
                ],
                [
                  -76.656359,
                  39.336504
                ],
                [
                  -76.656604,
                  39.337847
                ],
                [
                  -76.656903,
                  39.338201
                ],
                [
                  -76.657829,
                  39.339069
                ],
                [
                  -76.65841,
                  39.340832
                ],
                [
                  -76.658181,
                  39.340866
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "020200",
          "AFFGEOID": "1400000US24510020200",
          "GEOID": "24510020200",
          "NAME": "202",
          "NAMELSAD": "Census Tract 202",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 197559,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.593944,
                  39.291542
                ],
                [
                  -76.590468,
                  39.291679
                ],
                [
                  -76.590344,
                  39.289387
                ],
                [
                  -76.590113,
                  39.285735
                ],
                [
                  -76.593557,
                  39.285578
                ],
                [
                  -76.593638,
                  39.286609
                ],
                [
                  -76.593803,
                  39.289257
                ],
                [
                  -76.593869,
                  39.290399
                ],
                [
                  -76.593944,
                  39.291542
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "100100",
          "AFFGEOID": "1400000US24510100100",
          "GEOID": "24510100100",
          "NAME": "1001",
          "NAMELSAD": "Census Tract 1001",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 453808,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.611594,
                  39.302534
                ],
                [
                  -76.611516,
                  39.303603
                ],
                [
                  -76.61135,
                  39.304715
                ],
                [
                  -76.611208,
                  39.304718
                ],
                [
                  -76.608199,
                  39.304839
                ],
                [
                  -76.605118,
                  39.304964
                ],
                [
                  -76.603627,
                  39.305018
                ],
                [
                  -76.600021,
                  39.305157
                ],
                [
                  -76.598069,
                  39.305222
                ],
                [
                  -76.59792,
                  39.303106
                ],
                [
                  -76.597829,
                  39.301744
                ],
                [
                  -76.59937,
                  39.301682
                ],
                [
                  -76.600316,
                  39.301659
                ],
                [
                  -76.604906,
                  39.301491
                ],
                [
                  -76.606389,
                  39.301414
                ],
                [
                  -76.607269,
                  39.301361
                ],
                [
                  -76.61096,
                  39.301248
                ],
                [
                  -76.611551,
                  39.301224
                ],
                [
                  -76.611594,
                  39.302534
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "271802",
          "AFFGEOID": "1400000US24510271802",
          "GEOID": "24510271802",
          "NAME": "2718.02",
          "NAMELSAD": "Census Tract 2718.02",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 530270,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.683519,
                  39.34294
                ],
                [
                  -76.6808,
                  39.345951
                ],
                [
                  -76.679601,
                  39.346735
                ],
                [
                  -76.67936,
                  39.34689
                ],
                [
                  -76.67596,
                  39.349028
                ],
                [
                  -76.674733,
                  39.348372
                ],
                [
                  -76.673489,
                  39.347471
                ],
                [
                  -76.672669,
                  39.346575
                ],
                [
                  -76.671397,
                  39.345195
                ],
                [
                  -76.672386,
                  39.344643
                ],
                [
                  -76.672549,
                  39.344261
                ],
                [
                  -76.673848,
                  39.341026
                ],
                [
                  -76.67671,
                  39.341841
                ],
                [
                  -76.677745,
                  39.342136
                ],
                [
                  -76.678216,
                  39.342237
                ],
                [
                  -76.680993,
                  39.341688
                ],
                [
                  -76.683519,
                  39.34294
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "130600",
          "AFFGEOID": "1400000US24510130600",
          "GEOID": "24510130600",
          "NAME": "1306",
          "NAMELSAD": "Census Tract 1306",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 872125,
          "AWATER": 3815
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.635446,
                  39.332613
                ],
                [
                  -76.632791,
                  39.332743
                ],
                [
                  -76.631359,
                  39.332814
                ],
                [
                  -76.631254,
                  39.331172
                ],
                [
                  -76.6294,
                  39.331253
                ],
                [
                  -76.628029,
                  39.331301
                ],
                [
                  -76.626759,
                  39.33133
                ],
                [
                  -76.625917,
                  39.331158
                ],
                [
                  -76.624973,
                  39.327824
                ],
                [
                  -76.625348,
                  39.326224
                ],
                [
                  -76.626023,
                  39.325336
                ],
                [
                  -76.626132,
                  39.323849
                ],
                [
                  -76.626177,
                  39.320843
                ],
                [
                  -76.626752,
                  39.320889
                ],
                [
                  -76.628527,
                  39.319273
                ],
                [
                  -76.629201,
                  39.318733
                ],
                [
                  -76.629888,
                  39.318154
                ],
                [
                  -76.632701,
                  39.323496
                ],
                [
                  -76.6343,
                  39.324737
                ],
                [
                  -76.633998,
                  39.325174
                ],
                [
                  -76.633781,
                  39.325413
                ],
                [
                  -76.633653,
                  39.325568
                ],
                [
                  -76.633125,
                  39.326472
                ],
                [
                  -76.635446,
                  39.332613
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "120700",
          "AFFGEOID": "1400000US24510120700",
          "GEOID": "24510120700",
          "NAME": "1207",
          "NAMELSAD": "Census Tract 1207",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1034427,
          "AWATER": 9367
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.629888,
                  39.318154
                ],
                [
                  -76.629201,
                  39.318733
                ],
                [
                  -76.628527,
                  39.319273
                ],
                [
                  -76.626752,
                  39.320889
                ],
                [
                  -76.626177,
                  39.320843
                ],
                [
                  -76.626132,
                  39.323849
                ],
                [
                  -76.626023,
                  39.325336
                ],
                [
                  -76.625348,
                  39.326224
                ],
                [
                  -76.62291,
                  39.326262
                ],
                [
                  -76.620553,
                  39.324687
                ],
                [
                  -76.620114,
                  39.323152
                ],
                [
                  -76.619958,
                  39.321816
                ],
                [
                  -76.619908,
                  39.320531
                ],
                [
                  -76.619628,
                  39.316256
                ],
                [
                  -76.619559,
                  39.315159
                ],
                [
                  -76.619462,
                  39.313127
                ],
                [
                  -76.619351,
                  39.311729
                ],
                [
                  -76.619354,
                  39.310956
                ],
                [
                  -76.620221,
                  39.310945
                ],
                [
                  -76.623277,
                  39.310848
                ],
                [
                  -76.625574,
                  39.312345
                ],
                [
                  -76.627862,
                  39.314749
                ],
                [
                  -76.628466,
                  39.3154
                ],
                [
                  -76.62943,
                  39.317081
                ],
                [
                  -76.629888,
                  39.318154
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "270805",
          "AFFGEOID": "1400000US24510270805",
          "GEOID": "24510270805",
          "NAME": "2708.05",
          "NAMELSAD": "Census Tract 2708.05",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1248265,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.610005,
                  39.358549
                ],
                [
                  -76.609998,
                  39.364123
                ],
                [
                  -76.609985,
                  39.365126
                ],
                [
                  -76.608656,
                  39.365059
                ],
                [
                  -76.607244,
                  39.364853
                ],
                [
                  -76.605527,
                  39.36458
                ],
                [
                  -76.60296,
                  39.36502
                ],
                [
                  -76.599283,
                  39.365912
                ],
                [
                  -76.597883,
                  39.36314
                ],
                [
                  -76.598102,
                  39.359909
                ],
                [
                  -76.597752,
                  39.358535
                ],
                [
                  -76.595934,
                  39.356557
                ],
                [
                  -76.595172,
                  39.355519
                ],
                [
                  -76.594666,
                  39.354075
                ],
                [
                  -76.595733,
                  39.354022
                ],
                [
                  -76.596944,
                  39.354001
                ],
                [
                  -76.598289,
                  39.354166
                ],
                [
                  -76.602334,
                  39.354711
                ],
                [
                  -76.607685,
                  39.355274
                ],
                [
                  -76.609953,
                  39.355503
                ],
                [
                  -76.60997,
                  39.356525
                ],
                [
                  -76.610001,
                  39.358417
                ],
                [
                  -76.610005,
                  39.358549
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "200701",
          "AFFGEOID": "1400000US24510200701",
          "GEOID": "24510200701",
          "NAME": "2007.01",
          "NAMELSAD": "Census Tract 2007.01",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1203683,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.689425,
                  39.293581
                ],
                [
                  -76.685995,
                  39.293711
                ],
                [
                  -76.681211,
                  39.293884
                ],
                [
                  -76.680657,
                  39.293903
                ],
                [
                  -76.679766,
                  39.293934
                ],
                [
                  -76.675574,
                  39.294097
                ],
                [
                  -76.67278,
                  39.294174
                ],
                [
                  -76.67257,
                  39.290681
                ],
                [
                  -76.672573,
                  39.2906
                ],
                [
                  -76.67255,
                  39.28979
                ],
                [
                  -76.672341,
                  39.286403
                ],
                [
                  -76.672316,
                  39.285832
                ],
                [
                  -76.672982,
                  39.285805
                ],
                [
                  -76.67569,
                  39.28774
                ],
                [
                  -76.676279,
                  39.288107
                ],
                [
                  -76.676368,
                  39.288165
                ],
                [
                  -76.680813,
                  39.284149
                ],
                [
                  -76.681447,
                  39.284242
                ],
                [
                  -76.686776,
                  39.287229
                ],
                [
                  -76.687874,
                  39.287664
                ],
                [
                  -76.688925,
                  39.288204
                ],
                [
                  -76.689425,
                  39.293581
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "200702",
          "AFFGEOID": "1400000US24510200702",
          "GEOID": "24510200702",
          "NAME": "2007.02",
          "NAMELSAD": "Census Tract 2007.02",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 288171,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.676368,
                  39.288165
                ],
                [
                  -76.676279,
                  39.288107
                ],
                [
                  -76.67569,
                  39.28774
                ],
                [
                  -76.672982,
                  39.285805
                ],
                [
                  -76.672316,
                  39.285832
                ],
                [
                  -76.672275,
                  39.28486
                ],
                [
                  -76.672167,
                  39.281087
                ],
                [
                  -76.676208,
                  39.283123
                ],
                [
                  -76.680813,
                  39.284149
                ],
                [
                  -76.676368,
                  39.288165
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "160500",
          "AFFGEOID": "1400000US24510160500",
          "GEOID": "24510160500",
          "NAME": "1605",
          "NAMELSAD": "Census Tract 1605",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1048118,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.660898,
                  39.306144
                ],
                [
                  -76.659038,
                  39.306252
                ],
                [
                  -76.657936,
                  39.305372
                ],
                [
                  -76.653788,
                  39.303909
                ],
                [
                  -76.651607,
                  39.30335
                ],
                [
                  -76.649841,
                  39.303102
                ],
                [
                  -76.64865,
                  39.302917
                ],
                [
                  -76.647717,
                  39.302305
                ],
                [
                  -76.649479,
                  39.301595
                ],
                [
                  -76.650177,
                  39.30107
                ],
                [
                  -76.650905,
                  39.300165
                ],
                [
                  -76.651354,
                  39.298638
                ],
                [
                  -76.650607,
                  39.298663
                ],
                [
                  -76.65057,
                  39.297255
                ],
                [
                  -76.650518,
                  39.296353
                ],
                [
                  -76.650477,
                  39.295072
                ],
                [
                  -76.650383,
                  39.293698
                ],
                [
                  -76.656274,
                  39.293439
                ],
                [
                  -76.659353,
                  39.293352
                ],
                [
                  -76.659412,
                  39.294633
                ],
                [
                  -76.659431,
                  39.294983
                ],
                [
                  -76.659518,
                  39.296469
                ],
                [
                  -76.659589,
                  39.298339
                ],
                [
                  -76.660603,
                  39.299796
                ],
                [
                  -76.660824,
                  39.300451
                ],
                [
                  -76.660868,
                  39.301542
                ],
                [
                  -76.660721,
                  39.302624
                ],
                [
                  -76.660829,
                  39.303078
                ],
                [
                  -76.660898,
                  39.306144
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "271700",
          "AFFGEOID": "1400000US24510271700",
          "GEOID": "24510271700",
          "NAME": "2717",
          "NAMELSAD": "Census Tract 2717",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1734101,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.683358,
                  39.351757
                ],
                [
                  -76.678871,
                  39.354136
                ],
                [
                  -76.676277,
                  39.355221
                ],
                [
                  -76.675185,
                  39.355677
                ],
                [
                  -76.672581,
                  39.356749
                ],
                [
                  -76.670774,
                  39.356482
                ],
                [
                  -76.670817,
                  39.356633
                ],
                [
                  -76.670848,
                  39.356788
                ],
                [
                  -76.665964,
                  39.357613
                ],
                [
                  -76.66413,
                  39.355769
                ],
                [
                  -76.662208,
                  39.355033
                ],
                [
                  -76.660408,
                  39.355193
                ],
                [
                  -76.659604,
                  39.350934
                ],
                [
                  -76.659428,
                  39.349958
                ],
                [
                  -76.659133,
                  39.347887
                ],
                [
                  -76.659447,
                  39.346506
                ],
                [
                  -76.660418,
                  39.346594
                ],
                [
                  -76.661894,
                  39.346719
                ],
                [
                  -76.665551,
                  39.346678
                ],
                [
                  -76.668784,
                  39.346607
                ],
                [
                  -76.668919,
                  39.346591
                ],
                [
                  -76.671397,
                  39.345195
                ],
                [
                  -76.672669,
                  39.346575
                ],
                [
                  -76.673489,
                  39.347471
                ],
                [
                  -76.674733,
                  39.348372
                ],
                [
                  -76.67596,
                  39.349028
                ],
                [
                  -76.681322,
                  39.350604
                ],
                [
                  -76.683358,
                  39.351757
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "270600",
          "AFFGEOID": "1400000US24510270600",
          "GEOID": "24510270600",
          "NAME": "2706",
          "NAMELSAD": "Census Tract 2706",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1553593,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.573541,
                  39.365126
                ],
                [
                  -76.572247,
                  39.365409
                ],
                [
                  -76.572298,
                  39.364707
                ],
                [
                  -76.569197,
                  39.364566
                ],
                [
                  -76.568269,
                  39.364621
                ],
                [
                  -76.564453,
                  39.363651
                ],
                [
                  -76.562529,
                  39.362991
                ],
                [
                  -76.561605,
                  39.362648
                ],
                [
                  -76.558607,
                  39.36268
                ],
                [
                  -76.557859,
                  39.356511
                ],
                [
                  -76.55917,
                  39.354999
                ],
                [
                  -76.55986,
                  39.354183
                ],
                [
                  -76.560608,
                  39.353305
                ],
                [
                  -76.561603,
                  39.352177
                ],
                [
                  -76.56249,
                  39.35115
                ],
                [
                  -76.563355,
                  39.350138
                ],
                [
                  -76.565726,
                  39.352393
                ],
                [
                  -76.566612,
                  39.352787
                ],
                [
                  -76.568117,
                  39.353064
                ],
                [
                  -76.569183,
                  39.353248
                ],
                [
                  -76.570315,
                  39.353439
                ],
                [
                  -76.572549,
                  39.353808
                ],
                [
                  -76.573015,
                  39.353903
                ],
                [
                  -76.573117,
                  39.355529
                ],
                [
                  -76.572926,
                  39.357037
                ],
                [
                  -76.5734,
                  39.358011
                ],
                [
                  -76.573084,
                  39.36009
                ],
                [
                  -76.573541,
                  39.365126
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "080200",
          "AFFGEOID": "1400000US24510080200",
          "GEOID": "24510080200",
          "NAME": "802",
          "NAMELSAD": "Census Tract 802",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 856268,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.590619,
                  39.315073
                ],
                [
                  -76.589881,
                  39.316123
                ],
                [
                  -76.585062,
                  39.314926
                ],
                [
                  -76.581813,
                  39.314553
                ],
                [
                  -76.582164,
                  39.314243
                ],
                [
                  -76.573145,
                  39.314316
                ],
                [
                  -76.573046,
                  39.309338
                ],
                [
                  -76.575875,
                  39.309241
                ],
                [
                  -76.580103,
                  39.30906
                ],
                [
                  -76.582908,
                  39.308978
                ],
                [
                  -76.584365,
                  39.308929
                ],
                [
                  -76.585764,
                  39.308887
                ],
                [
                  -76.587394,
                  39.30885
                ],
                [
                  -76.588507,
                  39.308679
                ],
                [
                  -76.588483,
                  39.308805
                ],
                [
                  -76.588617,
                  39.310903
                ],
                [
                  -76.588692,
                  39.312419
                ],
                [
                  -76.588812,
                  39.314343
                ],
                [
                  -76.59057,
                  39.314304
                ],
                [
                  -76.590619,
                  39.315073
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "270401",
          "AFFGEOID": "1400000US24510270401",
          "GEOID": "24510270401",
          "NAME": "2704.01",
          "NAMELSAD": "Census Tract 2704.01",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1457277,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.558147,
                  39.345185
                ],
                [
                  -76.554682,
                  39.346922
                ],
                [
                  -76.552096,
                  39.34742
                ],
                [
                  -76.551134,
                  39.347743
                ],
                [
                  -76.54875,
                  39.348912
                ],
                [
                  -76.545591,
                  39.350384
                ],
                [
                  -76.543198,
                  39.351548
                ],
                [
                  -76.542666,
                  39.353531
                ],
                [
                  -76.540381,
                  39.353638
                ],
                [
                  -76.5403,
                  39.353628
                ],
                [
                  -76.537116,
                  39.352742
                ],
                [
                  -76.535667,
                  39.351832
                ],
                [
                  -76.534763,
                  39.351196
                ],
                [
                  -76.536321,
                  39.349793
                ],
                [
                  -76.538996,
                  39.34741
                ],
                [
                  -76.541004,
                  39.345612
                ],
                [
                  -76.543673,
                  39.343707
                ],
                [
                  -76.544006,
                  39.34347
                ],
                [
                  -76.544753,
                  39.342946
                ],
                [
                  -76.545574,
                  39.342364
                ],
                [
                  -76.547409,
                  39.341103
                ],
                [
                  -76.54808,
                  39.3406
                ],
                [
                  -76.55166,
                  39.338122
                ],
                [
                  -76.552441,
                  39.337614
                ],
                [
                  -76.553285,
                  39.339229
                ],
                [
                  -76.554799,
                  39.341218
                ],
                [
                  -76.555376,
                  39.34192
                ],
                [
                  -76.556947,
                  39.343776
                ],
                [
                  -76.558147,
                  39.345185
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "260402",
          "AFFGEOID": "1400000US24510260402",
          "GEOID": "24510260402",
          "NAME": "2604.02",
          "NAMELSAD": "Census Tract 2604.02",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1338498,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.549349,
                  39.31374
                ],
                [
                  -76.548938,
                  39.315888
                ],
                [
                  -76.548136,
                  39.316256
                ],
                [
                  -76.545847,
                  39.31762
                ],
                [
                  -76.540459,
                  39.321218
                ],
                [
                  -76.536023,
                  39.326705
                ],
                [
                  -76.534104,
                  39.328295
                ],
                [
                  -76.533806,
                  39.327792
                ],
                [
                  -76.53241,
                  39.324568
                ],
                [
                  -76.534414,
                  39.322306
                ],
                [
                  -76.535294,
                  39.317681
                ],
                [
                  -76.538793,
                  39.314253
                ],
                [
                  -76.540029,
                  39.312792
                ],
                [
                  -76.541316,
                  39.310578
                ],
                [
                  -76.543118,
                  39.307352
                ],
                [
                  -76.546903,
                  39.309604
                ],
                [
                  -76.547918,
                  39.311196
                ],
                [
                  -76.550387,
                  39.311318
                ],
                [
                  -76.549349,
                  39.31374
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "010400",
          "AFFGEOID": "1400000US24510010400",
          "GEOID": "24510010400",
          "NAME": "104",
          "NAMELSAD": "Census Tract 104",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 373744,
          "AWATER": 558487
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.587056,
                  39.285853
                ],
                [
                  -76.584332,
                  39.285956
                ],
                [
                  -76.584262,
                  39.284949
                ],
                [
                  -76.584222,
                  39.28403
                ],
                [
                  -76.584019,
                  39.283916
                ],
                [
                  -76.583895,
                  39.283844
                ],
                [
                  -76.582736,
                  39.283099
                ],
                [
                  -76.579853,
                  39.283085
                ],
                [
                  -76.577043,
                  39.28321
                ],
                [
                  -76.57698,
                  39.282175
                ],
                [
                  -76.576864,
                  39.28028
                ],
                [
                  -76.57674,
                  39.278534
                ],
                [
                  -76.575321,
                  39.278216
                ],
                [
                  -76.575615,
                  39.277213
                ],
                [
                  -76.576147,
                  39.276733
                ],
                [
                  -76.577586,
                  39.271606
                ],
                [
                  -76.586588,
                  39.277306
                ],
                [
                  -76.586889,
                  39.28323
                ],
                [
                  -76.58693,
                  39.283806
                ],
                [
                  -76.587056,
                  39.285853
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "200500",
          "AFFGEOID": "1400000US24510200500",
          "GEOID": "24510200500",
          "NAME": "2005",
          "NAMELSAD": "Census Tract 2005",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 653068,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.659026,
                  39.281384
                ],
                [
                  -76.657872,
                  39.282141
                ],
                [
                  -76.655928,
                  39.283405
                ],
                [
                  -76.654538,
                  39.284213
                ],
                [
                  -76.652622,
                  39.284874
                ],
                [
                  -76.649969,
                  39.28578
                ],
                [
                  -76.649903,
                  39.284994
                ],
                [
                  -76.649878,
                  39.284164
                ],
                [
                  -76.649772,
                  39.282387
                ],
                [
                  -76.648776,
                  39.280557
                ],
                [
                  -76.647977,
                  39.279075
                ],
                [
                  -76.651,
                  39.278227
                ],
                [
                  -76.652902,
                  39.277465
                ],
                [
                  -76.654552,
                  39.276152
                ],
                [
                  -76.654919,
                  39.275524
                ],
                [
                  -76.65664,
                  39.276256
                ],
                [
                  -76.657608,
                  39.276041
                ],
                [
                  -76.658684,
                  39.278057
                ],
                [
                  -76.660175,
                  39.280657
                ],
                [
                  -76.659026,
                  39.281384
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "250206",
          "AFFGEOID": "1400000US24510250206",
          "GEOID": "24510250206",
          "NAME": "2502.06",
          "NAMELSAD": "Census Tract 2502.06",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 2549600,
          "AWATER": 18103
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.671563,
                  39.275933
                ],
                [
                  -76.670022,
                  39.275533
                ],
                [
                  -76.669224,
                  39.275718
                ],
                [
                  -76.666756,
                  39.276116
                ],
                [
                  -76.665905,
                  39.275651
                ],
                [
                  -76.665061,
                  39.275043
                ],
                [
                  -76.662291,
                  39.27624
                ],
                [
                  -76.659408,
                  39.274653
                ],
                [
                  -76.657608,
                  39.276041
                ],
                [
                  -76.65664,
                  39.276256
                ],
                [
                  -76.654919,
                  39.275524
                ],
                [
                  -76.655024,
                  39.275331
                ],
                [
                  -76.655335,
                  39.274523
                ],
                [
                  -76.654996,
                  39.271192
                ],
                [
                  -76.654239,
                  39.266995
                ],
                [
                  -76.653422,
                  39.265822
                ],
                [
                  -76.652073,
                  39.264642
                ],
                [
                  -76.651693,
                  39.263463
                ],
                [
                  -76.651677,
                  39.26097
                ],
                [
                  -76.649834,
                  39.260314
                ],
                [
                  -76.65251,
                  39.258401
                ],
                [
                  -76.657559,
                  39.256784
                ],
                [
                  -76.65986,
                  39.255509
                ],
                [
                  -76.66261,
                  39.256796
                ],
                [
                  -76.664322,
                  39.257442
                ],
                [
                  -76.664247,
                  39.25851
                ],
                [
                  -76.664882,
                  39.260554
                ],
                [
                  -76.667055,
                  39.265971
                ],
                [
                  -76.668788,
                  39.26943
                ],
                [
                  -76.669689,
                  39.270672
                ],
                [
                  -76.671489,
                  39.273887
                ],
                [
                  -76.671563,
                  39.275933
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "151100",
          "AFFGEOID": "1400000US24510151100",
          "GEOID": "24510151100",
          "NAME": "1511",
          "NAMELSAD": "Census Tract 1511",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1698800,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.679667,
                  39.329778
                ],
                [
                  -76.678674,
                  39.331757
                ],
                [
                  -76.678891,
                  39.335313
                ],
                [
                  -76.679078,
                  39.337035
                ],
                [
                  -76.679197,
                  39.338172
                ],
                [
                  -76.677964,
                  39.339925
                ],
                [
                  -76.676243,
                  39.339098
                ],
                [
                  -76.673019,
                  39.336977
                ],
                [
                  -76.67167,
                  39.336104
                ],
                [
                  -76.670831,
                  39.335692
                ],
                [
                  -76.668475,
                  39.33485
                ],
                [
                  -76.666471,
                  39.333761
                ],
                [
                  -76.66589,
                  39.332968
                ],
                [
                  -76.66545,
                  39.331547
                ],
                [
                  -76.664302,
                  39.327512
                ],
                [
                  -76.66414,
                  39.325972
                ],
                [
                  -76.664776,
                  39.322194
                ],
                [
                  -76.669499,
                  39.323619
                ],
                [
                  -76.67145,
                  39.324189
                ],
                [
                  -76.674659,
                  39.325134
                ],
                [
                  -76.676491,
                  39.325672
                ],
                [
                  -76.681068,
                  39.326945
                ],
                [
                  -76.679667,
                  39.329778
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "080102",
          "AFFGEOID": "1400000US24510080102",
          "GEOID": "24510080102",
          "NAME": "801.02",
          "NAMELSAD": "Census Tract 801.02",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 365633,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.581813,
                  39.314553
                ],
                [
                  -76.578871,
                  39.317108
                ],
                [
                  -76.574591,
                  39.320865
                ],
                [
                  -76.573745,
                  39.321612
                ],
                [
                  -76.571729,
                  39.320259
                ],
                [
                  -76.572969,
                  39.317075
                ],
                [
                  -76.573137,
                  39.314474
                ],
                [
                  -76.573145,
                  39.314316
                ],
                [
                  -76.582164,
                  39.314243
                ],
                [
                  -76.581813,
                  39.314553
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "060100",
          "AFFGEOID": "1400000US24510060100",
          "GEOID": "24510060100",
          "NAME": "601",
          "NAMELSAD": "Census Tract 601",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 238719,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.577955,
                  39.296911
                ],
                [
                  -76.575804,
                  39.296994
                ],
                [
                  -76.572597,
                  39.297115
                ],
                [
                  -76.572579,
                  39.295644
                ],
                [
                  -76.572565,
                  39.294777
                ],
                [
                  -76.572468,
                  39.293504
                ],
                [
                  -76.57238,
                  39.292381
                ],
                [
                  -76.574076,
                  39.292312
                ],
                [
                  -76.575508,
                  39.292257
                ],
                [
                  -76.576174,
                  39.292232
                ],
                [
                  -76.577623,
                  39.292178
                ],
                [
                  -76.577783,
                  39.294582
                ],
                [
                  -76.577955,
                  39.296911
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "010200",
          "AFFGEOID": "1400000US24510010200",
          "GEOID": "24510010200",
          "NAME": "102",
          "NAMELSAD": "Census Tract 102",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 355165,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.577242,
                  39.286242
                ],
                [
                  -76.575814,
                  39.2863
                ],
                [
                  -76.576174,
                  39.292232
                ],
                [
                  -76.575508,
                  39.292257
                ],
                [
                  -76.574076,
                  39.292312
                ],
                [
                  -76.57238,
                  39.292381
                ],
                [
                  -76.571839,
                  39.291243
                ],
                [
                  -76.571669,
                  39.288471
                ],
                [
                  -76.571607,
                  39.287477
                ],
                [
                  -76.571533,
                  39.286455
                ],
                [
                  -76.571396,
                  39.284423
                ],
                [
                  -76.572821,
                  39.284364
                ],
                [
                  -76.57709,
                  39.284207
                ],
                [
                  -76.577242,
                  39.286242
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "140200",
          "AFFGEOID": "1400000US24510140200",
          "GEOID": "24510140200",
          "NAME": "1402",
          "NAMELSAD": "Census Tract 1402",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 395229,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.635591,
                  39.304339
                ],
                [
                  -76.634526,
                  39.305162
                ],
                [
                  -76.633407,
                  39.305969
                ],
                [
                  -76.632258,
                  39.306807
                ],
                [
                  -76.630761,
                  39.307947
                ],
                [
                  -76.628783,
                  39.306355
                ],
                [
                  -76.626905,
                  39.304784
                ],
                [
                  -76.628006,
                  39.30397
                ],
                [
                  -76.628764,
                  39.303409
                ],
                [
                  -76.629554,
                  39.3028
                ],
                [
                  -76.630627,
                  39.302006
                ],
                [
                  -76.631732,
                  39.301181
                ],
                [
                  -76.634475,
                  39.299142
                ],
                [
                  -76.634511,
                  39.299198
                ],
                [
                  -76.636829,
                  39.303421
                ],
                [
                  -76.635591,
                  39.304339
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "260404",
          "AFFGEOID": "1400000US24510260404",
          "GEOID": "24510260404",
          "NAME": "2604.04",
          "NAMELSAD": "Census Tract 2604.04",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 4467107,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.573046,
                  39.309338
                ],
                [
                  -76.568615,
                  39.309379
                ],
                [
                  -76.565478,
                  39.30897
                ],
                [
                  -76.563609,
                  39.307635
                ],
                [
                  -76.554885,
                  39.301018
                ],
                [
                  -76.553479,
                  39.300151
                ],
                [
                  -76.550674,
                  39.301077
                ],
                [
                  -76.549476,
                  39.301503
                ],
                [
                  -76.546089,
                  39.302548
                ],
                [
                  -76.539257,
                  39.304629
                ],
                [
                  -76.537893,
                  39.305258
                ],
                [
                  -76.536411,
                  39.305962
                ],
                [
                  -76.532346,
                  39.308668
                ],
                [
                  -76.529786,
                  39.310391
                ],
                [
                  -76.529786,
                  39.29911
                ],
                [
                  -76.529517,
                  39.297056
                ],
                [
                  -76.531351,
                  39.296057
                ],
                [
                  -76.532785,
                  39.295414
                ],
                [
                  -76.537271,
                  39.296207
                ],
                [
                  -76.547801,
                  39.29576
                ],
                [
                  -76.551503,
                  39.292216
                ],
                [
                  -76.553828,
                  39.291963
                ],
                [
                  -76.554992,
                  39.291911
                ],
                [
                  -76.557417,
                  39.291799
                ],
                [
                  -76.562744,
                  39.291595
                ],
                [
                  -76.562827,
                  39.292754
                ],
                [
                  -76.56755,
                  39.292568
                ],
                [
                  -76.569413,
                  39.292487
                ],
                [
                  -76.569462,
                  39.293066
                ],
                [
                  -76.569656,
                  39.296061
                ],
                [
                  -76.56974,
                  39.297225
                ],
                [
                  -76.569869,
                  39.299202
                ],
                [
                  -76.569911,
                  39.29935
                ],
                [
                  -76.572661,
                  39.299237
                ],
                [
                  -76.572789,
                  39.299234
                ],
                [
                  -76.572793,
                  39.302721
                ],
                [
                  -76.573046,
                  39.309338
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "130400",
          "AFFGEOID": "1400000US24510130400",
          "GEOID": "24510130400",
          "NAME": "1304",
          "NAMELSAD": "Census Tract 1304",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 2599677,
          "AWATER": 203955
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.657528,
                  39.325453
                ],
                [
                  -76.655061,
                  39.329543
                ],
                [
                  -76.654032,
                  39.330291
                ],
                [
                  -76.651891,
                  39.331051
                ],
                [
                  -76.646191,
                  39.329905
                ],
                [
                  -76.644891,
                  39.330905
                ],
                [
                  -76.642788,
                  39.329658
                ],
                [
                  -76.641762,
                  39.327965
                ],
                [
                  -76.640528,
                  39.327216
                ],
                [
                  -76.640014,
                  39.326736
                ],
                [
                  -76.6343,
                  39.324737
                ],
                [
                  -76.632701,
                  39.323496
                ],
                [
                  -76.629888,
                  39.318154
                ],
                [
                  -76.62943,
                  39.317081
                ],
                [
                  -76.631476,
                  39.316807
                ],
                [
                  -76.633956,
                  39.317011
                ],
                [
                  -76.63618,
                  39.316962
                ],
                [
                  -76.636903,
                  39.316914
                ],
                [
                  -76.639406,
                  39.315838
                ],
                [
                  -76.640303,
                  39.315139
                ],
                [
                  -76.641075,
                  39.314528
                ],
                [
                  -76.641849,
                  39.314032
                ],
                [
                  -76.643631,
                  39.315793
                ],
                [
                  -76.644335,
                  39.315093
                ],
                [
                  -76.644557,
                  39.314876
                ],
                [
                  -76.646316,
                  39.313248
                ],
                [
                  -76.648725,
                  39.315225
                ],
                [
                  -76.649115,
                  39.315543
                ],
                [
                  -76.650494,
                  39.316704
                ],
                [
                  -76.652014,
                  39.31805
                ],
                [
                  -76.652477,
                  39.318549
                ],
                [
                  -76.654881,
                  39.32181
                ],
                [
                  -76.657105,
                  39.324785
                ],
                [
                  -76.657528,
                  39.325453
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "250203",
          "AFFGEOID": "1400000US24510250203",
          "GEOID": "24510250203",
          "NAME": "2502.03",
          "NAMELSAD": "Census Tract 2502.03",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 923337,
          "AWATER": 361546
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.625398,
                  39.249082
                ],
                [
                  -76.623639,
                  39.249712
                ],
                [
                  -76.620881,
                  39.250895
                ],
                [
                  -76.618436,
                  39.251946
                ],
                [
                  -76.617349,
                  39.252412
                ],
                [
                  -76.617661,
                  39.252834
                ],
                [
                  -76.617915,
                  39.253531
                ],
                [
                  -76.617912,
                  39.253894
                ],
                [
                  -76.617775,
                  39.254455
                ],
                [
                  -76.61743,
                  39.255213
                ],
                [
                  -76.617143,
                  39.255627
                ],
                [
                  -76.616934,
                  39.256013
                ],
                [
                  -76.616883,
                  39.25612
                ],
                [
                  -76.616437,
                  39.257216
                ],
                [
                  -76.610488,
                  39.254706
                ],
                [
                  -76.608288,
                  39.254706
                ],
                [
                  -76.609089,
                  39.249906
                ],
                [
                  -76.611688,
                  39.247407
                ],
                [
                  -76.612489,
                  39.246606
                ],
                [
                  -76.614642,
                  39.241092
                ],
                [
                  -76.615308,
                  39.241144
                ],
                [
                  -76.621721,
                  39.241702
                ],
                [
                  -76.621489,
                  39.241906
                ],
                [
                  -76.619496,
                  39.244593
                ],
                [
                  -76.618824,
                  39.24575
                ],
                [
                  -76.623001,
                  39.248131
                ],
                [
                  -76.623857,
                  39.248517
                ],
                [
                  -76.625398,
                  39.249082
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "260700",
          "AFFGEOID": "1400000US24510260700",
          "GEOID": "24510260700",
          "NAME": "2607",
          "NAMELSAD": "Census Tract 2607",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 785731,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.562744,
                  39.291595
                ],
                [
                  -76.557417,
                  39.291799
                ],
                [
                  -76.554992,
                  39.291911
                ],
                [
                  -76.555724,
                  39.291783
                ],
                [
                  -76.554135,
                  39.288054
                ],
                [
                  -76.554983,
                  39.287127
                ],
                [
                  -76.554922,
                  39.286077
                ],
                [
                  -76.5548,
                  39.284053
                ],
                [
                  -76.554644,
                  39.282287
                ],
                [
                  -76.554581,
                  39.280977
                ],
                [
                  -76.55542,
                  39.280953
                ],
                [
                  -76.560994,
                  39.280738
                ],
                [
                  -76.562057,
                  39.280707
                ],
                [
                  -76.562123,
                  39.281749
                ],
                [
                  -76.562312,
                  39.284791
                ],
                [
                  -76.562446,
                  39.286877
                ],
                [
                  -76.562513,
                  39.287825
                ],
                [
                  -76.562578,
                  39.288816
                ],
                [
                  -76.562744,
                  39.291595
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "080600",
          "AFFGEOID": "1400000US24510080600",
          "GEOID": "24510080600",
          "NAME": "806",
          "NAMELSAD": "Census Tract 806",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 336416,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.598477,
                  39.311992
                ],
                [
                  -76.595233,
                  39.312158
                ],
                [
                  -76.593096,
                  39.312217
                ],
                [
                  -76.591098,
                  39.312313
                ],
                [
                  -76.588692,
                  39.312419
                ],
                [
                  -76.588617,
                  39.310903
                ],
                [
                  -76.588483,
                  39.308805
                ],
                [
                  -76.592846,
                  39.308641
                ],
                [
                  -76.598278,
                  39.308425
                ],
                [
                  -76.598318,
                  39.309477
                ],
                [
                  -76.59838,
                  39.310526
                ],
                [
                  -76.598477,
                  39.311992
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "090900",
          "AFFGEOID": "1400000US24510090900",
          "GEOID": "24510090900",
          "NAME": "909",
          "NAMELSAD": "Census Tract 909",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 686864,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.609497,
                  39.311405
                ],
                [
                  -76.607133,
                  39.311536
                ],
                [
                  -76.605177,
                  39.311662
                ],
                [
                  -76.600866,
                  39.311875
                ],
                [
                  -76.600704,
                  39.31188
                ],
                [
                  -76.59937,
                  39.311942
                ],
                [
                  -76.598477,
                  39.311992
                ],
                [
                  -76.59838,
                  39.310526
                ],
                [
                  -76.598318,
                  39.309477
                ],
                [
                  -76.598278,
                  39.308425
                ],
                [
                  -76.598069,
                  39.305222
                ],
                [
                  -76.600021,
                  39.305157
                ],
                [
                  -76.603627,
                  39.305018
                ],
                [
                  -76.605118,
                  39.304964
                ],
                [
                  -76.608199,
                  39.304839
                ],
                [
                  -76.609391,
                  39.310071
                ],
                [
                  -76.609497,
                  39.311405
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "280404",
          "AFFGEOID": "1400000US24510280404",
          "GEOID": "24510280404",
          "NAME": "2804.04",
          "NAMELSAD": "Census Tract 2804.04",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 848958,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.697993,
                  39.29306
                ],
                [
                  -76.696359,
                  39.293298
                ],
                [
                  -76.689425,
                  39.293581
                ],
                [
                  -76.688925,
                  39.288204
                ],
                [
                  -76.687874,
                  39.287664
                ],
                [
                  -76.686776,
                  39.287229
                ],
                [
                  -76.686706,
                  39.281656
                ],
                [
                  -76.692931,
                  39.281469
                ],
                [
                  -76.693817,
                  39.28484
                ],
                [
                  -76.693892,
                  39.285755
                ],
                [
                  -76.695944,
                  39.288681
                ],
                [
                  -76.697204,
                  39.289137
                ],
                [
                  -76.697993,
                  39.29306
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "090800",
          "AFFGEOID": "1400000US24510090800",
          "GEOID": "24510090800",
          "NAME": "908",
          "NAMELSAD": "Census Tract 908",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 846055,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.609528,
                  39.315066
                ],
                [
                  -76.60949,
                  39.316234
                ],
                [
                  -76.609464,
                  39.318111
                ],
                [
                  -76.609509,
                  39.319519
                ],
                [
                  -76.607873,
                  39.319552
                ],
                [
                  -76.605812,
                  39.319457
                ],
                [
                  -76.603351,
                  39.319181
                ],
                [
                  -76.601489,
                  39.31879
                ],
                [
                  -76.597717,
                  39.317922
                ],
                [
                  -76.594867,
                  39.317238
                ],
                [
                  -76.595463,
                  39.316672
                ],
                [
                  -76.596435,
                  39.315713
                ],
                [
                  -76.596927,
                  39.315241
                ],
                [
                  -76.597941,
                  39.314262
                ],
                [
                  -76.599057,
                  39.312961
                ],
                [
                  -76.59937,
                  39.311942
                ],
                [
                  -76.600704,
                  39.31188
                ],
                [
                  -76.600866,
                  39.311875
                ],
                [
                  -76.605177,
                  39.311662
                ],
                [
                  -76.607133,
                  39.311536
                ],
                [
                  -76.609497,
                  39.311405
                ],
                [
                  -76.609505,
                  39.311833
                ],
                [
                  -76.609532,
                  39.314508
                ],
                [
                  -76.609528,
                  39.315066
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "270200",
          "AFFGEOID": "1400000US24510270200",
          "GEOID": "24510270200",
          "NAME": "2702",
          "NAMELSAD": "Census Tract 2702",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 938519,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.580805,
                  39.345277
                ],
                [
                  -76.579179,
                  39.345194
                ],
                [
                  -76.57707,
                  39.345409
                ],
                [
                  -76.574478,
                  39.345725
                ],
                [
                  -76.573724,
                  39.345561
                ],
                [
                  -76.57134,
                  39.344489
                ],
                [
                  -76.569136,
                  39.342826
                ],
                [
                  -76.567956,
                  39.342076
                ],
                [
                  -76.567424,
                  39.339556
                ],
                [
                  -76.568325,
                  39.339026
                ],
                [
                  -76.56955,
                  39.338052
                ],
                [
                  -76.571468,
                  39.336506
                ],
                [
                  -76.572095,
                  39.336117
                ],
                [
                  -76.573154,
                  39.335787
                ],
                [
                  -76.575221,
                  39.335243
                ],
                [
                  -76.576547,
                  39.333861
                ],
                [
                  -76.578427,
                  39.335492
                ],
                [
                  -76.576952,
                  39.338625
                ],
                [
                  -76.579257,
                  39.341568
                ],
                [
                  -76.581539,
                  39.341919
                ],
                [
                  -76.580805,
                  39.345277
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "272003",
          "AFFGEOID": "1400000US24510272003",
          "GEOID": "24510272003",
          "NAME": "2720.03",
          "NAMELSAD": "Census Tract 2720.03",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1934714,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.698246,
                  39.363623
                ],
                [
                  -76.697167,
                  39.364952
                ],
                [
                  -76.692191,
                  39.365918
                ],
                [
                  -76.69075,
                  39.365684
                ],
                [
                  -76.689582,
                  39.36421
                ],
                [
                  -76.689003,
                  39.364605
                ],
                [
                  -76.685093,
                  39.365505
                ],
                [
                  -76.685228,
                  39.36897
                ],
                [
                  -76.680807,
                  39.369059
                ],
                [
                  -76.682172,
                  39.370525
                ],
                [
                  -76.682273,
                  39.370982
                ],
                [
                  -76.682343,
                  39.372201
                ],
                [
                  -76.678773,
                  39.37215
                ],
                [
                  -76.678191,
                  39.371994
                ],
                [
                  -76.677545,
                  39.369693
                ],
                [
                  -76.674202,
                  39.366381
                ],
                [
                  -76.67336,
                  39.364547
                ],
                [
                  -76.673301,
                  39.364466
                ],
                [
                  -76.673109,
                  39.364244
                ],
                [
                  -76.673895,
                  39.363843
                ],
                [
                  -76.675129,
                  39.36282
                ],
                [
                  -76.675658,
                  39.362375
                ],
                [
                  -76.679151,
                  39.360532
                ],
                [
                  -76.680398,
                  39.359836
                ],
                [
                  -76.682897,
                  39.358549
                ],
                [
                  -76.682956,
                  39.358518
                ],
                [
                  -76.686773,
                  39.356483
                ],
                [
                  -76.688144,
                  39.35576
                ],
                [
                  -76.68959,
                  39.356505
                ],
                [
                  -76.694038,
                  39.358715
                ],
                [
                  -76.694344,
                  39.358879
                ],
                [
                  -76.696712,
                  39.360122
                ],
                [
                  -76.697885,
                  39.360799
                ],
                [
                  -76.699798,
                  39.362363
                ],
                [
                  -76.698246,
                  39.363623
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "110200",
          "AFFGEOID": "1400000US24510110200",
          "GEOID": "24510110200",
          "NAME": "1102",
          "NAMELSAD": "Census Tract 1102",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 720072,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.621005,
                  39.307234
                ],
                [
                  -76.620355,
                  39.309123
                ],
                [
                  -76.617725,
                  39.307674
                ],
                [
                  -76.616286,
                  39.306763
                ],
                [
                  -76.614655,
                  39.306022
                ],
                [
                  -76.614613,
                  39.305469
                ],
                [
                  -76.614482,
                  39.303524
                ],
                [
                  -76.614406,
                  39.302461
                ],
                [
                  -76.614324,
                  39.301086
                ],
                [
                  -76.614243,
                  39.299721
                ],
                [
                  -76.61416,
                  39.298672
                ],
                [
                  -76.614072,
                  39.297358
                ],
                [
                  -76.613993,
                  39.296387
                ],
                [
                  -76.614342,
                  39.29512
                ],
                [
                  -76.615549,
                  39.295092
                ],
                [
                  -76.616933,
                  39.295049
                ],
                [
                  -76.618322,
                  39.294978
                ],
                [
                  -76.619819,
                  39.294931
                ],
                [
                  -76.619983,
                  39.297359
                ],
                [
                  -76.620036,
                  39.29843
                ],
                [
                  -76.620174,
                  39.301142
                ],
                [
                  -76.620269,
                  39.301757
                ],
                [
                  -76.620723,
                  39.304351
                ],
                [
                  -76.62076,
                  39.304815
                ],
                [
                  -76.620906,
                  39.306183
                ],
                [
                  -76.621005,
                  39.307234
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "271101",
          "AFFGEOID": "1400000US24510271101",
          "GEOID": "24510271101",
          "NAME": "2711.01",
          "NAMELSAD": "Census Tract 2711.01",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1011783,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.623522,
                  39.353226
                ],
                [
                  -76.616098,
                  39.353789
                ],
                [
                  -76.609928,
                  39.354331
                ],
                [
                  -76.609881,
                  39.352801
                ],
                [
                  -76.60984,
                  39.351952
                ],
                [
                  -76.609788,
                  39.350145
                ],
                [
                  -76.609718,
                  39.347917
                ],
                [
                  -76.609682,
                  39.346177
                ],
                [
                  -76.613313,
                  39.3461
                ],
                [
                  -76.617019,
                  39.345332
                ],
                [
                  -76.617127,
                  39.34533
                ],
                [
                  -76.620125,
                  39.345515
                ],
                [
                  -76.622127,
                  39.34534
                ],
                [
                  -76.622777,
                  39.349106
                ],
                [
                  -76.623522,
                  39.353226
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "271102",
          "AFFGEOID": "1400000US24510271102",
          "GEOID": "24510271102",
          "NAME": "2711.02",
          "NAMELSAD": "Census Tract 2711.02",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1227625,
          "AWATER": 29218
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.629227,
                  39.353429
                ],
                [
                  -76.623669,
                  39.353872
                ],
                [
                  -76.623522,
                  39.353226
                ],
                [
                  -76.622777,
                  39.349106
                ],
                [
                  -76.622127,
                  39.34534
                ],
                [
                  -76.620125,
                  39.345515
                ],
                [
                  -76.617127,
                  39.34533
                ],
                [
                  -76.617019,
                  39.345332
                ],
                [
                  -76.613313,
                  39.3461
                ],
                [
                  -76.609682,
                  39.346177
                ],
                [
                  -76.609636,
                  39.344296
                ],
                [
                  -76.609682,
                  39.34104
                ],
                [
                  -76.6096,
                  39.340181
                ],
                [
                  -76.60958,
                  39.339798
                ],
                [
                  -76.610776,
                  39.340043
                ],
                [
                  -76.612288,
                  39.340963
                ],
                [
                  -76.613276,
                  39.340278
                ],
                [
                  -76.61466,
                  39.33954
                ],
                [
                  -76.616574,
                  39.338842
                ],
                [
                  -76.618363,
                  39.338531
                ],
                [
                  -76.618401,
                  39.339254
                ],
                [
                  -76.620426,
                  39.340469
                ],
                [
                  -76.621404,
                  39.341089
                ],
                [
                  -76.622849,
                  39.340659
                ],
                [
                  -76.625785,
                  39.341591
                ],
                [
                  -76.625629,
                  39.344001
                ],
                [
                  -76.626282,
                  39.34506
                ],
                [
                  -76.628184,
                  39.348748
                ],
                [
                  -76.629227,
                  39.353429
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "130300",
          "AFFGEOID": "1400000US24510130300",
          "GEOID": "24510130300",
          "NAME": "1303",
          "NAMELSAD": "Census Tract 1303",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 359731,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.646316,
                  39.313248
                ],
                [
                  -76.644557,
                  39.314876
                ],
                [
                  -76.644335,
                  39.315093
                ],
                [
                  -76.643631,
                  39.315793
                ],
                [
                  -76.641849,
                  39.314032
                ],
                [
                  -76.641075,
                  39.314528
                ],
                [
                  -76.640303,
                  39.315139
                ],
                [
                  -76.637783,
                  39.312615
                ],
                [
                  -76.636683,
                  39.313246
                ],
                [
                  -76.635319,
                  39.3118
                ],
                [
                  -76.633896,
                  39.310335
                ],
                [
                  -76.636986,
                  39.310319
                ],
                [
                  -76.638331,
                  39.310237
                ],
                [
                  -76.638372,
                  39.310237
                ],
                [
                  -76.641168,
                  39.310145
                ],
                [
                  -76.642514,
                  39.310089
                ],
                [
                  -76.645408,
                  39.312515
                ],
                [
                  -76.646316,
                  39.313248
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "090300",
          "AFFGEOID": "1400000US24510090300",
          "GEOID": "24510090300",
          "NAME": "903",
          "NAMELSAD": "Census Tract 903",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 793221,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.609508,
                  39.334456
                ],
                [
                  -76.607537,
                  39.334483
                ],
                [
                  -76.605879,
                  39.334185
                ],
                [
                  -76.60463,
                  39.334327
                ],
                [
                  -76.604485,
                  39.33404
                ],
                [
                  -76.600197,
                  39.334038
                ],
                [
                  -76.595443,
                  39.33403
                ],
                [
                  -76.595159,
                  39.333147
                ],
                [
                  -76.595115,
                  39.330136
                ],
                [
                  -76.595145,
                  39.328347
                ],
                [
                  -76.597897,
                  39.328329
                ],
                [
                  -76.603629,
                  39.328332
                ],
                [
                  -76.608472,
                  39.328332
                ],
                [
                  -76.609428,
                  39.328314
                ],
                [
                  -76.60943,
                  39.328495
                ],
                [
                  -76.609476,
                  39.330965
                ],
                [
                  -76.609508,
                  39.334456
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "272007",
          "AFFGEOID": "1400000US24510272007",
          "GEOID": "24510272007",
          "NAME": "2720.07",
          "NAMELSAD": "Census Tract 2720.07",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 802298,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.711519,
                  39.365763
                ],
                [
                  -76.711313,
                  39.371933
                ],
                [
                  -76.706869,
                  39.368097
                ],
                [
                  -76.702834,
                  39.364819
                ],
                [
                  -76.701481,
                  39.363732
                ],
                [
                  -76.699798,
                  39.362363
                ],
                [
                  -76.703228,
                  39.359702
                ],
                [
                  -76.702391,
                  39.359069
                ],
                [
                  -76.702057,
                  39.358817
                ],
                [
                  -76.70083,
                  39.357891
                ],
                [
                  -76.702446,
                  39.356246
                ],
                [
                  -76.705097,
                  39.35825
                ],
                [
                  -76.706918,
                  39.359658
                ],
                [
                  -76.707751,
                  39.360323
                ],
                [
                  -76.711191,
                  39.362798
                ],
                [
                  -76.711408,
                  39.364409
                ],
                [
                  -76.711403,
                  39.364615
                ],
                [
                  -76.711519,
                  39.365763
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "160200",
          "AFFGEOID": "1400000US24510160200",
          "GEOID": "24510160200",
          "NAME": "1602",
          "NAMELSAD": "Census Tract 1602",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 374068,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.643218,
                  39.303211
                ],
                [
                  -76.640407,
                  39.303324
                ],
                [
                  -76.638967,
                  39.303378
                ],
                [
                  -76.638797,
                  39.300137
                ],
                [
                  -76.638757,
                  39.299062
                ],
                [
                  -76.638552,
                  39.295447
                ],
                [
                  -76.638462,
                  39.294189
                ],
                [
                  -76.639882,
                  39.294136
                ],
                [
                  -76.642696,
                  39.294009
                ],
                [
                  -76.642775,
                  39.295313
                ],
                [
                  -76.642975,
                  39.298894
                ],
                [
                  -76.64309,
                  39.301109
                ],
                [
                  -76.643218,
                  39.303211
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "160700",
          "AFFGEOID": "1400000US24510160700",
          "GEOID": "24510160700",
          "NAME": "1607",
          "NAMELSAD": "Census Tract 1607",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 953875,
          "AWATER": 14242
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.673976,
                  39.302639
                ],
                [
                  -76.673682,
                  39.304243
                ],
                [
                  -76.674142,
                  39.305682
                ],
                [
                  -76.674123,
                  39.306268
                ],
                [
                  -76.672291,
                  39.307205
                ],
                [
                  -76.669205,
                  39.307096
                ],
                [
                  -76.668405,
                  39.307117
                ],
                [
                  -76.667324,
                  39.305904
                ],
                [
                  -76.665595,
                  39.30596
                ],
                [
                  -76.660898,
                  39.306144
                ],
                [
                  -76.660829,
                  39.303078
                ],
                [
                  -76.660721,
                  39.302624
                ],
                [
                  -76.660868,
                  39.301542
                ],
                [
                  -76.660824,
                  39.300451
                ],
                [
                  -76.665271,
                  39.300283
                ],
                [
                  -76.665187,
                  39.29921
                ],
                [
                  -76.667641,
                  39.29941
                ],
                [
                  -76.668983,
                  39.29929
                ],
                [
                  -76.668949,
                  39.299182
                ],
                [
                  -76.668954,
                  39.297189
                ],
                [
                  -76.669245,
                  39.296623
                ],
                [
                  -76.669717,
                  39.294276
                ],
                [
                  -76.670465,
                  39.294257
                ],
                [
                  -76.670726,
                  39.296354
                ],
                [
                  -76.67275,
                  39.297609
                ],
                [
                  -76.67421,
                  39.302373
                ],
                [
                  -76.673976,
                  39.302639
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "240200",
          "AFFGEOID": "1400000US24510240200",
          "GEOID": "24510240200",
          "NAME": "2402",
          "NAMELSAD": "Census Tract 2402",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 435843,
          "AWATER": 311903
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.609234,
                  39.278994
                ],
                [
                  -76.606433,
                  39.279228
                ],
                [
                  -76.605926,
                  39.279258
                ],
                [
                  -76.604293,
                  39.279303
                ],
                [
                  -76.602788,
                  39.279806
                ],
                [
                  -76.602588,
                  39.279506
                ],
                [
                  -76.598977,
                  39.276916
                ],
                [
                  -76.595079,
                  39.277199
                ],
                [
                  -76.596493,
                  39.274586
                ],
                [
                  -76.597233,
                  39.273325
                ],
                [
                  -76.598908,
                  39.2708
                ],
                [
                  -76.599699,
                  39.271093
                ],
                [
                  -76.604087,
                  39.272615
                ],
                [
                  -76.605158,
                  39.272981
                ],
                [
                  -76.606712,
                  39.272908
                ],
                [
                  -76.608388,
                  39.272851
                ],
                [
                  -76.608592,
                  39.274266
                ],
                [
                  -76.608891,
                  39.276344
                ],
                [
                  -76.609034,
                  39.277376
                ],
                [
                  -76.609234,
                  39.278994
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "250207",
          "AFFGEOID": "1400000US24510250207",
          "GEOID": "24510250207",
          "NAME": "2502.07",
          "NAMELSAD": "Census Tract 2502.07",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 917475,
          "AWATER": 380163
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.634267,
                  39.255611
                ],
                [
                  -76.632768,
                  39.257731
                ],
                [
                  -76.631946,
                  39.25754
                ],
                [
                  -76.63009,
                  39.258824
                ],
                [
                  -76.629494,
                  39.258669
                ],
                [
                  -76.624689,
                  39.260606
                ],
                [
                  -76.623289,
                  39.260106
                ],
                [
                  -76.616437,
                  39.257216
                ],
                [
                  -76.616883,
                  39.25612
                ],
                [
                  -76.616934,
                  39.256013
                ],
                [
                  -76.617143,
                  39.255627
                ],
                [
                  -76.61743,
                  39.255213
                ],
                [
                  -76.617775,
                  39.254455
                ],
                [
                  -76.617912,
                  39.253894
                ],
                [
                  -76.617915,
                  39.253531
                ],
                [
                  -76.617661,
                  39.252834
                ],
                [
                  -76.617349,
                  39.252412
                ],
                [
                  -76.618436,
                  39.251946
                ],
                [
                  -76.620881,
                  39.250895
                ],
                [
                  -76.623639,
                  39.249712
                ],
                [
                  -76.625398,
                  39.249082
                ],
                [
                  -76.627535,
                  39.249821
                ],
                [
                  -76.625351,
                  39.250045
                ],
                [
                  -76.627427,
                  39.25158
                ],
                [
                  -76.628077,
                  39.250031
                ],
                [
                  -76.632601,
                  39.251544
                ],
                [
                  -76.63405,
                  39.254063
                ],
                [
                  -76.634267,
                  39.255611
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "240400",
          "AFFGEOID": "1400000US24510240400",
          "GEOID": "24510240400",
          "NAME": "2404",
          "NAMELSAD": "Census Tract 2404",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1180402,
          "AWATER": 965344
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.611922,
                  39.268516
                ],
                [
                  -76.611579,
                  39.270613
                ],
                [
                  -76.611504,
                  39.271142
                ],
                [
                  -76.611754,
                  39.2727
                ],
                [
                  -76.608388,
                  39.272851
                ],
                [
                  -76.606712,
                  39.272908
                ],
                [
                  -76.605158,
                  39.272981
                ],
                [
                  -76.604087,
                  39.272615
                ],
                [
                  -76.599699,
                  39.271093
                ],
                [
                  -76.600901,
                  39.269015
                ],
                [
                  -76.600833,
                  39.266823
                ],
                [
                  -76.600861,
                  39.266717
                ],
                [
                  -76.596918,
                  39.266182
                ],
                [
                  -76.592715,
                  39.265272
                ],
                [
                  -76.594092,
                  39.262606
                ],
                [
                  -76.594332,
                  39.262696
                ],
                [
                  -76.598588,
                  39.254806
                ],
                [
                  -76.608288,
                  39.254706
                ],
                [
                  -76.610488,
                  39.254706
                ],
                [
                  -76.610295,
                  39.25602
                ],
                [
                  -76.610626,
                  39.262249
                ],
                [
                  -76.606813,
                  39.263865
                ],
                [
                  -76.605578,
                  39.267235
                ],
                [
                  -76.607303,
                  39.267175
                ],
                [
                  -76.611855,
                  39.266951
                ],
                [
                  -76.611919,
                  39.267292
                ],
                [
                  -76.611922,
                  39.268516
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "240100",
          "AFFGEOID": "1400000US24510240100",
          "GEOID": "24510240100",
          "NAME": "2401",
          "NAMELSAD": "Census Tract 2401",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1906851,
          "AWATER": 2352887
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.600901,
                  39.269015
                ],
                [
                  -76.599699,
                  39.271093
                ],
                [
                  -76.598908,
                  39.2708
                ],
                [
                  -76.597233,
                  39.273325
                ],
                [
                  -76.596493,
                  39.274586
                ],
                [
                  -76.595079,
                  39.277199
                ],
                [
                  -76.592991,
                  39.277527
                ],
                [
                  -76.589884,
                  39.278005
                ],
                [
                  -76.586588,
                  39.277306
                ],
                [
                  -76.577586,
                  39.271606
                ],
                [
                  -76.575486,
                  39.267105
                ],
                [
                  -76.575218,
                  39.265652
                ],
                [
                  -76.5750309389132,
                  39.2646422283878
                ],
                [
                  -76.577453,
                  39.264557
                ],
                [
                  -76.5775790892698,
                  39.2643675853423
                ],
                [
                  -76.579474,
                  39.261521
                ],
                [
                  -76.5805274005719,
                  39.2614394464073
                ],
                [
                  -76.583039,
                  39.261245
                ],
                [
                  -76.58619,
                  39.261329124202
                ],
                [
                  -76.586485,
                  39.261337
                ],
                [
                  -76.5864652760091,
                  39.2612633279649
                ],
                [
                  -76.5848877881227,
                  39.2553711764285
                ],
                [
                  -76.589488,
                  39.254806
                ],
                [
                  -76.598588,
                  39.254806
                ],
                [
                  -76.594332,
                  39.262696
                ],
                [
                  -76.594092,
                  39.262606
                ],
                [
                  -76.592715,
                  39.265272
                ],
                [
                  -76.596918,
                  39.266182
                ],
                [
                  -76.600861,
                  39.266717
                ],
                [
                  -76.600833,
                  39.266823
                ],
                [
                  -76.600901,
                  39.269015
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "250600",
          "AFFGEOID": "1400000US24510250600",
          "GEOID": "24510250600",
          "NAME": "2506",
          "NAMELSAD": "Census Tract 2506",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 5660512,
          "AWATER": 9589221
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.614642,
                  39.241092
                ],
                [
                  -76.612489,
                  39.246606
                ],
                [
                  -76.611688,
                  39.247407
                ],
                [
                  -76.609089,
                  39.249906
                ],
                [
                  -76.608288,
                  39.254706
                ],
                [
                  -76.598588,
                  39.254806
                ],
                [
                  -76.589488,
                  39.254806
                ],
                [
                  -76.5848877881227,
                  39.2553711764285
                ],
                [
                  -76.584465,
                  39.253792
                ],
                [
                  -76.580187,
                  39.251951
                ],
                [
                  -76.578523,
                  39.251215
                ],
                [
                  -76.578523,
                  39.251061501906
                ],
                [
                  -76.578523,
                  39.2507626556196
                ],
                [
                  -76.578523,
                  39.2490106322972
                ],
                [
                  -76.578523,
                  39.248822
                ],
                [
                  -76.576543789426,
                  39.2478808961826
                ],
                [
                  -76.571749,
                  39.245601
                ],
                [
                  -76.5709347488766,
                  39.2450189026759
                ],
                [
                  -76.5676866787881,
                  39.242696900467
                ],
                [
                  -76.565569,
                  39.241183
                ],
                [
                  -76.56343,
                  39.23787
                ],
                [
                  -76.562242,
                  39.235292
                ],
                [
                  -76.560103,
                  39.235476
                ],
                [
                  -76.558439,
                  39.233727
                ],
                [
                  -76.558914,
                  39.232255
                ],
                [
                  -76.559992,
                  39.231166
                ],
                [
                  -76.562479,
                  39.230414
                ],
                [
                  -76.562836,
                  39.229677
                ],
                [
                  -76.562004,
                  39.22756
                ],
                [
                  -76.5645,
                  39.224614
                ],
                [
                  -76.5644445464556,
                  39.2245676907457
                ],
                [
                  -76.55946110415,
                  39.2204060181307
                ],
                [
                  -76.561642,
                  39.220633
                ],
                [
                  -76.566186,
                  39.221106
                ],
                [
                  -76.577387,
                  39.224906
                ],
                [
                  -76.579287,
                  39.226706
                ],
                [
                  -76.580587,
                  39.230906
                ],
                [
                  -76.582133,
                  39.23199
                ],
                [
                  -76.585039,
                  39.232402
                ],
                [
                  -76.593105,
                  39.241049
                ],
                [
                  -76.596954,
                  39.240977
                ],
                [
                  -76.595211,
                  39.239636
                ],
                [
                  -76.595552,
                  39.239143
                ],
                [
                  -76.601004,
                  39.240606
                ],
                [
                  -76.608657,
                  39.24033
                ],
                [
                  -76.60848,
                  39.240643
                ],
                [
                  -76.610055,
                  39.240637
                ],
                [
                  -76.61402,
                  39.241036
                ],
                [
                  -76.614642,
                  39.241092
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "120500",
          "AFFGEOID": "1400000US24510120500",
          "GEOID": "24510120500",
          "NAME": "1205",
          "NAMELSAD": "Census Tract 1205",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 534553,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.623277,
                  39.310848
                ],
                [
                  -76.620221,
                  39.310945
                ],
                [
                  -76.619354,
                  39.310956
                ],
                [
                  -76.616554,
                  39.311016
                ],
                [
                  -76.61583,
                  39.311041
                ],
                [
                  -76.614955,
                  39.311065
                ],
                [
                  -76.612464,
                  39.311194
                ],
                [
                  -76.609737,
                  39.311313
                ],
                [
                  -76.609497,
                  39.311405
                ],
                [
                  -76.609391,
                  39.310071
                ],
                [
                  -76.608199,
                  39.304839
                ],
                [
                  -76.611208,
                  39.304718
                ],
                [
                  -76.61135,
                  39.304715
                ],
                [
                  -76.612614,
                  39.305926
                ],
                [
                  -76.614655,
                  39.306022
                ],
                [
                  -76.616286,
                  39.306763
                ],
                [
                  -76.617725,
                  39.307674
                ],
                [
                  -76.620355,
                  39.309123
                ],
                [
                  -76.621549,
                  39.30985
                ],
                [
                  -76.62304,
                  39.310709
                ],
                [
                  -76.623277,
                  39.310848
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "200100",
          "AFFGEOID": "1400000US24510200100",
          "GEOID": "24510200100",
          "NAME": "2001",
          "NAMELSAD": "Census Tract 2001",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 264900,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.650383,
                  39.293698
                ],
                [
                  -76.647249,
                  39.293828
                ],
                [
                  -76.64552,
                  39.293895
                ],
                [
                  -76.645448,
                  39.292063
                ],
                [
                  -76.645301,
                  39.28958
                ],
                [
                  -76.645222,
                  39.288228
                ],
                [
                  -76.646959,
                  39.288148
                ],
                [
                  -76.650095,
                  39.288029
                ],
                [
                  -76.650164,
                  39.28939
                ],
                [
                  -76.650218,
                  39.289924
                ],
                [
                  -76.650383,
                  39.293698
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "280200",
          "AFFGEOID": "1400000US24510280200",
          "GEOID": "24510280200",
          "NAME": "2802",
          "NAMELSAD": "Census Tract 2802",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 2413240,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.711393,
                  39.322005
                ],
                [
                  -76.711393,
                  39.326955
                ],
                [
                  -76.711391,
                  39.327216
                ],
                [
                  -76.711462,
                  39.334573
                ],
                [
                  -76.711025,
                  39.336333
                ],
                [
                  -76.709912,
                  39.33599
                ],
                [
                  -76.70867,
                  39.335555
                ],
                [
                  -76.705367,
                  39.334445
                ],
                [
                  -76.703074,
                  39.333732
                ],
                [
                  -76.700637,
                  39.332962
                ],
                [
                  -76.697086,
                  39.331852
                ],
                [
                  -76.695674,
                  39.3314
                ],
                [
                  -76.694259,
                  39.33092
                ],
                [
                  -76.68858,
                  39.329184
                ],
                [
                  -76.687421,
                  39.328837
                ],
                [
                  -76.687999,
                  39.327696
                ],
                [
                  -76.690069,
                  39.323586
                ],
                [
                  -76.690198,
                  39.323552
                ],
                [
                  -76.693036,
                  39.322693
                ],
                [
                  -76.699953,
                  39.320325
                ],
                [
                  -76.70002,
                  39.320303
                ],
                [
                  -76.70177,
                  39.319596
                ],
                [
                  -76.704518,
                  39.322023
                ],
                [
                  -76.708393,
                  39.321805
                ],
                [
                  -76.711493,
                  39.320805
                ],
                [
                  -76.711393,
                  39.322005
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "140300",
          "AFFGEOID": "1400000US24510140300",
          "GEOID": "24510140300",
          "NAME": "1403",
          "NAMELSAD": "Census Tract 1403",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 389282,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.641168,
                  39.310145
                ],
                [
                  -76.638372,
                  39.310237
                ],
                [
                  -76.638331,
                  39.310237
                ],
                [
                  -76.636986,
                  39.310319
                ],
                [
                  -76.633896,
                  39.310335
                ],
                [
                  -76.633658,
                  39.310341
                ],
                [
                  -76.632658,
                  39.309499
                ],
                [
                  -76.630761,
                  39.307947
                ],
                [
                  -76.632258,
                  39.306807
                ],
                [
                  -76.633407,
                  39.305969
                ],
                [
                  -76.634526,
                  39.305162
                ],
                [
                  -76.635591,
                  39.304339
                ],
                [
                  -76.636829,
                  39.303421
                ],
                [
                  -76.638033,
                  39.305597
                ],
                [
                  -76.638823,
                  39.306992
                ],
                [
                  -76.640392,
                  39.3083
                ],
                [
                  -76.642514,
                  39.310089
                ],
                [
                  -76.641168,
                  39.310145
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "130700",
          "AFFGEOID": "1400000US24510130700",
          "GEOID": "24510130700",
          "NAME": "1307",
          "NAMELSAD": "Census Tract 1307",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1063583,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.640283,
                  39.343372
                ],
                [
                  -76.63917,
                  39.343066
                ],
                [
                  -76.635382,
                  39.34388
                ],
                [
                  -76.635163,
                  39.342645
                ],
                [
                  -76.634624,
                  39.341765
                ],
                [
                  -76.634251,
                  39.341418
                ],
                [
                  -76.632506,
                  39.3402
                ],
                [
                  -76.631389,
                  39.339326
                ],
                [
                  -76.62858,
                  39.339436
                ],
                [
                  -76.627683,
                  39.339122
                ],
                [
                  -76.625566,
                  39.33735
                ],
                [
                  -76.624544,
                  39.336791
                ],
                [
                  -76.624024,
                  39.336479
                ],
                [
                  -76.62376,
                  39.333934
                ],
                [
                  -76.624428,
                  39.33188
                ],
                [
                  -76.625917,
                  39.331158
                ],
                [
                  -76.626759,
                  39.33133
                ],
                [
                  -76.628029,
                  39.331301
                ],
                [
                  -76.6294,
                  39.331253
                ],
                [
                  -76.631254,
                  39.331172
                ],
                [
                  -76.631359,
                  39.332814
                ],
                [
                  -76.632791,
                  39.332743
                ],
                [
                  -76.635446,
                  39.332613
                ],
                [
                  -76.635638,
                  39.333202
                ],
                [
                  -76.636612,
                  39.336424
                ],
                [
                  -76.636825,
                  39.336893
                ],
                [
                  -76.637361,
                  39.337635
                ],
                [
                  -76.638982,
                  39.340027
                ],
                [
                  -76.639511,
                  39.341087
                ],
                [
                  -76.640218,
                  39.343174
                ],
                [
                  -76.640283,
                  39.343372
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "260102",
          "AFFGEOID": "1400000US24510260102",
          "GEOID": "24510260102",
          "NAME": "2601.02",
          "NAMELSAD": "Census Tract 2601.02",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1451520,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.55166,
                  39.338122
                ],
                [
                  -76.54808,
                  39.3406
                ],
                [
                  -76.547409,
                  39.341103
                ],
                [
                  -76.545574,
                  39.342364
                ],
                [
                  -76.541467,
                  39.339465
                ],
                [
                  -76.540625,
                  39.337798
                ],
                [
                  -76.539931,
                  39.337283
                ],
                [
                  -76.53896,
                  39.336832
                ],
                [
                  -76.537755,
                  39.336732
                ],
                [
                  -76.535872,
                  39.336957
                ],
                [
                  -76.533694,
                  39.337208
                ],
                [
                  -76.530318,
                  39.335969
                ],
                [
                  -76.529693,
                  39.336142
                ],
                [
                  -76.52968,
                  39.335246
                ],
                [
                  -76.529685,
                  39.33115
                ],
                [
                  -76.532977,
                  39.330558
                ],
                [
                  -76.534533,
                  39.33028
                ],
                [
                  -76.535007,
                  39.330198
                ],
                [
                  -76.538042,
                  39.329735
                ],
                [
                  -76.541721,
                  39.329213
                ],
                [
                  -76.543521,
                  39.331136
                ],
                [
                  -76.543988,
                  39.331596
                ],
                [
                  -76.547481,
                  39.333472
                ],
                [
                  -76.548004,
                  39.333966
                ],
                [
                  -76.548533,
                  39.335248
                ],
                [
                  -76.55166,
                  39.338122
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "270101",
          "AFFGEOID": "1400000US24510270101",
          "GEOID": "24510270101",
          "NAME": "2701.01",
          "NAMELSAD": "Census Tract 2701.01",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 954113,
          "AWATER": 2251
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.576547,
                  39.333861
                ],
                [
                  -76.575221,
                  39.335243
                ],
                [
                  -76.573154,
                  39.335787
                ],
                [
                  -76.572095,
                  39.336117
                ],
                [
                  -76.571468,
                  39.336506
                ],
                [
                  -76.56955,
                  39.338052
                ],
                [
                  -76.568325,
                  39.339026
                ],
                [
                  -76.567424,
                  39.339556
                ],
                [
                  -76.5672,
                  39.339075
                ],
                [
                  -76.565121,
                  39.337286
                ],
                [
                  -76.564844,
                  39.336822
                ],
                [
                  -76.563823,
                  39.335053
                ],
                [
                  -76.561612,
                  39.331095
                ],
                [
                  -76.56412,
                  39.329249
                ],
                [
                  -76.565965,
                  39.327734
                ],
                [
                  -76.567543,
                  39.326406
                ],
                [
                  -76.568236,
                  39.327416
                ],
                [
                  -76.570771,
                  39.32721
                ],
                [
                  -76.569928,
                  39.32954
                ],
                [
                  -76.575302,
                  39.33222
                ],
                [
                  -76.576547,
                  39.333861
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "150300",
          "AFFGEOID": "1400000US24510150300",
          "GEOID": "24510150300",
          "NAME": "1503",
          "NAMELSAD": "Census Tract 1503",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 399171,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.659985,
                  39.309368
                ],
                [
                  -76.655994,
                  39.309508
                ],
                [
                  -76.65413,
                  39.309567
                ],
                [
                  -76.652712,
                  39.309613
                ],
                [
                  -76.651339,
                  39.30968
                ],
                [
                  -76.651191,
                  39.307766
                ],
                [
                  -76.651048,
                  39.305115
                ],
                [
                  -76.651715,
                  39.305093
                ],
                [
                  -76.651607,
                  39.30335
                ],
                [
                  -76.653788,
                  39.303909
                ],
                [
                  -76.657936,
                  39.305372
                ],
                [
                  -76.659038,
                  39.306252
                ],
                [
                  -76.659292,
                  39.306518
                ],
                [
                  -76.660015,
                  39.308331
                ],
                [
                  -76.659985,
                  39.309368
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "151000",
          "AFFGEOID": "1400000US24510151000",
          "GEOID": "24510151000",
          "NAME": "1510",
          "NAMELSAD": "Census Tract 1510",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1484009,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.689675,
                  39.333394
                ],
                [
                  -76.689361,
                  39.333977
                ],
                [
                  -76.689347,
                  39.336633
                ],
                [
                  -76.689362,
                  39.337676
                ],
                [
                  -76.689373,
                  39.339732
                ],
                [
                  -76.689379,
                  39.340754
                ],
                [
                  -76.683477,
                  39.340794
                ],
                [
                  -76.682916,
                  39.341435
                ],
                [
                  -76.677964,
                  39.339925
                ],
                [
                  -76.679197,
                  39.338172
                ],
                [
                  -76.679078,
                  39.337035
                ],
                [
                  -76.678891,
                  39.335313
                ],
                [
                  -76.678674,
                  39.331757
                ],
                [
                  -76.679667,
                  39.329778
                ],
                [
                  -76.681068,
                  39.326945
                ],
                [
                  -76.681281,
                  39.326491
                ],
                [
                  -76.682092,
                  39.325027
                ],
                [
                  -76.682564,
                  39.325842
                ],
                [
                  -76.684189,
                  39.325351
                ],
                [
                  -76.690069,
                  39.323586
                ],
                [
                  -76.687999,
                  39.327696
                ],
                [
                  -76.687421,
                  39.328837
                ],
                [
                  -76.68858,
                  39.329184
                ],
                [
                  -76.688646,
                  39.330431
                ],
                [
                  -76.690866,
                  39.331013
                ],
                [
                  -76.689675,
                  39.333394
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "280302",
          "AFFGEOID": "1400000US24510280302",
          "GEOID": "24510280302",
          "NAME": "2803.02",
          "NAMELSAD": "Census Tract 2803.02",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1006761,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.703947,
                  39.318582
                ],
                [
                  -76.70177,
                  39.319596
                ],
                [
                  -76.70002,
                  39.320303
                ],
                [
                  -76.699953,
                  39.320325
                ],
                [
                  -76.693036,
                  39.322693
                ],
                [
                  -76.690198,
                  39.323552
                ],
                [
                  -76.690069,
                  39.323586
                ],
                [
                  -76.689789,
                  39.323065
                ],
                [
                  -76.689193,
                  39.32202
                ],
                [
                  -76.690145,
                  39.320985
                ],
                [
                  -76.687508,
                  39.321083
                ],
                [
                  -76.688862,
                  39.31903
                ],
                [
                  -76.688122,
                  39.31795
                ],
                [
                  -76.687295,
                  39.315497
                ],
                [
                  -76.686725,
                  39.315368
                ],
                [
                  -76.685822,
                  39.314413
                ],
                [
                  -76.685457,
                  39.312767
                ],
                [
                  -76.686069,
                  39.312516
                ],
                [
                  -76.689421,
                  39.312335
                ],
                [
                  -76.690004,
                  39.312386
                ],
                [
                  -76.692676,
                  39.314446
                ],
                [
                  -76.696412,
                  39.314793
                ],
                [
                  -76.697315,
                  39.317414
                ],
                [
                  -76.700037,
                  39.317043
                ],
                [
                  -76.702045,
                  39.315702
                ],
                [
                  -76.703947,
                  39.318582
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "270102",
          "AFFGEOID": "1400000US24510270102",
          "GEOID": "24510270102",
          "NAME": "2701.02",
          "NAMELSAD": "Census Tract 2701.02",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1021027,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.567424,
                  39.339556
                ],
                [
                  -76.563815,
                  39.341549
                ],
                [
                  -76.562998,
                  39.342016
                ],
                [
                  -76.561687,
                  39.343016
                ],
                [
                  -76.560887,
                  39.343606
                ],
                [
                  -76.55939,
                  39.344439
                ],
                [
                  -76.558147,
                  39.345185
                ],
                [
                  -76.556947,
                  39.343776
                ],
                [
                  -76.555376,
                  39.34192
                ],
                [
                  -76.554799,
                  39.341218
                ],
                [
                  -76.553285,
                  39.339229
                ],
                [
                  -76.552441,
                  39.337614
                ],
                [
                  -76.554456,
                  39.336185
                ],
                [
                  -76.556985,
                  39.33443
                ],
                [
                  -76.558902,
                  39.333078
                ],
                [
                  -76.559542,
                  39.33263
                ],
                [
                  -76.561612,
                  39.331095
                ],
                [
                  -76.563823,
                  39.335053
                ],
                [
                  -76.564844,
                  39.336822
                ],
                [
                  -76.565121,
                  39.337286
                ],
                [
                  -76.5672,
                  39.339075
                ],
                [
                  -76.567424,
                  39.339556
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "250205",
          "AFFGEOID": "1400000US24510250205",
          "GEOID": "24510250205",
          "NAME": "2502.05",
          "NAMELSAD": "Census Tract 2502.05",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 2316099,
          "AWATER": 14427
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.657559,
                  39.256784
                ],
                [
                  -76.65251,
                  39.258401
                ],
                [
                  -76.649834,
                  39.260314
                ],
                [
                  -76.64536,
                  39.260014
                ],
                [
                  -76.643351,
                  39.259375
                ],
                [
                  -76.64066,
                  39.257567
                ],
                [
                  -76.637462,
                  39.253807
                ],
                [
                  -76.634109,
                  39.249845
                ],
                [
                  -76.629762,
                  39.244547
                ],
                [
                  -76.62867,
                  39.243473
                ],
                [
                  -76.627985,
                  39.242996
                ],
                [
                  -76.625756,
                  39.242103
                ],
                [
                  -76.621721,
                  39.241702
                ],
                [
                  -76.615308,
                  39.241144
                ],
                [
                  -76.614642,
                  39.241092
                ],
                [
                  -76.615641,
                  39.239922
                ],
                [
                  -76.618612,
                  39.237398
                ],
                [
                  -76.619039,
                  39.237727
                ],
                [
                  -76.629853,
                  39.242338
                ],
                [
                  -76.632589,
                  39.243406
                ],
                [
                  -76.637267,
                  39.245648
                ],
                [
                  -76.639428,
                  39.246568
                ],
                [
                  -76.640328,
                  39.24703
                ],
                [
                  -76.644212,
                  39.248924
                ],
                [
                  -76.647256,
                  39.25006
                ],
                [
                  -76.655569,
                  39.253701
                ],
                [
                  -76.65986,
                  39.255509
                ],
                [
                  -76.657559,
                  39.256784
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "280402",
          "AFFGEOID": "1400000US24510280402",
          "GEOID": "24510280402",
          "NAME": "2804.02",
          "NAMELSAD": "Census Tract 2804.02",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 561712,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.694866,
                  39.302016
                ],
                [
                  -76.694509,
                  39.304737
                ],
                [
                  -76.689582,
                  39.305099
                ],
                [
                  -76.6895,
                  39.304372
                ],
                [
                  -76.690092,
                  39.302306
                ],
                [
                  -76.688139,
                  39.299172
                ],
                [
                  -76.686275,
                  39.299217
                ],
                [
                  -76.686193,
                  39.297742
                ],
                [
                  -76.686101,
                  39.29625
                ],
                [
                  -76.685995,
                  39.293711
                ],
                [
                  -76.689425,
                  39.293581
                ],
                [
                  -76.689442,
                  39.294111
                ],
                [
                  -76.692248,
                  39.296117
                ],
                [
                  -76.691572,
                  39.296734
                ],
                [
                  -76.693512,
                  39.297922
                ],
                [
                  -76.692406,
                  39.298946
                ],
                [
                  -76.69471,
                  39.301837
                ],
                [
                  -76.694866,
                  39.302016
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "271501",
          "AFFGEOID": "1400000US24510271501",
          "GEOID": "24510271501",
          "NAME": "2715.01",
          "NAMELSAD": "Census Tract 2715.01",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 3628340,
          "AWATER": 18282
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.678191,
                  39.371994
                ],
                [
                  -76.666192,
                  39.372005
                ],
                [
                  -76.659997,
                  39.372096
                ],
                [
                  -76.657792,
                  39.371993
                ],
                [
                  -76.652738,
                  39.372105
                ],
                [
                  -76.649803,
                  39.372104
                ],
                [
                  -76.649041,
                  39.372181
                ],
                [
                  -76.648769,
                  39.371166
                ],
                [
                  -76.649353,
                  39.370648
                ],
                [
                  -76.649165,
                  39.37014
                ],
                [
                  -76.646257,
                  39.361444
                ],
                [
                  -76.648588,
                  39.361042
                ],
                [
                  -76.650551,
                  39.360533
                ],
                [
                  -76.651161,
                  39.360396
                ],
                [
                  -76.654802,
                  39.357503
                ],
                [
                  -76.660408,
                  39.355193
                ],
                [
                  -76.662208,
                  39.355033
                ],
                [
                  -76.66413,
                  39.355769
                ],
                [
                  -76.665964,
                  39.357613
                ],
                [
                  -76.670848,
                  39.356788
                ],
                [
                  -76.671515,
                  39.359701
                ],
                [
                  -76.67133,
                  39.361955
                ],
                [
                  -76.672967,
                  39.36408
                ],
                [
                  -76.673109,
                  39.364244
                ],
                [
                  -76.673301,
                  39.364466
                ],
                [
                  -76.67336,
                  39.364547
                ],
                [
                  -76.674202,
                  39.366381
                ],
                [
                  -76.677545,
                  39.369693
                ],
                [
                  -76.678191,
                  39.371994
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "230200",
          "AFFGEOID": "1400000US24510230200",
          "GEOID": "24510230200",
          "NAME": "2302",
          "NAMELSAD": "Census Tract 2302",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 217596,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.616111,
                  39.272553
                ],
                [
                  -76.615266,
                  39.272582
                ],
                [
                  -76.614111,
                  39.272617
                ],
                [
                  -76.614159,
                  39.273657
                ],
                [
                  -76.614295,
                  39.275772
                ],
                [
                  -76.614525,
                  39.278985
                ],
                [
                  -76.612623,
                  39.27889
                ],
                [
                  -76.612375,
                  39.277052
                ],
                [
                  -76.612227,
                  39.276019
                ],
                [
                  -76.612049,
                  39.2747
                ],
                [
                  -76.611963,
                  39.274215
                ],
                [
                  -76.611843,
                  39.273257
                ],
                [
                  -76.611754,
                  39.2727
                ],
                [
                  -76.611504,
                  39.271142
                ],
                [
                  -76.611579,
                  39.270613
                ],
                [
                  -76.615953,
                  39.270453
                ],
                [
                  -76.616111,
                  39.272553
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "270501",
          "AFFGEOID": "1400000US24510270501",
          "GEOID": "24510270501",
          "NAME": "2705.01",
          "NAMELSAD": "Census Tract 2705.01",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 2319872,
          "AWATER": 2012
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.551464,
                  39.363897
                ],
                [
                  -76.548423,
                  39.367386
                ],
                [
                  -76.547824,
                  39.36807
                ],
                [
                  -76.544243,
                  39.372181
                ],
                [
                  -76.5405,
                  39.37211
                ],
                [
                  -76.538593,
                  39.372107
                ],
                [
                  -76.535287,
                  39.372106
                ],
                [
                  -76.529793,
                  39.372058
                ],
                [
                  -76.529787,
                  39.371606
                ],
                [
                  -76.529786,
                  39.366206
                ],
                [
                  -76.529686,
                  39.365706
                ],
                [
                  -76.52979,
                  39.363815
                ],
                [
                  -76.529785,
                  39.356552
                ],
                [
                  -76.535294,
                  39.358001
                ],
                [
                  -76.536979,
                  39.358255
                ],
                [
                  -76.537491,
                  39.358266
                ],
                [
                  -76.539224,
                  39.358825
                ],
                [
                  -76.544112,
                  39.360572
                ],
                [
                  -76.54775,
                  39.361901
                ],
                [
                  -76.551894,
                  39.363406
                ],
                [
                  -76.551464,
                  39.363897
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "270901",
          "AFFGEOID": "1400000US24510270901",
          "GEOID": "24510270901",
          "NAME": "2709.01",
          "NAMELSAD": "Census Tract 2709.01",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 677441,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.599376,
                  39.347277
                ],
                [
                  -76.599042,
                  39.349398
                ],
                [
                  -76.598833,
                  39.350714
                ],
                [
                  -76.598746,
                  39.351246
                ],
                [
                  -76.598571,
                  39.352377
                ],
                [
                  -76.598289,
                  39.354166
                ],
                [
                  -76.596944,
                  39.354001
                ],
                [
                  -76.595733,
                  39.354022
                ],
                [
                  -76.594666,
                  39.354075
                ],
                [
                  -76.593326,
                  39.354131
                ],
                [
                  -76.592136,
                  39.354367
                ],
                [
                  -76.589561,
                  39.355418
                ],
                [
                  -76.589787,
                  39.353931
                ],
                [
                  -76.590374,
                  39.352207
                ],
                [
                  -76.590955,
                  39.350575
                ],
                [
                  -76.591137,
                  39.35003
                ],
                [
                  -76.591419,
                  39.349263
                ],
                [
                  -76.591924,
                  39.34665
                ],
                [
                  -76.592006,
                  39.346163
                ],
                [
                  -76.592247,
                  39.346162
                ],
                [
                  -76.593567,
                  39.346021
                ],
                [
                  -76.595458,
                  39.345174
                ],
                [
                  -76.595891,
                  39.345008
                ],
                [
                  -76.597097,
                  39.344893
                ],
                [
                  -76.599729,
                  39.345149
                ],
                [
                  -76.599376,
                  39.347277
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "270402",
          "AFFGEOID": "1400000US24510270402",
          "GEOID": "24510270402",
          "NAME": "2704.02",
          "NAMELSAD": "Census Tract 2704.02",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1201224,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.56249,
                  39.35115
                ],
                [
                  -76.561603,
                  39.352177
                ],
                [
                  -76.560608,
                  39.353305
                ],
                [
                  -76.55986,
                  39.354183
                ],
                [
                  -76.55917,
                  39.354999
                ],
                [
                  -76.557859,
                  39.356511
                ],
                [
                  -76.557731,
                  39.356658
                ],
                [
                  -76.551914,
                  39.355052
                ],
                [
                  -76.548048,
                  39.354
                ],
                [
                  -76.547015,
                  39.353734
                ],
                [
                  -76.545862,
                  39.353607
                ],
                [
                  -76.543894,
                  39.353469
                ],
                [
                  -76.542666,
                  39.353531
                ],
                [
                  -76.543198,
                  39.351548
                ],
                [
                  -76.545591,
                  39.350384
                ],
                [
                  -76.54875,
                  39.348912
                ],
                [
                  -76.551134,
                  39.347743
                ],
                [
                  -76.552096,
                  39.34742
                ],
                [
                  -76.554682,
                  39.346922
                ],
                [
                  -76.558147,
                  39.345185
                ],
                [
                  -76.560257,
                  39.347685
                ],
                [
                  -76.560885,
                  39.348354
                ],
                [
                  -76.563355,
                  39.350138
                ],
                [
                  -76.56249,
                  39.35115
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "260301",
          "AFFGEOID": "1400000US24510260301",
          "GEOID": "24510260301",
          "NAME": "2603.01",
          "NAMELSAD": "Census Tract 2603.01",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 607369,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.573745,
                  39.321612
                ],
                [
                  -76.571286,
                  39.323389
                ],
                [
                  -76.570698,
                  39.323844
                ],
                [
                  -76.569634,
                  39.32472
                ],
                [
                  -76.569447,
                  39.32488
                ],
                [
                  -76.568405,
                  39.325727
                ],
                [
                  -76.567543,
                  39.326406
                ],
                [
                  -76.565589,
                  39.325222
                ],
                [
                  -76.562605,
                  39.32467
                ],
                [
                  -76.561433,
                  39.323472
                ],
                [
                  -76.560491,
                  39.321176
                ],
                [
                  -76.559759,
                  39.320994
                ],
                [
                  -76.56054,
                  39.320224
                ],
                [
                  -76.562827,
                  39.31975
                ],
                [
                  -76.563815,
                  39.319563
                ],
                [
                  -76.564966,
                  39.319417
                ],
                [
                  -76.565923,
                  39.319299
                ],
                [
                  -76.56647,
                  39.319221
                ],
                [
                  -76.567534,
                  39.319085
                ],
                [
                  -76.569962,
                  39.318792
                ],
                [
                  -76.570439,
                  39.318423
                ],
                [
                  -76.571103,
                  39.319612
                ],
                [
                  -76.571729,
                  39.320259
                ],
                [
                  -76.573745,
                  39.321612
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "030200",
          "AFFGEOID": "1400000US24510030200",
          "GEOID": "24510030200",
          "NAME": "302",
          "NAMELSAD": "Census Tract 302",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 506034,
          "AWATER": 91912
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.606429,
                  39.290712
                ],
                [
                  -76.605762,
                  39.290884
                ],
                [
                  -76.603006,
                  39.291641
                ],
                [
                  -76.599687,
                  39.292536
                ],
                [
                  -76.599636,
                  39.291864
                ],
                [
                  -76.599565,
                  39.290217
                ],
                [
                  -76.59946,
                  39.289033
                ],
                [
                  -76.599442,
                  39.288742
                ],
                [
                  -76.599415,
                  39.288364
                ],
                [
                  -76.599281,
                  39.286355
                ],
                [
                  -76.599227,
                  39.285337
                ],
                [
                  -76.599009,
                  39.282253
                ],
                [
                  -76.600218,
                  39.281526
                ],
                [
                  -76.600513,
                  39.280822
                ],
                [
                  -76.602588,
                  39.279506
                ],
                [
                  -76.602788,
                  39.279806
                ],
                [
                  -76.603688,
                  39.280906
                ],
                [
                  -76.60401,
                  39.282894
                ],
                [
                  -76.604436,
                  39.284283
                ],
                [
                  -76.604604,
                  39.285099
                ],
                [
                  -76.60515,
                  39.286689
                ],
                [
                  -76.605001,
                  39.286855
                ],
                [
                  -76.605139,
                  39.286851
                ],
                [
                  -76.605805,
                  39.289962
                ],
                [
                  -76.606429,
                  39.290712
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "250102",
          "AFFGEOID": "1400000US24510250102",
          "GEOID": "24510250102",
          "NAME": "2501.02",
          "NAMELSAD": "Census Tract 2501.02",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 737636,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.695724,
                  39.27794
                ],
                [
                  -76.694633,
                  39.279374
                ],
                [
                  -76.694546,
                  39.280063
                ],
                [
                  -76.693682,
                  39.281443
                ],
                [
                  -76.692931,
                  39.281469
                ],
                [
                  -76.686706,
                  39.281656
                ],
                [
                  -76.68561,
                  39.281679
                ],
                [
                  -76.685903,
                  39.27822
                ],
                [
                  -76.683581,
                  39.276569
                ],
                [
                  -76.688192,
                  39.274505
                ],
                [
                  -76.689454,
                  39.272116
                ],
                [
                  -76.69268,
                  39.271824
                ],
                [
                  -76.692922,
                  39.272496
                ],
                [
                  -76.694154,
                  39.275294
                ],
                [
                  -76.695152,
                  39.276352
                ],
                [
                  -76.695724,
                  39.27794
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "260201",
          "AFFGEOID": "1400000US24510260201",
          "GEOID": "24510260201",
          "NAME": "2602.01",
          "NAMELSAD": "Census Tract 2602.01",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1648547,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.561612,
                  39.331095
                ],
                [
                  -76.559542,
                  39.33263
                ],
                [
                  -76.558902,
                  39.333078
                ],
                [
                  -76.556985,
                  39.33443
                ],
                [
                  -76.554456,
                  39.336185
                ],
                [
                  -76.552441,
                  39.337614
                ],
                [
                  -76.55166,
                  39.338122
                ],
                [
                  -76.548533,
                  39.335248
                ],
                [
                  -76.548004,
                  39.333966
                ],
                [
                  -76.547481,
                  39.333472
                ],
                [
                  -76.543988,
                  39.331596
                ],
                [
                  -76.543521,
                  39.331136
                ],
                [
                  -76.541721,
                  39.329213
                ],
                [
                  -76.540754,
                  39.323623
                ],
                [
                  -76.542892,
                  39.322952
                ],
                [
                  -76.545266,
                  39.32225
                ],
                [
                  -76.548442,
                  39.32183
                ],
                [
                  -76.548647,
                  39.322535
                ],
                [
                  -76.551669,
                  39.325844
                ],
                [
                  -76.551788,
                  39.325781
                ],
                [
                  -76.555031,
                  39.327677
                ],
                [
                  -76.558756,
                  39.328963
                ],
                [
                  -76.560908,
                  39.330402
                ],
                [
                  -76.561612,
                  39.331095
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "040100",
          "AFFGEOID": "1400000US24510040100",
          "GEOID": "24510040100",
          "NAME": "401",
          "NAMELSAD": "Census Tract 401",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1189600,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.622638,
                  39.294812
                ],
                [
                  -76.621285,
                  39.294861
                ],
                [
                  -76.619819,
                  39.294931
                ],
                [
                  -76.618322,
                  39.294978
                ],
                [
                  -76.616933,
                  39.295049
                ],
                [
                  -76.615549,
                  39.295092
                ],
                [
                  -76.614342,
                  39.29512
                ],
                [
                  -76.613686,
                  39.294496
                ],
                [
                  -76.611252,
                  39.294523
                ],
                [
                  -76.611007,
                  39.294532
                ],
                [
                  -76.610541,
                  39.293472
                ],
                [
                  -76.606429,
                  39.290712
                ],
                [
                  -76.605805,
                  39.289962
                ],
                [
                  -76.605139,
                  39.286851
                ],
                [
                  -76.610722,
                  39.286652
                ],
                [
                  -76.612128,
                  39.286603
                ],
                [
                  -76.614896,
                  39.286513
                ],
                [
                  -76.617551,
                  39.286378
                ],
                [
                  -76.619332,
                  39.286316
                ],
                [
                  -76.620755,
                  39.286261
                ],
                [
                  -76.622129,
                  39.286257
                ],
                [
                  -76.62233,
                  39.289245
                ],
                [
                  -76.622571,
                  39.293837
                ],
                [
                  -76.622638,
                  39.294812
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "150800",
          "AFFGEOID": "1400000US24510150800",
          "GEOID": "24510150800",
          "NAME": "1508",
          "NAMELSAD": "Census Tract 1508",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1089496,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.682747,
                  39.322852
                ],
                [
                  -76.681084,
                  39.323358
                ],
                [
                  -76.682092,
                  39.325027
                ],
                [
                  -76.681281,
                  39.326491
                ],
                [
                  -76.681068,
                  39.326945
                ],
                [
                  -76.676491,
                  39.325672
                ],
                [
                  -76.674659,
                  39.325134
                ],
                [
                  -76.67145,
                  39.324189
                ],
                [
                  -76.67171,
                  39.323714
                ],
                [
                  -76.672888,
                  39.321345
                ],
                [
                  -76.674532,
                  39.321829
                ],
                [
                  -76.674862,
                  39.321181
                ],
                [
                  -76.674495,
                  39.315238
                ],
                [
                  -76.67443,
                  39.314334
                ],
                [
                  -76.674418,
                  39.314163
                ],
                [
                  -76.674239,
                  39.311032
                ],
                [
                  -76.676016,
                  39.310916
                ],
                [
                  -76.680565,
                  39.310762
                ],
                [
                  -76.680965,
                  39.313028
                ],
                [
                  -76.681102,
                  39.313922
                ],
                [
                  -76.681133,
                  39.314092
                ],
                [
                  -76.681301,
                  39.315002
                ],
                [
                  -76.68164,
                  39.318101
                ],
                [
                  -76.681841,
                  39.32009
                ],
                [
                  -76.681914,
                  39.321316
                ],
                [
                  -76.682747,
                  39.322852
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "210200",
          "AFFGEOID": "1400000US24510210200",
          "GEOID": "24510210200",
          "NAME": "2102",
          "NAMELSAD": "Census Tract 2102",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 2386963,
          "AWATER": 12265
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.655024,
                  39.275331
                ],
                [
                  -76.654919,
                  39.275524
                ],
                [
                  -76.654552,
                  39.276152
                ],
                [
                  -76.652902,
                  39.277465
                ],
                [
                  -76.651,
                  39.278227
                ],
                [
                  -76.647977,
                  39.279075
                ],
                [
                  -76.646426,
                  39.279489
                ],
                [
                  -76.641861,
                  39.280991
                ],
                [
                  -76.638979,
                  39.282402
                ],
                [
                  -76.637843,
                  39.282788
                ],
                [
                  -76.637984,
                  39.285587
                ],
                [
                  -76.631959,
                  39.285866
                ],
                [
                  -76.630532,
                  39.285937
                ],
                [
                  -76.630025,
                  39.285965
                ],
                [
                  -76.629019,
                  39.286009
                ],
                [
                  -76.628883,
                  39.283794
                ],
                [
                  -76.63185,
                  39.283689
                ],
                [
                  -76.632669,
                  39.283633
                ],
                [
                  -76.632821,
                  39.283117
                ],
                [
                  -76.632531,
                  39.282893
                ],
                [
                  -76.630343,
                  39.281257
                ],
                [
                  -76.634597,
                  39.277969
                ],
                [
                  -76.632848,
                  39.276638
                ],
                [
                  -76.628731,
                  39.273467
                ],
                [
                  -76.631928,
                  39.270884
                ],
                [
                  -76.633472,
                  39.269545
                ],
                [
                  -76.63733,
                  39.27014
                ],
                [
                  -76.639054,
                  39.270421
                ],
                [
                  -76.64737,
                  39.271164
                ],
                [
                  -76.648078,
                  39.271221
                ],
                [
                  -76.648408,
                  39.271251
                ],
                [
                  -76.653264,
                  39.271539
                ],
                [
                  -76.654996,
                  39.271192
                ],
                [
                  -76.655335,
                  39.274523
                ],
                [
                  -76.655024,
                  39.275331
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "150200",
          "AFFGEOID": "1400000US24510150200",
          "GEOID": "24510150200",
          "NAME": "1502",
          "NAMELSAD": "Census Tract 1502",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 420327,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.651715,
                  39.305093
                ],
                [
                  -76.651048,
                  39.305115
                ],
                [
                  -76.651191,
                  39.307766
                ],
                [
                  -76.651339,
                  39.30968
                ],
                [
                  -76.646496,
                  39.30989
                ],
                [
                  -76.645006,
                  39.309944
                ],
                [
                  -76.644913,
                  39.308006
                ],
                [
                  -76.644839,
                  39.306727
                ],
                [
                  -76.644769,
                  39.305352
                ],
                [
                  -76.644643,
                  39.303176
                ],
                [
                  -76.646118,
                  39.303112
                ],
                [
                  -76.647787,
                  39.303062
                ],
                [
                  -76.647717,
                  39.302305
                ],
                [
                  -76.64865,
                  39.302917
                ],
                [
                  -76.649841,
                  39.303102
                ],
                [
                  -76.651607,
                  39.30335
                ],
                [
                  -76.651715,
                  39.305093
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "250204",
          "AFFGEOID": "1400000US24510250204",
          "GEOID": "24510250204",
          "NAME": "2502.04",
          "NAMELSAD": "Census Tract 2502.04",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 861732,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.634553,
                  39.255971
                ],
                [
                  -76.633708,
                  39.258598
                ],
                [
                  -76.633505,
                  39.258348
                ],
                [
                  -76.632768,
                  39.257731
                ],
                [
                  -76.634267,
                  39.255611
                ],
                [
                  -76.63405,
                  39.254063
                ],
                [
                  -76.632601,
                  39.251544
                ],
                [
                  -76.628077,
                  39.250031
                ],
                [
                  -76.627427,
                  39.25158
                ],
                [
                  -76.625351,
                  39.250045
                ],
                [
                  -76.627535,
                  39.249821
                ],
                [
                  -76.625398,
                  39.249082
                ],
                [
                  -76.623857,
                  39.248517
                ],
                [
                  -76.623001,
                  39.248131
                ],
                [
                  -76.618824,
                  39.24575
                ],
                [
                  -76.619496,
                  39.244593
                ],
                [
                  -76.621489,
                  39.241906
                ],
                [
                  -76.621721,
                  39.241702
                ],
                [
                  -76.625756,
                  39.242103
                ],
                [
                  -76.627985,
                  39.242996
                ],
                [
                  -76.62867,
                  39.243473
                ],
                [
                  -76.629762,
                  39.244547
                ],
                [
                  -76.634109,
                  39.249845
                ],
                [
                  -76.635045,
                  39.251641
                ],
                [
                  -76.634553,
                  39.255971
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "270301",
          "AFFGEOID": "1400000US24510270301",
          "GEOID": "24510270301",
          "NAME": "2703.01",
          "NAMELSAD": "Census Tract 2703.01",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1138525,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.581827,
                  39.349018
                ],
                [
                  -76.579488,
                  39.350405
                ],
                [
                  -76.577609,
                  39.349775
                ],
                [
                  -76.577649,
                  39.352457
                ],
                [
                  -76.57418,
                  39.352651
                ],
                [
                  -76.573015,
                  39.353903
                ],
                [
                  -76.572549,
                  39.353808
                ],
                [
                  -76.570315,
                  39.353439
                ],
                [
                  -76.569183,
                  39.353248
                ],
                [
                  -76.568117,
                  39.353064
                ],
                [
                  -76.566612,
                  39.352787
                ],
                [
                  -76.565726,
                  39.352393
                ],
                [
                  -76.563355,
                  39.350138
                ],
                [
                  -76.564377,
                  39.348936
                ],
                [
                  -76.565274,
                  39.347859
                ],
                [
                  -76.565937,
                  39.347063
                ],
                [
                  -76.56618,
                  39.346778
                ],
                [
                  -76.567246,
                  39.345389
                ],
                [
                  -76.568321,
                  39.34376
                ],
                [
                  -76.569136,
                  39.342826
                ],
                [
                  -76.57134,
                  39.344489
                ],
                [
                  -76.573724,
                  39.345561
                ],
                [
                  -76.574478,
                  39.345725
                ],
                [
                  -76.57707,
                  39.345409
                ],
                [
                  -76.579179,
                  39.345194
                ],
                [
                  -76.580805,
                  39.345277
                ],
                [
                  -76.581206,
                  39.346997
                ],
                [
                  -76.581297,
                  39.348292
                ],
                [
                  -76.581827,
                  39.349018
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "271400",
          "AFFGEOID": "1400000US24510271400",
          "GEOID": "24510271400",
          "NAME": "2714",
          "NAMELSAD": "Census Tract 2714",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1717441,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.643328,
                  39.35316
                ],
                [
                  -76.639668,
                  39.353044
                ],
                [
                  -76.637464,
                  39.353843
                ],
                [
                  -76.634064,
                  39.353133
                ],
                [
                  -76.632222,
                  39.353076
                ],
                [
                  -76.629227,
                  39.353429
                ],
                [
                  -76.628184,
                  39.348748
                ],
                [
                  -76.626282,
                  39.34506
                ],
                [
                  -76.625629,
                  39.344001
                ],
                [
                  -76.625785,
                  39.341591
                ],
                [
                  -76.625744,
                  39.339604
                ],
                [
                  -76.624024,
                  39.336479
                ],
                [
                  -76.624544,
                  39.336791
                ],
                [
                  -76.625566,
                  39.33735
                ],
                [
                  -76.627683,
                  39.339122
                ],
                [
                  -76.62858,
                  39.339436
                ],
                [
                  -76.631389,
                  39.339326
                ],
                [
                  -76.632506,
                  39.3402
                ],
                [
                  -76.634251,
                  39.341418
                ],
                [
                  -76.634624,
                  39.341765
                ],
                [
                  -76.635163,
                  39.342645
                ],
                [
                  -76.635382,
                  39.34388
                ],
                [
                  -76.63917,
                  39.343066
                ],
                [
                  -76.640283,
                  39.343372
                ],
                [
                  -76.642035,
                  39.348863
                ],
                [
                  -76.643328,
                  39.35316
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "280403",
          "AFFGEOID": "1400000US24510280403",
          "GEOID": "24510280403",
          "NAME": "2804.03",
          "NAMELSAD": "Census Tract 2804.03",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1831350,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.711188,
                  39.281837
                ],
                [
                  -76.711186,
                  39.287394
                ],
                [
                  -76.711015,
                  39.289603
                ],
                [
                  -76.711195,
                  39.291749
                ],
                [
                  -76.708124,
                  39.291882
                ],
                [
                  -76.703902,
                  39.292431
                ],
                [
                  -76.699264,
                  39.292847
                ],
                [
                  -76.697993,
                  39.29306
                ],
                [
                  -76.697204,
                  39.289137
                ],
                [
                  -76.695944,
                  39.288681
                ],
                [
                  -76.693892,
                  39.285755
                ],
                [
                  -76.693817,
                  39.28484
                ],
                [
                  -76.692931,
                  39.281469
                ],
                [
                  -76.693682,
                  39.281443
                ],
                [
                  -76.695717,
                  39.281391
                ],
                [
                  -76.698046,
                  39.281334
                ],
                [
                  -76.699012,
                  39.281274
                ],
                [
                  -76.70264,
                  39.280857
                ],
                [
                  -76.705495,
                  39.280813
                ],
                [
                  -76.706764,
                  39.279696
                ],
                [
                  -76.708944,
                  39.278713
                ],
                [
                  -76.709839,
                  39.278359
                ],
                [
                  -76.711054,
                  39.277889
                ],
                [
                  -76.711132,
                  39.278262
                ],
                [
                  -76.711232,
                  39.278797
                ],
                [
                  -76.711188,
                  39.281837
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "250500",
          "AFFGEOID": "1400000US24510250500",
          "GEOID": "24510250500",
          "NAME": "2505",
          "NAMELSAD": "Census Tract 2505",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 8584546,
          "AWATER": 4070107
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.599308,
                  39.225298
                ],
                [
                  -76.599947,
                  39.226385
                ],
                [
                  -76.59936,
                  39.22746
                ],
                [
                  -76.597981,
                  39.230093
                ],
                [
                  -76.595787,
                  39.234309
                ],
                [
                  -76.597742,
                  39.234898
                ],
                [
                  -76.595552,
                  39.239143
                ],
                [
                  -76.595211,
                  39.239636
                ],
                [
                  -76.596954,
                  39.240977
                ],
                [
                  -76.593105,
                  39.241049
                ],
                [
                  -76.585039,
                  39.232402
                ],
                [
                  -76.582133,
                  39.23199
                ],
                [
                  -76.580587,
                  39.230906
                ],
                [
                  -76.579287,
                  39.226706
                ],
                [
                  -76.577387,
                  39.224906
                ],
                [
                  -76.566186,
                  39.221106
                ],
                [
                  -76.561642,
                  39.220633
                ],
                [
                  -76.55946110415,
                  39.2204060181307
                ],
                [
                  -76.555349,
                  39.216972
                ],
                [
                  -76.5517563742984,
                  39.217231428353
                ],
                [
                  -76.550239,
                  39.217341
                ],
                [
                  -76.549051,
                  39.21375
                ],
                [
                  -76.5490326615279,
                  39.2137462741283
                ],
                [
                  -76.542103336904,
                  39.2123384265186
                ],
                [
                  -76.541801,
                  39.212277
                ],
                [
                  -76.5413313993025,
                  39.212335169006
                ],
                [
                  -76.534285,
                  39.213208
                ],
                [
                  -76.534107800034,
                  39.212949829494
                ],
                [
                  -76.532845,
                  39.21111
                ],
                [
                  -76.532399,
                  39.209993
                ],
                [
                  -76.5330735988679,
                  39.2076476380469
                ],
                [
                  -76.550086,
                  39.197207
                ],
                [
                  -76.555549,
                  39.198984
                ],
                [
                  -76.563786,
                  39.201407
                ],
                [
                  -76.567396,
                  39.202117
                ],
                [
                  -76.571114,
                  39.20382
                ],
                [
                  -76.577295,
                  39.205586
                ],
                [
                  -76.580287,
                  39.206607
                ],
                [
                  -76.582386,
                  39.207151
                ],
                [
                  -76.584077,
                  39.207921
                ],
                [
                  -76.589162,
                  39.213105
                ],
                [
                  -76.590075,
                  39.213979
                ],
                [
                  -76.597437,
                  39.220806
                ],
                [
                  -76.597923,
                  39.221268
                ],
                [
                  -76.600665,
                  39.223734
                ],
                [
                  -76.599308,
                  39.225298
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "190200",
          "AFFGEOID": "1400000US24510190200",
          "GEOID": "24510190200",
          "NAME": "1902",
          "NAMELSAD": "Census Tract 1902",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 266105,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.642413,
                  39.288373
                ],
                [
                  -76.640997,
                  39.28844
                ],
                [
                  -76.638166,
                  39.288566
                ],
                [
                  -76.638101,
                  39.287556
                ],
                [
                  -76.637984,
                  39.285587
                ],
                [
                  -76.637843,
                  39.282788
                ],
                [
                  -76.638979,
                  39.282402
                ],
                [
                  -76.641861,
                  39.280991
                ],
                [
                  -76.641988,
                  39.281604
                ],
                [
                  -76.642168,
                  39.284421
                ],
                [
                  -76.642197,
                  39.285389
                ],
                [
                  -76.642413,
                  39.288373
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "080101",
          "AFFGEOID": "1400000US24510080101",
          "GEOID": "24510080101",
          "NAME": "801.01",
          "NAMELSAD": "Census Tract 801.01",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 2323952,
          "AWATER": 1899
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.592821,
                  39.319178
                ],
                [
                  -76.591683,
                  39.32026
                ],
                [
                  -76.590658,
                  39.321239
                ],
                [
                  -76.589978,
                  39.321861
                ],
                [
                  -76.588534,
                  39.32283
                ],
                [
                  -76.58747,
                  39.323564
                ],
                [
                  -76.584576,
                  39.327047
                ],
                [
                  -76.583702,
                  39.328021
                ],
                [
                  -76.581792,
                  39.329725
                ],
                [
                  -76.580827,
                  39.330558
                ],
                [
                  -76.580342,
                  39.330907
                ],
                [
                  -76.579515,
                  39.331409
                ],
                [
                  -76.578105,
                  39.332461
                ],
                [
                  -76.576547,
                  39.333861
                ],
                [
                  -76.575302,
                  39.33222
                ],
                [
                  -76.569928,
                  39.32954
                ],
                [
                  -76.570771,
                  39.32721
                ],
                [
                  -76.568236,
                  39.327416
                ],
                [
                  -76.567543,
                  39.326406
                ],
                [
                  -76.568405,
                  39.325727
                ],
                [
                  -76.569447,
                  39.32488
                ],
                [
                  -76.569634,
                  39.32472
                ],
                [
                  -76.570698,
                  39.323844
                ],
                [
                  -76.571286,
                  39.323389
                ],
                [
                  -76.573745,
                  39.321612
                ],
                [
                  -76.574591,
                  39.320865
                ],
                [
                  -76.578871,
                  39.317108
                ],
                [
                  -76.581813,
                  39.314553
                ],
                [
                  -76.585062,
                  39.314926
                ],
                [
                  -76.589881,
                  39.316123
                ],
                [
                  -76.594867,
                  39.317238
                ],
                [
                  -76.592821,
                  39.319178
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "110100",
          "AFFGEOID": "1400000US24510110100",
          "GEOID": "24510110100",
          "NAME": "1101",
          "NAMELSAD": "Census Tract 1101",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 313921,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.614655,
                  39.306022
                ],
                [
                  -76.612614,
                  39.305926
                ],
                [
                  -76.61135,
                  39.304715
                ],
                [
                  -76.611516,
                  39.303603
                ],
                [
                  -76.611594,
                  39.302534
                ],
                [
                  -76.611551,
                  39.301224
                ],
                [
                  -76.611424,
                  39.29877
                ],
                [
                  -76.611313,
                  39.297707
                ],
                [
                  -76.611007,
                  39.294532
                ],
                [
                  -76.611252,
                  39.294523
                ],
                [
                  -76.613686,
                  39.294496
                ],
                [
                  -76.614342,
                  39.29512
                ],
                [
                  -76.613993,
                  39.296387
                ],
                [
                  -76.614072,
                  39.297358
                ],
                [
                  -76.61416,
                  39.298672
                ],
                [
                  -76.614243,
                  39.299721
                ],
                [
                  -76.614324,
                  39.301086
                ],
                [
                  -76.614406,
                  39.302461
                ],
                [
                  -76.614482,
                  39.303524
                ],
                [
                  -76.614613,
                  39.305469
                ],
                [
                  -76.614655,
                  39.306022
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "270803",
          "AFFGEOID": "1400000US24510270803",
          "GEOID": "24510270803",
          "NAME": "2708.03",
          "NAMELSAD": "Census Tract 2708.03",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 2190787,
          "AWATER": 2110
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.589582,
                  39.357315
                ],
                [
                  -76.588468,
                  39.359817
                ],
                [
                  -76.587754,
                  39.361281
                ],
                [
                  -76.586309,
                  39.364381
                ],
                [
                  -76.58551,
                  39.366039
                ],
                [
                  -76.584053,
                  39.368525
                ],
                [
                  -76.581956,
                  39.372105
                ],
                [
                  -76.579029,
                  39.372091
                ],
                [
                  -76.571996,
                  39.372108
                ],
                [
                  -76.569997,
                  39.372121
                ],
                [
                  -76.5701,
                  39.372039
                ],
                [
                  -76.573563,
                  39.368539
                ],
                [
                  -76.574048,
                  39.36754
                ],
                [
                  -76.573541,
                  39.365126
                ],
                [
                  -76.573084,
                  39.36009
                ],
                [
                  -76.5734,
                  39.358011
                ],
                [
                  -76.572926,
                  39.357037
                ],
                [
                  -76.573117,
                  39.355529
                ],
                [
                  -76.573015,
                  39.353903
                ],
                [
                  -76.574056,
                  39.354117
                ],
                [
                  -76.575628,
                  39.354844
                ],
                [
                  -76.575788,
                  39.354923
                ],
                [
                  -76.578658,
                  39.354486
                ],
                [
                  -76.582683,
                  39.355597
                ],
                [
                  -76.589561,
                  39.355418
                ],
                [
                  -76.589582,
                  39.357315
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "250301",
          "AFFGEOID": "1400000US24510250301",
          "GEOID": "24510250301",
          "NAME": "2503.01",
          "NAMELSAD": "Census Tract 2503.01",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1891899,
          "AWATER": 311271
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.649834,
                  39.260314
                ],
                [
                  -76.638874,
                  39.268938
                ],
                [
                  -76.63868,
                  39.269072
                ],
                [
                  -76.63733,
                  39.27014
                ],
                [
                  -76.633472,
                  39.269545
                ],
                [
                  -76.631861,
                  39.269242
                ],
                [
                  -76.62997,
                  39.268814
                ],
                [
                  -76.626137,
                  39.268195
                ],
                [
                  -76.625855,
                  39.268189
                ],
                [
                  -76.625654,
                  39.267162
                ],
                [
                  -76.627205,
                  39.265108
                ],
                [
                  -76.623793,
                  39.265075
                ],
                [
                  -76.623289,
                  39.260106
                ],
                [
                  -76.624689,
                  39.260606
                ],
                [
                  -76.629494,
                  39.258669
                ],
                [
                  -76.63009,
                  39.258824
                ],
                [
                  -76.631946,
                  39.25754
                ],
                [
                  -76.632768,
                  39.257731
                ],
                [
                  -76.633505,
                  39.258348
                ],
                [
                  -76.633708,
                  39.258598
                ],
                [
                  -76.634553,
                  39.255971
                ],
                [
                  -76.635045,
                  39.251641
                ],
                [
                  -76.634109,
                  39.249845
                ],
                [
                  -76.637462,
                  39.253807
                ],
                [
                  -76.64066,
                  39.257567
                ],
                [
                  -76.643351,
                  39.259375
                ],
                [
                  -76.64536,
                  39.260014
                ],
                [
                  -76.649834,
                  39.260314
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "120202",
          "AFFGEOID": "1400000US24510120202",
          "GEOID": "24510120202",
          "NAME": "1202.02",
          "NAMELSAD": "Census Tract 1202.02",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 981794,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.625917,
                  39.331158
                ],
                [
                  -76.624428,
                  39.33188
                ],
                [
                  -76.62376,
                  39.333934
                ],
                [
                  -76.624024,
                  39.336479
                ],
                [
                  -76.62317,
                  39.335925
                ],
                [
                  -76.617978,
                  39.33248
                ],
                [
                  -76.616273,
                  39.331473
                ],
                [
                  -76.616221,
                  39.331527
                ],
                [
                  -76.613646,
                  39.329922
                ],
                [
                  -76.613546,
                  39.3284
                ],
                [
                  -76.613333,
                  39.325914
                ],
                [
                  -76.61331,
                  39.324643
                ],
                [
                  -76.613226,
                  39.323381
                ],
                [
                  -76.614622,
                  39.323331
                ],
                [
                  -76.615743,
                  39.323287
                ],
                [
                  -76.617364,
                  39.323207
                ],
                [
                  -76.618709,
                  39.323144
                ],
                [
                  -76.620114,
                  39.323152
                ],
                [
                  -76.620553,
                  39.324687
                ],
                [
                  -76.62291,
                  39.326262
                ],
                [
                  -76.625348,
                  39.326224
                ],
                [
                  -76.624973,
                  39.327824
                ],
                [
                  -76.625917,
                  39.331158
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "271900",
          "AFFGEOID": "1400000US24510271900",
          "GEOID": "24510271900",
          "NAME": "2719",
          "NAMELSAD": "Census Tract 2719",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1398986,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.695355,
                  39.351254
                ],
                [
                  -76.691712,
                  39.353942
                ],
                [
                  -76.690683,
                  39.354448
                ],
                [
                  -76.688144,
                  39.35576
                ],
                [
                  -76.686773,
                  39.356483
                ],
                [
                  -76.682956,
                  39.358518
                ],
                [
                  -76.682897,
                  39.358549
                ],
                [
                  -76.680398,
                  39.359836
                ],
                [
                  -76.679151,
                  39.360532
                ],
                [
                  -76.675658,
                  39.362375
                ],
                [
                  -76.675129,
                  39.36282
                ],
                [
                  -76.673895,
                  39.363843
                ],
                [
                  -76.673109,
                  39.364244
                ],
                [
                  -76.672967,
                  39.36408
                ],
                [
                  -76.67133,
                  39.361955
                ],
                [
                  -76.671515,
                  39.359701
                ],
                [
                  -76.670848,
                  39.356788
                ],
                [
                  -76.670817,
                  39.356633
                ],
                [
                  -76.670774,
                  39.356482
                ],
                [
                  -76.672581,
                  39.356749
                ],
                [
                  -76.675185,
                  39.355677
                ],
                [
                  -76.676277,
                  39.355221
                ],
                [
                  -76.678871,
                  39.354136
                ],
                [
                  -76.683358,
                  39.351757
                ],
                [
                  -76.685732,
                  39.350438
                ],
                [
                  -76.687608,
                  39.349407
                ],
                [
                  -76.690059,
                  39.347585
                ],
                [
                  -76.691839,
                  39.348808
                ],
                [
                  -76.695355,
                  39.351254
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "270902",
          "AFFGEOID": "1400000US24510270902",
          "GEOID": "24510270902",
          "NAME": "2709.02",
          "NAMELSAD": "Census Tract 2709.02",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1132898,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.591924,
                  39.34665
                ],
                [
                  -76.591419,
                  39.349263
                ],
                [
                  -76.591137,
                  39.35003
                ],
                [
                  -76.590955,
                  39.350575
                ],
                [
                  -76.590374,
                  39.352207
                ],
                [
                  -76.589787,
                  39.353931
                ],
                [
                  -76.589561,
                  39.355418
                ],
                [
                  -76.582683,
                  39.355597
                ],
                [
                  -76.578658,
                  39.354486
                ],
                [
                  -76.575788,
                  39.354923
                ],
                [
                  -76.575628,
                  39.354844
                ],
                [
                  -76.574056,
                  39.354117
                ],
                [
                  -76.573015,
                  39.353903
                ],
                [
                  -76.57418,
                  39.352651
                ],
                [
                  -76.577649,
                  39.352457
                ],
                [
                  -76.577609,
                  39.349775
                ],
                [
                  -76.579488,
                  39.350405
                ],
                [
                  -76.581827,
                  39.349018
                ],
                [
                  -76.581297,
                  39.348292
                ],
                [
                  -76.581206,
                  39.346997
                ],
                [
                  -76.580805,
                  39.345277
                ],
                [
                  -76.583517,
                  39.345893
                ],
                [
                  -76.585947,
                  39.345863
                ],
                [
                  -76.586178,
                  39.345856
                ],
                [
                  -76.589323,
                  39.346058
                ],
                [
                  -76.592006,
                  39.346163
                ],
                [
                  -76.591924,
                  39.34665
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "150600",
          "AFFGEOID": "1400000US24510150600",
          "GEOID": "24510150600",
          "NAME": "1506",
          "NAMELSAD": "Census Tract 1506",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 959035,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.680565,
                  39.310762
                ],
                [
                  -76.676016,
                  39.310916
                ],
                [
                  -76.674239,
                  39.311032
                ],
                [
                  -76.672505,
                  39.311077
                ],
                [
                  -76.671068,
                  39.311116
                ],
                [
                  -76.669446,
                  39.311147
                ],
                [
                  -76.66591,
                  39.31132
                ],
                [
                  -76.664137,
                  39.311374
                ],
                [
                  -76.661319,
                  39.311446
                ],
                [
                  -76.661728,
                  39.314727
                ],
                [
                  -76.659779,
                  39.315224
                ],
                [
                  -76.659625,
                  39.314451
                ],
                [
                  -76.659985,
                  39.309368
                ],
                [
                  -76.660015,
                  39.308331
                ],
                [
                  -76.659292,
                  39.306518
                ],
                [
                  -76.659038,
                  39.306252
                ],
                [
                  -76.660898,
                  39.306144
                ],
                [
                  -76.665595,
                  39.30596
                ],
                [
                  -76.667324,
                  39.305904
                ],
                [
                  -76.668405,
                  39.307117
                ],
                [
                  -76.669205,
                  39.307096
                ],
                [
                  -76.672291,
                  39.307205
                ],
                [
                  -76.674123,
                  39.306268
                ],
                [
                  -76.676717,
                  39.306749
                ],
                [
                  -76.679261,
                  39.306865
                ],
                [
                  -76.680565,
                  39.310762
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "260403",
          "AFFGEOID": "1400000US24510260403",
          "GEOID": "24510260403",
          "NAME": "2604.03",
          "NAMELSAD": "Census Tract 2604.03",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1706884,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.544698,
                  39.304559
                ],
                [
                  -76.543118,
                  39.307352
                ],
                [
                  -76.541316,
                  39.310578
                ],
                [
                  -76.540029,
                  39.312792
                ],
                [
                  -76.538793,
                  39.314253
                ],
                [
                  -76.535294,
                  39.317681
                ],
                [
                  -76.534414,
                  39.322306
                ],
                [
                  -76.53241,
                  39.324568
                ],
                [
                  -76.533806,
                  39.327792
                ],
                [
                  -76.534104,
                  39.328295
                ],
                [
                  -76.534112,
                  39.328893
                ],
                [
                  -76.532977,
                  39.330558
                ],
                [
                  -76.529685,
                  39.33115
                ],
                [
                  -76.529686,
                  39.323264
                ],
                [
                  -76.529971,
                  39.319565
                ],
                [
                  -76.529786,
                  39.310391
                ],
                [
                  -76.532346,
                  39.308668
                ],
                [
                  -76.536411,
                  39.305962
                ],
                [
                  -76.537893,
                  39.305258
                ],
                [
                  -76.539257,
                  39.304629
                ],
                [
                  -76.546089,
                  39.302548
                ],
                [
                  -76.544698,
                  39.304559
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "120600",
          "AFFGEOID": "1400000US24510120600",
          "GEOID": "24510120600",
          "NAME": "1206",
          "NAMELSAD": "Census Tract 1206",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 504967,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.620114,
                  39.323152
                ],
                [
                  -76.618709,
                  39.323144
                ],
                [
                  -76.617364,
                  39.323207
                ],
                [
                  -76.615743,
                  39.323287
                ],
                [
                  -76.615665,
                  39.322003
                ],
                [
                  -76.615589,
                  39.320712
                ],
                [
                  -76.615526,
                  39.31942
                ],
                [
                  -76.615406,
                  39.317929
                ],
                [
                  -76.615302,
                  39.316413
                ],
                [
                  -76.615273,
                  39.315363
                ],
                [
                  -76.615176,
                  39.314292
                ],
                [
                  -76.615132,
                  39.313279
                ],
                [
                  -76.615064,
                  39.312305
                ],
                [
                  -76.614964,
                  39.311197
                ],
                [
                  -76.614955,
                  39.311065
                ],
                [
                  -76.61583,
                  39.311041
                ],
                [
                  -76.616554,
                  39.311016
                ],
                [
                  -76.619354,
                  39.310956
                ],
                [
                  -76.619351,
                  39.311729
                ],
                [
                  -76.619462,
                  39.313127
                ],
                [
                  -76.619559,
                  39.315159
                ],
                [
                  -76.619628,
                  39.316256
                ],
                [
                  -76.619908,
                  39.320531
                ],
                [
                  -76.619958,
                  39.321816
                ],
                [
                  -76.620114,
                  39.323152
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "150702",
          "AFFGEOID": "1400000US24510150702",
          "GEOID": "24510150702",
          "NAME": "1507.02",
          "NAMELSAD": "Census Tract 1507.02",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 391519,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.674418,
                  39.314163
                ],
                [
                  -76.672681,
                  39.314219
                ],
                [
                  -76.671249,
                  39.314278
                ],
                [
                  -76.667868,
                  39.314404
                ],
                [
                  -76.666091,
                  39.314458
                ],
                [
                  -76.661728,
                  39.314727
                ],
                [
                  -76.661319,
                  39.311446
                ],
                [
                  -76.664137,
                  39.311374
                ],
                [
                  -76.66591,
                  39.31132
                ],
                [
                  -76.669446,
                  39.311147
                ],
                [
                  -76.671068,
                  39.311116
                ],
                [
                  -76.672505,
                  39.311077
                ],
                [
                  -76.674239,
                  39.311032
                ],
                [
                  -76.674418,
                  39.314163
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "160400",
          "AFFGEOID": "1400000US24510160400",
          "GEOID": "24510160400",
          "NAME": "1604",
          "NAMELSAD": "Census Tract 1604",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 389583,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.650905,
                  39.300165
                ],
                [
                  -76.650177,
                  39.30107
                ],
                [
                  -76.649479,
                  39.301595
                ],
                [
                  -76.647717,
                  39.302305
                ],
                [
                  -76.647787,
                  39.303062
                ],
                [
                  -76.646118,
                  39.303112
                ],
                [
                  -76.645997,
                  39.300961
                ],
                [
                  -76.645868,
                  39.298803
                ],
                [
                  -76.645808,
                  39.297629
                ],
                [
                  -76.64561,
                  39.29524
                ],
                [
                  -76.64552,
                  39.293895
                ],
                [
                  -76.647249,
                  39.293828
                ],
                [
                  -76.650383,
                  39.293698
                ],
                [
                  -76.650477,
                  39.295072
                ],
                [
                  -76.650518,
                  39.296353
                ],
                [
                  -76.65057,
                  39.297255
                ],
                [
                  -76.650607,
                  39.298663
                ],
                [
                  -76.651354,
                  39.298638
                ],
                [
                  -76.650905,
                  39.300165
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "210100",
          "AFFGEOID": "1400000US24510210100",
          "GEOID": "24510210100",
          "NAME": "2101",
          "NAMELSAD": "Census Tract 2101",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1288245,
          "AWATER": 192308
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.634597,
                  39.277969
                ],
                [
                  -76.630343,
                  39.281257
                ],
                [
                  -76.632531,
                  39.282893
                ],
                [
                  -76.632821,
                  39.283117
                ],
                [
                  -76.632669,
                  39.283633
                ],
                [
                  -76.63185,
                  39.283689
                ],
                [
                  -76.628883,
                  39.283794
                ],
                [
                  -76.629019,
                  39.286009
                ],
                [
                  -76.62786,
                  39.286046
                ],
                [
                  -76.627539,
                  39.286057
                ],
                [
                  -76.625384,
                  39.282235
                ],
                [
                  -76.623186,
                  39.281238
                ],
                [
                  -76.620207,
                  39.28027
                ],
                [
                  -76.619884,
                  39.280047
                ],
                [
                  -76.61979,
                  39.280205
                ],
                [
                  -76.618999,
                  39.279052
                ],
                [
                  -76.619237,
                  39.278248
                ],
                [
                  -76.62013,
                  39.276446
                ],
                [
                  -76.620945,
                  39.274549
                ],
                [
                  -76.621815,
                  39.27289
                ],
                [
                  -76.624502,
                  39.26861
                ],
                [
                  -76.625855,
                  39.268189
                ],
                [
                  -76.626137,
                  39.268195
                ],
                [
                  -76.62997,
                  39.268814
                ],
                [
                  -76.631861,
                  39.269242
                ],
                [
                  -76.633472,
                  39.269545
                ],
                [
                  -76.631928,
                  39.270884
                ],
                [
                  -76.628731,
                  39.273467
                ],
                [
                  -76.632848,
                  39.276638
                ],
                [
                  -76.634597,
                  39.277969
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "250402",
          "AFFGEOID": "1400000US24510250402",
          "GEOID": "24510250402",
          "NAME": "2504.02",
          "NAMELSAD": "Census Tract 2504.02",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 702436,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.608167,
                  39.231099
                ],
                [
                  -76.606417,
                  39.231825
                ],
                [
                  -76.604205,
                  39.232623
                ],
                [
                  -76.602353,
                  39.236303
                ],
                [
                  -76.599319,
                  39.235389
                ],
                [
                  -76.597742,
                  39.234898
                ],
                [
                  -76.595787,
                  39.234309
                ],
                [
                  -76.597981,
                  39.230093
                ],
                [
                  -76.59936,
                  39.22746
                ],
                [
                  -76.599947,
                  39.226385
                ],
                [
                  -76.599308,
                  39.225298
                ],
                [
                  -76.600665,
                  39.223734
                ],
                [
                  -76.603665,
                  39.226709
                ],
                [
                  -76.604725,
                  39.227916
                ],
                [
                  -76.606916,
                  39.229769
                ],
                [
                  -76.608167,
                  39.231099
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "200600",
          "AFFGEOID": "1400000US24510200600",
          "GEOID": "24510200600",
          "NAME": "2006",
          "NAMELSAD": "Census Tract 2006",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 1770698,
          "AWATER": 30330
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.67278,
                  39.294174
                ],
                [
                  -76.672383,
                  39.294201
                ],
                [
                  -76.670465,
                  39.294257
                ],
                [
                  -76.669717,
                  39.294276
                ],
                [
                  -76.669712,
                  39.294163
                ],
                [
                  -76.669642,
                  39.293528
                ],
                [
                  -76.667858,
                  39.292412
                ],
                [
                  -76.66653,
                  39.291022
                ],
                [
                  -76.663613,
                  39.287616
                ],
                [
                  -76.662924,
                  39.287424
                ],
                [
                  -76.659436,
                  39.2862
                ],
                [
                  -76.659259,
                  39.285763
                ],
                [
                  -76.65986,
                  39.282321
                ],
                [
                  -76.659026,
                  39.281384
                ],
                [
                  -76.660175,
                  39.280657
                ],
                [
                  -76.658684,
                  39.278057
                ],
                [
                  -76.657608,
                  39.276041
                ],
                [
                  -76.659408,
                  39.274653
                ],
                [
                  -76.662291,
                  39.27624
                ],
                [
                  -76.665061,
                  39.275043
                ],
                [
                  -76.665905,
                  39.275651
                ],
                [
                  -76.666756,
                  39.276116
                ],
                [
                  -76.669224,
                  39.275718
                ],
                [
                  -76.670022,
                  39.275533
                ],
                [
                  -76.671563,
                  39.275933
                ],
                [
                  -76.671582,
                  39.276971
                ],
                [
                  -76.671651,
                  39.27967
                ],
                [
                  -76.672216,
                  39.280937
                ],
                [
                  -76.672167,
                  39.281087
                ],
                [
                  -76.672275,
                  39.28486
                ],
                [
                  -76.672316,
                  39.285832
                ],
                [
                  -76.672341,
                  39.286403
                ],
                [
                  -76.67255,
                  39.28979
                ],
                [
                  -76.672573,
                  39.2906
                ],
                [
                  -76.67257,
                  39.290681
                ],
                [
                  -76.67278,
                  39.294174
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "170200",
          "AFFGEOID": "1400000US24510170200",
          "GEOID": "24510170200",
          "NAME": "1702",
          "NAMELSAD": "Census Tract 1702",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 494006,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.630627,
                  39.302006
                ],
                [
                  -76.629554,
                  39.3028
                ],
                [
                  -76.628764,
                  39.303409
                ],
                [
                  -76.628006,
                  39.30397
                ],
                [
                  -76.626905,
                  39.304784
                ],
                [
                  -76.625118,
                  39.303182
                ],
                [
                  -76.62457,
                  39.303584
                ],
                [
                  -76.624132,
                  39.303841
                ],
                [
                  -76.620723,
                  39.304351
                ],
                [
                  -76.620269,
                  39.301757
                ],
                [
                  -76.621822,
                  39.300465
                ],
                [
                  -76.622721,
                  39.299687
                ],
                [
                  -76.624049,
                  39.298357
                ],
                [
                  -76.626159,
                  39.296653
                ],
                [
                  -76.628616,
                  39.298666
                ],
                [
                  -76.629665,
                  39.299518
                ],
                [
                  -76.631732,
                  39.301181
                ],
                [
                  -76.630627,
                  39.302006
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "272006",
          "AFFGEOID": "1400000US24510272006",
          "GEOID": "24510272006",
          "NAME": "2720.06",
          "NAMELSAD": "Census Tract 2720.06",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 736776,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.703228,
                  39.359702
                ],
                [
                  -76.699798,
                  39.362363
                ],
                [
                  -76.697885,
                  39.360799
                ],
                [
                  -76.696712,
                  39.360122
                ],
                [
                  -76.694344,
                  39.358879
                ],
                [
                  -76.694038,
                  39.358715
                ],
                [
                  -76.68959,
                  39.356505
                ],
                [
                  -76.688144,
                  39.35576
                ],
                [
                  -76.690683,
                  39.354448
                ],
                [
                  -76.691712,
                  39.353942
                ],
                [
                  -76.695355,
                  39.351254
                ],
                [
                  -76.696528,
                  39.352084
                ],
                [
                  -76.698965,
                  39.353797
                ],
                [
                  -76.699685,
                  39.354301
                ],
                [
                  -76.700188,
                  39.35465
                ],
                [
                  -76.702446,
                  39.356246
                ],
                [
                  -76.70083,
                  39.357891
                ],
                [
                  -76.702057,
                  39.358817
                ],
                [
                  -76.702391,
                  39.359069
                ],
                [
                  -76.703228,
                  39.359702
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "160300",
          "AFFGEOID": "1400000US24510160300",
          "GEOID": "24510160300",
          "NAME": "1603",
          "NAMELSAD": "Census Tract 1603",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 255075,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.646118,
                  39.303112
                ],
                [
                  -76.644643,
                  39.303176
                ],
                [
                  -76.643218,
                  39.303211
                ],
                [
                  -76.64309,
                  39.301109
                ],
                [
                  -76.642975,
                  39.298894
                ],
                [
                  -76.642775,
                  39.295313
                ],
                [
                  -76.642696,
                  39.294009
                ],
                [
                  -76.64552,
                  39.293895
                ],
                [
                  -76.64561,
                  39.29524
                ],
                [
                  -76.645808,
                  39.297629
                ],
                [
                  -76.645868,
                  39.298803
                ],
                [
                  -76.645997,
                  39.300961
                ],
                [
                  -76.646118,
                  39.303112
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "080700",
          "AFFGEOID": "1400000US24510080700",
          "GEOID": "24510080700",
          "NAME": "807",
          "NAMELSAD": "Census Tract 807",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 298756,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.598278,
                  39.308425
                ],
                [
                  -76.592846,
                  39.308641
                ],
                [
                  -76.588483,
                  39.308805
                ],
                [
                  -76.588507,
                  39.308679
                ],
                [
                  -76.588286,
                  39.30564
                ],
                [
                  -76.592521,
                  39.305452
                ],
                [
                  -76.598069,
                  39.305222
                ],
                [
                  -76.598278,
                  39.308425
                ]
              ]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "STATEFP": "24",
          "COUNTYFP": "510",
          "TRACTCE": "060200",
          "AFFGEOID": "1400000US24510060200",
          "GEOID": "24510060200",
          "NAME": "602",
          "NAMELSAD": "Census Tract 602",
          "STUSPS": "MD",
          "NAMELSADCO": "Baltimore city",
          "STATE_NAME": "Maryland",
          "LSAD": "CT",
          "ALAND": 257735,
          "AWATER": 0
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": [
            [
              [
                [
                  -76.583585,
                  39.296687
                ],
                [
                  -76.582169,
                  39.296752
                ],
                [
                  -76.580754,
                  39.29679
                ],
                [
                  -76.580041,
                  39.296817
                ],
                [
                  -76.578653,
                  39.296879
                ],
                [
                  -76.577955,
                  39.296911
                ],
                [
                  -76.577783,
                  39.294582
                ],
                [
                  -76.577623,
                  39.292178
                ],
                [
                  -76.579727,
                  39.292099
                ],
                [
                  -76.581886,
                  39.292012
                ],
                [
                  -76.583325,
                  39.291956
                ],
                [
                  -76.583456,
                  39.294361
                ],
                [
                  -76.583568,
                  39.296393
                ],
                [
                  -76.583585,
                  39.296687
                ]
              ]
            ]
          ]
        }
      }
    ]
  }

  export default data;